/* ==========================================================================
   Echoa — Konfigurator
   --------------------------------------------------------------------------
   Verbindet Eingabe, Auswahl, Bühne, Wartezeit und Warenkorb.

   Die Generierung läuft außerhalb des Themes (Backend `dienst.py`). Der
   Haken dafür ist `window.ECHOA_BACKEND` bzw. `D.backend` — gesetzt fährt
   der Konfigurator für die Handles in LIVE_HANDLES den echten Pfad
   (Entwürfe → Rückfragen → Vorschau → Warenkorb mit echter Kandidaten-ID).
   Ohne Backend läuft der Ablauf simuliert durch, damit die Oberfläche
   prüfbar bleibt — die simulierte ID trägt ein sim_-Präfix, geht NIE als
   _kandidat_id in den Warenkorb, und die Zeile wird als simuliert markiert.

   🔴 SEIT 09.08.2026 IST DAS HIER DER KANON DES KUNDENPFADS (Entscheidung
   Sascha, Weg A): die Brief-Felder je Konzept (Eingabe-Vorlage 05.08.,
   eingebaut 07.08.) leben in BRIEFE unten — der Prototyp unter
   `shop/konfigurator/` ist Referenz/Testkit und wird nicht mehr erweitert.
   ========================================================================== */

(() => {
  'use strict';

  const wurzel = document.querySelector('[data-konfigurator]');
  const datenTag = document.querySelector('[data-konfig-daten]');
  if (!wurzel || !datenTag) return;

  const D = JSON.parse(datenTag.textContent);
  /* Das Produkt, mit dem die Seite geladen wurde — die Galerie-Tafeln (Machart, Räume) gehören
     zu IHM, auch nachdem der Ort/Moment-Schalter `D.produkt` getauscht hat (20.10.2026). */
  const START_HANDLE = D.produkt.handle;
  /* Zu welchem Produkt die Galerie links GERADE gehört — seit 21.10.2026 tauscht der
     Ort/Moment-Schalter sie mit (`galerieTauschen`); vorher blieb sie beim Einstieg. */
  let galerieHandle = START_HANDLE;

  /* --- Vorwahl für Anzeigen, deren Link sich nicht mehr ändern lässt (24.10.2026) ----------
     Sascha: »korrigiere auf jeden Fall den Link-Parameter«. Die Kopien der alten Gewinner
     (`hund_farben_9x16-G`, `pferd_geschenk_9x16-G`) hängen bewusst am alten Beitrag — nur so
     wandern Likes und Kommentare mit. Ein Meta-Beitrag ist nach dem Anlegen unveränderlich,
     und sein Link trägt kein `?machart=illustration`: die Seite wählte Magazin vor, die Anzeige
     zeigt Illustration (werbe-lock.md, 22.10. 12:22). Deshalb ergänzt die Seite die fehlenden
     Parameter selbst, bevor irgendein Teil dieser Datei die Adresse liest.
     GELTUNGSBEREICH: nur die hier genannten `utm_content`-Werte und nur Parameter, die in der
     Adresse FEHLEN — ein Link, der selbst etwas vorwählt, gewinnt immer. Jeder Wert läuft
     danach durch dieselbe `urlVorwahl`-Prüfung wie ein echter Link-Parameter. */
  const UTM_VORWAHL = {
    hund_farben_9x16: { machart: 'illustration' },
    pferd_geschenk_9x16: { machart: 'illustration' },
  };
  try {
    const q = new URLSearchParams(window.location.search);
    const fehlt = Object.entries(UTM_VORWAHL[q.get('utm_content') || ''] || {})
      .filter(([k]) => !q.has(k));
    if (fehlt.length) {
      fehlt.forEach(([k, v]) => q.set(k, v));
      history.replaceState(history.state, '', `${location.pathname}?${q}${location.hash}`);
    }
  } catch { /* eine Vorwahl darf die Seite nie kosten */ }

  /* --- Andruck nicht per Rechtsklick speichern (29.09.2026) -----------------
     Sascha: Kunde gestaltet, lädt die Vorschau per Rechtsklick herunter und
     druckt selbst. Das hält nur den Gelegenheitsfall ab — ein Bildschirmfoto
     geht immer; die Auflösung deckelt das Backend (1200 px). Delegiert am
     Dokument, weil `.buehne__bild` beim Look- und Formatwechsel neu gesetzt
     wird. Nur am Andruck: die Blatt-Bühne und die Leiste „Deine Entwürfe".
     🔴 NICHT `.buehne__bild` allein — das ist die Klasse ALLER Poster-Kacheln,
     auch der verlinkten in „Die anderen Wege" (code-pruefer 29.09.2026); dort
     nähme die Sperre dem Kunden „Link in neuem Tab öffnen". */
  /* Seit 21.10.2026 hängt der Andruck auch in den Raum-Montagen und im kleinen Raumbild am
     Formatwähler (`raumPosterSetzen`) — dieselbe Datei, also dieselbe Sperre (code-pruefer). */
  const ANDRUCK = '[data-tafel="blatt"] .buehne__bild, .entwurf img, [data-raum-poster] img';
  ['contextmenu', 'dragstart'].forEach((art) =>
    document.addEventListener(art, (e) => {
      if (e.target instanceof Element && e.target.closest(ANDRUCK)) e.preventDefault();
    }));

  /* --- Backend-Haken --------------------------------------------------------
     Nur die Handles in LIVE_HANDLES haben einen echten Kundenpfad (Stufe 1 +
     Render). Alles andere bleibt simuliert, auch MIT Backend — das Backend
     lehnt diese Produkte live ohnehin ab (fehlende Stufe 1, dienst.py), und
     ein 500er im Konfigurator wäre eine Sackgasse.

     ⏪ 11.08.2026: `icon-grid` und `weg-chronik` sind dazugekommen. Der Grund
     für ihren Ausschluss — „das Backend lehnt sie live ohnehin ab" — gilt
     seit der Verdrahtung vom selben Tag nicht mehr; beide haben Stufe 1 und
     einen Kundenpfad. Der Shop ist passwortgeschützt und ohne Traffic, das
     hier ist also der Weg, auf dem Sascha die Kette überhaupt ansehen kann.
     ⚠️ Was dabei zu erwarten ist, damit es niemand für einen Fehler hält:
       weg-chronik  vollständig — die Karte trägt ihre Typografie selbst,
                    die Vorschau IST das Produkt. Kosten ~0,001 $ (nur der
                    Textdurchlauf), der Render ist konstruiert.
       icon-grid    Vorschau zeigt den ROHRENDER ohne Captions, Titel und
                    Fußzeile — der Setzer läuft heute nur im Druck. Das ist
                    bekannt und offen, kein Defekt. Kosten 0,96 $ je Vorschau
                    (⚠️ Stand 12.08.2026, 4K-Zeit — gemessen 19.–28.10.: ~0,12 € je
                    Andruck, [[echoa_vorschau_budget]] Episode 29.10.).
     ⏪ 12.08.2026: `momentaufnahme` ist dazugekommen. Der Grund für den
     Ausschluss — „ihm fehlt der eingefrorene Prompt, das Backend hält dort
     hart an" — gilt seit `a5_stufe1` nicht mehr; A5 hat Stufe 1 und einen
     Kundenpfad. Damit ist KEIN Handle mehr simuliert.
     ⚠️ Was dabei zu erwarten ist:
       momentaufnahme  vollständig — die Vorschau ist das GESETZTE Blatt
                    (Namen + Unterzeile stehen drauf), gesetzt mit derselben
                    Kette wie im Druck. Kosten 0,96 $ je Vorschau (⚠️ Stand 12.08.,
                    gemessen 19.–28.10.: Ø 0,16 € je Andruck, mit Paarfoto geschätzt
                    ~0,30 € — [[echoa_vorschau_budget]] Episode 29.10.). ⏪ Seit dem
                    Abend des 12.08. sind ALLE SECHS Momenttypen wählbar; die
                    drei zugewandten waren einen halben Tag grau. ⚠️ Ihre
                    Komposition ist am Bild abgenommen (03.08.), die
                    Prompt-Fassung noch nicht — sie gehört auf den nächsten
                    Renderlauf.
     Ohne laufendes Backend im Live-Modus kostet das alles weiterhin nichts —
     `livePfad()` verlangt beides. */
  /* --- `?backend=` NUR auf einem lokalen Host (15.08.2026) -----------------
     🔴 WOZU: `shopify theme dev` serviert die lokalen Dateien, aber die
     Backend-URL steht in `templates/product.json` — einer VERSIONIERTEN Datei,
     die auf das Cloud-Run-Backend zeigt. Sie zum Testen umzubiegen hieße, eine
     Änderung im Working Tree zu halten, die niemals committet oder gepusht
     werden darf. Genau die Sorte Zustand, die irgendwann doch mitgeht.

     🔴 UND WARUM DIE HOST-SPERRE KEIN BEIWERK IST: ohne sie könnte ein Link
     wie `…/products/icon-grid?backend=https://fremd.example` den Konfigurator
     eines LIVE-Shops auf einen fremden Dienst zeigen lassen — Kundentexte
     gingen dorthin, und die Vorschau käme von dort. Der Parameter wird
     deshalb ausschließlich auf `localhost`/`127.0.0.1` gelesen, also genau
     dort, wo `theme dev` läuft. Auf der echten Domain existiert er nicht.
     ⚠️ Zusätzlich nur `http(s)://localhost|127.0.0.1` als ZIEL — auch lokal
     soll der Parameter kein Tor nach außen sein. */
  function backendAusUrl() {
    try {
      const host = window.location.hostname;
      if (host !== 'localhost' && host !== '127.0.0.1') return '';
      const wunsch = new URLSearchParams(window.location.search).get('backend') || '';
      return /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/.test(wunsch.replace(/\/$/, ''))
        ? wunsch : '';
    } catch { return ''; }
  }

  const BACKEND = String(backendAusUrl() || window.ECHOA_BACKEND || D.backend || '')
    .replace(/\/$/, '');

  /* --- Kauf-Versprechen (Stufe 2 B2, Saschas T1 27.10.2026) --------------------------------
     KAUFVERSPRECHEN_AN: Schalter aus `snippets/echoa-kaufversprechen.liquid` (über das Attribut
     am Konfigurator, eine Quelle mit dem Warenkorb). Wirkt auf den Knopftext und die
     Lieferspanne; Kacheln und Kaufleiste schaltet das CSS am selben Attribut.
     BESTELLMODUS: der Kunde kommt NACH dem Kauf über den Link der Freigabe-Seite
     (`backend/kundenfreigabe.py`, `?fo=&fb=&fs=&fz=`) und ändert hier, mit derselben
     Zeichen-Kette wie vor dem Kauf. Der Hauptknopf nimmt die Fassung, statt sie in den Warenkorb
     zu legen (`fassungNehmen`). Geprüft wird die Signatur im Dienst, nicht hier — die Seite liest
     die Parameter nur, um sie zurückzuschicken. Unabhängig vom Schalter: den Link gibt es nur,
     wenn die Druckstraße die Freigabe-Mail verschickt. */
  const KAUFVERSPRECHEN_AN = wurzel.dataset.kaufversprechen === 'an';
  const BESTELLMODUS = (() => {
    try {
      const q = new URLSearchParams(window.location.search);
      const b = { o: q.get('fo') || '', b: q.get('fb') || '', s: q.get('fs') || '', z: q.get('fz') || '' };
      return (/^\d{1,20}$/.test(b.o) && /^\d{1,12}$/.test(b.b) && /^[0-9a-f]{32}$/.test(b.s)
              && /^\d{1,20}$/.test(b.z) && BACKEND) ? b : null;
    } catch { return null; }
  })();
  const FREIGABE_SEITE = BESTELLMODUS
    ? `${BACKEND}/freigabe?o=${BESTELLMODUS.o}&b=${BESTELLMODUS.b}&s=${BESTELLMODUS.s}` : '';
  if (BESTELLMODUS) {
    document.documentElement.classList.add('ist-bestellmodus');
    const aktionKnopf = wurzel.querySelector('[data-aktion]');
    if (aktionKnopf) {
      const h = document.createElement('p');
      h.className = 'bestellmodus-hinweis';
      h.innerHTML = '<b>Du änderst deine Bestellung.</b> Sag uns unter dem Bild, was anders sein soll, '
        + 'und lass neu zeichnen. Gefällt es dir, tipp auf „Diese Fassung nehmen“. '
        + `<br><a class="echoa-link" href="${FREIGABE_SEITE}">Zurück zu meiner Bestellung</a>`;
      aktionKnopf.before(h);
    }
  }

  /** Bestellmodus: die Fassung an den Dienst statt in den Warenkorb, danach zurück zur
      Freigabe-Seite. `properties` sind exakt die, die sonst in den Warenkorb gingen. */
  /* Hat der Kunde im Bestellmodus wirklich etwas geändert (neu gezeichnet oder ein Feld angefasst)?
     Ohne Änderung führt „Diese Fassung nehmen“ nur zurück: die geladene Seite gibt den Stand von
     vor dem Kauf nicht immer exakt wieder (Ton, Sätze bei Haustier und Rezept) — eine Übernahme
     ohne Änderung hätte genau diese Abweichung gedruckt (Befund code-pruefer Runde 2, 27.10.2026). */
  let bestellGeaendert = false;
  let bestellStartKid = null;
  if (BESTELLMODUS) {
    ['input', 'change'].forEach((art) => wurzel.addEventListener(art, (e) => {
      if (e.isTrusted) bestellGeaendert = true;
    }, true));
    /* Auswahl-Knöpfe (Machart, Farbe, Kacheln) feuern kein input — sie zählen als Änderung. */
    wurzel.addEventListener('click', (e) => {
      if (e.isTrusted && e.target.closest('[data-brieffeld], .brieffeld button, [aria-pressed]')) {
        bestellGeaendert = true;
      }
    }, true);
  }

  async function fassungNehmen(properties) {
    const knopf = $('[data-aktion]');
    const fehler = $('[data-fehler]');
    if (bestellStartKid === null) bestellStartKid = new URLSearchParams(window.location.search).get('entwurf') || '';
    if (!bestellGeaendert && properties._kandidat_id === bestellStartKid) {
      window.location.href = FREIGABE_SEITE;
      return;
    }
    if (knopf) { knopf.disabled = true; knopf.textContent = 'Wird übernommen …'; }
    try {
      const r = await fetch(`${BACKEND}/api/freigabe/fassung`, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({ ...BESTELLMODUS, properties }),
      });
      const a = await r.json().catch(() => ({}));
      if (r.ok && a.weiter) { window.location.href = a.weiter; return; }
      if (fehler) {
        fehler.textContent = a.fehler || 'Das hat gerade nicht geklappt. Bitte gleich noch einmal.';
        fehler.hidden = false;
      }
      if (a.weiter && r.status === 409) { window.location.href = a.weiter; return; }
    } catch {
      if (fehler) { fehler.textContent = 'Keine Verbindung. Bitte gleich noch einmal.'; fehler.hidden = false; }
    }
    if (knopf) { knopf.disabled = false; aktionZeichnen(findeVariante()); }
  }
  const LIVE_HANDLES = new Set(['orts-print', 'icon-grid', 'weg-chronik',
                                'momentaufnahme',
                                // Kids Collection, 07.09.2026
                                'wortschatz', 'jahreszahl',
                                // Zitat, eigenes Produkt seit 29.09.2026
                                'zitat',
                                // Gaming-Paar, 16.10.2026
                                'gaming',
                                // Haustier und Pferd, 16.10.2026; Linien-Seite, 28.10.2026
                                'haustier', 'pferd', 'linie',
                                // Porträt, 29.10.2026 (sichtbar erst mit freigeschaltetem Produkt)
                                'portraet',
                                // Strecke und Wanderung, 17.10.2026
                                'strecke', 'wanderung',
                                // Rezept, 17.10.2026 (Familienrezept)
                                'rezept']);
  const livePfad = () => Boolean(BACKEND) && LIVE_HANDLES.has(D.produkt.handle);

  /* Haustier-Foto (16.10.2026). Steht HIER oben, weil `baueBrief()` beim
     Start `sammleBrief()` ruft und `let` eine temporale Todeszone hat.
     status: leer | laedt | ok | hauptmotiv | kein_tier | falsche_art |
     neues_foto | fehler */
  let foto = { id: '', status: 'leer', meldung: '', hinweis: '', tiere: [],
               hauptmotiv: '', ohne: false, bild: '' };
  /* Rezept-Karteikarte (17.10.2026), aus demselben Grund hier oben.
     status: leer | laedt | ok | kein_rezept | fehler */
  let karte = { id: '', status: 'leer', meldung: '', unsicher: [], bild: '' };
  /* Orts-Print: optionales Foto des Ortes (19.10.2026, Saschas Auftrag „Foto-Upload des Kunden als
     optionale Ergänzung"). AUS bis zur Freigabe — Spiegel von `dienst.C1_ORTSFOTO_UPLOAD`: steht nur
     einer von beiden an, gibt es entweder kein Feld oder eine Route, die 400 antwortet. Hier oben aus
     demselben Grund wie `foto` (BRIEFE liest den Schalter beim Start).
     status: leer | laedt | ok | kein_ort | neues_foto | fehler */
  const ORTSFOTO_UPLOAD_AN = true;   /* EIN seit Saschas »Foto-Upload fehlt«, 20.10.2026 abends */
  /* Orts-Print: die NEUE EINGABEMASKE (Saschas T1 1A/2A, 20.10.2026, Klick-Dummy
     https://claude.ai/artifact/GXxmnkdEwt5rnj517H4bUt): Ort · Jahr · „Was darf nicht fehlen?" ·
     Foto · Machart Farbig/Dunkel. KEIN Erinnerungen-Feld (Gegenstände kamen zu groß ins Bild),
     KEIN Paar (wer ein Paar will, nimmt den Moment), KEIN Tageszeit-Feld (T2 20.10.). AUS bis
     zu Saschas Freigabe — Spiegel von `dienst.C1_MASKE`; der Dienst-Selbsttest (C1-M) hält
     beide gleich. Hier oben aus demselben Grund wie `foto` (BRIEFE liest ihn beim Start). */
  const ORTS_MASKE_AN = true;   /* EIN seit Saschas T1 »A«, 20.10.2026 abends */
  /* 🆕 STIMMUNG beim Orts-Print (Saschas Urteil am Raster 0f, 27.10.2026: „als ‚Stimmung' … als visuellen Button wie
     bei den Stil-Auswahlmöglichkeiten, mit demselben Bild … in Abendstimmung"). Zwei Bild-Kacheln Tag · Abend, nur bei
     „Farbig". AUS bis Saschas Wort zum Live-Gang; der Dienst kennt das Feld (`dienst.C1_STIMMUNGEN`). */
  const ORTS_STIMMUNG_AN = true;   /* EIN seit Saschas T1 »A«, 27.10.2026 */
  /* Spiegel von `dienst.C1_ORTSFOTO_TREU` (27.10.2026): mit dem Treu-Weg zeichnen wir Menschen aus dem Foto klein und
     ohne Gesicht mit — dann darf der Hilfetext am Foto-Feld nicht „zeichnen wir nicht" sagen (code-pruefer). Beide
     zusammen umschalten. */
  const ORTSFOTO_TREU_AN = true;   /* EIN seit Saschas T1 »A«, 27.10.2026 — zusammen mit dienst.C1_ORTSFOTO_TREU */
  /* 🆕 ORTS-PRINT WIE DER MOMENT (Sascha 30.10.2026, Variante C: „Mir ist nicht klar, warum ich ein Foto hinzufügen
     muss … Möglicherweise schließt sich beides gegenseitig aus"). Nach dem Ort kommt das Foto und sagt, wofür es da ist;
     „Was darf nicht fehlen?" steht in der Klappe „Kein Foto zur Hand?". Mit angenommenem Foto ist die Klappe weg und
     der Text geht nicht in den Brief — mit Foto bestimmt das Foto den Blick (`c1_ortsfoto.STUFE1_KUNDENFOTO_TREU`
     geht den übrigen Regeln vor; ein Widerspruch fiel bisher still zugunsten des Fotos aus). AUS = wie bis zum 30.10. */
  const ORTS_KLAPPE_AN = true;
  /* 🆕 NACH DEM ENTWURF (Saschas T1, 30.10.2026, Bilder-Seite claude.ai/artifact/JTdTB2S3Ufp6nHVgSAT1YQ): keine Pillen
     unter dem Bild, kein „Neu zeichnen“-Formular unter dem Entwurf. Die Klappe heißt „Doch schon etwas anpassen?“ und
     trägt grün „Texte und Farben ändern“ (alles ohne neuen Entwurf), den Wunsch für nach der Bestellung und „Neu
     beginnen“. Gebaut in `nachherZeichnen`. AUS = Pillen, Melde-Panel und „Neu zeichnen“ wie bis zum 30.10. */
  const NACHHER_AN = true;
  /* Felder, die im Formular stehen, aber ohne neuen Render gesetzt werden — sie ziehen im Kaufzustand in die grüne
     Sektion (`freieFelderUmziehen`). Nur Namen aus `HAUSTIER_SATZ_FELDER`, `REZEPT_SATZ_FELDER` bzw. `KARTEN_FELDER`:
     ein Feld, das einen Render braucht, verwürfe dort den bezahlten Entwurf. */
  const FREI_IM_KAUF = {
    haustier: ['eigenheit_1', 'eigenheit_2', 'eigenheit_3', 'eigenheit_4', 'familie'],
    pferd: ['eigenheit_1', 'eigenheit_2', 'eigenheit_3', 'eigenheit_4'],
    rezept: ['titel', 'zutaten', 'bedeutung_1', 'bedeutung_2', 'bedeutung_3'],
    /* Die Orte-Liste trägt auch Jahre und Markierung je Ort (`KARTEN_FELDER`, kostenlos). Die Ortsnamen selbst
       brauchen eine neue Karte — sie stehen in Grün gesperrt (`chronikOrteSperren`), ändern heißt „Neu beginnen“
       (code-pruefer 30.10.2026). */
    'weg-chronik': ['namen', 'stationen'],
  };
  /* Die Frage vor „Neu beginnen“ — der Oberbegriff dessen, was ein neues Bild braucht, nie ein interner Name
     (Sascha, 30.10.2026: „Du weißt natürlich, was mit Magazin, Kohle oder Linie gemeint ist … der Kunde nicht“). */
  const NEU_FRAGE = {
    'orts-print': 'Lieber einen anderen Ort oder eine andere Tageszeit?',
    momentaufnahme: 'Lieber eine andere Machart, einen anderen Ort oder ein anderes Foto?',
    haustier: 'Lieber eine andere Machart oder ein anderes Foto?',
    pferd: 'Lieber eine andere Machart oder ein anderes Foto?',
    gaming: 'Lieber eine andere Welt oder andere Figuren?',
    'icon-grid': 'Lieber andere Symbole oder einen anderen Hintergrund?',
    'weg-chronik': 'Lieber andere Orte oder einen anderen Hintergrund?',
    wortschatz: 'Lieber einen anderen Stil oder ein anderes Wort?',
    zitat: 'Lieber ein anderes Poster oder einen anderen Satz?',
    jahreszahl: 'Lieber ein anderes Alter oder andere Dinge im Bild?',
    rezept: 'Lieber ein anderes Gericht?',
    strecke: 'Lieber eine andere Strecke?',
    wanderung: 'Lieber eine andere Wanderung?',
    linie: 'Lieber eine andere Machart oder ein anderes Foto?',
    portraet: 'Lieber eine andere Machart oder ein anderes Foto?',
  };
  /* 🆕 GELB (Phase 2, Saschas »Ja, bauen«, 30.10.2026): „Gleiches Bild, anders zeigen“ — derselbe Entwurf am Abend,
     als Linolschnitt oder mit einem geänderten Detail. Ein neues Bild aus dem alten (Dienst `_umwandeln_vorbereiten`,
     derselbe Weg wie ein Andruck: Kontingent, Warteschlange, Siebe). Sichtbar nur, wenn der Dienst es meldet
     (`/puls` → `umwandeln`); der alte Entwurf bleibt unter „Deine Entwürfe“ und als „Zurück“-Zeile. Gebaut in
     `gelbZeichnen`. AUS = wie Phase 1. */
  const GELB_AN = true;
  const GELB_DETAIL_MAX = 2;      // Spiegel von `dienst.UMWANDELN_DETAIL_MAX`; das Urteil fällt im Dienst
  const GELB_WUNSCH_MAX = 200;    // Spiegel von `dienst.UMWANDELN_WUNSCH_MAX`
  let neuBegonnen = false;   // „Neu beginnen“ gedrückt, noch kein neuer Entwurf fertig → Banner über der Eingabe
  /* 🆕 PIXEL-PAAR MIT FOTO (Saschas »Ja, so bauen«, 30.10.2026): optionales „Foto von euch zwei" über dem Baukasten.
     Der Dienst prüft es wie beim Moment und schlägt Merkmale vor; daraus füllen wir den Baukasten vor (`gamingVorbelegen`)
     und klappen ihn zu („Figuren anpassen"). Beim Andruck nimmt der Dienst den Kopf aus dem Foto, die Kleidung aus dem
     Baukasten (`dienst.GAMING_FOTO`). EIN seit 30.10.2026 abends (Saschas »so lassen und testen«, Dienst 30e939c3 live) — false = wie bis zum 30.10. */
  const GAMING_FOTO_AN = true;
  /* 🆕 „langer Afro“ (Sascha, 30.10.2026 abends). AUS, bis der Dienst `gaming_satz.FRISUREN["afro_lang"]` kennt —
     ein älterer Dienst lehnte den Wert beim Andruck ab. */
  const AFRO_LANG_AN = true;   // EIN seit 30.10.2026 abends: Dienst 98228f06 kennt den Wert
  let gamingFotoOffen = false;      // „Figuren anpassen" mit Foto aufgeklappt   /* EIN seit Saschas T1 »Ja, so live schalten«, 30.10.2026 */
  /* 🆕 HAARFARBE AM ENTWURF (Pixel-Paar, Stufe 2, 27.10.2026 — Saschas Wunsch „Haarfarbe direkt am Bild anklicken
     und sofort sehen"): unter dem fertigen Entwurf je Figur eine Reihe Farbfelder; ein Tipp färbt das Haar um, ohne
     neuen Render (0 €, `dienst.gaming_neu_setzen` mit `haar1`/`haar2`). AUS bis Saschas Wort — Spiegel von
     `dienst.GAMING_HAAR_UMFAERBEN`. Töne = `gaming_haar.TOENE` (Schatten, Grund, Licht); der Dienst-Selbsttest
     (8b-haar) hält IDs und Werte gleich. Bildfarben der Spielwelt, keine Marken-Töne. */
  const HAAR_UMFAERBEN_AN = true;   /* EIN seit Saschas T1 »A«, 27.10.2026 — zusammen mit dienst.GAMING_HAAR_UMFAERBEN */
  const HAAR_TOENE = [
    ['schwarz', 'Schwarz', '#1C1816', '#2E2824', '#4A413A'],
    ['dunkelbraun', 'Dunkelbraun', '#2E1E14', '#45301F', '#5E4430'],
    ['hellbraun', 'Hellbraun', '#4A3320', '#6B4A2E', '#86603E'],
    ['dunkelblond', 'Dunkelblond', '#6B5233', '#8F7049', '#AD8D62'],
    ['aschblond', 'Aschblond', '#7C6849', '#A08763', '#B79F7A'],
    ['blond', 'Blond', '#A3854F', '#C9A86B', '#DDC08A'],
    ['hellblond', 'Hellblond', '#C4A66E', '#E2C995', '#F0DDB4'],
    ['rot', 'Rot', '#80281A', '#B2401E', '#D46034'],
    ['grau', 'Grau', '#77736E', '#A19C96', '#C6C2BC'],
  ];
  /* 🆕 Hautton und Kleidungsfarben nach dem Entwurf (Sascha, 27.10.2026: „soweit möglich mit den Avataren spielen
     lassen"): dieselben Formularfelder; mit Schalter AN zählen sie wie gesetzte Texte — ein Wechsel färbt den Entwurf
     um (`textSatzSenden`), statt ihn zu verwerfen. Lässt sich ein Teil nicht umfärben, antwortet der Dienst 409 und
     der Entwurf weicht einem neuen Andruck. Spiegel von `dienst.GAMING_FARB_FELDER` (Selbsttest 8b-haar). */
  /* ⏪ Bis 27.10.2026 abends auch p1_haut/p2_haut — Saschas Beschriftung: 30 von 34 Hautwechseln fehlerhaft. */
  const GAMING_FARB_FELDER = ['p1_oberteil', 'p2_oberteil', 'p1_unterteilfarbe', 'p2_unterteilfarbe'];
  /** Trägt dieser Historien-Eintrag GENAU den Stand des Formulars — Fingerabdruck UND die gesetzten Felder (Texte, beim
      Pixel-Paar auch die Kleidungsfarben)? Dann ist er schon gezeichnet und kommt kostenlos zurück, statt dass ein
      Wechsel den gezeigten Entwurf umfärbt oder — wenn das nicht geht — einen neuen Andruck verlangt
      (code-pruefer 27.10.2026: Hautton hin und zurück kostete sonst einen Render). */
  function genauGezeichnet(e) {
    if (!(e && e.brief) || e.handle !== D.produkt.handle || e.schluessel !== briefSchluessel(s.brief)) return false;
    if (!textSatzFelder(s.brief).every((k) => String(e.brief[k] || '') === String(s.brief[k] || ''))) return false;
    /* Pixel-Paar: auch die Haarfarbe muss gleich der des gezeigten Entwurfs sein — sie steht nicht im Formular, sondern
       im Eintrag (`haar`). Sonst holte ein Oberteil-Wechsel einen Entwurf mit längst verworfener Haarfarbe zurück
       (code-pruefer 27.10.2026, Runde 2). */
    if (!istGaming()) return true;
    const jetzt = haarDesEntwurfs();
    return [1, 2].every((p) => String((e.haar || {})[p] || '') === String(jetzt[p] || ''));
  }
  /* Hilfe unter „Ton" bei Dunkel (Orts-Print und Moment). ⏪ „Alles andere bleibt cremefarbenes
     Papier." — Sascha, 21.10.2026: unverständlich. Wortlaut unten ist Saschas Entscheidung
     vom selben Tag. Stimmt mit den Ton-Beispielen (`echoa-ton-*-petrol.png`): der Ton füllt
     den Himmel und zeichnet die Linien, die Szene ist im Papierton ausgespart. */
  const TON_HILFE = 'Himmel und Linien werden im gewählten Ton eingefärbt, alles andere bleibt Creme.';
  /* Muss zu `dienst.MUSS_REIN_MAX` passen (Selbsttest C1-M) — der Browser schneidet ab,
     der Dienst kürzt trotzdem. */
  const MUSS_REIN_MAX = 160;
  let ortfoto = { id: '', status: 'leer', meldung: '', hinweis: '', bild: '' };
  /* 🆕 MOMENT MIT PAARFOTO (Stufe 2, Saschas T1 »A«, 27.10.2026: „eine Seite — Machart, Foto, Ort, Entwurf; Namen
     und Jahr danach"). Spiegel von `dienst.A5_PAARFOTO`; beide zusammen umschalten, AUS bis Saschas Wort.
     AN: Moment-Seite ohne Schritte — Machart (Dunkel · Kohle · Strich · Farbig), Feld »paarfoto« (Foto → „Wir
     sehen …" → ändern; ohne Foto nur Frau/Mann/neutral), Ort, „Was macht ihr?" optional, Namen (Pflicht, der
     Titel) und Jahr VOR dem Entwurf (Sascha 27.10.: „Nur so kann doch überhaupt ein fertiges Poster erzeugt
     werden"); danach ohne neuen Render änderbar. Kohle und Strich brauchen das Foto. Der Feldtyp »paarfoto« schickt `produkt: D.produkt.handle`
     und dient auch der Linien-Seite (`dienst.PAARFOTO_PRODUKTE`). Setzt DREI_SEITEN_AN voraus (kein Ort/Moment-
     Schalter mehr über dem Formular). AUS: Moment-Seite byte-gleich wie bisher. */
  const PAARFOTO_AN = true;
  /* 🔴 SCHALTER Pinsel auf der Linien-Seite (28.10.2026). Saschas Ausroll-T1 »Ja, erst live« mit der Bedingung:
     „Das Pinsel-Paar … geht nicht ungesehen raus. Zeig Sascha vorher das Bild, oder roll Linie ohne Pinsel aus
     und reich Pinsel nach." AUS = nur die Machart Linie (Kachel und Galerie); AN = Pinsel als zweite Kachel.
     Spiegel: `linie_pinsel_an` in `sections/echoa-pdp.liquid` — beide zusammen umschalten. Der Dienst kann
     Pinsel weiter (`linie.TECHNIKEN`), es wird nur nicht angeboten. */
  const LINIE_PINSEL_AN = true;   // Saschas »Ja, mit Pinsel« (28.10.2026, Bild R1)
  /* status: leer | laedt | ok | nein | fehler · paar: {p1, p2, groesse, stil} mit den IDs aus
     `pipeline/a5_paar.py`; Geschlecht je Person in p1/p2.geschlecht (weiblich | maennlich | neutral) */
  let paarfoto = { id: '', status: 'leer', text: '', bild: '', paar: null, offen: false, ohne: false };
  let paarfotoNr = 0;
  /* Strecke: die EINE GPX-Datei (17.10.2026). Steht aus demselben Grund hier
     oben wie `foto`. status: leer | laedt | ok | fehler */
  let datei = { id: '', status: 'leer', meldung: '', name: '' };

  /* ------------------------------------------------------------------ Zustand */
  const s = {
    look: 'hell',
    grund: null,
    akzent: null,
    rand: 'randlos',
    ton: '',            // Liste-B-Ton nach dem Andruck (Farbachse, 09.09.2026)
    /* Der Ton, mit dem der GEZEIGTE Kandidat gerendert wurde. `Farbe` geht
       nur mit, wenn `ton` davon abweicht (22.09.2026 — vorher wurde gegen
       `s.brief.grund` verglichen, und das ändert sich seit heute schon beim
       Marker-Klick nach dem Andruck, s. `tonNurWechsel`). */
    kandidatTon: '',
    kandidatBild: '',   /* Bühnen-URL des Andrucks ohne Format (Orts-Print) */
    ausfuehrung: 'Print',
    groesse: null,
    rahmenfarbe: null,
    phase: 'leer',      // leer | laeuft | fertig
    kandidatId: null,
    kandidat: null,     // {vorschau_url, titel, unterzeile} aus dem Backend
    /* Fingerabdruck des Briefs OHNE Markierung und Linien, auf dem der
       gezeigte Andruck steht (Chronik, `chronikUmzeichnenMoeglich`). Gesetzt,
       wenn ein Andruck gezeigt wird, und nach einem reinen Farbwechsel. */
    kartenBasis: '',
    brief: {},
    /* 🔴 BEANTWORTETE RÜCKFRAGEN ÜBERLEBEN DIE RUNDE (15.08.2026, Befund
       `code-pruefer` Runde 2, BELEGT an drei echten Backend-Aufrufen).

       Bis hierher schickte jede Runde NUR die gerade angezeigten Fragen
       zurück — `gewaehlt` ist eine frische Map je `rueckfragenZeigen`. Solange
       es genau eine Fragestellerin gab (Stufe 1, ein Deckel von einer Runde),
       war das folgenlos. Mit der Akzent-Rückfrage gibt es ZWEI, und sie
       fragen nacheinander:
         R1 Farbfrage      → beantwortet
         R2 Akzent gelöst, Stufe 1 fragt ihrerseits → beantwortet
         R3 trägt nur noch die Stufe-1-Antwort, die Farbantwort ist weg
            → Farbfrage erneut → R4 = R2 …
       Eine Endlosschleife, und jede gerade Runde bucht einen bezahlten
       Textdurchlauf. Antworten gehören zur BESTELLUNG, nicht zu einer Runde.

       ⚠️ Wird bei jeder Brief-Änderung geleert (`eingabeGeaendert`): ein
       geänderter Text kann andere Fragen bedeuten, und eine Antwort auf eine
       Frage, die so nicht mehr gestellt wird, ist schlimmer als keine. */
    antworten: [],
  };

  /* Der noch nicht eingelöste `?look=`-Wunsch aus der URL. Steht HIER und
     nicht bei seinen zwei Funktionen, weil `baueBrief()` ihn liest und `let`
     eine temporale Todeszone hat. Herleitung: `lookWunschEinloesen()`. */
  let lookWunsch = '';

  /* ------------------------------------------------------------------ Helfer */
  const $  = (sel, ctx = wurzel) => ctx.querySelector(sel);
  const $$ = (sel, ctx = wurzel) => Array.from(ctx.querySelectorAll(sel));

  function geld(cent) {
    if (cent == null) return '–';
    const betrag = (cent / 100).toLocaleString('de-DE', {
      minimumFractionDigits: cent % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    });
    return `${betrag} €`;
  }

  /* --- Zwei mögliche Optionslayouts -----------------------------------------
     Der Store ist NICHT so angelegt, wie varianten.json es beschreibt.

       varianten.json / produkte.csv : Ausführung · Größe · Rahmenfarbe   (3 Achsen)
       tatsächlich im Store          : Ausführung · Rahmen               (2 Achsen)

     Im Store steckt die Größe im Ausführungs-Wert („Print 30×40 cm",
     „Gerahmt 50×70 cm"), und „Rahmen" trägt „Ohne Rahmen" als Nicht-Wert.
     Das ist die Struktur, die import.py erzeugt — produkte.csv erzeugt die
     andere. Angelegt wurde offenbar über die API.

     Gemessen am 03.08.2026: bis dahin fand der Konfigurator auf KEINEM der
     vier Produkte eine Variante und zeigte „—". Meine frühere Prüfung lief
     gegen selbst gebaute Daten mit drei Achsen und konnte das nicht sehen.

     Deshalb trägt der Konfigurator jetzt beide Layouts. Er bleibt richtig,
     wenn der Katalog später auf drei Achsen normalisiert wird.           */

  const optIndex = {};
  (D.optionsnamen || []).forEach((name, i) => {
    const n = String(name).toLowerCase();
    if (n.startsWith('ausf')) optIndex.ausfuehrung = i;
    else if (n.startsWith('gr')) optIndex.groesse = i;
    else if (n.startsWith('rahmen')) optIndex.rahmenfarbe = i;
  });

  // Zwei Achsen und keine eigene Größe → kombiniertes Layout.
  const kombiniert = optIndex.groesse == null && optIndex.ausfuehrung != null;

  const OHNE_RAHMEN = 'Ohne Rahmen';

  /** Der Wert, den die Ausführungs-Achse für die aktuelle Wahl tragen muss. */
  function ausfuehrungsWert(z) {
    if (!kombiniert) return z.ausfuehrung;
    return z.groesse ? `${z.ausfuehrung} ${z.groesse}` : null;
  }

  /** Alle Größen, die im kombinierten Layout für eine Ausführung existieren. */
  function groessenAus(ausf) {
    const i = optIndex.ausfuehrung;
    if (i == null) return [];
    const raus = new Set();
    D.varianten.forEach((v) => {
      const w = v.optionen[i] || '';
      if (w.startsWith(ausf + ' ')) raus.add(w.slice(ausf.length + 1));
    });
    return Array.from(raus);
  }

  function werteFuer(feld) {
    if (kombiniert && feld === 'groesse') {
      // Größen aus „Print …" — sie gelten auch für „Gerahmt …".
      const p = groessenAus('Print');
      return p.length ? p : groessenAus('Gerahmt');
    }
    const i = optIndex[feld];
    if (i == null) return [];
    const gesehen = new Set();
    D.varianten.forEach((v) => {
      const w = v.optionen[i];
      if (w && w !== 'Default Title' && w !== OHNE_RAHMEN) gesehen.add(w);
    });
    return Array.from(gesehen);
  }

  /* --- Passende Variante suchen -------------------------------------------
     KONFLIKT 2: Rahmenfarbe ist eine VARIANTE, keine Property. Die Gelato-COGS
     unterscheiden sich je Farbe um 1,26–2,87 € — als Property wäre die Marge
     nicht zuzuordnen. Deshalb geht sie hier in die Variantensuche ein. */
  function trifft(v, z) {
    const o = v.optionen;
    const soll = ausfuehrungsWert(z);
    if (soll == null) return false;
    if (optIndex.ausfuehrung != null && o[optIndex.ausfuehrung] !== soll) return false;

    if (!kombiniert) {
      if (optIndex.groesse != null && z.groesse && o[optIndex.groesse] !== z.groesse) return false;
    }

    if (optIndex.rahmenfarbe != null) {
      const rahmenSoll = z.ausfuehrung === 'Gerahmt' ? z.rahmenfarbe : OHNE_RAHMEN;
      if (rahmenSoll && o[optIndex.rahmenfarbe] !== rahmenSoll) return false;
    }
    return true;
  }

  function findeVariante(zustand) {
    return D.varianten.find((v) => trifft(v, zustand || s));
  }

  /* 🔴 DER RAHMEN GEHÖRT INS BILD, NICHT NUR IN DIE MERKMALE (30.09.2026,
     Sascha: gerahmt bestellt, aber Warenkorb, Kasse und Mail zeigten das
     Blatt ohne Leiste). Die Bühne zeichnet den Rahmen per CSS — das Bild
     selbst hat keinen. Für die Zeile im Warenkorb hängt deshalb
     `?rahmen=<leiste>` an der Bild-Adresse; das Backend zeichnet die Leiste
     mit `pipeline/raum-rahmen.py` (dieselben abgenommenen Farben und
     Breiten). Die Bühne selbst bekommt den Parameter NIE — sonst trüge sie
     zwei Rahmen.
     Schlüssel = Optionswert klein, Leerzeichen → „-": „Holz Natur" →
     `holz-natur`. Das Backend lehnt unbekannte Namen mit 400 ab — dann
     zeigen Warenkorb, Kasse und Mail ein FEHLENDES Bild (Liquid prüft nur,
     ob die Property gesetzt ist, nicht ob sie lädt). Sichtbar, nicht still
     falsch; Auslöser wäre ein neuer Rahmen im Katalog, der in
     `raum-rahmen.LEISTEN` fehlt — dort nachziehen, nicht hier. */
  /* Dasselbe für den RAND (Steg schmal/breit): auch er entsteht erst im
     Druck (`postergen.steg_anlegen`) und fehlte deshalb im Warenkorbbild.
     `?rand=` zeichnet ihn mit derselben Funktion. NICHT für Wortschatz und
     Jahreszahl — deren Passepartout steckt schon im Bild (`achsen.png`),
     `randSichtbar()` ist dort false. Das ZITAT bekommt den Rand seit dem
     30.09.2026 wie die übrigen Konzepte. */
  function mitRahmenParameter(url) {
    const gerahmt = s.ausfuehrung === 'Gerahmt' && s.rahmenfarbe;
    const rand = randSichtbar() && s.rand && s.rand !== 'randlos' ? s.rand : '';
    if (!gerahmt && !rand) return url;
    try {
      const u = new URL(url);
      if (rand) u.searchParams.set('rand', rand);
      if (gerahmt) {
        u.searchParams.set('rahmen',
          String(s.rahmenfarbe).trim().toLowerCase().replace(/\s+/g, '-'));
      }
      return u.toString();
    } catch { return url; }
  }

  function hatEingabe() {
    return $$('[data-eingabe]').some((f) => f.value.trim() !== '');
  }

  /* ================================================================== Brief */

  /* Felder je Konzept — Stand der Eingabe-Vorlage 05.08., eingebaut 07.08.,
     hierher portiert 09.08.2026 (Entscheidung A: das Theme ist der Kanon).

     ⚠️ INVARIANTE für alle Listenfelder: der Wert bleibt eine Liste von
     STRINGS. `backend/dienst.content_block` baut den Prompt mit
     `' · '.join(v)`, und `entwuerfe_erzeugen` zählt `len(brief["momente"])`
     für die Symbolzahl. Jahre und Akzentträger stehen deshalb in eigenen
     Feldern daneben, nicht verschachtelt. */
  /* --- Die Liste-B-Töne, aus dem marke:auto-Block ---------------------------
     🔴 GELESEN, NICHT GESCHRIEBEN. `D.grundtoene.dunkel` steht im erzeugten
     Block der PDP-Section und kommt aus marke/tokens.json (Liste B: Petrol ·
     Terrakotta · Salbei). Eine eigene Liste hier wäre die zweite Wahrheit, an
     der Terrakotta bis zum 31.07.2026 an sechs Stellen auseinanderlief — und
     sie überlebte den nächsten `marke/sync.py`-Lauf nicht.
     ⚠️ Der Backend-Riegel prüft dieselben IDs gegen `markenwerte.GRUENDE`;
     ein Ton, den jemand hier hinzufügt, ohne ihn in den Kanon zu nehmen,
     scheitert dort laut statt still zu rendern. */
  const LISTE_B = () => (D.grundtoene?.dunkel || [])
    .map((t) => ({ id: t.id, label: t.label, hex: t.hex }));

  /* Der zweite Look, je Bautyp. Saschas Farbentscheidung vom 09.08.2026,
     wörtlich: „Liste B bestimmt die Fläche — bei A1/A5/A8 als
     Aussparungs-Grund, bei C1 als Linol-Tinte."
     🔴 Der Look ist ein BRIEF-Feld, keine globale Optik-Achse: er geht ins
     Backend und bestimmt den Prompt. Schritt II („Look und Farbe") ist
     deshalb am 14.08.2026 für alle vier Konzepte abgeschaltet worden — er
     führte vier Regler, die NUR in Cart-Properties landeten. Zwei
     Grundton-Felder auf einer Seite wären genau die „zwei Hüllen"-Bauform,
     nur sichtbar für den Kunden. */

  /* --- Look und Ton als EINE Reihe runder Marker (17.08.2026) --------------
     Sascha, nach Durchsicht der vier Staging-PDPs, wörtlich: „Unterschied
     hell zu dunkel wird visuell nicht ersichtlich beim Klick. Mit runden
     Markern arbeiten, d.h. Hell = Kreis mit Creme, Dunkel = Kreise mit den
     Vollton-Farben zur Auswahl. Ggf. einfach alle Kreise direkt nebeneinander
     zeigen und Kunden wählen lassen."

     🔴 EIN FELD STATT ZWEI, und das ist der eigentliche Gewinn. Vorher waren
     es zwei Chip-Reihen: „Wie es aussehen soll" (Hell/Dunkel) und darunter,
     erst nach der Wahl von „Dunkel", „Grundton". Zwei Entscheidungen für
     einen Entschluss — und die erste war unanschaulich, weil „Dunkel" keine
     Farbe zeigt, sondern ein Wort. Wer Farben am Muster wählt (und das ist
     hier jeder, `ventures/echoa/CLAUDE.md`), entscheidet an der zweiten Reihe
     ohnehin neu.

     🔴 DER MARKER-WERT TRÄGT BEIDES: `kontrolle` oder `<zweig>:<ton>`, also
     z.B. `aussparung:petrol`. Aufgespalten wird er in `sammleBrief()` — der
     Brief ans Backend führt `look` und `grund`/`tinte` unverändert GETRENNT
     weiter (`dienst.look_und_ton` prüft beide einzeln). Die Zusammenfassung
     ist eine Sache der Oberfläche und endet an der Formulargrenze.

     ⚠️ Der helle Marker ist NICHT immer creme: bei A5 ist die Kontrollfassung
     ein farbiger Moment, kein cremefarbenes Blatt. Ein Creme-Kreis dort wäre
     eine falsche Zusage — deshalb `art: 'bunt'` und ein Marker aus den
     Akzenttönen. */
  /* 🔴 DIE LOOK-WERTE JE KONZEPT — EINE STELLE, DIE DIE WAHRHEIT TRÄGT
     (17.08.2026). Alles darunter LEITET AB: `markerFeld` nimmt seinen Zweig
     von hier, die C1-Stilkacheln nehmen ihre IDs von hier.

     Es ist zugleich die Schnittstelle nach außen: `backend/dienst.py` prüft
     im Selbsttest, dass jeder Look, den `look_und_ton` erlaubt, im Theme auch
     einen Bedienweg hat — der Test greppt diese Konstante, statt die
     Formularbauform zu parsen.

     🔴 WARUM DAS NICHT KOSMETIK IST: der Test hat genau einen Zweck — ein
     Look ohne Bedienelement ist unerreichbar, ein Bedienelement ohne Zweig
     wirft dem Kunden NACH dem bezahlten Textdurchlauf. Also nach dem Geld.
     Bis heute las er `const AUSSPARUNG`; die Umstellung auf Farbmarker ließ
     ihn ins Leere greifen und vier rote Zeilen melden, obwohl nichts kaputt
     war — eine Prüfung, die gute Arbeit verwirft, wird weggelesen und meldet
     dann den Ernstfall nicht mehr (`rules/pruefungen.md` §1).
     ⚠️ Wer hier einen Wert ändert, ändert ihn in `dienst.look_und_ton` mit —
     dort steht die Gegenprobe, und sie lehnt Unbekanntes laut ab. */
  const LOOKS_JE_HANDLE = {
    'icon-grid':      ['kontrolle', 'aussparung'],
    'weg-chronik':    ['kontrolle', 'aussparung'],
    'momentaufnahme': ['kontrolle', 'aussparung'],
    'orts-print':     ['kontrolle', 'linolschnitt'],
    /* 🔴 K2 hat zwei MACHARTEN statt zweier Flächen — `bildlich` wird
       gerendert, `lexikon` vollständig gesetzt (0,00 $ je Vorschau).
       Der ERSTE Eintrag ist der Vorgabe-Look, hier also `bildlich`.
       C2 hat genau EINEN Look: Sascha am Bild, 07.09.2026 — kein Muster,
       sechs Objekte plus große Zahl vertragen es nicht.
       ⚠️ Die Gegenprobe steht in `dienst.LOOKS_JE_BAUTYP`; der Selbsttest
       (5b-bis) hält beide gegeneinander. */
    /* 🆕 20.10.2026 (Saschas T1 »A«, Bauplan „Pop im Shop"): Wortschatz-Pop —
       Stil Linolschnitt / Abstrakt. Die alten Macharten `bildlich`/`lexikon`
       baut das Backend weiter (`dienst.LOOKS_ALTBESTAND`), angeboten werden sie
       nicht mehr. */
    'wortschatz':     ['linol', 'abstrakt'],
    'jahreszahl':     ['kontrolle'],
    /* Zitat (29.09.2026): eigenes Produkt, genau ein Look — gesetzt. */
    /* 🆕 20.10.2026: Zitat-Pop, fünf feste Poster (Feld `poster`); das gesetzte
       Farbwelt-Zitat ist Altbestand im Backend. */
    'zitat':          ['pop'],
    /* Gaming-Paar (16.10.2026): ein Look; die Spielwelt ist eine Angabe. */
    'gaming':         ['gaming'],
    /* Haustier/Pferd (16.10.2026): fünf Looks aus EINEM Render, Wechsel nach
       dem Andruck ohne neuen Render (`haustierSatz`). Gegenprobe:
       `dienst.LOOKS_JE_BAUTYP['h1']` und `haustier.LOOKS`. */
    'haustier':       ['farbig', 'schwarzweiss', 'petrol', 'terrakotta', 'salbei'],
    'pferd':          ['farbig', 'schwarzweiss', 'petrol', 'terrakotta', 'salbei'],
    /* Linien-Seite (28.10.2026): Tinte auf Papier oder Papier auf drei Gründen, nach dem Andruck ohne Render.
       Gegenprobe: `dienst.LOOKS_JE_PRODUKT['linie']` (`linie.GRUENDE`). */
    'linie':          ['papier', 'terrakotta', 'petrol', 'salbei'],
    /* Porträt (29.10.2026): dieselben Gründe, wählbar beim Pinsel; Kohle steht immer auf Papier.
       Gegenprobe: `dienst.LOOKS_JE_PRODUKT['portraet']`. */
    'portraet':       ['papier', 'terrakotta', 'petrol', 'salbei'],
    /* Rezept (17.10.2026): dieselben fünf Looks, Wechsel nach dem Andruck ohne
       neuen Render (`rezeptSatz`). Gegenprobe: `dienst.LOOKS_JE_BAUTYP['r1']`. */
    'rezept':         ['farbig', 'schwarzweiss', 'petrol', 'terrakotta', 'salbei'],
    /* Strecke/Wanderung (17.10.2026): ein Look — Karte auf Creme, Strecke in
       Terrakotta. Gegenprobe: `dienst.LOOKS_JE_BAUTYP['s1']`. */
    'strecke':        ['karte'],
    'wanderung':      ['karte'],
  };
  /** Der zweite Look eines Konzepts — der Zweig, den die Volltöne tragen. */
  const zweigVon = (handle) => LOOKS_JE_HANDLE[handle][1];

  /* 🔴 `hell: null` LÄSST DEN KONTROLL-MARKER WEG (Sascha, 24.09.2026,
     Option B am Moment): der farbige Look bleibt im Backend baubar
     (`dienst.look_und_ton` kennt ihn weiter, `LOOKS_JE_HANDLE` unverändert),
     ist aber im Kaufweg nicht mehr wählbar — die Vorwahl fällt auf den ersten
     Vollton. Nicht löschen, sondern verstecken: der Rückweg zum späteren
     Bündel-Konzept bleibt eine Zeile. Der Rückfall in `briefSichtbar()`
     (»der Kontroll-Marker ist nie gesperrt«) läuft ohne den Marker leer, was
     dort erlaubt ist: beim Moment gibt es seit dem 19.08.2026 keine Sperre. */
  /* `hellHinten` (30.09.2026, Sascha: der farbige Moment „weniger prominent …
     einfach nur als zweite Option hinter der eingefärbten Akzent-Variante"):
     der Kontroll-Chip steht HINTER den Volltönen. Die Vorwahl ist beim Look
     immer der erste Chip — damit bleibt sie der erste Vollton. */
  const markerFeld = ({ label, hilfe, tonFeld, zweig, hell, hellHinten = false }) => {
    const kontrolle = hell
      ? [{ id: 'kontrolle', label: hell.label, art: hell.art, hex: hell.hex || null }]
      : [];
    const volltoene = LISTE_B().map((t) => ({
      id: `${zweig}:${t.id}`, label: t.label, hex: t.hex, art: 'vollton',
    }));
    return {
      name: 'look', typ: 'farbmarker', property: 'Look', pflicht: true,
      label, hilfe, tonFeld,
      optionen: hellHinten ? [...volltoene, ...kontrolle] : [...kontrolle, ...volltoene],
    };
  };

  /* --- Haustier/Pferd: gemeinsame Bausteine (16.10.2026) ------------------ */
  /* Felder, die NACH dem Andruck gesetzt werden — kein neuer Render.
     🔴 Spiegel von `dienst.HAUSTIER_SATZ_FELDER`. Fehlt hier eines, wirft
     jeder Klick darauf den bezahlten Andruck weg (`briefSchluessel`). */
  const HAUSTIER_HANDLES = new Set(['haustier', 'pferd']);
  const HAUSTIER_SATZ_FELDER = new Set(['look', 'machart', 'name', 'zeile', 'geschlecht',
    'eigenheit_1', 'eigenheit_2', 'eigenheit_3', 'eigenheit_4', 'familie', 'stall',
    'seit', 'stockmass', 'besitzer', 'titelfarbe', 'fusszeile']);
  /* 🔴 SCHALTER (21.10.2026): Der Code steht seit PR #346 in main, die Live-Schaltung ist
     Saschas T1. AUS = Haustier sieht aus wie vor dem 21.10. (Porträt/Lexikon, fünf Farben),
     das Backend setzt ohne `stil` die Illustration. Spiegel: `haustier_macharten_an` in
     `sections/echoa-pdp.liquid`. AN schaltet `shop/live-haustier-macharten-1021.sh`. */
  const HAUSTIER_MACHARTEN_AN = true;
  /* 🔴 SCHALTER (27.10.2026, Saschas T1): Machart »Linie« bei Haustier und Pferd — eine durchgehende
     Linie, Tier im Profil. AUS = keine Linie-Kachel, kein `?machart=linie`. Spiegel: `dienst.HAUSTIER_LINIE`
     (Andruck) und `linie_an` in `sections/echoa-pdp.liquid` (Galerie). AN schaltet `shop/live-linie.sh`. */
  const LINIE_AN = true;
  /* 🔴 SCHALTER (21.10.2026, Saschas T1 »A, bau das so«): Entwurfs-Vorteil unter jedem eigenen
     Andruck — 15 % + Versand frei mit echter Frist. AUS = Seite wie vor dem 21.10. Spiegel von
     `dienst.VORTEIL_AN`; der Dienst-Selbsttest (V) hält beide gleich. Zusätzlich fragt die Seite
     nur, wenn `/puls` → vorteil meldet — ein alter Dienst bleibt damit still. */
  const VORTEIL_AN = true;
  /* Zustand von Vorteil und Auswahl HIER oben, nicht bei ihren Funktionen:
     `aktionZeichnen()` ruft `vorteilZeichnen()`, und ein `const` weiter unten
     wäre beim ersten Zeichnen noch nicht angelegt (TDZ → ReferenceError). */
  const VORTEIL = new Map();     // kandidatId → Antwort | null (kein Vorteil) | undefined (läuft)
  let vorteilBereit = false;     // `/puls` → vorteil: true
  /* 🆕 31.10.2026 BLACK FRIDAY (Saschas T1 »A«, Werbe-Lock 31.10. 09:25): im Fenster heißt der Vorteil
     „Black Friday“ statt „Exklusiv für deinen Entwurf“ / „Dein Vorteil“. Nur die WORTE hängen am Fenster —
     Prozent und Frist kommen weiter aus `/api/vorteil` (`vt.prozent`, im Fenster 20). Fenster = Shop-Metafeld
     `echoa.black_friday` (`backend/black_friday.py`, `start`/`ende`), ausgegeben in
     `snippets/echoa-konfigurator.liquid` als `[data-black-friday]`. Geprüft wird HIER im Browser, nicht beim
     Rendern: eine zwischengespeicherte Seite trüge sonst das Fenster vom Renderzeitpunkt. Kein Feld → wie bisher.
     🆕 02.11.2026 (Saschas »Claim A«): die Worte heißen „Weihnachtsrabatt“ statt „Black Friday“ — EINE Stelle, BF_NAME. */
  const BF_NAME = 'Weihnachtsrabatt';
  const BF = (() => {
    try {
      const b = JSON.parse(document.querySelector('[data-black-friday]')?.textContent || 'null');
      const a = Date.parse(b?.start), e = Date.parse(b?.ende);
      return Number.isFinite(a) && Number.isFinite(e) ? { a, e, p: Number(b?.prozent_1) || 0 } : null;
    } catch { return null; }
  })();
  /* Ein Code von vor der Umstellung (15 %) heißt NICHT „Black Friday“ — sonst stünde „Black-Friday-Vorteil −15 %“
     neben einer Aktion mit 20 % (code-pruefer Runde 2). Der Text bleibt dann der alte. */
  function bfAktiv(vt) {
    const t = Date.now();
    return Boolean(BF) && t >= BF.a && t <= BF.e && !(vt && vt.prozent < BF.p);
  }
  /* Setzt den Text eines Elements im Fenster auf `bf`, außerhalb zurück auf den Text aus dem Theme. */
  function bfText(el, bf, vt) {
    if (!el) return;
    if (el.dataset.ursprung == null) el.dataset.ursprung = el.textContent;
    el.textContent = bfAktiv(vt) ? bf : el.dataset.ursprung;
  }
  const AUSWAHL_GESENDET = new Set();   // `${kandidatId}|${varianteId}|${anlass}`, je Seitenaufruf
  /* 🔴 STREICHPREIS (Saschas T1 »A«, 21.10.2026): bei gültigem Vorteil „~~49 €~~ 41,65 €".
     Durchgestrichen wird NUR der echte Listenpreis. § 11 PAngV verlangt als Bezug den
     niedrigsten Preis der letzten 30 Tage — das ist der Listenpreis, solange binnen 30 Tagen
     kein Preis ERHÖHT wurde. `scripts/code-gate.sh` (Prüfung 19) meldet rot, wenn
     `katalog/varianten.json` das getan hat und dieser Schalter an ist; dann hier `false`,
     bis 30 Tage um sind. ⚠️ Eine Preisänderung direkt im Shopify-Admin sieht das Gate nicht. */
  const STREICHPREIS_AN = true;
  /* „Deine Angaben" offen? Zu klappt es NUR, wenn ein Andruck fertig WIRD (Phase wechselt nach
     'fertig') — nicht bei jeder neuen Kandidaten-ID: Pixel-Paar (Satz), Weg-Chronik (Umzeichnen)
     und der Look-Rückweg erzeugen im offenen Formular selbst eine neue ID, und das Formular
     klappte sonst unter dem tippenden Finger zu (code-pruefer 21.10.2026). */
  let angabenOffen = false;
  let kaufPhaseVorher = null;
  let leisteRahmen = 0;          // requestAnimationFrame der Kaufleiste
  /* 🆕 MAGAZIN · KOHLE · ILLUSTRATION (Saschas T1 »A«, 20.10.2026). Die Machart
     (`stil`) und das Styling gehen in den Render — sie stehen bewusst NICHT oben:
     ein Wechsel ist ein neuer Andruck. Titelfarbe, Fußzeile und »seit« sind Satz. */
  /* `k`: Bildschlüssel des Produkts (`h1m` Haustier, `h2m` Pferd seit 21.10.2026). */
  const HAUSTIER_STIL = (k = 'h1m') => ({
    name: 'stil', typ: 'stil', label: 'Machart', property: 'Machart', pflicht: true,
    /* `urlVorwahl` (22.10.2026, Saschas T1 »A«): die Creme-Anzeigen verlinken
       `?machart=illustration` — ohne landete ihr Klick auf Magazin. */
    vorwahl: 'magazin', urlVorwahl: 'machart', spalten: 3,
    /* Seit 26.10.2026 steht die Machart VOR dem Foto — der Satz sagt deshalb, welche ein Foto braucht. */
    hilfe: 'Jede Machart ist ein eigener Entwurf. Magazin entsteht aus deinem Foto, die anderen gehen auch ohne.',
    /* Sascha 28.10.2026: „die anderen gehen auch ohne" ist zu salopp — sein Wortlaut. */
    hilfeEineSeite: 'Magazin braucht dein Foto, alle anderen Stile kannst du optional auch beschreiben.',
    optionen: [
      { id: 'magazin', label: 'Magazin', bild: `${k}_magazin_ohne`,
        hinweis: 'Dein Foto in Schwarz-Weiß, der Name als Titel' },
      { id: 'kohle', label: 'Kohle', bild: `${k}_kohle`,
        hinweis: 'Von Hand gezeichnet, wie im Atelier' },
      { id: 'illustration', label: 'Illustration', bild: `${k.slice(0, 2)}_farbig`,
        hinweis: 'Flach gemalt, Porträt oder Lexikon' },
      ...(LINIE_AN ? [{ id: 'linie', label: 'Linie', bild: `${k}_linie`,
        hinweis: 'Eine einzige Linie, wie aus dem Gedächtnis gezeichnet' }] : []),
    ] });
  const HAUSTIER_STYLING = {
    /* `?styling=sonnenbrille` | `turnier` … für die Magazin-Anzeigen (22.10.2026). */
    /* 🆕 22.10.2026 (Sascha: „braucht zwingend Vorschaubilder … direkt als Knopf"): Bildkacheln
       statt Wort-Chips. Das Bild folgt dem Tier (`kachelBilderSetzen`); fehlt ein Tier-Bild
       (Katze/Kleintier mit Seidentuch oder Mütze), zeigt die Kachel den Hund mit demselben
       Styling — sie erklärt das Accessoire, nicht das Tier. */
    name: 'styling', typ: 'stil', reihe: true, label: 'Styling', property: 'Styling', vorwahl: 'ohne',
    urlVorwahl: 'styling',
    hilfe: 'Wird mitfotografiert – entscheide dich vor dem Entwurf.',
    nurWenn: { feld: 'stil', wert: 'magazin' },
    optionen: [
      { id: 'ohne', label: 'Ohne', bild: 'h1m_magazin_ohne' },
      /* `kurz`: nur auf der einen Seite (`EINE_SEITE_AN`) — „Son-nen-bril-le" brach in der schmalen Kachel über drei
         Zeilen, die Reihe war dadurch 210 px hoch (Handy 375 px, 28.10.2026). Das Bild zeigt, welches Tuch, welche
         Brille. Warenkorb und Zusammenfassung behalten `label`. */
      { id: 'seidentuch', label: 'Seidentuch', kurz: 'Tuch', bild: 'h1m_magazin_seidentuch' },
      { id: 'sonnenbrille', label: 'Sonnenbrille', kurz: 'Brille', bild: 'h1m_magazin_sonnenbrille' },
      { id: 'strickmuetze', label: 'Strickmütze', kurz: 'Mütze', bild: 'h1m_magazin_strickmuetze' },
    ] };
  /* Pferd (Saschas T1 21.10.2026): reitertypisch statt Schal/Brille/Mütze. */
  const PFERD_STYLING = {
    ...HAUSTIER_STYLING,
    optionen: [
      { id: 'ohne', label: 'Ohne', bild: 'h2m_magazin_ohne' },
      { id: 'trense', label: 'Trense schlicht', bild: 'h2m_magazin_trense' },
      { id: 'turnier', label: 'Turnier', hinweis: 'Mähne geflochten', bild: 'h2m_magazin_turnier' },
    ] };
  /* Titelfarben aus dem Kanon (`D.titelfarben`, erzeugter `marke:auto`-Block). */
  const HAUSTIER_TITELFARBE = () => ({
    name: 'titelfarbe', typ: 'marker', label: 'Farbe des Titels', property: 'Titelfarbe',
    pflicht: true, vorwahl: 'neongelb',
    hilfe: 'Kannst du nach dem Entwurf wechseln, ohne neuen Entwurf.',
    hilfeEineSeite: '',
    nurWenn: { feld: 'stil', wert: 'magazin' },
    optionen: (D.titelfarben || []).map((t) => ({ id: t.id, label: t.label, hex: t.hex })),
  });
  const istHaustier = () => HAUSTIER_HANDLES.has(D.produkt.handle);
  /* Satz ohne Render über `/api/kandidat/<id>/haustier` (Bautyp h1): Haustier, Pferd und die Linien-Seite
     (28.10.2026). NUR an den Satz-Stellen (Basis, Warenkorb-Fassung, Fingerabdruck, Neu-Setzen) — Tierfoto,
     Magazin, Lexikon und Tier-Befund bleiben bei `istHaustier()`. */
  const SATZ_H1 = new Set([...HAUSTIER_HANDLES, 'linie', 'portraet']);
  const istSatzH1 = () => SATZ_H1.has(D.produkt.handle);

  /* 🆕 PIXEL-PAAR: EINSTIEG UND FIGUREN-EDITOR (18.10.2026, Saschas T1 »A« vom
     17.10.; Editor statt Szene nach Saschas Abwägung am 18.10.). Die Maske hat
     15 Felder — vor dem ersten Klick sieht der Kunde nur das Beispiel der Welt
     und „Euch gestalten". Danach steht über den Feldern ein FIGUREN-EDITOR:
     beide Figuren neutral stehend (`/api/gaming/figuren.png`,
     `pipeline/nischen/gaming_vorschau.py`, 0 $, kein Modell), wie in einem
     Spiel. Die Bühne zeigt weiter das Beispiel der gewählten Welt.
     ⏪ Bis 18.10. nachmittags stand das Paar als Vorschau IN der Welt auf der
     Bühne (»C«). Sascha: „die Leute erwarten genau diesen Look und bekommen ihn
     am Ende aber mit Abweichungen" — ein Editor weckt diese Erwartung nicht.
     Zu ist zu per Klasse am <html>, nicht per `hidden` am Knopf: den Knopf
     `[data-aktion]` schalten andere Stellen selbst. */
  const istGaming = () => D.produkt.handle === 'gaming';
  /* 🆕 21.10.2026 (Saschas Linie: was gesetzt ist, ist nach dem Andruck kostenlos änderbar,
     „alle Konzepte einheitlich"): Texte, die auf dem eingefrorenen Render GESETZT stehen —
     ein Wechsel setzt den gezeigten Entwurf neu (`textSatzAnstossen`, 0 $), statt ihn zu
     verwerfen. Ergebnis ist ein NEUER Entwurf, wie beim Chronik-Umzeichnen.
     Spiegel von `dienst.GAMING_SATZ_FELDER` (Route `gaming`) und `dienst.TEXT_SATZ_FELDER`
     (Route `texte`). Gemalt und deshalb NICHT dabei: der Ort (Szene), das Alter der
     Jahreszahl, der Satz auf den gemalten Zitat-Postern 1–4, die Symbole selbst. Die Beschriftungen
     unter den Symbolen sind gesetzt (`beschriftungen`, eine Liste je Symbol — Sascha, E8 »A«,
     29.10.2026); ihre Felder baut `beschriftungenZeichnen`, nicht das Formular.
     Chronik (Namen, Jahre am Ort) läuft übers Umzeichnen (`KARTEN_FELDER`), Haustier,
     Rezept und Strecke über ihre eigenen Satz-Wege — die setzen ohne neuen Entwurf. */
  const TEXT_SATZ = {
    gaming: { route: 'gaming', felder: ['name1', 'name2', 'jahr'] },
    momentaufnahme: { route: 'texte', felder: ['name1', 'name2', 'jahr'] },
    'orts-print': { route: 'texte', felder: ['jahr'] },
    jahreszahl: { route: 'texte', felder: ['widmung'] },
    wortschatz: { route: 'texte', felder: ['wort', 'kind_und_alter', 'anlass'] },
    zitat: { route: 'texte', felder: ['kind_und_alter', 'anlass', 'satz'] },
    'icon-grid': { route: 'texte', felder: ['name1', 'name2', 'beschriftungen'] },
  };
  /* Spiegel von `dienst.A1_BESCHRIFTUNG_MAX` — der Browser schneidet ab, der Dienst lehnt trotzdem ab. */
  const BESCHRIFTUNG_MAX = 40;
  /** Vergleichswert eines gesetzten Felds: Listen (Beschriftungen) als JSON, sonst der Text. */
  const satzWert = (v) => (Array.isArray(v) ? JSON.stringify(v) : String(v || ''));
  const textSatzAktiv = () => Boolean(TEXT_SATZ[D.produkt.handle]);
  /** Die gesetzten Felder für DIESEN Brief. Zitat: der Satz ist nur auf Flieder gesetzt —
      auf den Postern 1–4 malt ihn das Modell, ein anderer Satz ist ein neuer Andruck. */
  function textSatzFelder(brief) {
    const t = TEXT_SATZ[D.produkt.handle];
    if (!t) return [];
    /* Das gemalte Wortschatz-Blatt hat kein Pop-Paket — der Dienst setzt dort keine Texte neu
       (`texte_neu_setzen` → 404). Das Wort bleibt im Fingerabdruck, eine Änderung verwirft den
       Andruck sauber (code-pruefer 22.10.2026: sonst 404-Schleife mit altem Wort auf der Bühne). */
    if (D.produkt.handle === 'wortschatz' && (brief || {}).look === 'bildlich') return [];
    if (D.produkt.handle === 'gaming' && HAAR_UMFAERBEN_AN) return [...t.felder, ...GAMING_FARB_FELDER];
    /* Beschriftungen nur, wenn der Brief sie trägt — vor dem Andruck und bei einem Entwurf ohne
       bekannte Beschriftungen gibt es keine Felder, und ein fehlender Wert ist dann keine Änderung. */
    return t.felder.filter((k) => (k !== 'satz' || (brief || {}).poster === 'flieder')
      && (k !== 'beschriftungen' || Array.isArray((brief || {}).beschriftungen)));
  }
  /** Was der Fingerabdruck NICHT zählt (`namen` ist die Zusammenfassung von name1/name2). */
  function textSatzOhne(brief) {
    const f = textSatzFelder(brief);
    return new Set(f.includes('name1') ? [...f, 'namen'] : f);
  }
  let gamingOffen = false;
  const GAMING_FELDER = /^(p[12]_[a-z]+|tier[12](_fell)?)$/;
  function gamingFigurenUrl() {
    if (!BACKEND) return '';
    const q = new URLSearchParams();
    Object.entries(s.brief || {}).forEach(([k, v]) => {
      if (v && GAMING_FELDER.test(k)) q.set(k, String(v).slice(0, 40));
    });
    return `${BACKEND}/api/gaming/figuren.png?${q}`;
  }
  function gamingTorZeichnen() {
    if (!istGaming()) return;
    const halter = $('[data-brief]');
    if (!halter) return;
    /* 🆕 30.10.2026 abends (Sascha: „nicht konsistent mit der Reihenfolge der anderen Konzepte“): mit `GAMING_FOTO_AN`
       kein Tor „Euch gestalten“ mehr — Spielwelt, Foto bzw. „Kein Foto zur Hand?“, Namen stehen offen da wie bei allen
       Konzepten (Reihenfolge seit 31.10.2026, Saschas T1 »B«); den Baukasten öffnet erst die Klappe (`gamingMaskeZeichnen`). */
    const offen = GAMING_FOTO_AN || gamingOffen || s.phase !== 'leer' || Boolean(s.kandidatId);
    /* Einmal offen, bleibt offen — auch wenn ein eigener Entwurf (Rückweg aus dem Warenkorb,
       Entwurfsleiste) danach verworfen wird; sonst verschwände das Formular beim Tippen
       (code-pruefer 18.10.2026). */
    if (offen) gamingOffen = true;
    document.documentElement.classList.toggle('echoa-gaming-zu', !offen);
    let tor = $('[data-gaming-tor]');
    if (!tor) {
      tor = document.createElement('div');
      tor.className = 'gaming-tor';
      tor.dataset.gamingTor = '';
      tor.innerHTML = `<p class="feld-hilfe">Ihr zwei als Pixel-Figuren – mit Frisur,
        Brille, Lieblingsfarbe und Haustier. Ein paar Klicks, dann zeichnen wir euer Bild.</p>
        <button type="button" class="echoa-aktion echoa-aktion--gross"
          data-gaming-oeffnen>Euch gestalten</button>`;
      halter.before(tor);
    }
    tor.hidden = offen;
    /* Beispiel der gewählten Welt auf die Bühne — nie über einen eigenen Andruck (derselbe Riegel
       wie `lookBeispielZeigen`, das beim Pixel-Paar deshalb gar nicht erst läuft). */
    const blatt = document.querySelector('[data-tafel="blatt"] .buehne__bild');
    const weltBild = (D.stilbilder || {})[`g1_${s.brief.welt || ''}`];
    const eigen = Boolean(blatt) && (/\/api\/kandidat\//.test(blatt.src)
      || Boolean(BACKEND && blatt.src.startsWith(BACKEND)));
    if (blatt && weltBild && !eigen && s.phase === 'leer' && !s.kandidatId
        && blatt.getAttribute('src') !== weltBild) {
      blatt.removeAttribute('srcset');
      blatt.src = weltBild;
      ansichtWechseln('blatt');
    }
    /* `baueBrief` leert den Halter — der Editor wird dann neu angelegt. */
    let ed = halter.querySelector('[data-gaming-figuren]');
    if (!ed && BACKEND) {
      ed = document.createElement('figure');
      ed.className = 'gaming-figuren';
      ed.dataset.gamingFiguren = '';
      ed.innerHTML = `<img alt="Eure zwei Figuren" width="680" height="368">
        <figcaption class="feld-hilfe">Vereinfachte Vorschau – im fertigen Bild zeichnen wir euch
        <b>detailreicher und mitten in eurer Welt</b>, so wie im Beispiel.</figcaption>`;
      /* ⏪ Bis 19.10.2026: „Eure Figuren. Im fertigen Bild sitzen bzw. stehen sie …". Sascha 19.10.:
         viele probieren, wenige bestellen — wer sich im groben Editor nicht sofort wiederfindet,
         soll nicht abspringen. Der Satz verspricht mehr, nicht weniger (Kauffläche, CLAUDE.md). */
      /* 🆕 30.10.2026 abends: mit `GAMING_FOTO_AN` direkt über dem Baukasten (unter „Foto wählen | Deine Avatare
         gestalten“), sonst stünde die Vorschau weit über dem Knopf, der sie öffnet. Sie klebt weiter beim Blättern. */
      const vor = GAMING_FOTO_AN && (halter.querySelector('[data-gaming-kopf="1"]')
        || halter.querySelector('[data-brieffeld-halter="p1_haar"]'));
      if (vor) vor.before(ed); else halter.prepend(ed);
      /* Kaputtes Bild nie zeigen — und nicht beim nächsten Zeichnen wieder einblenden. */
      const img = ed.querySelector('img');
      img.onerror = () => { img.dataset.kaputt = '1'; ed.hidden = true; };
      img.onload = () => { img.dataset.kaputt = ''; ed.hidden = !gamingOffen; };
    }
    gamingMaskeZeichnen(halter);
    if (!ed) return;
    ed.hidden = !offen || ed.querySelector('img').dataset.kaputt === '1';
    if (!offen) return;
    /* Nur Klick-Felder gehen in die Adresse (keine Namen) — Tippen holt also kein neues Bild. */
    const img = ed.querySelector('img');
    const url = gamingFigurenUrl();
    if (url && img.getAttribute('src') !== url) img.src = url;
  }
  /* 🆕 Pixel-Paar-Maske »C« (Sascha, 19.10.2026): Umschalter „Figur 1 | Figur 2" — es stehen
     immer nur die Fragen EINER Figur da — und je Figur ein Klappschalter „Brille, Bart,
     Kleidung". Gemessen vorher: 18 Fragen auf 4,3 Bildschirmhöhen (375×812).
     Ausgeblendet wird per Klasse, nicht per `hidden`: `hidden` gehört `briefSichtbar`
     (nurWenn) und LEERT dort die Wahl — hier muss sie stehen bleiben (s. `gamingFigur`).
     Die Knöpfe sind keine Brief-Felder: nichts davon geht in den Warenkorb. */
  let gamingAktiv = 1;
  const gamingKlappe = { 1: false, 2: false };
  /* Reiter an/aus: true = Variante C (Umschalter), false = Variante D (beide Figuren
     untereinander, je mit Überschrift). Sascha 19.10.: „bist du sicher, dass die Leute den
     Umschalter checken?" — Vergleich am Vorschau-Theme. */
  const GAMING_REITER = false;
  function gamingMaskeZeichnen(halter) {
    if (!istGaming() || !halter) return;
    const felder = briefDef().felder || [];
    const klappe = new Set(felder.filter((f) => f.klappe).map((f) => f.name));
    const erstes = halter.querySelector('[data-brieffeld-halter="p1_haar"]');
    if (!erstes) return;
    if (!GAMING_REITER) gamingAktiv = 0;
    /* Variante D: je Figur eine Überschrift mit Name und Seite im Bild. */
    [1, 2].forEach((n) => {
      let kopf = halter.querySelector(`[data-gaming-kopf="${n}"]`);
      const anker = halter.querySelector(`[data-brieffeld-halter="p${n}_haar"]`);
      if (!kopf && anker) {
        kopf = document.createElement('p');
        kopf.className = 'gaming-kopf';
        kopf.dataset.gamingKopf = String(n);
        anker.before(kopf);
      }
      if (kopf) {
        const name = String(s.brief[`name${n}`] || '').trim();
        kopf.innerHTML = `${escape(name || `Figur ${n}`)} <span>${n === 1 ? 'links' : 'rechts'} im Bild</span>`;
        kopf.classList.toggle('gaming-weg', GAMING_REITER);
      }
    });
    let tabs = halter.querySelector('[data-gaming-tabs]');
    if (!tabs && GAMING_REITER) {
      tabs = document.createElement('div');
      tabs.className = 'optionen gaming-tabs';
      tabs.dataset.gamingTabs = '';
      tabs.setAttribute('role', 'group');
      tabs.setAttribute('aria-label', 'Welche Figur gestaltest du?');
      tabs.innerHTML = [1, 2].map((n) => `<button type="button" class="option"
        data-gaming-tab="${n}" aria-pressed="false"></button>`).join('');
      erstes.before(tabs);
      tabs.addEventListener('click', (e) => {
        const b = e.target.closest('[data-gaming-tab]');
        if (!b) return;
        gamingAktiv = Number(b.dataset.gamingTab);
        gamingMaskeZeichnen(halter);
      });
    }
    /* Beschriftung: der Name, sobald getippt — sonst „Figur 1". Links/rechts darunter. */
    if (tabs) tabs.querySelectorAll('[data-gaming-tab]').forEach((b) => {
      const n = Number(b.dataset.gamingTab);
      const name = String(s.brief[`name${n}`] || '').trim();
      b.innerHTML = `${escape(name || `Figur ${n}`)}<span class="option__zusatz">${n === 1 ? 'links' : 'rechts'} im Bild</span>`;
      b.setAttribute('aria-pressed', String(n === gamingAktiv));
    });
    [1, 2].forEach((n) => {
      let knopf = halter.querySelector(`[data-gaming-klappe="${n}"]`);
      const erstesDetail = halter.querySelector(`[data-brieffeld-halter="p${n}_brille"]`);
      if (!knopf && erstesDetail) {
        knopf = document.createElement('button');
        knopf.type = 'button';
        knopf.className = 'listenknopf gaming-klappe';
        knopf.dataset.gamingKlappe = String(n);
        erstesDetail.before(knopf);
        knopf.addEventListener('click', () => {
          gamingKlappe[n] = !gamingKlappe[n];
          gamingMaskeZeichnen(halter);
        });
      }
      if (knopf) {
        knopf.setAttribute('aria-expanded', String(gamingKlappe[n]));
        knopf.innerHTML = `<span class="listenknopf__zeichen" aria-hidden="true">${gamingKlappe[n] ? '–' : '+'}</span> Brille, Bart, Kleidung`;
        knopf.classList.toggle('gaming-weg', Boolean(gamingAktiv) && n !== gamingAktiv);
      }
    });
    halter.querySelectorAll('[data-brieffeld-halter]').forEach((h) => {
      const m = /^p([12])_/.exec(h.dataset.brieffeldHalter || '');
      if (!m) return;
      const n = Number(m[1]);
      const weg = (Boolean(gamingAktiv) && n !== gamingAktiv)
        || (klappe.has(h.dataset.brieffeldHalter) && !gamingKlappe[n]);
      h.classList.toggle('gaming-weg', weg);
    });
    /* Mit angenommenem Foto (`GAMING_FOTO_AN`) ist der Baukasten zu, „Figuren anpassen" öffnet ihn. Nur ausblenden,
       nie leeren — die Werte bleiben im Brief wie bei der Klappe „Brille, Bart, Kleidung". */
    /* 🔴 Am echten Element, nicht an `halter`: `gamingfotoZeichnen` übergibt `briefHalter()`, ein Ersatzobjekt
       ohne `classList` — das brach am 30.10.2026 live den Aufbau der Maske ab (Avatare und Tor weg). */
    /* 🆕 30.10.2026 abends (Sascha: „Das Foto soll eine echte Alternative sein … die manuelle Maske bleibt zu, daneben
       ein Knopf ‚Deine Avatare gestalten‘“): zu auch OHNE Foto, bis der Knopf sie öffnet. ⏪ Vorher zu nur mit Foto. */
    $('[data-brief]')?.classList.toggle('gaming-foto-zu', GAMING_FOTO_AN && !gamingFotoOffen);
    chipListenAbgleichen(halter);
    gamingMehrKlappen();
  }
  /* 🆕 30.10.2026 nachts (PDP-Session nach Saschas Regel „Nicht Nötiges einklappen“, live seit 78fdbeb): „Zusammen seit“
     in den Klappblock „Mehr aufs Poster (optional)“ wie bei den anderen Konzepten. Das Pixel-Paar steht bewusst nicht in
     `EINE_SEITE` (eigener Editor) — daher hier, mit eigener Markierung `data-gaming-mehr`, damit das Auflösen der
     `[data-eine-seite-mehr]`-Blöcke nach dem Andruck ihn nicht trifft. Mit eingetragenem Jahr steht der Block offen. */
  function gamingMehrKlappen() {
    const brief = $('[data-brief]');
    const jahr = brief?.querySelector(':scope > [data-brieffeld-halter="jahr"]');
    if (!jahr) return;
    const box = document.createElement('details');
    box.className = 'am-blatt__mehr';
    box.dataset.gamingMehr = '';
    box.innerHTML = '<summary>Mehr aufs Poster (optional)</summary>';
    box.open = Boolean(String(s.brief.jahr || '').trim());
    jahr.before(box);
    box.appendChild(jahr);
  }
  /** Auswahllisten (`liste`) auf den gedrückten Chip setzen — nach Vorbelegung, Rückweg, Neuzeichnen. */
  function chipListenAbgleichen(halter) {
    (halter?.querySelectorAll('select[data-chip-liste]') || []).forEach((sel) => {
      const an = halter.querySelector(`[data-brieffeld="${sel.dataset.chipListe}"][aria-pressed="true"]`);
      if (an && sel.value !== an.dataset.wert) sel.value = an.dataset.wert;
    });
  }

  /* --- Rezept (17.10.2026) ------------------------------------------------
     Nur das GERICHT gehört zum Render; alles andere ist Satz und wird nach
     dem Andruck ohne neuen Render gesetzt. 🔴 Spiegel von
     `dienst.REZEPT_SATZ_FELDER` (Gegenprobe im Dienst-Selbsttest). */
  const REZEPT_SATZ_FELDER = new Set(['look', 'machart', 'bild', 'titel', 'von', 'seit',
    'zutaten', 'zubereitung', 'bedeutung_1', 'bedeutung_2', 'bedeutung_3', 'synonym',
    'familie']);
  const istRezept = () => D.produkt.handle === 'rezept';
  /* Gleicher Wortlaut wie `rezept_satz.LEER_ZUTATEN` (Sascha, T1 »A« 17.10.):
     klarer Hinweis direkt am Feld statt Fehlermeldung. */
  const REZEPT_LEER_ZUTATEN = 'Bitte mindestens eine Zutat eintragen.';
  const HAUSTIER_MACHART = {
    name: 'machart', typ: 'chips', label: 'Machart', property: 'Machart',
    pflicht: true, vorwahl: 'portraet',
    hilfe: 'Beides entsteht aus demselben Entwurf – du kannst nach dem Andruck wechseln.',
    optionen: [
      { id: 'portraet', label: 'Porträt', hinweis: 'Name und eine Zeile' },
      { id: 'lexikon', label: 'Lexikon-Eintrag', hinweis: 'Wie im Wörterbuch, mit Eigenheiten' },
    ] };
  /* Fünf Looks als Marker. Farbig = bunter Kreis; Schwarz-Weiß in der
     Druckfarbe des Looks (`haustier.SCHWARZ`, Sascha am Bogen v6); die drei
     Akzente aus Liste B (`D.grundtoene`, Marken-Quelle). */
  /* `bild` (19.10.2026, Sascha: „Beim Hund fehlen Beispielbilder für die Farbakzente"): der
     Marker legt vor dem Andruck das Beispiel dieser Farbe aufs Blatt (`stilBeispielUrl`).
     Die Kacheln wechseln das Tier (Hund/Katze, Fuchs/Schimmel), Erzeuger
     `pipeline/nischen-shopbilder.py kacheln`, Liste `stilbilder` in `echoa-pdp.liquid`. */
  const HAUSTIER_LOOK = () => {
    /* Nur Haustier und Pferd haben Beispiele — das Rezept nutzt dieselbe Auswahl ohne Bild. */
    const k = { haustier: 'h1', pferd: 'h2' }[D.produkt.handle];
    const bild = (id) => (k ? { bild: `${k}_${id}` } : {});
    return {
      name: 'look', typ: 'marker', label: 'Farbe', property: 'Farbgebung', pflicht: true,
      hilfe: 'Kannst du nach dem Andruck wechseln, ohne neuen Entwurf.',
      hilfeEineSeite: '',
      optionen: [
        { id: 'farbig', label: 'Farbig', art: 'bunt', ...bild('farbig') },
        { id: 'schwarzweiss', label: 'Schwarz-Weiß', hex: '#181818', ...bild('schwarzweiss') },
        ...LISTE_B().map((t) => ({ id: t.id, label: t.label, hex: t.hex, ...bild(t.id) })),
      ] };
  };
  /* Platzhalter je Tier (Tiefen-Check 22.10.2026: beim Pferd standen die Hunde-Sätze). */
  const EIGENHEIT_BEISPIELE = {
    tier: ['Hauptberuflich Sofaecke links.', 'Hört auf: Käse. Nicht auf: „Aus".',
      'Liebt Pfützen, hasst Montage.', 'Seit dem 14. März 2024 bei uns.'],
    pferd: ['Hauptberuflich Möhrenprüferin.', 'Hört auf: Leckerli. Nicht auf: „Halt".',
      'Liebt Wälzen im Sand, hasst Pfützen.', 'Seit dem 14. März 2024 bei uns.'],
  };
  const haustierEigenheiten = (art) => [1, 2, 3, 4].map((i) => ({
    name: `eigenheit_${i}`, label: `Eigenheit ${i}`, typ: 'text',
    pflicht: i <= 2, optional: i > 2, maxlength: 60,
    platzhalter: EIGENHEIT_BEISPIELE[art][i - 1],
    ...(i === 1 ? { hilfe: 'Zwei bis vier kurze Sätze, wie im Wörterbuch.' } : {}),
    nurWenn: { feld: 'machart', wert: 'lexikon' },
  }));
  const HAUSTIER_EIGENHEITEN = haustierEigenheiten('tier');

  /* --- Strecke/Wanderung: gemeinsame Bausteine (17.10.2026) --------------- */
  /* Felder, die NACH dem Andruck gesetzt werden — kein neuer Kartenabruf.
     🔴 Spiegel von `strecke.SATZ_FELDER` (beide Produkte zusammen). Fehlt hier
     eines, wirft jeder Tastendruck darin den Andruck weg (`briefSchluessel`). */
  const STRECKE_HANDLES = new Set(['strecke', 'wanderung']);
  const STRECKE_SATZ_FELDER = new Set(['zeit', 'namen', 'ort', 'distanz', 'datum',
    'unterzeile', 'titel']);
  const istStrecke = () => STRECKE_HANDLES.has(D.produkt.handle);
  const STRECKE_SATZ_HILFE = 'Füllen wir aus deinem Text vor. Auch nach dem Andruck kannst du '
    + 'alles ändern, ohne dass die Karte neu entsteht.';
  /* Platzhalter je Produkt — ein Marathon-Beispiel im Wanderformular
     verwirrt (Sascha-Maßstab: der Kunde sieht ein Beispiel SEINER Sache). */
  const streckeSatzGemeinsam = (bsp) => [
    /* Namen und Ort volle Breite, Zahlen mittel (Sascha, 19.10.2026: „Eingabefelder sind
       teils sehr kurz … ganze Zeilenbreite ausnutzen“ — „06.09.2026“ wurde abgeschnitten). */
    { name: 'namen', label: 'Namen', typ: 'text', optional: true, maxlength: 30,
      platzhalter: bsp.namen },
    { name: 'distanz', label: 'Distanz', typ: 'text', optional: true, mittel: true, maxlength: 12,
      platzhalter: bsp.distanz },
    { name: 'datum', label: 'Datum', typ: 'text', optional: true, mittel: true, maxlength: 16,
      platzhalter: bsp.datum },
    { name: 'unterzeile', label: 'Eine Zeile darunter', typ: 'text', optional: true,
      maxlength: 40, platzhalter: bsp.unterzeile,
      hilfe: 'Namen von Veranstaltungen und Marken drucken wir nicht.' },
  ];
  /* Beispiele ohne Veranstaltungskurs (Saschas T1 »A«, 18.10.2026; bis dahin
     ein Berlin-Beispiel). */
  /* Einstieg je Zielgruppe (18.10.2026, Saschas »erst A dann C«): eine
     Rad-Anzeige landet auf `?view=rad`, `echoa-pdp.liquid` setzt dann
     D.einstieg = 'rad' und zeigt das Bodensee-Blatt. Die Beispiele hier
     passen zu genau dem Blatt, das der Kunde gerade sieht. */
  const EINSTIEG_RAD = D.einstieg === 'rad';
  const STRECKE_SATZ_LAUF = EINSTIEG_RAD
    ? streckeSatzGemeinsam({ namen: 'Tom & Mia', distanz: '220 km',
      datum: '14.06.2025', unterzeile: 'Einmal rund um den See' })
    : streckeSatzGemeinsam({ namen: 'Lena', distanz: '16,3 km',
      datum: '06.09.2026', unterzeile: 'Sonntags an der Isar' });
  const STRECKE_SATZ_WANDERN = streckeSatzGemeinsam({ namen: 'Anna & Jonas', distanz: '214 km',
    datum: 'August 2026', unterzeile: 'Zu Fuß über die Alpen' });

  const BRIEFE = {
    /* 🔴 STRECKE UND WANDERUNG (17.10.2026, Saschas Entscheidungen 16.10.).
       EIN Textfeld, die KI versteht es und fragt höchstens EINMAL zurück
       (`strecke.planen`). Bei der Strecke optional GENAU EINE GPX-Datei.
       Alles ab „Zeit" ist SATZ und wird nach dem Andruck ohne neuen
       Kartenabruf gesetzt (`STRECKE_SATZ_FELDER`, `streckeSatz`). */
    'strecke': {
      felder: [
        { name: 'beschreibung', label: 'Erzähl uns von deiner Strecke', typ: 'text-lang',
          property: 'Beschreibung', pflicht: true, maxlength: 600,
          platzhalter: EINSTIEG_RAD
            ? 'Mit dem Rad einmal um den Bodensee, an einem Tag – 9:12:40, am 14.06.2025. '
              + 'Für Tom & Mia.'
            : 'Sonntags an der Isar, vom Flaucher zum Englischen Garten und zurück – '
              + '1:31:24, am 06.09.2026. Für Lena.',
          hilfe: 'Wo, wann, mit wem – und deine Zeit. Bei einer eigenen Runde: 2–3 Orte, '
               + 'an denen sie vorbeiführt.' },
        { name: 'datei', typ: 'gpx', label: 'Datei aus deiner Uhr' },
        { name: 'zeit', label: 'Zeit', typ: 'text', optional: true, mittel: true, maxlength: 10,
          platzhalter: EINSTIEG_RAD ? '9:12:40' : '1:31:24', hilfe: STRECKE_SATZ_HILFE },
        STRECKE_SATZ_LAUF[0],
        { name: 'ort', label: 'Ort', typ: 'text', optional: true, maxlength: 24,
          platzhalter: EINSTIEG_RAD ? 'Bodensee' : 'München' },
        ...STRECKE_SATZ_LAUF.slice(1),
      ],
    },
    'wanderung': {
      felder: [
        { name: 'beschreibung', label: 'Erzähl uns von deiner Wanderung', typ: 'text-lang',
          property: 'Beschreibung', pflicht: true, maxlength: 600,
          platzhalter: 'Mit Jonas im August 2026 über den E5 von Oberstdorf nach Meran.',
          hilfe: 'Start, Ziel und – wenn du sie weißt – die Übernachtungsorte. Wir schlagen '
               + 'dir die Etappen vor, du bestätigst sie.' },
        { name: 'titel', label: 'Titel', typ: 'text', optional: true, maxlength: 26,
          platzhalter: 'Oberstdorf – Meran', hilfe: STRECKE_SATZ_HILFE },
        ...STRECKE_SATZ_WANDERN,
      ],
    },
    'icon-grid': {
      felder: [
        { name: 'namen', typ: 'namen' },
        /* ⏪ 15.08.2026: `akzent: true` ist entfallen — mit ihm der
           Pflicht-Radio »welches Ding trägt die Farbe«.

           🔴 DER GRUND IST EIN FEHLERPFAD, nicht Aufräumen: Träger und Farbe
           konnten auseinanderlaufen. Der Kunde schrieb »die senffarbene
           Regenjacke« in Zeile 1 und markierte den Kreis an Zeile 2 — das
           Poster zeigte eine senffarbene Pfeffermühle unter einer
           Bildunterschrift über eine Jacke (die Brief-F-Klasse vom 05.08.:
           „das Poster widersprach dem Text des Kunden").

           Seit Saschas Entscheidung vom 15.08.2026 entsteht der Akzent NUR
           aus einem selbst geschriebenen Farbwort — damit beantwortet sich
           die Trägerfrage von selbst: es ist das Ding, in dessen
           Beschreibung die Farbe steht. Eine zweite Angabe daneben kann nur
           noch widersprechen. Ein Pflichtfeld weniger ist zugleich ein Klick
           weniger über etwas, das der Kunde ohne Vorschau nicht beurteilen
           kann. */
        /* 🔴 DER HILFETEXT NENNT DIE FARBREGEL — sonst ist sie unauffindbar
           (15.08.2026). Seit der Akzent nur noch aus einem selbst
           geschriebenen Farbwort entsteht, ist er ein Feature ohne
           Bedienelement: wer es nicht weiß, bekommt nie eine Farbe und
           erfährt auch nie, dass er eine hätte haben können. Der alte
           Hilfetext („Genau eines davon trägt die Farbe") gehörte zum Radio
           und ist mit ihm weg — er hätte hier ohnehin das Falsche gesagt.
           ⚠️ Bewusst als ANGEBOT formuliert, nicht als Aufforderung: der
           Regelfall ist das neutrale Blatt, und ein „nenne eine Farbe!"
           würde die Erzwingung wiederherstellen, die gerade abgeschafft ist. */
        /* ⏪ 17.08.2026: `start: 4` und der Jahres-Schalter. Sascha: „Das Jahr
           ist optional, wirkt aber hier wie ein Pflichtfeld. Genauso wirken
           6 Felder wie Pflicht, es ist nicht klar (außer anhand der
           Beschreibung), dass 4 Felder auch in Ordnung sind."
           🔴 BEIDES IST DIESELBE KLASSE: ein leeres Feld sieht aus wie eine
           unerledigte Aufgabe, egal was danebensteht. Ein Hilfetext kann das
           nicht heilen — er wird gegen den Augenschein gelesen. Deshalb ist
           die Zahl der SICHTBAREN Zeilen jetzt die Pflichtzahl, und das Jahr
           existiert erst, wenn jemand es anfordert. */
        /* ⏪ 18.08.2026 (Sascha, PDP-Feedbackrunde): „Symbole" statt „Dinge",
           und Du-Anrede im Fließtext. Die gemeinsame Anrede („Eure") trägt
           nur noch der Produkttitel — im Formular spricht der Text die Person
           an, die gerade tippt. Der Feldschlüssel `momente` bleibt: er steht
           in den Cart-Properties und im Prompt-Vertrag, ein Umbenennen wäre
           eine Backend-Änderung ohne Nutzen. */
        { name: 'momente', label: 'Deine Symbole', typ: 'liste',
          anzahl: 6, start: 4, pflicht: 4,
          /* ⏪ 18.08.2026 (Sascha): „sonst bleibt das Blatt in Tinte" war zu
             unverständlich — „Tinte" ist unser Wort für die dunkle Zeichenfarbe,
             der Kunde kennt es nicht. Statt es zu erklären ist die Folge jetzt
             direkt benannt. */
          hilfe: 'Vier genügen, sechs sind das Maximum. Schreibst du eine Farbe '
               + 'dazu („die senffarbene Jacke"), taucht sie im Bild auf.',
          jahr: true, jahrLabel: 'Jahreszahlen ergänzen',
          mehrLabel: 'Noch ein Symbol',
          platzhalter: ['Die senffarbene Regenjacke', 'Unsere Pfeffermühle aus Holz',
            'Der Campingkocher vom ersten Urlaub', 'Die Leine unseres Hundes',
            'Das selbst gebackene Brot', 'Die Schallplatte, die immer läuft'] },
        markerFeld({
          label: 'Hintergrundfarbe', tonFeld: 'grund',
          zweig: zweigVon('icon-grid'),
          hell: { label: 'Hell', art: 'creme', hex: '#FEF7EC' },
        }),
      ],
    },
    'weg-chronik': {
      felder: [
        { name: 'namen', typ: 'namen' },
        /* ⏪ 17.08.2026: `start: 2` statt fünf offener Zeilen (Sascha:
           „Analog 1 nur zwei gefordert, maximal 5. … Nur 2 by default
           anzeigen, den Rest per ‚+' bis maximal 5 hinzufügen lassen").
           Die Platzhalter der Zeilen 4 und 5 waren „…" — sichtbare Felder
           ohne Beispiel, die nach unerledigter Arbeit aussahen. Sie sind
           jetzt versteckt und tragen echte Beispiele, sobald jemand sie holt. */
        /* 🔴 MARKIERUNG JE ORT UND LINIEN ALS SCHALTER (Sascha, 15.10.2026,
           T1): Ring-Punkt als Standard, Haus für Zuhause, Herz für Reisen;
           Verbindungslinien nur auf Wunsch — bei Reisezielen erzählen sie
           eine Reihenfolge, die es nie gab. Beides geht als
           `stationen_marken` / `verbindungslinien` ans Backend
           (`dienst._a8_marken`), das jeden neuen Kandidaten unter
           Projektion v2 zeichnet. */
        { name: 'stationen', label: 'Deine Orte', typ: 'liste',
          anzahl: 5, start: 2, pflicht: 2,
          hilfe: 'Zwei genügen, fünf ist das Maximum. Je Ort wählst du, '
               + 'wie er markiert wird: Punkt, Zuhause oder Reise – du siehst es an deinem Entwurf '
               + 'und kannst es danach ohne neuen Entwurf ändern.',
          hilfeEineSeite: 'Zwei genügen, fünf ist das Maximum. Je Ort wählst du, '
               + 'wie er markiert wird: Punkt, Zuhause oder Reise.',
          jahr: true, jahrLabel: 'Jahreszahlen ergänzen',
          marke: true,
          mehrLabel: 'Noch ein Ort',
          platzhalter: ['Leipzig', 'Lissabon', 'Radebeul', 'Kopenhagen', 'Triest'] },
        { name: 'verbindungslinien', typ: 'chips', label: 'Verbindungslinien',
          property: 'Verbindungslinien', pflicht: true, vorwahl: 'nein',
          hilfe: 'Passt, wenn ihr nacheinander an diesen Orten gewohnt habt. '
               + 'Bei Reisezielen wirkt die Karte ohne Linien ruhiger. Du siehst es an deinem '
               + 'Entwurf und kannst es danach ohne neuen Entwurf ändern.',
          hilfeEineSeite: 'Passt, wenn ihr nacheinander an diesen Orten gewohnt habt. '
               + 'Bei Reisezielen wirkt die Karte ohne Linien ruhiger.',
          /* Zeichen am Knopf statt Live-Bild (Sascha, 22.10.2026 abends): drei Orte, einmal lose,
             einmal verbunden — `LINIEN_ZEICHEN`, gezeichnet in `currentColor`. */
          optionen: [
            { id: 'nein', label: 'ohne Linien', zeichen: 'linien_nein' },
            { id: 'ja', label: 'mit Linien', zeichen: 'linien_ja' },
          ] },
        markerFeld({
          label: 'Hintergrundfarbe', tonFeld: 'grund',
          zweig: zweigVon('weg-chronik'),
          hell: { label: 'Hell', art: 'creme', hex: '#FEF7EC' },
        }),
      ],
    },
    'momentaufnahme': {
      felder: [
        /* Mit Paarfoto kommt das Geschlecht aus dem Feld »paarfoto« — das Namensfeld fragt es dann nicht.
           Die Namen bleiben Pflicht: sie SIND der Titel (Sascha 27.10.2026: „Nur so kann doch überhaupt ein
           fertiges Poster erzeugt werden"); geändert werden sie danach ohne neuen Render (`TEXT_SATZ`). */
        { name: 'namen', typ: 'namen', geschlecht: !PAARFOTO_AN,
          ...(ORTS_MASKE_AN ? { label: 'Eure Namen' } : {}) },
        /* ⏪ HIER STANDEN »Was passiert im Bild« (momenttyp) UND »Drinnen oder
           draußen« (raum) — beide am 19.08.2026 ENTFERNT (Saschas Auftrag:
           „Was passiert im Bild" nur beim ersten Sehen erfragen, „Drinnen
           oder draußen" vom Modell entscheiden lassen).
           Seit dem 18.08.2026 leitet `pipeline/a5_stufe1.moment_schreiben`
           beide aus dem Momenttext ab, sobald sie leer bleiben. Gemessen an
           fünf bezahlten Läufen: momenttyp 5/5 sinnvoll, raum 5/5, alle in
           Runde 1, keine Reparatur-Runde.
           🔴 DER ABLEITUNGSPFAD IST JETZT DER REGELWEG, NICHT DER RÜCKFALL.
           Ein übergebener Wert schlägt ihn weiterhin — das ist Absicht und
           hält den Kundenpfad zwischen zwei Commits, taugt aber nicht als
           Einladung, das Feld wieder einzuführen: es würde die Ableitung
           lautlos ausschalten. `dienst.py --selbsttest` (5b) prüft die
           Abwesenheit beider Felder in BEIDEN Konfiguratoren.
           📎 Die Provenienz der fünf Momenttypen — warum »einander gesehen«
           am 12.08. nach dem ersten Render wieder fiel und als Nebeneinander
           MIT Berührung umgedeutet wurde — steht dort, wo sie jetzt wirkt:
           `pipeline/a5_stufe1._INSTRUKTION` und `bauplan._A5_ANORDNUNGEN`. */
        { name: 'moment', label: PAARFOTO_AN ? 'Was macht ihr?' : ORTS_MASKE_AN ? 'Wo seid ihr, was macht ihr?' : 'Der Moment',
          typ: 'text-lang', pflicht: !PAARFOTO_AN, ...(PAARFOTO_AN ? { optional: true } : {}),
          /* 🔴 DIESELBE FARBREGEL WIE BEI A1 — sie gilt für beide Bautypen,
             also steht sie an beiden Feldern. Ein Zeiger auf das andere Feld
             trüge sie nicht (`rules/architektur.md` §1: die Regel gehört an
             den Punkt der Handlung), und A1 und A5 haben verschiedene
             Formulare, die ein Kunde nie beide sieht.
             ⚠️ NICHT bei C1 und A8: dort wird gar kein Akzent abgeleitet
             (C1 seit 09.08., A8 seit 14.08.). Ein Hinweis dort verspräche
             etwas, das der Bautyp nicht kann. */
          /* 🔴 „KEINE GESICHTER" STEHT SEIT DEM 19.08.2026 HIER — vorher trug
             es der Hilfetext des Momenttyp-Felds, das an diesem Tag entfiel.
             Es ist die einzige Stelle im Kundenformular, an der die Zusage
             steht, und sie trägt laut `shop/design/quellen/logo-briefing.md`
             die Ähnlichkeits-Reklamation UND den DSGVO-Teil — bei einem eigens
             gefertigten Blatt ohne Rückgaberecht ist das keine Fußnote.
             Ohne Ersatzort wäre sie mit dem Feld ersatzlos verschwunden
             (`code-pruefer`, 19.08.2026).
             ⚠️ Der zweite Halbsatz ist NEU und beschreibt den Ist-Zustand:
             die Haltung der Figuren kommt seit dem 18.08.2026 aus DIESEM Text,
             nicht mehr aus einer Chip-Wahl. Er steht deshalb an diesem Feld
             und nirgends sonst (`rules/architektur.md` §1). */
          /* 🔴 NEUE MASKE (Sascha, 20.10.2026: „wir wollen doch gar keine Gegenstände mehr
             forcieren" · die Farb-Zusage „kann gestrichen werden"): Wortlaut aus dem
             Klick-Dummy. Der Akzent aus einem genannten Farbwort wirkt im Backend weiter,
             er wird nur nicht mehr versprochen. */
          /* Mit Paarfoto ist das Paar bei Dunkel, Kohle und Strich etwa ein Drittel der Bildhöhe groß, nicht klein
             (Befund der Session moment-stilisiert, Sichtprobe 28.10.2026). */
          hilfe: PAARFOTO_AN
            ? 'Ein, zwei Sätze. Wir zeichnen euch von hinten, ohne Gesichter – '
              + 'wie ihr zueinander steht, lesen wir aus deinem Satz.'
            : ORTS_MASKE_AN
            ? 'Ein, zwei Sätze. Ihr zwei seid klein im Bild, von hinten, ohne Gesichter – '
              + 'wie ihr zueinander steht, lesen wir aus deinem Satz.'
            : 'Ein bis zwei Sätze. Gegenstände sind wertvoller als '
               + 'Gefühle. Keine Gesichter – das ist Absicht; wie die beiden '
               + 'zueinander stehen, lesen wir aus dem, was du hier '
               + 'schreibst. Nennst du eine Farbe („deine petrolfarbene '
               + 'Jacke"), greifen wir sie auf – sonst bleibt das Blatt ruhig.',
          /* 🔴 EIN ORT, EIN BLICKWINKEL (20.08.2026). Sascha: „Der
             Beispieltext macht inhaltlich keinen Sinn, da er sowohl eine
             Szene draußen als auch drinnen beschreibt. Primed den Kunden in
             eine Richtung, mit denen der Render im Zweifel selbst Probleme
             gehabt hätte."

             Hier stand „… unter einem Schirm vor der Bar … zwei Schalen
             Ramen, deine Jacke am Haken": draußen im Regen UND drinnen am
             Tresen, in einem Satz. Der Platzhalter ist aber die einzige
             Anschauung dafür, was ein guter Moment ist — was er vormacht,
             schreiben Kunden nach. Und A5 baut EINE zusammenhängende Szene
             aus EINEM Blickwinkel (`a5_stufe1._INSTRUKTION`); zwei Orte in
             einem Brief sind für den Render nicht auflösbar.

             ⚠️ Die Ramen-Schalen sind zusätzlich aus einem zweiten Grund
             raus: Dampf ohne Quelle ist ein belegter Renderfehler dieses
             Konzepts (`konsistenz-test-30-07.md`, Befund 1), und die Prompts
             verbieten ihn seither ausdrücklich. Ein Platzhalter, der Kunden
             zu dampfenden Schüsseln einlädt, arbeitet gegen die eigene
             Pipeline.

             Was der Satz stattdessen vormacht: ein Ort, ein Blickwinkel,
             greifbare Gegenstände statt Gefühlen, und eine BERÜHRUNG — auf
             jedem A5-Blatt findet eine statt ([[echoa_looks]], 19.08.2026),
             und der Kunde erfährt das sonst nirgends.

             ⏪ 20.08.2026, wenige Minuten später: die Berührung hieß zuerst
             „deine Hand in meiner Manteltasche". Sascha: „klingt eher
             creepy." Ersetzt durch „dein Arm um meine Schulter" — dieselbe
             Nähe, aber eindeutig, und es ist GENAU die Geste, die der
             A5-Prompt ohnehin baut (`a5-genre-stadt.json`: „the man has his
             arm around the woman's shoulders"). Der Platzhalter führt den
             Kunden damit auf das, was das Modell am zuverlässigsten trifft.
             🔴 Eine Berührung MUSS es bleiben — sie ersatzlos zu streichen
             nähme dem Kunden die einzige Anschauung dafür. */
          platzhalter: ORTS_MASKE_AN
            ? 'Wir standen am Aussichtspunkt über den Dächern und haben aufs Meer geschaut, dein Arm um meine Schulter.'
            : 'Regen, wir standen unter einem Schirm vor der Bar in der Torstraße, dein Arm um meine Schulter.' },
        { name: 'ort', label: 'Ort', typ: 'text', platzhalter: 'Berlin', pflicht: true },
        /* ⏪ 17.08.2026: `optional: true`. Das Jahr war nie Pflicht und sah
           trotzdem aus wie eines — dieselbe Klasse wie die sechs offenen
           Zeilen bei A1 (Sascha, 17.08.2026). Ein Feld, das niemand ausfüllen
           muss, trägt das jetzt im Label und nicht nur in der Abwesenheit
           einer Fehlermeldung. */
        { name: 'jahr', label: 'Jahr', typ: 'text', platzhalter: '2025',
          kurz: true, optional: true },
        /* 🔴 A5 IST DER EINZIGE BAUTYP, BEI DEM DER ZWEITE LOOK NICHT ZU JEDER
           KOMPOSITION PASST: der Aussparungs-Zweig bringt seinen EIGENEN
           Figurenblock mit (Vollton gegen Reserve) und kennt nur
           „nebeneinander". Bei »begrüßt/umarmt« und »aus der Ferne« stünden
           zwei Figurenblöcke im selben Prompt — `bauplan.pruefe_a5` weist das
           ab, und `a5_stufe1` noch einmal davor.
           ⏪ 19.08.2026: HIER STAND, DER CHIP WERDE GESPERRT UND DER KUNDE
           SEHE DEN GRUND AM CHIP. Das gilt nicht mehr — der Momenttyp ist kein
           Formularfeld mehr, und mit ihm ist `markerSperre` entfallen. Der
           Riegel ist damit NICHT weg, sondern an die Quelle gewandert:
           `a5_stufe1.momenttyp_auswahl` zeigt dem Modell bei
           `look="aussparung"` nur die drei Nebeneinander-Typen. Die
           vollständige Begründung steht am Fuß dieses Konzepts, an der Stelle,
           an der `markerSperre` stand.
           ⚠️ WER DEN QUELL-RIEGEL FÜR „DOPPELT" HÄLT UND STREICHT, ÖFFNET
           GENAU DEN PFAD WIEDER, DEN DIESE SPERRE ZUMACHTE — er ist seit dem
           19.08.2026 der einzige, der ihn noch schließt. */
        /* Der helle Marker ist hier NICHT creme, sondern bunt: die
           Kontrollfassung von A5 ist ein farbiger Moment, kein cremefarbenes
           Blatt (Sascha, 17.08.2026: „hier ggf. mit wählbarem ‚buntem' Kreis
           (= Moment farbig) vs. wählbare Volltöne"). Ein Creme-Kreis wäre an
           dieser Stelle eine falsche Zusage. */
        /* ⏪ 19.08.2026: DAS FELD HEISST „FARBE", NICHT „HINTERGRUNDFARBE"
           (Sascha: „Bestellt man hier überhaupt eine ‚Hintergrundfarbe' beim
           Kontroll-Look? Eine der beiden Bezeichnungen kommt mir für A5
           irreführend vor").
           🔴 Die irreführende war „Hintergrundfarbe". Bei A1 und A8 stimmt
           sie — dort steht eine Strichzeichnung auf einem Grund, und der
           Grund ist wählbar. Bei A5 ist das Blatt ein vollflächiger Moment;
           einen Hintergrund, den man getrennt vom Motiv färben könnte, gibt
           es nicht. Was das Feld wirklich wählt, ist die Farbigkeit des
           ganzen Blattes: farbig ODER ein Vollton mit ausgesparten Figuren.
           „Farbe" ist in beiden Zuständen wahr und behauptet nichts.
           ⚠️ Der Chip „Farbig" bleibt — er ist Saschas eigenes Wort
           (17.08.2026: „mit wählbarem ‚buntem' Kreis (= Moment farbig)") und
           war nicht der irreführende Teil. */
        /* ⏪ 24.09.2026: `hell: { label: 'Farbig', art: 'bunt' }` ist RAUS —
           Sascha nach vier Rastern und drei Testmomenten: der farbige Look
           sitzt 1 von 8 Würfen („schemenhafte Personen, kein guter
           Eindruck") und wird aus dem Kaufweg genommen (Option B: Code und
           Backend-Pfad bleiben, nur der Marker fehlt). Der Moment ist damit
           ein Vollton-Produkt: Petrol, Terrakotta, Salbei. Hero und
           Raum-Beispiele zeigen seither das Petrol-Blatt (Paris). */
        /* ✅ 30.09.2026: der farbige Look ist ZURÜCK, als letzte Option hinter
           den Volltönen (Sascha, T1 »B«, dann A). Vorher im Backend gebaut und
           getestet: Weiche im Fertigstellen, Sieb Titelzone/Schwarzanteil mit
           Neuwurf, Titelband-Rückfall, neutrale Figurentinte, Kleidung —
           Stabilitätstest 8 von 8 frischen Szenen (`pipeline/output/
           a5-farbig-stabil-2026-09-30/`). Rückweg: `hell: null`. */
        /* 🔴 NEUE MASKE (Sascha, 20.10.2026: „Machart sollte analog Orts-Print sein, eine
           Kachel für farbig, eine für dunkel"): Stil-Kacheln plus Ton-Kreise darunter, wie
           beim Orts-Print. Look-IDs bleiben (kontrolle/aussparung), der Ton heißt weiter
           `grund` — Dienst, Warenkorb und Druck sehen dieselbe Bestellung wie vorher. */
        ...(ORTS_MASKE_AN ? [
          { name: 'look', typ: 'stil', label: PAARFOTO_AN ? 'Machart' : 'Druck', property: 'Look', pflicht: true,
            /* Farbig VORNE und vorgewählt, wie beim Orts-Print (Sascha, 21.10.2026, an der
               Live-Seite). ⏪ Bis dahin Dunkel vorne — Saschas Urteil vom 30.09.2026
               (`hellHinten`). Im Speicher lagen am 19.10. beim Moment 48 dunkle gegen 23
               farbige Entwürfe; die Vorwahl lenkt also messbar, das ist hier gewollt. */
            optionen: [
              { id: 'kontrolle', label: 'Farbig',
                hinweis: 'Die Farben des Ortes', bild: PAARFOTO_AN ? 'a5p_farbig' : 'a5_farbig' },
              { id: zweigVon('momentaufnahme'), label: 'Dunkel',
                hinweis: 'Eine Farbe, der Ort hell ausgespart', bild: PAARFOTO_AN ? 'a5p_dunkel' : 'a5_dunkel' },
              /* Mit Paarfoto: Dunkel zuerst und vorgewählt (zeigt euch groß), dann Kohle und Strich (nur mit Foto —
                 kein Schild an der Kachel, Sascha 27.10.: das Foto gilt für alle Macharten; die Pflicht meldet das Fotofeld),
                 Farbig zuletzt (der Ort als Motiv, ihr klein — Sascha 26.10.: farbig nah wirkt „fast creepy"). */
              ...(PAARFOTO_AN ? [
                { id: 'kohle', label: 'Kohle', hinweis: 'Gezeichnet, mit Tiefe', bild: 'a5_kohle' },
                { id: 'strich', label: 'Strich', hinweis: 'Wenige Linien, ganz ruhig', bild: 'a5_strich' },
              ] : []),
            ].sort((a, b) => (PAARFOTO_AN ? (a.id === 'kontrolle') - (b.id === 'kontrolle') : 0)) },
          ...(PAARFOTO_AN ? [{ name: 'paarfoto', typ: 'paarfoto', label: 'Ihr zwei' }] : []),
          { name: 'grund', typ: 'marker-solo', label: 'Ton', property: 'Farbe', pflicht: true,
            vorwahl: 'petrol',
            hilfe: TON_HILFE,
            nurWenn: { feld: 'look', wert: zweigVon('momentaufnahme') } },
        ] : [markerFeld({
          label: 'Farbe', tonFeld: 'grund',
          zweig: zweigVon('momentaufnahme'),
          hell: { label: 'Farbig', art: 'bunt' },
          hellHinten: true,
        })]),
      ],
      /* ⏪ HIER STAND `markerSperre` — die Sperre des Aussparungs-Zweigs, die
         am Momenttyp hing (`feld: 'momenttyp'`, erlaubt waren `geschaut`,
         `gemacht`, `unterwegs`). ENTFERNT am 19.08.2026 mit dem Feld, an dem
         sie hing.
         🔴 SIE WÄRE NICHT KAPUTTGEGANGEN, SIE WÄRE STILL ZUM NO-OP VERFALLEN:
         die Auswertung unten liest `const gilt = !ist || werte.includes(ist)`.
         Ohne das Feld ist `ist === ''`, damit `gilt === true` — kein Fehler,
         keine Konsolenmeldung, nie wieder eine Sperre. Ein toter Riegel, der
         wie Schutz aussieht, ist schlechter als kein Riegel; deshalb steht
         hier eine Notiz statt einer Attrappe.
         ✅ DER RIEGEL SELBST IST NICHT WEG, ER SITZT AN DER QUELLE. Seit dem
         18.08.2026 bekommt das Modell bei `look="aussparung"` nur die drei
         Nebeneinander-Typen zur Auswahl (`a5_stufe1.momenttyp_auswahl`) und
         `anordnung` fest auf „nebeneinander" — die zwei Figurenblöcke im
         selben Prompt können gar nicht erst entstehen. Belegt am
         kontrollierten Vergleich der fünf bezahlten Läufe: gleicher
         Momenttext, Aussparung ergab `geschaut`, der Kontroll-Look `umarmt`.
         Ein übergebener unerlaubter Wert wirft weiterhin in
         `moment_schreiben`, vor dem ersten bezahlten Aufruf.
         ⚠️ Die AUSWERTUNG unten (`briefDef().markerSperre`) bleibt bewusst
         stehen: sie ist der generische Mechanismus für alle Konzepte und
         läuft ohne Definition schlicht nicht an. Sie hat getragen und
         verliert nur ihren einzigen Fall — anders als ein Mechanismus, der
         nie einen Aufrufer hatte. */
    },
    'orts-print': {
      felder: [
        { name: 'ort', label: 'Ort', typ: 'text', platzhalter: 'Santanyí, Mallorca', pflicht: true,
          hilfeUnten: ORTS_MASKE_AN,
          hilfe: 'So genau wie möglich. „Mallorca“ ist eine Insel, „Santanyí“ ist ein Bild.' },
        { name: 'jahr', label: 'Jahr', typ: 'text', platzhalter: '2024',
          kurz: true, optional: true },
        /* 🔴 EINGEKLAPPT (Sascha, 30.09.2026): „(optional)" in kleiner Schrift
           kam nicht an — „ich glaube inzwischen, dass es den meisten Leuten
           eher um den Ort geht als um bestimmte Gegenstände". Die Felder
           stehen deshalb hinter EINEM Knopf; ein Klick öffnet alle drei, damit
           keine Klickerei je Zeile entsteht. Pflicht ist keine Zeile (seit
           23.09.), eine, zwei oder drei gehen. Der Knopf ist bewusst NICHT
           schwarz: Schwarz ist auf dieser Seite der Andruck-Knopf, und zwei
           schwarze Flächen konkurrieren um denselben Blick. */
        /* 🔴 NEUE MASKE (ORTS_MASKE_AN): ein Feld für das, was nicht fehlen darf, statt der
           Erinnerungen. Hilfetext wörtlich aus dem Dummy. Der Link zum Moment steht hier,
           weil genau an dieser Stelle der Wunsch „und wir zwei" auftaucht (2A). */
        ...(ORTS_MASKE_AN && !ORTS_KLAPPE_AN ? [{ name: 'muss_rein', label: 'Was darf nicht fehlen?', typ: 'text',
          optional: true, maxlength: MUSS_REIN_MAX,
          platzhalter: 'der Blick vom Hafen auf die Altstadt',
          hilfeUnten: true,
          hilfe: 'Ein Wahrzeichen oder ein Blick. Gegenstände zeichnen wir nicht – das Blatt '
               + 'zeigt den Ort. Eine Tageszeit? Schreib sie dazu, etwa „bei Sonnenuntergang“.' }] : []),
        ...(ORTS_MASKE_AN ? [] : [{ name: 'erinnerungen', label: 'Erinnerungen', typ: 'liste',
          eingeklappt: {
            knopf: 'Erinnerungen ins Bild legen',
            zu: 'Doch ohne Erinnerungen',
            zusatz: 'Optional – ohne sie zeichnen wir nur den Ort.',
          },
          /* 23.09.2026 (Sascha): Erinnerungen sind optional — ohne sie
             zeichnet das Backend nur den Ort, ohne Stillleben und ohne
             Vordergrund-Träger (`c1_stufe1`, nur_ort). Eine einzelne
             Erinnerung wandert als Element in die Szene. */
          anzahl: 3, start: 3, pflicht: 0,
          /* 🔴 KEIN „+"-Aufbau hier, anders als bei A1 und A8 — und das ist
             der Geltungsbereich der Startzahl, nicht ein vergessener Fall.
             Drei Zeilen bei zwei Pflichtzeilen ist genau EINE Zeile Luft; ein
             Knopf, der eine einzelne Zeile nachlädt, wäre mehr Bedienung als
             Ersparnis. Bei A1 (6 gegen 4) und A8 (5 gegen 2) trägt er. */
          hilfe: 'Eine, zwei oder drei – wir legen sie als kleines Stillleben ins '
               + 'Bild. Je konkreter, desto besser: ein Gegenstand, kein Gefühl.',
          /* ⏪ 17.10.2026: „Die zwei Aperol auf der Brüstung" — der Platzhalter
             schlug dem Kunden selbst eine Marke vor (Sascha: Marke ist No-Go,
             „beim initialen Prompt ansetzen"). */
          platzhalter: ['Die zwei Gläser Spritz im Café', 'Der Korb vom Markt',
            'Die aufgerollte Luftmatratze'] }]),
        /* 🔴 OPTIONALES FOTO DES ORTES (19.10.2026, Sascha): der Text bleibt die Haupteingabe, das Foto
           ist nur Hilfe fürs Modell — „wenn ihm bestimmte Dinge wichtig sind oder eine bestimmte
           Szenerie". GENAU EIN Foto. Für BEIDE Looks (Saschas »A«, 19.10.2026: der Linolschnitt nimmt das
           Foto seither auch, `dienst.C1_ORTSFOTO_LINOL`). ⏪ Bis dahin nur bei „Farbig". */
        ...(ORTSFOTO_UPLOAD_AN ? [{ name: 'ortsfoto', typ: 'ortsfoto', label: 'Dein Foto vom Ort',
          hilfeUnten: ORTS_MASKE_AN,
          /* Neue Maske: Wortlaut aus dem Klick-Dummy (20.10.2026). */
          hilfe: ORTS_MASKE_AN
            ? (ORTSFOTO_TREU_AN
              ? 'Wir zeichnen genau deinen Blick nach. Menschen auf dem Foto zeichnen wir nur klein und ohne Gesicht.'
              : 'Damit treffen wir dein Wahrzeichen genauer. Menschen auf dem Foto zeichnen wir nicht.')
            : 'Ist dir ein Gebäude oder ein Blick besonders wichtig? Lade ein Foto hoch – wir '
              + 'zeichnen den Ort danach in unserem Stil, nicht als Kopie des Fotos.',
          /* Klappe wie beim Moment (`ORTS_KLAPPE_AN`): eigener Titel, kein „(optional)", der Satz sagt, wofür. */
          ...(ORTS_KLAPPE_AN ? { label: 'Dein Blick', ohneOptional: true, knopf: 'Foto vom Ort wählen',
            hilfe: 'Mit Foto zeichnen wir genau diesen Blick nach – das schönste Ergebnis. Menschen darauf zeichnen '
                 + 'wir nur klein und ohne Gesicht.' } : {}) }] : []),
        /* Ohne Foto: der Blick in einem Satz, in der Klappe unter dem Foto (`ORTS_KLAPPE_AN`). */
        ...(ORTS_MASKE_AN && ORTS_KLAPPE_AN ? [{ name: 'muss_rein', label: 'Was darf nicht fehlen?', typ: 'text',
          maxlength: MUSS_REIN_MAX, platzhalter: 'der Blick vom Hafen auf die Altstadt', hilfeUnten: true,
          klappe: { titel: 'Kein Foto zur Hand?', zusatz: 'Beschreib den Blick in einem Satz' },
          hilfe: 'Ein Wahrzeichen oder ein Blick, gern mit Tageszeit – etwa „bei Sonnenuntergang“.' }] : []),
        /* ⏪ 14.08.2026: Der Linolschnitt ist FREI. Der Grund für die Sperre
           („bis c1_stufe1 den Prompt trägt") ist eingelöst —
           `bauplan.c1_linol_block` leitet den Layout-Block der farbigen
           Fassung ab und `c1_linol_farbe` ersetzt die Ortspalette durch die
           EINE bestellte Tinte aus Liste B.

           ⏪ 17.08.2026: C1 bekommt STILKACHELN statt der Markerreihe der
           anderen drei Konzepte. Sascha: „Unterschied Farbig zu Linolschnitt
           klarer aufzeigen, hier ggf. abweichend von den anderen Konzepten,
           da sich hier der Stil auch signifikant ändert."

           🔴 DER GRUND IST, DASS HIER NICHT DIE FARBE DIE WAHL IST. Bei A1,
           A5 und A8 ändert der zweite Look den GRUNDTON — dieselbe Zeichnung,
           andere Fläche; ein Farbkreis zeigt das vollständig. Beim
           Linolschnitt ändert sich die Machart: Flächen statt Feinzeichnung,
           Schnittkanten, eine einzige Tinte. Ein Kreis in Petrol behauptete,
           es ginge um Petrol — es geht um den Schnitt.
           Deshalb zwei Bilder, und die Tinte erst danach. */
        { name: 'look', typ: 'stil', label: ORTS_MASKE_AN ? 'Druck' : 'Stil', property: 'Look', pflicht: true,
          /* Neue Maske: „Dunkel" statt „Linolschnitt" — die Look-ID bleibt
             `linolschnitt` (Dienst, Druck und Ton-Umschalten hängen daran), gezeichnet wird
             mit `dienst.C1_DUNKEL_AUSSPARUNG` in der Aussparung des Moments. Kachelbilder
             seit 20.10.2026 aus der Maske-Probe (`echoa-platzhalter-p-c1m-*`, Lissabon). */
          optionen: [
            { id: 'kontrolle', label: 'Farbig',
              hinweis: 'Die typischen Farben des Ortes', bild: 'c1_farbig' },
            ORTS_MASKE_AN
              ? { id: zweigVon('orts-print'), label: 'Dunkel',
                  hinweis: 'Eine Farbe, der Ort hell ausgespart', bild: 'c1_lino' }
              : { id: zweigVon('orts-print'), label: 'Linolschnitt',
                  hinweis: 'Eine Farbe, in Flächen geschnitten', bild: 'c1_lino' },
          ] },
        ...(ORTS_STIMMUNG_AN ? [{ name: 'stimmung', typ: 'stil', label: 'Stimmung', property: 'Stimmung',
          pflicht: true, vorwahl: 'tag', spalten: 2,
          optionen: [
            { id: 'tag', label: 'Tag', hinweis: 'Im Licht des Tages', bild: 'c1_farbig' },
            { id: 'abend', label: 'Abend', hinweis: 'Blaue Stunde, Licht in den Fenstern', bild: 'c1_abend' },
          ],
          nurWenn: { feld: 'look', wert: 'kontrolle' } }] : []),
        { name: 'tinte', typ: 'marker-solo', label: ORTS_MASKE_AN ? 'Ton' : 'Farbe des Schnitts',
          property: 'Tinte', pflicht: true,
          hilfe: ORTS_MASKE_AN ? TON_HILFE : 'Alles andere bleibt cremefarbenes Papier.',
          /* Nur sichtbar, wenn der Schnitt gewählt ist — bei der farbigen
             Fassung gibt es nichts zu wählen, und ein Feld, das folgenlos
             dasteht, ist schlimmer als keines. */
          nurWenn: { feld: 'look', wert: 'linolschnitt' } },
      ],
    },
    /* ---------------------------------------------------------- Kids Collection
       🔴 ZWEI KONZEPTE OHNE FARBWAHL (07.09.2026). Sie tragen keinen Marker
       und kein Tonfeld — Marken-Ausnahme I0: in dieser Schiene kommt die Farbe
       aus dem GEGENSTAND, Liste A gilt hier nicht und Liste B kommt nicht vor.
       Ein Farbkreis wäre hier eine Bestellung, die es nicht gibt.

       🔴 STATTDESSEN ZWEI ACHSEN, DIE KEINEN RENDER KOSTEN: Muster (4) und
       Passepartout (3) entstehen NACH dem Render aus EINEM Motiv — 12
       Kombinationen für 0,134 $ statt 1,61 $. Der Wechsel läuft über
       `/api/kandidat/<id>/achsen.png` und rendert NICHT; deshalb zählt er auch
       nicht gegen die fünf freien Vorschauen. */
    /* 🔴 HAUSTIER UND PFERD (16.10.2026, Saschas Entscheidungen 15./16.10.).
       EIN Render je Andruck; alles ab „Machart" ist SATZ und wird nach dem
       Andruck ohne neuen Render gesetzt (`HAUSTIER_SATZ_FELDER`,
       `haustierSatz`). Das Foto wird vor dem Andruck geprüft
       (`/api/haustier/foto`) und füllt Fell, Ohren und Merkmal vor. */
    'haustier': {
      felder: [
        { name: 'foto', typ: 'foto', label: 'Foto deines Tiers',
          hilfe: 'Ein Foto, auf dem dein Tier gut und scharf zu sehen ist – am besten '
               + 'von vorn. Menschen auf dem Foto zeichnen wir nicht mit.',
          hilfeEineSeite: 'Gut und scharf, am besten von vorn. Menschen zeichnen wir nicht mit.' },
        /* `?tier=katze` für die Katzen-Anzeigen (22.10.2026, Saschas T1 »A«). */
        { name: 'art', typ: 'chips', label: 'Welches Tier?', property: 'Tier',
          pflicht: true, vorwahl: 'hund', urlVorwahl: 'tier',
          optionen: [
            { id: 'hund', label: 'Hund' }, { id: 'katze', label: 'Katze' },
            { id: 'kaninchen', label: 'Kaninchen' },
            { id: 'meerschweinchen', label: 'Meerschweinchen' },
            { id: 'kleintier', label: 'Anderes Kleintier' },
          ] },
        { name: 'rasse', label: 'Rasse', typ: 'text', optional: true, maxlength: 30,
          platzhalter: 'Mischling',
          hilfe: 'Ohne Foto brauchen wir sie. Mit Foto hilft sie beim Treffen.' },
        { name: 'fell', label: 'Fell und Farben', typ: 'text', pflicht: true,
          maxlength: 80, platzhalter: 'schwarz mit weißer Brust',
          hilfe: 'Füllen wir aus deinem Foto vor – bitte kurz prüfen.' },
        { name: 'ohren', label: 'Ohren', typ: 'chips', optional: true,
          optionen: [{ id: 'Stehohren', label: 'Stehohren' },
            { id: 'Kippohren', label: 'Kippohren' },
            { id: 'Schlappohren', label: 'Schlappohren' }] },
        { name: 'merkmal', label: 'Ein besonderes Merkmal', typ: 'text', optional: true,
          maxlength: 80, platzhalter: 'rotes Halsband' },
        ...(HAUSTIER_MACHARTEN_AN ? [
          HAUSTIER_STIL('h1m'), HAUSTIER_STYLING,
          /* Eigene Property: »Machart« trägt hier die Wahl Magazin/Kohle/Illustration. */
          /* `?aufbau=lexikon` für die Lexikon-Anzeigen (22.10.2026). */
          { ...HAUSTIER_MACHART, label: 'Aufbau', property: 'Aufbau', urlVorwahl: 'aufbau',
            nurWenn: { feld: 'stil', wert: 'illustration' } },
          /* Vorwahl, weil das Feld beim Einblenden sonst leer stünde (`briefSichtbar`). */
          { ...HAUSTIER_LOOK(), vorwahl: 'farbig', nurWenn: { feld: 'stil', wert: 'illustration' } },
          HAUSTIER_TITELFARBE(),
        ] : [HAUSTIER_MACHART, HAUSTIER_LOOK()]),
        { name: 'name', label: 'Name', typ: 'text', pflicht: true, maxlength: 18,
          platzhalter: 'Bruno' },
        ...(HAUSTIER_MACHARTEN_AN ? [
          { name: 'fusszeile', label: 'Fußzeile', typ: 'text', optional: true, maxlength: 40,
            platzhalter: '2024 · Sofakönig',
            hilfe: 'Klein unten, in der Farbe des Titels – zum Beispiel ein Jahr.',
            nurWenn: { feld: 'stil', wert: 'magazin' } },
          /* Linie (27.10.2026): dieselbe Zeile wie bei Kohle, dazu die Rasse — »BRUNO · SEIT 2024 · MOPS«. */
          { name: 'seit', label: 'Bei dir seit', typ: 'text', optional: true, maxlength: 12,
            kurz: true, platzhalter: '2024', hilfe: 'Steht klein unten: BRUNO · SEIT 2024.',
            nurWenn: { feld: 'stil', werte: ['kohle', 'linie'] } },
        ] : []),
        { name: 'zeile', label: 'Eine Zeile darunter', typ: 'text', optional: true,
          maxlength: 42, platzhalter: 'Seit 2024 · Sofaecke links',
          nurWenn: { feld: 'machart', wert: 'portraet' } },
        { name: 'geschlecht', label: 'Wortart', typ: 'chips', optional: true,
          optionen: [{ id: 'männlich', label: 'maskulin' }, { id: 'weiblich', label: 'feminin' }],
          nurWenn: { feld: 'machart', wert: 'lexikon' } },
        ...HAUSTIER_EIGENHEITEN,
        { name: 'familie', label: 'Familienname', typ: 'text', pflicht: true,
          maxlength: 30, platzhalter: 'Weber',
          hilfe: 'Steht unten als „Aus dem Wörterbuch der Familie Weber".',
          nurWenn: { feld: 'machart', wert: 'lexikon' } },
      ],
    },
    /* 🔴 REZEPT (17.10.2026, Saschas Entscheidungen 16./17.10.). Die Karte
       füllt nur VOR — Titel, Zutaten, Zubereitung bleiben frei editierbar,
       unsicher Gelesenes ist am Feld markiert. Das Gericht steht frei als
       Text, keine Vorauswahl. Standard ist „Rezept" (Bild + Rezept); ohne
       Zubereitung setzt das Backend automatisch „Bild + Zutaten".
       `warenkorb: false`: lange Texte reisen nicht als Property — gedruckt
       wird ohnehin der Schnappschuss (`_rezept_satz`). */
    'rezept': {
      felder: [
        { name: 'karte', typ: 'karte', label: 'Foto deiner Rezeptkarte',
          hilfe: 'Wir lesen die Karte und füllen die Felder unten vor – du kannst alles ändern.' },
        { name: 'gericht', label: 'Welches Gericht zeichnen wir?', property: 'Gericht',
          typ: 'text', pflicht: true,
          maxlength: 120, platzhalter: 'Marmorgugelhupf mit Schokoladensauce',
          hilfe: 'Frei beschrieben, gern mit Sauce oder Beilagen.' },
        { name: 'machart', typ: 'chips', label: 'Machart', property: 'Machart',
          pflicht: true, vorwahl: 'rezept',
          hilfe: 'Beides entsteht aus demselben Entwurf – du kannst nach dem Andruck wechseln.',
          optionen: [
            { id: 'rezept', label: 'Rezept', hinweis: 'Gericht, Zutaten und Zubereitung' },
            { id: 'lexikon', label: 'Lexikon-Eintrag', hinweis: 'Wie im Wörterbuch' },
          ] },
        { name: 'bild', typ: 'chips', label: 'Bild des Gerichts', property: 'Bild',
          vorwahl: 'an', optionen: [{ id: 'an', label: 'Mit Bild' }, { id: 'aus', label: 'Ohne Bild' }],
          nurWenn: { feld: 'machart', wert: 'lexikon' } },
        HAUSTIER_LOOK(),
        { name: 'titel', label: 'Titel', typ: 'text', pflicht: true, maxlength: 60,
          platzhalter: 'Omas Marmorgugelhupf', nurWenn: { feld: 'machart', wert: 'rezept' } },
        { name: 'von', label: 'Aus der Küche von', typ: 'text', optional: true, maxlength: 40,
          platzhalter: 'Inge Weber' },
        { name: 'seit', label: 'Seit', typ: 'text', optional: true, maxlength: 12, kurz: true,
          platzhalter: '1974' },
        { name: 'zutaten', typ: 'liste', label: 'Zutaten', pflicht: 1, anzahl: 20, start: 6, startEineSeite: 3,
          mehrLabel: 'Noch eine Zutat', warenkorb: false, leerHinweis: REZEPT_LEER_ZUTATEN,
          hilfe: 'Eine Zutat je Zeile, mit Menge.',
          platzhalter: ['250 g weiche Butter', '200 g Zucker', '5 Eier', '400 g Mehl',
            '1 Päckchen Backpulver', '125 ml Milch'] },
        { name: 'zubereitung', label: 'Zubereitung', typ: 'text-lang', optional: true,
          maxlength: 1100, warenkorb: false,
          platzhalter: 'Butter und Zucker schaumig rühren, die Eier einzeln dazu …',
          /* ⏪ bis 22.10.2026: „Leer lassen: … dafür größer" — stimmte nicht, das Blatt blieb zu
             ~40 % leer (Tiefen-Check, Andruck k_8304164b9ded). */
          hilfe: 'Füllt das Blatt – ohne Zubereitung stehen nur die Zutaten darauf.',
          nurWenn: { feld: 'machart', wert: 'rezept' } },
        ...[1, 2, 3].map((i) => ({
          name: `bedeutung_${i}`, label: `Bedeutung ${i}`, typ: 'text', pflicht: i === 1,
          optional: i > 1, maxlength: 120, warenkorb: false,
          platzhalter: ['Marmorkuchen nach Omas Rezept, sonntags um drei.',
            'Wird lauwarm gestürzt. Nie vor dem Kaffee angeschnitten.',
            'Der Grund, warum alle pünktlich kommen.'][i - 1],
          ...(i === 1 ? { hilfe: 'Ein bis drei kurze Sätze, wie im Wörterbuch.' } : {}),
          nurWenn: { feld: 'machart', wert: 'lexikon' } })),
        { name: 'synonym', label: 'Synonym', typ: 'text', optional: true, maxlength: 80,
          warenkorb: false, platzhalter: 'Omas Kuchen, der Sonntagskuchen.',
          nurWenn: { feld: 'machart', wert: 'lexikon' } },
        { name: 'familie', label: 'Familienname', typ: 'text', optional: true, maxlength: 30,
          platzhalter: 'Weber', hilfe: 'Steht unten als „Aus dem Kochbuch der Familie Weber".',
          nurWenn: { feld: 'machart', wert: 'lexikon' } },
      ],
    },
    /* 🆕 LINIEN-SEITE »linie« (Saschas T1 27.10.2026, Variante 3: „drei Seiten — Ort, Paar am Ort, Paar als Linie
       (Linie vorausgewählt, Pinsel)"). Ein Foto von euch beiden (Feld der Moment-Sitzung, hier immer Pflicht), EIN
       Render aus den bestätigten Merkmalen (`dienst._linie_erzeugen`; das Foto selbst geht nicht ans Bildmodell).
       Farbe, Namen und Zeile setzen den Entwurf danach neu, ohne Render (Satz wie Haustier: `SATZ_H1`).
       Sichtbar erst, wenn das Shopify-Produkt freigeschaltet ist und der Dienst `LINIE_SEITE_AN` trägt
       (`shop/live-linie-seite.sh`). */
    'linie': {
      felder: [
        { name: 'stil', typ: 'stil', label: 'Machart', property: 'Machart', pflicht: true, vorwahl: 'linie',
          urlVorwahl: 'machart', spalten: 2,
          /* Ohne Pinsel gibt es nur die eine Machart — dann kein Satz über mehrere (Sichtprobe 28.10.2026). */
          ...(LINIE_PINSEL_AN ? { hilfe: 'Jede Machart ist ein eigener Entwurf.' } : {}),
          optionen: [
            { id: 'linie', label: 'Linie', bild: 'l1_linie', hinweis: 'Eine einzige Linie, wie aus dem Gedächtnis' },
            ...(LINIE_PINSEL_AN ? [{ id: 'pinsel', label: 'Pinsel', bild: 'l1_pinsel', hinweis: 'Wenige Pinselstriche' }] : []),
          ] },
        { name: 'paarfoto', typ: 'paarfoto', label: 'Ihr zwei' },
        { name: 'look', typ: 'marker', label: 'Farbe', property: 'Farbgebung', pflicht: true, vorwahl: 'papier',
          hilfe: 'Kannst du nach dem Andruck wechseln, ohne neuen Entwurf.',
          hilfeEineSeite: '',
          optionen: [
            { id: 'papier', label: 'Tinte auf Papier', hex: '#181818', bild: 'l1_papier' },
            /* Die Gründe der Linie (`linie.GRUENDE`): drei aus Liste B, die Linie dann in Papier. */
            ...LISTE_B().filter((t) => ['terrakotta', 'petrol', 'salbei'].includes(t.id))
              .map((t) => ({ id: t.id, label: t.label, hex: t.hex, bild: `l1_${t.id}` })),
          ] },
        { name: 'name', label: 'Eure Namen', typ: 'text', optional: true, maxlength: 30,
          platzhalter: 'Lena & Tim', hilfe: 'Steht klein unter dem Bild: LENA & TIM · 21. JUNI 2025.' },
        { name: 'zeile', label: 'Ein Datum oder ein Wort', typ: 'text', optional: true, maxlength: 30,
          platzhalter: '21. Juni 2025' },
      ],
    },
    /* 🆕 PORTRÄT »portraet« (Saschas Auftrag 29.10.2026: „nenn es … ‚Porträt‘. Es könnten ja auch einfach zwei
       erwachsene Personen oder eine zu sehen sein"). Ein Foto von 1–5 Personen, auch Kinder, als Kohle »mittel« oder
       Pinsel im Aufbau des Fotos (`dienst._portraet_erzeugen`, `pipeline/portraet.py`; das Foto geht hier ans
       Bildmodell — Saschas Klarstellung 29.10.). Foto-Feld wie bei der Linien-Seite (Typ »paarfoto«, beim Porträt
       ohne Merkmal-Auswahl: nur „Wir sehen …"). Farbe (nur Pinsel), Namen und Zeile ohne Render (`SATZ_H1`). */
    'portraet': {
      felder: [
        { name: 'stil', typ: 'stil', label: 'Machart', property: 'Machart', pflicht: true, vorwahl: 'kohle',
          urlVorwahl: 'machart', spalten: 2, hilfe: 'Jede Machart ist ein eigener Entwurf.',
          optionen: [
            { id: 'kohle', label: 'Kohle', bild: 'p1_kohle', hinweis: 'Gezeichnet mit Kohlestift' },
            { id: 'pinsel', label: 'Pinsel', bild: 'p1_pinsel', hinweis: 'Wenige Pinselstriche' },
          ] },
        { name: 'paarfoto', typ: 'paarfoto', label: 'Euer Foto' },
        { name: 'look', typ: 'marker', label: 'Farbe', property: 'Farbgebung', pflicht: true, vorwahl: 'papier',
          nurWenn: { feld: 'stil', werte: ['pinsel'] },
          hilfe: 'Kannst du nach dem Andruck wechseln, ohne neuen Entwurf.',
          hilfeEineSeite: '',
          optionen: [
            { id: 'papier', label: 'Tinte auf Papier', hex: '#181818', bild: 'p1_papier' },
            ...LISTE_B().filter((t) => ['terrakotta', 'petrol', 'salbei'].includes(t.id))
              .map((t) => ({ id: t.id, label: t.label, hex: t.hex, bild: `p1_${t.id}` })),
          ] },
        { name: 'name', label: 'Namen', typ: 'text', optional: true, maxlength: 30,
          platzhalter: 'Lena, Tom & Mia', hilfe: 'Steht klein unter dem Bild.' },
        { name: 'zeile', label: 'Ein Datum oder ein Wort', typ: 'text', optional: true, maxlength: 30,
          platzhalter: 'Weihnachten 2026' },
      ],
    },
    'pferd': {
      felder: [
        { name: 'foto', typ: 'foto', label: 'Foto deines Pferdes',
          hilfe: 'Ein Foto, auf dem Kopf und Hals gut und scharf zu sehen sind – am '
               + 'besten von vorn. Menschen auf dem Foto zeichnen wir nicht mit.',
          hilfeEineSeite: 'Kopf und Hals gut und scharf, am besten von vorn. Menschen zeichnen wir nicht mit.' },
        { name: 'rasse', label: 'Rasse', typ: 'text', optional: true, maxlength: 30,
          platzhalter: 'Hannoveraner',
          /* Sascha, 19.10.2026: „Steht im Lexikon-Eintrag“ versteht ein Erstbesucher nicht —
             die Machart wird erst weiter unten gewählt. */
          hilfe: 'Ohne Foto brauchen wir sie. Wählst du im nächsten Schritt „Lexikon“, '
               + 'steht sie dort auch im Text.' },
        { name: 'fell', label: 'Fellfarbe und Abzeichen', typ: 'text', pflicht: true,
          maxlength: 80, platzhalter: 'Fuchs mit durchgehender Blesse',
          hilfe: 'Füllen wir aus deinem Foto vor – bitte kurz prüfen.' },
        { name: 'merkmal', label: 'Ein besonderes Merkmal', typ: 'text', optional: true,
          maxlength: 80, platzhalter: 'helle Mähne' },
        /* Magazin/Kohle beim Pferd (Saschas T1 21.10.2026), derselbe Schalter wie beim Haustier. */
        ...(HAUSTIER_MACHARTEN_AN ? [
          HAUSTIER_STIL('h2m'), PFERD_STYLING,
          { ...HAUSTIER_MACHART, label: 'Aufbau', property: 'Aufbau', urlVorwahl: 'aufbau',
            nurWenn: { feld: 'stil', wert: 'illustration' } },
          { ...HAUSTIER_LOOK(), vorwahl: 'farbig', nurWenn: { feld: 'stil', wert: 'illustration' } },
          HAUSTIER_TITELFARBE(),
        ] : [HAUSTIER_MACHART, HAUSTIER_LOOK()]),
        { name: 'name', label: 'Name', typ: 'text', pflicht: true, maxlength: 18,
          platzhalter: 'Lotte' },
        /* 22.10.2026 abends (Sascha: „was bezweckt die Auswahl? Nicht ersichtlich!"): gesetzt wird es
           nur im Lexikon-Eintrag (`haustier.py`, Zeile „Stute · Stockmaß …") — sonst ausgeblendet. */
        { name: 'geschlecht', label: 'Stute, Wallach oder Hengst', typ: 'chips', optional: true,
          hilfe: 'Steht im Lexikon-Eintrag gleich unter dem Namen.',
          nurWenn: { feld: 'machart', wert: 'lexikon' },
          optionen: [{ id: 'Stute', label: 'Stute' }, { id: 'Wallach', label: 'Wallach' },
            { id: 'Hengst', label: 'Hengst' }] },
        { name: 'stockmass', label: 'Stockmaß', typ: 'text', optional: true, maxlength: 10,
          platzhalter: '1,68 m', nurWenn: { feld: 'machart', wert: 'lexikon' } },
        { name: 'stall', label: 'Stall', typ: 'text', optional: true, maxlength: 30,
          platzhalter: 'Lindenhof', hilfe: 'Steht klein unten auf dem Blatt: LOTTE · LINDENHOF · SEIT 2024.' },
        /* Mit Magazin/Kohle steht „seit“ in der Fußzeile — dann immer sichtbar. */
        { name: 'seit', label: 'Bei dir seit', typ: 'text', optional: true, maxlength: 12,
          platzhalter: '2024',
          ...(HAUSTIER_MACHARTEN_AN ? {} : { nurWenn: { feld: 'machart', wert: 'portraet' } }) },
        { name: 'zeile', label: 'Eine Zeile darunter', typ: 'text', optional: true,
          /* Platzhalter ≠ Rückfall (Sascha: „Leer lassen: dann steht hier Stall und Jahr" neben
             dem Platzhalter „Stall Lindenhof · seit 2024" ergab keinen Sinn). */
          maxlength: 42, platzhalter: 'Die Königin vom Lindenhof',
          hilfe: 'Leer lassen: dann steht hier Stall und Jahr.',
          nurWenn: { feld: 'machart', wert: 'portraet' } },
        ...(HAUSTIER_MACHARTEN_AN ? [
          { name: 'fusszeile', label: 'Fußzeile', typ: 'text', optional: true, maxlength: 40,
            platzhalter: 'Lindenhof · seit 2024',
            hilfe: 'Leer lassen: dann stehen Stall und Jahr dort – klein, in der Farbe des Titels.',
            nurWenn: { feld: 'stil', wert: 'magazin' } },
        ] : []),
        ...haustierEigenheiten('pferd'),
        { name: 'besitzer', label: 'Dein Name', typ: 'text', optional: true,
          maxlength: 30, platzhalter: 'Marie',
          hilfe: 'Steht unten als „Aus dem Stallbuch von Marie".',
          nurWenn: { feld: 'machart', wert: 'lexikon' } },
      ],
    },
    'wortschatz': {
      /* 🆕 WORTSCHATZ-POP (Saschas T1 »A«, 20.10.2026, Mock „Creme fest"):
         drei Fragen — Wort · Stil · Hintergrund. Ein Render (Nano Banana 2.1) auf
         Vollton, der Hintergrund wird umgefärbt (`dienst._wortschatz_pop_erzeugen`).
         ⏪ Bis 20.10.2026 standen hier die Macharten Gemalt/Wörterbuch mit Muster
         und Passepartout; das Backend baut sie für alte Entwürfe weiter. */
      felder: [
        { name: 'wort', label: 'Das Wort', typ: 'text', pflicht: true,
          hilfe: 'So, wie dein Kind es sagt. Genau diese Schreibweise steht '
               + 'später auf dem Blatt – gesetzt, nicht gemalt.',
          platzhalter: 'Dakko' },
        { name: 'bedeutung', label: 'Was es bedeutet', typ: 'text', pflicht: true,
          hilfe: 'Das Ding, das gemeint ist. Daraus entsteht das Bild.',
          platzhalter: 'Traktor' },
        /* Beim Stil „Gemalt" steht nur das Wort auf dem Blatt (`dienst._k2_blatt_setzen`) — Kind,
           Alter und Anlass würden dort nie erscheinen, also fragen wir sie dann nicht. */
        { name: 'kind_und_alter', label: 'Kind und Alter', typ: 'text',
          pflicht: true, platzhalter: 'Leon, 2 Jahre',
          hilfe: 'Steht klein unten auf dem Blatt.',
          nurWenn: { feld: 'look', werte: ['linol', 'abstrakt'] } },
        { name: 'anlass', label: 'Wann oder wo', typ: 'text', optional: true,
          maxlength: 36, platzhalter: 'Sommer 2026',
          hilfe: 'Steht klein neben dem Namen.',
          nurWenn: { feld: 'look', werte: ['linol', 'abstrakt'] } },
        /* Stilkacheln: hier ändert sich die MACHART (Linolschnitt gegen
           abstrakte Formen), nicht die Farbe. Bilder aus Saschas Gesamtraster. */
        /* 🆕 22.10.2026 abends (Sascha: „den alten Stil … als dritten Stil mit einfügen, also der
           farbig-aquarellmäßig gezeichnete Gegenstand. Für diejenigen, die es weder abstrakt wollen,
           noch den Linolschnitt"): `bildlich` wieder angeboten. Der Dienst baut ihn unverändert
           (`dienst.LOOKS_ALTBESTAND`), mit Muster und Passepartout wie bis zum 20.10.2026.
           `LOOKS_JE_HANDLE` bleibt bei den zwei Pop-Looks — es ist die Gegenprobe zum Dienst-Selbsttest
           5b-bis, und der führt `bildlich` dort als Altbestand. */
        { name: 'look', typ: 'stil', label: 'Stil', property: 'Stil', reihe: true,
          pflicht: true, vorwahl: 'linol',
          optionen: [
            { id: 'linol', label: 'Linolschnitt', bild: 'k2p_linol' },
            { id: 'abstrakt', label: 'Abstrakt', bild: 'k2p_abstrakt' },
            { id: 'bildlich', label: 'Gemalt', bild: 'k2_bildlich' },
          ] },
        /* Muster hinter dem gemalten Motiv (wie bis 20.10.2026, Bildkacheln vom abgenommenen Blatt,
           `dienst.achsen_setzen`, 0 $). Nur beim Stil „Gemalt". */
        { name: 'muster', typ: 'stil', label: 'Muster hinter dem Motiv', reihe: true,
          property: 'Muster', pflicht: true, vorwahl: 'punkte',
          hilfe: 'Kostet keinen zweiten Entwurf – du kannst nach dem Andruck durchschalten.',
          optionen: [
            { id: 'punkte', label: 'Punkte', bild: 'k2_muster_punkte' },
            { id: 'karo', label: 'Karo', bild: 'k2_muster_karo' },
            { id: 'streifen', label: 'Streifen', bild: 'k2_muster_streifen' },
            { id: 'ohne', label: 'ohne Muster', bild: 'k2_muster_ohne' },
          ],
          nurWenn: { feld: 'look', wert: 'bildlich' } },
        /* Passepartout nach dem Andruck, nur beim gemalten Stil (wie bis 20.10.2026). */
        { name: 'passepartout', typ: 'chips', label: 'Passepartout',
          property: 'Passepartout', pflicht: true, vorwahl: 'randlos', schritt: 'ausfuehrung',
          hilfe: 'Ein cremefarbener Rand ums Motiv, aus dem Blatt selbst – kostet keinen zweiten Entwurf.',
          optionen: [
            { id: 'randlos', label: 'randlos' }, { id: 'schmal', label: 'schmal' },
            { id: 'breit', label: 'breit' },
          ],
          nurWenn: { feld: 'look', wert: 'bildlich' } },
        /* Fünf Hintergründe, jeder ein fertiger Look; Creme zeigt den
           Linolschnitt in der Echoa-Tinte. Das Bühnenbild vor dem Andruck hängt
           an Stil UND Hintergrund (`k2p_<grund>_<stil>`, `achsenBeispielUrl`).
           🔴 Beim Linolschnitt eine kostenlose Achse nach dem Andruck; beim
           Abstrakt Teil des Renders (die Palette lässt die Grundfarbe aus) —
           `briefSchluessel` nimmt ihn dort in den Fingerabdruck.
           ⚠️ IDs, Labels und Farben hält `dienst.py --selbsttest` gegen
           `zitat-pop-prompts.WORTSCHATZ_POP_GRUENDE`. */
        /* 🆕 22.10.2026: Bildkacheln statt Farbpunkt-Chips — das Bild zeigt den Hintergrund im
           gewählten Stil (`k2p_<grund>_<stil>`, `kachelBilderSetzen`). */
        { name: 'hintergrund', typ: 'stil', reihe: true, label: 'Hintergrund', bildJeLook: true,
          nurWenn: { feld: 'look', werte: ['linol', 'abstrakt'] },
          /* `?hintergrund=creme` für die Creme-Anzeige (22.10.2026, Saschas T1 »A«). */
          property: 'Hintergrund', pflicht: true, vorwahl: 'kobalt', urlVorwahl: 'hintergrund',
          optionen: [
            { id: 'kobalt', label: 'Kobalt', hex: '#3A64B0', bild: 'k2p_kobalt' },
            { id: 'pink', label: 'Pink', hex: '#F27BAE', bild: 'k2p_pink' },
            { id: 'rot', label: 'Rot', hex: '#E2462F', bild: 'k2p_rot' },
            { id: 'dunkelgruen', label: 'Dunkelgrün', hex: '#1B3435', bild: 'k2p_dunkelgruen' },
            { id: 'creme', label: 'Creme', hex: '#FEF7EC', bild: 'k2p_creme' },
          ] },
      ],
    },
    /* 🔴 ZITAT — eigenes Produkt seit 29.09.2026 (Sascha: „ein drittes
       Konzept neben dem Wortschatz und neben der Jahreszahl … ganze Sätze …
       kein Symbol, was gemalt werden muss"). Bis dahin war es eine Machart
       des Wortschatzes. Vollständig GESETZT: kein Wort, kein Motiv, kein
       Look-Wahl — der einzige Look `zitat` ist die Vorgabe im Backend. */
    'zitat': {
      /* 🆕 ZITAT-POP (Sascha, 20.10.2026): Satz · Kind und Alter · Anlass und
         EINES von fünf festen Postern. 1–4 malt Nano Banana 2.1 mitsamt dem Satz
         (Lese-Probe, höchstens ein Neuwurf), 5 wird gesetzt. Das Poster ist KEINE
         Achse nach dem Andruck — ein anderes Poster ist ein neuer Andruck.
         ⏪ Bis 20.10.2026: gesetztes Blatt mit Farbwelt (Altrosa/Salbei/Petrol/
         Beige); das Backend baut es für alte Entwürfe weiter. */
      felder: [
        { name: 'satz', label: 'Der Satz', typ: 'text-lang', pflicht: true,
          maxlength: 90,
          hilfe: 'Genau so, wie euer Kind es gesagt hat. Höchstens 90 Zeichen.',
          platzhalter: 'Papa, dein Gehirn ist noch im Urlaub!' },
        { name: 'kind_und_alter', label: 'Kind und Alter', typ: 'text',
          pflicht: true, platzhalter: 'Ella, 3 Jahre',
          hilfe: 'Steht klein unten auf dem Poster.' },
        { name: 'anlass', label: 'Wann oder wo', typ: 'text', optional: true,
          maxlength: 36,
          hilfe: 'Steht klein neben dem Namen – „beim Abendessen, März 2025".',
          platzhalter: 'beim Abendessen, März 2025' },
        /* `beispiel: true`: die Kachel legt ihr Bild vor dem Andruck aufs Blatt
           (`stilBeispielUrl`). ⚠️ IDs und Labels hält `dienst.py --selbsttest`
           gegen `zitat-pop-prompts.ZITAT_POSTER`. */
        /* `?poster=kobalt_rosa` für die Emil-Anzeige (22.10.2026, Saschas Wunsch: zweiter Zitat-Test). */
        { name: 'poster', typ: 'stil', reihe: true, label: 'Poster', property: 'Poster',
          pflicht: true, vorwahl: 'markise_pink', urlVorwahl: 'poster', spalten: 5, beispiel: true,
          optionen: [
            { id: 'markise_pink', label: 'Markise Pink', bild: 'k3p_markise_pink' },
            { id: 'markise_kobalt', label: 'Markise Kobalt', bild: 'k3p_markise_kobalt' },
            { id: 'kobalt_rosa', label: 'Kobalt Rosa', bild: 'k3p_kobalt_rosa' },
            /* `umbruch` nur für die Anzeige: „Dunkelgrün" (81 px bei 15 px Schrift) ist
               breiter als die Kachel bei fünf Spalten (~55 px Innenraum, gemessen
               20.10.2026) — die weiche Trennstelle greift nur, wenn der Platz fehlt.
               Das Label (Cart-Property, Selbsttest) bleibt unverändert. */
            { id: 'dunkelgruen_neon', label: 'Dunkelgrün Neon', bild: 'k3p_dunkelgruen_neon',
              umbruch: 'Dunkel&shy;grün Neon' },
            { id: 'flieder', label: 'Flieder', bild: 'k3p_flieder' },
          ] },
      ],
    },
    /* 🎮 GAMING-PAAR (16.10.2026, Sascha am Bild: „würde ich so in den Shop
       packen"). Zwei selbst gebaute Spielfiguren in einer festen 16-Bit-Welt,
       ohne Foto. Gefragt wird nur, was auf 20–30 Spielpixeln je Figur
       SICHTBAR ist (`pipeline/nischen/ohne-foto.md`, Baukasten). Figur 1 =
       links = erster Name. Die IDs hält `dienst.py` Selbsttest (8b-gaming)
       gegen `gaming_satz.py`; Felder je Figur aus `gamingFigur()` unten. */
    'gaming': {
      felder: [
        /* `urlVorwahl` (18.10.2026, Saschas T1 »C«): die Übersichtskachel
           „Pixel-Paar, schlicht" verlinkt `?welt=creme` auf dieselbe Seite. */
        /* 🆕 22.10.2026: Bildkacheln — jede Welt zeigt ihr Beispielbild (`g1_<welt>`). */
        { name: 'welt', typ: 'stil', reihe: true, label: 'Spielwelt', property: 'Spielwelt',
          pflicht: true, vorwahl: 'lagerfeuer', urlVorwahl: 'welt',
          optionen: [
            { id: 'lagerfeuer', label: 'Lagerfeuer am See', hinweis: 'nachts, von oben', bild: 'g1_lagerfeuer' },
            { id: 'klippe', label: 'Klippe im Sonnenuntergang', hinweis: 'von der Seite', bild: 'g1_klippe' },
            /* 🆕 18.10.2026 (Saschas T1 »A« + Variante 2 + Größe M, 17.10.):
               das Paar auf dem Stamm, Creme-Grund, Namen in Bodoni. */
            { id: 'creme', label: 'Schlicht auf Creme', hinweis: 'Namen in edler Schrift', bild: 'g1_creme' },
          ] },
        /* 🆕 31.10.2026 (Saschas T1 »B«, am Mockup A gegen B): Stil → Foto → Texte wie auf allen Foto-Seiten — das
           Foto samt Baukasten („Kein Foto zur Hand?“ / „Figuren anpassen“) direkt unter der Spielwelt, die Namen danach.
           ⏪ Bis 31.10.2026: Spielwelt → Namen → Foto. */
        ...(GAMING_FOTO_AN ? [{ name: 'paarfoto', typ: 'paarfoto', label: 'Ihr zwei' }] : []),
        ...gamingFigur(1),
        ...gamingFigur(2),
        /* `beide`: der Satz verlangt zwei Namen (`gaming_satz.py`: „Bitte den 2. Vornamen eintragen.“) — schon hier
           prüfen, damit der Hinweis am Feld steht statt als Dienst-Meldung oben (Sascha live, 30.10.2026). */
        { name: 'namen', typ: 'namen', maxlength: 20, beide: true,
          hilfe: 'Stehen auf dem Holzschild bzw. unter dem Bild. Höchstens 20 Zeichen je Name.' },
        { name: 'tier1', typ: 'chips', label: 'Haustier', property: 'Haustier',
          pflicht: true, vorwahl: 'keins', optionen: gamingAuswahl().tiere },
        /* Vorwahl creme = was der Editor ohne Wahl zeigt (`gaming_vorschau.wahl`). */
        { name: 'tier1_fell', typ: 'chips', label: 'Fellfarbe', property: 'Fellfarbe',
          pflicht: true, vorwahl: 'creme', optionen: gamingAuswahl().felle,
          nurWenn: { feld: 'tier1', werte: ['hund', 'katze'] } },
        { name: 'tier2', typ: 'chips', label: 'Zweites Haustier', property: 'Haustier 2',
          pflicht: true, vorwahl: 'keins', optionen: gamingAuswahl().tiere,
          nurWenn: { feld: 'tier1', werte: ['hund', 'katze'] } },
        { name: 'tier2_fell', typ: 'chips', label: 'Fellfarbe (zweites Tier)',
          property: 'Fellfarbe 2', pflicht: true, vorwahl: 'creme', optionen: gamingAuswahl().felle,
          nurWenn: { feld: 'tier2', werte: ['hund', 'katze'] } },
        { name: 'jahr', label: 'Zusammen seit', typ: 'text', kurz: true, optional: true,
          maxlength: 4, platzhalter: '2016',
          hilfe: 'Steht unter euren Namen: „seit 2016“.' },
      ],
    },
    'jahreszahl': {
      felder: [
        /* 🔴 DIE ZIFFER IST DAS ALTER, NICHT DAS GEBURTSJAHR — Sascha am Bild
           (07.09.2026): „vierstellig trägt nicht". Der Hilfetext sagt es, und
           `c2_stufe1.alter_lesen` weist eine vierstellige Zahl mit genau
           dieser Begründung ab, bevor Geld fließt. */
        { name: 'alter', label: 'Alter', typ: 'text', kurz: true, pflicht: true,
          hilfe: 'Die Zahl, die groß auf dem Blatt steht – das Alter, kein '
               + 'Geburtsjahr.',
          platzhalter: '7' },
        /* 🔴 EIN FREIES, OPTIONALES FELD (Sascha, 07.09.2026): „Wer mag kann
           hier den Namen mit Jahreszahl oder eben eine Widmung eintragen oder
           gar nichts."
           ⏪ Hier stand ein PFLICHT-Namensfeld. Der Grund für den Wechsel ist
           kein Geschmack: das Referenzblatt trug „Ella · 2019", und die Zahl
           dahinter ist das Geburtsjahr. Aus dem Alter zurückzurechnen wäre je
           nach Geburtstag um ein Jahr falsch gewesen — eine Vermutung auf
           gedruckter Ware. Mit einem freien Feld schreibt der Kunde sie selbst
           hin, und wer nichts will, bekommt nichts: dann trägt das Blatt nur
           die Ziffer und die Objekte.
           🔴 44 ZEICHEN ist eine Setz-Grenze, keine runde Zahl — gemessen am
           breitesten Fall (eine Zeile aus lauter Versalien, 15 pt auf 30×40).
           `bauplan.C2_WIDMUNG_MAX` und `c2_stufe1` halten denselben Riegel;
           `maxlength` hier spart dem Kunden nur die Fehlermeldung. */
        { name: 'widmung', label: 'Widmung', typ: 'text', optional: true,
          maxlength: 44,
          hilfe: 'Steht klein unter dem Bild, in unserer Schrift gesetzt. '
               + 'Ein Name mit Jahreszahl, ein Satz für dein Kind – oder du '
               + 'lässt es leer, dann bleibt das Blatt ohne Zeile.',
          /* ⏪ 22.09.2026 (Sascha): Komma statt Mittelpunkt — den »·« kann ein
             Kunde nicht tippen, und er hätte ihn für Pflicht gehalten. */
          platzhalter: 'Ella, 2026' },
        { name: 'begriffe', label: 'Was dein Kind ausmacht', typ: 'liste',
          anzahl: 6, start: 3, pflicht: 3,
          /* ⏪ 09.09.2026: „was man hinstellen könnte" ist raus (Sascha:
             irreführend fürs Bild). Es legte einen Gegenstand auf dem Tisch
             nahe — auf dem Blatt umgeben die Dinge aber die Ziffer, sie
             stehen nicht irgendwo. Die Unterscheidung, auf die es ankommt,
             bleibt: DING statt Eigenschaft. */
          hilfe: 'Drei genügen, sechs sind das Maximum. Dinge, keine '
               + 'Eigenschaften – Sachen, die es wirklich gibt.',
          mehrLabel: 'Noch ein Ding',
          platzhalter: ['Fußball', 'Geige', 'Ein aufgeschlagenes Buch',
            'Schlittschuh', 'Meerschweinchen', 'Fahrradhelm'] },
        /* Schritt II, wie beim Wortschatz — Begründung dort. */
        { name: 'passepartout', typ: 'chips', label: 'Passepartout',
          property: 'Passepartout', pflicht: true, vorwahl: 'randlos',  /* 30.09.2026, Sascha A */
          schritt: 'ausfuehrung',
          hilfe: 'Ein cremefarbener Rand ums Motiv, aus dem Blatt selbst – '
               + 'kostet keinen zweiten Entwurf.',
          optionen: [
            { id: 'randlos', label: 'randlos' },
            { id: 'schmal', label: 'schmal' },
            { id: 'breit', label: 'breit' },
          ] },
      ],
    },
  };

  /* >>> GAMING-BAUKASTEN (16.10.2026) — die Auswahl je Figur. IDs =
     Schlüssel in `pipeline/nischen/gaming_satz.py`; dort steht, was das
     Bildmodell daraus liest. Die Farbpunkte sind Bildfarben der Spielwelt,
     keine Marken-Töne (kein Wert aus `marke/`). Beides `function`, damit
     `BRIEFE` oben sie schon beim Aufbau findet (Hebung) — eine `const`
     hier wäre beim Aufbau von `BRIEFE` noch nicht belegt. */
  function gamingFigur(n) {
    const g = gamingAuswahl();
    const chip = (feld, label, optionen, extra = {}) => ({
      name: `p${n}_${feld}`, typ: 'chips', label: `Figur ${n} · ${label}`,
      property: `Figur ${n} ${label}`, pflicht: true, optionen, ...extra });
    /* 🆕 19.10.2026 (Sascha am Editor gegen den Render: „beide sehen gleich aus,
       im Bild trägt sie plötzlich Rock"): Figur, Mütze/Cap, Pulli/Hoodie/T-Shirt, Hose/Rock.
       Alle mit Vorwahl — kein Pflichtklick mehr, der Editor zeigt die Vorgabe
       sofort. „Figur" ist bewusst keine Geschlechterfrage. Die Labels der
       bisherigen Felder bleiben, sonst ändern sich die Warenkorb-Properties. */
    /* 🆕 19.10.2026 abends (Sascha: „muss 1x alles vorausgewählt sein … wahnsinnig
       frustrierend, wenn man beim Drücken auf den Render-Button ständig gesagt bekommt, was
       alles noch anzuklicken ist, obwohl die Personen im Bild so für einen passen"): jede
       Wahl hat eine Vorwahl, und zwar GENAU die, die der Editor ohne Wahl zeigt — der erste
       Eintrag je Liste in `gaming_satz.PERSON_FELDER` (`gaming_vorschau.wahl`). Ändert sich
       dort die Reihenfolge, hier nachziehen, sonst zeigt der Editor etwas anderes als gewählt. */
    return [
      chip('haar', 'Haarfarbe', g.haare, { vorwahl: 'schwarz' }),
      /* 🆕 30.10.2026 abends (Sascha: „bei zu vielen Möglichkeiten die Frisur als Dropdown“): `liste` zeigt eine
         Auswahlliste, die Chips bleiben verborgen darunter — Vorbelegung, Vorschau und Warenkorb lesen weiter sie. */
      chip('frisur', 'Frisur', g.frisuren, { vorwahl: 'kurz', liste: true }),
      chip('haut', 'Hautton', g.haut, { vorwahl: 'sehr_hell' }),
      /* 🆕 Saschas Wahl »C« (19.10.2026 abends): sichtbar nur Haar, Frisur, Haut — der Rest
         steht hinter dem Klappschalter „Brille, Bart, Kleidung" (`gamingMaskeZeichnen`).
         🔴 KLAPPE = NUR AUSBLENDEN, NIE LEEREN. Die Felder bleiben mit ihrer Vorwahl im Brief;
         der Dienst verlangt Brille, Bart und Oberteil (`gaming_satz.brief_pruefen`, nicht in
         NEU_FELDER) — ein geleertes Feld hieße „Bitte für Figur 1 noch Brille wählen".
         ⏪ Bis 19.10. abends: Chip „Kleidung & Details" (Standard/Selbst wählen) mit `nurWenn`,
         Brille/Bart/Oberteil standen offen da. */
      ...[
        chip('brille', 'Brille', g.brille, { vorwahl: 'nein' }),
        chip('bart', 'Bart', g.bart, { vorwahl: 'kein' }),
        chip('oberteil', 'Oberteil', g.oberteile, { vorwahl: 'rot' }),
        chip('figur', 'Figur', g.figur, { vorwahl: 'gerade' }),
        chip('muetze', 'Mütze oder Cap', g.muetze, { vorwahl: 'nein' }),
        chip('muetzefarbe', 'Farbe Mütze/Cap', g.muetzenfarben,
          { vorwahl: 'rot', nurWenn: { feld: `p${n}_muetze`, werte: ['muetze', 'cap'] } }),
        chip('oberteilart', 'Art des Oberteils', g.oberteilarten, { vorwahl: 'pulli' }),
        chip('unterteil', 'Hose oder Rock', g.unterteile, { vorwahl: 'hose' }),
        chip('unterteilfarbe', 'Farbe Hose/Rock', g.unterteilfarben, { vorwahl: 'jeans' }),
      ].map((f) => ({ ...f, klappe: true })),
    ];
  }
  function gamingAuswahl() { return {
    haare: [
      { id: 'schwarz', label: 'Schwarz', hex: '#1e1a1a' },
      { id: 'dunkelbraun', label: 'Dunkelbraun', hex: '#4a2e1f' },
      { id: 'hellbraun', label: 'Hellbraun', hex: '#8a5a35' },
      { id: 'blond', label: 'Blond', hex: '#e2c26e' },
      { id: 'rot', label: 'Rot', hex: '#b4472a' },
      { id: 'grau', label: 'Grau/Weiß', hex: '#b9b9b9' },
      { id: 'pink', label: 'Pink', hex: '#e86fb0' },
    ],
    frisuren: [
      { id: 'sehr_kurz', label: 'sehr kurz' },
      { id: 'seitenscheitel', label: 'kurz, Scheitel' },
      { id: 'kurz', label: 'kurz, mit Pony' },
      { id: 'mittel', label: 'schulterlang' },
      { id: 'lang_glatt', label: 'lang, glatt' },
      { id: 'lang_lockig', label: 'lang, lockig' },
      { id: 'dutt', label: 'Dutt' },
      { id: 'glatze', label: 'Glatze' },
      /* 🆕 30.10.2026: Zöpfe (`gaming_satz.FRISUREN`); der Editor zeigt sie als „lang, glatt". Mit `GAMING_FOTO_AN`,
         weil ein älterer Dienst den Wert nicht kennt. */
      ...(GAMING_FOTO_AN ? [{ id: 'zoepfe', label: 'Zöpfe' }, { id: 'afro_kurz', label: 'kurzer Afro' }] : []),
      ...(AFRO_LANG_AN ? [{ id: 'afro_lang', label: 'langer Afro' }] : []),
    ],
    haut: [
      { id: 'sehr_hell', label: 'sehr hell', hex: '#f6dcc8' },
      { id: 'hell', label: 'hell', hex: '#ebc09f' },
      { id: 'mittel', label: 'mittel', hex: '#d19a6e' },
      { id: 'braun', label: 'braun', hex: '#a86b45' },
      { id: 'dunkel', label: 'dunkel', hex: '#6b4128' },
    ],
    /* 🆕 30.10.2026: Brillenfarbe — „ja" bleibt die schwarze Brille (ältere Entwürfe gelten unverändert). */
    brille: GAMING_FOTO_AN ? [{ id: 'nein', label: 'keine' }, { id: 'ja', label: 'schwarz' }, { id: 'braun', label: 'braun' },
      { id: 'rot', label: 'rot' }, { id: 'gold', label: 'gold' }] : [{ id: 'nein', label: 'keine' }, { id: 'ja', label: 'Brille' }],
    bart: [{ id: 'kein', label: 'kein' },
           /* 🆕 30.10.2026: Stoppeln (Saschas Kommentar am Paris-Paar) — mit `GAMING_FOTO_AN`, wie Zöpfe. */
           ...(GAMING_FOTO_AN ? [{ id: 'stoppel', label: 'Stoppeln' }] : []),
           { id: 'kurz', label: 'kurz' }, { id: 'voll', label: 'Vollbart' }],
    oberteile: [
      { id: 'rot', label: 'Rot', hex: '#c8352e' },
      { id: 'orange', label: 'Orange', hex: '#e07b2e' },
      { id: 'gelb', label: 'Gelb', hex: '#e9c23a' },
      { id: 'gruen', label: 'Grün', hex: '#4e9a45' },
      { id: 'tuerkis', label: 'Türkis', hex: '#2e9c96' },
      { id: 'blau', label: 'Blau', hex: '#2b3f7a' },
      { id: 'lila', label: 'Lila', hex: '#7a4c9c' },
      { id: 'weiss', label: 'Weiß', hex: '#f4f1ea' },
    ],
    figur: [{ id: 'gerade', label: 'gerade' }, { id: 'taille', label: 'mit Taille' }],
    muetze: [{ id: 'nein', label: 'keine' }, { id: 'muetze', label: 'Mütze' },
             { id: 'cap', label: 'Cap' }],
    muetzenfarben: [
      { id: 'rot', label: 'Rot', hex: '#be3430' },
      { id: 'senf', label: 'Senf', hex: '#d6a430' },
      { id: 'gruen', label: 'Grün', hex: '#468248' },
      { id: 'blau', label: 'Blau', hex: '#2e4e8c' },
      { id: 'grau', label: 'Grau', hex: '#828286' },
      { id: 'schwarz', label: 'Schwarz', hex: '#262428' },
    ],
    oberteilarten: [{ id: 'pulli', label: 'Pullover' }, { id: 'hoodie', label: 'Hoodie' },
                    { id: 'shirt', label: 'T-Shirt' }],
    unterteile: [{ id: 'hose', label: 'Hose' }, { id: 'rock', label: 'Rock' }],
    unterteilfarben: [
      { id: 'jeans', label: 'Jeans', hex: '#5676a8' },
      { id: 'dunkelblau', label: 'Dunkelblau', hex: '#28305a' },
      { id: 'schwarz', label: 'Schwarz', hex: '#242226' },
      { id: 'grau', label: 'Grau', hex: '#7d7d82' },
      { id: 'beige', label: 'Beige', hex: '#c8b086' },
      { id: 'braun', label: 'Braun', hex: '#704c32' },
    ],
    tiere: [{ id: 'keins', label: 'keins' }, { id: 'hund', label: 'Hund' },
            { id: 'katze', label: 'Katze' }],
    felle: [
      { id: 'schwarz', label: 'Schwarz', hex: '#1e1a1a' },
      { id: 'weiss', label: 'Weiß', hex: '#f4f1ea' },
      { id: 'grau', label: 'Grau', hex: '#8c8c8c' },
      { id: 'creme', label: 'Creme', hex: '#e8d3a8' },
      { id: 'rotbraun', label: 'Rotbraun', hex: '#c0652f' },
      { id: 'dunkelbraun', label: 'Dunkelbraun', hex: '#4a2e1f' },
    ],
  }; }
  /* <<< GAMING-BAUKASTEN */

  /* 🔴 SCHRITT II IST FÜR ALLE VIER KONZEPTE AUS (14.08.2026).
     Bis dahin galt das nur für C1. Bei A1/A5/A8 stand dort „Look und Farbe"
     mit vier Reglern — Look (hell/dunkel), Grundton, Akzentton, Rand —, und
     KEINER davon erreichte das Backend: sie landeten ausschließlich in den
     Cart-Properties. Der Kunde konnte „dunkel + Petrol" wählen und bekam ein
     cremefarbenes Blatt, während die Bestellzeile „Look: dunkel, Grundton:
     petrol" trug.
     Seit der Freischaltung wäre es zusätzlich ein ZWEITES Grundton-Feld auf
     derselben Seite — die „zwei Hüllen"-Bauform, nur sichtbar für den Kunden.
     Der Look lebt jetzt vollständig im Brief (oben), also dort, wo er ins
     Backend geht. Akzent und Rand waren ebenfalls folgenlos: der Akzent wird
     in Stufe 1 aus dem Text abgeleitet (das ist die dokumentierte Stärke des
     Verfahrens), einen Rand kennt keiner der vier Bautypen.
     ⚠️ Die Konstante bleibt stehen, damit ein späteres Konzept mit echten
     Optik-Achsen sie wieder einschalten kann — sie ist heute nur leer. */
  const OPTIK = {
    'orts-print': false, 'icon-grid': false,
    'momentaufnahme': false, 'weg-chronik': false,
    'wortschatz': false, 'jahreszahl': false, 'zitat': false,
    'gaming': false,
    'haustier': false, 'pferd': false, 'rezept': false,
    'strecke': false, 'wanderung': false,
    'linie': false,             // Linien-Seite (28.10.2026): Farbe ist der Marker im Formular
    'portraet': false,          // Porträt (29.10.2026): wie Linie
  };
  const optikSichtbar = () => OPTIK[D.produkt.handle] !== false;

  /* --- Der Steg: JEDES Konzept bietet ihn an (19.08.2026) ------------------
     🔴 DIE RAND-WAHL WAR BESTELLT UND IST AM 14.08.2026 MIT DER OPTIK-HÜLLE
     UNTERGEGANGEN. Sascha am 31.07.2026, nach seinem eigenen Einwand („es
     gibt genug Leute, die einen gerahmten Print mit Rand möchten"):
     „der Rand wird eine Kundenwahl in drei Stufen — randlos / schmal / breit
     — aus EINEM Render. Bedingung: randlos heißt BESCHNITTEN."
     Die Begründung der Abschaltung („einen Rand kennt keiner der vier
     Bautypen") stimmte für den damaligen Code — sie hat die Funktion aber
     abgeräumt statt sie zu bauen. Gebaut ist sie seit heute:
     `postergen.steg_anlegen` legt den Rand am fertigen Blatt an, und das
     Fulfillment liest die Property `Rand`.

     🔴 HIER STAND EINE LISTE, UND SASCHA HAT SIE AM 19.08.2026 GESTRICHEN.
     Sie nahm ORTS-PRINT (C1) aus, weil der GEMALTE Rand dort seit dem
     07.08.2026 Kanon ist und derselbe Eintrag lautete: „Konfigurator ohne
     Rand-Wahl bei C1 — der Rand ist im Bild". Vorgelegt am Musterbogen (vier
     Konzepte × drei Stufen), Saschas Entscheidung, wörtlich:

         „B, ich würde das dem Nutzer überlassen und einfach konsistent
          anbieten."

     Damit ist die 07.08.-Ausnahme aufgehoben — NICHT der gemalte Rand selbst.
     Der bleibt Kanon und wird weiter so gerendert; hinzu kommt nur, dass der
     Kunde zusätzlich einen unbedruckten Steg wählen DARF. Wer „breit" auf C1
     wählt, bekommt einen weißen Rand um einen gemalten — das ist seither
     seine Entscheidung, nicht unsere.

     🔴 UND ES GIBT KEINE LISTE MEHR, das ist der zweite Teil derselben
     Entscheidung. „Konsistent anbieten" heißt: ein fünftes Konzept ist
     automatisch dabei, statt auf einen Eintrag zu warten, den jemand
     vergisst. Eine Sonderregel je Konzept war genau das, was hier weg sollte.
     ⚠️ Wer den Steg für ein Konzept doch sperren will, baut die Ausnahme neu
     — und ändert damit eine Sascha-Entscheidung vom 19.08.2026. */
  /* 🔴 KIDS OHNE RAND-BLOCK (⚑ 09.09.2026, reversibel). Wortschatz und
     Jahreszahl tragen das Passepartout — ein Rand ums Motiv AUS dem Blatt,
     im Setzer gesetzt. Der Steg („Rand") ist dasselbe Versprechen ein
     zweites Mal, und im Druck legte `fulfillment` den Steg zusätzlich AUF
     das Passepartout (`steg_anlegen` läuft nach dem Kids-Zweig). Seit das
     Passepartout in Schritt II steht, stünden beide nebeneinander. Ohne
     Property »Rand« druckt `fulfillment` randlos — der Rückfall dort ist
     genau dafür gebaut. Alle anderen Konzepte: unverändert. */
  /* ⏪ 30.09.2026 (Sascha): der Rand gilt jetzt auch für das ZITAT. Es war
     das einzige Konzept ohne jede Wahl — weder Rand noch Passepartout.
     Ausgenommen bleiben nur die Kids-Konzepte, deren Passepartout-Achse die
     Rolle des Randes übernimmt (Wortschatz, Jahreszahl) — dort wären Rand
     und Passepartout zwei weiße Ränder übereinander (Entscheidung 09.09.2026).
     Das Fulfillment legt den Rand für jede Zeile mit Property `Rand` an
     (`druckdatei_bauen`, `postergen.steg_anlegen`), also auch fürs Zitat. */
  /* ⏪ 20.10.2026: Wortschatz-Pop hat kein Passepartout mehr — es bekommt den
     Rand wie das Zitat („konsistent anbieten", Sascha 19.08.2026). */
  const MIT_PASSEPARTOUT = new Set(['jahreszahl']);
  /* 🆕 22.10.2026 abends: Wortschatz „Gemalt" (`bildlich`) hat wieder sein Passepartout — dort
     kein Rand, sonst zwei weiße Ränder übereinander und im Druck beides (code-pruefer, BELEGT). */
  const randSichtbar = () => !MIT_PASSEPARTOUT.has(D.produkt.handle)
    && !(D.produkt.handle === 'wortschatz' && s.brief.look === 'bildlich');

  /* Anteil der BLATTBREITE, ringsum gleich — dieselben Werte wie
     `postergen.STEG_STUFEN`. 🔴 Zweitkopie einer Zahl, und sie ist hier
     unvermeidbar: das Theme kennt die Pipeline zur Bauzeit nicht. Wer eine
     Stufe ändert, greppt nach der anderen — sonst zeigt die Vorschau einen
     anderen Rand, als gedruckt wird, und der Kunde sieht es erst auf Papier. */
  /* ⏪ 22.09.2026 (Sascha, Option A am Raster): 6/12 → 4/8 %. Druck-Kopie in
     `postergen.STEG_STUFEN`, nur zusammen ändern. */
  const STEG_STUFEN = { randlos: 0, schmal: 4, breit: 8 };
  /* Zeichen für die Linien-Knöpfe der Weg-Chronik (22.10.2026 abends): drei Orte, lose bzw. in
     der Reihenfolge verbunden. Inline, damit es keine Bilddatei braucht. */
  const LINIEN_PUNKTE = '<circle cx="5" cy="16" r="2.4"/><circle cx="14" cy="5" r="2.4"/><circle cx="23" cy="13" r="2.4"/>';
  const LINIEN_ZEICHEN = {
    linien_nein: `<svg class="option__zeichen" viewBox="0 0 28 20" aria-hidden="true" fill="currentColor">${LINIEN_PUNKTE}</svg>`,
    linien_ja: `<svg class="option__zeichen" viewBox="0 0 28 20" aria-hidden="true" fill="currentColor">${LINIEN_PUNKTE}`
      + '<path d="M5 16 Q8 7 14 5 Q20 6 23 13" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>',
  };

  const GESCHLECHTER = [['', 'bitte wählen'], ['weiblich', 'weiblich'],
                        ['maennlich', 'männlich'], ['neutral', 'neutral']];

  function briefDef() {
    return BRIEFE[D.produkt.handle] || BRIEFE['icon-grid'];
  }

  /* --- Ein runder Marker ----------------------------------------------------
     Der Kreis IST die Auskunft, das Wort steht daneben für Screenreader und
     für den Fall, dass jemand „Salbei" sucht statt es zu sehen.

     🔴 NIE EIN HÄKCHEN AUF DEM KREIS — dieselbe Regel wie bei den Swatches
     (`echoa-pdp.css`): es überdeckt genau die Farbe, die beurteilt werden
     soll. Gewählt ist ein Ring mit Luft.

     ⚠️ `art: 'bunt'` malt KEINE eigene Farbe, sondern die vier Akzente aus
     `D.akzente` als Kreissegmente. Ein erfundener Bunt-Ton hier wäre ein
     Produktfarbwert in der Oberfläche und damit ein I4-Bruch (`marke/kanon.md`);
     die Akzente kommen aus dem `marke:auto`-Block der PDP-Section. */
  function markerKnopf(feldname, o) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'marker';
    b.dataset.brieffeld = feldname;
    b.dataset.wert = o.id;
    b.setAttribute('aria-pressed', 'false');

    let stil = '';
    let klasse = 'marker__kreis';
    if (o.art === 'bunt') {
      const toene = (D.akzente || []).map((a) => a.hex);
      if (toene.length) {
        const stueck = 100 / toene.length;
        const stops = toene
          .map((h, i) => `${h} ${(i * stueck).toFixed(2)}% ${((i + 1) * stueck).toFixed(2)}%`)
          .join(', ');
        stil = `--verlauf: conic-gradient(from 210deg, ${stops})`;
      }
      klasse += ' marker__kreis--bunt';
    } else {
      stil = `--farbe: ${o.hex || 'transparent'}`;
      if (o.art === 'creme') klasse += ' marker__kreis--hell';
    }

    b.innerHTML = `<span class="${klasse}" style="${attr(stil)}" aria-hidden="true"></span>
      <span class="marker__name">${escape(o.label)}</span>`;
    return b;
  }

  /* --- Listenzeilen wachsen auf Anforderung --------------------------------
     Sichtbar sind beim Laden `start` Zeilen (die Pflichtzahl), die übrigen
     stehen versteckt im DOM. `zeilenOeffnen` zeigt so viele, wie gebraucht
     werden, und blendet den „+"-Knopf aus, sobald alle stehen.

     ⚠️ NIE WIEDER SCHLIESSEN. Eine Zeile, die der Kunde geholt hat,
     verschwindet nicht mehr — auch nicht, wenn er sie wieder leert. Ein Feld,
     das unter der Hand verschwindet, sieht wie Datenverlust aus, und der
     leere Zustand ist ohnehin folgenlos (leere Zeilen fallen beim Sammeln
     heraus). */
  function zeilenOeffnen(halter, f, anzahlSoll) {
    const gruppe = halter.querySelector(`[data-zeilen][data-feldname="${f.name}"]`);
    if (!gruppe) return;
    const zeilen = Array.from(gruppe.querySelectorAll('.briefzeile'));
    const sichtbar = zeilen.filter((z) => !z.hidden).length;
    const soll = Math.min(Math.max(sichtbar, anzahlSoll), zeilen.length);
    zeilen.forEach((z, i) => { if (i < soll) z.hidden = false; });
    const knopf = halter.querySelector(`[data-mehr="${f.name}"]`);
    if (knopf) knopf.hidden = soll >= zeilen.length;
  }

  /** Blendet die Jahres-Spalte einer Liste ein oder aus.
      🔴 BEIM AUSSCHALTEN WERDEN DIE FELDER GELEERT. Sonst reiste eine
      Jahreszahl unsichtbar mit in die Bestellung — der Kunde hat den Schalter
      umgelegt, weil er die Jahre NICHT will, und bekäme sie trotzdem aufs
      Blatt. Ein verstecktes Feld, das noch einen Wert trägt, ist dieselbe
      Klasse wie eine Regel an zwei Orten: was man nicht sieht, prüft man
      nicht nach. */
  function jahrSchalterSetzen(halter, feldname, an) {
    const schalter = halter.querySelector(`[data-jahrschalter="${feldname}"]`);
    const gruppe = halter.querySelector(`[data-zeilen][data-feldname="${feldname}"]`);
    if (!schalter || !gruppe) return;
    schalter.setAttribute('aria-pressed', String(Boolean(an)));
    gruppe.classList.toggle('feldgruppe--mit-jahr', Boolean(an));
    gruppe.querySelectorAll(`[data-feld="${feldname}_jahre"]`).forEach((el) => {
      /* tabindex: ein ausgeblendetes Feld darf die Tabulator-Reihenfolge
         nicht mitnehmen — sonst springt der Fokus in ein unsichtbares Feld. */
      el.tabIndex = an ? 0 : -1;
      if (!an) el.value = '';
    });
    /* Mit Jahresfeld werden die Textfelder schmaler: Höhe neu messen (30.10.2026). */
    requestAnimationFrame(() => gruppe.querySelectorAll('[data-waechst]').forEach(wachsen));
  }

  /* 🔴 DER BRIEF WOHNT SEIT DEM 09.09.2026 IN ZWEI CONTAINERN: `[data-brief]`
     (Schritt I) und `[data-brief-ausfuehrung]` (Schritt II, für Felder mit
     `schritt: 'ausfuehrung'`). Alles, was den Brief LIEST — sammeln,
     Sichtbarkeit, Pflichtprüfung, Zurückschreiben, Zeilen öffnen — geht
     über diesen Helfer, der beide Container wie einen behandelt. Wer wieder
     `$('[data-brief]')` greift, übersieht Schritt II still: der Wert wäre
     weder im Brief noch in der Bestellzeile. */
  function briefHalter() {
    /* 🆕 22.10.2026: dritter Container `[data-brief-feinschliff]` — die gesetzten Felder, die
       erst nach dem Andruck erscheinen (`ABLAUF.nachher`). */
    const teile = ['[data-brief]', '[data-brief-feinschliff]', '[data-brief-ausfuehrung]']
      .map((sel) => $(sel)).filter(Boolean);
    if (!teile.length) return null;
    return {
      querySelector: (sel) => {
        for (const t of teile) { const e = t.querySelector(sel); if (e) return e; }
        return null;
      },
      querySelectorAll: (sel) => teile.flatMap((t) => Array.from(t.querySelectorAll(sel))),
    };
  }

  /* ---------- Ort ⇄ Moment auf EINER Seite (Saschas T1 »A«, 20.10.2026) ----------
     Wie im Klick-Dummy: „Nur der Ort | Wir zwei im Bild" über dem Formular. Der Schalter
     tauscht IN DER SEITE Produkt, Varianten und Felder — kein Sprung zur anderen PDP.
     Belegt, dass das trägt: beide Shopify-Produkte haben dieselben 16 Varianten (Ausführung ×
     Rahmen) zu identischen Preisen (gemessen über /products/*.js, 20.10.2026); der Warenkorb
     legt über `findeVariante()` die Variante des gewählten Produkts. Ort, Jahr und Machart
     (Farbig/Dunkel mit Ton) gehen mit. Die Galerie links geht seit 21.10.2026 mit
     (`galerieTauschen`) — vorher blieb sie die der Einstiegsseite, und das Lissabon-Blatt des
     Orts stand neben den Moment-Kacheln (Sascha am Live-Screenshot).
     Die Adresse wechselt mit (replaceState): ein Neuladen landet auf demselben Produkt. */
  const ORT_MOMENT = { 'orts-print': 'momentaufnahme', momentaufnahme: 'orts-print' };
  /* 🔴 SCHALTER (Saschas T1 27.10.2026, „Variante 3 — drei Seiten: Ort, Paar am Ort, Paar als Linie").
     AUS (false, heute live) = der Schalter Ort ⇄ Moment wie seit 20.10. AN = kein Schalter; jede Seite steht
     für sich, unter dem Formular verweisen Links auf die Nachbarseiten (`QUERVERWEISE`). Gemessen an den
     Schritt-Ereignissen 22.–27.10.2026 (interne Besuche nicht herausgefiltert): 17 von 202 Ort/Moment-Sitzungen
     wechselten, und 7 von 8 Sitzungen mit Moment-Andruck kamen über einen Wechsel — der Querverweis ersetzt
     also einen Weg, der genutzt wird, und steht deshalb sichtbar über dem Andruck-Knopf, nicht im Fuß.
     AN schaltet `shop/live-linie-seite.sh`, zusammen mit der Linien-Seite. */
  const DREI_SEITEN_AN = true;
  const QUERVERWEISE = {
    'orts-print': [['momentaufnahme', 'Lieber ihr zwei im Bild, an eurem Ort?']],
    momentaufnahme: [['linie', 'Lieber nur ihr zwei, als Linie?'], ['orts-print', 'Lieber nur euer Ort?']],
    linie: [['momentaufnahme', 'Lieber mit eurem Ort im Bild?']],
  };
  /* ⏪ 30.10.2026 aus (Sascha live: „störend und führen zum Abbruch des Entwurfs … keine Querverweise mehr, der
     User soll fokussiert bleiben"). Die Liste oben bleibt als Herkunft stehen. */
  const QUERVERWEISE_AN = false;
  function querverweiseZeichnen(halter) {
    const ziele = DREI_SEITEN_AN && QUERVERWEISE_AN ? QUERVERWEISE[D.produkt.handle] : null;
    if (!ziele || !halter) return;
    const p = document.createElement('p');
    p.className = 'querverweis';
    p.innerHTML = ziele.map(([h, text]) => `<a href="/products/${attr(h)}">${escape(text)}</a>`).join('');
    halter.appendChild(p);
  }
  /* Spiegel der Nennzeit im PDP-Liquid (`dauer_sekunden`, Block „Nennzeit je Produkt"). */
  const ORT_MOMENT_DAUER = { 'orts-print': 55, momentaufnahme: 50 };
  /* Saschas Wunsch (20.10.2026): erst der Ort für BEIDE, dann der Schalter, dahinter, was nur
     zum gewählten Konzept gehört (Orts-Print: Was darf nicht fehlen + Foto; Moment: der Moment
     + Namen), zuletzt die Machart. Der Schalter steht vor dem ersten Feld nach dem Jahr. */
  const ORT_MOMENT_GRUPPEN = {
    'orts-print': { ort: 'Der Ort', look: 'Machart' },
    momentaufnahme: { ort: 'Der Ort', moment: 'Ihr zwei', look: 'Machart' },
  };
  const ORT_MOMENT_REIHENFOLGE = {
    'orts-print': ORTS_KLAPPE_AN ? ['ort', 'jahr', 'ortsfoto', 'muss_rein', 'look', 'stimmung', 'tinte']
      : ['ort', 'jahr', 'muss_rein', 'ortsfoto', 'look', 'stimmung', 'tinte'],
    momentaufnahme: PAARFOTO_AN ? ['look', 'grund', 'paarfoto', 'ort', 'moment', 'namen', 'jahr']
      : ['ort', 'jahr', 'moment', 'namen', 'look', 'grund'],
  };
  /* ⏪ 20.10.2026 abends: der Schalter stand kurz nach dem Jahr. Sascha: „doch oben lassen,
     weil er die gesamte PDP umschaltet, auch die Überschrift". Reihenfolge bleibt: Ort zuerst,
     beim Moment dann Moment, dann Namen. */
  const ORT_MOMENT_SCHALTER_VOR = { 'orts-print': 'ort', momentaufnahme: 'ort' };
  function ortMomentFelder(felder) {
    const reihe = ORT_MOMENT_REIHENFOLGE[D.produkt.handle] || [];
    const rang = (f) => { const i = reihe.indexOf(f.name); return i < 0 ? reihe.length : i; };
    return felder.slice().sort((a, b) => rang(a) - rang(b));
  }

  /* 🆕 EIN ABLAUF FÜR ALLE PRODUKTSEITEN (Saschas T1 »B«, 22.10.2026; Konzept im Wiki
     [[echoa_eingabe_und_galerie]]). Vor dem Andruck steht nur, was GEMALT wird: 1 · der
     Inhalt (ein Upload immer zuerst), 2 · die Machart. Was nur GESETZT wird, wandert in den
     Block „Deine Texte" (`[data-brief-feinschliff]`), der mit Format und Rahmen erst nach dem
     Andruck erscheint. Anlass, gemessen am Live-Shop (Handy, 390 px): „Andruck erstellen" lag
     2,1 bis 4,2 Bildschirmhöhen tief, beim Pferd hinter 7 Feldern und 15 Knöpfen, und keine
     zwei Seiten hatten dieselbe Reihenfolge.
       reihe    Reihenfolge in Schritt I; nicht genannte Felder bleiben hinten in ihrer Ordnung.
       gruppen  [Überschrift, [Felder]] — die Überschrift steht vor dem ersten dieser Felder,
                das es auf der Seite gibt (Haustier ohne Machart-Schalter: »machart« statt »stil«).
       nachher  Felder für den Block nach dem Andruck.
       schritte [Titel, [Felder]] — 🆕 Stufe 2 (Saschas T1, 22.10.2026): die Maske zeigt vor dem ersten
                Andruck immer nur EINEN Schritt (`schritteZeichnen`); nicht genannte Felder gehören zum
                letzten Schritt. Der Titel jedes Schritts ist zugleich seine Überschrift.
     🔴 IN `nachher` DARF NUR STEHEN, WAS OHNE NEUEN RENDER GESETZT WIRD (`HAUSTIER_SATZ_FELDER`,
     `REZEPT_SATZ_FELDER`, `STRECKE_SATZ_FELDER`, `TEXT_SATZ`, `KARTEN_FELDER`) UND OHNE EINGABE
     GÜLTIG IST (optional oder mit Vorwahl). Sonst sperrte ein Feld, das der Kunde vor dem
     Andruck gar nicht sieht, den Knopf — oder seine Änderung danach verwürfe den bezahlten
     Andruck. Gegenprobe: `theme/ablauf-selbsttest.py` (code-gate). Pflichtfelder wie der Name
     bleiben vorn, auch wenn sie gesetzt werden: ohne sie gäbe es keinen Andruck.
     Pixel-Paar bleibt beim eigenen Einstieg mit Figuren-Editor — der IST schon Schritt 1. */
  const ABLAUF = {
    /* 🆕 MACHART ZUERST (Saschas T1 »A«, 26.10.2026, Stufe 1): die Machart bestimmt, ob ein Foto
       nötig ist (nur Magazin bearbeitet genau das Kundenfoto). ⏪ Bis 26.10.2026 kam erst das Tier
       mit „Ohne Foto weiter", dann die Machart — wer ohne Foto weiterging, traf im zweiten Schritt
       auf die vorgewählte Magazin-Kachel und eine rote Meldung zu einem Schritt, der schon hinter
       ihm lag. Jetzt meldet sich „Magazin braucht ein Foto" im Foto-Schritt selbst, und dort lässt
       es sich heilen: Foto hochladen ODER eine Machart ohne Foto antippen (`fotoZeichnen`). */
    haustier: {
      schritte: [['1 · Machart', ['stil', 'styling', 'machart']],
        ['2 · Dein Tier', ['foto', 'art', 'rasse', 'fell', 'ohren', 'merkmal', 'name',
          'eigenheit_1', 'eigenheit_2', 'eigenheit_3', 'eigenheit_4', 'familie']]],
      reihe: ['stil', 'styling', 'machart', 'foto', 'art', 'rasse', 'fell', 'ohren', 'merkmal', 'name',
        'eigenheit_1', 'eigenheit_2', 'eigenheit_3', 'eigenheit_4', 'familie'],
      gruppen: [['1 · Machart', ['stil', 'machart']], ['2 · Dein Tier', ['foto']]],
      nachher: ['look', 'titelfarbe', 'fusszeile', 'seit', 'zeile', 'geschlecht'],
    },
    linie: {
      schritte: [['1 · Machart', ['stil']], ['2 · Ihr zwei', ['paarfoto']]],
      reihe: ['stil', 'paarfoto', 'look', 'name', 'zeile'],
      gruppen: [['1 · Machart', ['stil']], ['2 · Ihr zwei', ['paarfoto']]],
      nachher: ['look', 'name', 'zeile'],
    },
    portraet: {
      schritte: [['1 · Machart', ['stil']], ['2 · Euer Foto', ['paarfoto']]],
      reihe: ['stil', 'paarfoto', 'look', 'name', 'zeile'],
      gruppen: [['1 · Machart', ['stil']], ['2 · Euer Foto', ['paarfoto']]],
      nachher: ['look', 'name', 'zeile'],
    },
    pferd: {
      schritte: [['1 · Machart', ['stil', 'styling', 'machart']],
        ['2 · Dein Pferd', ['foto', 'rasse', 'fell', 'merkmal', 'name',
          'eigenheit_1', 'eigenheit_2', 'eigenheit_3', 'eigenheit_4']]],
      reihe: ['stil', 'styling', 'machart', 'foto', 'rasse', 'fell', 'merkmal', 'name',
        'eigenheit_1', 'eigenheit_2', 'eigenheit_3', 'eigenheit_4'],
      gruppen: [['1 · Machart', ['stil', 'machart']], ['2 · Dein Pferd', ['foto']]],
      nachher: ['look', 'titelfarbe', 'geschlecht', 'stockmass', 'stall', 'seit', 'zeile',
        'fusszeile', 'besitzer'],
    },
    rezept: {
      schritte: [['1 · Dein Gericht', ['karte', 'gericht']], ['2 · Machart', ['machart', 'bild']],
        ['3 · Rezepttext', ['titel', 'zutaten', 'bedeutung_1', 'bedeutung_2', 'bedeutung_3']]],
      /* Reihenfolge = Schritte (code-pruefer 22.10.2026: Titel und Zutaten standen vor der Machart). */
      reihe: ['karte', 'gericht', 'machart', 'bild', 'titel', 'zutaten',
        'bedeutung_1', 'bedeutung_2', 'bedeutung_3'],
      gruppen: [['1 · Dein Rezept', ['karte']], ['2 · Machart', ['machart']]],
      nachher: ['look', 'von', 'seit', 'zubereitung', 'synonym', 'familie'],
    },
    strecke: {
      schritte: [['1 · Deine Strecke', ['datei', 'beschreibung']]],
      reihe: ['datei', 'beschreibung'],
      gruppen: [['1 · Deine Strecke', ['datei']]],
      nachher: ['zeit', 'namen', 'ort', 'distanz', 'datum', 'unterzeile'],
    },
    wanderung: {
      schritte: [['1 · Deine Wanderung', ['beschreibung']]],
      reihe: ['beschreibung'],
      gruppen: [['1 · Deine Wanderung', ['beschreibung']]],
      nachher: ['titel', 'namen', 'distanz', 'datum', 'unterzeile'],
    },
    'icon-grid': {
      schritte: [['1 · Eure Symbole', ['namen', 'momente']], ['2 · Hintergrund', ['look']]],
      reihe: ['namen', 'momente', 'look'],
      gruppen: [['1 · Eure Symbole', ['namen']], ['2 · Hintergrund', ['look']]],
      nachher: [],
    },
    'weg-chronik': {
      schritte: [['1 · Eure Orte', ['namen', 'stationen']], ['2 · Hintergrund', ['look']]],
      reihe: ['namen', 'stationen', 'look'],
      gruppen: [['1 · Eure Orte', ['namen']], ['2 · Hintergrund', ['look']]],
      nachher: ['verbindungslinien'],
    },
    wortschatz: {
      schritte: [['1 · Das Wort', ['wort', 'bedeutung', 'kind_und_alter']], ['2 · Machart', ['look', 'hintergrund', 'muster']]],
      reihe: ['wort', 'bedeutung', 'kind_und_alter', 'look', 'hintergrund', 'muster'],
      gruppen: [['1 · Das Wort', ['wort']], ['2 · Machart', ['look']]],
      nachher: ['anlass'],
    },
    zitat: {
      schritte: [['1 · Der Satz', ['satz', 'kind_und_alter']], ['2 · Poster', ['poster']]],
      reihe: ['satz', 'kind_und_alter', 'poster'],
      gruppen: [['1 · Der Satz', ['satz']], ['2 · Poster', ['poster']]],
      nachher: ['anlass'],
    },
    /* Ort und Moment ordnen über `ORT_MOMENT_REIHENFOLGE` (der Schalter steht dazwischen);
       hier stehen nur die Überschriften und das Jahr, das gesetzt wird. */
    'orts-print': {
      gruppen: [['1 · Der Ort', ['ort']], ['2 · Machart', ['look']]], nachher: ['jahr'],
      schritte: [['1 · Der Ort', ORTS_KLAPPE_AN ? ['ort', 'ortsfoto', 'muss_rein'] : ['ort', 'muss_rein', 'ortsfoto']],
        ['2 · Machart', ['look', 'stimmung', 'tinte']]],
    },
    momentaufnahme: PAARFOTO_AN ? {
      /* Eine Seite ohne „Weiter" (Saschas »A«, 27.10.2026): ein Schritt mit allem, was das fertige Poster braucht
         — Machart, Foto, Ort, Namen (Titel), Jahr (Unterzeile). ⏪ Namen und Jahr standen zuerst NACH dem Entwurf;
         Sascha: „Nur so kann doch überhaupt ein fertiges Poster erzeugt werden." Änderbar bleiben sie danach
         ohne neuen Render (`TEXT_SATZ.momentaufnahme`). */
      gruppen: [['Machart', ['look']], ['Ihr zwei', ['paarfoto']], ['Euer Ort', ['ort']], ['Auf dem Poster', ['namen']]],
      nachher: [],
      schritte: [['Euer Moment', ['look', 'grund', 'paarfoto', 'ort', 'moment', 'namen', 'jahr']]],
    } : {
      gruppen: [['1 · Der Ort', ['ort']], ['2 · Ihr zwei', ['moment']], ['3 · Machart', ['look']]],
      nachher: ['jahr'],
      schritte: [['1 · Der Ort', ['ort']], ['2 · Ihr zwei', ['moment', 'namen']], ['3 · Machart', ['look', 'grund']]],
    },
    /* Pixel-Paar steht bewusst NICHT hier: seine Maske (`gamingMaskeZeichnen`) baut aus den
       Feldern in `[data-brief]` einen eigenen Editor — ein Feld in einem anderen Container
       fiele dort still heraus. */
  };
  /* EINE SEITE (Probe 27.10.2026, Saschas Auftrag zur finalen Prüfung des Nutzerflusses: „bei jedem Konzept
     eine Maske mit einer Seite oder zumindest so wenigen Schritten wie möglich"). AN legt alle Schritte eines
     Produkts zu EINEM zusammen: kein „Weiter", die Felder stehen untereinander, am Ende „Andruck erstellen".
     Die Texte (`nachher`) bekommen dann keinen eigenen Schritt, sie stehen als „Auf dem Poster" vor dem Andruck
     (Sascha, 28.10.2026). Reihenfolge, Überschriften und Klappblock: `EINE_SEITE`.
     AN seit Saschas T1 »Live schalten« (28.10.2026, am Vorschau-Theme 210938003786 gesehen). ⏪ Bis dahin geführte Maske
     (seine T1 vom 22.10.2026): ein Schritt offen, „Weiter", Schrittleiste — mit `false` kommt sie unverändert zurück. */
  const EINE_SEITE_AN = true;
  /* Muster der Moment-Seite (Sascha, 28.10.2026): „Styling und Foto zuerst" · alles, was aufs Poster kommt, auch die
     Texte, auf derselben Seite („nur so erhält der Kunde eine fertige Ansicht") · was nicht nötig ist, eingeklappt.
       reihe    ersetzt `ABLAUF.reihe` (beim Orts-Print `ORT_MOMENT_REIHENFOLGE`): Machart vor Foto vor dem Rest.
       gruppen  Überschriften ohne Nummer — die Reihenfolge ist jetzt eine andere als in den Schritten.
       aufsPoster  Felder, die aus dem Formular nach „Auf dem Poster" wandern: der Name steht bei seiner Farbe (Sascha
                28.10.2026: „Name steht über dem Abschnitt … getrennt von den wählbaren Farben. Macht hier keinen Sinn").
                Nur Felder, die ohne neuen Render gesetzt werden (`HAUSTIER_SATZ_FELDER`).
       mehr     OPTIONALE Felder in den Klappblock „Mehr aufs Poster" (`eineSeiteKlappen`); ein Pflichtfeld wird nie
                eingeklappt, auch wenn es hier steht. */
  /* ⏪ 30.10.2026 abends (Sascha: „einheitliches Template … trotzdem wieder nicht konsistent umgesetzt“): `mehr` stand nur
     bei 6 von 13 Produkten gefüllt — Haustier, Pferd (Stall, Zeile), Zitat, Wortschatz, Orts-Print, Moment, Strecke und Rezept
     zeigten optionale TEXTfelder offen. Jetzt überall eingeklappt. Bewusst offen bleiben optionale Felder, die mitgemalt werden
     (Moment „Was macht ihr?“, Uploads wie Rezeptkarte und Strecken-Datei). */
  const EINE_SEITE = {
    haustier: { gruppen: [['Machart', ['stil', 'machart']], ['Dein Tier', ['foto']]],
      mehr: ['seit', 'fusszeile', 'zeile', 'eigenheit_3', 'eigenheit_4'], aufsPoster: ['name'] },
    linie: { gruppen: [['Machart', ['stil']], ['Ihr zwei', ['paarfoto']]], mehr: ['zeile'], aufsPoster: ['name'] },
    portraet: { gruppen: [['Machart', ['stil']], ['Euer Foto', ['paarfoto']]], mehr: ['zeile'], aufsPoster: ['name'] },
    pferd: { gruppen: [['Machart', ['stil', 'machart']], ['Dein Pferd', ['foto']]],
      mehr: ['seit', 'fusszeile', 'stall', 'zeile', 'stockmass', 'besitzer', 'eigenheit_3', 'eigenheit_4'],
      aufsPoster: ['name'] },
    rezept: {
      reihe: ['machart', 'bild', 'karte', 'gericht', 'titel', 'zutaten', 'bedeutung_1', 'bedeutung_2', 'bedeutung_3'],
      gruppen: [['Machart', ['machart']], ['Dein Rezept', ['karte']]],
      /* »von« und »zubereitung« bleiben offen: die Rezeptkarte füllt sie vor (unsicher Gelesenes muss sichtbar sein),
         und ohne Zubereitung bleibt das Blatt zu ~40 % leer (code-pruefer 30.10.2026). */
      mehr: ['seit', 'synonym', 'familie', 'bedeutung_1', 'bedeutung_2', 'bedeutung_3'],
    },
    strecke: { gruppen: [['Deine Strecke', ['datei']]], mehr: ['zeit', 'distanz', 'datum', 'unterzeile', 'namen', 'ort'] },
    wanderung: { gruppen: [['Deine Wanderung', ['beschreibung']]], mehr: ['titel', 'namen', 'distanz', 'datum', 'unterzeile'] },
    /* Überall „Machart" als erste Überschrift, beim Zitat „Motiv" — ⏪ bis 28.10.2026 abends „Hintergrund" bzw. „Poster",
       beim Zitat stand dann „Poster" über „Auf dem Poster" (Durchsicht, Saschas »A«). */
    'icon-grid': { reihe: ['look', 'namen', 'momente'], gruppen: [['Machart', ['look']], ['Eure Symbole', ['namen']]], mehr: [] },
    'weg-chronik': { reihe: ['look', 'namen', 'stationen'], gruppen: [['Machart', ['look']], ['Eure Orte', ['namen']]], mehr: [] },
    wortschatz: {
      reihe: ['look', 'hintergrund', 'muster', 'wort', 'bedeutung', 'kind_und_alter'],
      gruppen: [['Machart', ['look']], ['Das Wort', ['wort']]], mehr: ['anlass'],
    },
    zitat: { reihe: ['poster', 'satz', 'kind_und_alter'], gruppen: [['Motiv', ['poster']], ['Der Satz', ['satz']]], mehr: ['anlass'] },
    'orts-print': {
      /* `ORTS_KLAPPE_AN`: erst der Ort, dann das Foto, direkt darunter die Klappe ohne Foto (Saschas »C«). */
      reihe: ORTS_KLAPPE_AN ? ['look', 'stimmung', 'tinte', 'ort', 'ortsfoto', 'muss_rein']
        : ['look', 'stimmung', 'tinte', 'ortsfoto', 'ort', 'muss_rein'],
      gruppen: [['Machart', ['look']], ['Euer Ort', [ORTS_KLAPPE_AN ? 'ort' : 'ortsfoto']]], mehr: ['jahr'],
    },
    /* Moment (Durchsicht 28.10.2026 abends, Saschas »A«): seine Seite ist schon eine (`ABLAUF.momentaufnahme`,
       `PAARFOTO_AN`), hatte aber weder das Band oben am Handy noch die Meldung am Feld — beides hängt an `eineSeite()`.
       Reihenfolge und Überschriften bleiben die eigenen (kein `reihe`, kein `gruppen`). Ohne Paarfoto nicht dabei. */
    ...(PAARFOTO_AN ? { momentaufnahme: { mehr: ['jahr'] } } : {}),
  };
  const eineSeite = () => (EINE_SEITE_AN ? EINE_SEITE[D.produkt.handle] || null : null);
  /* Alle fünf Macharten von Haustier/Pferd in EINER Reihe statt 3 + 2, ohne Zusatzzeile (402 → 100 px). Sascha am Bild,
     28.10.2026: „in einer Reihe". Greift nur mit `EINE_SEITE_AN`. */
  const EINE_SEITE_MACHART_REIHE = true;
  const ablauf = () => {
    const a = ABLAUF[D.produkt.handle] || {};
    if (!EINE_SEITE_AN || !a.schritte) return a;
    const e = eineSeite() || {};
    return { ...a, ...(e.reihe ? { reihe: e.reihe } : {}), ...(e.gruppen ? { gruppen: e.gruppen } : {}),
      schritte: [['Dein Poster', a.schritte.flatMap(([, f]) => f)]] };
  };
  const istNachher = (f) => (ablauf().nachher || []).includes(f.name);
  function ablaufFelder(felder) {
    const reihe = ablauf().reihe;
    if (!reihe) return felder;
    const rang = (f) => { const i = reihe.indexOf(f.name); return i < 0 ? reihe.length : i; };
    /* `sort` ist stabil: nicht genannte Felder behalten untereinander ihre Ordnung. */
    return felder.slice().sort((a, b) => rang(a) - rang(b));
  }
  /* 🆕 STUFE 2: DIE GEFÜHRTE MASKE (Saschas T1, 22.10.2026: „mach dann asap mit Stufe 2 weiter";
     Vorbild das Pferd-Bild vom Vormittag, `pipeline/output/pdp-konzept-1022/konzept-pferd.png`).
     Vor dem ersten Andruck dieser Seitenansicht zeigt die Maske nur EINEN Schritt: oben die
     Schrittleiste, darunter der offene Schritt, erledigte Schritte als eine Zeile „✓ … · Ändern",
     am Ende „Weiter zu …" — erst im letzten Schritt stehen Hinweis-Satz und „Andruck erstellen".
     Anlass: auch nach Stufe 1 scrollte der Kunde am Handy alle Schritte auf einmal durch (Pferd
     2,9 Bildschirmhöhen bis zum Knopf), und die Wirkung seiner Wahl lag außerhalb des Bildes.
     🔴 NUR VOR DEM ERSTEN ANDRUCK. Danach (und bei Rückkehr mit Entwurf, `?entwurf=`) ist das Formular
     wie in Stufe 1 — „Deine Angaben" klappt es zu, und ein Kunde, der nachbessert, sucht seine Felder
     nicht hinter Schritten. Der Merker `schritteAus` kippt in `zeichne()` und kippt nie zurück.
     ⚠️ Zu ist eine KLASSE (`brieffeld--schritt-zu`), nicht `hidden`: `hidden` heißt für `brieffehler()`
     „gilt nicht", und das Andruck-Prüfen muss alle Schritte sehen. „Weiter" prüft nur die Felder
     seines Schritts — über dasselbe `brieffehler(nur)`, keine zweite Prüfung. */
  let schrittAktiv = 0;
  let schritteAus = false;
  let eineSeiteFotoGezeichnet = false;
  function schritteListe() {
    const sch = ablauf().schritte;
    if (!sch || istGaming()) return null;
    const vorn = briefDef().felder.filter((f) => !istNachher(f)).map((f) => f.name);
    const da = new Set(vorn);
    const liste = sch.map(([titel, namen]) => ({ titel, namen: namen.filter((n) => da.has(n)) }))
      .filter((x) => x.namen.length);
    if (!liste.length) return null;
    const genannt = new Set(liste.flatMap((x) => x.namen));
    liste[liste.length - 1].namen.push(...vorn.filter((n) => !genannt.has(n)));
    /* „Auf dem Blatt" (22.10.2026 abends): ab DREI sichtbaren gesetzten Feldern ein eigener letzter
       Schritt „Texte" — darunter (Ort, Moment, Wortschatz, Zitat: ein Feld) steht der Block im
       letzten Schritt mit. Sichtbar ist er so oder so nur im letzten Schritt (`maske-vor-ende`).
       Die Felder liegen in `[data-brief-feinschliff]`, nicht in `[data-brief]` — der Schritt hat
       deshalb keine eigenen Feld-Halter, die `schritteZeichnen` auf- und zuklappt. */
    const texte = (ablauf().nachher || []).filter((n) => {
      const w = $(`[data-brief-feinschliff] [data-brieffeld-halter="${n}"]`);
      return w && !w.hidden;
    });
    if (texte.length >= 3 && !EINE_SEITE_AN) liste.push({ titel: `${liste.length + 1} · Texte`, namen: texte, texte: true });
    return liste;
  }
  /** Was in einem erledigten Schritt steht, als eine Zeile (wie „Deine Angaben"). */
  function schrittWerte(wraps) {
    const teile = [];
    wraps.forEach((w) => {
      if (w.hidden) return;
      if (w.querySelector('[data-fotofeld]') && foto.id && ['ok', 'hauptmotiv'].includes(foto.status)) teile.push('Foto ✓');
      if (w.querySelector('[data-karte-bild]:not([hidden]), [data-ortfoto-bild]:not([hidden])')) teile.push('Foto ✓');
      w.querySelectorAll('textarea, input[type="text"], input:not([type])').forEach((e) => {
        if (e.value.trim() && !e.closest('[hidden]')) teile.push(e.value.trim());
      });
      /* Ohne die Markierung je Ort (●/⌂/♥): sie stünde in jeder Zeile und sagt in der Zeile nichts. */
      w.querySelectorAll('select:not(.echoa-feld--marke):not([data-chip-liste])').forEach((e) => {
        const o = e.options[e.selectedIndex];
        if (e.value && o && !e.closest('[hidden]')) teile.push(o.textContent.trim());
      });
      w.querySelectorAll('[aria-pressed="true"]').forEach((b) => {
        if (b.closest('.kombi--verdeckt') || b.matches('[data-foto-ohne]')) return;   // Knöpfe unter der Machart-Reihe, „Ohne Foto“
        const n = b.querySelector('.stilkachel__name, .marker__name');
        const x = ((n ? n.textContent : b.textContent) || '').trim();
        if (x) teile.push(x);
      });
    });
    const text = teile.join(' · ');
    /* 90 Zeichen: nur die Kürzung der Zeile (zwei Zeilen am Handy), kein Datenmaß. */
    return text.length > 90 ? `${text.slice(0, 89)}…` : text;
  }
  function schritteZeichnen() {
    const halter = $('[data-brief]');
    if (!halter || !wurzel) return;
    const liste = schritteListe();
    const an = Boolean(liste) && !schritteAus && s.phase === 'leer' && !s.kandidatId;
    /* 🔴 NUR NEU BAUEN, WENN SICH WAS ÄNDERT (code-pruefer 22.10.2026, in Chrome nachgestellt): jedes
       „change" beim Verlassen eines Feldes lief hier durch und ersetzte den „Weiter"-Knopf, den der
       Kunde gerade antippte — der erste Tipp ging verloren. Die Signatur deckt alles, was die Knöpfe
       und Zeilen tragen; Tippen im offenen Schritt ändert sie nicht. */
    const sig = an ? JSON.stringify([schrittAktiv, liste.map((x) => x.titel),
      liste.map((x, i) => (i < schrittAktiv
        ? schrittWerte(x.namen.map((n) => halter.querySelector(`[data-brieffeld-halter="${n}"]`)).filter(Boolean))
        : ''))]) : '';
    if (an && halter.dataset.schrittSig === sig && halter.querySelector('[data-schrittleiste]:not([hidden])')) return;
    halter.dataset.schrittSig = sig;
    halter.querySelectorAll('[data-schritt-zeile], [data-schritt-weiter]').forEach((e) => e.remove());
    let leiste = halter.querySelector('[data-schrittleiste]');
    wurzel.classList.toggle('maske-schritte', an);
    if (!an) {
      halter.querySelectorAll('.brieffeld--schritt-zu').forEach((w) => w.classList.remove('brieffeld--schritt-zu'));
      if (leiste) leiste.hidden = true;
      wurzel.classList.remove('maske-vor-ende', 'maske-eine-seite');
      /* Nach dem Andruck wie vorher: der Klappblock „Mehr aufs Poster" löst sich auf, seine Felder stehen
         wieder offen (code-pruefer 28.10.2026 — sonst lagen sie hinter einem zweiten Tipp). */
      document.querySelectorAll('[data-eine-seite-mehr]').forEach((d) => {
        d.querySelectorAll(':scope > [data-brieffeld-halter]').forEach((w) => d.before(w));
        d.remove();
      });
      return;
    }
    schrittAktiv = Math.max(0, Math.min(schrittAktiv, liste.length - 1));
    if (!leiste) {
      leiste = document.createElement('ol');
      leiste.className = 'schrittleiste';
      leiste.dataset.schrittleiste = '';
      leiste.setAttribute('aria-label', 'Schritte');
      halter.prepend(leiste);
    }
    /* 🆕 22.10.2026 (Sascha: „Der Toggle … beeinflusst die Auswahl, entsprechend sollte der
       Nutzer diese Wahl zuerst treffen"): der Ort⇄Moment-Schalter steht ÜBER der Schrittleiste —
       er wählt, welche Schritte es überhaupt gibt. */
    const om = halter.querySelector(':scope > .ort-moment');
    if (om && om.nextElementSibling !== leiste) halter.prepend(om);
    leiste.hidden = false;
    const punkte = [...liste.map((x) => x.titel.replace(/^\d+ · /, '')), 'Andruck'];
    leiste.innerHTML = punkte.map((titel, i) => {
      const fertig = i < schrittAktiv;
      const aktiv = i === schrittAktiv || (i === liste.length && schrittAktiv === liste.length - 1);
      return `<li class="schrittleiste__punkt${aktiv ? ' ist-aktiv' : ''}${fertig ? ' ist-fertig' : ''}">
        <button type="button" class="schrittleiste__knopf" data-schritt-gehe="${i}"${fertig ? '' : ' disabled'}>
          <span class="schrittleiste__nr" aria-hidden="true">${fertig ? '✓' : i + 1}</span>
          <span class="schrittleiste__wort">${escape(titel)}</span></button></li>`;
    }).join('');
    liste.forEach((x, i) => {
      const wraps = x.namen.map((n) => halter.querySelector(`[data-brieffeld-halter="${n}"]`)).filter(Boolean);
      wraps.forEach((w) => w.classList.toggle('brieffeld--schritt-zu', i !== schrittAktiv));
      x.namen.forEach((n) => halter.querySelector(`[data-kopf-feld="${n}"]`)
        ?.classList.toggle('brieffeld--schritt-zu', i !== schrittAktiv));
      if (x.namen.includes('foto')) {
        halter.querySelector('[data-tier-befund]')?.classList.toggle('brieffeld--schritt-zu', i !== schrittAktiv);
      }
      if (!wraps.length) return;
      if (i < schrittAktiv) {
        const z = document.createElement('button');
        z.type = 'button';
        z.className = 'schritt-zeile';
        z.dataset.schrittZeile = '';
        z.dataset.schrittGehe = String(i);
        z.innerHTML = `<span class="schritt-zeile__titel"><span aria-hidden="true">✓</span> ${escape(x.titel)}</span>
          <span class="schritt-zeile__werte">${escape(schrittWerte(wraps))}</span>
          <span class="schritt-zeile__aendern">Ändern</span>`;
        const kopf = x.namen.map((n) => halter.querySelector(`[data-kopf-feld="${n}"]`)).find(Boolean);
        (kopf || wraps[0]).insertAdjacentElement('beforebegin', z);
      }
      if (i === schrittAktiv && i < liste.length - 1) {
        const w = document.createElement('div');
        w.className = 'schritt-weiter';
        w.dataset.schrittWeiter = '';
        w.innerHTML = `<p class="feld-hilfe schritt-weiter__fehler" data-schritt-fehler role="alert" hidden></p>
          <button type="button" class="echoa-aktion schritt-weiter__knopf" data-schritt-vor="${i + 1}">
            Weiter zu ${escape(liste[i + 1].titel)}</button>`;
        wraps[wraps.length - 1].insertAdjacentElement('afterend', w);
      }
    });
    wurzel.classList.toggle('maske-vor-ende', schrittAktiv < liste.length - 1);
    wurzel.classList.toggle('maske-eine-seite', EINE_SEITE_AN);   // keine Schrittleiste (echoa-pdp.css)
    /* Eine Seite: das Foto-Feld ist von Anfang an sichtbar, ohne „Weiter" (das sonst `fotoZeichnen` ruft).
       Einmal nachziehen, sobald die Machart-Knöpfe stehen — sonst stand bei vorgewähltem Magazin
       „Ohne Foto weiter" statt der Macharten ohne Foto (Handy-Probe 27.10.2026). */
    if (EINE_SEITE_AN && istHaustier() && !eineSeiteFotoGezeichnet) { eineSeiteFotoGezeichnet = true; fotoZeichnen(); }
    wachsenAlle();   // der offene Schritt ist jetzt sichtbar — Textfelder auf ihren Inhalt
  }
  /** Zum Schritt `i` — vorwärts nur, wenn die Schritte davor vollständig sind. */
  function schrittGehe(i) {
    const liste = schritteListe();
    if (!liste) return;
    if (i > schrittAktiv) {
      for (let k = schrittAktiv; k < i; k++) {
        sammleBrief();
        const m = brieffehler(liste[k].namen);
        if (m) {
          const f = $('[data-schritt-fehler]');
          if (f) { f.textContent = m; f.hidden = false; }
          return;
        }
      }
    }
    schrittAktiv = i;
    schritteZeichnen();
    schrittHinweisPruefen();
    if (istHaustier()) fotoZeichnen();   // Foto-Schritt: Magazin-Alternativen nach der gewählten Machart
    /* Den neuen Schritt oben ins Bild — samt Überschrift, unter dem festen Kopf. */
    const namen = liste[Math.min(i, liste.length - 1)].namen;
    const ziel = liste[Math.min(i, liste.length - 1)].texte ? $('[data-am-blatt]')
      : namen.map((n) => $(`[data-brief] [data-kopf-feld="${n}"]`)).find(Boolean)
        || $(`[data-brief] [data-brieffeld-halter="${namen[0]}"]`);
    /* Messung „Machart erreicht" (22.10.2026): am Schritt, der die Machart trägt — nicht an der Nummer. */
    if (namen.some((n) => ['stil', 'look', 'poster', 'machart'].includes(n))) schrittMelden('machart');
    if (ziel) {
      const y = ziel.getBoundingClientRect().top + window.scrollY - (einspaltig() ? 16 : 110);
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }
  }

  /** Überschrift je Feldname — vor dem ersten Feld jeder Gruppe, das es hier gibt. */
  function ablaufUeberschriften(felder) {
    const da = new Set(felder.filter((f) => !istNachher(f)).map((f) => f.name));
    const aus = {};
    /* Eine Seite: die Überschriften der Gruppen, nicht der eine Sammelschritt „Dein Poster" — sonst
       fehlten „1 · Machart" usw., und `schrittBeobachten` meldete „machart" schon an „Dein Poster"
       (code-pruefer 27.10.2026). */
    ((EINE_SEITE_AN ? null : ablauf().schritte) || ablauf().gruppen || []).forEach(([titel, namen]) => {
      const erstes = namen.find((n) => da.has(n));
      if (erstes) aus[erstes] = titel;
    });
    return aus;
  }
  const ortMomentProdukte = {};

  function ortMomentSchalter() {
    const box = document.createElement('div');
    box.className = 'ort-moment';
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', 'Wer ist im Bild');
    [['orts-print', 'Ein Ort'], ['momentaufnahme', 'Wir zwei im Bild']].forEach(([h, text]) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'ort-moment__knopf';
      b.textContent = text;
      b.setAttribute('aria-pressed', String(D.produkt.handle === h));
      b.addEventListener('click', () => {
        produktWechseln(h).catch((e) => {
          console.warn('[echoa] Wechsel Ort/Moment gescheitert', e);
          zeigeMeldung('Das hat gerade nicht geklappt – bitte noch einmal tippen.');
        });
      });
      box.appendChild(b);
    });
    return box;
  }

  /* Die Dunkel-Kachel zeigt den gewählten Ton (Sascha, 20.10.2026: die Vorschau soll sich
     „direkt über den Knöpfen ändern") — dasselbe Bild wie das Ton-Beispiel der Bühne. */
  /* Schlüssel der Ton-Beispiele (`D.tonbeispiele`): der Moment mit Paarfoto zeigt das Paar groß (»a5p«). */
  const tonBautyp = (handle) => (PAARFOTO_AN && handle === 'momentaufnahme' ? 'a5p' : BAUTYP_JE_HANDLE[handle]);
  function stilKachelnTon() {
    if (!ORTS_MASKE_AN || !ORT_MOMENT[D.produkt.handle]) return;
    const bautyp = tonBautyp(D.produkt.handle);
    const dunkel = zweigVon(D.produkt.handle);
    const ton = s.brief.tinte || s.brief.grund || '';
    const kachel = wurzel.querySelector(`.stilkachel[data-brieffeld="look"][data-wert="${dunkel}"] img`);
    if (!kachel) return;
    const def = (briefDef().felder.find((f) => f.name === 'look' && f.typ === 'stil')?.optionen || [])
      .find((o) => o.id === dunkel);
    const url = (ton && (D.tonbeispiele || {})[`${bautyp}_${dunkel}_${ton}`])
      || (D.stilbilder || {})[def?.bild] || '';
    if (url && kachel.getAttribute('src') !== url) kachel.setAttribute('src', url);
  }

  /* Kacheln und Tafeln der Galerie auf das Produkt `ziel` (Bildsätze aus
     `D.ort_moment_galerie`, Liquid). Das große Blatt setzt `produktWechseln` selbst — dort
     steht die Sperre gegen das Überschreiben eines eigenen Entwurfs. Die Raum-Montage geht
     IMMER mit: hier wird nur das SHOP-Bild der Montage getauscht. ⏪ Bis 21.10.2026 trug die
     Montage nie das Kundenmotiv; seither setzt `raumPosterSetzen()` es in Phase `fertig` darüber
     und merkt sich das hier gesetzte Shop-Bild als Rückfall. Nach Ort → Moment → Ort mit
     wiederhergestelltem Entwurf hing sonst das Moment-Blatt in den Räumen des Orts-Prints. */
  function galerieTauschen(ziel) {
    const g = (D.ort_moment_galerie || {})[ziel];
    if (!g) return;
    const setze = (img, url) => {
      if (!img || !url || img.getAttribute('src') === url) return;
      img.removeAttribute('srcset');
      img.setAttribute('src', url);
    };
    setze(document.querySelector('.pdp__kachel[data-ansicht="blatt"] img'), g.blatt_kachel);
    Object.entries(g.raum || {}).forEach(([r, url]) => {
      setze(document.querySelector(`.pdp__kachel[data-ansicht="raum-${r}"] img`), url);
      setze(document.querySelector(`[data-tafel="raum-${r}"] [data-raum-beispiel]`), url);
      setze(document.querySelector(`[data-tafel="raum-${r}"] [data-raum-poster] img`), g.raum_poster);
    });
    setze(document.querySelector('.pdp__kachel[data-ansicht="detail"] img'), g.detail);
    setze(document.querySelector('[data-tafel="detail"] img'), g.detail);
    /* Machart-Kacheln gehören zum Einstieg (Ort und Moment haben seit 21.10.2026 keine):
       beim anderen Produkt weg, sonst zeigte „Farbig — Beispiel" das falsche Konzept. */
    const eigene = ziel === START_HANDLE;
    document.querySelectorAll('.pdp__kachel[data-machartkachel]').forEach((k) => { k.hidden = !eigene; });
    galerieHandle = ziel;
  }

  async function produktWechseln(ziel) {
    const von = D.produkt.handle;
    if (ziel === von || ORT_MOMENT[von] !== ziel) return;
    /* Nicht mitten im Andruck — sonst gehörte das Ergebnis zu einem Produkt, das nicht mehr
       auf der Seite steht. */
    if (s.phase === 'laeuft') return;
    if (!ortMomentProdukte[von]) {
      ortMomentProdukte[von] = { produkt: { ...D.produkt }, varianten: D.varianten.slice(),
                                 dauer: D.dauer_sekunden };
    }
    if (!ortMomentProdukte[ziel]) {
      const r = await fetch(`/products/${ziel}.js`, { headers: { Accept: 'application/json' } });
      if (!r.ok) throw new Error(`Produkt ${ziel}: HTTP ${r.status}`);
      const p = await r.json();
      ortMomentProdukte[ziel] = {
        produkt: { id: p.id, titel: p.title, handle: p.handle },
        varianten: p.variants.map((v) => ({ id: v.id, titel: v.title, preis: v.price,
                                            verfuegbar: v.available, optionen: v.options })),
        dauer: ORT_MOMENT_DAUER[ziel] || D.dauer_sekunden,
      };
    }
    /* Zweiter Riegel NACH dem Laden (code-pruefer 20.10.2026, BELEGT): während `fetch` lief,
       konnte „Andruck erstellen" schon gestartet sein — dann gehörte der Entwurf zum alten
       Produkt, der Warenkorb läge im neuen. */
    if (s.phase === 'laeuft' || D.produkt.handle !== von) return;
    sammleBrief();
    const alt = { ...s.brief };
    const neu = ortMomentProdukte[ziel];
    /* 🔴 Varianten nur tauschen, wenn sie dieselben Titel tragen — sonst läge im Warenkorb
       eine andere Größe oder ein anderer Rahmen als gewählt. */
    const titel = (liste) => liste.map((v) => v.titel).sort().join('|');
    if (titel(neu.varianten) !== titel(D.varianten)) {
      throw new Error(`Varianten von ${von} und ${ziel} passen nicht zusammen`);
    }
    D.produkt = { ...neu.produkt };
    D.varianten.splice(0, D.varianten.length, ...neu.varianten);
    D.dauer_sekunden = neu.dauer;
    const dunkel = Boolean(alt.look) && alt.look !== 'kontrolle';
    const ton = alt.tinte || alt.grund || '';
    const uebernahme = { ort: alt.ort || '', jahr: alt.jahr || '',
                         look: dunkel ? zweigVon(ziel) : 'kontrolle' };
    if (dunkel && ton) uebernahme[ziel === 'orts-print' ? 'tinte' : 'grund'] = ton;
    s.kandidatId = null;
    s.kandidat = null;
    s.antworten = [];
    /* Das Ortsfoto gehört zum Orts-Print und geht beim Wechsel NICHT mit (code-pruefer
       20.10.2026, BELEGT: sonst ritt ein angenommenes Foto unsichtbar und nicht entfernbar in
       den nächsten Andruck). */
    ortfoto = { id: '', status: 'leer', meldung: '', hinweis: '', bild: '' };
    ortfotoNr++;   /* eine noch laufende Prüfung verwerfen, wie „Foto entfernen" (code-pruefer R2) */
    paarfoto = { id: '', status: 'leer', text: '', bild: '', paar: null, offen: false, ohne: false };
    paarfotoNr++;
    baueBrief();
    briefEinsetzen(uebernahme);
    $$('[data-waechst]').forEach(wachsen);
    eingabeGeaendert();
    grundtoeneSetzen();
    historieZeichnen();
    zeichne();
    /* Die Bühne: ein Beispiel des NEUEN Produkts, nie über einem eigenen Entwurf. Danach wie
       nach einem Klick an Farbe/Stil — ein dunkler Moment zeigt so sein Ton-Beispiel. */
    const blatt = document.querySelector('[data-tafel="blatt"] .buehne__bild');
    const start = (D.ort_moment_start || {})[ziel];
    if (blatt && start && !/\/api\/kandidat\//.test(blatt.src)
        && !(BACKEND && blatt.src.startsWith(BACKEND))) {
      blatt.removeAttribute('srcset');
      blatt.src = start;
      buehneStart = start;
      beispielAufBlatt = false;
    }
    galerieTauschen(ziel);
    stilKachelnTon();
    ansichtWechseln('blatt');
    markerKlick = true;
    try { lookBeispielZeigen(); } finally { markerKlick = false; }
    document.querySelectorAll('.pdp__titel').forEach((t) => { t.textContent = D.produkt.titel; });
    try {
      history.replaceState(history.state, '', `/products/${ziel}${location.search}`);
    } catch { /* ohne Adresswechsel geht es trotzdem */ }
  }

  function baueBrief() {
    const halter = $('[data-brief]');           // hier das ECHTE Element: es wird gebaut
    if (!halter) return;                       // altes Markup ohne Container
    const halterII = $('[data-brief-ausfuehrung]');
    const halterTexte = $('[data-brief-feinschliff]');
    const def = briefDef();
    halter.innerHTML = '';
    if (halterII) halterII.innerHTML = '';
    if (halterTexte) halterTexte.innerHTML = '';
    /* Ort ⇄ Moment auf EINER Seite (Saschas T1 »A«, 20.10.2026): der Schalter steht über
       dem Formular, wie im Klick-Dummy. Nur mit der neuen Maske. */
    const ortMoment = ORTS_MASKE_AN && Boolean(ORT_MOMENT[D.produkt.handle]);
    /* 🆕 22.10.2026: die Schritt-Überschriften gelten für alle Seiten mit `ABLAUF.gruppen`
       (`brief--maske` trägt ihr Aussehen); ohne neue Orts-Maske die alten Gruppen. */
    const mitAblauf = Boolean(ablauf().gruppen || ablauf().schritte) && (!ORT_MOMENT[D.produkt.handle] || ortMoment);
    halter.classList.toggle('brief--maske', ortMoment || mitAblauf);
    const gruppen = mitAblauf ? ablaufUeberschriften(def.felder)
      : (ortMoment ? (ORT_MOMENT_GRUPPEN[D.produkt.handle] || {}) : {});
    /* Eine Seite mit eigener Reihenfolge: der Schalter bleibt oben, vor dem ERSTEN Feld (Sascha 20.10.2026:
       „doch oben lassen") — 'ort' steht dort erst an fünfter Stelle (code-pruefer 28.10.2026). */
    const schalterVor = ortMoment && !DREI_SEITEN_AN
      ? (eineSeite()?.reihe?.[0] || ORT_MOMENT_SCHALTER_VOR[D.produkt.handle]) : null;
    const spaeter = [];   // Labels der Felder, die nach dem Andruck kommen

    (ortMoment && !eineSeite()?.reihe ? ortMomentFelder(def.felder) : ablaufFelder(def.felder)).forEach((f) => {
      if (schalterVor && f.name === schalterVor) halter.appendChild(ortMomentSchalter());
      const wrap = document.createElement('div');
      wrap.className = 'brieffeld';
      /* `hilfeEineSeite`: kürzerer Satz auf der einen Seite ('' = keiner) — dort steht über „Auf dem Poster" schon
         „ohne neuen Entwurf", und jeder Satz kostet am Handy eine Zeile (Saschas »B«, 28.10.2026). */
      const hilfeText = eineSeite() && f.hilfeEineSeite !== undefined ? f.hilfeEineSeite : f.hilfe;
      const hilfe = hilfeText && !f.hilfeUnten ? `<p class="feld-hilfe">${hilfeText}</p>` : '';

      /* Zwei Namensfelder statt einem — das „&" setzt der Code, sonst kommen
         „und", „+" und Tippfehler in die Titelzeile. Geschlecht nur bei A5
         (Figuren im Bild), als echtes Pflichtfeld mit leerer Option. */
      if (f.typ === 'namen') {
        const gesch = (n) => (f.geschlecht
          ? `<select class="echoa-feld" data-feld="geschlecht${n}" aria-label="Geschlecht ${n}">
               ${GESCHLECHTER.map(([v, l]) => `<option value="${v}">${l}</option>`).join('')}
             </select>` : '');
        /* `maxlength` nur, wo eine Setz-Grenze dahintersteht (Gaming: das
           Holzschild, 20 Zeichen je Name, 16.10.2026). */
        const grenzeN = f.maxlength ? ` maxlength="${Number(f.maxlength)}"` : '';
        wrap.innerHTML = `<label class="feld-label">${escape(f.label || 'Namen auf dem Poster')}</label>${hilfe}
          ${f.geschlecht ? '<p class="feld-hilfe">Das Geschlecht wird gebraucht, weil zwei Figuren im Bild stehen.</p>' : ''}
          <div class="feldgruppe feldgruppe--zwei">
            <div><textarea class="echoa-feld" rows="1" data-waechst data-eingabe${grenzeN}
              data-feld="name1" placeholder="Lena" aria-label="Name 1"></textarea>${gesch(1)}</div>
            <div><textarea class="echoa-feld" rows="1" data-waechst data-eingabe${grenzeN}
              data-feld="name2" placeholder="Jonas" aria-label="Name 2"></textarea>${gesch(2)}</div>
          </div>`;
      } else if (f.typ === 'chips') {
        wrap.innerHTML = `<p class="feld-label">${f.label}</p>${hilfe}
          <div class="optionen" role="group" aria-label="${f.label}"></div>`;
        const box = wrap.querySelector('.optionen');
        /* 🆕 `liste` (30.10.2026, Pixel-Paar-Frisur): eine Auswahlliste vor den verborgenen Chips. Sie drückt nur den
           passenden Chip — der Klick-Hörer bleibt der einzige Weg in den Brief. Abgleich zurück: `chipListenAbgleichen`. */
        if (f.liste) {
          const sel = document.createElement('select');
          sel.className = 'echoa-feld echoa-feld--wahl';
          sel.dataset.chipListe = f.name;
          sel.setAttribute('aria-label', f.label);
          sel.innerHTML = f.optionen.map((o) => `<option value="${attr(o.id)}">${escape(o.label)}</option>`).join('');
          sel.addEventListener('change', () => {
            box.querySelector(`[data-wert="${CSS.escape(sel.value)}"]`)?.click();
          });
          box.before(sel);
          box.style.display = 'none';   // `hidden` allein schlägt `.optionen { display: grid }` nicht
        }
        /* 🆕 Pixel-Paar (18.10.2026, Sascha: „Haarfarbe, Haut etc. in der Auswahl visuell
           farbig darstellen"): reine Farbfelder werden runde Farbkreise mit dem Namen darunter. */
        const farbfeld = istGaming() && f.optionen.length > 0 && f.optionen.every((o) => o.hex);
        if (farbfeld) wrap.classList.add('brieffeld--farben');
        f.optionen.forEach((o) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'option';
          b.dataset.brieffeld = f.name;
          b.dataset.wert = o.id;
          b.setAttribute('aria-pressed', 'false');
          /* Swatch statt Wort, wo die Farbe die Wahl ist — Sascha wählt
             Farben am Muster, nicht am Namen (`ventures/echoa/CLAUDE.md`:
             Auswählen ist die schnelle Operation). Der Name bleibt daneben
             stehen, sonst ist der Chip für Screenreader leer. */
          /* ⚠️ Punkt und Label MÜSSEN in einem gemeinsamen Element stehen:
             `.option` ist ein `flex-direction: column`, jedes Kind wird dort
             eine eigene Zeile. Ohne die Hülle säße der Farbpunkt ÜBER dem
             Namen statt daneben. */
          if (farbfeld) {
            b.classList.add('option--farbe');
            b.innerHTML = `<span class="option__kreis" style="--farbe:${o.hex}" aria-hidden="true"></span>
              <span class="option__name">${o.label}</span>`;
            if (o.deaktiviert) b.disabled = true;
            box.appendChild(b);
            return;
          }
          const kopf = o.hex
            ? `<span class="option__zeile"><span class="option__punkt"
                 style="--farbe:${o.hex}" aria-hidden="true"></span>${o.label}</span>`
            : o.zeichen && LINIEN_ZEICHEN[o.zeichen]
              ? `<span class="option__zeile">${LINIEN_ZEICHEN[o.zeichen]}${o.label}</span>`
              : o.label;
          b.innerHTML = `${kopf}${o.hinweis ? `<span class="option__zusatz">${o.hinweis}</span>` : ''}`;
          if (o.deaktiviert) b.disabled = true;
          /* ⏪ 17.08.2026: `data-nur-bei` und `data-gesperrt-hinweis` sind
             hier ERSATZLOS weg (Befund `code-pruefer`, BELEGT). Die Schleife
             in `briefSichtbar()`, die sie las, ist mit der Marker-Umstellung
             durch `briefDef().markerSperre` ersetzt worden — die Attribute
             wurden geschrieben und von niemandem mehr gelesen.
             🔴 Ein totes Attribut ist hier teurer als anderswo: der nächste,
             der einem Chip eine Bedingung mitgibt, bekommt sie STUMM nicht
             durchgesetzt. Die Kombination liefe dann bis ins Backend und
             würde erst nach der Eingabe abgelehnt (`bauplan.pruefe_a5`) —
             genau der Zustand, gegen den die Sperre gebaut war.
             Wer eine chip-eigene Bedingung braucht, baut sie in
             `briefSichtbar()` neben `markerSperre`, nicht hier. */
          box.appendChild(b);
        });
      } else if (f.typ === 'farbmarker' || f.typ === 'marker-solo') {
        /* Runde Marker statt Wort-Chips (Sascha, 17.08.2026). Die Kreise
           stehen alle nebeneinander in EINER Reihe: hell/farbig zuerst, dann
           die Volltöne aus Liste B. */
        const opts = f.typ === 'marker-solo'
          ? LISTE_B().map((t) => ({ id: t.id, label: t.label, hex: t.hex, art: 'vollton' }))
          : f.optionen;
        wrap.innerHTML = `<p class="feld-label">${f.label}</p>${hilfe}
          <div class="marker-reihe" role="group" aria-label="${attr(f.label)}"></div>`;
        const reihe = wrap.querySelector('.marker-reihe');
        opts.forEach((o) => reihe.appendChild(markerKnopf(f.name, o)));
      } else if (f.typ === 'marker') {
        /* Marker mit festen Optionen (Haustier-Looks, 16.10.2026) — dieselben
           Kreise wie `farbmarker`, aber ohne zusammengesetzten Wert. */
        wrap.innerHTML = `<p class="feld-label">${f.label}</p>${hilfe}
          <div class="marker-reihe" role="group" aria-label="${attr(f.label)}"></div>`;
        const reihe = wrap.querySelector('.marker-reihe');
        f.optionen.forEach((o) => reihe.appendChild(markerKnopf(f.name, o)));
      } else if (f.typ === 'foto') {
        wrap.innerHTML = fotoFeldHtml(f, hilfe);
      } else if (f.typ === 'ortsfoto') {
        wrap.innerHTML = ortfotoFeldHtml(f, hilfe);
      } else if (f.typ === 'paarfoto') {
        wrap.innerHTML = paarfotoFeldHtml(f, hilfe);
      } else if (f.typ === 'karte') {
        wrap.innerHTML = karteFeldHtml(f, hilfe);
      } else if (f.typ === 'gpx') {
        wrap.innerHTML = dateiFeldHtml(f, hilfe);
      } else if (f.typ === 'stil') {
        /* Stilkacheln mit Bild — nur dort, wo sich die MACHART ändert und
           nicht bloß die Farbe (heute: C1 farbig gegen Linolschnitt). */
        wrap.innerHTML = `<p class="feld-label">${f.label}</p>${hilfe}
          <div class="stilwahl" role="group" aria-label="${attr(f.label)}"></div>`;
        const box = wrap.querySelector('.stilwahl');
        if (f.spalten) box.style.setProperty('--stil-spalten', String(f.spalten));
        /* Varianten-Reihe (22.10.2026): ALLE Kacheln in EINER Zeile, verkleinert — kein seitliches
           Scrollen (Sascha: „nicht klar, dass die Hintergründe nach rechts weiter gescrollt werden
           können … alternativ verkleinert, so wie beim Zitat"). Für Bilder, deren Unterschied auch
           klein lesbar ist (Accessoire, Farbe, Muster, Spielwelt, Poster), höchstens fünf. */
        if (f.reihe) {
          box.classList.add('stilwahl--reihe');
          box.style.setProperty('--reihe-n', String(f.optionen.length));
          if (f.optionen.length >= 5) box.classList.add('stilwahl--eng');
        }
        f.optionen.forEach((o) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'stilkachel';
          b.dataset.brieffeld = f.name;
          b.dataset.wert = o.id;
          b.setAttribute('aria-pressed', 'false');
          const url = (D.stilbilder || {})[o.bild] || '';
          b.innerHTML = `
            <span class="stilkachel__bild">${url
              ? `<img src="${attr(url)}" alt="" loading="lazy" width="300" height="400">`
              : ''}</span>
            <span class="stilkachel__name"${eineSeite() && o.kurz ? ` data-voll="${attr(o.label)}"` : ''}>${eineSeite() && o.kurz ? escape(o.kurz) : o.umbruch || escape(o.label)}</span>
            ${o.hinweis ? `<span class="stilkachel__zusatz">${escape(o.hinweis)}</span>` : ''}`;
          box.appendChild(b);
        });
      } else if (f.typ === 'liste') {
        /* ⏪ 09.09.2026: Listen ohne Jahr waren am Desktop ZWEISPALTIG
           (`feldgruppe--zwei`), mit Jahr einspaltig — Sascha an der Jahreszahl:
           „je Symbol eine Zeile über die gesamte Breite, so wie bei A1". Jetzt
           immer eine Spalte; A1 sah nur deshalb anders aus, weil es ein Jahr hat. */
        const spalten = '';
        /* 🔴 SICHTBAR SIND NUR `start` ZEILEN (17.08.2026). Der Rest steht im
           DOM und ist `hidden` — nicht ungebaut. Grund: `sammleBrief()` und
           `briefEinsetzen()` arbeiten über den Index der Felder; würden Zeilen
           erst beim Klick entstehen, verschöbe sich die Zuordnung von Ding und
           Jahr zwischen Formular und Historie. Ein verstecktes leeres Feld
           kostet nichts und fällt beim Sammeln ohnehin heraus. */
        /* `startEineSeite`: auf der einen Seite weniger leere Zeilen zu Beginn (Rezept 6 → 3, Saschas »B«, 28.10.2026);
           die übrigen stehen wie immer versteckt im DOM, „Noch eine Zutat" und das Einlesen der Karte zeigen sie. */
        const start = Math.min((eineSeite() && f.startEineSeite) || f.start || f.anzahl, f.anzahl);
        const optional = !f.pflicht
          ? ' <span class="feld-label__optional">(optional)</span>' : '';
        wrap.innerHTML = `<p class="feld-label">${f.label}${optional}</p>
          ${hilfe || `<p class="feld-hilfe">Mindestens ${f.pflicht} ausfüllen.</p>`}
          <div class="feldgruppe${spalten}" data-zeilen data-feldname="${attr(f.name)}"></div>
          <div class="listenknoepfe" data-listenknoepfe></div>`;
        /* `eingeklappt`: der ganze Inhalt liegt hinter einem Knopf (Orts-Print,
           30.09.2026). Steht schon etwas drin (Historie, Adresse), klappt
           `aufklapperNachziehen` von selbst auf.
           ⏪ Zuerst nur in EINE Richtung, weil eine eingeklappte Liste mit
           Inhalt unsichtbar in die Bestellung reiste. Sascha am iPhone,
           30.09. abends: wer nur nachsehen wollte, fühlt sich von den
           Platzhaltern zur Eingabe gedrängt und will zurück. Deshalb jetzt
           „Doch ohne Erinnerungen" — und das Zuklappen LEERT die Felder
           (`zuklappen`), damit die alte Gefahr nicht wiederkommt. */
        if (f.eingeklappt) {
          const inhalt = document.createElement('div');
          inhalt.dataset.aufklappInhalt = f.name;
          inhalt.hidden = true;
          while (wrap.firstChild) inhalt.appendChild(wrap.firstChild);
          wrap.innerHTML = `<button type="button" class="aufklapper"
              data-aufklapper="${attr(f.name)}" aria-expanded="false">
              <span class="aufklapper__zeichen" aria-hidden="true">+</span>
              <span class="aufklapper__text">
                <span class="aufklapper__titel">${escape(f.eingeklappt.knopf)}</span>
                <span class="aufklapper__zusatz">${escape(f.eingeklappt.zusatz || '')}</span>
              </span>
            </button>`;
          inhalt.querySelector('[data-listenknoepfe]').insertAdjacentHTML('beforeend',
            `<button type="button" class="listenknopf" data-zuklapper="${attr(f.name)}">
               <span class="listenknopf__zeichen" aria-hidden="true">−</span>
               ${escape(f.eingeklappt.zu || 'Doch ohne')}
             </button>`);
          wrap.appendChild(inhalt);
        }
        const zeilen = wrap.querySelector('[data-zeilen]');
        for (let i = 0; i < f.anzahl; i++) {
          const z = document.createElement('div');
          z.className = 'briefzeile';
          if (i >= start) z.hidden = true;
          /* Das Jahr steht in einem EIGENEN Feld — im selben Feld wäre es
             Teil des Textes, den das Modell zeichnet (Befund 07.08.). */
          /* „×" nur an Zeilen oberhalb der Pflichtzahl (Sascha, 09.09.2026):
             eine geholte Zeile mit Platzhalter liest sich wie Inhalt, und der
             Kunde fürchtet, der Platzhalter werde mitgerendert. Leere Zeilen
             fallen beim Sammeln ohnehin heraus — das Entfernen ist Bedienbarkeit,
             kein Datenpfad. Die Regel „nie unter der Hand schließen" bleibt:
             geschlossen wird nur auf Klick. */
          /* Nur, wo ein »+« die Zeile zurückholen kann (code-pruefer 09.09.,
             BELEGT an C1: anzahl 3 = start 3, kein »+« — das »×« wäre eine
             Sackgasse bis zum Neuladen). */
          const entfernen = i >= (f.pflicht || 0) && f.anzahl > start
            ? `<button type="button" class="zeile-entfernen" data-zeile-entfernen="${attr(f.name)}"
                 data-index="${i}" aria-label="${attr(f.label)} ${i + 1} entfernen" title="Zeile entfernen">×</button>`
            : '';
          z.innerHTML = `
            <textarea class="echoa-feld" rows="1" data-waechst data-eingabe
              data-feld="${f.name}" data-index="${i}"
              placeholder="${attr(f.platzhalter[i] || '…')}" aria-label="${attr(f.label)} ${i + 1}"></textarea>
            ${f.jahr ? `<input type="text" class="echoa-feld echoa-feld--kurz"
              data-feld="${f.name}_jahre" data-index="${i}" maxlength="9"
              placeholder="Jahr" aria-label="Jahr ${i + 1}" tabindex="-1">` : ''}
            ${f.marke ? `<select class="echoa-feld echoa-feld--marke"
              data-feld="${f.name}_marken" data-index="${i}" aria-label="Markierung ${i + 1}">
                <option value="ring">● Ort</option>
                <option value="haus">⌂ Zuhause</option>
                <option value="herz">♥ Reise</option>
              </select>` : ''}
            ${entfernen}
`;
          zeilen.appendChild(z);
        }
        const knoepfe = wrap.querySelector('[data-listenknoepfe]');
        if (f.anzahl > start) {
          knoepfe.insertAdjacentHTML('beforeend',
            `<button type="button" class="listenknopf" data-mehr="${attr(f.name)}">
               <span class="listenknopf__zeichen" aria-hidden="true">+</span>
               ${escape(f.mehrLabel || 'Noch eine Zeile')}
             </button>`);
        }
        /* 🔴 DAS JAHR IST HINTER EINEM SCHALTER (Sascha, 17.08.2026: „Das
           Jahr ist optional, wirkt aber hier wie ein Pflichtfeld").
           Ein Schalter für die ganze Spalte statt eines Knopfes je Zeile: bei
           sechs Zeilen wären das sechs Bedienelemente für eine Entscheidung,
           die man einmal trifft. */
        if (f.jahr) {
          knoepfe.insertAdjacentHTML('beforeend',
            `<button type="button" class="listenknopf" aria-pressed="false"
                     data-jahrschalter="${attr(f.name)}">
               <span class="listenknopf__zeichen" aria-hidden="true">+</span>
               ${escape(f.jahrLabel || 'Jahreszahlen ergänzen')}
             </button>`);
        }
      } else {
        const el = f.typ === 'text-lang' ? 'textarea' : 'input';
        /* „(optional)" steht AM LABEL, nicht in einem Hilfetext darunter.
           Ein leeres Feld liest sich als unerledigte Aufgabe; das korrigiert
           nur, was im selben Blick steht. */
        const zusatz = f.optional
          ? ' <span class="feld-label__optional">(optional)</span>' : '';
        /* `maxlength` nur, wo eine SETZ-Grenze dahintersteht (heute: die
           Widmung des Jahreszahl-Posters, 44 Zeichen gemessen). Der Browser
           schneidet dann ab, statt dass der Kunde nach dem Absenden eine
           Fehlermeldung liest — der Riegel im Backend bleibt trotzdem stehen,
           denn eine `maxlength` ist eine Bitte, keine Zusage. */
        const grenze = f.maxlength ? ` maxlength="${Number(f.maxlength)}"` : '';
        wrap.innerHTML = `<label class="feld-label">${f.label}${zusatz}</label>${hilfe}
          <${el} ${el === 'input' ? 'type="text"' : 'rows="3"'}${grenze}
            class="echoa-feld${el === 'textarea' ? ' echoa-feld--lang' : ''}${f.kurz ? ' echoa-feld--kurz' : ''}${f.mittel ? ' echoa-feld--mittel' : ''}"
            data-eingabe ${el === 'textarea' ? 'data-waechst' : ''}
            data-feld="${f.name}" placeholder="${attr(f.platzhalter || '')}"></${el}>`;
      }
      if (f.hilfe && f.hilfeUnten) {
        wrap.insertAdjacentHTML('beforeend', `<p class="feld-hilfe feld-hilfe--unten">${f.hilfe}</p>`);
      }
      /* `klappe` (Orts-Print, `ORTS_KLAPPE_AN`): das Feld steht in einer Klappe nach Muster `.anders`. */
      if (f.klappe) {
        wrap.innerHTML = `<details class="anders ohne-klappe" data-feld-klappe><summary class="anders__kopf">
            <span class="anders__titel">${escape(f.klappe.titel)}</span>
            <span class="anders__zusatz">${escape(f.klappe.zusatz)}</span></summary>
          <div class="anders__inhalt">${wrap.innerHTML}</div></details>`;
      }
      /* Die Überschrift steht VOR dem Feld, nicht in ihm (code-pruefer 22.10.2026): beim Rezept-Lexikon
         ist der Titel ausgeblendet, und mit ihm verschwand „3 · Rezepttext". `data-kopf-feld` sagt
         der Schritt-Ansicht, zu welchem Schritt sie gehört. */
      let kopf = null;
      if (gruppen[f.name] && !(istNachher(f) && halterTexte)) {
        kopf = document.createElement('p');
        kopf.className = 'brief-gruppe';
        kopf.dataset.kopfFeld = f.name;
        kopf.textContent = gruppen[f.name];
      }
      wrap.dataset.brieffeldHalter = f.name;
      /* Felder mit `schritt: 'ausfuehrung'` gehören in Schritt II. Fehlt der
         Container (altes Markup), landen sie in Schritt I — sichtbar falsch
         statt still verloren. Dasselbe für `ABLAUF.nachher` und den Texte-Block. */
      if (istNachher(f) && halterTexte) {
        halterTexte.appendChild(wrap);
        spaeter.push(f.label || f.name);
      } else {
        const ziel = f.schritt === 'ausfuehrung' && halterII ? halterII : halter;
        if (kopf) ziel.appendChild(kopf);
        ziel.appendChild(wrap);
      }
    });
    /* „Auf dem Blatt" (22.10.2026 abends): die gesetzten Texte stehen VOR dem Andruck über dem
       Knopf (`[data-am-blatt]`), nach dem Andruck zugeklappt. Die Überschrift gilt nur vorher —
       nachher trägt die Zusammenfassung des Klappblocks den Titel (`echoa-pdp.css`).
       ⏪ Bis heute abend hier „Deine Texte" (nur nach dem Andruck) und darunter in Schritt I der
       Satz „… wählst du nach dem Andruck – kostenlos" (`spaeterSatzZeichnen`, jetzt ohne Ziel). */
    if (spaeter.length && halterTexte) {
      halterTexte.insertAdjacentHTML('afterbegin', eineSeite()
        ? `<p class="brief-gruppe am-blatt__vorher" data-kopf-texte>Auf dem Poster</p>
           <p class="feld-hilfe am-blatt__vorher">Steht so auf deinem Entwurf – nach dem Andruck jederzeit änderbar, ohne neuen Entwurf.</p>`
        : `<p class="brief-gruppe am-blatt__vorher" data-kopf-texte>Auf dem Blatt</p>
         <p class="feld-hilfe am-blatt__vorher">Alles optional – du kannst es nach dem Andruck jederzeit ändern, ohne neuen Entwurf.</p>`);
    }
    eineSeiteKlappen(halter, halterTexte);
    const sicht = briefHalter();
    /* 🔴 VORWAHL, damit kein Pflichtfeld leer startet. Der Look ist Pflicht;
       ohne Vorwahl bliebe der Knopf grau, ohne dass der Kunde sähe warum —
       und bei C1 war „Farbig" bisher stillschweigend der einzige Zustand.
       Vorgewählt ist immer der ERSTE Marker bzw. die erste Stilkachel, und
       das ist überall die Kontrollfassung (hell/farbig).
       Die Tinte (`marker-solo`) wird NICHT vorgewählt: sie ist erst sichtbar,
       wenn der Schnitt gewählt ist, und dort ist die Farbe die eigentliche
       Entscheidung. Ein vorgewählter Vollton wäre eine Bestellung, die
       niemand getroffen hat. */
    let ausUrlGewaehlt = false;    // hat ein `urlVorwahl` gegriffen? → Bühne unten
    briefDef().felder.forEach((f) => {
      /* 🔴 EIN PFLICHTFELD OHNE VORWAHL SPERRT DEN KNOPF, OHNE ES ZU SAGEN.
         Beim Look ist die Vorwahl immer der erste Chip (die Kontrollfassung).
         Die zwei Kids-Achsen tragen dagegen eine BENANNTE Vorwahl. Seit dem
         30.09.2026 ist das beim Passepartout „randlos" (Sascha, Option A:
         alle Konzepte starten ohne Rahmen, Rand, Passepartout). ⏪ Vorher
         „breit mit feiner Kante" (07.09.2026) — NICHT wiederherstellen, das
         ist abgelöst. Die Reihenfolge randlos → schmal → breit ist eine Skala
         und soll es bleiben. `vorwahl` trennt damit „was steht vorne" von „was ist
         gewählt", statt die eine Frage über die andere zu beantworten. */
      if (f.name !== 'look' && !f.vorwahl) return;
      const gruppe = sicht.querySelectorAll(`[data-brieffeld="${f.name}"]`);
      /* `urlVorwahl`: ein Wert aus der Adresse ersetzt die Vorwahl, aber nur,
         wenn es ihn als wählbaren Chip gibt — wie bei `?look=` wählt die URL
         nur vor und greift an keinem Riegel vorbei. Unbekannt → Vorwahl. */
      let vorwahl = f.vorwahl;
      if (f.urlVorwahl) {
        let ausUrl = '';
        try {
          ausUrl = (new URLSearchParams(window.location.search).get(f.urlVorwahl)
                    || '').trim().toLowerCase();
        } catch { ausUrl = ''; }
        if (ausUrl && Array.from(gruppe).some((b) => b.dataset.wert === ausUrl && !b.disabled)) {
          if (ausUrl !== vorwahl) ausUrlGewaehlt = true;
          vorwahl = ausUrl;
        }
      }
      const ziel = vorwahl
        ? Array.from(gruppe).find((b) => b.dataset.wert === vorwahl && !b.disabled)
        : sicht.querySelector(`[data-brieffeld="${f.name}"]:not([disabled])`);
      if (ziel) ziel.setAttribute('aria-pressed', 'true');
    });
    /* Reihenfolge: erst den Wunsch LESEN, dann die Sichtbarkeit rechnen —
       `briefSichtbar()` löst ihn am Ende selbst ein, sobald er baubar ist.
       Ihn hier direkt zu setzen war die erste Fassung, und sie wurde von der
       Sperre eine Zeile später wieder kassiert (Befund oben). */
    querverweiseZeichnen(halter);
    paarfotoZeichnen();
    lookWunschLesen();
    const lookAusAdresse = lookWunsch;
    briefSichtbar();
    sammleBrief();
    /* 🆕 22.10.2026 (Anzeigen-Session, Saschas Kernregel „jede Wahl zeigt sich auf der Bühne"): auch
       `?look=` zeigt sein Beispiel, wenn es beim LADEN von der Vorwahl abweicht (Moment Dunkel aus
       der Anzeige stand sonst farbig da). Der Riegel vom 10.09.2026 bleibt für Tastendrucke: hier
       greift nur der einmalige Wert aus der Adresse, und nur, wenn er eingelöst wurde. */
    if (lookAusAdresse && !lookWunsch) {
      const gedrueckt = sicht.querySelector('[data-brieffeld="look"][aria-pressed="true"]');
      const erster = sicht.querySelector('[data-brieffeld="look"]:not([disabled])');
      /* Das Startbild zeigt den Look des ersten Knopfs. ⏪ 30.10.2026 mittags stand hier kurz „die
         Kontrollfassung" (Moment: Dunkel vorne, oben farbig); seit Saschas »A, Dunkel oben« zeigt der Moment
         oben Dunkel (`einstieg_blatt`), und der erste Knopf stimmt wieder überall. `?look=kontrolle` beim
         Moment zeigt so das farbige Blatt (`stilBeispielUrl`, `a5s_farbig`). */
      if (gedrueckt && erster && gedrueckt !== erster && gedrueckt.dataset.wert === lookAusAdresse) ausUrlGewaehlt = true;
    }
    /* 🔴 Wählt die ADRESSE eine andere Option vor (Anzeige → `?machart=illustration`),
       zeigt die Bühne deren Beispiel wie nach einem Klick (22.10.2026, Saschas T1 »A«:
       sonst sah der Klick aus der Creme-Anzeige oben weiter das Magazin-Blatt).
       Nur `urlVorwahl` — `?look=` bleibt beim Riegel vom 10.09.2026 (`markerKlick`). */
    if (ausUrlGewaehlt) {
      markerKlick = true;
      try { lookBeispielZeigen(); } finally { markerKlick = false; }
    }
  }

  /* --- Bedingte Felder: Ton nur beim zweiten Look, Aussparung nur wo sie
     baubar ist -------------------------------------------------------------
     🔴 EINE Stelle, die beide Richtungen zieht. Die erste Fassung dieses
     Konfigurators hätte den Grundton dauerhaft angezeigt; ein Feld, das
     folgenlos dasteht, ist genau der Zustand, den Schritt II vier Regler lang
     hatte. Und ein Chip, der eine nicht baubare Kombination anbietet, führt
     den Kunden in einen Backend-Fehler NACH der Eingabe. */
  function aufklappen(name, { fokus = false } = {}) {
    const halter = briefHalter();
    const inhalt = halter?.querySelector(`[data-aufklapp-inhalt="${name}"]`);
    if (!inhalt || !inhalt.hidden) return;
    inhalt.hidden = false;
    const knopf = halter.querySelector(`[data-aufklapper="${name}"]`);
    if (knopf) { knopf.hidden = true; knopf.setAttribute('aria-expanded', 'true'); }
    if (fokus) inhalt.querySelector('textarea, input')?.focus();
  }

  /* Zurück in den eingeklappten Zustand — mit LEEREN Feldern. Was eingeklappt
     ist, darf nicht mitbestellt werden. Der Aufrufer zieht den Brief nach
     (`eingabeGeaendert`). */
  function zuklappen(name) {
    const halter = briefHalter();
    const inhalt = halter?.querySelector(`[data-aufklapp-inhalt="${name}"]`);
    if (!inhalt || inhalt.hidden) return;
    inhalt.querySelectorAll('textarea, input').forEach((el) => { el.value = ''; el.style.height = ''; });
    inhalt.hidden = true;
    const knopf = halter.querySelector(`[data-aufklapper="${name}"]`);
    if (knopf) {
      knopf.hidden = false;
      knopf.setAttribute('aria-expanded', 'false');
      knopf.focus();
    }
  }

  /* Eine eingeklappte Liste, in der schon etwas steht, wird aufgeklappt —
     sonst reiste ihr Inhalt unsichtbar mit. Läuft in `briefSichtbar`, also
     nach jedem Einsetzen und jeder Eingabe. */
  function aufklapperNachziehen(halter) {
    halter.querySelectorAll('[data-aufklapp-inhalt]').forEach((inhalt) => {
      if (!inhalt.hidden) return;
      const voll = Array.from(inhalt.querySelectorAll('textarea, input'))
        .some((el) => el.value.trim());
      if (voll) aufklappen(inhalt.dataset.aufklappInhalt);
    });
  }

  function briefSichtbar() {
    const halter = briefHalter();
    if (!halter) return;
    aufklapperNachziehen(halter);
    const wert = (n) => {
      const an = Array.from(halter.querySelectorAll(`[data-brieffeld="${n}"]`))
        .find((b) => b.getAttribute('aria-pressed') === 'true');
      return an ? an.dataset.wert : '';
    };
    /* Zuerst die gesperrten Marker: ein Marker, dessen Bedingung nicht gilt,
       wird gesperrt — und war er gewählt, fällt die Wahl auf den ersten
       freien zurück. Ohne diesen Rückfall bliebe eine unsichtbar gewordene
       Bestellung stehen und das Backend lehnte sie ab.

       ⏪ 17.08.2026: die Bedingung steht jetzt EINMAL am Konzept
       (`markerSperre`) statt an jedem betroffenen Chip. Grund: aus zwei
       Look-Chips sind vier Marker geworden, von denen DREI dieselbe Sperre
       teilen — dieselbe Bedingung dreimal ins Markup zu schreiben wäre die
       „zwei Hüllen"-Bauform im Kleinen (`rules/architektur.md`). */
    const sperre = briefDef().markerSperre;
    if (sperre) {
      /* 🔴 SOLANGE DAS BEDINGENDE FELD LEER IST, WIRD NICHT GESPERRT
         (17.08.2026, am eigenen Kontaktbogen gefunden). Die erste Fassung
         prüfte nur `werte.includes(…)`, und ein leerer Momenttyp ist in
         keiner Werteliste — also standen bei A5 beim LADEN drei von vier
         Markern grau, bevor der Kunde irgendetwas getan hatte. Der Grund
         steht im `title` und ist damit auf einem Telefon unsichtbar.
         Drei graue Farbkreise ohne Anlass lesen sich als kaputt, nicht als
         gesperrt — und sie sind es an dieser Stelle auch nicht: gesperrt ist
         die Kombination mit »begrüßt/umarmt« und »aus der Ferne«, nicht der
         Zustand davor.
         ⚠️ Der Riegel bleibt vollständig: wählt der Kunde später einen
         sperrenden Typ, greift der Rückfall unten und die Wahl kippt sichtbar
         auf `kontrolle`. Ein gesperrter Look kann weiterhin nicht ins
         Backend — `sammleBrief()` liest das korrigierte DOM. */
      const ist = wert(sperre.feld);
      const gilt = !ist || (sperre.werte || []).includes(ist);
      halter.querySelectorAll('[data-brieffeld="look"]').forEach((b) => {
        /* Der Kontroll-Marker ist NIE gesperrt — er ist der Rückfall. */
        if (b.dataset.wert === 'kontrolle') return;
        b.disabled = !gilt;
        b.title = gilt ? '' : (sperre.hinweis || '');
        if (!gilt && b.getAttribute('aria-pressed') === 'true') {
          b.setAttribute('aria-pressed', 'false');
          const frei = halter.querySelector('[data-brieffeld="look"]:not([disabled])');
          if (frei) frei.setAttribute('aria-pressed', 'true');
        }
      });
    }
    /* 🔴 JETZT der URL-Wunsch — nach dem Sperren, vor der Feld-Sichtbarkeit.
       Nach dem Sperren, weil erst dort feststeht, ob der gewünschte Chip
       überhaupt wählbar ist. Vor der Feld-Sichtbarkeit, weil die Einlösung
       den Look ändert und der Grundton daran hängt: andersherum stünde das
       Tonfeld eine Runde lang falsch. */
    lookWunschEinloesen(halter);
    /* Danach die Felder — der Rückfall oben und die Einlösung können die
       Bedingung geändert haben. */
    briefDef().felder.forEach((f) => {
      if (!f.nurWenn) return;
      const halterFeld = halter.querySelector(`[data-brieffeld-halter="${f.name}"]`);
      if (!halterFeld) return;
      const ist = wert(f.nurWenn.feld);
      /* `werte` (28.09.2026): ein Feld für mehrere Macharten — „Kind und
         Alter" gilt für Lexikon UND Zitat. */
      const zeigen = f.nurWenn.nicht !== undefined
        ? ist !== f.nurWenn.nicht
        : (f.nurWenn.werte ? f.nurWenn.werte.includes(ist) : ist === f.nurWenn.wert);
      halterFeld.hidden = !zeigen;
      if (!zeigen) {
        halterFeld.querySelectorAll(`[data-brieffeld="${f.name}"]`)
          .forEach((b) => b.setAttribute('aria-pressed', 'false'));
      } else if (f.vorwahl) {
        /* 🔴 VORWAHL BEIM EINBLENDEN (code-pruefer, 28.09.2026): die Vorwahl
           wird beim Aufbau gesetzt — und direkt danach vom Ausblenden oben
           wieder gelöscht, wenn das Feld an einer anderen Machart hängt. Wer
           dann auf »Zitat« wechselte, fand die Farbwelt ohne Auswahl und las
           „Bitte „Farbwelt" ausfüllen". Also: ist beim Einblenden nichts
           gewählt, greift die Vorwahl erneut. */
        const knoepfe = Array.from(halterFeld.querySelectorAll(`[data-brieffeld="${f.name}"]`));
        if (!knoepfe.some((b) => b.getAttribute('aria-pressed') === 'true')) {
          const vor = knoepfe.find((b) => b.dataset.wert === f.vorwahl);
          if (vor) vor.setAttribute('aria-pressed', 'true');
        }
      }
    });
    /* Foto-Befund als Zeile (22.10.2026) — nach jeder Sichtbarkeits-Runde nachziehen. */
    tierBefundZeichnen();
    kombiZeichnen();
    schritteZeichnen();
  }

  /** „<Felder>: wählst du nach dem Andruck – kostenlos." — nur Felder, die es bei der gewählten
      Machart wirklich gibt (`nurWenn`), höchstens drei beim Namen. Nach jeder Sichtbarkeits-Runde,
      weil ein Machart-Wechsel die Menge ändert (code-pruefer 22.10.2026: beim Magazin nannte der
      Satz „Farbe", die es dort nicht gibt). */


  /* --- `?look=` in der URL wählt den Look vor -------------------------------
     🔴 DAS IST DIE „EIGENE LANDING-URL JE LOOK" OHNE ACHT PRODUKTE. Jeder der
     acht Looks bekommt damit eine eigene Adresse für Ads und für die
     Kollektionskacheln (`/products/orts-print?look=linolschnitt`), während
     Katalog, Varianten und Gelato-Zuordnung vierfach bleiben statt achtfach.
     ⚠️ Der Parameter WÄHLT nur vor, er bestellt nichts: ein unbekannter oder
     für dieses Konzept nicht baubarer Wert wird ignoriert, und die Sperren in
     `briefSichtbar()` gelten unverändert. Eine URL kann jeder schreiben —
     sie darf deshalb nie an den Riegeln vorbeigreifen.

     🔴 DER WUNSCH ÜBERLEBT, SOLANGE ER NICHT ERFÜLLBAR IST (Befund
     `code-pruefer`, 14.08.2026, BELEGT). Erste Fassung: `vorauswahlAusUrl`
     setzte den Chip und `briefSichtbar()` kassierte ihn eine Zeile später
     wieder — bei A5 hängt der Aussparungs-Chip am Momenttyp, und zum
     Aufbauzeitpunkt ist keiner gewählt. Folge war, dass ausgerechnet die
     Kachel »Euer Moment · dunkel« auf einer PDP mit vorgewähltem »Hell«
     landete: **genau der Trichterbruch, den der Kachel-Link beheben sollte**,
     still, ohne Fehler, ohne Log, und nur bei einem von vier Konzepten.

     Deshalb ist der Wunsch jetzt ein ZUSTAND, kein einmaliger Griff: er
     wartet, bis die Kombination baubar wird (der Kunde wählt einen
     Nebeneinander-Momenttyp), und wird dann eingelöst. Er verfällt, sobald
     der Kunde den Look SELBST anfasst — eine URL darf eine Kundenwahl nie
     überschreiben, auch nicht später.
     ⚠️ Der Zustand selbst steht oben bei `s` — `let` hat eine temporale
     Todeszone, und `baueBrief()` liest ihn. Heute läuft der Aufbau zuletzt,
     die Deklaration hier wäre also gutgegangen; „geht heute gut" ist aber
     keine Zusage, sondern eine Wette auf die Aufrufreihenfolge. */

  function lookWunschLesen() {
    try {
      lookWunsch = (new URLSearchParams(window.location.search).get('look')
                    || '').trim().toLowerCase();
    } catch { lookWunsch = ''; }
  }

  /** Setzt den gewünschten Look, wenn er JETZT wählbar ist. Der Wunsch bleibt
      stehen, solange er es nicht ist — aufgeräumt wird er nur, wenn er
      eingelöst wurde oder der Kunde selbst gewählt hat. */
  function lookWunschEinloesen(halter) {
    if (!lookWunsch || !halter) return;
    const chips = Array.from(halter.querySelectorAll('[data-brieffeld="look"]'));
    const ziel = chips.find((b) => b.dataset.wert === lookWunsch && !b.disabled);
    if (!ziel) return;                       // noch nicht baubar — warten
    chips.forEach((b) => b.setAttribute('aria-pressed', String(b === ziel)));
    lookWunsch = '';
  }

  function sammleBrief() {
    const halter = briefHalter();
    if (!halter) return;
    const def = briefDef();
    const wert = (n) => {
      const el = halter.querySelector(`[data-feld="${n}"]`);
      return el ? el.value.trim() : '';
    };
    const liste = (n) => Array.from(halter.querySelectorAll(`[data-feld="${n}"]`))
      .map((i) => i.value.trim());

    s.brief = {};
    def.felder.forEach((f) => {
      if (f.typ === 'namen') {
        const a = wert('name1');
        const b = wert('name2');
        s.brief.name1 = a; s.brief.name2 = b;
        s.brief.namen = [a, b].filter(Boolean).join(' & ');
        if (f.geschlecht) {
          s.brief.geschlecht1 = wert('geschlecht1');
          s.brief.geschlecht2 = wert('geschlecht2');
        }
      } else if (f.typ === 'chips' || f.typ === 'stil' || f.typ === 'marker-solo'
                 || f.typ === 'marker') {
        const an = Array.from(halter.querySelectorAll(`[data-brieffeld="${f.name}"]`))
          .find((b) => b.getAttribute('aria-pressed') === 'true');
        s.brief[f.name] = an ? an.dataset.wert : '';
      } else if (f.typ === 'karte') {
        /* Nur die Herkunft (Schutz der Datei im Aufräumen) — die gelesenen
           Texte stehen längst in den Feldern, die der Kunde geprüft hat. */
        s.brief.karte_id = karte.status === 'ok' ? karte.id : '';
      } else if (f.typ === 'foto') {
        /* Nur ein GEPRÜFTES Foto geht in den Brief; „Ohne Foto" schickt keins. */
        const gut = !foto.ohne && foto.id && ['ok', 'hauptmotiv'].includes(foto.status);
        s.brief.foto_id = gut ? foto.id : '';
        s.brief.hauptmotiv = gut ? (foto.hauptmotiv || '') : '';
      } else if (f.typ === 'ortsfoto') {
        /* Nur ein ANGENOMMENES Foto geht in den Brief — ein abgelehntes zeichnet nichts. */
        s.brief.ortsfoto_id = ortfoto.status === 'ok' ? ortfoto.id : '';
      } else if (f.typ === 'paarfoto') {
        /* Nur ein ANGENOMMENES Foto und die bestätigten Merkmale gehen in den Brief. Das Geschlecht je Person
           steht auch ohne Foto in `geschlecht1/2` — der kleine Moment (`a5_neu`) braucht es. */
        const mitFoto = paarfoto.status === 'ok' && paarfoto.id;
        s.brief.paarfoto_id = mitFoto ? paarfoto.id : '';
        /* Pixel-Paar: nur die Foto-ID — die Merkmale stehen im Baukasten (`gamingVorbelegen`). */
        if (istGaming()) { delete s.brief.paar; return; }
        /* 🔴 Ohne Foto KEIN Feld `paar` — nie `null`: der Dienst setzt jedes Brief-Feld, das kein Text ist, per
           `' · '.join` in den Prompt (`content_block`), und `null` warf dort — jeder Moment ohne Foto brach mit
           „Erzeugung fehlgeschlagen" ab (Sascha live, 30.10.2026, 20 Minuten lang). */
        /* Mit `OHNE_FOTO_AN` gehen die Vorgaben, die die Tabelle zeigt (Brille „keine", Bart „keiner" beim Mann,
           „beide gleich groß"), auch in den Brief — mit und ohne Foto (code-pruefer 30.10.2026). */
        const v = (q) => ({ ...q, brille: paarVorgabe(q, 'brille'), bart: paarVorgabe(q, 'bart') });
        const mitVorgaben = (pp) => (OHNE_FOTO_AN ? { ...pp, p1: v(pp.p1 || {}), p2: v(pp.p2 || {}),
                                                     groesse: pp.groesse || 'gleich' } : pp);
        if (mitFoto && paarfoto.paar) s.brief.paar = paarBrief(mitVorgaben(paarfoto.paar));
        /* Ohne Foto (`OHNE_FOTO_AN`): die Angaben aus der Tabelle — als Objekt aus Texten, nie `null`. Porträt nimmt
           keine Angaben. */
        else if (OHNE_FOTO_AN && paarfoto.paar && D.produkt.handle !== 'portraet') {
          s.brief.paar = paarBrief(mitVorgaben(paarfoto.paar));
        } else delete s.brief.paar;
        const p = paarfoto.paar || {};
        s.brief.geschlecht1 = (p.p1 || {}).geschlecht || '';
        s.brief.geschlecht2 = (p.p2 || {}).geschlecht || '';
        /* Nur bei Farbig im Brief (`paarMitHaut`; `look` ist vorher gesammelt) — sonst stünde der Hautton im
           Fingerabdruck von Dunkel/Kohle/Strich, und ein Wechsel zurück fände den eigenen Entwurf nicht mehr
           (code-pruefer 28.10.2026). */
        if (paarMitHaut()) {
          s.brief.hautton1 = paarHaut(p.p1);
          s.brief.hautton2 = paarHaut(p.p2);
        }
      } else if (f.typ === 'gpx') {
        /* Nur eine GELESENE Datei geht in den Brief. */
        s.brief.datei_id = datei.status === 'ok' ? datei.id : '';
      } else if (f.typ === 'farbmarker') {
        /* 🔴 HIER ENDET DIE ZUSAMMENFASSUNG. Der Marker trägt in der
           Oberfläche `kontrolle` oder `<zweig>:<ton>`; der Brief ans Backend
           führt `look` und `grund`/`tinte` GETRENNT weiter, weil
           `dienst.look_und_ton` beide einzeln prüft und einen unbekannten Ton
           laut ablehnt statt still auf `kontrolle` zurückzufallen.
           Ein zusammengesetzter Wert im Brief wäre eine zweite Schreibweise
           desselben Sachverhalts — genau das, was am 31.07.2026 bei
           Terrakotta an sechs Stellen auseinanderlief. */
        const an = Array.from(halter.querySelectorAll(`[data-brieffeld="${f.name}"]`))
          .find((b) => b.getAttribute('aria-pressed') === 'true');
        const roh = an ? String(an.dataset.wert) : '';
        const trenner = roh.indexOf(':');
        s.brief.look = trenner < 0 ? roh : roh.slice(0, trenner);
        s.brief[f.tonFeld] = trenner < 0 ? '' : roh.slice(trenner + 1);
      } else if (f.typ === 'liste') {
        /* Leere Zeilen fallen aus Liste UND Jahres-Liste gleichzeitig raus,
           sonst verrutschen die Indizes. Der Akzentträger zeigt auf die
           AUSGEFÜLLTE Liste, nicht auf die Formularzeile. */
        const dinge = liste(f.name);
        const jahre = f.jahr ? liste(f.name + '_jahre') : [];
        const marken = f.marke ? liste(f.name + '_marken') : [];
        const behalten = dinge.map((d, i) => [d, jahre[i] || '', i]).filter(([d]) => d);
        s.brief[f.name] = behalten.map(([d]) => d);
        /* Der Hinweis am Feld geht, sobald eine Zeile ausgefüllt ist. */
        if (f.leerHinweis && behalten.length) feldHinweis(f.name, '');
        if (f.jahr) s.brief[f.name + '_jahre'] = behalten.map(([, j]) => j);
        /* Dieselbe Leerzeilen-Regel wie beim Jahr — sonst verrutscht die
           Markierung auf den falschen Ort. */
        if (f.marke) s.brief[f.name + '_marken'] = behalten.map(([, , i]) => marken[i] || 'ring');
        /* ⏪ 15.08.2026: `akzenttraeger` wird nicht mehr gesammelt — das
           Feld gibt es nicht mehr. Das Backend ignoriert einen
           mitgeschickten Wert ohnehin (`a1_stufe1.ikonen_schreiben` kennt
           den Parameter nicht mehr); hier gar nicht erst zu senden hält den
           Brief frei von Feldern, die niemand liest. */
      } else {
        /* 🔴 AUSGEBLENDETE TEXTFELDER ZÄHLEN NICHT (code-pruefer, 28.09.2026):
           wer erst »Das Wort« tippte und dann auf »Zitat« wechselte, bekam
           „Das Wort: Bisketti" als Property in Warenkorb und Bestellung —
           eine Angabe, die nicht auf dem Blatt steht. Der Wert bleibt im
           Feld stehen (ein Rückwechsel findet ihn wieder), er wird nur nicht
           gesammelt. */
        const verborgen = halter.querySelector(`[data-brieffeld-halter="${f.name}"]`)?.hidden;
        s.brief[f.name] = verborgen ? '' : wert(f.name);
      }
    });
    const beschriftungen = beschriftungenLesen();
    if (beschriftungen) s.brief.beschriftungen = beschriftungen;
  }

  /** Erste fehlende Pflichtangabe als Meldung — null, wenn vollständig. */
  /** Erste Meldung, die den Andruck sperrt — oder null. `nur` (Stufe 2, 22.10.2026): nur diese
      Feldnamen prüfen (der „Weiter"-Knopf eines Schritts), sonst alle. */
  function brieffehler(nur = null) {
    const def = briefDef();
    const halter = briefHalter();
    for (const f of def.felder) {
      if (nur && !nur.includes(f.name)) continue;
      /* 🔴 Ein AUSGEBLENDETES Pflichtfeld darf nicht blockieren — sonst
         sperrt der Grundton den Knopf beim Kontroll-Look, und der Kunde
         liest „Bitte Grundton ausfüllen" neben einem Feld, das er nicht
         sieht. Gefragt wird der SICHTBARE Zustand, nicht die Definition. */
      const wrapper = halter?.querySelector(`[data-brieffeld-halter="${f.name}"]`);
      if (wrapper && wrapper.hidden) continue;
      if (f.typ === 'namen') {
        if (!s.brief.name1 && !s.brief.name2) return 'Bitte mindestens einen Namen eintragen.';
        if (f.beide && !(s.brief.name1 || '').trim()) return 'Bitte den 1. Namen eintragen.';
        if (f.beide && !(s.brief.name2 || '').trim()) return 'Bitte den 2. Namen eintragen.';
        if (f.geschlecht && (!s.brief.geschlecht1 || !s.brief.geschlecht2)) {
          return 'Bitte für beide Personen das Geschlecht wählen.';
        }
      } else if (f.typ === 'liste') {
        if ((s.brief[f.name] || []).length < f.pflicht) {
          /* `leerHinweis` (Rezept, 17.10.2026): der Hinweis steht DIREKT am
             Feld, nicht nur oben in der Meldung (Sascha, T1 »A«). */
          if (f.leerHinweis) {
            feldHinweis(f.name, f.leerHinweis);
            return f.leerHinweis;
          }
          return `Bitte mindestens ${f.pflicht} × „${f.label}" ausfüllen.`;
        }
        if (f.leerHinweis) feldHinweis(f.name, '');
      } else if (f.typ === 'foto') {
        /* Seit 26.10.2026 (Machart zuerst) gehört „Magazin braucht ein Foto" zum Foto-Schritt selbst. */
        const m = fotoFehler(false);
        if (m) return m;
      } else if (f.typ === 'ortsfoto') {
        /* Optional: nur die laufende Prüfung hält an — ein abgelehntes Foto sperrt nicht. */
        if (ortfoto.status === 'laedt') return 'Dein Foto wird gerade geprüft …';
      } else if (f.typ === 'paarfoto') {
        if (paarfoto.status === 'laedt') return 'Euer Foto wird gerade geprüft …';
        if (D.produkt.handle === 'linie' && !s.brief.paarfoto_id && !OHNE_FOTO_AN) {
          return 'Für dieses Poster brauchen wir ein Foto von euch beiden.';
        }
        /* Porträt: gezeichnet wird nur aus dem Foto; Frau/Mann fragt es nicht ab (nächste Zeile). */
        if (D.produkt.handle === 'portraet' && !s.brief.paarfoto_id) return 'Für dieses Poster brauchen wir ein Foto.';
        if (PAARFOTO_NUR_MIT_FOTO.includes(s.brief.look) && !s.brief.paarfoto_id && !OHNE_FOTO_AN) {
          return 'Für Kohle und Strich brauchen wir ein Foto von euch beiden – oder wähle Dunkel oder Farbig.';
        }
        if (D.produkt.handle !== 'portraet' && !istGaming() && (!s.brief.geschlecht1 || !s.brief.geschlecht2)) {
          /* Ohne Foto steht die Auswahl in der Klappe — ist sie zu, sagt die Meldung, wo. */
          if (OHNE_FOTO_AN && !s.brief.paarfoto_id && !ohneKlappe) {
            return 'Ladet ein Foto von euch hoch – oder beschreibt euch unter „Kein Foto zur Hand?".';
          }
          return 'Bitte für beide Personen wählen: Frau, Mann oder neutral.';
        }
      } else if (f.typ === 'karte') {
        if (karte.status === 'laedt') return 'Deine Karte wird gerade gelesen …';
      } else if (f.typ === 'gpx') {
        if (datei.status === 'laedt') return 'Deine Datei wird gerade gelesen …';
        /* Ein gescheitertes BILD sperrt nicht (code-pruefer 19.10.2026): das Feld ist
           optional, und ein Apple-Kunde hat keine GPX — er nennt dann oben Orte. */
        if (datei.status === 'fehler' && !datei.bild) return datei.meldung || 'Bitte wähle eine andere Datei.';

      } else if (f.pflicht && !s.brief[f.name]) {
        return `Bitte „${f.label}" ausfüllen.`;
      }
    }
    /* 🔴 Die Machart prüft das Foto mit (Sascha, 22.10.2026 abends, Pferd: „Fehlermeldung kommt erst
       ganz am Ende … Fehlermeldungen müssen direkt in den Schritten kommen, in denen sie passieren").
       „Magazin braucht ein Foto" hing am Foto-Feld — der Schritt „Machart" enthält es nicht, also
       ließ „Weiter" Magazin ohne Foto durch, und erst der Andruck meldete es. */
    /* ⚠️ Seit 26.10.2026 steht die Machart VOR dem Foto (`ABLAUF`): hier zählt nur noch der
       Widerspruch Magazin + „Ohne Foto" — nie „Bitte lade ein Foto hoch", denn das Foto kommt
       erst im nächsten Schritt. Das Antippen von Magazin hebt „Ohne Foto" ohnehin auf. */
    if (nur && nur.includes('stil') && !nur.includes('foto') && def.felder.some((f) => f.typ === 'foto')) {
      const m = magazinOhneFoto();
      if (m) return m;
    }
    return null;
  }
  /** Sofort-Hinweis im offenen Schritt, wenn eine Wahl dort nicht zusammenpasst (heute: Magazin
      ohne Foto) — nicht erst bei „Weiter". Steht unter dem Knopf des Schritts; im letzten Schritt
      in der Meldung über dem Andruck-Knopf. */
  function schrittHinweisPruefen() {
    if (!wurzel.classList.contains('maske-schritte')) return;
    const liste = schritteListe();
    const x = liste && liste[schrittAktiv];
    if (!x || !x.namen.includes('stil') || x.namen.includes('foto')) return;
    sammleBrief();
    /* NUR die Magazin/Foto-Bedingung — nicht `brieffehler` für den ganzen Schritt: das meldete beim
       Antippen von „Lexikon" sofort „Bitte Eigenheit 1 ausfüllen", bevor der Kunde tippen konnte,
       und die Meldung blieb nach dem Ausfüllen stehen (code-pruefer 22.10.2026). Leere Pflichtfelder
       meldet weiter „Weiter" bzw. der Andruck. Weggeräumt wird nur, was dieser Hinweis selbst gesetzt hat. */
    const m = magazinOhneFoto();
    const ziel = $('[data-schritt-fehler]') || $('[data-fehler]');
    if (!ziel) return;
    if (m) {
      ziel.textContent = m;
      ziel.hidden = false;
      ziel.dataset.fotoHinweis = '1';
    } else if (ziel.dataset.fotoHinweis) {
      ziel.hidden = true;
      delete ziel.dataset.fotoHinweis;
    }
  }

  /* ================================================================== Aufbau */

  /* --- Swatches ------------------------------------------------------------
     Die einzigen Kreise im System. NIE EIN HÄKCHEN — es überdeckt die Farbe,
     die beurteilt werden soll. Der gewählte Zustand ist ein Ring mit Luft. */
  function baueSwatches(art, liste) {
    const halter = $(`[data-swatches="${art}"]`);
    if (!halter) return;
    halter.innerHTML = liste
      .map(
        (f) => `<span class="swatch-huelle">
          <button type="button" class="swatch" style="--farbe:${f.hex}"
            data-swatch="${art}" data-wert="${f.id}"
            aria-pressed="false" aria-label="${f.label}" title="${f.label}"></button>
        </span>`
      )
      .join('');
  }

  /* ======================================================= Format und Rahmen

     🔴 ZWEI BEDIENELEMENTE STATT VIER (Sascha, 17.08.2026): „Format und
     Ausführung sind UX / UI-technisch sehr Nutzer-unfreundlich — plumpe
     Boxen, kein visueller Anker. … Das heißt, eine Vorschau zeigen für den
     Rahmen. Das Format gegebenenfalls als Dropdown, damit es weniger Platz
     wegnimmt."

     Die Aufteilung folgt der Frage, ob die Wahl eine ANSCHAUUNG braucht:
       Format  ist eine Zahl. Vier Kacheln nahmen auf 390 px zwei Zeilen ein,
               ohne dass die Entscheidung dadurch leichter wird → `select`.
       Rahmen  ist ein Aussehen. „Dunkles Holz" ist kein Wort, an dem jemand
               etwas entscheidet → Bildkacheln.

     ⚠️ Die Rahmenkachel ist bewusst KEIN Foto. Sascha, 13.08.2026, an den
     Wettbewerbern abgelesen: „bei Juniqe und Desenio ist der Rahmen in der
     Vorschau ohnehin kaum mehr als eine dicke Linie um das Blatt. Sieht zwar
     nicht fotorealistisch aus, aber gibt dem Kunden eine Idee, und das sollte
     reichen." Ein gezeichneter Rahmen wandert außerdem mit dem Blatt und
     seine Farbe bleibt ein Parameter — mit einem generierten ginge das nie
     (`pipeline/raum-rahmen.py`, Kopf). */

  /* Die drei Gelato-Leisten. ZWEITKOPIE der Werte aus
     `pipeline/raum-rahmen.py:LEISTEN` — unvermeidbar, weil das Theme die
     Pipeline zur Bauzeit nicht kennt, und deshalb hier deklariert statt
     stillschweigend.
     🔴 Weiß FEHLT bewusst: Sascha hat den weißen Rahmen am 13.08.2026 nach
     Sichtung der Testdrucke gestrichen. Nicht wieder aufnehmen, ohne dass die
     Entscheidung zurückgenommen wurde.
     ⚠️ Die Schlüssel sind die Shopify-OPTIONSWERTE, nicht die Pipeline-Namen
     (dort: eiche · nuss · schwarz). Wer einen Variantennamen im Store ändert,
     ändert ihn hier mit — sonst fällt die Kachel still auf den Rückfall. */
  /* 🔴 ERKANNT, NICHT NACHGESCHLAGEN (18.08.2026, zweiter Riss in zwei Tagen).

     Bis hierher war das eine Tabelle mit den Optionswerten als Schlüssel:
     `'Holz natur' · 'Dunkles Holz' · 'Schwarz'`. Am 17.08. stellte der Katalog
     auf `'Holz Natur' · 'Holz Schwarz' · 'Alu Schwarz'` um — **null
     Überschneidung**, schon wegen des großen N in „Natur". Alle drei Kacheln
     und die Bühne zeichneten ab da über den Rückfall, also alles als helles
     Holz. Es scheppert nicht: der Code läuft, die Prüfungen sind grün, nur das
     Bild ist falsch.

     Deshalb steht hier jetzt eine ERKENNUNG statt einer Zuordnung. Sie liest
     zwei Eigenschaften aus dem Namen — Werkstoff und Farbe — und setzt den Ton
     daraus zusammen. Eine Umbenennung („Holz natur" → „Holz Natur", „Schwarz"
     → „Holz Schwarz") läuft damit durch, eine echte Neuheit („Alu Silber")
     fällt auf, weil `rahmenTon()` sie meldet statt sie still zu ersetzen.

     ⚠️ WAS DIE ERKENNUNG NICHT LEISTET: sie rät nicht. Trifft weder ein
     Werkstoff noch eine Farbe, gibt es eine Warnung in der Konsole und den
     Rückfall — sichtbar für jeden, der den Prüfstand öffnet.

     🔴 ALU IST KEIN HOLZ, und das ist der Grund für die zweite Achse. Das
     Ton-Modell {aussen, flaeche, falz} zeichnet eine Fase; bei Holz trägt sie
     Wärme und einen deutlichen Falzkontrast, bei Aluminium liest sie kühler
     und flacher. Ein Alu-Rahmen in Holztönen ist kein Rundungsfehler, sondern
     ein anderes Produkt.
     ⚠️ Die Alu-Werte sind ein VORSCHLAG, kein Messwert. n=0, und der Weg zu
     einem Messwert ist ZU: die Gelato-Product-API liefert keine Bilder (nur
     `attributes`, `weight`, `dimensions`, `contentAreas`), gelato.com
     antwortet auf automatisierten Zugriff mit 403. Am 18.08.2026 von der
     Katalog-Session ergebnislos versucht — wer es erneut probiert, weiß das.
     Belegbar ist nur die textliche Angabe aus Gelatos Help Center:
     schwarze und weiße Premium-Holzrahmen sind ESCHE, naturfarbene EICHE,
     Metallrahmen Aluminium.
     ✅ ABGENOMMEN am 18.08.2026 (Sascha, an der gerenderten Kachelreihe):
     „Rahmenbilder passen genau so, alles lassen." Damit ist die Frage
     ENTSCHIEDEN und keine offene mehr — sie lautete: Alu Schwarz und Holz
     Schwarz sehen real ähnlich aus (sie unterscheiden sich in Werkstoff und
     Leistenbreite, 10 gegen 12 mm, kaum in der Farbe), und die Kachel bildet
     genau das ab.
     🔴 WER DIE WERTE ÄNDERN WILL, ÄNDERT EINE ABNAHME. Nicht „ein Vorschlag,
     den man mal nachschärfen könnte" — das war der Stand VOR dem 18.08.
     Ein späterer Lauf legt die Frage bitte nicht erneut vor; sie ist am Bild
     beantwortet worden. Neu aufgemacht wird sie nur, wenn ein echter Rahmen
     vorliegt und ihm widerspricht.

     ⏪ 18.08.2026: die weiteren Kopien in `pipeline/` sind erledigt
     (`423d25c`, Katalog-Session). Es waren VIER, nicht drei — `raum-composite.py`
     führte dieselben Rahmen ein zweites Mal. Dort ist `raum-rahmen.py` jetzt
     die Quelle, mit Katalognamen und eigener Leistenbreite für Alu.
     🔴 EIN UNTERSCHIED ZU DORT IST ABSICHT, keine Inkonsistenz: die Pipeline
     lässt `nuss` LAUT brechen, dieses Theme erkennt `dunkel`/`nuss` still
     weiter. Grund: die Pipeline hat keine Laufzeit-Eingabe — ein Name, der
     dort weiterzeichnet, ist ein stiller Fehler in einem Mockup, das als
     Anzeige ausgeliefert wird. Der Kundenpfad hier bekommt seine Namen aus
     dem STORE, und der liefert bis zum Reimport die alten. Tolerant, wo eine
     fremde Eingabe ankommt; laut, wo der eigene Code die Wahl trifft. */
  const RAHMEN_WERKSTOFF = {
    alu:  { flaeche: '#3A3A38', aussen: '#2A2A28', falz: '#4A4A47' },
    holz: { flaeche: '#C4A47A', aussen: '#96764F', falz: '#AC8C62' },
  };
  /* Nur Farben, die den Werkstoff-Grundton ÜBERSCHREIBEN. „Natur" steht
     bewusst nicht drin: es ist die Abwesenheit einer Farbe, also der
     Werkstoff selbst. */
  const RAHMEN_FARBE = {
    schwarz: {
      alu:  { flaeche: '#3A3A38', aussen: '#2A2A28', falz: '#4A4A47' },
      holz: { flaeche: '#2A2826', aussen: '#121110', falz: '#1C1A18' },
    },
    /* 🔴 „Dunkel" steht hier, obwohl der Katalog seit dem 18.08.2026 keinen
       dunklen Holzrahmen mehr führt — und das ist kein Altlast-Rest, sondern
       der Grund, warum diese Reparatur überhaupt sicher ist:
       DER SHOPIFY-REIMPORT IST NICHT GELAUFEN. Bis er läuft, liefert der
       Store weiter `Holz natur · Dunkles Holz · Schwarz`. Ohne diesen Eintrag
       fiele „Dunkles Holz" auf den Werkstoff-Grundton und stünde HELL da —
       die Reparatur hätte den Fehler von hell-statt-dunkel behoben und einen
       zweiten in derselben Richtung eingeführt.
       ⚠️ Nicht entfernen, solange `varianten.json` und der Store
       auseinanderliegen. Erst wenn der Store die neue Reihe trägt, ist es
       toter Code — und dann fällt er beim nächsten Aufräumen weg, nicht
       vorher. */
    dunkel: {
      holz: { flaeche: '#6E4E34', aussen: '#4A3220', falz: '#5A3E28' },
    },
  };

  /* Leistenbreite je Seite in Millimetern — GELESEN aus den
     `gelato_product_uid` der gerahmten Varianten (`katalog/varianten.json`,
     Stand 18.08.2026): `_w10xt22-mm` bei Aluminium, `_w12xt22-mm` bei beiden
     Holzrahmen. Kein Schätzwert.
     GELTUNGSBEREICH: die Maßstabsrechnung der Raumansicht. NICHT die Tiefe
     (22 mm bei allen) und NICHT die gezeichnete Kachel — die ist ein Symbol,
     kein Maßstab. */
  const LEISTE_MM = { alu: 10, holz: 12 };

  /* Wörter, die im Namen stehen dürfen, ohne eine Farbe zu bezeichnen.
     „Natur" ist die ABWESENHEIT einer Farbe — der Werkstoff selbst. */
  const RAHMEN_NEUTRAL = ['natur', 'nature', 'roh', 'unbehandelt'];
  /* „Dunkles" enthält „dunkel" NICHT (d-u-n-k-l-e-s gegen d-u-n-k-e-l), und
     „Nussbaum" enthält „dunkel" auch nicht. Beides braucht deshalb einen
     eigenen Eintrag. Sie kosten nichts und fangen die Namen, die der Store bis
     zum Reimport noch trägt (`Dunkles Holz`) sowie die der Pipeline (`nuss`). */
  const RAHMEN_ALIAS = { nuss: 'dunkel', walnuss: 'dunkel', dunkles: 'dunkel' };
  const RAHMEN_WERKSTOFF_WORT = [
    [/\balu/, 'alu'], [/\bmetall/, 'alu'],
    [/\bholz\b/, 'holz'], [/eiche/, 'holz'], [/nuss/, 'holz'], [/kiefer/, 'holz'],
  ];

  /** Werkstoff und Farbe aus einem Optionswert. `null`, wenn nichts greift.
      @param unbekannt  optionales Array — jedes Wort, das die Erkennung nicht
        einordnen konnte, wird hier abgelegt. Siehe `rahmenTon()`. */
  function rahmenTeile(name, unbekannt) {
    const n = String(name || '').toLowerCase();
    if (!n) return null;
    const paar = RAHMEN_WERKSTOFF_WORT.find(([re]) => re.test(n));
    const werkstoff = paar ? paar[1] : null;
    const treffer = Object.keys(RAHMEN_FARBE).find((f) => n.includes(f))
      || Object.keys(RAHMEN_ALIAS).find((a) => n.includes(a));
    const farbe = treffer ? (RAHMEN_ALIAS[treffer] || treffer) : null;

    /* 🔴 EIN UNBEKANNTES WORT MELDET SICH, AUCH WENN DER REST TRIFFT
       (Befund `code-pruefer` 18.08.2026, BELEGT).
       Die erste Fassung warnte nur, wenn WEDER Werkstoff NOCH Farbe griff.
       „Alu Silber" fand damit den Werkstoff, verlor die Farbe still — und ein
       silberner Rahmen wurde anthrazit gezeichnet. Genau die Klasse „läuft
       fehlerfrei, liefert falsch aus", gegen die diese Erkennung gebaut ist;
       der Kommentar oben nennt „Alu Silber" sogar als den Fall, der auffallen
       SOLLTE.
       Geprüft wird deshalb Wort für Wort: was weder Werkstoff noch Farbe noch
       ausdrücklich neutral ist, wird gemeldet. */
    if (unbekannt) {
      n.split(/[^a-zäöüß]+/).filter(Boolean).forEach((wort) => {
        if (RAHMEN_NEUTRAL.includes(wort)) return;
        if (RAHMEN_WERKSTOFF_WORT.some(([re]) => re.test(wort))) return;
        if (Object.keys(RAHMEN_FARBE).some((f) => wort.includes(f))) return;
        if (Object.keys(RAHMEN_ALIAS).some((a) => wort.includes(a))) return;
        unbekannt.push(wort);
      });
    }
    return werkstoff || farbe ? { werkstoff: werkstoff || 'holz', farbe } : null;
  }

  /* Damit dieselbe Unbekannte nicht bei jedem `zeichne()` erneut in die
     Konsole schreibt — die Warnung soll auffallen, nicht zumüllen. */
  const rahmenGemeldet = new Set();

  /** Der Ton zu einem Optionswert. Meldet laut, wenn er raten müsste. */
  function rahmenTon(name) {
    const unbekannt = [];
    const teile = rahmenTeile(name, unbekannt);
    if (name && unbekannt.length && !rahmenGemeldet.has(name)) {
      rahmenGemeldet.add(name);
      console.warn(`[echoa] Rahmenfarbe „${name}": „${unbekannt.join('", "')}" `
        + `${unbekannt.length > 1 ? 'sind' : 'ist'} der Erkennung unbekannt – `
        + `gezeichnet wird ${teile ? 'nur der erkannte Teil' : 'der Rückfall (Holz natur)'}. `
        + `Nachziehen in echoa-konfigurator.js: RAHMEN_WERKSTOFF_WORT, `
        + `RAHMEN_FARBE oder RAHMEN_NEUTRAL.`);
    }
    if (!teile) return RAHMEN_WERKSTOFF.holz;
    const ueber = teile.farbe && RAHMEN_FARBE[teile.farbe][teile.werkstoff];
    return ueber || RAHMEN_WERKSTOFF[teile.werkstoff];
  }

  /** Leistenbreite je Seite in cm, aus dem Namen. */
  function leisteCm(name) {
    const teile = rahmenTeile(name);
    return (LEISTE_MM[teile ? teile.werkstoff : 'holz'] / 10);
  }

  const RAHMEN_RUECKFALL = RAHMEN_WERKSTOFF.holz;

  /** Die Gehrungsecke als SVG — dieselbe Form wie bei Desenio und Juniqe:
      ein nach unten offener Winkel, Fuge senkrecht in der Mitte.
      Der Innenfalz liegt OBEN (dort sitzt das Blatt), die Außenkante unten. */
  function rahmenEcke(ton) {
    const t = ton || RAHMEN_RUECKFALL;
    return `<svg class="rahmen__ecke" viewBox="0 0 100 88" aria-hidden="true"
                 preserveAspectRatio="xMidYMid meet">
      <polygon points="0,6 50,56 100,6 100,32 50,82 0,32" fill="${t.flaeche}"/>
      <polygon points="0,6 50,56 50,82 0,32" fill="#FFFFFF" opacity=".10"/>
      <polygon points="50,56 100,6 100,32 50,82" fill="#000000" opacity=".12"/>
      <path d="M0,6 L50,56 L100,6" fill="none" stroke="${t.falz}" stroke-width="3"/>
      <path d="M0,32 L50,82 L100,32" fill="none" stroke="${t.aussen}" stroke-width="4"/>
      <path d="M50,56 L50,82" stroke="${t.aussen}" stroke-width="1" opacity=".55"/>
    </svg>`;
  }

  /** „Ohne Rahmen": das nackte Blatt mit Schlagschatten, wie bei Desenio. */
  function blattEcke() {
    return `<svg class="rahmen__ecke" viewBox="0 0 100 88" aria-hidden="true"
                 preserveAspectRatio="xMidYMid meet">
      <rect x="26" y="10" width="52" height="70" fill="#000000" opacity=".10"
            transform="translate(3,4)"/>
      <rect x="26" y="10" width="52" height="70" fill="var(--papier, #FEF7EC)"
            stroke="var(--kante-satt, #C6BFB0)" stroke-width="1"/>
    </svg>`;
  }

  /** Preis einer Kombination in Cent, oder null. */
  function preisVon(ausfuehrung, groesse, rahmenfarbe) {
    const v = findeVariante({ ...s, ausfuehrung, groesse, rahmenfarbe });
    return v ? v.preis : null;
  }

  /* --- Format ---------------------------------------------------------------
     Der Preis in der Zeile ist der Preis DIESER Ausführung, nicht der
     Grundpreis: wer einen Rahmen gewählt hat, soll beim Formatwechsel sehen,
     was er zahlt, statt zwei Zahlen zusammenrechnen zu müssen.
     ⚠️ Wird bei jedem Rahmenwechsel neu beschriftet (`zeichne`). */
  function baueGroessen() {
    const sel = $('[data-groesse]');
    if (!sel) return;
    const werte = werteFuer('groesse');
    sel.innerHTML = werte
      .map((w) => `<option value="${attr(w)}">${escape(w)}</option>`)
      .join('');
    if (s.groesse) sel.value = s.groesse;
  }

  function groessenBeschriften() {
    const sel = $('[data-groesse]');
    if (!sel) return;
    Array.from(sel.options).forEach((o) => {
      const v = findeVariante({ ...s, groesse: o.value });
      /* 🔴 BEIDES PRÜFEN — Existenz UND Verfügbarkeit (Befund `code-pruefer`
         17.08.2026, BELEGT). Die erste Fassung fragte nur nach dem Preis und
         hätte damit eine ausverkaufte Größe als wählbar mit Preis gezeigt;
         `rahmenZeichnen()` eine Funktion weiter prüfte bereits beides, und
         die entfernte `[data-wahl]`-Schleife hatte es für beide Achsen getan
         (`const weg = treffer && !treffer.verfuegbar`).
         ⚠️ Heute nicht erreichbar: `katalog/import.py` legt alle Varianten
         mit `inventoryPolicy: CONTINUE` und `tracked: false` an, `available`
         ist damit immer wahr. Der Pfad öffnet sich, sobald jemand
         Bestandsführung einschaltet oder eine Variante von Hand deaktiviert —
         also lautlos, an einem Schalter im Shopify-Admin.
         Gesperrt UND benannt, nie ausgegraut ohne Erklärung (`echoa.css`). */
      o.disabled = !v || !v.verfuegbar;
      if (!v) o.textContent = `${o.value} – in dieser Ausführung nicht erhältlich`;
      else if (!v.verfuegbar) o.textContent = `${o.value} – zurzeit nicht lieferbar`;
      else o.textContent = `${o.value} – ${geld(v.preis)}`;
    });
  }

  /* --- Rahmen ---------------------------------------------------------------
     EINE Achse aus zwei Datenfeldern: die erste Kachel ist „Ohne Rahmen"
     (= Ausführung „Print"), die übrigen sind die Rahmenfarben (= „Gerahmt").
     Darunter bleibt die Variantenstruktur unverändert zweiachsig — die
     Zusammenfassung endet an der Formulargrenze, wie beim Farbmarker. */
  function baueRahmen() {
    const halter = $('[data-rahmenwahl]');
    if (!halter) return;
    const kachel = (wert, name, inhalt) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'rahmen';
      b.dataset.rahmen = wert;
      b.setAttribute('aria-pressed', 'false');
      b.innerHTML = `<span class="rahmen__bild">${inhalt}</span>
        <span class="rahmen__name">${escape(name)}</span>
        <span class="rahmen__preis" data-rahmenpreis></span>`;
      return b;
    };
    halter.innerHTML = '';
    halter.appendChild(kachel('', 'Ohne Rahmen', blattEcke()));
    werteFuer('rahmenfarbe').forEach((farbe) => {
      halter.appendChild(kachel(farbe, farbe, rahmenEcke(rahmenTon(farbe))));
    });
  }

  function rahmenZeichnen() {
    const halter = $('[data-rahmenwahl]');
    if (!halter) return;
    const grund = preisVon('Print', s.groesse, null);
    halter.querySelectorAll('[data-rahmen]').forEach((b) => {
      const farbe = b.dataset.rahmen;
      const gerahmt = Boolean(farbe);
      const cent = gerahmt
        ? preisVon('Gerahmt', s.groesse, farbe)
        : grund;
      const gewaehlt = gerahmt
        ? (s.ausfuehrung === 'Gerahmt' && s.rahmenfarbe === farbe)
        : s.ausfuehrung === 'Print';
      b.setAttribute('aria-pressed', String(gewaehlt));

      const v = findeVariante({
        ...s,
        ausfuehrung: gerahmt ? 'Gerahmt' : 'Print',
        rahmenfarbe: gerahmt ? farbe : null,
      });
      b.disabled = !v || !v.verfuegbar;

      const preis = b.querySelector('[data-rahmenpreis]');
      if (!preis) return;
      if (!v) preis.textContent = 'nicht erhältlich';
      else if (!v.verfuegbar) preis.textContent = 'zurzeit nicht lieferbar';
      else if (!gerahmt) preis.textContent = '';
      else if (cent != null && grund != null) preis.textContent = `+ ${geld(cent - grund)}`;
      else preis.textContent = '';
    });
  }

  /* --- Grundton-Liste wechselt mit dem Look ------------------------------- */
  function grundtoeneSetzen() {
    const liste = D.grundtoene[s.look] || [];
    baueSwatches('grund', liste);
    // Nach dem Neuaufbau ist die alte Wahl weg. Erste Farbe vorwählen, damit
    // der Kunde nie ohne Grundton dasteht.
    s.grund = liste.length ? liste[0].id : null;
    zeichne();
  }

  /* ================================================================== Zeichnen */

  /* --- Farbachse nach dem Andruck (Sascha, 09.09.2026, Option A) ----------
     Der Liste-B-Ton wird am FERTIGEN Blatt durchgeschaltet — 0 $, kein
     Render, kein Kontingent (`GET /api/kandidat/<id>/ton.png`). Sichtbar nur,
     wenn der Look einen Ton trägt: Aussparung (A1/A5/A8) oder Linolschnitt
     (C1). Der Kontroll-Look und die Kids haben keinen. Die Reihe wird aus
     Liste B gebaut (`D.grundtoene.dunkel`), nie aus einer zweiten Liste. */
  const TON_LOOKS = new Set(['aussparung', 'linolschnitt']);
  function tonSichtbar() {
    return s.phase === 'fertig' && TON_LOOKS.has(s.brief.look || '') && Boolean(s.kandidatId);
  }
  function tonwahlBauen() {
    const reihe = $('[data-tonwahl]');
    if (!reihe || reihe.childElementCount) return;
    LISTE_B().forEach((t) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'marker';
      b.dataset.tonwert = t.id;
      b.setAttribute('aria-pressed', 'false');
      b.innerHTML = `<span class="marker__kreis" style="${attr(`--farbe: ${t.hex}`)}" aria-hidden="true"></span>
        <span class="marker__name">${escape(t.label)}</span>`;
      reihe.appendChild(b);
    });
  }
  /* --- Vorschau am Look-Marker VOR dem Andruck (Teil 2 der Farbachse,
     Sascha 09.09.2026: „ich klicke sie und erwarte, dass irgendetwas
     passiert"). Solange kein Andruck existiert, tauscht die Bühne auf ein
     vorgerendertes Beispielblatt in Look und Ton (`D.tonbeispiele`, zwölf
     Kacheln aus echten Andrucken, 0 $); der Kontroll-Look holt das
     Startbild zurück — außer beim Moment: dort springt „Farbig" seit
     30.09.2026 auf die eigene Galerie-Kachel `machart-kontrolle` (Nyhavn). Nach dem Andruck übernimmt die echte Achse oben. */
  const BAUTYP_JE_HANDLE = { 'icon-grid': 'a1', 'momentaufnahme': 'a5',
                             'weg-chronik': 'a8', 'orts-print': 'c1',
                             /* Kids (23.09.2026): nur für `data-blattfit`
                                („mitte"); Ton-Bilder gibt es dort nicht,
                                `tonSichtbar()` bleibt über den Look aus. */
                             'wortschatz': 'k2', 'jahreszahl': 'c2', 'zitat': 'k3',
                             'gaming': 'g1',
                             'haustier': 'h1', 'pferd': 'h1',
                             'strecke': 's1', 'wanderung': 's1', 'rezept': 'r1' };
  let buehneStart = '';
  /* `lookBeispielZeigen` läuft bei JEDER Brief-Eingabe (`eingabeGeaendert`).
     Springen und tauschen darf die Galerie aber nur auf einen KLICK auf eine
     Stil-, Marker- oder Achsen-Kachel — beim Tippen nie. Der Chip-Handler
     setzt diesen Merker um genau seinen eigenen `eingabeGeaendert()`-Aufruf.
     ⏪ Bis 29.09.2026 stand hier ein Merker der letzten WAHL, verglichen mit
     der jetzigen. Er zog bei Wechseln NACH dem Andruck nicht nach (Achse über
     `achsen.png`, Ton über `tonNurWechsel`, Entwurf aus der Leiste) — der
     nächste Tastendruck galt dann als Änderung und tauschte das eigene,
     gerade verworfene Blatt gegen ein Beispiel (code-pruefer, BELEGT). */
  let markerKlick = false;
  /* Steht gerade ein Kachel-Beispiel (statt des Startbilds) auf dem Blatt? */
  let beispielAufBlatt = false;
  function lookBeispielZeigen() {
    if (s.phase !== 'leer' || s.kandidatId) return;
    /* Pixel-Paar: kein Look, das Weltbeispiel legt `gamingTorZeichnen`. */
    if (istGaming()) return;
    /* 🔴 NIE über einen eigenen Andruck (code-pruefer 09.09.2026, T2): sobald
       die Sitzung Entwürfe kennt, bleibt die Bühne, wie sie ist — sonst
       ersetzte ein Tippfehler im Namen den Render des Kunden durch ein
       fremdes Beispiel, ohne Etikett. Die Vorschau gilt nur VOR dem ersten
       Andruck. */
    /* ⏪ 25.09.2026 (Sascha: „Wahl der Akzentfarbe hat in der Galerie keinen
       Effekt … öffne ich ein neues Fenster, ist der Fehler weg"): hier stand
       der Historie-Riegel, und er sperrte auch den SPRUNG auf die Farbtafel —
       sobald die Sitzung (sessionStorage, je Tab) einen Entwurf kannte, tat
       der Marker in der Galerie nichts mehr. Der Riegel schützt aber nur das
       Überschreiben des BLATTS (unten, Rückfall ohne Tafeln); der Sprung
       auf eine eigene Tafel lässt den Andruck unberührt. */
    let entwuerfe = 0;
    /* Nur Entwürfe DIESES Konzepts — ein Entwurf eines anderen Konzepts ist kein Grund,
       das Beispiel auf dem Blatt nicht zu tauschen (19.10.2026). */
    try {
      entwuerfe = historieLesen().filter((e) => e.handle === D.produkt.handle).length;
    } catch { entwuerfe = 0; }
    const look = s.brief.look || 'kontrolle';
    const ton = s.brief.grund || s.brief.tinte || '';
    /* ⏪ 10.09.2026 (Sascha, Option A): die Beispiele sind jetzt eigene
       Galerie-Tafeln (`farbe-<ton>`, `machart-<look>` in `echoa-pdp.liquid`).
       Der Marker SPRINGT auf die Tafel, statt das Blatt zu überschreiben —
       damit bleibt die Blatt-Bühne immer das Produktbild, und die Kachel
       daneben zeigt, wohin gesprungen wurde. Kontrolle/Gemalt → Blatt.
       ⏪ 29.09.2026 (Sascha): die `farbe-<ton>`-Tafeln gibt es nicht mehr —
       der Farbton landet unten auf dem Blatt (`tonBild`). Übrig sind
       `machart-lexikon` beim Wortschatz und seit 30.09.2026
       `machart-kontrolle` (Farbig) beim Moment. */
    /* 🔴 Eine eigene `machart-<look>`-Tafel gewinnt auch bei `kontrolle`
       (30.09.2026: „Farbig" beim Moment hat seine Galerie-Kachel, Nyhavn).
       Ohne diese Tafel bleibt Kontrolle beim Blatt — A1/A8/C1 wie bisher. */
    /* Machart-Tafeln nur für das Produkt, mit dem die Seite geladen wurde (code-pruefer
       20.10.2026, BELEGT: Einstieg über den Moment, Wechsel auf „Nur der Ort" + „Farbig"
       sprang auf die Paar-Tafel des Moments). */
    const tafel = D.produkt.handle === galerieHandle && D.produkt.handle === START_HANDLE
      && document.querySelector(`[data-tafel="machart-${look}"]`) ? `machart-${look}`
      : look === 'kontrolle' ? 'blatt'
      : document.querySelector(`[data-tafel="farbe-${ton}"]`) && ton ? `farbe-${ton}`
      : 'blatt';
    /* Die kostenlosen Kids-Achsen (Muster, Farbwelt), 29.09.2026. */
    const achsenBild = achsenBeispielUrl();
    /* 🔴 Nur ein Klick springt (`markerKlick`, siehe dort). Auch der erste
       Tastendruck nicht — bei K2 mit `?look=lexikon` sprang die Galerie sonst
       vom Raum auf die Lexikon-Tafel, ohne Anlass (`code-pruefer` 10.09.2026). */
    const geaendert = markerKlick;
    if (geaendert) ansichtWechseln(tafel);
    /* Rückfall für Läufe ohne Tafeln (z. B. Konfigurator ohne Galerie):
       wie bisher das Blatt tauschen. */
    if (tafel !== 'blatt') {
      /* 🔴 Ein zuvor gelegtes Beispiel (z. B. Terrakotta) nicht auf der
         Blatt-Tafel liegen lassen, wenn die Wahl auf eine eigene Tafel
         springt (code-pruefer 30.09.2026: sonst zeigte das Blatt Terrakotta,
         während „Farbig" gewählt ist). */
      /* Nie über einem eigenen Entwurf — dieselbe Sperre wie weiter unten
         (`eigenerEntwurf`); der Merker kann dort noch vom Klick VOR dem
         Andruck stehen (code-pruefer Runde 2, 30.09.2026). */
      if (beispielAufBlatt && geaendert) {
        const b = document.querySelector('[data-tafel="blatt"] .buehne__bild');
        const eigen = Boolean(b) && (/\/api\/kandidat\//.test(b.src)
          || Boolean(BACKEND && b.src.startsWith(BACKEND)));
        if (b && buehneStart && !eigen) { b.removeAttribute('srcset'); b.src = buehneStart; }
        beispielAufBlatt = false;
      }
      return;
    }
    const blatt = document.querySelector('[data-tafel="blatt"] .buehne__bild');
    if (!blatt) return;
    if (!buehneStart) buehneStart = blatt.src;
    /* 🔴 KIDS-ACHSEN VOR DEM ANDRUCK (Sascha, 29.09.2026: „wenn ich auf der
       Zitate-PDP die helle Variante anwähle, soll die Galerie schon mal die
       helle Variante anzeigen"). Das Bild der gewählten Kachel (Muster bzw.
       Farbwelt, dasselbe Beispielblatt durch den Setzer, 0 $) kommt aufs
       Blatt. Getauscht wird NUR auf einen Klick hin (`geaendert`) — beim
       Tippen eines Namens bleibt die Bühne, wie sie ist. Der Historie-Riegel
       darunter gilt hier bewusst nicht: er sperrte die Vorschau für jeden,
       der in diesem Tab schon einmal einen Entwurf hatte, und über einem
       verworfenen Andruck ist der Klick des Kunden die Anweisung. */
    /* Dasselbe für eine Stil-Kachel ohne eigene Galerie-Tafel (Orts-Print
       „Linolschnitt" ohne gewählte Tinte, 29.09.2026): ihr Kachelbild. */
    /* 🔴 UND FÜR DEN FARBTON (A1/A5/A8/C1, Sascha 29.09.2026: „einheitlich
       lösen, so wie beim Wortschatz und beim Zitat"). Die Farbton-Tafeln in der
       Galerie sind weg — sie schoben die Interiors nach hinten. Das Beispiel
       aus `D.tonbeispiele` kommt jetzt aufs Blatt. Es steht VOR dem Stilbild:
       bei C1 mit gewählter Tinte ist das eingefärbte Blatt die genauere
       Antwort als die Linolschnitt-Kachel ohne Tinte. */
    /* 🔴 NIE ÜBER DEN EIGENEN ENTWURF (code-pruefer 29.09.2026, BELEGT): nach
       einem fertigen „Hell"-Andruck setzt `eingabeGeaendert` Phase und
       Kandidat zurück, bevor es hierher kommt — der Riegel oben greift dann
       nicht, und ein Farbklick legte ein FREMDES Beispiel über den Andruck des
       Kunden, ohne Etikett, neben „dein Blatt wird neu gezeichnet". Vorher
       sprang der Klick auf eine eigene Farbtafel und das Blatt blieb stehen.
       Deshalb: zeigt das Blatt gerade einen Entwurf aus dem Backend, bleibt es. */
    const eigenerEntwurf = /\/api\/kandidat\//.test(blatt.src)
      || Boolean(BACKEND && blatt.src.startsWith(BACKEND));
    /* Steht ein eigener Entwurf da, liegt kein Beispiel mehr auf dem Blatt —
       sonst holte der Rückweg unten („Hell"/„Farbig") das Startbild über den
       Entwurf (code-pruefer Runde 2, 29.09.2026, BELEGT). */
    if (eigenerEntwurf) beispielAufBlatt = false;
    const bautypTon = tonBautyp(D.produkt.handle);
    const tonBild = bautypTon && look !== 'kontrolle' && ton && !eigenerEntwurf
      ? ((D.tonbeispiele || {})[`${bautypTon}_${look}_${ton}`] || '') : '';
    /* ⏪ 22.10.2026 abends: hier zeigte ein Tipp auf „Verbindungslinien" acht konstruierte v2-Blätter.
       Sascha: „ich würde bei der Deutschlandkarte bleiben wollen" — Linien und Markierungen zeigen
       sich am eigenen Entwurf; der Knopf trägt dafür ein Zeichen (`LINIEN_ZEICHEN`). */
    const beispiel = achsenBild || tonBild || stilBeispielUrl();
    if (beispiel) {
      if (!geaendert) return;
      blatt.removeAttribute('srcset');
      if (blatt.src !== beispiel) blatt.src = beispiel;
      beispielAufBlatt = true;
      return;
    }
    /* Zurück auf eine Wahl ohne Beispiel (z. B. „Farbig" bei A1/A8/C1; beim
       Moment springt „Farbig" seit 30.09.2026 auf die eigene Kachel): das Startbild
       zurückholen, das der Klick oben verdrängt hat — auch über den
       Historie-Riegel hinweg, sonst bliebe das fremde Beispiel stehen. */
    if (beispielAufBlatt && geaendert) {
      blatt.removeAttribute('srcset');
      blatt.src = buehneStart;
      beispielAufBlatt = false;
      return;
    }
    if (entwuerfe) return;          /* nie das Blatt über einem eigenen Entwurf tauschen */
    /* `image_tag` schreibt ein `srcset`; solange es steht, ist `src` für den
       Browser kein Kandidat. Weg damit — wie in `vorschauSetzen`. */
    blatt.removeAttribute('srcset');
    const bautyp = tonBautyp(D.produkt.handle);
    const hatTafeln = Boolean(document.querySelector('[data-tafel^="farbe-"], [data-tafel^="machart-"]'));
    if (eigenerEntwurf) return;     /* derselbe Riegel wie bei `tonBild` oben */
    const url = !hatTafeln && bautyp && look !== 'kontrolle' && ton
      ? (D.tonbeispiele || {})[`${bautyp}_${look}_${ton}`] : '';
    const ziel = url || buehneStart;
    if (blatt.src !== ziel) blatt.src = ziel;
  }

  /** Beispielbild der gewählten Kids-Achse (Muster, Farbwelt) aus
      `D.stilbilder` — '' wenn das Produkt keine hat oder das Feld gerade
      ausgeblendet ist (Muster nur bei der gemalten Machart). Achsen des
      Schritts II (Passepartout) zählen nicht: die gibt es erst nach dem
      Andruck. */
  function achsenBeispielUrl() {
    for (const f of briefDef().felder || []) {
      if (!ACHSEN_FELDER.has(f.name) || f.schritt === 'ausfuehrung') continue;
      /* `werte` mitlesen (Wortschatz-Hintergrund gilt für zwei Stile, 22.10.2026). */
      if (f.nurWenn && !(f.nurWenn.werte ? f.nurWenn.werte.includes(s.brief[f.nurWenn.feld])
        : s.brief[f.nurWenn.feld] === f.nurWenn.wert)) continue;
      const opt = (f.optionen || []).find((o) => o.id === s.brief[f.name]);
      /* Wortschatz-Pop: das Bild hängt zusätzlich am Stil (`k2p_kobalt_linol`). */
      const url = opt && opt.bild ? ((D.stilbilder || {})[`${opt.bild}_${s.brief.look}`]
        || (D.stilbilder || {})[opt.bild]) : '';
      if (url) return url;
    }
    return '';
  }

  /** Kachelbild der gewählten Stil-Option des Feldes `look` (nur `typ:
      'stil'`, nie der Kontroll-Look — der ist das Startbild). */
  /* 🆕 BEISPIELE JE TIERART (Sascha, 22.10.2026: „zusätzliche Bilder für Katzen oder andere
     Kleintiere … wenn jemand diese wählt oder über eine Anzeige auf die Seite kommt"). Bis heute
     zeigten Bühne und Machart-Kacheln beim Haustier immer einen Hund, auch nach „Katze" oder
     `?tier=katze`. Jetzt `<schlüssel>_<suffix>` aus `D.stilbilder`, Rückfall der Hund-Schlüssel
     ohne Suffix. Kaninchen, Meerschweinchen und „Anderes" teilen den Kleintier-Satz (Krümel). */
  function tierSuffix() {
    if (D.produkt.handle !== 'haustier') return '';
    const art = s.brief.art || '';
    if (art === 'katze') return 'katze';
    if (['kaninchen', 'meerschweinchen', 'kleintier'].includes(art)) return 'kleintier';
    return 'hund';
  }
  function tierBild(schluessel) {
    const sb = D.stilbilder || {};
    const suf = tierSuffix();
    return (suf && sb[`${schluessel}_${suf}`]) || sb[schluessel] || '';
  }
  /** Bildkacheln, deren Bild von einer anderen Wahl abhängt (22.10.2026): Haustier-Styling folgt
      dem Tier, Wortschatz-Hintergrund dem Stil (`bildJeLook`). Die Machart-Kacheln regelt
      `tierKachelnSetzen` darunter. */
  function kachelBilderSetzen() {
    const sb = D.stilbilder || {};
    (briefDef().felder || []).forEach((f) => {
      if (f.typ !== 'stil' || !(f.bildJeLook || (istHaustier() && f.name === 'styling'))) return;
      briefHalter()?.querySelectorAll(`.stilkachel[data-brieffeld="${f.name}"]`).forEach((b) => {
        const opt = (f.optionen || []).find((o) => o.id === b.dataset.wert);
        if (!opt || !opt.bild) return;
        const url = f.bildJeLook ? (sb[`${opt.bild}_${s.brief.look || ''}`] || sb[opt.bild] || '')
          : tierBild(opt.bild);
        let img = b.querySelector('img');
        if (!url) return;
        if (!img) {
          img = document.createElement('img');
          img.alt = ''; img.loading = 'lazy'; img.width = 300; img.height = 400;
          b.querySelector('.stilkachel__bild')?.appendChild(img);
        }
        if (img.getAttribute('src') !== url) img.setAttribute('src', url);
      });
    });
  }
  /** Die Machart-Kacheln (Magazin · Kohle · Illustration) zeigen das gewählte Tier. */
  function tierKachelnSetzen() {
    kachelBilderSetzen();
    if (!istHaustier()) return;
    const k = D.produkt.handle === 'pferd' ? 'h2' : 'h1';
    briefHalter()?.querySelectorAll('.stilkachel[data-brieffeld="stil"]').forEach((b) => {
      const img = b.querySelector('img');
      const opt = (briefDef().felder.find((f) => f.name === 'stil')?.optionen || [])
        .find((o) => o.id === b.dataset.wert);
      if (!img || !opt) return;
      const url = b.dataset.wert === 'illustration' ? tierBild(`${k}_farbig`) : tierBild(opt.bild);
      if (url && img.getAttribute('src') !== url) img.setAttribute('src', url);
    });
  }

  /** Haustier: die Raum-Beispiele zeigen bei „Katze" Mila (Satz »h1k«), sonst den gemischten Satz
      »h1t« (22.10.2026). Nur die BEISPIEL-Ebene vor dem Andruck — die Montage mit dem eigenen
      Entwurf (`raumPosterSetzen`) bleibt unberührt. */
  function raumTierSetzen() {
    if (D.produkt.handle !== 'haustier' || !D.raum_tier) return;
    const setze = (img, url) => {
      if (!img || !url || img.getAttribute('src') === url) return;
      img.removeAttribute('srcset');
      img.setAttribute('src', url);
    };
    const satz = D.raum_tier[tierSuffix() === 'katze' ? 'katze' : 'hund'] || {};
    Object.entries(satz).forEach(([r, url]) => {
      setze(document.querySelector(`[data-tafel="raum-${r}"] [data-raum-beispiel]`), url);
      setze(document.querySelector(`.pdp__kachel[data-ansicht="raum-${r}"] img`), url);
    });
    /* Die Machart-Kacheln der Galerie (Kohle, Lexikon) ebenso — Rückfall der Hund. */
    [['kohle', 'h1m_kohle'], ['lexikon', 'h1_lexikon'], ['linie', 'h1m_linie']].forEach(([m, k]) => {
      const url = tierBild(k);
      setze(document.querySelector(`[data-tafel="machart-${m}"] img`), url);
      setze(document.querySelector(`.pdp__kachel[data-ansicht="machart-${m}"] img`), url);
    });
  }

  /* 🆕 MACHART ALS EINE REIHE (Stufe 2, 22.10.2026; Pferd-Bild: „Machart und Variante in einer Reihe
     (heute zwei Ebenen)"). Haustier/Pferd: Magazin · Kohle · Porträt · Lexikon statt Magazin · Kohle ·
     Illustration und darunter Porträt/Lexikon. Rezept: Rezept · Lexikon mit Bild · Lexikon ohne Bild.
     🔴 DIE FELDER DARUNTER BLEIBEN DIE WAHRHEIT. Eine Kachel klickt nur die vorhandenen Knöpfe von
     `stil`/`machart` bzw. `machart`/`bild` in dieser Reihenfolge — derselbe Weg wie ein Kundenklick
     (nurWenn, Beispiel auf der Bühne, Brief). Deshalb gelten Feldnamen, IDs und die Anzeigen-Links
     (`?machart=`, `?aufbau=`) unverändert, und `ablauf-selbsttest.py` prüft sie weiter. Die
     Original-Knöpfe sind nur ausgeblendet (`kombi--verdeckt`), nicht entfernt. */
  function kombiDef() {
    const h = D.produkt.handle;
    if (HAUSTIER_HANDLES.has(h)) {
      if (!briefDef().felder.some((f) => f.name === 'stil')) return null;
      const k = h === 'pferd' ? 'h2' : 'h1';
      return { traeger: 'stil', verdeckt: ['machart'], kacheln: [
        { id: 'magazin', label: 'Magazin', hinweis: 'Dein Foto, der Name als Titel', setze: [['stil', 'magazin']], bild: `${k}m_magazin_ohne` },
        { id: 'kohle', label: 'Kohle', hinweis: 'Von Hand gezeichnet', setze: [['stil', 'kohle']], bild: `${k}m_kohle` },
        { id: 'portraet', label: 'Porträt', hinweis: 'Flach gemalt, mit Name', setze: [['stil', 'illustration'], ['machart', 'portraet']], bild: `${k}_farbig` },
        { id: 'lexikon', label: 'Lexikon', hinweis: 'Wie im Wörterbuch', setze: [['stil', 'illustration'], ['machart', 'lexikon']], bild: `${k}_lexikon` },
        ...(LINIE_AN ? [{ id: 'linie', label: 'Linie', hinweis: 'Eine einzige Linie', setze: [['stil', 'linie']], bild: `${k}m_linie` }] : []),
      ] };
    }
    if (istRezept()) {
      return { traeger: 'machart', verdeckt: ['bild'], kacheln: [
        { id: 'rezept', label: 'Rezept', hinweis: 'Gericht, Zutaten, Zubereitung', setze: [['machart', 'rezept']], bild: 'r1_rezept_farbig' },
        { id: 'lexikon', label: 'Lexikon', hinweis: 'Mit Bild des Gerichts', setze: [['machart', 'lexikon'], ['bild', 'an']], bild: 'r1_lexikon_farbig' },
        { id: 'lexikon_text', label: 'Lexikon ohne Bild', hinweis: 'Nur Text', setze: [['machart', 'lexikon'], ['bild', 'aus']], bild: 'r1_lexikon_ohne_bild' },
      ] };
    }
    return null;
  }
  function kombiGedrueckt(feld) {
    const b = briefHalter()?.querySelector(`[data-brieffeld="${feld}"][aria-pressed="true"]`);
    return b ? b.dataset.wert : '';
  }
  function kombiZeichnen() {
    const def = kombiDef();
    const halter = briefHalter();
    if (!def || !halter) return;
    const traeger = halter.querySelector(`[data-brieffeld-halter="${def.traeger}"]`);
    if (!traeger) return;
    let reihe = traeger.querySelector('[data-kombi-reihe]');
    if (!reihe) {
      reihe = document.createElement('div');
      reihe.className = 'stilwahl kombi';
      reihe.dataset.kombiReihe = '';
      reihe.setAttribute('role', 'group');
      reihe.setAttribute('aria-label', 'Machart');
      reihe.style.setProperty('--stil-spalten', String(def.kacheln.length));
      /* Eine Seite: drei Spalten auch am Handy (dort sonst fest zwei) — fünf Macharten (Haustier, Pferd) kosteten in
         zwei Spalten allein 889 px, mehr als eine Bildschirmhöhe (375 px, gemessen 28.10.2026). */
      if (eineSeite() && def.kacheln.length >= 3) {
        reihe.classList.add(EINE_SEITE_MACHART_REIHE && def.kacheln.length > 3 ? 'stilwahl--fuenf' : 'stilwahl--drei');
      }
      reihe.innerHTML = def.kacheln.map((k) => `<button type="button" class="stilkachel" data-kombi="${attr(k.id)}" aria-pressed="false">
          <span class="stilkachel__bild"><img alt="" loading="lazy" width="300" height="400"></span>
          <span class="stilkachel__name">${escape(k.label)}</span>
          <span class="stilkachel__zusatz">${escape(k.hinweis)}</span></button>`).join('');
      const alt = traeger.querySelector('.stilwahl, .optionen');
      if (alt) { alt.classList.add('kombi--verdeckt'); alt.insertAdjacentElement('afterend', reihe); }
      else traeger.appendChild(reihe);
      def.verdeckt.forEach((n) => halter.querySelector(`[data-brieffeld-halter="${n}"]`)?.classList.add('kombi--verdeckt'));
    }
    def.kacheln.forEach((k) => {
      const b = reihe.querySelector(`[data-kombi="${k.id}"]`);
      if (!b) return;
      b.setAttribute('aria-pressed', String(k.setze.every(([f, w]) => kombiGedrueckt(f) === w)));
      const img = b.querySelector('img');
      const url = tierBild(k.bild);
      if (img && url && img.getAttribute('src') !== url) img.setAttribute('src', url);
    });
  }
  function kombiWaehlen(id) {
    const def = kombiDef();
    const k = def && def.kacheln.find((x) => x.id === id);
    const halter = briefHalter();
    if (!k || !halter) return;
    k.setze.forEach(([feld, wert]) => {
      const b = halter.querySelector(`[data-brieffeld="${feld}"][data-wert="${wert}"]`);
      if (b && b.getAttribute('aria-pressed') !== 'true' && !b.disabled) b.click();
    });
    kombiZeichnen();
    schrittHinweisPruefen();
  }

  function stilBeispielUrl() {
    /* Haustier Magazin/Kohle (20.10.2026): das Beispiel der Machart, beim Magazin
       je Styling. Illustration fällt durch auf die Farb-Marker unten. */
    if (istHaustier() && ['magazin', 'kohle'].includes(s.brief.stil)) {
      const p = D.produkt.handle === 'pferd' ? 'h2m' : 'h1m';
      const k = s.brief.stil === 'kohle' ? `${p}_kohle` : `${p}_magazin_${s.brief.styling || 'ohne'}`;
      /* Styling ohne eigenes Tierbild (Katze mit Seidentuch) → dasselbe Tier ohne Styling,
         nie ein Hund mit Seidentuch auf einer Katzen-Seite. */
      const suf = tierSuffix();
      const sb = D.stilbilder || {};
      const ohne = `${p}_magazin_ohne_${suf}`;
      const schluessel = (suf && sb[`${k}_${suf}`]) ? `${k}_${suf}`
        : (suf && suf !== 'hund' && s.brief.stil === 'magazin' && sb[ohne]) ? ohne : k;
      /* 🆕 Titelfarbe (Sascha, 22.10.2026 abends: „die farbigen Knöpfe sollten auch direkt den Titel
         oben im Bild ändern"): je Beispiel ein Satz in den fünf Titelfarben, gesetzt aus demselben
         Render (`nischen-shopbilder.py titelfarben`, 0 $). Neongelb ist das Grundbild. */
      const tf = s.brief.stil === 'magazin' ? s.brief.titelfarbe : '';
      if (tf && tf !== 'neongelb' && sb[`${schluessel}_${tf}`]) return sb[`${schluessel}_${tf}`];
      return sb[schluessel] || '';
    }
    /* 🆕 Rezept (22.10.2026): Machart, Bild und Farbe zeigen ihr Beispiel auf der Bühne — gemessen
       am Live-Shop änderte keine der zwölf Rezept-Wahlen das Bild. Gugelhupf-Blätter aus dem
       Satzweg (`galerie-tier-im-raum.py rezept-kacheln`), die Farbe steht seit heute nach dem
       Andruck, das Beispiel folgt ihr trotzdem, solange kein Andruck steht. */
    if (istRezept()) {
      const sb = D.stilbilder || {};
      if (s.brief.machart === 'lexikon' && s.brief.bild === 'aus' && sb.r1_lexikon_ohne_bild) {
        return sb.r1_lexikon_ohne_bild;
      }
      const m = s.brief.machart === 'lexikon' ? 'lexikon' : 'rezept';
      return sb[`r1_${m}_${s.brief.look || 'farbig'}`] || '';
    }
    /* 🆕 Lexikon-Eintrag (22.10.2026): die Variante zeigt ihr Beispiel auf der Bühne. Gemessen
       am Live-Shop: der Klick auf „Lexikon-Eintrag" änderte das Bild nicht (Haustier, Pferd). */
    if (istHaustier() && s.brief.machart === 'lexikon'
        && (!s.brief.stil || s.brief.stil === 'illustration')) {
      const u = tierBild(`${D.produkt.handle === 'pferd' ? 'h2' : 'h1'}_lexikon`);
      if (u) return u;
    }
    /* Linie (28.10.2026, Saschas Frage „sieht er oben immer, wie seine Auswahl aussieht?", gemessen: nein) —
       ohne diesen Zweig fiel die Bühne aufs Produktbild zurück; jetzt dasselbe Bild wie die Kachel. */
    /* Beide neuen Zweige nie über einem eigenen (gerade verworfenen) Entwurf — dieselbe Sperre wie `tonBild`
       (code-pruefer 28.10.2026, BELEGT: Andruck in Magazin, dann Tipp auf Linie legte das Beispiel darüber). */
    const blattJetzt = document.querySelector('[data-tafel="blatt"] .buehne__bild');
    const ueberEntwurf = Boolean(blattJetzt) && (/\/api\/kandidat\//.test(blattJetzt.src)
      || Boolean(BACKEND && blattJetzt.src.startsWith(BACKEND)));
    if (istHaustier() && s.brief.stil === 'linie' && !ueberEntwurf) {
      const u = tierBild(`${D.produkt.handle === 'pferd' ? 'h2' : 'h1'}m_linie`);
      if (u) return u;
    }
    /* 🆕 Linie und Porträt (30.10.2026, Sascha: „Beim Wechsel zwischen den Stilen … vor dem Entwurf wechselt das
       Galeriebild oben nicht mit"): die Farbe allein bestimmte das Bild unten (`look` → `l1_<grund>`), die Machart nie.
       Jetzt Machart UND Farbe: Linie je Grund `l1_<grund>`, Pinsel je Grund `l1_pinsel_<grund>` (Papier = `l1_pinsel`).
       Beim Porträt sind die Grund-Bilder Pinsel (`galerie_portraet.py`), Kohle steht nur auf Papier. */
    /* Über dem eigenen (gerade verworfenen) Entwurf kein Beispiel — auch nicht über den Farb-Rückfall unten
       (code-pruefer 30.10.2026: Machart-Wechsel nach dem Andruck legte sonst `l1_<grund>` ohne Etikett darüber). */
    if (['linie', 'portraet'].includes(D.produkt.handle)) {
      if (ueberEntwurf) return '';
      const sb = D.stilbilder || {};
      const grund = s.brief.look || 'papier';
      if (D.produkt.handle === 'portraet') {
        const u = s.brief.stil === 'pinsel' ? (sb[`p1_${grund}`] || sb.p1_pinsel) : sb.p1_kohle;
        if (u) return u;
      } else {
        const u = s.brief.stil === 'pinsel'
          ? (grund === 'papier' ? sb.l1_pinsel : sb[`l1_pinsel_${grund}`] || sb.l1_pinsel)
          : (sb[`l1_${grund}`] || sb.l1_linie);
        if (u) return u;
      }
    }
    /* 🆕 Moment „Farbig" (30.10.2026, Saschas »A, Dunkel oben«): oben steht jetzt Dunkel, also braucht Farbig
       ein eigenes Beispiel — sonst holte der Rückweg das Startbild (Dunkel) zurück. */
    if (D.produkt.handle === 'momentaufnahme' && s.brief.look === 'kontrolle' && !ueberEntwurf
        && (D.stilbilder || {}).a5s_farbig) {
      return D.stilbilder.a5s_farbig;
    }
    /* Orts-Print „Abend" (28.10.2026, gleiche Messung): die Stimmung wechselte das Bild nicht. Nur Farbig —
       beim Linol zeigt die Tinte ihr Beispiel (`tonBild`), ein Abend-Linol-Bild gibt es nicht. */
    /* Am gedrückten Knopf gelesen, nicht an `s.brief` (wie `magazinGewaehlt`): zurück von Linol auf Farbig ist
       die Stimmung im Brief noch leer, weil sie beim Linol versteckt war (Handy-Probe 28.10.2026). */
    const stimmung = briefHalter()?.querySelector('[data-brieffeld="stimmung"][aria-pressed="true"]')?.dataset.wert
      || s.brief.stimmung;
    if (D.produkt.handle === 'orts-print' && stimmung === 'abend' && !ueberEntwurf
        && (!s.brief.look || s.brief.look === 'kontrolle') && (D.stilbilder || {}).c1_abend) {
      return D.stilbilder.c1_abend;
    }
    /* Zitat-Pop (20.10.2026): das gewählte Poster (`beispiel: true`). */
    const bf = (briefDef().felder || []).find((x) => x.beispiel && s.brief[x.name]);
    const bo = bf && (bf.optionen || []).find((o) => o.id === s.brief[bf.name]);
    if (bo && bo.bild && (D.stilbilder || {})[bo.bild]) return D.stilbilder[bo.bild];
    const look = s.brief.look;
    if (!look || look === 'kontrolle') return '';
    /* Auch Marker mit Bild (Haustier/Pferd, 19.10.2026) — nicht nur Stil-Kacheln. */
    const f = (briefDef().felder || []).find(
      (x) => x.name === 'look' && (x.typ === 'stil' || x.typ === 'marker'));
    const opt = f && (f.optionen || []).find((o) => o.id === look);
    return opt && opt.bild ? tierBild(opt.bild) : '';
  }

  /* --- Kachel → Marker (die andere Richtung der Kopplung) -----------------
     Klick auf eine Farbton- oder Machart-Kachel wählt den passenden Marker im
     Konfigurator, solange kein eigener Andruck existiert (derselbe Riegel wie
     oben). Programmatischer `click()` auf den Chip, damit der EINE Chip-Pfad
     (aria-pressed, `eingabeGeaendert`, Achsen-URL) läuft und keine zweite
     Schreibweise entsteht. Ist der Chip schon gedrückt, passiert nichts. */
  function farbkachelWaehlen(kachel) {
    if (!wurzel) return;
    if (s.phase !== 'leer' || s.kandidatId) return;
    /* ⏪ 25.09.2026: kein Historie-Riegel mehr — ein Kachelklick wählt nur den
       Marker (eine Brief-Änderung wie jeder Klick); er überschreibt nichts. */
    const handle = D.produkt.handle;
    const chips = [];
    const chip = (feld, wert) => wurzel.querySelector(
      `[data-brieffeld="${feld}"][data-wert="${wert}"]:not([disabled])`);
    if (kachel.dataset.farbkachel) {
      const ton = kachel.dataset.farbkachel;
      const zweig = (LOOKS_JE_HANDLE[handle] || [])[1];
      if (!zweig) return;
      /* A1/A5/A8: ein Marker trägt Look UND Ton. C1: Stil-Kachel plus
         Tinte-Marker, in dieser Reihenfolge — die Tinte ist erst sichtbar,
         wenn der Schnitt gewählt ist. */
      const kombi = chip('look', `${zweig}:${ton}`);
      if (kombi) chips.push(kombi);
      else { chips.push(chip('look', zweig)); chips.push(chip('tinte', ton)); }
    } else if (kachel.dataset.machartkachel) {
      chips.push(chip('look', kachel.dataset.machartkachel)
        /* Linien-Seite (Variante 3: „Galeriebild antippen wählt den Stil"): die Machart heißt dort `stil`. */
        || (['linie', 'portraet'].includes(handle) ? chip('stil', kachel.dataset.machartkachel) : null));
    }
    chips.filter(Boolean).forEach((c) => {
      if (c.getAttribute('aria-pressed') !== 'true') c.click();
    });
  }

  /** Ist dieser Marker-Klick nur ein anderer Liste-B-Ton DESSELBEN Looks —
      also ein Wechsel, den `ton.png` ohne Render leistet? Liefert die Ton-ID
      oder ''. Gilt nur bei fertigem, echtem Andruck; vor dem Andruck bleibt
      alles beim Brief-Pfad (Beispieltafeln). */
  function tonNurWechsel(feld, wert) {
    if (s.phase !== 'fertig' || !s.kandidatId || !BACKEND) return '';
    if (String(s.kandidatId).startsWith('sim_')) return '';
    const look = s.brief.look || '';
    if (!TON_LOOKS.has(look)) return '';
    const kennt = (id) => LISTE_B().some((t) => t.id === id);
    if (feld === 'look') {
      const trenner = String(wert || '').indexOf(':');
      if (trenner < 0) return '';
      const zweig = wert.slice(0, trenner);
      const ton = wert.slice(trenner + 1);
      return zweig === look && kennt(ton) ? ton : '';
    }
    if (feld === 'tinte' && look === 'linolschnitt') return kennt(wert) ? wert : '';
    /* Moment in der neuen Maske: der Ton hat ein eigenes Feld `grund` (code-pruefer
       20.10.2026, BELEGT: ohne diese Zeile verwarf ein Farbwechsel den fertigen Andruck). */
    if (feld === 'grund' && look === 'aussparung') return kennt(wert) ? wert : '';
    return '';
  }

  /* --- Der sichtbare Hinweis, dass ein neuer Andruck nötig ist ------------
     Steht direkt unter der Markerreihe, mit zwei Wegen: „Neuen Andruck
     erstellen" (derselbe Pfad wie der große Knopf) und „Doch bei <vorher> bleiben"
     (klickt den vorherigen Marker — der Fingerabdruck holt den Andruck
     kostenlos zurück). Verschwindet mit dem nächsten Andruck oder Klick. */
  function neurenderHinweisVerbergen() {
    document.querySelectorAll('[data-neurender]').forEach((el) => el.remove());
  }
  function neurenderHinweisZeigen(chip, vorher, vorherStand = {}, text = {}) {
    neurenderHinweisVerbergen();
    const reihe = chip.closest('.marker-reihe, .optionen, .stilwahl') || chip.parentElement;
    if (!reihe) return;
    const box = document.createElement('div');
    box.dataset.neurender = '';
    box.className = 'neurender';
    /* `text.name`/`text.vorherName`/`text.zurueck`: für Auslöser, die kein
       Marker sind (die Größenwahl des Orts-Prints, ein <select>) — dort ist
       der Textinhalt des Elements nicht der Name der Wahl. */
    /* 🔴 `.stilkachel__name`, nicht `.stil__name` (Sascha, 30.09.2026, am
       iPhone): die Klasse `.stil__name` gibt es nicht. Der Rückfall las den
       ganzen Kacheltext samt Unterzeile — der Kunde las „Zurück zu »Farbig
       Die typischen Farben des Ortes«". Name ohne Zusatz, und NUR der Name.
       ⏪ „… und kostet nichts" ist raus (Sascha: „für den Nutzer kostet ja
       ohnehin alles nichts, unnötige Information"). */
    const NAMENS_KLASSEN = '.marker__name, .stilkachel__name';
    const name = text.name || (chip.querySelector(NAMENS_KLASSEN) || chip).textContent.trim();
    const sek = D.dauer_sekunden || 50;
    const p = document.createElement('p');
    p.className = 'feld-hilfe neurender__text';
    p.textContent = `Für »${name}« zeichnen wir dein Blatt neu – das dauert etwa ${sek} Sekunden.`;
    box.appendChild(p);
    const zeile = document.createElement('div');
    zeile.className = 'neurender__aktionen';
    const los = document.createElement('button');
    los.type = 'button';
    los.className = 'echoa-aktion';
    los.textContent = 'Neuen Andruck erstellen';
    los.addEventListener('click', () => {
      neurenderHinweisVerbergen();
      const knopf = $('[data-aktion]');
      if (knopf && !knopf.disabled) knopf.click();
    });
    zeile.appendChild(los);
    if ((vorher && vorher !== chip) || text.zurueck) {
      const zurueck = document.createElement('button');
      zurueck.type = 'button';
      zurueck.className = 'echoa-link neurender__zurueck';
      const vName = text.vorherName || (vorher.querySelector(NAMENS_KLASSEN) || vorher).textContent.trim();
      /* „Bei … bleiben" statt „Zurück zu …": der Kunde hat den alten Andruck
         noch im Kopf, nicht einen Ort, zu dem er zurückkehrt (Sascha,
         30.09.2026: „für den Nutzer völlig unverständlich"). */
      zurueck.textContent = `Doch bei »${vName}« bleiben`;
      /* Den Andruck von vorhin zurückholen — samt dem Ton, den der Kunde
         zuletzt darauf gesehen hat (der kann vom gerenderten abweichen,
         s. `tonNurWechsel`). Kennt die Historie ihn nicht, greift `ersatz`:
         beim Marker der Klick auf den alten Marker, bei der Größenwahl
         `eingabeGeaendert()` — jeweils der Fingerabdruck-Weg.
         🔴 `text.zurueck` bekommt DIESEN Weg gereicht statt einen eigenen
         (Befund code-pruefer 23.09.2026): nach einem Farbwechsel ohne
         Neurender trägt der Brief die neue Tinte, der gemerkte Andruck die
         alte — der Fingerabdruck allein fände ihn nicht, und der Kunde
         stünde ohne Andruck da. */
      const standHolen = (ersatz) => {
        const e = vorherStand.kandidat
          && historieLesen().find((x) => x.id === vorherStand.kandidat);
        if (!e) { ersatz(); return; }
        historieWaehlen(e.id);
        /* 🔴 Zurück auf das Blatt (code-pruefer 25.09.): der Marker-Sprung kann
           die Galerie auf eine Beispieltafel gestellt haben — der Kunde sähe
           sonst ein fremdes Blatt neben dem Warenkorb-Knopf seines Entwurfs. */
        ansichtWechseln('blatt');
        const ton = vorherStand.ton;
        if (ton && ton !== s.kandidatTon && tonSichtbar()) {
          const look = s.brief.look || '';
          const tonChip = wurzel.querySelector(
            `[data-brieffeld="look"][data-wert="${look}:${ton}"], [data-brieffeld="tinte"][data-wert="${ton}"], `
            + `[data-brieffeld="grund"][data-wert="${ton}"]`);
          if (tonChip) {
            wurzel.querySelectorAll(`[data-brieffeld="${tonChip.dataset.brieffeld}"]`)
              .forEach((x) => x.setAttribute('aria-pressed', String(x === tonChip)));
            sammleBrief();
          }
          s.ton = ton;
          tonVorschau();
          zeichne();
        }
      };
      zurueck.addEventListener('click', () => {
        neurenderHinweisVerbergen();
        if (text.zurueck) { text.zurueck(standHolen); return; }
        standHolen(() => vorher.click());
      });
      zeile.appendChild(zurueck);
    }
    box.appendChild(zeile);
    reihe.insertAdjacentElement('afterend', box);
  }

  function tonVorschau() {
    if (!s.kandidatId || !BACKEND || !s.ton) return;
    vorschauSetzen(kandidatBildUrl(`${BACKEND}/api/kandidat/${s.kandidatId}/ton.png?ton=${encodeURIComponent(s.ton)}`));
  }

  function zeichne() {
    /* Die Dunkel-Kachel zeigt den Ton — auf JEDEM Weg (kostenloser Tonwechsel, Entwurf aus der
       Leiste, Warenkorb-Rückweg), nicht nur beim Klick (code-pruefer 20.10.2026). */
    stilKachelnTon();
    tierKachelnSetzen();
    raumTierSetzen();
    /* Stufe 2: nach dem ersten Andruck (oder mit Entwurf) keine Schritt-Ansicht mehr. */
    if (s.phase !== 'leer' || s.kandidatId) schritteAus = true;
    schritteZeichnen();
    ankunftZeichnen();
    kaufAnsichtZeichnen();
    gamingTorZeichnen();
    // --- Farbachse
    const blockTon = $('[data-block="ton"]');
    if (blockTon) {
      tonwahlBauen();
      /* ⏪ 22.09.2026: die Reihe bleibt VERSTECKT. Der Ton wird seit heute an
         der Markerreihe in Schritt I gewechselt (`tonNurWechsel`) — zwei
         Farbregler für dieselbe Sache wären die „zwei Hüllen"-Bauform für
         den Kunden. `tonSichtbar()` lebt weiter: es entscheidet, ob »Farbe«
         in die Bestellzeile geht. */
      blockTon.hidden = true;
      $$('[data-tonwert]').forEach((b) => {
        b.setAttribute('aria-pressed', String(s.ton === b.dataset.tonwert));
      });
    }
    // --- Optionszustände
    $$('[data-wahl]').forEach((b) => {
      b.setAttribute('aria-pressed', String(s[b.dataset.wahl] === b.dataset.wert));
    });
    $$('[data-swatch]').forEach((b) => {
      const feld = b.dataset.swatch;
      b.setAttribute('aria-pressed', String(s[feld] === b.dataset.wert));
    });

    /* --- Format und Ausführung erscheinen ERST MIT DEM FERTIGEN ANDRUCK
       (Sascha, 17.08.2026): „den Kunden erstmal generieren lassen, und nach
       Erstellung und Anzeige der Vorschau geht es an die Auswahl von Format
       und Ausführung."

       🔴 AN `s.phase`, NICHT AM KNOPFTEXT — dieselbe Begründung wie beim
       Widerrufs-Hinweis darunter: am Text hinge es am nächsten
       Wortlaut-Wechsel und bräche still.
       ⚠️ Auch während `laeuft` bleibt der Block zu. Die 50 Sekunden mit einer
       Auswahl zu füllen wäre naheliegend und falsch: der Kunde entschiede
       über das Format eines Bildes, das er noch nicht gesehen hat — genau die
       Reihenfolge, die hier gerade abgeschafft wird. */
    const gerahmt = s.ausfuehrung === 'Gerahmt';
    const blockAusfuehrung = $('[data-schritt="ausfuehrung"]');
    if (blockAusfuehrung) blockAusfuehrung.hidden = s.phase !== 'fertig';
    /* Der Rand hängt seit Wortschatz „Gemalt" am Stil, nicht nur am Produkt — bei jedem Zeichnen. */
    const blockRand = $('[data-block="rand"]');
    if (blockRand) blockRand.hidden = !randSichtbar();

    // --- Variante und Preis
    const v = findeVariante();
    const preis = $('[data-preis]');
    /* Vor dem Andruck steht der Preis oben in der Preiszeile als „ab X" —
       hier würde eine zweite, genauere Zahl über einer noch unsichtbaren
       Auswahl stehen. Sie erscheint mit der Auswahl. */
    if (preis) {
      preis.textContent = s.phase === 'fertig' && v ? geld(v.preis) : '';
      preis.hidden = s.phase !== 'fertig' || !v;
    }
    groessenBeschriften();
    rahmenZeichnen();

    /* Findet der Konfigurator gar keine Variante, ist das kein Randfall,
       sondern ein Datenfehler — und ein stilles „—" verbirgt ihn. Am
       03.08.2026 stand er auf allen vier Produkten und fiel niemandem auf. */
    const fehlerZeile = $('[data-fehler]');
    if (!v && fehlerZeile) {
      fehlerZeile.textContent =
        'Diese Kombination gibt es im Katalog nicht. Bitte Format oder Ausführung ändern.';
      fehlerZeile.hidden = false;
    } else if (v && fehlerZeile && /Kombination gibt es im Katalog/.test(fehlerZeile.textContent)) {
      fehlerZeile.hidden = true;
    }

    /* ⏪ 17.08.2026: hier stand die Verfügbarkeitsprüfung über alle
       `[data-wahl]`-Knöpfe. Sie galt Format und Rahmenfarbe — beide sind
       keine `.option`-Knöpfe mehr, sondern `select` und Kachelreihe, und
       beide prüfen ihre Verfügbarkeit jetzt selbst (`groessenBeschriften`,
       `rahmenZeichnen`) mit demselben Grundsatz: nie ausgegraut ohne Wort.
       Übrig blieben nur die Knöpfe der toten Schritt-II-Hülle (Look, Rand),
       die gar keine Varianten-Achse haben — für sie prüfte die Schleife
       immer dieselbe, gerade gewählte Variante und war damit folgenlos. */

    // --- Versandhinweis
    /* ENTSCHEIDUNG 8: der Link, nie ein Betrag. Der frühere Sonderfall
       „Sofort-Download" ohne Link fiel mit „Nur Datei" weg (03.08.2026). */
    const vh = $('[data-versandhinweis]');
    if (vh) {
      vh.innerHTML =
        `<a href="${D.versand_seite || '#'}" class="echoa-link pdp__versandlink">zzgl. Versandkosten</a>`;
      /* ⏪ 19.08.2026 (Sascha): „‚zzgl. Versandkosten‘ steht immer noch bei
         Stufe 1 auf der PDP, dort nicht notwendig, da auch gar kein Preis
         angezeigt wird."
         🔴 DAS IST DIE ZWEITE DER DREI STELLEN. Am 18.08. wurde die Kopie in
         der Preiszeile oben (`[data-versand-oben]`) an die Phase gebunden —
         diese hier blieb stehen, und sie ist die, die im Screenshot über dem
         Knopf „Andruck erstellen" steht. Der Grund ist derselbe wie dort und
         wie beim Widerrufs-Hinweis: eine Zusatzkosten-Auskunft neben einem
         Preis, den es noch gar nicht gibt (`.pdp__preis[data-preis]` trägt in
         Stufe 1 ein „—" und ist selbst versteckt, zwei Zeilen höher), ist
         eine Einschränkung ohne Gegenstand — und sie steht direkt über der
         teuersten Fläche der Seite.
         ⚠️ Die geschuldete Angabe geht dabei nicht verloren: sie erscheint
         mit dem Preis, also an der Kaufkante, wo sie hingehört. Ein `<span>`
         ohne eigene `display`-Regel — hier reicht `hidden` allein (anders als
         bei `.pdp__versandlink`, s. `echoa-pdp.css`). */
      vh.hidden = s.phase !== 'fertig';
    }

    /* Das Akkordeon „Versand und Lieferzeit" wechselte früher mit der
       Ausführung (Datei ohne Versand). Mit dem Wegfall von „Nur Datei"
       (03.08.2026) trägt es genau einen Text — hier ist nichts mehr zu tun. */

    // --- Bühne: Steg und Rahmen spiegeln die Wahl
    const flaeche = document.querySelector('[data-tafel="blatt"] .buehne__flaeche');
    const buehne = document.querySelector('[data-tafel="blatt"] .buehne');
    /* 🔴 EINE RECHNUNG FÜR BEIDE VORSCHAUEN (19.08.2026). Der Steg muss auf
       der Blatt-Bühne UND im Raum gleich breit sein — zwei Vorschauen
       desselben Blattes, die sich unterscheiden, sind die „zwei Hüllen"-Klasse
       aus `rules/architektur.md`, nur diesmal für den Kunden sichtbar.
       Der Prozentwert bezieht sich in beiden Fällen auf die BREITE des
       Blattes, weil CSS-Padding in Prozent immer gegen die Breite auflöst —
       dieselbe Definition wie in `postergen.STEG_STUFEN`. */
    const stegProzent = `${STEG_STUFEN[s.rand] ?? 0}%`;
    if (flaeche) flaeche.style.setProperty('--steg', stegProzent);
    /* 🔴 Die Klasse GEHÖRT ZUR VARIABLEN, nicht daneben (19.08.2026). Sie
       schaltet den Kartonrand der Bühne aus, damit der weiße Steg nicht in
       einem grauen Ring steht (Saschas Befund am Screenshot). CSS kann nicht
       auf „Variable ungleich 0" prüfen — deshalb eine Klasse, und deshalb
       steht sie in derselben Zeile wie der Wert, den sie beschreibt. */
    if (buehne) buehne.classList.toggle('buehne--steg', (STEG_STUFEN[s.rand] ?? 0) > 0);
    document.querySelectorAll('[data-raum-poster]')
      .forEach((pst) => pst.style.setProperty('--steg', stegProzent));
    /* 🔴 DER RAHMEN AUF DER BUEHNE ERSCHEINT ERST IN STUFE 2 (20.08.2026).
       Sascha: „In Stufe 1 das erste Vorschaubild by default ohne Rahmen,
       d.h. den schwarzen Rahmen weg lassen."

       In Stufe 1 GIBT es keine Rahmenwahl — der Block „Ausführung" ist bis
       Phase `fertig` versteckt (`blockAusfuehrung.hidden`, oben in dieser
       Funktion). Der schwarze Ring dort war also nicht die Antwort auf eine
       Wahl, sondern die stumme Nebenwirkung der Vorwahl vom 19.08.2026 —
       dieselbe Klasse wie der Widerrufs-Hinweis und die Versandzeile über
       einem Preis, den es noch nicht gibt.

       ⚠️ DAS IST EINE ANZEIGE-ENTSCHEIDUNG, KEINE ABWAHL. `s.ausfuehrung`
       und `s.rahmenfarbe` bleiben auf „Gerahmt / schwarz" — die Vorwahl vom
       19.08. und damit die Variante, die in den Warenkorb geht, ist
       unberührt.
       ⚠️ GELTUNGSBEREICH: nur die Blatt-Bühne. Die Interior-Ansichten
       zeigen den Rahmen in BEIDEN Stufen weiter — in Stufe 1 steckt er im
       generierten Beispielbild, ab Stufe 2 zeichnet ihn `--raum-leiste`.
       Genau so hat Sascha es am 19.08. bestellt („egal ob Stufe 1 oder
       Stufe 2"), und der heutige Befund nimmt das nicht zurück. */
    /* 🔴 DIE BLATT-TAFEL ZEIGT DAS BLATT WIE DER DRUCK (Sascha, 22.09.2026:
       bei »randlos« standen Karton-Streifen neben dem Blatt). Nach dem
       Andruck trägt die Tafel das gewählte Format; ein 3:4-Render passt nur
       bei 30×40 exakt. Was der Druck damit macht, steht in
       `postergen.offen`: A1/A5/A8 füllen die BREITE, der Überstand geht unten
       weg → `beschnitt` (cover, oben bündig). C1 füllt die HÖHE und ergänzt
       Papier an den Seiten, weil dort der Cremerand Inhalt ist → `papier`
       (contain auf Papierton). Vor dem Andruck bleibt Saschas Regel vom
       09.09.2026 (nichts abschneiden, Kartonbalken) unverändert — dort liegt
       das 3:4-Hero-Bild ohnehin in einer 3:4-Bühne.
       ⏪ Kids hatten bis zum 23.09.2026 kein Attribut (`contain`) — der
       Druck beschneidet dort aber mittig (`auf_blattformat`, cover), also
       trägt die Tafel jetzt `mitte`. */
    blattVerhaeltnisSetzen();
    const tafelBlatt = document.querySelector('[data-tafel="blatt"]');
    if (tafelBlatt) {
      const bautypFit = BAUTYP_JE_HANDLE[D.produkt.handle] || '';
      /* a1/a8: Tafel bleibt 3:4 (s. `blattVerhaeltnisSetzen`) — kein Attribut. */
      const fit = s.phase === 'fertig' && bautypFit
        ? (bautypFit === 'c1' ? 'papier' : bautypFit === 'a5' ? 'beschnitt'
           /* Kids (23.09.2026, Sascha: Rand zwischen Rahmen und Druck bei
              40×50/21×30): der Druck rechnet `kids-muster-setzen.auf_blattformat`
              = COVER mit mittigem Beschnitt → dieselbe Sicht hier. */
           : (bautypFit === 'k2' || bautypFit === 'c2' || bautypFit === 'k3') ? 'mitte' : '') : '';
      if (fit) tafelBlatt.dataset.blattfit = fit;
      else delete tafelBlatt.dataset.blattfit;
    }
    const rahmenAufBuehne = gerahmt && s.phase === 'fertig';
    if (buehne) {
      buehne.classList.toggle('buehne--gerahmt', rahmenAufBuehne);
      /* 🔴 IN STUFE 1 FÜLLT DAS BLATT DIE BÜHNE (20.08.2026). Ohne diese
         Zeile kommt mit dem weggefallenen Rahmen der 8-%-Kartonrand zurück
         (`echoa-buehne.css`, `--rand-wirksam`) — Saschas „dafür viel grauer
         Hintergrund". Beide Stufen tragen damit dieselbe Außenkante, und das
         Blatt springt beim Wechsel nicht in der Größe.
         ⚠️ An `s.phase`, nicht an `gerahmt`: in Stufe 2 OHNE Rahmen bleibt
         der Kartonrand, denn dort liegt ein nacktes Blatt auf der Bühne und
         genau dafür ist sie da. */
      buehne.classList.toggle('buehne--randlos', s.phase !== 'fertig');
      if (rahmenAufBuehne) {
        /* 🔴 DIESELBE TABELLE WIE DIE KACHEL (17.08.2026). Bis hierher stand
           hier eine EIGENE Farbliste (#1E1B18 / #C9A87C / #5A3F2B), die von
           den Werten in `pipeline/raum-rahmen.py` abwich — solange die
           Rahmenwahl aus Wort-Knöpfen bestand, sah das niemand. Mit den
           Bildkacheln stehen Kachel und Bühne nebeneinander im Blick, und
           zwei Brauntöne für denselben Rahmen lesen sich als Fehler. Das ist
           die „zwei Hüllen"-Klasse (`rules/architektur.md`), nur farbig.
           ⚠️ Die Kacheln baut der Konfigurator aus den LIVE-Produktvarianten
           (`werteFuer('rahmenfarbe')`), nicht aus dieser Tabelle. Solange im
           Shop eine Weiß-Variante existiert, bliebe die Kachel sichtbar und
           zeigte den Rückfall — Reihenfolge also immer: erst die Variante im
           Shop entfernen, dann hier. Am 13.08.2026 geprüft: der Shop enthält
           null Produkte, es gibt keine solche Variante. */
        const ton = rahmenTon(s.rahmenfarbe);
        buehne.style.setProperty('--rahmen-farbe', ton.flaeche);
      }
    }

    // --- Beispiel-Ribbon verschwindet bei der ersten Eingabe — oder sobald ein eigener Entwurf auf dem Blatt steht.
    /* Die Linien-Seite hat kein Pflicht-Textfeld: ohne Namen blieb „Beispiel" über dem Andruck des Kunden stehen
       (Sichtprobe 28.10.2026). Derselbe Test wie `eigenerEntwurf` in `lookBeispielZeigen`. */
    const ribbon = document.querySelector('.buehne__etikett--pdp');
    const blattSrc = document.querySelector('[data-tafel="blatt"] .buehne__bild')?.src || '';
    const eigenesBlatt = /\/api\/kandidat\//.test(blattSrc) || Boolean(BACKEND && blattSrc.startsWith(BACKEND));
    if (ribbon) ribbon.hidden = hatEingabe() || eigenesBlatt;

    // --- Poster im Raum maßstabsgetreu
    raumSkalieren();

    // --- Kauf-Anker unter dem Knopf
    ankerZeichnen(gerahmt);

    // --- Primäraktion
    aktionZeichnen(v);
  }

  /* ================================================== Kauf-Anker (17.08.2026)

     Saschas Bestellung, aus der CRO-Praxis und an Juniqe und Desenio
     abgelesen: „Unterhalb des Warenkorb-Buttons tauchen nochmal einige
     Kauf-Anker auf: Voraussichtliche Lieferung, wenn heute bestellt wird (mit
     ‚grün' = verfügbar), zentrale USPs …"

     🔴 SICHTBAR ERST IN PHASE `fertig`, zusammen mit dem Kaufknopf. Über
     „Andruck erstellen" wäre eine Lieferzusage eine Zusage über eine
     Bestellung, die es noch nicht gibt — dieselbe Überlegung, die den
     Widerrufs-Hinweis dorthin verschoben hat.
     ⚠️ „Aufhängefertig" hängt an der Rahmenwahl: an einem ungerahmten Druck
     wäre es schlicht falsch. Das entscheidet das Setting `nur_gerahmt` am
     Block, nicht der Text. */
  function ankerZeichnen(gerahmt) {
    const kasten = document.querySelector('[data-anker]');
    if (!kasten) return;
    kasten.hidden = s.phase !== 'fertig';
    kasten.querySelectorAll('[data-nur-gerahmt]').forEach((li) => {
      li.hidden = !gerahmt;
    });
    /* Entwurfs-Vorteil (21.10.2026): „Versandkostenfrei ab 69 €" widerspräche dem
       Kasten „kostenloser Versand" darüber — solange der Vorteil gilt, tritt der
       Anker zurück. Markiert in Liquid über den Titel (`data-versand-anker`). */
    kasten.querySelectorAll('[data-versand-anker]').forEach((li) => {
      li.hidden = Boolean(vorteilFuer(s.kandidatId));
    });
    if (s.phase === 'fertig') lieferzeileZeichnen();
  }

  /* --- Die Lieferzeile ------------------------------------------------------
     🔴 SIE RECHNET IM BROWSER, NICHT IN LIQUID. Liquid kennt nur den Zeitpunkt
     des Renderns, und die Seite wird gecacht — ein in Liquid gerechnetes
     Datum wäre am nächsten Tag falsch, ohne dass es auffällt. Das ist die
     Klasse „läuft fehlerfrei, liefert falsch aus".

     GELTUNGSBEREICH DER DREI ZAHLEN (alle als Theme-Setting, hier nur der
     Rückfall):
       liefer_min / liefer_max  WERKTAGE ab Produktionsbeginn, Gelato-Produktion
                                UND Versand zusammen.
                                🔴 SEIT 17.08.2026 AN ZWEI ECHTEN
                                GELATO-BESTELLUNGEN KALIBRIERT, nicht mehr an
                                der AGB-Zusage. Beide Testdrucke: Freitagabend
                                bestellt → Montag versendet → Mittwoch in
                                Zustellung. Das ist **Werktag 2** ab
                                Produktionsbeginn; Testdruck 1 wurde Donnerstag
                                (Werktag 3), und zwar durch einen
                                Touren-Abbruch beim Zusteller, nicht durch die
                                Produktion.
                                ⏪ Eingestellt waren 3–5: die Untergrenze einen
                                Tag über dem Bestfall, die Obergrenze zwei über
                                dem beobachteten Schlechtfall. n=2, beide
                                Freitagsbestellungen — ein Wochentagslauf ist
                                UNGEMESSEN und könnte anders liegen.
                                🔴 SEIT 21.09.2026 STEHEN HIER 4–6, UND DER
                                GRUND IST EINE ZWEITE QUELLE FÜR DIESELBE
                                FRAGE: der Shopify-Checkout rechnet eigenständig
                                „Bearbeitungszeit + Transportzeit der
                                Versandart" und zeigt das Ergebnis als Datum an
                                der Stelle, an der der Kunde zahlt.
                                Am offenen Shop gemessen (21.09.2026):
                                Transportzeit stand auf 4–7 Werktagen — also
                                der AGB-Zahl, die aber die GESAMTZEIT meint —,
                                der Checkout zeigte deshalb „Do., 1. Okt–Di.,
                                6. Okt", 8–11 Werktage. Die Produktionszeit
                                wurde doppelt gezählt. Nach der Korrektur auf
                                1–2 Werktage Transport zeigt er „Mo., 28. Sep–
                                Di., 29. Sep" = 5–6 Werktage ab Bestellung.
                                Bei 3–5 nannte diese Zeile einen FRÜHEREN Tag
                                als der Checkout. 4–6 deckt ihn ab: der
                                früheste Tag trifft exakt, der späteste ist
                                einen Werktag konservativer.
                                🔴 SEIT 30.09.2026 STEHEN HIER 3–4 (Sascha:
                                „Mi. bis Fr. ist schon extrem viel" — eine
                                Bestellung Mi. nachmittags soll Di.–Mi. nennen).
                                Gedeckt durch 5 echte Gelato-Sendungen
                                (07.08.–11.09.2026, alle Freitagsbestellungen):
                                Zustellung 1, 1, 3, 3, 3 Werktage nach
                                Produktionsbeginn — der schlechteste Fall
                                liegt am ersten Tag der Spanne. ⚠️ Zustelltag
                                ist Gelatos letzte Statusänderung (Ersatzmaß,
                                nicht das DHL-Protokoll); Wochentagsbestellungen
                                weiter UNGEMESSEN. Checkout zeitgleich
                                nachgezogen: Bearbeitungszeit 3 → 2 Werktage
                                (Server: processingTime P2D), Transportzeit
                                1–2 unverändert → 3–4, identisch zu hier.
                                ⚠️ Die Zahl hängt damit an ZWEI Shopify-
                                Einstellungen (Bearbeitungszeit 3 Werktage,
                                Transportzeit 1–2). Wer eine davon ändert,
                                misst diese Zeile neu gegen den Checkout —
                                niemand meldet den Drift.
                                ⏪ Davor standen hier 4–7 (aus der AGB) und
                                kurz 4–6. Beides war damals zu konservativ:
                                4–7 ergab ab einer Montagsbestellung 7–10
                                KALENDERTAGE, mehr als das Doppelte des
                                Gemessenen.
                                🔴 DIESE ZAHL IST CRO, KEINE RECHTLICHE
                                ABSICHERUNG (Sascha, 17.08.2026) — dafür steht
                                „voraussichtlich" im Text. Die AGB (§ 6 Abs. 2)
                                nennt weiter 4–7 als äußeren Rahmen; das ist
                                die übliche Staffelung und kein Widerspruch.
                                ⚠️ Das PDP-Akkordeon „Versand und Lieferzeit"
                                nannte ebenfalls 4–7 und steht auf DERSELBEN
                                Seite — am 17.08. auf „in der Regel 3–5
                                Werktage" umgestellt, am 21.09. mit dieser
                                Zeile zusammen auf „4–6 Werktage". Wer eine der
                                beiden Zahlen ändert, greppt nach der anderen
                                (Text in `templates/product.json`).
                                Gilt NICHT für gerahmte Sendungen — die sind
                                eine eigene Sendungsgruppe und laufen länger.
       annahmeschluss           Stunde (lokale Zeit des Kunden), bis zu der ein
                                Auftrag am selben Werktag in Produktion geht.
                                ⏪ 17.08.2026 von 14 auf 17 Uhr. Die Belege
                                sagen dazu nur, dass „Freitagabend" nicht mehr
                                am Freitag lief — der genaue Cutoff bleibt
                                UNGEMESSEN. 17 Uhr war der übliche Wert bei
                                Print-on-Demand und widersprach keinem der
                                beiden Läufe.
                                🔴 SEIT 21.09.2026 STEHEN HIER 12 UHR, UND
                                ZWAR NICHT, WEIL GELATO GEMESSEN WURDE:
                                Shopify rechnet im Checkout mit einem 12-Uhr-
                                Annahmeschluss. Stand hier 17, nannte diese
                                Zeile zwischen 12 und 17 Uhr einen Liefertag
                                FRÜHER als der Checkout — zwei Zahlen für
                                dieselbe Bestellung, nur abhängig von der
                                Uhrzeit des Besuchs. 12 Uhr ist der Wert, der
                                zum Checkout passt und im Zweifel die
                                vorsichtigere Angabe macht.
                                ⚠️ n=1 (eine Checkout-Messung), und Shopify
                                nennt den Wert nirgends ausdrücklich. Ein
                                zweiter Messpunkt, der etwas anderes zeigt,
                                sticht diese Zahl.
                                🔴 Die Zahl kostet einen ganzen Werktag, über
                                ein Wochenende drei: eine Bestellung um 15 Uhr
                                geht bei 14 erst morgen in Produktion, bei 17
                                noch heute. Wer die Prognose weiter verkürzen
                                will, misst zuerst das — es ist der größere
                                Hebel als ein Tag an der Spanne.
     ⚠️ FEIERTAGE KENNT SIE NICHT. Deshalb steht „voraussichtlich" im Text und
     die Spanne ist zwei Tage breit. Eine taggenaue Zusage wäre eine Zusage,
     die niemand einlöst — und ein gebrochenes Lieferversprechen kostet mehr
     als der Anker einbringt (dieselbe Bedingung, die Sascha am 15.08.2026 für
     die Fehlermeldungs-Mail gesetzt hat). */
  function istWerktag(d) {
    const w = d.getDay();
    return w !== 0 && w !== 6;
  }

  function werktagePlus(start, tage) {
    const d = new Date(start.getTime());
    let rest = tage;
    while (rest > 0) {
      d.setDate(d.getDate() + 1);
      if (istWerktag(d)) rest -= 1;
    }
    return d;
  }

  function lieferzeileZeichnen() {
    const zeile = document.querySelector('[data-lieferzeile]');
    if (!zeile) return;
    zeile.innerHTML = `<span class="anker__punkt-gruen" aria-hidden="true"></span>
      <span>Bestellst du heute, ist dein Poster voraussichtlich
      <strong class="anker__spanne">${escape(lieferSpanne())}</strong> bei dir</span>`;
    zeile.hidden = false;
  }

  /** Die Lieferspanne als Text („Mi., 28. – Do., 29. Oktober") — eine Rechnung für die Zeile
      am Kaufknopf und die Ankunft-Zone (22.10.2026), damit beide dasselbe Datum nennen. */
  function lieferSpanne() {
    const min = Number(D.liefer_min) || 3;
    /* Kauf-Versprechen: gedruckt wird erst nach dem OK des Kunden. Die Spanne nimmt an, dass er
       am Bestelltag antwortet, und legt einen Werktag oben drauf (n=0, nicht gemessen). */
    const max = (Number(D.liefer_max) || 5) + (KAUFVERSPRECHEN_AN ? 1 : 0);
    const schluss = Number(D.annahmeschluss);
    const jetzt = new Date();

    /* Produktionsbeginn: heute, wenn Werktag und vor Annahmeschluss —
       sonst der nächste Werktag. */
    let beginn = new Date(jetzt.getTime());
    const heuteNoch = istWerktag(jetzt)
      && (Number.isFinite(schluss) ? jetzt.getHours() < schluss : true);
    if (!heuteNoch) beginn = werktagePlus(beginn, 1);

    const von = werktagePlus(beginn, min);
    const bis = werktagePlus(beginn, max);

    /* 🔴 DIE SPANNE IST EIN BLOCK, KEIN SATZ AUS VIER TEILEN (17.08.2026, an
       der eigenen Probe auf 390 px gefunden). Die erste Fassung schrieb
       „zwischen <Mo., 24. August> und <Do., 27. August>" mit vollem Datum auf
       beiden Seiten — mobil brach das mitten zwischen Tag und Monat um und
       las sich als vier Angaben statt einer Spanne.
       Der Monat steht deshalb nur einmal, solange beide Daten in denselben
       fallen; über einen Monatswechsel hinweg trägt jede Seite ihren eigenen.
       Zusammengehalten wird die Spanne zusätzlich per `white-space: nowrap`
       im CSS — ein Datum, das über zwei Zeilen läuft, ist keine Zusage mehr,
       sondern ein Suchbild. */
    const tag = (d) => d.toLocaleDateString('de-DE', { weekday: 'short', day: 'numeric' });
    const monat = (d) => d.toLocaleDateString('de-DE', { month: 'long' });
    return monat(von) === monat(bis)
      ? `${tag(von)} – ${tag(bis)} ${monat(bis)}`
      : `${tag(von)} ${monat(von)} – ${tag(bis)} ${monat(bis)}`;
  }

  /* 🆕 „SO KOMMT ES BEI DIR AN" (22.10.2026, Saschas Auftrag über die Anzeigen-Session: „Die Leute
     sehen den Entwurf als Spielerei und nicht als Produkt"). Gemessen 08.–21.10.2026: 225 Besuche
     mit Entwurf, 14 Warenkörbe (6 %). Direkt nach dem fertigen Entwurf macht diese Zone aus dem
     Bild ein Ding: Format und Papier, Rahmen, Verpackung, ein echtes Lieferdatum (dieselbe Rechnung
     wie am Kaufknopf), daneben der eigene Entwurf im Raum (Klon der Größenhilfe, maßstäblich).
     🔴 NUR, WAS STIMMT. Papier: Magazin seidenglänzendes Fotopapier 200 g, sonst mattes 200-g-Papier
     (Akkordeon „Material und Druck"). Verpackung: „im Karton" — Gelato verschickt Poster in flachen
     oder dreieckigen Kartons, nicht in Rollen (support.gelato.com, Artikel 8996200, gelesen
     22.10.2026). Kein Weihnachten (Sascha: noch zu früh), keine Produktfotos (es gibt keine Drucke
     der neuen Motive). */
  function ankunftZeichnen() {
    const zone = $('[data-ankunft]');
    if (!zone) return;
    const fertig = s.phase === 'fertig' && Boolean(s.kandidatId);
    zone.hidden = !fertig;
    if (!fertig) return;
    const magazin = istHaustier() && s.brief.stil === 'magazin';
    const papier = magazin ? 'seidenglänzendes Fotopapier, 200 g' : 'mattes Papier, 200 g';
    const rahmenKachel = $('[data-rahmenwahl] [aria-pressed="true"]');
    const rahmenWort = rahmenKachel ? (rahmenKachel.innerText || '').split('\n')[0].trim() : '';
    const gerahmt = s.ausfuehrung === 'Gerahmt';
    const zeilen = [
      [s.groesse ? `${s.groesse} · ${papier}` : papier, ''],
      [gerahmt ? `Im Rahmen ${rahmenWort}`.trim() : 'Ohne Rahmen', ''],
      ['Sicher im Karton verpackt', ''],
      [`Bei dir: ${lieferSpanne()}`, 'wenn du heute bestellst'],
    ];
    const liste = zone.querySelector('[data-ankunft-liste]');
    if (liste) {
      liste.innerHTML = zeilen.map(([a, b]) => `<li><span class="ankunft__haken" aria-hidden="true">✓</span>
        <span>${escape(a)}${b ? ` <span class="ankunft__zusatz">${escape(b)}</span>` : ''}</span></li>`).join('');
    }
    const halter = zone.querySelector('[data-ankunft-raum]');
    const quelle = document.querySelector('.pdp__tafel[data-tafel^="raum-"] [data-raum]');
    if (halter && quelle) {
      if (!halter.firstElementChild) {
        const klon = quelle.cloneNode(true);
        klon.querySelectorAll('[data-raum-beispiel]').forEach((e) => e.remove());
        klon.querySelectorAll('img').forEach((e) => e.setAttribute('loading', 'eager'));
        klon.classList.add('raum--klein');
        halter.appendChild(klon);
        halter.dataset.ziel = quelle.closest('[data-tafel]').dataset.tafel;
      }
      raumEinzeln(halter.firstElementChild);
      halter.hidden = false;
    } else if (halter) {
      halter.hidden = true;
    }
  }

  /* --- Die Primäraktion wechselt mit dem Zustand -------------------------- */
  function aktionZeichnen(v) {
    const knopf = $('[data-aktion]');

    /* 🔴 DER WIDERRUFS-HINWEIS ERSCHEINT ERST BEIM BESTELLEN
       (Sascha, 15.08.2026). Er hing zuvor ab dem ersten Moment über einem
       Knopf, auf dem „Andruck erstellen" steht — eine Belehrung über eine
       Bestellung, die es noch nicht gibt.
       ⚠️ Er hängt an `s.phase`, nicht am Knopftext: `phase === 'fertig'` ist
       genau der Zustand, in dem der Knopf „In den Warenkorb" trägt. Stünde er
       am Text, bräche er beim nächsten Wortlaut-Wechsel still.
       ⏪ 15.08.2026 später am Tag: aus der Checkbox ist ein reiner
       Hinweistext geworden (Entscheidung B). Damit entfällt auch der frühere
       Reset beim Phasenwechsel — es gibt keinen Zustand mehr, der von einer
       verworfenen Fassung stehenbleiben könnte.
       Steht VOR dem `return` weiter unten: der Läuft-Zweig verlässt die
       Funktion früh, und dort muss der Hinweis ebenfalls weg sein. */
    const wid = $('[data-widerruf-block]');
    if (wid) {
      /* Nur noch Sichtbarkeit — es gibt keinen Zustand mehr
         zurückzusetzen (⏪ das Häkchen ist am 15.08.2026 entfallen). */
      wid.hidden = s.phase !== 'fertig';
    }

    /* ⏪ 18.08.2026 (Sascha): „zzgl. Versandkosten" oben neben dem ab-Preis
       erscheint ebenfalls erst in Stufe 2 — an derselben Phase wie der
       Widerrufs-Hinweis, aus demselben Grund: eine Zusatzkosten-Auskunft,
       bevor der Kunde überhaupt etwas gewählt hat, ist eine Einschränkung
       ohne Gegenstand.
       ⚠️ Der Hinweis UNTEN im Abschluss (`[data-versandhinweis]`) bleibt
       unberührt — er steht dort erst ab dem fertigen Andruck und trägt die
       geschuldete Angabe an der Kaufkante. Es geht hier nur um die Kopie in
       der Preiszeile. */
    const vo = document.querySelector('[data-versand-oben]');
    if (vo) vo.hidden = s.phase !== 'fertig';

    /* Der Einstieg zur Fehlermeldung hängt an derselben Phase, steht aber
       UNTER DER BÜHNE statt hier im Abschluss — er darf nicht mit dem
       Bestellknopf konkurrieren (15.08.2026). Gezeichnet wird er trotzdem von
       hier aus: das ist die eine Stelle, an der Phasenwechsel sichtbar werden,
       und eine zweite hätte genau die Divergenz erzeugt, gegen die der
       Widerrufs-Hinweis oben schon einmal umgebaut wurde.
       ⚠️ Vor dem `return` des Läuft-Zweigs, aus demselben Grund wie dort. */
    meldenZeichnen();
    /* Entwurfs-Vorteil (21.10.2026): hängt an derselben Phase wie der Widerruf —
       gezeichnet von hier aus, vor dem `return` des Läuft-Zweigs. */
    vorteilZeichnen();

    if (!knopf) return;
    knopf.classList.remove('mit-versprechen');   /* nur der fertige Zustand trägt die zweite Zeile */

    if (s.phase === 'laeuft') {
      knopf.disabled = true;
      return; // Text setzt die Wartezeit-Schleife
    }

    if (s.phase === 'fertig') {
      knopf.disabled = false;
      kaufknopfSetzen(knopf, v);
      return;
    }

    /* 🔴 HARTER HALT (code-pruefer Runde 2, 09.08.2026): ein Produkt mit
       echtem Kundenpfad (LIVE_HANDLES) darf ohne erreichbares Backend NICHT
       in die Simulation fallen — das wäre eine bezahlte Bestellung ohne
       Produktionsauftrag, still im Webhook ignoriert. Der Knopf sperrt,
       statt zu simulieren; die Absicherung hängt damit am Code, nicht daran,
       dass beim Veröffentlichen jemand an die Theme-Einstellung denkt
       (dasselbe Muster wie Metas Zwangs-Pause vor der Live-Schaltung). */
    if (LIVE_HANDLES.has(D.produkt.handle) && !BACKEND) {
      knopf.disabled = true;
      knopf.textContent = 'Andruck derzeit nicht verfügbar – wir sind gleich zurück';
      return;
    }

    knopf.disabled = false;
    const sek = D.dauer_sekunden || 50;
    knopf.textContent = `Andruck erstellen – etwa ${sek} Sekunden`;
  }

  /* Die Breite in cm aus einem Größen-Label. Meldet laut statt still
     zurückzufallen — der stille Rückfall ist die Klasse, die hier zweimal
     zugeschnappt hat (`raumSkalieren`).
     ⚠️ Das Trennzeichen ist ein echtes MAL-ZEICHEN (×, U+00D7), nicht das
     Buchstaben-x. Der Katalog schreibt es so, und ein Parser, der nur `x`
     kennt, träfe keine einzige Größe. */
  const groesseGemeldet = new Set();

  /* Beide Maße aus demselben Label, mit EINEM Parser.
     ⏪ 18.08.2026: bis hierher wurde nur die Breite gelesen. Die Höhe kam
     dazu, weil die Vorschau seither das SEITENVERHÄLTNIS der gewählten Größe
     zeigt (`blattVerhaeltnisSetzen`). Bewusst dieselbe Funktion und nicht
     eine zweite daneben: zwei Parser auf dasselbe Label sind die „zwei
     Hüllen"-Klasse aus `rules/architektur.md`, und genau an diesem Label ist
     schon zweimal eine Handtabelle gerissen.
     GELTUNGSBEREICH unverändert: jedes Label der Form „<Breite>×<Höhe> cm".
     Fehlt die Höhe (Label „30 cm"), bleibt sie null und der Aufrufer fällt
     auf 3/4 zurück — die Breite ist davon unberührt. */
  function groesseMasse(label) {
    const treffer = /^\s*(\d+(?:[.,]\d+)?)\s*[×x]\s*(\d+(?:[.,]\d+)?)?/
      .exec(String(label || ''));
    if (treffer) {
      return { b: parseFloat(treffer[1].replace(',', '.')),
               h: treffer[2] ? parseFloat(treffer[2].replace(',', '.')) : null };
    }
    if (label && !groesseGemeldet.has(label)) {
      groesseGemeldet.add(label);
      console.warn(`[echoa] Größe „${label}" trägt keine lesbare Breite – die `
        + `Raumansicht rechnet mit 30 cm. Erwartet: „<Breite>×<Höhe> cm".`);
    }
    return { b: 30, h: null };
  }

  function groesseCm(label) { return groesseMasse(label).b; }

  /* --- Formatklasse einer Größe (Orts-Print, 23.09.2026) ---------------------
     Der Orts-Print wird EINMAL gerendert (Master 4:5); jede andere Größe ist
     ein Seitenbeschnitt davon, den das Backend ohne Render setzt
     (`vorschau.png?format=…`, `ton.png?format=…`). Hier wird nur die
     Katalogklasse zur gewählten Größe gerechnet — die nächste der vier zum
     Verhältnis Breite/Höhe; das Backend kennt dieselbe Tabelle
     (`c1-template-bauen.FORMATE`). Ohne lesbare Größe: 4:5, der Master.
     ⏪ Vormittags stand hier „im Format gerendert" mit Neurender je Klasse —
     Sascha: „für den Kunden untragbar". */
  const FORMAT_KLASSEN = [['3:4', 3 / 4], ['4:5', 4 / 5], ['5:7', 5 / 7], ['7:10', 7 / 10]];
  function formatKlasse(label) {
    const { b, h } = groesseMasse(label);
    if (!(b > 0 && h > 0)) return '4:5';
    const r = b / h;
    return FORMAT_KLASSEN.reduce((best, k) =>
      (Math.abs(k[1] - r) < Math.abs(best[1] - r) ? k : best))[0];
  }
  function istOrtsPrint() { return (BAUTYP_JE_HANDLE[D.produkt.handle] || '') === 'c1'; }
  /** Die Bühnen-URL eines Andrucks im gewählten Format (nur Orts-Print;
      alle anderen Bautypen bekommen die URL unverändert). */
  function kandidatBildUrl(basis) {
    if (!basis || !istOrtsPrint()) return basis;
    try {
      const u = new URL(basis, window.location.href);
      u.searchParams.set('format', formatKlasse(s.groesse));
      return u.toString();
    } catch { return basis; }
  }

  /* --- Poster im Raum ------------------------------------------------------
     breite_prozent = format_cm / wandBreiteCm * 100, plus Rahmenzuschlag.
     Die drei Formate skalieren damit proportional; ein neues Foto braucht
     drei Zahlen, kein neues Layout. */
  function raumSkalieren() {
    /* 🔴 ALLE Raum-Tafeln, nicht die erste (19.08.2026). Seit es drei
       Interiors gibt, hätte `querySelector` nur das erste bedient — die
       beiden anderen behielten die Breite des zuletzt gerenderten Zustands
       und zeigten beim Umschalten ein falsch skaliertes Poster. Der Fehler
       wäre erst beim Klick auf die zweite Kachel sichtbar geworden.
       ⚠️ Jede Tafel bringt ihre EIGENE Wandbreite mit (`data-wandbreite`) —
       sie gehört zum Foto, nicht zum Produkt. */
    document.querySelectorAll('[data-raum]').forEach(raumEinzeln);
    blattVerhaeltnisSetzen();
    raumBeispieleSchalten();
    raumPosterSetzen();
    groesseRaumZeichnen();
    ankunftZeichnen();
  }

  /* --- Stufe 1 zeigt das generierte Beispiel, Stufe 2 die Montage ----------
     Sascha, 19.08.2026: „Vor Produktion (Stufe 1) die Interior Mockups nicht
     mit den platzierten Bildern füllen, sondern mit ‚echten‘ (generierten)
     Beispielen … Erst in Stufe 2 dann auf die Mockups switchen, die der Kunde
     auch tatsächlich generiert hat."

     🔴 DIE PHASE ENTSCHEIDET, NICHT DAS VORHANDENSEIN EINES ENTWURFS. `fertig`
     ist genau der Zustand, in dem `s.kandidat.vorschau_url` in der Montage
     steht; jeder frühere zeigt das Platzhalter-Blatt aus dem Theme. Am
     Kandidaten zu hängen wäre dieselbe Bindung an einen Nebenwert, gegen die
     der Widerrufs-Hinweis am 15.08. schon einmal umgebaut wurde.
     ⚠️ Räume ohne Beispielbild haben das Element gar nicht (die Raumtabelle
     im Liquid lässt die Spalte dann leer) — dort bleibt es in beiden Stufen
     bei der Montage. Ein fehlendes Bild kann so keine leere Tafel erzeugen. */
  function raumBeispieleSchalten() {
    const zeigen = s.phase !== 'fertig';
    document.querySelectorAll('[data-raum-beispiel]')
      .forEach((b) => { b.hidden = !zeigen; });
  }

  function raumEinzeln(raum) {
    const poster = raum.querySelector('[data-raum-poster]');
    if (!poster) return;

    const wand = parseFloat(raum.dataset.wandbreite) || 240;
    /* 🔴 DIE BREITE WIRD GELESEN, NICHT NACHGESCHLAGEN (18.08.2026).

       Hier stand zweimal in zwei Tagen dieselbe Handtabelle, und sie riss
       zweimal: am 17.08. fehlte 20×25 (Poster 50 % zu groß), am 18.08. fiel
       20×25 aus dem Katalog und 21×30 kam dazu — die frisch reparierte
       Tabelle war vier Stunden später wieder falsch (~38 % zu groß, und zwar
       ausgerechnet beim Einstiegsformat, das den „ab 39 €"-Preis trägt).

       Die Breite steht im Label selbst („21×30 cm"). Sie von dort zu lesen
       kann strukturell nicht veralten — eine Tabelle daneben kann es immer.
       Das ist die Lehre aus zwei Rissen: nicht den Wert nachtragen, sondern
       die Quelle wechseln.

       GELTUNGSBEREICH: jedes Label der Form „<Breite>×<Höhe> cm". Ein Label
       ohne führende Zahl fällt auf 30 zurück UND meldet sich — ein stiller
       Rückfall war der ganze Fehler. */
    const cm = groesseCm(s.groesse);
    /* Der Rahmen ist seit dem 18.08. NICHT mehr pauschal: Aluminium hat eine
       10-mm-Leiste, Holz 12 mm (aus den Gelato-UIDs gelesen, `LEISTE_MM`).
       Mal zwei, weil die Leiste an beiden Seiten sitzt. */
    /* Raum: gerahmt, solange der Kunde den Rahmen nicht selbst abgewählt hat
       (Vorwahl ist seit 23.09. „Print", die Raum-Ansicht zeigt trotzdem den
       schwarzen Rahmen — Sascha, 19.08.: „nur so wirken die Bilder"). */
    const gerahmt = s.ausfuehrung === 'Gerahmt' || (!s.rahmenGewaehlt && Boolean(s.rahmenfarbe));
    const leiste = gerahmt ? leisteCm(s.rahmenfarbe) : 0;
    const rahmenZuschlagCm = leiste * 2;
    poster.style.setProperty('--poster-breite', `${((cm + rahmenZuschlagCm) / wand) * 100}%`);

    /* --- Die Leiste, sichtbar (19.08.2026) --------------------------------
       Saschas Beanstandung vom 18.08.: die Rahmenwahl war im Raum nicht zu
       sehen — sie änderte dort nur die Breite um den Leistenzuschlag, rund
       ein Prozent. Seit den drei Aufnahmen mit LEERER Wand ist der Rahmen als
       eigene Schicht baubar; vorher wäre er der zweite gewesen.

       🔴 DER BEZUG IST DIE WAND, NICHT DAS POSTER — daran ist die erste
       Fassung gescheitert (`501d35f`, Faktor 4,6 bis 10,4 zu dick). Ein
       Prozent-Padding löst gegen den ENTHALTENDEN BLOCK auf, und das ist
       `.raum`; `--poster-breite` rechnet gegen dieselbe Breite. Beide teilen
       sich damit den Bezug, und `leiste / wand` trifft die Leiste exakt.
       Zusammen mit `box-sizing: border-box` (in `echoa-pdp.css`) bleibt die
       Außenbreite bei `--poster-breite` — der Zuschlag oben ist bereits
       darin, das Blatt behält sein Maß.
       ⚠️ Die Unterkante bewegt sich nicht: das Poster hängt über
       `translate(-50%, -100%)` an ihr, der Kasten wächst nur nach oben. Auf
       `--anker-y` liegt danach die Außenkante des Rahmens.
       GELTUNGSBEREICH: nur die Raumansicht. Die Bühne („Blatt") hat ihren
       eigenen Rahmen über `.buehne--gerahmt`.
       ⏪ 20.08.2026: hier stand „mit fester Pixelleiste". Das stimmt nicht
       mehr — sie rechnet seit heute `padding: 3.4%` (`echoa-buehne.css`).
       🔴 DIE TRENNUNG BLEIBT TROTZDEM, und zwar aus dem Grund, der schon
       immer der eigentliche war: BEIDE rechnen prozentual, aber gegen
       VERSCHIEDENE Bezüge. Die Bühne rechnet gegen ihre eigene Breite (der
       Rahmen soll auf jedem Bildschirm gleich dick AUSSEHEN), die
       Raumansicht gegen die WANDBREITE (der Rahmen soll im Raum maßstäblich
       sein, also bei einem 21×30 schmaler wirken als bei einem 50×70). Wer
       die beiden zusammenlegt, weil „beide sind jetzt Prozent", zeichnet im
       Raum eine Leiste, die mit dem Format nicht mehr mitwächst. */
    poster.classList.toggle('raum__poster--gerahmt', gerahmt);
    if (gerahmt) {
      poster.style.setProperty('--raum-leiste', `${(leiste / wand) * 100}%`);
      /* Dieselbe Tabelle wie Kachel und Bühne (`rahmenTon`) — drei Orte, ein
         Wert. Eine eigene Farbliste hier wäre die „zwei Hüllen"-Klasse, und
         genau die ist am 17.08.2026 an der Bühne schon einmal aufgelaufen. */
      poster.style.setProperty('--raum-rahmenfarbe', rahmenTon(s.rahmenfarbe).flaeche);
    } else {
      poster.style.removeProperty('--raum-leiste');
      poster.style.removeProperty('--raum-rahmenfarbe');
    }

    /* ⏪ PROVENIENZ, in zwei Schritten — sie erklärt, warum der Rahmen oben
       so und nicht anders gerechnet wird:

       1. Am 18.08.2026 wurde ein CSS-Rahmen eingebaut und am selben Tag
          zurückgebaut. Sascha am Staging: „Im Interior legt sich das Bild
          über das Interior-Platzhalter-Bild anstatt auf eine leere Wand, dazu
          bekommt es einen Rahmen, obwohl es schon auf grauem Rahmen liegt."
          Die Ursache lag im MATERIAL: die damaligen vier Raumfotos zeigten
          bereits ein fertig gerahmtes Poster, jeder CSS-Rahmen war der zweite.
          Der Rechenfehler derselben Fassung ist oben benannt (`501d35f`).
       2. Am 19.08.2026 ist die Bedingung entfallen — die drei Aufnahmen
          `echoa-raum-A/B/D.jpg` zeigen eine LEERE Wand. Seither ist der
          Rahmen eine eigene Schicht, und er ist oben gebaut. */
  }

  /* --- Das Seitenverhältnis der gewählten Größe ----------------------------
     🔴 KOSTET KEINEN RENDER, UND DAS IST DIE GANZE POINTE (Sascha, 18.08.2026:
     „Wichtig ist, dass das keine zusätzlichen Renderkosten verursacht … die
     Live-Vorschau muss nicht auf den Millimeter genau stimmen").

     Die Vorschau entsteht formatunabhängig — `dienst.py` sagt es wörtlich:
     „Kein postergen.setze_format hier: die Zielgröße steht zur Vorschauzeit
     nicht fest (der Kunde wählt sie im Korb), und der Druck setzt sie später
     selbst." Das gerenderte Blatt misst 1792×2400 (≈3:4). Ein Formatwechsel
     ändert deshalb NUR den Ausschnitt, den wir davon zeigen — `object-fit:
     cover` beschneidet, das Backend wird nicht angefasst.

     ⚠️ Was das bewusst NICHT ist: eine maßgetreue Vorschau. Bei 40×50 (0,80)
     fallen gegenüber 3:4 oben und unten je ~3 % weg, bei 21×30 (0,70) links
     und rechts je ~3 %. Motivteile am Rand können also im Andruck anders
     sitzen als im Druck. Das ist der Preis dafür, dass die Formatwahl
     überhaupt sichtbar wird, und er war ausdrücklich gewollt.

     GELTUNGSBEREICH: setzt die Variable NUR auf den PDP-Tafeln. Kacheln im
     Raster und jede Bühne ohne Formatwahl bleiben bei 3/4 (`echoa-buehne.css`). */
  function blattVerhaeltnisSetzen() {
    const { b, h } = groesseMasse(s.groesse);
    const gueltig = b > 0 && h > 0;
    /* ⚠️ `^="raum"` statt `="raum"` — seit dem 19.08.2026 heissen die Tafeln
       `raum-A`, `raum-B`, `raum-D`. Ein exakter Selektor traefe keine
       einzige und die Formatwahl waere im Raum unsichtbar. */
    /* 🔴 A1 UND A8 BLEIBEN AUF DER BLATT-TAFEL 3:4 (22.09.2026, Sascha: „der
       gezeichnete filigrane Rahmen ist nach dem Generieren unten
       abgeschnitten"). Beide Bautypen SETZEN das Blatt im Druck für jedes
       Format neu (`a1-matrix.typ_produktiv`, `mapgen`) — es wird nichts
       beschnitten. Ein 3:4-Render in einer 4:5-Bühne kann diese Neusetzung
       nicht zeigen; `cover` schnitte den gemalten Rahmen, `contain` brächte
       Streifen. Also bleibt die Tafel beim Render-Verhältnis. Der Raum
       rechnet weiter mit dem echten Format (Maßstab). A5 (`offen()`
       beschneidet unten) und C1 (Papier an den Seiten) behalten das Format. */
    const nativGesetzt = ['a1', 'a8'].includes(BAUTYP_JE_HANDLE[D.produkt.handle] || '');
    /* 🔴 VOR DEM ANDRUCK BLEIBT DIE BLATT-TAFEL 3:4 (22.09.2026, Sascha: Hero
       und Farbtafeln verschieden groß, Hero „verzerrt"). Das Hero-Bild ist ein
       3:4-Blatt; die Formatwahl gibt es erst in Stufe 2. Vorher stand die
       Tafel trotzdem schon auf 4:5 (Vorwahl 40×50) — mit Balken neben dem Hero
       und einer anderen Höhe als die 3:4-Farbtafeln daneben. */
    const blattBleibt34 = nativGesetzt || s.phase !== 'fertig';
    /* `[data-groesse-raum-bild]`: das kleine Raumbild am Formatwähler (21.10.2026) braucht dasselbe
       Seitenverhältnis wie die großen Raum-Tafeln — sonst zeigte es eine andere Form als die Ansicht,
       auf die sein Tipp führt (code-pruefer 21.10.2026). */
    for (const tafel of document.querySelectorAll('[data-tafel="blatt"], [data-tafel^="raum"], [data-groesse-raum-bild]')) {
      if (gueltig && !(blattBleibt34 && tafel.dataset.tafel === 'blatt')) {
        tafel.style.setProperty('--blatt-verhaeltnis', `${b} / ${h}`);
        /* Zweite Schreibweise DESSELBEN Werts, nicht ein zweiter Wert: `calc`
           kann mit dem `a / b` einer `aspect-ratio` nicht rechnen, und die
           Mobil-Regel in `echoa-pdp.css` braucht genau das (Höhendeckel in
           Breite umrechnen). Beide entstehen hier aus denselben zwei Zahlen —
           auseinanderlaufen können sie deshalb nicht. */
        tafel.style.setProperty('--blatt-faktor', (b / h).toFixed(4));
      } else {
        tafel.style.removeProperty('--blatt-verhaeltnis');
        tafel.style.removeProperty('--blatt-faktor');
      }
    }
  }

  /* ================================================================== Wartezeit */

  /* ENTSCHEIDUNG 5 — die Wartezeit wird BENANNT, nicht überbrückt.
     Ein Spinner behauptet, es gehe gleich weiter; nach zehn Sekunden ist das
     eine Lüge und der Kunde geht. Stattdessen vier sichtbare Schritte im
     Vokabular einer Druckerei, mit verbleibender Zeit.

     Während der Wartezeit bleibt die Eingabe sichtbar und änderbar, und der
     Kunde liest seine eigene Geschichte in Echoa-Typografie gesetzt. Das ist
     der beste Inhalt, den die Seite in diesem Moment haben kann. */
  /* 🔴 ANTEILE, KEINE SEKUNDEN (07.09.2026). Bis hierher standen hier feste
     Sekunden — 6/34/46/50 —, kalibriert gegen die eine Nennzeit 50 s, die
     damals für ALLE Produkte galt. Seit dem 07.09. trägt jedes Produkt seine
     eigene (`dauer_sekunden`, je am Livebetrieb gemessen). Die WERTE stehen
     bewusst NICHT hier, sondern nur in `sections/echoa-pdp.liquid` — hier
     stand bis zum 08.09.2026 eine Aufzählung „A8 15 s, C1 50 s, A5 65 s,
     A1 80 s", und sie war einen Tag später falsch: mit `wortschatz` (115 s)
     und `jahreszahl` (125 s) sind es sechs Produkte. Eine Kopie einer Liste,
     die anderswo wächst, veraltet zwangsläufig — gefunden von der
     Kids-Go-Live-Session, dieselbe Klasse wie der Fehler, gegen den dieser
     Block gebaut ist. Eine feste Tabelle daneben wäre die „zwei Hüllen"-
     Klasse aus `rules/architektur.md`: bei 65 s stünde Phase IV ab Sekunde 51
     auf „✓", während der Knopf noch 14 Sekunden herunterzählt.
     Die Anteile sind exakt die alten Werte durch 50 — bei einer Nennzeit von
     50 s ist die Tabelle danach unverändert. */
  const PHASEN = [
    { rom: 'I',   titel: 'Geschichte gelesen', anteil: 6 / 50 },
    { rom: 'II',  titel: 'Motive gezeichnet',  anteil: 34 / 50 },
    { rom: 'III', titel: 'Satz gesetzt',       anteil: 46 / 50 },
    { rom: 'IV',  titel: 'Andruck',            anteil: 1 },
  ];
  /* Strecke/Wanderung (17.10.2026): kein Bildmodell — die Phasen heißen nach
     dem, was wirklich passiert (Text verstehen, Karte holen, Satz). Anteile
     unverändert: die Kartenkacheln brauchen gemessen 10–60 s, wie ein Render. */
  const PHASEN_TITEL_STRECKE = ['Strecke gelesen', 'Karte gezeichnet', 'Satz gesetzt', 'Andruck'];

  /* Die Tabelle in Sekunden, für EINE Nennzeit. Monoton steigend, jede Stufe
     mindestens eine Sekunde lang, und keine Stufe vor der letzten endet später
     als bei `gesamt - 2`.

     🔴 DER DECKEL `gesamt - 2` IST KEIN SCHÖNHEITSMASS (Befund code-pruefer,
     07.09.2026, nachgerechnet). Die Anzeige deckelt die laufende Sekunde bei
     `Math.min(t, gesamt - 1)` — eine vorletzte Stufe, die bei `gesamt - 1`
     endet, wird deshalb NIE „fertig" und die letzte nie „laeuft". Bei 15 s
     (A8) traf das genau zu: round(15 × 46/50) = 14 = gesamt − 1, und Phase IV
     wäre die ganze Wartezeit über dunkel geblieben. Bei 50/65/80 s ändert der
     Deckel nichts — dort liegt die dritte Stufe ohnehin tiefer.
     ⚠️ Gilt ab vier Stufen und `gesamt ≥ 5`; darunter kollidierte der Deckel
     mit der Ein-Sekunden-Regel. Kleinste vorkommende Nennzeit ist 15. */
  function phasenBis(gesamt) {
    let vorher = 0;
    return PHASEN.map((p0, i) => {
      const p = istStrecke() ? { ...p0, titel: PHASEN_TITEL_STRECKE[i] } : p0;
      const bis = i === PHASEN.length - 1
        ? gesamt
        : Math.min(Math.max(vorher + 1, Math.round(gesamt * p.anteil)),
                   gesamt - 2);
      vorher = bis;
      return { ...p, bis };
    });
  }

  /* --- Echter Lauf gegen das Backend (LIVE_HANDLES) ------------------------
     Dieselben Phasen wie die Simulation, aber der Abschluss kommt aus der
     Antwort, nicht aus dem Timer: Rückfragen → Chips im Panel, Kandidat →
     echte Vorschau in der Bühne. Der Timer ist nur Anzeige — läuft er über
     die Nennzeit, sagt er das ehrlich, statt fertig zu spielen. */
  function phasenAnim() {
    const gesamt = D.dauer_sekunden || 50;
    const takt = D.zeitraffer ? 240 : 1000;
    const knopf = $('[data-aktion]');
    let t = 0;
    /* Eine Notiz von außen (Warteschlange) schlägt die Überzeit-Notiz. */
    let notiz = '';
    phasenZeichnen(0, gesamt);
    statusZeichnen(0, gesamt, notiz);
    const timer = setInterval(() => {
      t += 1;
      phasenZeichnen(Math.min(t, gesamt - 1), gesamt, t >= gesamt);
      statusZeichnen(t, gesamt, notiz);
      if (knopf) {
        knopf.textContent = t < gesamt
          ? `Andruck läuft – noch etwa ${gesamt - t} Sekunden`
          : 'Andruck läuft – dauert gerade etwas länger …';
      }
    }, takt);
    return {
      stop: () => clearInterval(timer),
      notiz: (txt) => { notiz = txt; statusZeichnen(t, gesamt, notiz); },
    };
  }

  /* --- Die Maske zeigt, DASS gearbeitet wird (Sascha, 30.09.2026) ----------
     „so etwas, was man hier in der Cloud auch oft sieht: ‚Brewing, cooking'
     (natürlich auf Deutsch), damit immer mal wieder etwas passiert." Bis
     hierher stand die Maske still: Geschichte oben, und der einzige
     Fortschritt lief mobil UNTER der Bühne — wer auf die Maske sah, sah
     nichts passieren.

     Kein Widerspruch zu ENTSCHEIDUNG 5 oben („benannt, nicht überbrückt"):
     die Wörter gehören zur jeweils laufenden Phase und zum Vokabular einer
     Druckerei, sie behaupten keinen Fortschritt, den es nicht gibt. Die Zeit
     sagt weiter die Phasenleiste.

     ⏪ 30.09.2026 abends: Wechsel alle drei Sekunden war ZU SCHNELL. Sascha
     am iPhone: „Es macht einen eher noch ungeduldiger und nervöser … Je
     schneller die Wörter abwechseln, desto eher hat man das Gefühl, dass es
     eben auch schnell geht, und wird dann eher enttäuscht." Jetzt acht
     Sekunden: bei 50 s Wartezeit etwa sechs Wörter statt sechzehn — ab und
     zu passiert etwas, ohne ein Tempo zu versprechen, das der Render nicht
     hält. Ein Phasenwechsel bringt ohnehin ein neues Wort. */
  const TAETIGKEIT_TAKT_S = 8;
  const TAETIGKEITEN = [
    ['Liest deine Geschichte', 'Sucht die Motive heraus', 'Ordnet die Erinnerungen'],
    ['Skizziert die Umrisse', 'Zieht die Linien nach', 'Mischt die Farbe an',
      'Schneidet die Flächen', 'Setzt die Schatten', 'Radiert nach'],
    ['Wählt die Lettern', 'Setzt den Titel', 'Richtet die Zeilen aus'],
    ['Walzt die Farbe auf', 'Legt das Papier auf', 'Zieht den Andruck ab'],
  ];
  const TAETIGKEITEN_LAENGER = ['Prüft den Andruck', 'Legt letzte Hand an',
    'Glättet die Kanten', 'Zieht noch einmal ab'];
  const TAETIGKEITEN_STRECKE = [
    ['Liest deine Strecke', 'Sucht die Orte heraus'],
    ['Holt die Karte', 'Zeichnet die Straßen', 'Legt die Strecke auf', 'Beschriftet die Orte'],
    ['Setzt die Zeit', 'Richtet die Zeilen aus'],
    ['Walzt die Farbe auf', 'Zieht den Andruck ab'],
  ];
  const taetigkeiten = () => (istStrecke() ? TAETIGKEITEN_STRECKE : TAETIGKEITEN);

  function dauerText(sek) {
    if (sek < 60) return `${sek} Sekunden`;
    return `${Math.floor(sek / 60)}:${String(sek % 60).padStart(2, '0')} Minuten`;
  }

  function statusZeichnen(t, gesamt, notiz) {
    const feld = document.querySelector('[data-taetigkeit]');
    if (feld) {
      const ueber = t >= gesamt;
      const tabelle = phasenBis(gesamt);
      const i = tabelle.findIndex((p) => t < p.bis);
      const liste = ueber ? TAETIGKEITEN_LAENGER
        : taetigkeiten()[i < 0 ? taetigkeiten().length - 1 : i];
      const wort = `${liste[Math.floor(t / TAETIGKEIT_TAKT_S) % liste.length]} …`;
      if (feld.textContent !== wort) {
        feld.textContent = wort;
        /* Einblenden neu starten: Klasse weg, Reflow, Klasse wieder dran. */
        feld.classList.remove('andruck__taetigkeit--neu');
        void feld.offsetWidth;
        feld.classList.add('andruck__taetigkeit--neu');
      }
    }
    /* 🔴 ÜBERZEIT WIRD GESAGT, NICHT VERSCHWIEGEN (Sascha, 30.09.2026: das
       Modell „bleibt bei ‚noch 1 s' oder noch viel länger hängen … damit
       klar ist, dass es gerade etwas länger dauert und dass da kein Fehler
       ist"). Ab der Nennzeit steht in der Maske, dass es länger dauert, mit
       der bisher verstrichenen Zeit — eine Zahl, die sich bewegt, ist der
       Beweis, dass die Seite nicht hängt. */
    const zeile = document.querySelector('[data-andruck-notiz]');
    if (zeile) {
      const txt = notiz || (t >= gesamt
        ? `Dauert gerade etwas länger als sonst – kein Fehler, dein Blatt entsteht noch (bisher ${dauerText(t)}).`
        : '');
      if (zeile.textContent !== txt) zeile.textContent = txt;
      zeile.hidden = !txt;
    }
  }

  /* --- Ein Fehler steht IN der Maske, nicht nur unter dem Knopf -----------
     Sascha, 30.09.2026, am iPhone: die Fehlerzeile sitzt über dem
     Andruck-Knopf, „das sieht man allerdings nicht, wenn man oben auf diese
     beige Maske blickt. Man sieht dann einfach nur, dass das Ganze hängen
     bleibt." Mobil liegen zwischen Maske und Knopf das ganze Formular.
     Die Zeile unten bleibt trotzdem (`zeigeMeldung`) — dort liest sie, wer
     nach dem Schließen weiter unten arbeitet.

     Die Maske wird dafür umgebaut statt entfernt: sie steht genau dort, wo
     der Kunde hinsieht. Zwei Wege heraus — nochmal oder schließen.
     ⚠️ `andruckPanelZeigen` räumt eine Fehlermaske vorher ab; ohne das
     fände es `[data-andruck]` und kehrte früh zurück, und der nächste Lauf
     liefe unter der alten Fehlermeldung. */
  /** Welches Feld meint eine Eingabe-Meldung des Dienstes („Bitte den 2. Vornamen eintragen.", „Diese Zeichen gibt es
      in unserer Schrift nicht …")? Zuerst das Feld, dessen Beschriftung im Satz steht, sonst Namen/Satz/Jahr am Wort.
      30.10.2026 (Sascha: „Fehler sollten mit einem Klick immer direkt zum Feld führen … konsistent in allen Konzepten"):
      bisher stand so eine Meldung nur oben in der Vorschau. */
  function feldAusMeldung(txt) {
    const t = String(txt || '');
    const alle = (briefDef().felder || []).filter((f) => briefHalter()?.querySelector(`[data-brieffeld-halter="${f.name}"]`));
    const felder = alle.filter((f) => f.label);
    /* 1. Eine Beschriftung in Anführungszeichen („Ort“ enthält Zeichen …) meint genau dieses Feld — auch gekürzt
       („Zeile darunter“ für „Eine Zeile darunter“). */
    const zitiert = [...t.matchAll(/„([^“"]+)[“"]/g)].map((m) => m[1].trim());
    const exakt = felder.find((f) => zitiert.some((q) => f.label === q || (q.length > 3 && f.label.endsWith(q))));
    if (exakt) return exakt.name;
    /* 2. Sonst zählt, was nach „bitte“ steht („Die Zeile unter der Zeit wird zu lang – bitte Namen oder Ort kürzen.“
       meint Namen, nicht Zeit — Befund code-pruefer 30.10.2026), erst danach der ganze Satz. Wortgrenzen, damit
       „Ort“ nicht in „Orte“ oder „Wort“ trifft. */
    const wort = (s, l) => new RegExp(`(^|[^\\p{L}])${l.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}($|[^\\p{L}])`, 'u').test(s);
    const nachBitte = (t.match(/bitte\s+(.*)$/i) || [])[1];
    /* Steht ein „bitte …“ im Satz, zählt nur dieser Teil — „Namen von Veranstaltungen … bitte weglassen“ meint kein
       Namensfeld. Bei mehreren Treffern die längste Beschriftung (die genaueste). */
    /* Ausnahme: „… – bitte kürzen / kürzer schreiben“ — dort steht das Feld VOR „bitte“ („Die Fußzeile ist zu lang …,
       bitte kürzen“), also dann doch der ganze Satz (code-pruefer Runde 2). */
    const teil = nachBitte !== undefined && !(/^\s*k(ü|ue)rz/i.test(nachBitte)) ? nachBitte : t;
    const treffer = felder.filter((x) => wort(teil, x.label)).sort((a, b) => b.label.length - a.label.length);
    if (treffer.length) return treffer[0].name;
    const hat = (n) => alle.some((f) => f.name === n);
    if (/Name/i.test(teil) && hat('namen')) return 'namen';
    if (/Name/i.test(teil) && hat('name')) return 'name';      // Haustier/Pferd: „Bitte gib den Namen des Tiers an.“
    if (/Satz/i.test(teil) && hat('satz')) return 'satz';
    if (/Jahr/i.test(teil) && hat('jahr')) return 'jahr';
    if (/Spielwelt/i.test(teil) && hat('welt')) return 'welt';
    return null;
  }
  function zumFeldSpringen(name) {
    const w = name && briefHalter()?.querySelector(`[data-brieffeld-halter="${name}"]`);
    if (!w) return false;
    /* Liegt das Feld im zugeklappten „Mehr aufs Poster“, erst aufklappen (Befund code-pruefer 30.10.2026). */
    const zu = w.closest('details:not([open])');
    if (zu) zu.open = true;
    w.scrollIntoView({ block: 'center' });
    w.querySelector('input:not([type=hidden]), textarea, select, button')?.focus({ preventScroll: true });
    return true;
  }

  function maskeFehler(txt, { nochmal = true, titel = 'Das hat gerade nicht geklappt', feld = null } = {}) {
    zeigeMeldung(txt);
    /* Eingabe-Meldung mit bekanntem Feld: Hinweis am Feld und „Zum Feld" in der Maske (30.10.2026). Der Hinweis
       verschwindet wie in `feldFehlerZeigen`, sobald im Feld etwas geändert wird oder ein Andruck neu startet
       (`feldFehlerName`) — sonst stand er neben dem fertigen Entwurf weiter (Befund code-pruefer). */
    if (feld) {
      if (feldFehlerName && feldFehlerName !== feld) feldHinweis(feldFehlerName, '');
      feldFehlerName = feld;
      feldHinweis(feld, txt);
      const w = briefHalter()?.querySelector(`[data-brieffeld-halter="${feld}"]`);
      w?.addEventListener('input', () => {
        if (feldFehlerName === feld) { feldHinweis(feld, ''); feldFehlerName = ''; }
      }, { once: true });
    }
    document.querySelector('[data-phasen]')?.remove();
    const flaeche = document.querySelector('[data-tafel="blatt"] .buehne__flaeche');
    if (!flaeche) return;
    flaeche.querySelector('[data-andruck]')?.remove();
    const panel = document.createElement('div');
    panel.dataset.andruck = '';
    panel.dataset.andruckFehler = '';
    panel.className = 'andruck andruck--fehler';
    panel.setAttribute('role', 'alert');
    panel.innerHTML = `
      <div class="andruck__inhalt">
        <p class="andruck__fehlertitel">${escape(titel)}</p>
        <p class="andruck__fehlertext">${escape(txt)}</p>
        <div class="andruck__fehleraktionen">
          ${feld ? '<button type="button" class="echoa-aktion" data-maske-zum-feld>Zum Feld</button>' : ''}
          ${nochmal ? '<button type="button" class="echoa-aktion" data-maske-nochmal>Noch einmal versuchen</button>' : ''}
          <button type="button" class="echoa-link andruck__schliessen" data-maske-zu>Schließen</button>
        </div>
      </div>`;
    panel.addEventListener('click', (ev) => {
      if (ev.target.closest('[data-maske-zu]')) { panel.remove(); return; }
      if (ev.target.closest('[data-maske-zum-feld]')) { panel.remove(); zumFeldSpringen(feld); return; }
      if (ev.target.closest('[data-maske-nochmal]')) {
        panel.remove();
        const knopf = $('[data-aktion]');
        if (knopf && !knopf.disabled) knopf.click();
      }
    });
    flaeche.appendChild(panel);
  }

  /* --- 202: der Auftrag steht in der Warteschlange und wird ABGEHOLT -------
     🔴 DIE ABHOLUNG FEHLTE SEIT DEM 17.08.2026 (gefunden 30.09.2026). Das
     Backend nimmt bei Modell-Überlastung einen Auftrag an und antwortet 202
     mit `auftrag_id` (`dienst.py`, „ÜBERLASTUNG IST KEIN FEHLER, SONDERN EIN
     TERMIN"); abgeholt wird unter `GET /api/entwuerfe/<id>`. Diese Datei hat
     beides nie gekannt: 202 ist `r.ok`, die Antwort hat keine Kandidaten,
     und der Kunde landete im `catch` — „Da ist etwas schiefgegangen". Und
     weil nie abgeholt wurde, VERWARF die Warteschlange den Auftrag nach
     ihrer Abholfrist (`warteschlange.py`, Regel 2). Der gebaute Schutz lief
     also genau im Fall, für den er gebaut war, ins Leere.

     Takt 4 s. Die Warteschlange erneuert bei jedem Abruf den Abholnachweis
     (`ABHOLFRIST_MINUTEN` = 10), vier Sekunden liegen weit darunter. Ein
     einzelner Netzaussetzer bricht nichts ab — gezählt wird nur ein
     endgültiger Zustand oder die eigene Obergrenze von 35 Minuten
     (Warteschlange: 30 min Altersgrenze, plus Luft). */
  const ABHOLTAKT_MS = 4000;
  const ABHOLEN_MAX_MS = 35 * 60 * 1000;

  /* --- Kennung dieses Browsers fürs Tageskontingent (30.09.2026) -----------
     Zufalls-ID in localStorage, damit sie Seitenwechsel und Neuladen
     überlebt — das Kontingent gilt „je Browser und Tag" (Sascha, 25.09.2026).
     🔴 Das ist KEIN Schutz gegen Missbrauch und soll keiner sein: ein
     privates Fenster ist ein neuer Browser mit neuem Kontingent. Den Schutz
     tragen IP-Grenze und Tagesbudget im Backend.
     Ohne localStorage (privater Modus mancher Browser, blockierter Speicher)
     wird für diese Seite eine flüchtige ID gebildet; ganz ohne ID zählt das
     Backend auf die Adresse (`dienst.sitzung_schluessel`). */
  const SITZUNG_KEY = 'echoa:sitzung';
  let sitzungFluechtig = '';
  function sitzungsKennung() {
    const neu = () => ((window.crypto && crypto.randomUUID)
      ? crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`);
    try {
      let id = window.localStorage.getItem(SITZUNG_KEY);
      if (!id || !/^[A-Za-z0-9-]{8,64}$/.test(id)) {
        id = neu();
        window.localStorage.setItem(SITZUNG_KEY, id);
      }
      return id;
    } catch {
      if (!sitzungFluechtig) sitzungFluechtig = neu();
      return sitzungFluechtig;
    }
  }

  /* „ab 14:05 Uhr" bzw. „morgen ab 14:05 Uhr" — aus den Sekunden, die das
     Backend nennt. Ohne brauchbare Zahl: „morgen". */
  function wiederFreiText(sekunden) {
    const s = Number(sekunden);
    if (!Number.isFinite(s) || s <= 0) return 'morgen';
    const ab = new Date(Date.now() + s * 1000);
    const uhr = ab.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
    const heute = new Date().toDateString() === ab.toDateString();
    return `${heute ? '' : 'morgen '}ab ${uhr} Uhr`;
  }

  async function auftragAbholen(id, anim) {
    anim.notiz('Gerade zeichnen sehr viele gleichzeitig. Dein Blatt ist in der '
      + 'Warteschlange und erscheint hier von selbst – lass die Seite einfach offen.');
    const start = Date.now();
    while (Date.now() - start < ABHOLEN_MAX_MS) {
      await new Promise((ok) => setTimeout(ok, D.zeitraffer ? 1000 : ABHOLTAKT_MS));
      let st;
      try {
        const r = await fetch(`${BACKEND}/api/entwuerfe/${encodeURIComponent(id)}`);
        if (r.status === 404) throw Object.assign(new Error('Auftrag unbekannt'), { endgueltig: true });
        if (!r.ok) continue;
        st = await r.json();
      } catch (e) {
        if (e && e.endgueltig) throw e;
        continue;
      }
      if (st.zustand === 'fertig' && st.ergebnis) return st.ergebnis;
      if (st.zustand === 'verworfen' || st.zustand === 'gescheitert') {
        throw new Error(`Auftrag ${st.zustand}`);
      }
    }
    throw new Error('Abholung zu lange');
  }

  /* 🆕 ANDRUCK NACH VERBINDUNGSABBRUCH ABHOLEN (24.10.2026, Sascha: »Wartezeit-Fehler beheben«).
     Gemessen 22.–24.10.: 4 von 38 Andrucken in den Clarity-Spuren endeten in der Fehlermaske,
     während der Dienst denselben Entwurf nach 58–133 s fertig lieferte — das Handy hatte die
     Verbindung verloren (App gewechselt, Funkloch). Der Dienst merkt sich die letzte gelieferte
     Antwort je Browser-Kennung (`dienst.ANTWORT_HALTEN_S`); hier wird sie abgeholt.
     Ob die Antwort zu DIESEM Andruck gehört, entscheidet die eigene Uhr: `alter_s` (Dauer seit
     „fertig", gemessen im Dienst) darf nicht größer sein als die Dauer seit dem Klick (gemessen
     hier). Beides sind Dauern, die Uhrzeiten von Browser und Dienst spielen keine Rolle. Die
     eigene Antwort ist immer jünger als der Klick; eine größere ist der VORIGE Entwurf.
     GELTUNGSBEREICH der Zahlen:
       NACHHOLEN_MAX_MS 180 s ab Beginn des Abholens (nicht ab Klick: wer nach Minuten in die
                        App zurückkehrt, soll trotzdem abholen; der Dienst hält die Antwort
                        900 s) — JA: deckt den längsten gemessenen Andruck (133 s), auch wenn
                        die Verbindung direkt nach dem Klick riss; NEIN als Wartezeit, die ein
                        Kunde sehen soll (der Normalfall endet mit dem ersten Abruf).
       NACHHOLEN_TAKT_MS 3 s — JA: ein fertiger Entwurf erscheint spätestens 3 s nach „fertig";
                        NEIN kalibriert, bei 180 s sind es höchstens 60 Abrufe (Riegel im
                        Dienst: 600 je Adresse und Stunde).
       +1 s             nur gegen Rundung (`alter_s` auf 0,1 s); NICHT vergrößern — jede
                        Sekunde mehr lässt einen vorigen Entwurf als neuen durch.
       2× „keiner"      nichts läuft, nichts Neues → echter Abbruch, alte Fehlermaske. Eine
                        Fehlerantwort (404 alter Dienst, 429 Riegel, 500) zählt genauso.
       10 Netzfehler    ~30 s ohne Netz im Vordergrund → aufgeben statt endlos animieren. */
  const NACHHOLEN_MAX_MS = 180000;
  const NACHHOLEN_TAKT_MS = 3000;
  async function andruckNachholen(gestartet, anim) {
    if (!BACKEND) return null;
    if (anim && anim.notiz) {
      anim.notiz('Die Verbindung war kurz weg – dein Blatt wird trotzdem fertig gezeichnet '
        + 'und erscheint hier von selbst.');
    }
    const kennung = sitzungsKennung();
    const bis = Date.now() + NACHHOLEN_MAX_MS;
    let leer = 0;
    let netzFehler = 0;
    while (Date.now() < bis) {
      let st = null;
      let fehlerAntwort = false;
      try {
        const r = await fetch(`${BACKEND}/api/entwuerfe/nachholen?sitzung=${encodeURIComponent(kennung)}`,
          { cache: 'no-store' });
        netzFehler = 0;
        if (r.ok) st = await r.json();
        else fehlerAntwort = true;
      } catch {
        if (++netzFehler >= 10) return null;
      }
      if (st) {
        const seitKlick = (Date.now() - gestartet) / 1000;
        if (st.zustand === 'fertig' && st.ergebnis && Number(st.alter_s) <= seitKlick + 1) {
          return st.ergebnis;
        }
        if (st.zustand === 'laeuft' || st.laeuft) leer = 0;
        else if (++leer >= 2) return null;
      } else if (fehlerAntwort && ++leer >= 2) {
        return null;
      }
      await new Promise((ok) => setTimeout(ok, NACHHOLEN_TAKT_MS));
    }
    return null;
  }

  /* Meldungen des Dienstes, im Theme geglättet (Sascha, 22.10.2026 abends): „Das zählt nicht als
     Entwurf" versteht ein Kunde nicht, der vom Limit noch nichts weiß — raus. Und ohne Foto hilft
     der Foto-Tipp nicht — dann nur „noch einmal". Der Dienst-Wortlaut bleibt (kein Deploy nötig). */
  function meldungKlar(txt) {
    let m = String(txt || '')
      .replace(/\s*[–-]\s*das zählt nicht als Entwurf\.?/gi, '.')
      .replace(/\s*Das zählt nicht als Entwurf\.?/gi, '')
      .replace(/\.\./g, '.').trim();
    if ((foto.ohne || foto.status === 'leer') && /Am besten klappt es mit einem Foto/.test(m)) {
      m = 'Diesmal ist das Bild nicht gelungen – das kommt vor. Bitte tippe noch einmal auf „Andruck erstellen“.';
    }
    return m;
  }
  function zeigeMeldung(txt) {
    const fehler = $('[data-fehler]');
    if (!fehler) return;
    fehler.textContent = txt;
    fehler.hidden = false;
  }

  async function backendLauf(neueAntworten = null, umwandeln = null) {
    /* Gelb (`umwandeln` = {von, art, wunsch?, tinte?}): scheitert die Umwandlung, steht der alte Entwurf wieder auf
       der Bühne und die Meldung darunter — keine Fehlermaske über einem Bild, das der Kunde schon hatte. */
    const melde = (txt, opt) => {
      if (!umwandeln) return maskeFehler(txt, opt);
      historieWaehlen(umwandeln.von);
      zeigeMeldung(txt);
      return undefined;
    };
    /* Neue Antworten in den Bestand mischen — je Frage gewinnt die JÜNGSTE.
       Eine Map über den Fragetext, weil genau der die Identität ist: das
       Backend erkennt seine eigene Frage daran wieder
       (`dienst._AKZENT_FRAGE`). */
    if (neueAntworten && neueAntworten.length) {
      const nach = new Map(s.antworten.map((a) => [a.frage, a]));
      neueAntworten.forEach((a) => { if (a && a.frage) nach.set(a.frage, a); });
      s.antworten = Array.from(nach.values());
    }
    /* Eine Umwandlung fragt nicht zurück: Ort und Szene stehen im gespeicherten Entwurf. */
    const rueckfrageAntworten = !umwandeln && s.antworten.length ? s.antworten : null;
    /* 🆕 19.10.2026 (Sascha: „SINDELFINGEN" aus dem Vortest auf der Bodensee-Karte): Satz-Felder,
       die der Kunde nicht selbst getippt hat (alter KI-Vorschlag, vom Browser wiederhergestellt),
       gehen LEER in einen neuen Andruck — sonst hält sie der Dienst für Kundeneingabe und der
       neue Vorschlag kommt nie an (code-pruefer, BELEGT: `satz_normalisieren` lässt den Kunden
       gewinnen). Danach füllt `streckeVorschlagEinsetzen` sie mit dem neuen Vorschlag. */
    if (istStrecke()) {
      const halter = briefHalter();
      STRECKE_SATZ_FELDER.forEach((name) => {
        const el = halter && halter.querySelector(`[data-feld="${name}"]`);
        if (el && el.value && el.dataset.eigen !== '1') el.value = '';
      });
    }
    sammleBrief();
    const fehlt = brieffehler();
    if (fehlt) {
      /* Stufe 2: liegt das fehlende Feld in einem früheren (zugeklappten) Schritt, dorthin springen —
         sonst stünde die Meldung neben einem Feld, das der Kunde nicht sieht. */
      const liste = wurzel.classList.contains('maske-schritte') ? schritteListe() : null;
      const k = liste ? liste.findIndex((x) => brieffehler(x.namen)) : -1;
      if (k >= 0 && k !== schrittAktiv) {
        schrittAktiv = k;
        schritteZeichnen();
        const f = $('[data-schritt-fehler]');
        if (f) { f.textContent = fehlt; f.hidden = false; }
        $(`[data-brief] [data-brieffeld-halter="${liste[k].namen[0]}"]`)?.scrollIntoView({ block: 'start' });   // direkt (30.10.2026, s. feldFehlerZeigen)
      }
      const r = zeigeMeldung(fehlt);
      /* Pixel-Paar dazu (Sascha live, 30.10.2026: dort fehlten Hinweis am Feld und „Zum Feld“ — gleiches Template). */
      if ((eineSeite() || istGaming()) && !schritteAus) feldFehlerZeigen(fehlt);   // nach dem ersten Andruck wie bisher
      return r;
    }
    if ((eineSeite() || istGaming()) && !schritteAus) feldFehlerZeigen('');
    /* Ein Hinweis aus einer Dienst-Meldung (`maskeFehler`) kommt immer NACH einem Andruck, also bei `schritteAus` —
       dort räumt die Zeile darüber nichts ab. Darum hier unabhängig davon (code-pruefer Runde 2, 30.10.2026). */
    else if (feldFehlerName) { feldHinweis(feldFehlerName, ''); feldFehlerName = ''; }
    const fehler = $('[data-fehler]');
    if (fehler) fehler.hidden = true;

    s.phase = 'laeuft';
    s.kandidatId = null;
    s.kandidat = null;
    speichernZeigen();
    ansichtWechseln('blatt');
    andruckPanelZeigen();
    const anim = phasenAnim();
    /* Gelb: sagen, was gerade entsteht — die Phasenwörter sprechen sonst von „deiner Geschichte“. */
    if (umwandeln && GELB_WARTE[umwandeln.art]) anim.notiz(GELB_WARTE[umwandeln.art]);
    zeichne();

    /* Der Stand, mit dem dieser Andruck bestellt wird — eingefroren VOR dem
       Absenden. Er geht später unverändert in die Entwurfs-Historie, damit
       Bild und Text dort zusammengehören (s. `historieMerken`). */
    let briefStand = { ...s.brief };
    /* Die Beschriftungen gehören zum gezeigten Entwurf, nicht zur Bestellung eines neuen — den
       neuen beschriftet Stufe 1 aus den Formularzeilen (29.10.2026). */
    delete briefStand.beschriftungen;

    try {
      const brief = rueckfrageAntworten
        ? { ...briefStand, rueckfrageAntworten }
        : umwandeln ? { ...briefStand, _umwandeln: umwandeln } : briefStand;
      /* 🆕 24.10.2026 (Sascha: »Wartezeit-Fehler beheben«): reißt die Verbindung während des
         Zeichnens ab (App gewechselt, Funkloch), zeichnet der Dienst weiter und merkt sich die
         Antwort. Statt der Fehlermaske holt `andruckNachholen` sie dann ab. Nur ein NETZ-Abbruch
         führt dorthin — eine echte Fehlerantwort des Dienstes (500, 429) geht den alten Weg. */
      const gestartet = Date.now();
      let r = null;
      let a = null;
      try {
        r = await fetch(`${BACKEND}/api/entwuerfe`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ produkt: D.produkt.handle, brief, sitzung: sitzungsKennung() }),
        });
        if (r.ok) a = await r.json();
      } catch (netz) {
        a = await andruckNachholen(gestartet, anim);
        if (!a) throw netz;
        r = null;
      }
      /* 🔴 429 hat seit dem 30.09.2026 DREI Gründe (`grund` im Body), und
         jeder braucht einen anderen Satz:
           sitzung        Tageskontingent dieses Browsers (`LIMIT_JE_SITZUNG`,
                          10 je 24 h seit 24.10.2026) — wann es weitergeht, steht in
                          `wieder_frei_in_s`
           sitzung_laeuft ein anderer Andruck desselben Browsers läuft noch
                          und würde das Kontingent füllen
           ip / fehlt     Stundengrenze der Adresse (`LIMIT_JE_IP_STUNDE`),
                          auch der Rückfall für ältere Backend-Stände
         Bis 30.09.2026 landete ein 429 im `catch` als „Da ist etwas
         schiefgegangen". Allen Sätzen gemeinsam: was los ist, wann es
         weitergeht, und dass gesehene Entwürfe bestellbar bleiben — die
         Meldung steht an der Kaufstrecke und soll dort halten, nicht
         abschrecken. */
      if (r && r.status === 429) {
        let sperre = {};
        try { sperre = await r.json(); } catch { sperre = {}; }
        anim.stop();
        s.phase = 'leer';
        zeichne();
        if (sperre.grund === 'sitzung') {
          /* Die Zahl kommt vom Backend (`limit`), nicht aus einer Kopie hier —
             fehlt sie, steht der Satz ohne Zahl. */
          const zahl = Number.isInteger(sperre.limit) ? ` ${sperre.limit}` : '';
          /* Der Verweis auf die Entwürfe nur, wenn die Leiste auch welche zeigt (Sascha: „andernfalls
             macht auch die Fehlermeldung keinen Sinn"). */
          const hatEntwuerfe = historieLesen().length > 0;
          return melde(`Für heute hast du alle${zahl} Andrucke erstellt. `
            + `Neue kannst du ${wiederFreiText(sperre.wieder_frei_in_s)} erstellen`
            + (hatEntwuerfe ? ' – deine bisherigen Entwürfe findest du unter „Deine Entwürfe“ '
              + 'über dem Knopf und kannst sie jetzt bestellen.' : '.'),
          { nochmal: false, titel: 'Deine Andrucke für heute' });
        }
        if (sperre.grund === 'sitzung_laeuft') {
          return melde('Dein anderer Andruck wird gerade noch gezeichnet. '
            + 'Warte, bis er fertig ist – dann kannst du weitermachen.',
          { nochmal: false, titel: 'Einen Moment' });
        }
        return melde('Du hast in der letzten Stunde schon sehr viele Andrucke erstellt. '
          + 'Spätestens in einer Stunde geht es weiter – jeden Entwurf, den du schon '
          + 'gesehen hast, kannst du jederzeit bestellen.',
        { nochmal: false, titel: 'Kurze Pause' });
      }
      if (r && !r.ok) throw new Error(`Backend ${r.status}`);
      if (r && r.status === 202 && a.auftrag_id) a = await auftragAbholen(a.auftrag_id, anim);
      anim.stop();

      /* Formular-Validierung (Beschluss 03.08.): mehrdeutig → Chips zurück,
         kein bezahlter Render auf geratenem Input. Nach EINER beantworteten
         Runde rendert das Backend die beste Fassung statt erneut zu fragen.

         ⚠️ Die Runde sagt seit dem 11.08.2026 das BACKEND (`a.runde`), nicht
         mehr diese Datei über `!rueckfrageAntworten`. Grund: es gibt einen
         Fall, in dem auch die zweite Runde kein Raster ergibt (A1, fünf
         auflösbare Zeilen nach einem „weglassen"). Auf der alten Bedingung
         fiel der durch beide Zweige und landete im catch — der Kunde sah
         „Da ist etwas schiefgegangen" und konnte nichts daran ändern.
         Der `|| 1` hält ältere Backend-Stände am Laufen. */
      /* Ein Brief, den das Backend ohne Modell als ungültig erkennt (Zitat:
         leer, zu lang, Zeichen ohne Glyphe) kommt als `meldung` zurück — ein
         Satz zum Korrigieren, keine Chip-Rückfrage (28.09.2026). */
      /* Diese drei Ausgänge stehen seit dem 30.09.2026 ebenfalls IN der
         Maske (`maskeFehler`) — aus demselben Grund wie der Fehler unten:
         der Kunde sieht dorthin, nicht auf die Zeile über dem Knopf. */
      if (a.meldung && !(a.kandidaten || []).length) {
        s.phase = 'leer';
        zeichne();
        return melde(meldungKlar(a.meldung), { nochmal: false, titel: 'Bitte kurz prüfen',
                                                     feld: feldAusMeldung(a.meldung) });
      }
      const rueckfragen = (a.rueckfragen || []).filter((rf) => rf.frage && (rf.chips || []).length);
      if (rueckfragen.length && (a.runde || 1) === 1) {
        s.phase = 'leer';
        rueckfragenZeigen(rueckfragen);
        zeichne();
        return;
      }

      if (a.safety === 'b_manuell') {
        s.phase = 'leer';
        zeichne();
        return melde('Diesen Entwurf schauen wir uns von Hand an, bevor er entsteht. '
          + 'Du bekommst innerhalb eines Werktags eine Mail.',
        { nochmal: false, titel: 'Wir schauen es uns an' });
      }

      /* Zweite Runde und immer noch kein Raster: HARTER BLOCK mit benannten
         Feldern — genau der Mechanismus aus dem Beschluss vom 03.08., nur
         nach einem geführten Versuch statt davor. Bewusst KEINE dritte
         Chip-Runde: jede weitere kostet einen Textdurchlauf und hat keine
         bessere Aussicht, weil die Angabe im Formular fehlt, nicht in der
         Antwort. */
      if (a.runde === 2 && !(a.kandidaten || []).length) {
        s.phase = 'leer';
        zeichne();
        const offen = (a.rueckfragen || []).map((rf) => rf.frage).filter(Boolean);
        return melde([
          'Daraus wird noch kein vollständiges Raster.',
          offen.join(' '),
          a.hinweis || '',
          'Bitte oben ergänzen – danach läuft es durch.',
        ].filter(Boolean).join(' '), { nochmal: false, titel: 'Bitte kurz ergänzen' });
      }

      const k = (a.kandidaten || [])[0];
      if (!k) throw new Error('Antwort ohne Kandidaten');
      if (umwandeln && k.brief) {
        /* Der Dienst baut den neuen Brief aus dem gespeicherten Entwurf. Das Formular übernimmt davon nur, was die
           Umwandlung ändert (Look, Tinte, Stimmung) — so tragen Bühne, Bestellzeile und „Deine Entwürfe“ denselben
           Stand, und ein Text, den der Kunde in Grün geändert hat, bleibt. */
        const neu = { ...s.brief };
        ['look', 'tinte', 'stimmung'].forEach((f) => {
          if (k.brief[f] != null && k.brief[f] !== '') neu[f] = k.brief[f]; else if (f === 'stimmung') delete neu[f];
        });
        briefEinsetzen(neu);
        briefSichtbar();
        sammleBrief();
        briefStand = { ...s.brief };
        delete briefStand.beschriftungen;
      }
      s.kandidatId = k.id;
      s.kandidat = k;
      /* Farbachse: ein neuer Andruck steht auf dem BESTELLTEN Ton. */
      s.ton = s.brief.grund || s.brief.tinte || '';
      s.kandidatTon = s.ton;
      s.kartenBasis = kartenSchluessel(briefStand);
      /* Haustier: Basis für Satz-Wechsel ohne Render, und der Schnappschuss
         der gezeigten Fassung (Warenkorb → Druck). */
      s.haustierBasis = istSatzH1() ? briefSchluessel(briefStand) : '';
      s.textBasis = textSatzAktiv() ? briefSchluessel(briefStand) : '';
      s.textSatzFehlt = false;
      s.haustierSatz = k.satz || '';
      if (istHaustier()) {
        haustierLookGut = k.look || '';
        haustierLookSetzen(k.look);
      }
      /* Rezept: dasselbe — Basis für Satz-Wechsel ohne Render, Schnappschuss
         der gezeigten Fassung, und die Knöpfe auf das, was das Backend
         TATSÄCHLICH gesetzt hat (SW gescheitert → farbig; Lexikon nicht
         setzbar → Rezept). */
      s.rezeptBasis = istRezept() ? briefSchluessel(briefStand) : '';
      s.rezeptSatz = istRezept() ? (k.satz || '') : '';
      if (istRezept()) {
        rezeptGut = { look: k.look || '', machart: k.machart || '' };
        rezeptChipSetzen('look', k.look);
        /* Rückfall Lexikon → Rezept: das Titelfeld war ausgeblendet und leer;
           das Backend hat das Gericht als Titel gesetzt (`_rezept_rueckfall`). */
        if (rezeptChipSetzen('machart', k.machart) && k.titel) {
          const t = document.querySelector('[data-feld="titel"]');
          if (t && !t.value.trim()) { t.value = k.titel; sammleBrief(); }
        }
        if (a.hinweis) zeigeMeldung(a.hinweis);
      }
      /* Strecke: Basis für Satz-Wechsel ohne Kartenabruf, der Schnappschuss
         der gezeigten Fassung, und die Vorschläge der KI in die Felder. */
      s.streckeBasis = istStrecke() ? briefSchluessel(briefStand) : '';
      s.streckeSatz = istStrecke() ? (k.satz || '') : '';
      if (istStrecke()) streckeVorschlagEinsetzen(k.strecke);
      s.kandidatBild = `${BACKEND}${k.vorschau_url}`;
      vorschauSetzen(kandidatBildUrl(s.kandidatBild));
      /* 🔴 HIER, direkt am fertigen Entwurf, nicht beim Verlassen der Phase:
         `eingabeGeaendert()` löscht `s.kandidatId`, und ein Merken von dort
         käme immer einen Zug zu spät. */
      historieMerken(k, briefStand, rueckfrageAntworten);
      metaEntwurf(k.id);
      andruckPanelVerbergen();
      s.phase = 'fertig';
      neurenderHinweisVerbergen();
      speichernZeigen();
      /* Was Stufe 1 am Input ändern MUSSTE, gehört dem Kunden gesagt:
         aufgelöste Tippfehler („Wohnlobim → Wohnmobil"), eine verworfene
         Jahresangabe, „Marken kommen nicht ins Bild". Bis zum 11.08.2026
         stand das nur in der Kandidaten-Meta und las es niemand — die
         A1-Vorschau zeigt den Rohrender ohne Typo, das fehlende Jahr ist
         dort also nicht einmal sichtbar. Kanal wie beim Safety-Hinweis. */
      const noten = [
        a.safety === 'a_umgedeutet' ? a.safetyHinweis : '',
        a.hinweis || '',
      ].filter(Boolean);
      if (umwandeln) noten.unshift(GELB_FERTIG[umwandeln.art] || '');
      if (noten.filter(Boolean).length) zeigeMeldung(noten.filter(Boolean).join(' '));
      zeichne();
    } catch (e) {
      anim.stop();
      s.phase = 'leer';
      zeichne();
      melde(umwandeln
        ? 'Das neue Bild hat gerade nicht geklappt – dein Entwurf ist noch da. Versuch es bitte gleich noch einmal.'
        : 'Beim Zeichnen ist etwas schiefgegangen – oft ist das Modell nur kurz '
          + 'überlastet. Versuch es bitte gleich noch einmal.');
      console.error(e);
    }
  }

  /* Rückfragen im Andruck-Panel: Frage + antippbare Chips, „Entwürfe
     erzeugen" erst, wenn ALLE beantwortet sind. */
  function rueckfragenZeigen(rueckfragen) {
    andruckPanelVerbergen();
    const flaeche = document.querySelector('[data-tafel="blatt"] .buehne__flaeche');
    if (!flaeche) return;
    const panel = document.createElement('div');
    panel.dataset.andruck = '';
    /* `andruck--frage`: die Galerie-Pfeile weichen, sie lagen über dem Antwortfeld (Tiefen-Check
       22.10.2026, Strecke). */
    panel.className = 'andruck andruck--frage';
    const gewaehlt = new Map();
    const inhalt = document.createElement('div');
    inhalt.className = 'andruck__inhalt';
    inhalt.innerHTML = '<p class="feld-label">Eine kurze Rückfrage, bevor gezeichnet wird:</p>';
    rueckfragen.forEach((rf, i) => {
      const p = document.createElement('p');
      p.className = 'feld-hilfe';
      p.textContent = rf.frage;
      inhalt.appendChild(p);
      const reihe = document.createElement('div');
      reihe.className = 'optionen';
      /* 🔴 FREITEXT NEBEN DEN CHIPS (Sascha, 22.09.2026, Testbestellung
         Sri Lanka: „keiner der vorgeschlagenen Orte … hätte ich mir ein
         Freifeld gewünscht"). Die Chips bleiben der schnelle Weg; das Feld
         ist der Ausgang, wenn keiner passt. Fürs Backend ist eine getippte
         Antwort dieselbe Sache wie ein Chip — ein String in
         `rueckfrageAntworten`. Chip und Feld schließen sich aus: ein Chip
         leert das Feld, eine Eingabe löst den Chip. */
      const frei = document.createElement('input');
      frei.type = 'text';
      frei.className = 'andruck__frei';
      frei.placeholder = 'Oder eigene Antwort eintippen …';
      frei.setAttribute('aria-label', 'Eigene Antwort');
      frei.maxLength = 80;
      rf.chips.forEach((chip) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'option';
        b.setAttribute('aria-pressed', 'false');
        b.textContent = chip;
        b.addEventListener('click', () => {
          gewaehlt.set(i, chip);
          frei.value = '';
          reihe.querySelectorAll('.option').forEach((x) =>
            x.setAttribute('aria-pressed', String(x === b)));
          weiter.disabled = gewaehlt.size < rueckfragen.length;
        });
        reihe.appendChild(b);
      });
      inhalt.appendChild(reihe);
      frei.addEventListener('input', () => {
        const wert = frei.value.trim();
        if (wert) {
          gewaehlt.set(i, wert);
          reihe.querySelectorAll('.option').forEach((x) => x.setAttribute('aria-pressed', 'false'));
        } else {
          gewaehlt.delete(i);
        }
        weiter.disabled = gewaehlt.size < rueckfragen.length;
      });
      frei.addEventListener('keydown', (ev) => {
        if (ev.key === 'Enter' && !weiter.disabled) { ev.preventDefault(); weiter.click(); }
      });
      inhalt.appendChild(frei);
    });
    const weiter = document.createElement('button');
    weiter.type = 'button';
    weiter.className = 'echoa-aktion';
    weiter.disabled = true;
    /* Derselbe Begriff wie am Hauptknopf (Sascha, 28.10.2026, »Ja, umbenennen«). ⏪ Bis dahin „Entwürfe erzeugen". */
    weiter.textContent = 'Andruck erstellen';
    weiter.addEventListener('click', () => {
      panel.remove();
      backendLauf(rueckfragen.map((rf, i) => ({ frage: rf.frage, antwort: gewaehlt.get(i) })));
    });
    inhalt.appendChild(weiter);
    panel.appendChild(inhalt);
    flaeche.appendChild(panel);
  }

  /* Die echte Vorschau ersetzt das Beispielbild — in Blatt UND Detail. */
  function vorschauSetzen(url) {
    const blatt = document.querySelector('[data-tafel="blatt"] .buehne__bild');
    /* 🔴 SICHTBAR WARTEN (Sascha, 23.09.2026: beim Farb- und Formatwechsel
       „wirkt es, als passiere nichts"). Solange das neue Bild lädt (ton.png
       und ?format= setzen im Backend, 2–10 s), trägt die Tafel
       `data-laedt`; `echoa-buehne.css` legt darüber einen Schleier mit
       „Wird gesetzt …". Weg beim ersten load/error, und nur, wenn sich die
       Adresse wirklich ändert. */
    const tafel = document.querySelector('[data-tafel="blatt"]');
    if (blatt && tafel && url && blatt.src !== url) {
      tafel.dataset.laedt = '';
      const fertigGeladen = () => { delete tafel.dataset.laedt; };
      blatt.addEventListener('load', fertigGeladen, { once: true });
      blatt.addEventListener('error', fertigGeladen, { once: true });
      /* Sicherheitsnetz: nach 30 s fällt der Schleier auch ohne Ereignis. */
      setTimeout(fertigGeladen, 30000);
    }
    /* `srcset` aus Shopifys `image_tag` schlägt `src` — entfernen, sonst zeigt
       die Bühne bei einem Bild mit Kandidatenliste weiter das Startbild
       (code-pruefer 09.09.2026, VERMUTET; hier defensiv geschlossen). */
    if (blatt) { blatt.removeAttribute('srcset'); blatt.removeAttribute('sizes'); blatt.src = url; }
    const detail = document.querySelector('.detail__bild');
    if (detail) detail.src = url;
    raumPosterSetzen();
    kachelnEigenZeichnen(istKauf());   // E9: die Bildchen folgen dem neuen Ziel sofort
  }

  /* 🔴 DER EIGENE ENTWURF IM RAUM (Saschas T1 »A«, 21.10.2026). Saschas Vorgabe vom 19.08.2026
     („erst in Stufe 2 auf die Mockups switchen, die der Kunde auch tatsächlich generiert hat")
     war nie umgesetzt: in Phase `fertig` verschwand das Beispiel (`raumBeispieleSchalten`), aber
     in der Montage hing weiter das Shop-Bild — kein Code setzte `[data-raum-poster] img`
     (gemessen am Live-Shop 21.10.2026: Entwurf „Mampf", im Raum „Sapperling").
     Jetzt: in `fertig` trägt jede Montage (auch das kleine Raumbild am Formatwähler) das Bild der
     Bühne; das Shop-Bild davor merkt sich `data-vor-kunde` und kommt zurück, sobald die Phase
     endet. Setzt jemand anderes (`galerieTauschen`) inzwischen ein neues Shop-Bild, gilt dieses. */
  function raumPosterSetzen() {
    const blatt = document.querySelector('[data-tafel="blatt"] .buehne__bild');
    const kunde = s.phase === 'fertig' && s.kandidatId && blatt ? blatt.getAttribute('src') || '' : '';
    document.querySelectorAll('[data-raum-poster] img').forEach((img) => {
      const jetzt = img.getAttribute('src') || '';
      if (kunde) {
        if (jetzt === kunde) return;
        /* Merken nur ein SHOP-Bild: wechselt in `fertig` die Bühne (Ton, Format, Historie), ist
           `jetzt` ein älterer Entwurf vom Dienst — der darf nicht als Rückfall gelten
           (code-pruefer 21.10.2026). Ein neues Shop-Bild aus `galerieTauschen` gilt dagegen. */
        if (img.dataset.vorKunde == null || !(BACKEND && jetzt.startsWith(BACKEND))) img.dataset.vorKunde = jetzt;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.setAttribute('src', kunde);
      } else if (img.dataset.vorKunde != null) {
        img.setAttribute('src', img.dataset.vorKunde);
        delete img.dataset.vorKunde;
      }
    });
  }

  /* Größenhilfe am Formatwähler (Saschas T1 »A«, 21.10.2026): Klon der ersten Raum-Tafel,
     einmal angelegt, danach von `raumEinzeln` mitskaliert wie die großen Tafeln. Nur in
     Phase `fertig` — vorher gibt es keine Formatwahl. */
  /* Das kleine Raumbild vergrößert auf den Poster-Bereich (1,3) — aber nur so weit, dass die
     Oberkante des Posters im Bild bleibt (Sascha, 22.10.2026: „bei Wahl von 50×70 ragt das
     Vorschaubild aus dem Bild"; die feste 1,3 war an Raum K gemessen, nicht am Pferde-Raum).
     Rechnung mit Ursprung 30 % von oben wie im CSS: y' = oy + (y − oy) · k. */
  function kleinZoom(klon) {
    if (!klon) return;
    klon.style.setProperty('--klein-zoom', '1');
    const poster = klon.querySelector('[data-raum-poster]');
    const hb = klon.parentElement?.getBoundingClientRect();
    const pb = poster?.getBoundingClientRect();
    if (!hb || !pb || !hb.height || !pb.height) { klon.style.removeProperty('--klein-zoom'); return; }
    const oy = hb.top + hb.height * 0.3;
    const k = pb.top < oy ? (oy - hb.top - 4) / (oy - pb.top) : 1.3;
    klon.style.setProperty('--klein-zoom', String(Math.max(1, Math.min(1.3, k)).toFixed(3)));
  }
  function groesseRaumZeichnen() {
    const knopf = $('[data-groesse-raum]');
    const halter = $('[data-groesse-raum-bild]');
    const quelle = document.querySelector('.pdp__tafel[data-tafel^="raum-"] [data-raum]');
    if (!knopf || !halter || !quelle) { if (knopf) knopf.hidden = true; return; }
    if (!halter.firstElementChild) {
      const klon = quelle.cloneNode(true);
      klon.querySelectorAll('[data-raum-beispiel]').forEach((e) => e.remove());
      klon.querySelectorAll('img').forEach((e) => e.setAttribute('loading', 'eager'));
      klon.classList.add('raum--klein');
      halter.appendChild(klon);
      knopf.dataset.ziel = quelle.closest('[data-tafel]').dataset.tafel;
    }
    knopf.hidden = s.phase !== 'fertig';
    if (knopf.hidden) return;
    raumEinzeln(halter.firstElementChild);
    kleinZoom(halter.firstElementChild);
    const text = knopf.querySelector('[data-groesse-raum-text]');
    if (text && s.groesse) text.textContent = `So wirkt ${s.groesse} an der Wand`;
  }

  function wartezeitStarten() {
    s.phase = 'laeuft';
    const gesamt = D.dauer_sekunden || 50;
    const takt = D.zeitraffer ? 240 : 1000;   // Zeitraffer nur zum Prüfen
    const knopf = $('[data-aktion]');
    const tafel = document.querySelector('[data-tafel="blatt"]');

    // Ansicht auf „Blatt", sonst läuft der Andruck unsichtbar
    ansichtWechseln('blatt');
    andruckPanelZeigen();

    let t = 0;
    zeichne();

    const timer = setInterval(() => {
      t += 1;
      const rest = Math.max(0, gesamt - t);
      /* ⏪ 07.09.2026: hier stand `const phase = PHASEN.find(...)`. Die
         Variable wurde nie gelesen — und haette nach der Umstellung auf
         Anteile still auf ein `bis` gegriffen, das es in `PHASEN` nicht mehr
         gibt. Gezeichnet wird ohnehin in `phasenZeichnen`. */

      if (knopf) knopf.textContent = `Andruck läuft – noch etwa ${rest} Sekunden`;
      phasenZeichnen(t, gesamt);
      statusZeichnen(t, gesamt, '');

      if (t >= gesamt) {
        clearInterval(timer);
        s.phase = 'fertig';
        /* 🔴 sim_-Präfix, NIE k_: die frühere Fake-ID im k_-Format wäre als
           _kandidat_id in die Order gelaufen und hätte im Fulfillment wie
           ein echter (fehlender) Kandidat ausgesehen — SystemExit nach der
           Zahlung (code-pruefer 09.08.). Der Warenkorb schickt sim_-IDs
           nicht als _kandidat_id, sondern markiert die Zeile als simuliert. */
        s.kandidatId = `sim_${Math.random().toString(36).slice(2, 10)}`;
        andruckPanelVerbergen();
        speichernZeigen();   // sim_-ID: bleibt verborgen, es gibt nichts zu verschicken
        zeichne();
      }
    }, takt);
  }

  /* `ueber`: die Nennzeit ist verstrichen. Dann steht an der laufenden
     Phase „läuft noch" statt eines eingefrorenen „noch 1 s" — genau die
     Anzeige, die Sascha am 30.09.2026 als Hänger las. */
  function phasenZeichnen(t, gesamt, ueber = false) {
    const halter = document.querySelector('[data-phasen]');
    if (!halter) return;
    const tabelle = phasenBis(gesamt);
    halter.innerHTML = tabelle.map((p, i) => {
      const vorher = i === 0 ? 0 : tabelle[i - 1].bis;
      const zustand = t > p.bis ? 'fertig' : t > vorher ? 'laeuft' : 'offen';
      const zeit = zustand === 'fertig' ? '✓'
        : zustand !== 'laeuft' ? ''
        : ueber ? 'läuft noch' : `noch ${Math.max(0, p.bis - t)} s`;
      return `<li class="phase phase--${zustand}">
        <span class="phase__rom">${p.rom}</span>
        <span class="phase__titel">${p.titel}</span>
        <span class="phase__zeit">${zeit}</span>
      </li>`;
    }).join('');
  }

  /* Der Andruck zeigt die Eingaben in Echoa-Typografie, nicht das echte Bild —
     das entsteht erst in der Generierung. */
  function andruckPanelZeigen() {
    const flaeche = document.querySelector('[data-tafel="blatt"] .buehne__flaeche');
    flaeche?.querySelector('[data-andruck-fehler]')?.remove();
    if (!flaeche || flaeche.querySelector('[data-andruck]')) return;

    /* Kopf und Zeilen kommen aus dem Brief des jeweiligen Konzepts — nicht
       mehr aus fest verdrahteten A1-Feldern (09.08.2026). */
    sammleBrief();
    const namen = s.brief.namen || s.brief.ort || '';
    const listenfeld = briefDef().felder.find((f) => f.typ === 'liste');
    const dinge = listenfeld ? (s.brief[listenfeld.name] || [])
      : [s.brief.moment].filter(Boolean);

    const panel = document.createElement('div');
    panel.dataset.andruck = '';
    panel.className = 'andruck';
    panel.innerHTML = `
      <div class="andruck__inhalt">
        ${namen ? `<p class="andruck__namen">${escape(namen)}</p>` : ''}
        <ul class="andruck__dinge">${dinge.map((d) => `<li>${escape(d)}</li>`).join('')}</ul>
      </div>
      <div class="andruck__status">
        <span class="andruck__walze" aria-hidden="true"></span>
        <span class="andruck__taetigkeit" data-taetigkeit aria-hidden="true">${taetigkeiten()[0][0]} …</span>
        <p class="andruck__notiz" data-andruck-notiz role="status" hidden></p>
      </div>`;
    flaeche.appendChild(panel);

    /* Die Phasenleiste sitzt mobil UNTER der Bühne, nicht im Panel.
       Gemessen: Geschichte plus vier Phasenzeilen streckten das Panel auf ein
       Verhältnis von 1,89 statt 1,33, und die Phasenzeilen brachen um. Unter
       der Bühne haben sie die volle Breite.

       Das ist ein Elternwechsel, keine Media Query — deshalb hier und nicht
       im CSS. */
    const leiste = document.createElement('ol');
    leiste.className = 'phasen';
    leiste.dataset.phasen = '';
    if (mobil()) {
      leiste.classList.add('phasen--ausgelagert');
      const block = flaeche.closest('.buehne-block');
      block?.parentElement?.insertBefore(leiste, block.nextSibling);
    } else {
      panel.appendChild(leiste);
    }

    zurWartemaskeScrollen();
  }

  function mobil() {
    return window.matchMedia('(max-width: 480px)').matches;
  }

  /* 🔴 834 px, NICHT 480 — und das ist ein anderer Umbruchpunkt als `mobil()`.
     Er beantwortet die Frage „steht die Bühne ÜBER dem Formular statt daneben?"
     und ist damit an `.pdp__innen` gebunden (`echoa-pdp.css`, Media Query
     834), nicht an die Mobil-Regeln bei 480. Wer die zwei zusammenlegt,
     lässt Tablets ohne Scroll zurück, obwohl die Bühne dort schon oben steht.
     GELTUNGSBEREICH: nur für die Frage, ob nach dem Klick gescrollt werden
     muss. NICHT als allgemeine Mobil-Erkennung — dafür bleibt `mobil()`. */
  function einspaltig() {
    return window.matchMedia('(max-width: 834px)').matches;
  }

  /* --- Nach „Andruck erstellen" zur Warte-Maske scrollen (20.08.2026) -------
     Sascha: „Nach Klick auf ‚Andruck erstellen' sollte mobile zur Wartemaske
     hoch gescrollt werden. Sonst ist nicht klar was passiert und das
     Entertainment für den Kunden geht verloren (Bounce Risiko)."

     🔴 NUR EINSPALTIG. Ab 835 px steht die Bühne sticky NEBEN dem Formular
     und ist beim Klick ohnehin im Blick; dort wäre ein Sprung eine Bewegung
     ohne Anlass.

     🔴 DER SCROLL SCHEITERTE ZUERST AM SCROLL-ANCHORING, UND DIE REPARATUR
     STEHT DESHALB IM CSS, NICHT HIER. Der Aufrufer hängt unmittelbar davor
     die Warte-Maske UND (mobil) die Phasenleiste ins Dokument. Der Browser
     hält bei wachsendem Inhalt die sichtbare Stelle fest, indem er den
     Scrollstand nachzieht — und überschreibt dabei den gerade abgesetzten
     Scroll. Am laufenden Theme gemessen (390 × 844): `scrollTo({top: 86})`
     wurde nachweislich abgesetzt, und einen Wimpernschlag später stand
     `scrollY` auf 1251. `.pdp__innen` trägt seither `overflow-anchor: none`
     (`echoa-pdp.css`); ohne diese Zeile ist die Funktion hier wirkungslos.

     ⏪ Eine Zwischenfassung wartete stattdessen zwei `requestAnimationFrame`
     ab. Verworfen: sie behandelte die Wirkung statt der Ursache, und rAF
     feuert in einem nicht sichtbaren Tab gar nicht — der Scroll wäre dann
     stumm ausgefallen, und stumm ist genau das, was hier nicht sein darf.

     🔴 DER KOPF WIRD GEFRAGT, OB ER AM ZIEL ÜBERHAUPT NOCH DA IST — und das
     ist eine andere Frage als „steht irgendwo `position: sticky`".

     Zwei Dinge machen sie schwer, beide am laufenden Theme belegt:
     1. DAS KLEBEN SITZT NICHT IMMER AM SELBEN ELEMENT. Bis zum 20.08.2026
        trug `.kopf` selbst ein `position: sticky`, das nie wirkte (seine
        Shopify-Hülle ist genauso hoch wie er). Seither klebt die HÜLLE, und
        `.kopf` steht auf `relative`. Wer nur `.kopf` fragt, bekommt seit
        dieser Änderung immer „klebt nicht" — auch auf Desktop, wo er klebt.
        Deshalb werden BEIDE Ebenen gefragt.
     2. EIN KLEBENDES ELEMENT KLEBT NICHT ÜBERALL. Es kann seinen
        enthaltenden Block nicht verlassen; endet der vor dem Zielstand, ist
        der Kopf dort längst aus dem Bild. Gemessen (390 × 844, vor der
        Reparatur): bei `scrollY = 800` stand die Kopf-Unterkante bei −654.
        Ein Abzug „weil sticky" verschenkte 112 px Telefonhöhe an einen Kopf,
        der gar nicht da ist — genau die Fläche, um die es hier geht.

     Die HÖHE wird ebenfalls gemessen und nicht nachgeschlagen: sie steht als
     78/64 px plus Navigationsleiste im CSS, und eine Zahl hier wäre eine
     zweite Hülle davon (`rules/architektur.md`), die still risse, sobald die
     Leiste umbricht.

     ⚠️ HEUTE IST DAS ERGEBNIS AUF DIESEM PFAD IMMER NULL, und das ist kein
     toter Code: der Sprung läuft nur einspaltig (≤ 834 px), der Kopf klebt
     nur ab 835 px. Die beiden Bedingungen schließen sich gerade aus. Sobald
     eine von beiden sich bewegt — ein klebender Kopf auch mobil, oder ein
     Sprung auch auf Desktop —, rechnet die Funktion ohne Zutun richtig
     weiter. Eine hart notierte Null täte das nicht.

     ⚠️ `prefers-reduced-motion` respektiert: wer weiche Bewegung abgeschaltet
     hat, wird gesetzt statt geschoben. Das Ziel bleibt dasselbe. */
  function zurWartemaskeScrollen() {
    if (!einspaltig()) return;
    const buehne = document.querySelector('.pdp__buehne');
    if (!buehne) return;
    const zielRoh = window.scrollY + buehne.getBoundingClientRect().top;
    const sanft = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, zielRoh - kopfVersatz(zielRoh) - 12),
                      behavior: sanft ? 'smooth' : 'auto' });
  }

  /* Wie viel Höhe nimmt der Kopf am Zielstand weg? Siehe die Begründung über
     `zurWartemaskeScrollen` — gefragt werden der Kopf UND seine Hülle, weil
     das Kleben mal am einen und mal am anderen sitzt. */
  function kopfVersatz(zielRoh) {
    const kopf = document.querySelector('.kopf');
    if (!kopf) return 0;
    const hoehe = kopf.getBoundingClientRect().height;
    for (const el of [kopf, kopf.parentElement]) {
      if (!el) continue;
      const lage = getComputedStyle(el).position;
      if (lage === 'fixed') return hoehe;
      if (lage === 'sticky' && el.parentElement) {
        const endetBei = window.scrollY + el.parentElement.getBoundingClientRect().bottom;
        if (endetBei > zielRoh) return hoehe;
      }
    }
    return 0;
  }

  function andruckPanelVerbergen() {
    document.querySelector('[data-andruck]')?.remove();
    document.querySelector('[data-phasen]')?.remove();
  }

  function escape(str) {
    const d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  /* 🔴 EIGENE FUNKTION FÜR ATTRIBUT-KONTEXTE (15.08.2026). `escape()` geht
     über `textContent` → `innerHTML` und maskiert damit `&`, `<` und `>` —
     aber KEINE Anführungszeichen. In `<li>${escape(x)}</li>` ist das richtig;
     in `title="${escape(x)}"` bricht ein Zitatzeichen aus dem Attribut aus.
     Bisher stand `escape()` nur in Element-Kontexten, die Lücke war also
     folgenlos — mit der Entwurfs-Leiste kam der erste Attribut-Fall dazu. */
  function attr(str) {
    return escape(str).replace(/"/g, '&quot;');
  }

  /* ============================================ Fehlermeldung zum Entwurf (B)

     🔴 WOZU, und der Grund ist NICHT der gerettete Sale (Sascha, 15.08.2026):
     das Repo hat keinen beschrifteten Prüfsatz für Bildfehler. Jeder Bildprüfer
     wird ohne ihn ins Blaue kalibriert — die 64-%-Fehlerquote der Vision-Rubrik
     vom 04.08. ist genau das Ergebnis davon. Kundenfeedback IST dieser
     Prüfsatz, kostenlos beschriftet: ein Bild, ein Urteil, ein Grund.

     ⛔ WAS HIER AUSDRÜCKLICH NICHT PASSIERT (Saschas Reihenfolge „B, dann A,
     dann C"): keine Mail, keine Einwilligung für eine spätere Benachrichtigung,
     kein „für später speichern". A und C kommen danach.

     🔴 SASCHAS BEDINGUNG FÜR C, jetzt schon hier, damit sie den Auftrag
     überlebt: kommt später eine Mail-Strecke, dann OHNE JEDES ZEITVERSPRECHEN
     — nie „innerhalb von 24 h", auch nicht „wir melden uns, sobald wir es
     behoben haben" — und nur, solange Sascha die Mail selbst auslöst. Ein
     gebrochenes Versprechen kostet mehr, als der gerettete Sale einbringt.
     Deshalb verspricht der Bestätigungstext unten heute schon nichts. Wer ihn
     später anfasst, liest diesen Absatz zuerst. */

  /* Muss zu `dienst.FEEDBACK_TEXT_MAX` passen. Zweitkopie einer Zahl, und das
     ist hier unvermeidbar: das Theme kennt das Backend nicht zur Bauzeit.
     ⚠️ Deshalb ist sie die WEICHE Grenze (Tippen wird gestoppt, bevor Text
     verlorengeht); die harte steht im Backend und kürzt notfalls stumm. Läuft
     eine der beiden weg, verliert der Kunde beim Absenden das Ende seines
     Textes, ohne dass es scheppert — wer eine anfasst, greppt nach der anderen. */
  const MELDE_TEXT_MAX = 2000;

  /* ---------- „Noch einmal zeichnen" nach einer Meldung (12.10.2026) ------
     Nach einer abgeschickten Meldung bietet der Danke-Kasten einen NEUEN WURF
     mit derselben Eingabe an. Bis hierher gab es den nicht: ein neuer Andruck
     entstand nur über eine geänderte Eingabe.
     ⏪ Erst gebaut als „Nachbessern per Hinweis" (Meldetext als Änderungs-
     wunsch in Stufe 1). Saschas Urteil am Bild, drei echte Meldungen mit
     Gegenprobe: der Wurf OHNE Hinweis war jedes Mal der beste — lebhafter
     und genauer —, der Hinweis weichte Regeln auf (schwarzer Eiffelturm,
     drei gleiche Vespas). Deshalb: Meldung sammeln, neu würfeln, den Text
     NICHT ins Bild geben. Herleitung: [[echoa_vorschau_budget]], Verlauf.
     🔴 GELTUNGSBEREICH: Orts-Print (gemessen, n=3) und seit 21.10.2026 der
     Moment (Saschas Ablauf „erst neu zeichnen, dann Mail"). Beim Zitat ist
     das Blatt gesetzt (ein neuer Wurf wäre dasselbe Blatt), bei den übrigen
     Konzepten ungemessen.
     ⚠️ Kostet einen Andruck und zählt aufs Kontingent — es ist derselbe
     `backendLauf()` wie „Andruck erstellen". */
  const NOCHMAL_HANDLES = new Set(['orts-print', 'momentaufnahme']);
  /* Wunsch nach einer Meldung (Saschas 3A, 20.10.2026; Moment seit 21.10.2026): je Handle
     nur, wenn `/puls` das zugehörige Feld meldet (`dienst.C1_WUNSCH` bzw. `dienst.A5_WUNSCH`)
     — ein neues Theme vor einem alten Image bietet den Wunsch dann nicht an, statt ihn
     ungesperrt durchzureichen. Die Frage MUSS wörtlich `rueckmeldung.WUNSCH_FRAGE` sein —
     an ihr erkennt der Dienst den Wunsch und setzt die Sperre; der Dienst-Selbsttest (C1-M)
     hält beide Zeilen gegeneinander, ebenso WUNSCH_MAX und WUNSCH_PULS. */
  const WUNSCH_PULS = { 'orts-print': 'wunsch', momentaufnahme: 'wunsch_moment' };
  const WUNSCH_FRAGE = 'Änderungswunsch des Kunden zum vorigen Entwurf — setze ihn genau so um';
  const WUNSCH_MAX = 600;
  let pulsFelder = {};
  const wunschMoeglich = () => Boolean(pulsFelder[WUNSCH_PULS[D.produkt.handle]]);

  /* ---------- Hinweis → Felder (Saschas T1 »A«, 21.10.2026) -----------------
     „Eine Feedback-Maske für alle 13 Konzepte": nach 👎 und Meldung bietet der
     Danke-Kasten auch hier „Mit meinem Hinweis neu zeichnen" an. Anders als bei
     Orts-Print und Moment geht der Text NIE ins Bild: `/api/hinweis` übersetzt
     ihn in die Felder, die das Formular schon hat (`hinweis.PRODUKTE` im Dienst
     entscheidet, welche), sie werden hier ins Formular gesetzt, und gezeichnet
     wird über den normalen Weg (`eingabeGeaendert` → Neu-Setzen ohne Render bzw.
     `backendLauf`). Unter dem neuen Bild steht „Geändert: …"; sein 👎 öffnet den
     Kasten „kostenloser Neu-Render" (`NACHGEZEICHNET`). Passt kein Feld: „Das
     können wir in diesem Motiv nicht ändern" und direkt der Mail-Kasten.
     🔴 EIN KNOPF, KEIN ZWISCHENHALT (Sascha, 21.10.2026 abends): „Mit meinem Hinweis
     neu zeichnen" steht schon im Meldeformular und schickt Meldung UND Wurf; der
     Danke-Kasten dazwischen und der Halt im Pixel-Paar-Editor sind gestrichen —
     „nur ein kleiner Teil der Kunden gibt überhaupt schriftliches Feedback, und das
     sollte direkt belohnt werden". Gilt auch für Orts-Print und Moment.
     ⏪ Bis dahin: Abschicken → Danke-Kasten „Mit meinem Hinweis neu zeichnen ·
     Nein, danke" (Ort/Moment zusätzlich „Ohne Hinweis noch einmal") → beim
     Pixel-Paar ein Halt im Editor mit „So neu zeichnen".
     Angeboten nur, wenn `/puls` → `hinweis_felder` den Handle nennt — ein neues
     Theme vor einem alten Image bietet es dann nicht an. Der Dienst-Selbsttest
     hält `HINWEIS_HANDLES` gegen `hinweis.PRODUKTE` und `HINWEIS_MAX`. */
  const HINWEIS_HANDLES = new Set(['gaming', 'haustier', 'pferd', 'wortschatz', 'icon-grid',
    'jahreszahl', 'rezept', 'weg-chronik', 'wanderung', 'strecke', 'zitat']);
  const HINWEIS_MAX = 600;
  const hinweisMoeglich = () => HINWEIS_HANDLES.has(D.produkt.handle)
    && Array.isArray(pulsFelder.hinweis_felder)
    && pulsFelder.hinweis_felder.includes(D.produkt.handle);
  /** Zeichnet der Melde-Knopf direkt neu? Dann mit dem Satz, was sich ändern lässt.
      Orts-Print/Moment über den Wunsch mit Sperre, die übrigen über die Felder. */
  function direktNeuZeichnen() {
    const h = D.produkt.handle;
    if (NOCHMAL_HANDLES.has(h) && wunschMoeglich()) {
      return { satz: h === 'momentaufnahme'
        ? 'Wir ändern den Ort, den Blick, die Stimmung oder eure Stelle im Bild – '
          + 'ihr zwei bleibt klein. Essen und Getränke zeichnen wir nicht.'
        : 'Wir ändern den Ort, den Blick oder die Stimmung – Gegenstände zeichnen wir nicht.' };
    }
    if (hinweisMoeglich()) return { satz: HINWEIS_SATZ[h] || '' };
    return null;
  }
  /* Der Satz VOR dem Knopf, wie beim Orts-Print: wer „mit Controller in der Hand"
     schreibt, soll vorher wissen, was geht. Bei Symbol und Jahreszahl gemessen am
     Code (21.10.2026): EIN Render fürs ganze Blatt — die anderen Symbole entstehen
     mit neu, das sagt der Satz. */
  const HINWEIS_SATZ = {
    gaming: 'Wir ändern, was du bei euren Figuren auswählen kannst – Haare, Kleidung, '
      + 'Brille, Haustier, Namen. Dinge in der Hand oder andere Posen gehen nicht.',
    haustier: 'Wir ändern Fell, Ohren, Rasse oder ein Merkmal. Pose und Hintergrund bleiben.',
    pferd: 'Wir ändern Fell, Abzeichen, Rasse oder ein Merkmal. Pose und Hintergrund bleiben.',
    wortschatz: 'Wir ändern das Ding im Bild, seine Farbe oder Form. Stil, Hintergrund '
      + 'und Schrift bleiben.',
    'icon-grid': 'Wir ändern das Symbol, das du meinst. Dabei entsteht das ganze Blatt neu – '
      + 'auch die anderen Symbole sehen danach etwas anders aus.',
    jahreszahl: 'Wir ändern das Alter, die Widmung oder ein Ding. Dabei entsteht das ganze '
      + 'Blatt neu.',
    rezept: 'Wir ändern Gericht, Titel, Zutaten, Zubereitung oder „Aus der Küche von“.',
    'weg-chronik': 'Wir ändern die Orte, ihre Reihenfolge oder die Linien.',
    wanderung: 'Wir ändern Start, Ziel, Übernachtungsorte oder den Titel.',
    strecke: 'Wir ändern Zeit, Ort oder Titel. Den Weg selbst ändern wir nicht.',
    zitat: 'Wir ändern den Satz, Name und Alter oder „Wann oder wo“.',
  };
  /* Der übersetzte, angewandte Hinweis — bis der nächste Entwurf auf der Bühne steht.
     `hinweisOffenPruefen()` (aus `meldenZeichnen`) hängt ihn dann an DIESEN Entwurf.
     `satz`: der Hinweis wurde ohne neuen Entwurf neu gesetzt (Strecke, Rezept, Haustier —
     die Entwurfs-Nummer bleibt), dann gilt er für denselben Entwurf, sobald das Setzen fertig ist. */
  let HINWEIS_OFFEN = null;    // { vor, kategorie, text, aenderungen, nicht, satz }
  const GEAENDERT = new Map(); // kandidatId → { aenderungen, nicht } | { wunsch } (Ort/Moment)

  /** Der Brief des GEZEIGTEN Entwurfs, wie er jetzt im Formular steht.
      🔴 NICHT `briefZumEntwurf()` allein (code-pruefer 21.10.2026, T2, BELEGT): das ist
      der Stand beim Absenden. Was danach ohne neuen Entwurf dazukam — die vorgefüllten
      Satz-Felder der Strecke, Name/Machart beim Haustier, der Rezept-Rückfall —, stünde
      sonst nach dem Hinweis leer im Formular, und der Warenkorb trüge diesen Stand.
      Das Formular trägt den gezeigten Entwurf: jede Eingabe, die ihn ändert, wirft ihn
      ab (`andruckVerwerfen`), und dann ist `s.phase` nicht mehr `fertig`. Nur das Foto
      kommt aus der Historie — der Foto-Zustand der Seite ist nach `?entwurf=` leer. */
  function hinweisBasis() {
    sammleBrief();
    const b = JSON.parse(JSON.stringify(s.brief || {}));
    const h = briefZumEntwurf();
    if (istHaustier() && !b.foto_id && h && h.foto_id && !foto.ohne) {
      b.foto_id = h.foto_id;
      b.hauptmotiv = h.hauptmotiv || '';
    }
    return b;
  }

  /** Alle Formularfelder dieses Konzepts mit ihrem Stand ZUM GEZEIGTEN ENTWURF —
      der Dienst filtert gegen seine Whitelist, hier wird nichts entschieden.
      Ausgeblendete Text- und Listenfelder fehlen: `sammleBrief` liest sie leer,
      eine Änderung dort käme nie an. Auswahlfelder gehen immer mit — das Fell eines
      Haustiers ist ausgeblendet, solange „keins" gewählt ist. */
  function hinweisFelder(brief) {
    const halter = briefHalter();
    const verborgen = (n) => Boolean(halter
      && halter.querySelector(`[data-brieffeld-halter="${n}"]`)?.hidden);
    const out = [];
    briefDef().felder.forEach((f) => {
      if (f.typ === 'namen') {
        out.push({ name: 'name1', typ: 'text', label: 'Erster Name (links)', wert: brief.name1 || '' });
        out.push({ name: 'name2', typ: 'text', label: 'Zweiter Name (rechts)', wert: brief.name2 || '' });
      } else if ((f.typ === 'chips' || f.typ === 'stil') && Array.isArray(f.optionen)) {
        out.push({ name: f.name, typ: 'auswahl', label: f.label || f.name,
          wert: brief[f.name] || '',
          optionen: f.optionen.map((o) => ({ id: o.id, label: o.label })) });
      } else if (f.typ === 'liste' && !verborgen(f.name)) {
        out.push({ name: f.name, typ: 'liste', label: f.label || f.name,
          wert: Array.isArray(brief[f.name]) ? brief[f.name] : [] });
      } else if ((f.typ === 'text' || f.typ === 'text-lang') && !verborgen(f.name)) {
        out.push({ name: f.name, typ: 'text', label: f.label || f.name, wert: brief[f.name] || '' });
      }
    });
    return out;
  }

  /** Setzt die übersetzten Änderungen in den Brief dieses Entwurfs und ins Formular.
      Jahre und Markierungen einer Liste ziehen mit ihrem Ort mit (Chronik). */
  function hinweisInBrief(brief, aenderungen) {
    const norm = (x) => String(x || '').trim().toLowerCase();
    aenderungen.forEach((a) => {
      if (a.feld === 'name1' || a.feld === 'name2') {
        brief[a.feld] = a.wert;
        brief.namen = [brief.name1, brief.name2].filter(Boolean).join(' & ');
      } else if (Number.isInteger(a.zeile)) {
        const liste = Array.isArray(brief[a.feld]) ? brief[a.feld].slice() : [];
        liste[a.zeile - 1] = a.wert;
        brief[a.feld] = liste;
        [['_jahre', ''], ['_marken', 'ring']].forEach(([suf, leer]) => {
          const alt = brief[a.feld + suf];
          if (!Array.isArray(alt)) return;
          const neu = alt.slice();
          while (neu.length < liste.length) neu.push(leer);
          brief[a.feld + suf] = neu;
        });
      } else if (Array.isArray(a.wert)) {
        const alt = Array.isArray(brief[a.feld]) ? brief[a.feld] : [];
        const stelle = (w) => alt.findIndex((x) => norm(x) === norm(w));
        [['_jahre', ''], ['_marken', 'ring']].forEach(([suf, leer]) => {
          const bei = brief[a.feld + suf];
          if (!Array.isArray(bei)) return;
          brief[a.feld + suf] = a.wert.map((w) => (stelle(w) >= 0 ? bei[stelle(w)] || leer : leer));
        });
        brief[a.feld] = a.wert.slice();
      } else {
        brief[a.feld] = a.wert;
      }
    });
    return brief;
  }

  /** Gilt die Änderung im Brief, der jetzt auf der Bühne steht? Sonst trüge die
      Zeile „Geändert" etwas, das der Kunde inzwischen selbst zurückgenommen hat. */
  function hinweisGilt(a) {
    const b = s.brief || {};
    const t = (x) => String(x == null ? '' : x).trim();
    if (Number.isInteger(a.zeile)) return (b[a.feld] || []).some((x) => t(x) === t(a.wert));
    if (Array.isArray(a.wert)) {
      return JSON.stringify((b[a.feld] || []).map(t)) === JSON.stringify(a.wert.map(t));
    }
    return t(b[a.feld]) === t(a.wert);
  }

  function hinweisOffenPruefen() {
    const o = HINWEIS_OFFEN;
    if (!o || s.phase !== 'fertig' || !s.kandidatId
        || String(s.kandidatId).startsWith('sim_')) return;
    /* Derselbe Entwurf zählt nur nach einem Neu-Setzen, und erst, wenn es fertig ist —
       sonst hinge „Geändert" an dem Bild, über das der Kunde gerade geklagt hat. */
    /* 🔴 UND NUR NACH ERFOLG (code-pruefer Runde 2, 21.10.2026, BELEGT): der Abschluss des
       Neu-Setzens läuft auch bei Fehlschlag und Abbruch — gezählt wird erst, wenn die Bühne
       wirklich ein neues Bild zeigt (`bildVor`). */
    if (String(s.kandidatId) === String(o.vor)) {
      const jetzt = document.querySelector('[data-tafel="blatt"] .buehne__bild')?.src || '';
      if (!o.satz || umzeichnenOffen || !jetzt || jetzt === o.bildVor) return;
    }
    HINWEIS_OFFEN = null;
    const gilt = o.aenderungen.filter(hinweisGilt);
    if (!gilt.length) return;
    NACHGEZEICHNET.set(String(s.kandidatId), { vor: o.vor, kategorie: o.kategorie, text: o.text });
    GEAENDERT.set(String(s.kandidatId), { aenderungen: gilt, nicht: o.nicht });
    /* Neu gesetzt bei gleicher Entwurfs-Nummer: das 👎 von vorhin gilt dem alten Blatt —
       die Daumen stehen wieder offen (`daumenZuruecksetzen` vergleicht die Nummer). */
    const zeile = document.querySelector('[data-melden-zeile]');
    if (zeile && String(s.kandidatId) === String(o.vor)) zeile.dataset.daumenFuer = '';
  }

  /** Die Zeile „Geändert: …" unter dem Bild. */
  function geaendertZeichnen() {
    const zeile = document.querySelector('[data-melden-zeile]');
    let el = document.querySelector('[data-geaendert]');
    if (!el && zeile) {
      el = document.createElement('p');
      el.className = 'melden__geaendert';
      el.dataset.geaendert = '';
      el.setAttribute('aria-live', 'polite');
      zeile.before(el);
    }
    /* Nur, was JETZT noch gilt: nimmt der Kunde eine Änderung am selben Entwurf zurück
       (Satz-Felder ändern die Entwurfs-Nummer nicht), verschwindet sie aus der Zeile. */
    const roh = s.phase === 'fertig' && s.kandidatId ? GEAENDERT.get(String(s.kandidatId)) : null;
    /* Orts-Print/Moment (Sascha, 21.10.2026 abends): dort ändert der Hinweis keine Felder —
       die Zeile nennt ihn selbst, damit es aussieht wie bei den übrigen Konzepten. */
    if (el && roh && roh.wunsch) {
      el.hidden = false;
      el.innerHTML = `<strong>Neu gezeichnet mit deinem Hinweis:</strong> „${escape(roh.wunsch)}“`;
      return;
    }
    const zeilen = roh && roh.aenderungen ? roh.aenderungen.filter(hinweisGilt).map((a) => a.anzeige) : [];
    const g = zeilen.length ? { zeilen, nicht: roh.nicht } : null;
    if (el) {
      el.hidden = !g;
      el.innerHTML = g ? `<strong>Geändert:</strong> ${g.zeilen.map(escape).join(' · ')}`
        + (g.nicht && g.nicht.length
          ? `<span class="melden__geaendert-nicht">Nicht änderbar in diesem Motiv: ${escape(g.nicht.join(', '))}</span>`
          : '') : '';
    }
  }

  /** Kein passendes Feld (oder die Vorstufe kam nicht durch): der Mail-Kasten direkt,
      mit dem Satz davor. Ohne Mail-Strecke bleibt es beim ehrlichen Satz. */
  function hinweisMailZeigen(vorher, satz) {
    if (rueckmeldungBereit) return neuRenderPanelZeigen({ vorher, vorspann: satz });
    const zeile = document.querySelector('[data-melden-zeile]');
    if (!zeile) return;
    meldenPanelVerbergen();
    const panel = document.createElement('div');
    panel.dataset.meldenPanel = String(s.kandidatId);
    panel.className = 'melden';
    panel.innerHTML = `<p class="melden__danke">${escape(satz)} Dein Hinweis ist bei uns angekommen.</p>`;
    zeile.insertAdjacentElement('afterend', panel);
    window.setTimeout(() => meldenPanelVerbergen(panel), 8000);
  }

  async function hinweisUebersetzen(panel, kandidatId, kategorie, text) {
    let res = null;
    /* 45 s: die Vorstufe hat 30 s (`dienst._hinweis`) — danach wartet der Kunde nicht
       weiter auf „Wir schauen …", sondern bekommt den Mail-Kasten. */
    const abbruch = new AbortController();
    const uhr = setTimeout(() => abbruch.abort(), 45000);
    try {
      const r = await fetch(`${BACKEND}/api/hinweis`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kandidat_id: kandidatId, produkt: D.produkt.handle,
          hinweis: text, felder: hinweisFelder(hinweisBasis()) }),
        signal: abbruch.signal,
      });
      if (r.ok) res = await r.json();
    } catch (e) { console.error(e); }
    clearTimeout(uhr);
    meldenPanelVerbergen(panel);
    /* Steht inzwischen ein anderer Entwurf auf der Bühne, gehört die Antwort zu
       keinem Bild mehr, das der Kunde sieht — nichts anwenden. */
    if (s.kandidatId !== kandidatId || s.phase !== 'fertig') return;
    const vorher = { vor: kandidatId, kategorie, text };
    if (!res || !Array.isArray(res.aenderungen)) {
      return hinweisMailZeigen(vorher, 'Das konnten wir gerade nicht umsetzen.');
    }
    if (!res.aenderungen.length) {
      return hinweisMailZeigen(vorher, 'Das können wir in diesem Motiv nicht ändern.');
    }
    hinweisAnwenden(kandidatId, kategorie, text, res);
  }

  function hinweisAnwenden(kandidatId, kategorie, text, res) {
    const brief = hinweisInBrief(hinweisBasis(), res.aenderungen);
    briefEinsetzen(brief);
    /* 🔴 HAUSTIER/PFERD: DAS FOTO DIESES ENTWURFS GEHT MIT (Probe 21.10.2026, echte
       Meldung k_a9644760c913). Ein über `?entwurf=` oder die Historie zurückgeholter
       Entwurf trägt `foto_id` im Brief, der Foto-Zustand der Seite aber ist leer —
       der neue Andruck stoppte mit „Bitte lade ein Foto hoch". Das Foto ist dasselbe,
       nach dem der Entwurf gezeichnet wurde; der Dienst prüft beim Andruck erneut,
       ob es noch liegt. ⚠️ Gilt nur hier: der allgemeine Rückweg (`historieWaehlen`)
       verliert das Foto weiterhin — offener Punkt, nicht Teil dieser Maske. */
    if (istHaustier() && brief.foto_id && foto.id !== brief.foto_id && !foto.ohne) {
      foto = { ...foto, id: brief.foto_id, status: brief.hauptmotiv ? 'hauptmotiv' : 'ok',
               meldung: '', hinweis: '', tiere: [], hauptmotiv: brief.hauptmotiv || '' };
      fotoZeichnen();
    }
    /* Selbst gewünscht = selbst getippt: ein KI-Vorschlag (Strecke) überschreibt
       das Feld sonst beim nächsten Andruck (`backendLauf`, `dataset.eigen`). */
    const halter = briefHalter();
    res.aenderungen.forEach((a) => {
      const el = halter && halter.querySelector(`[data-feld="${a.feld}"]`);
      if (el) el.dataset.eigen = '1';
      /* Pixel-Paar: eine geänderte Wahl hinter der Klappe „Brille, Bart, Kleidung"
         steht offen da, wenn der Kunde später ins Formular schaut. */
      const m = /^p([12])_/.exec(a.feld);
      if (m) gamingKlappe[m[1]] = true;
    });
    HINWEIS_OFFEN = { vor: kandidatId, kategorie, text,
      aenderungen: res.aenderungen, nicht: res.nicht_moeglich || [], satz: false,
      bildVor: document.querySelector('[data-tafel="blatt"] .buehne__bild')?.src || '' };
    /* Derselbe Weg wie eine Eingabe des Kunden: Neu-Setzen ohne Render, Rückweg auf
       einen gleichen Entwurf, Chronik-Umzeichnen — oder der Andruck fällt weg. */
    eingabeGeaendert();
    /* Steht danach noch derselbe Entwurf da, wurde neu gesetzt (Strecke, Rezept,
       Haustier: gleiche Entwurfs-Nummer, code-pruefer 21.10.2026) — dann gilt der
       Hinweis für ihn, sobald `umzeichnenOffen` erledigt ist. */
    /* ⚠️ Nicht beim Chronik-Umzeichnen: das endet mit einer NEUEN Entwurfs-Nummer, der
       Hinweis hängt sich dann wie bei jedem neuen Entwurf an (code-pruefer Runde 2). */
    if (HINWEIS_OFFEN && s.phase === 'fertig' && s.kandidatId === kandidatId
        && !chronikUmzeichnenMoeglich()) {
      HINWEIS_OFFEN.satz = true;
      meldenZeichnen();
    }
    /* Immer zum Bild — auch beim Neu-Setzen ohne neuen Wurf (Rezept, Strecke, Haustier):
       sonst stand der Kunde unten im Formular und sah sein neues Blatt nicht
       (Aufnahme 21.10.2026 abends). */
    document.querySelector('[data-tafel="blatt"]')
      ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (s.phase === 'leer' && !umzeichnenOffen) backendLauf();
  }

  /* ---------- Zweite Stufe: kostenloser Neu-Render per Mail (21.10.2026) ----
     Saschas Ablauf: erst neu zeichnen, und erst wenn das ZWEITE Bild auch nicht
     gefällt, die Mail — deutlich hervorgehoben. Bis hierher stand das Mailfeld
     klein als „(freiwillig)" im ersten Meldeformular: 1 Adresse auf 10 Meldungen.
     Gemerkt wird je Seitenaufruf, welcher Entwurf aus „noch einmal" entstand —
     nur dessen 👎 öffnet den Kasten. Neue Eingabe = neuer Entwurf = wieder Stufe 1.
     🔴 Saschas Bedingung vom 15.08. gilt weiter: kein Zeitversprechen, und die
     Mail löst nur er aus (`rueckmeldung.py`). */
  const NACHGEZEICHNET = new Map();   // neue kandidatId → { vor, kategorie, text }
  /* ⏪ Erst „– wir zeichnen dein Bild von Hand nach" (Saschas Auftrag). Sascha am
     Screenshot, 21.10.2026: missverständlich, klingt nach echter Handzeichnung. Wahr
     ist: er sieht sich das Bild an, der neue Wurf geht erst nach seinem Ja raus. */
  const RUECK_KASTEN_TITEL = 'Erhalte einen <strong>kostenlosen Neu-Render</strong> per Mail '
    + '– wir schauen uns dein Bild persönlich an';

  const MELDE_KATEGORIEN = [
    /* 🔴 Die Kategorie macht Berichte zählbar, sie ERSETZT den Freitext nie.
       Die teuersten Befunde dieses Repos waren nie ankreuzbar — deshalb ist der
       Text Pflicht und der Chip die Beigabe.
       ⚑ »gefällt mir nicht« statt »hässlich« (seitenintern, reversibel):
       niemand klickt »hässlich« über die eigene Geschichte, und eine Kategorie,
       die aus Scham gemieden wird, schiebt ihre Fälle nach »falsch« — genau die
       Trennung, für die es sie gibt. Die IDs sind Systemschlüssel und müssen zu
       `dienst.FEEDBACK_KATEGORIEN` passen; die Labels sind frei. */
    /* ⏪ 19.08.2026: »Die Schrift« ist RAUS (Sascha: „sonst nicht MECE.
       Entweder fehlt etwas nicht, entweder ist etwas falsch oder das Bild
       gefällt insgesamt nicht"). Sie war keine vierte Art von Befund, sondern
       ein ORT — ein Schriftfehler ist entweder ein Fehlen, ein Falsches oder
       ein Missfallen, und die Kachel zog Fälle aus allen dreien ab. Was
       genau an der Schrift klemmt, steht ohnehin im Pflicht-Freitext.
       ⚠️ `dienst.FEEDBACK_KATEGORIEN` führt „schrift" WEITER. Das ist
       Absicht, kein vergessener Rückbau: das Backend nimmt entgegen, was
       ankommt, und ein Browser mit noch zwischengespeichertem alten Skript
       darf keine 400 bekommen. Tolerant, wo eine fremde Eingabe ankommt;
       laut, wo der eigene Code die Wahl trifft. */
    { id: 'fehlt', label: 'Etwas fehlt' },
    { id: 'falsch', label: 'Etwas ist falsch' },
    { id: 'gefaellt_nicht', label: 'Gefällt mir nicht' },
  ];

  /* ------------------------------ Pills unter dem Entwurf (27.10.2026) ----
     Stufe 1b, Saschas OK am Raster („Die Pills passen so"): statt 👍 👎 und „Stimmt etwas noch nicht?"
     stehen unter dem Bild nur BILDfragen — „Passt so ✓" und die Bereiche des Bildes. „Passt so" zählt
     wie 👍 (`daumenGeben('hoch')`), die erste Bild-Pill wie 👎 und öffnet sofort das Feld „Was genau an …?"
     — ohne die drei Kategorie-Kacheln. Mehrere Pills gehen: ein Feld, die Frage nennt alle. Der Bericht
     trägt `kategorie` = erster Bereich und `bereiche` = alle.
     🔴 Die IDs sind Systemschlüssel und müssen zu `dienst.FEEDBACK_BEREICHE` passen (der Selbsttest des
     Dienstes liest diese Zeile); die Labels sind frei und je Produkt verschieden.
     Kauffragen (Größe, Rahmen, Preis) stehen hier bewusst NICHT: vor der Wahl von Format und Rahmen werden
     sie reflexhaft angetippt (Sascha, 26.10.2026) — sie stehen in der Zögern-Frage unter dem Kaufknopf.
     ⏪ Bis 29.10.2026 öffnete die erst nach Format/Rahmen (`kaufBeruehrt`); seither unter jedem fertigen
     Entwurf (Saschas zweite Durchsicht). `kaufBeruehrt` wird nur noch gesetzt, nicht mehr gelesen. */
  const FEEDBACK_BEREICHE = ['personen', 'tier', 'ort', 'szene', 'motiv', 'text', 'details', 'farben', 'machart'];
  const PILLS_JE_PRODUKT = {
    momentaufnahme: [['personen', 'Personen'], ['ort', 'Ort'], ['details', 'Details'],
      ['farben', 'Farben & Stil'], ['machart', 'Machart']],
    gaming: [['personen', 'Personen'], ['szene', 'Szene'], ['details', 'Details'], ['farben', 'Farben']],
    'orts-print': [['ort', 'Ort'], ['details', 'Details'], ['farben', 'Farben & Stil'], ['machart', 'Machart']],
    haustier: [['tier', 'Tier'], ['details', 'Details'], ['farben', 'Farben & Stil'], ['machart', 'Machart']],
    pferd: [['tier', 'Pferd'], ['details', 'Details'], ['farben', 'Farben & Stil'], ['machart', 'Machart']],
    linie: [['personen', 'Paar'], ['details', 'Details'], ['farben', 'Farben'], ['machart', 'Machart']],
    portraet: [['personen', 'Personen'], ['details', 'Details'], ['farben', 'Farben'], ['machart', 'Machart']],
    wortschatz: [['text', 'Text'], ['details', 'Gestaltung'], ['farben', 'Farben'], ['machart', 'Machart']],
    jahreszahl: [['text', 'Text'], ['details', 'Gestaltung'], ['farben', 'Farben']],
    zitat: [['text', 'Text'], ['details', 'Gestaltung'], ['farben', 'Farben']],
    rezept: [['text', 'Rezept'], ['details', 'Gestaltung'], ['farben', 'Farben']],
    'icon-grid': [['motiv', 'Symbole'], ['details', 'Details'], ['farben', 'Farben & Stil'], ['machart', 'Machart']],
    'weg-chronik': [['motiv', 'Strecke'], ['details', 'Details'], ['farben', 'Farben & Stil'], ['machart', 'Machart']],
    strecke: [['motiv', 'Strecke'], ['details', 'Details'], ['farben', 'Farben & Stil']],
    wanderung: [['motiv', 'Strecke'], ['details', 'Details'], ['farben', 'Farben & Stil']],
  };
  const PILLS_STANDARD = [['motiv', 'Motiv'], ['details', 'Details'], ['farben', 'Farben & Stil']];
  let pillWahl = [];          // gewählte Bereiche zum gezeigten Entwurf, in Tipp-Reihenfolge
  let kaufBeruehrt = false;   // Format oder Rahmen angefasst → Zögern-Frage darf erscheinen

  /** Die Pills zum gezeigten Entwurf — neu gebaut und offen, sobald ein anderer Entwurf auf der Bühne steht. */
  function pillsZeichnen(zeile) {
    const halter = zeile && zeile.querySelector('[data-pills]');
    if (!halter) return;
    const fuer = String(s.kandidatId || '');
    if (halter.dataset.pillsFuer === fuer) return;
    halter.dataset.pillsFuer = fuer;
    pillWahl = [];
    garantieHinweisZeichnen();
    /* 29.10.2026 (Sascha: „»Symbole« oder »Details« sind gar keine Antwort auf diese Frage“): die Frage heißt
       „Passt alles – oder soll sich etwas ändern?“ (Liquid), und jede Bereichs-Pille ist eine Antwort mit Verb
       („Symbole ändern“). Die IDs bleiben (`dienst.FEEDBACK_BEREICHE`). */
    const liste = [['passt', 'Passt so ✓'],
      ...(PILLS_JE_PRODUKT[D.produkt.handle] || PILLS_STANDARD).map(([id, l]) => [id, `${l} ändern`])];
    halter.innerHTML = liste.map(([id, label]) => `
      <button type="button" class="pdp__pill${id === 'passt' ? ' pdp__pill--passt' : ''}"
              data-pill="${attr(id)}" aria-pressed="false">${escape(label)}</button>`).join('');
    pillsOffen(zeile, true);
  }

  /** Pills und Frage zeigen (offen) oder hinter „Schön! … / Doch etwas ändern" zuklappen. */
  function pillsOffen(zeile, offen) {
    const halter = zeile.querySelector('[data-pills]');
    const frage = zeile.querySelector('[data-pills-frage]');
    if (halter) halter.hidden = !offen;
    if (frage) frage.hidden = !offen;
    if (offen) {
      const dank = zeile.querySelector('[data-daumen-dank]');
      if (dank) dank.hidden = true;
    }
    linksKleben();   // die Spalte ändert ihre Höhe — nicht auf den ResizeObserver allein verlassen
  }

  /** „Personen", „Personen und Ort", „Personen, Ort und Details" — aus den Labels der gewählten Pills. */
  function pillListe(zeile) {
    const namen = pillWahl.map((id) => {
      const b = zeile && zeile.querySelector(`[data-pill="${id}"]`);
      return b ? b.textContent.trim().replace(/ ändern$/, '') : id;
    });
    return namen.length < 2 ? (namen[0] || '') : `${namen.slice(0, -1).join(', ')} und ${namen[namen.length - 1]}`;
  }

  /** Auswahl leeren und alle Pills lösen — nach Abbrechen und nach dem Absenden (code-pruefer 27.10.2026:
      sonst trüge der nächste Bericht die Bereiche des vorigen mit). */
  function pillsLoesen() {
    pillWahl = [];
    document.querySelectorAll('[data-melden-zeile] [data-pill]').forEach((b) =>
      b.setAttribute('aria-pressed', 'false'));
    garantieHinweisZeichnen();
  }

  function meldenFrageSetzen(panel) {
    const lab = panel && panel.querySelector('[data-melde-frage]');
    if (lab) lab.textContent = `Was genau an ${pillListe(document.querySelector('[data-melden-zeile]'))}?`;
  }

  /** Garantie-Kasten unter den Pills (Saschas E5 »A«, 29.10.2026): sichtbar bei einer gedrückten
      Änderungs-Pille oder ab dem zweiten Entwurf DIESES Produkts (`historieLesen` führt alle Produkte,
      gezählt wird nur `handle` der Seite — sonst zählte ein Symbole-Entwurf beim ersten Haustier mit). */
  function garantieHinweisZeichnen() {
    const k = document.querySelector('[data-garantie-hinweis]');
    if (!k) return;
    const eigene = historieLesen().filter((e) => e.handle === D.produkt.handle).length;
    k.hidden = !(meldenMoeglich() && (pillWahl.length > 0 || eigene >= 2));
  }

  function pillTippen(id) {
    if (!meldenMoeglich()) return;
    const zeile = document.querySelector('[data-melden-zeile]');
    if (!zeile) return;
    if (id === 'passt') {
      pillWahl = [];
      zeile.querySelectorAll('[data-pill]').forEach((b) =>
        b.setAttribute('aria-pressed', String(b.dataset.pill === 'passt')));
      daumenGeben('hoch');                  // Ereignis wie 👍, schließt ein offenes Feld
      pillsOffen(zeile, false);
      garantieHinweisZeichnen();
      return;
    }
    if (!FEEDBACK_BEREICHE.includes(id)) return;
    pillWahl = pillWahl.includes(id) ? pillWahl.filter((x) => x !== id) : [...pillWahl, id];
    zeile.querySelectorAll('[data-pill]').forEach((b) =>
      b.setAttribute('aria-pressed', String(pillWahl.includes(b.dataset.pill))));
    garantieHinweisZeichnen();
    /* E7 (29.10.2026): wer „Farben“ antippt, findet die kostenlose Farbwahl sofort offen, wer „Machart“
       antippt, die Klappe „Neu zeichnen“. Nur öffnen, nie schließen — und nur beim Drücken. */
    if (pillWahl.includes(id) && istKauf()) {
      const blatt = $('[data-am-blatt]');
      if (id === 'farben' && blatt && getComputedStyle(blatt).display !== 'none') blatt.open = true;
      if (id === 'machart' && !angabenOffen) {
        angabenOffen = true;
        kaufZeichnen(vorteilFuer(s.kandidatId));
      }
    }
    if (!pillWahl.length) return meldenPanelVerbergen();
    const offen = document.querySelector('[data-melden-panel]');
    if (offen) return meldenFrageSetzen(offen);
    daumenGeben('runter');                  // Ereignis wie 👎 und öffnet das Feld
  }

  /* 🔴 DIE KLEBENDE LINKE SPALTE DARF DIE PILLS NICHT UNTER DEN FENSTERRAND SCHIEBEN (Sichtprobe 27.10.2026,
     1280 × 900: Spalte 1.034 px hoch, Pills-Unterkante bei 938 px + 102 px Abstand oben → erst ab ~1.040 px
     Fensterhöhe sichtbar; ein MacBook zeigt ~850). Ist die Spalte höher als das Fenster, klebt sie mit ihrer
     Unterkante am Rand (negatives `top`), sonst wie bisher 102 px unter der Kopfzeile. Mobil klebt nichts. */
  const LINKS = document.querySelector('.pdp__links');
  function linksKleben() {
    if (!LINKS) return;
    LINKS.style.removeProperty('--links-top');
    const cs = getComputedStyle(LINKS);
    if (cs.position !== 'sticky') return;
    const oben = parseFloat(cs.top) || 0;
    // 16 px Luft zum Fensterrand: gesetzt, nicht gemessen; wirkt nur, wenn die Spalte höher ist als das Fenster.
    const frei = window.innerHeight - LINKS.offsetHeight - 16;
    if (frei < oben) LINKS.style.setProperty('--links-top', `${Math.round(frei)}px`);
  }
  if (LINKS && 'ResizeObserver' in window) new ResizeObserver(linksKleben).observe(LINKS);
  window.addEventListener('resize', linksKleben);
  window.addEventListener('load', linksKleben);

  /** Format oder Rahmen angefasst: ab jetzt darf die Zögern-Frage unter dem Kaufbereich stehen. */
  function kaufBeruehren() {
    kaufBeruehrt = true;
    /* 30.10.2026: auch bei offenem Melde-Feld — die Frage steht unter dem Kaufbereich, weit weg davon. */
    if (meldenMoeglich()) zoegernPanelZeigen();
  }

  /** Darf zu DIESEM Entwurf überhaupt gemeldet werden?
      🔴 Simulierte Entwürfe sind ausgeschlossen: sie zeigen ein eingefrorenes
      Beispielblatt, das mit dem Kundentext nichts zu tun hat. Ein Bericht
      darüber wäre eine FALSCHBESCHRIFTUNG im Prüfsatz — schlimmer als keiner,
      weil er später wie ein echter Fall aussieht. Dieselbe Grenze wie bei
      `_kandidat_id` im Warenkorb und in `historieMerken()`.
      Ohne BACKEND gibt es zudem keinen Empfänger. */
  function meldenMoeglich() {
    return Boolean(BACKEND) && s.phase === 'fertig' && s.kandidatId
      && !String(s.kandidatId).startsWith('sim_');
  }

  /* --- Vorgemerkte Änderungswünsche (Saschas »B«, 29.10.2026) ------------------------------------------
     Je Entwurf ein Text, gemerkt für diese Sitzung (sessionStorage, wie die Entwurfs-Historie nur auf diesem
     Gerät). In den Warenkorb geht er als sichtbare Zeilen-Eigenschaft »Änderungswunsch« (`properties`), damit
     Kunde und Sascha ihn in Bestellung und Mail sehen. Im Bestellmodus gibt es den Knopf nicht — dort zeichnet
     der Kunde selbst neu. 500 Zeichen: Shopify-Eigenschaften tragen mehr, die Mail an Sascha soll lesbar bleiben. */
  const VORMERK_KEY = 'echoa:vormerk';
  const VORMERK_MAX = 500;
  const VORMERK = new Map((() => {
    try { return Object.entries(JSON.parse(sessionStorage.getItem(VORMERK_KEY) || '{}')); } catch { return []; }
  })());
  /* Wo Gelb steht („Ein Detail ändern“), entfällt die Box — sonst stünden zwei Wunsch-Felder untereinander, eins für
     jetzt, eins für nach der Bestellung (Sascha, T1 30.10.2026: »A«, nur dort, wo Gelb steht). */
  function vormerkenMoeglich() { return meldenMoeglich() && !BESTELLMODUS && !gelbMoeglich(); }
  function vormerkenSetzen(kid, text) {
    const k = String(kid || '');
    if (!k) return;
    if (text) VORMERK.set(k, String(text).slice(0, VORMERK_MAX)); else VORMERK.delete(k);
    try { sessionStorage.setItem(VORMERK_KEY, JSON.stringify(Object.fromEntries(VORMERK))); } catch { /* ohne Speicher gilt es bis zum Neuladen */ }
  }

  /** Schließt das Melde-Panel.
      🔴 MIT OPTIONALEM ZIEL (Befund `code-pruefer` 15.08.2026, Runde 2).
      Ohne Argument entfernt die Funktion das Panel, das GERADE im DOM steht —
      für einen Timer, der 6 Sekunden vorher gesetzt wurde, ist das nicht
      unbedingt dasselbe Panel. Der Weg: melden zu Entwurf A, „Angekommen"
      lesen, binnen 6 s auf Entwurf B wechseln, dort neu öffnen und tippen —
      der alte Timer räumte das frische Panel samt getipptem Text weg, ohne
      ein Wort. Wer ein bestimmtes Panel meint, gibt es mit. */
  function meldenPanelVerbergen(nur = null) {
    const offen = document.querySelector('[data-melden-panel]');
    if (!offen) return;
    if (nur && offen !== nur) return;
    offen.remove();
  }

  /** Sichtbarkeit der leisen Zeile unter der Bühne.
      Hängt an `s.phase`, nicht am Knopftext — dieselbe Begründung wie beim
      Widerrufs-Hinweis: am Text hinge sie am nächsten Wortlaut-Wechsel. */
  function meldenZeichnen() {
    /* Hinweis → Felder: ein eben fertig gewordener Entwurf erbt den angewandten
       Hinweis, BEVOR Zeile und Daumen gezeichnet werden. */
    hinweisOffenPruefen();
    geaendertZeichnen();
    const zeile = document.querySelector('[data-melden-zeile]');
    const moeglich = meldenMoeglich();
    garantieHinweisZeichnen();
    /* 30.10.2026 (`NACHHER_AN`): keine Frage und keine Pillen mehr unter dem Bild — Ändern steht in der Klappe
       „Doch schon etwas anpassen?“, die Garantie im Kaufkopf. Der Rest dieser Funktion läuft weiter (Panels
       schließen, Daumen zurücksetzen), damit `false` den alten Stand ohne Umbau zurückholt. */
    if (zeile) zeile.hidden = !moeglich || NACHHER_AN;
    daumenZuruecksetzen(zeile);
    haarZeichnen();
    /* Verlässt der Entwurf die Phase `fertig` (Eingabe geändert, neuer Lauf),
       muss ein offenes Panel mit — es zeigte sonst ein Formular zu einem Bild,
       das nicht mehr auf der Bühne steht. */
    if (!moeglich) {
      zoegernPanelVerbergen();
      andersZeichnen();          // räumt den Block weg, sobald kein Entwurf mehr gezeigt wird
      return meldenPanelVerbergen();
    }
    /* Dieselbe Regel für die Nachfrage nach 👍 (15.10.2026): ihre Antworten
       gehören zu dem Entwurf, zu dem sie geöffnet wurde. */
    const zp = document.querySelector('[data-zoegern-panel]');
    if (zp && zp.dataset.zoegernPanel !== String(s.kandidatId)) zoegernPanelVerbergen();

    /* 🔴 UND ES REICHT NICHT, AUF DIE PHASE ZU SCHAUEN (Befund `code-pruefer`
       15.08.2026, Runde 1, BELEGT). `historieWaehlen()` wechselt auf einen
       ANDEREN fertigen Entwurf: `s.kandidatId` ändert sich, `phase` bleibt
       `fertig`, `meldenMoeglich()` bleibt wahr — das offene Panel blieb stehen
       und trug weiter die beim Öffnen eingefrorene ID.

       Der Kunde hätte dann über Entwurf A geschrieben, während der Bericht an
       B ging: im Prüfbogen steht B's Bild neben einer Beschwerde über A. Das
       ist exakt die Bild/Text-Divergenz, gegen die `historieMerken()` und
       `brief_stand` gebaut sind — eine Ebene höher, und im Prüfsatz doppelt
       teuer, weil ein FALSCH beschrifteter Fall schlimmer ist als ein
       fehlender.

       ⚠️ Der Fall ist nicht exotisch: das Vergleichen mehrerer Entwürfe ist
       genau der Fall, gegen den `LIMIT_FEEDBACK_JE_IP_STUNDE` kalibriert ist.

       Geschlossen statt umgeschrieben: ein Panel, dessen Bezug sich unter dem
       Tippenden ändert, soll sichtbar neu geöffnet werden. */
    const panel = document.querySelector('[data-melden-panel]');
    if (panel && panel.dataset.meldenPanel !== String(s.kandidatId)) {
      meldenPanelVerbergen();
    }

    /* 🆕 26.10.2026 (Saschas T1 »A«, Stufe 1, Punkt 5): „Stimmt etwas noch nicht?" steht unter jedem
       Entwurf, auch ohne 👍/👎 — und die Zögern-Frage zeigt sich allen, nicht nur nach 👍.
       Ein Tipp, kein Pflichtfeld. Solange das Melde-Feld offen ist, bleibt die Frage weg (eins nach
       dem anderen, wie bisher bei 👎). */
    /* ⏪ 27.10.2026: statt des Links „Stimmt etwas noch nicht?" stehen hier die Pills (`pillsZeichnen`). */
    pillsZeichnen(zeile);
    andersZeichnen();
    /* 30.10.2026 (Sascha: die Pillen unter dem Warenkorb „wurden wieder nicht angezeigt“): immer zeigen, auch
       wenn das Melde-Feld oben offen ist — beide stehen weit auseinander. ⏪ bis heute nur ohne offenes Feld. */
    zoegernPanelZeigen();
  }

  /* ------------------------------ Nach dem Entwurf neu zeichnen (26.10.2026) ----
     Saschas T1 »A«, Stufe 1, Punkt 4: „Stil/Machart/Farbe/Szene sind nach dem Andruck ausgeblendet,
     man muss neu laden." Unter dem Entwurf steht jetzt ein zugeklappter Block mit den GEMALTEN Wahlen
     des Konzepts (Machart, Styling, Stil, Hintergrund …). Ein Tipp merkt die Wahl nur vor — der
     gezeigte Entwurf, sein Preis und die Kaufleiste bleiben, bis „Neu zeichnen" gedrückt wird. Erst
     dann werden die echten Knöpfe im Formular geklickt (derselbe Weg wie ein Kundenklick, keine
     zweite Wahrheit) und der Andruck gestartet; er zählt gegen dasselbe Kontingent (10 je 24 h).
     Wechsel, die ohne neuen Render gehen (Porträt ⇄ Lexikon, Farbe), setzt der Satz-Weg sofort.
     🔴 Gesetzte Texte bleiben bei „Texte und Farben am Blatt ändern" — dieser Block fasst sie nicht an.
     ⚠️ Nur Felder, deren Knöpfe es im Formular gibt und die nicht verborgen sind; die Liste je Konzept
     nennt Kandidaten, das Formular entscheidet. */
  const ANDERS_FELDER = {
    haustier: ['styling'],
    pferd: ['styling'],
    rezept: [],
    momentaufnahme: ['look', 'grund'],
    'orts-print': ['look', 'stimmung', 'tinte'],
    wortschatz: ['look', 'hintergrund', 'muster'],
    zitat: ['poster'],
    'icon-grid': ['look'],
    'weg-chronik': ['look'],
    /* Pixel-Paar (27.10.2026, nur mit `HAAR_UMFAERBEN_AN`): alles, was ein neues Bild braucht — seit Saschas
       Beschriftung auch der Hautton. Farben von Haaren und Kleidung stehen im Block „Farben am Bild ändern". */
    gaming: ['welt', ...[1, 2].flatMap((n) => ['haut', 'frisur', 'brille', 'bart', 'muetze', 'oberteilart', 'unterteil', 'figur']
      .map((f) => `p${n}_${f}`)), 'tier1'],
  };
  let andersWahl = {};   // feld → wert (`_kombi` für die Machart-Reihe), nur vorgemerkt

  function andersGruppen() {
    const felder = ANDERS_FELDER[D.produkt.handle];
    const halter = briefHalter();
    if (!felder || !halter) return [];
    const gruppen = [];
    const def = kombiDef();
    const bild = (b) => (b.querySelector('img') || {}).src || '';
    if (def) {
      const aktuell = (def.kacheln.find((k) => k.setze.every(([f, w]) => kombiGedrueckt(f) === w)) || {}).id || '';
      /* Dieselben Bildkacheln wie vor dem Entwurf: die Machart-Reihe (`kombiZeichnen`) wird geklont. */
      const reihe = halter.querySelector('[data-kombi-reihe]');
      const knoepfe = reihe ? Array.from(reihe.querySelectorAll('[data-kombi]')) : [];
      gruppen.push({ feld: '_kombi', label: 'Machart', aktuell, reihe,
        knoepfe: knoepfe.map((b) => ({ el: b, wert: b.dataset.kombi })),
        optionen: def.kacheln.map((k) => ({ wert: k.id, label: k.label,
          bild: bild(knoepfe.find((b) => b.dataset.kombi === k.id) || document.createElement('i')) })) });
    }
    felder.forEach((feld) => {
      const w = halter.querySelector(`[data-brieffeld-halter="${feld}"]`);
      if (!w || w.hidden) return;
      /* Styling gibt es nur beim Magazin — auch, wenn Magazin gerade erst vorgemerkt ist. */
      if (feld === 'styling') {
        const kombi = andersWahl._kombi || (gruppen[0] && gruppen[0].aktuell);
        if (kombi !== 'magazin') return;
      }
      const knoepfe = Array.from(w.querySelectorAll(`[data-brieffeld="${feld}"][data-wert]`))
        .filter((b) => !b.disabled && !b.hidden && !b.closest('.kombi--verdeckt'));
      if (knoepfe.length < 2) return;
      const def2 = briefDef().felder.find((f) => f.name === feld);
      const gedrueckt = knoepfe.find((b) => b.getAttribute('aria-pressed') === 'true');
      gruppen.push({
        /* Pixel-Paar: „Figur 1 · Frisur" mit dem Namen statt der Nummer — wie die Überschriften der Maske. */
        feld, label: ((def2 && def2.label) || feld).replace(/^Figur ([12]) · /,
          (_m, n) => `${String(s.brief[`name${n}`] || '').trim() || `Figur ${n}`} · `),
        aktuell: gedrueckt ? gedrueckt.dataset.wert : '',
        reihe: knoepfe[0].parentElement,
        knoepfe: knoepfe.map((b) => ({ el: b, wert: b.dataset.wert })),
        optionen: knoepfe.map((b) => ({
          wert: b.dataset.wert, bild: bild(b),
          label: ((b.querySelector('.stilkachel__name, .marker__name') || b).textContent || '').trim()
            || b.getAttribute('aria-label') || b.title || b.dataset.wert,
        })),
      });
    });
    return gruppen;
  }

  function andersVorgemerkt() {
    return Object.keys(andersWahl).length > 0;
  }

  /* 🔴 SCHALTER (29.10.2026, Saschas PDP-Vorlage E7 »A«): AUS = kein Block „Andere Machart ausprobieren“
     unter dem Bild. Die Machart wählt der Kunde in „Neu zeichnen“ (das Formular „Deine Angaben“), Farben
     ohne neuen Entwurf in „Bild anpassen“ — zwei Orte statt drei. ⏪ Bis heute stand die Machart zusätzlich
     hier, bei Symbole samt Farben, die gar keinen neuen Entwurf brauchen. Rückweg: true. */
  const ANDERS_BLOCK_AN = false;
  function andersZeichnen() {
    const zeile = document.querySelector('[data-melden-zeile]');
    let box = document.querySelector('[data-anders]');
    if (!ANDERS_BLOCK_AN) {
      if (box) box.remove();
      andersWahl = {};
      return;
    }
    const gruppen = meldenMoeglich() && (!istGaming() || HAAR_UMFAERBEN_AN) && zeile ? andersGruppen() : [];
    if (!gruppen.length) {
      if (box) box.remove();
      andersWahl = {};
      return;
    }
    if (box && box.dataset.anders !== String(s.kandidatId)) {
      box.remove();
      box = null;
      andersWahl = {};
    }
    if (!box) {
      box = document.createElement('details');
      box.className = 'anders';
      box.dataset.anders = String(s.kandidatId);
      box.innerHTML = `<summary class="anders__kopf">
          <span class="anders__titel">${istGaming() ? 'Mehr ändern – mit neuem Bild' : 'Andere Machart ausprobieren'}</span>
          <span class="anders__zusatz">neuer Entwurf in ca. ${escape(String(D.dauer_sekunden || 50))} Sekunden</span>
        </summary><div class="anders__inhalt" data-anders-inhalt></div>`;
      /* Hinter Zeile und offenen Panels, damit sich die Reihenfolge nicht verschiebt. */
      let anker = zeile;
      while (anker.nextElementSibling
        && anker.nextElementSibling.matches('[data-zoegern-panel], [data-melden-panel]')) {
        anker = anker.nextElementSibling;
      }
      anker.insertAdjacentElement('afterend', box);
    }
    const sig = JSON.stringify([gruppen.map((g) => [g.feld, g.aktuell, g.optionen]), andersWahl]);
    if (box.dataset.sig === sig) return;
    box.dataset.sig = sig;
    const inhalt = box.querySelector('[data-anders-inhalt]');
    inhalt.textContent = '';
    /* 🆕 DIESELBEN KACHELN WIE VOR DEM ENTWURF (Sascha, 26.10.2026: „im Block fehlen die Bilder").
       Geklont wird, was die Maske gerade zeigt — Reihe und Knöpfe samt Bild, Name und Zusatz —, keine
       zweite Bildliste. Die Klone verlieren alle `data-*` und `id` (sonst hielte der Formular-Hörer
       sie für die echten Felder) und tragen nur `data-anders-wahl`/`data-wert`. */
    const ohneKennung = (el) => {
      [el, ...el.querySelectorAll('*')].forEach((x) => {
        Array.from(x.attributes).forEach((a) => {
          if (a.name === 'id' || a.name.startsWith('data-') || a.name === 'aria-labelledby') x.removeAttribute(a.name);
        });
      });
      return el;
    };
    gruppen.forEach((g) => {
      const kopf = document.createElement('p');
      kopf.className = 'feld-label';
      kopf.textContent = g.label;
      inhalt.appendChild(kopf);
      const reihe = g.reihe ? ohneKennung(g.reihe.cloneNode(false)) : document.createElement('div');
      if (!g.reihe) reihe.className = 'optionen';
      reihe.classList.remove('kombi--verdeckt');
      reihe.setAttribute('role', 'group');
      reihe.setAttribute('aria-label', g.label);
      g.knoepfe.forEach(({ el, wert }) => {
        const k = ohneKennung(el.cloneNode(true));
        k.type = 'button';
        k.disabled = false;
        k.hidden = false;
        k.dataset.andersWahl = g.feld;
        k.dataset.wert = wert;
        k.setAttribute('aria-pressed', String((g.feld in andersWahl ? andersWahl[g.feld] : g.aktuell) === wert));
        reihe.appendChild(k);
      });
      inhalt.appendChild(reihe);
    });
    inhalt.insertAdjacentHTML('beforeend', `
      <p class="feld-hilfe">Dein jetziger Entwurf bleibt unter „Deine Entwürfe“.</p>
      <div class="melden__aktionen">
        <button type="button" class="echoa-aktion echoa-aktion--leise" data-anders-los${andersVorgemerkt() ? '' : ' disabled'}>Neu zeichnen</button>
      </div>`);
  }

  function andersWaehlen(feld, wert) {
    const g = andersGruppen().find((x) => x.feld === feld);
    if (!g) return;
    if (g.aktuell === wert) delete andersWahl[feld];
    else andersWahl[feld] = wert;
    /* Weg von Magazin: ein vorgemerktes Styling gilt nicht mehr. */
    if (feld === '_kombi' && (andersWahl._kombi || g.aktuell) !== 'magazin') delete andersWahl.styling;
    andersZeichnen();
  }

  /** Fehlt für die gerade gewählte Machart eine Pflichtangabe (Lexikon: Eigenheiten), das Formular
      aufklappen, die Meldung zeigen und das erste leere sichtbare Feld ansteuern. true = es fehlte etwas.
      (code-pruefer Runde 1, 26.10.2026, BELEGT: Porträt → Lexikon bleibt im Satz-Weg, der Dienst lehnt
      ohne zwei Eigenheiten ab — und die Felder standen zugeklappt in „Deine Angaben".) */
  function andersFehlendeZeigen(ohneFoto = false) {
    sammleBrief();
    /* `ohneFoto`: im Satz-Weg wird nichts gerendert — ein (nach `?entwurf=` leeres) Foto-Feld ist
       dort kein Mangel und darf die Meldung nicht stellen. */
    const m = ohneFoto
      ? brieffehler(briefDef().felder.filter((f) => f.typ !== 'foto').map((f) => f.name))
      : brieffehler();
    if (!m) return false;
    angabenOffen = true;
    kaufZeichnen(s.phase === 'fertig' ? vorteilFuer(s.kandidatId) : null);
    wachsenAlle();
    zeigeMeldung(m);
    const halter = briefHalter();
    /* Zum Feld, das die Meldung NENNT — nicht zum ersten leeren (code-pruefer Runde 2: ein leeres
       optionales „Merkmal" davor zog sonst Fokus und Tastatur auf sich). */
    const namen = briefDef().felder.filter((f) => !ohneFoto || f.typ !== 'foto').map((f) => f.name);
    const fehltName = namen.find((n) => brieffehler([n]));
    const w = fehltName && halter && halter.querySelector(`[data-brieffeld-halter="${fehltName}"]`);
    const leer = w && w.getClientRects().length
      ? w.querySelector('textarea[data-feld], input[type="text"][data-feld]') : null;
    if (leer) {
      leer.scrollIntoView({ block: 'center' });   // direkt (30.10.2026, s. feldFehlerZeigen)
      leer.focus({ preventScroll: true });
    } else {
      $('[data-fehler]:not([hidden])')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return true;
  }

  function andersLos() {
    if (!andersVorgemerkt() || !meldenMoeglich()) return;
    const wahl = { ...andersWahl };
    andersWahl = {};
    const halter = briefHalter();
    /* Haustier/Pferd: der Brief DIESES Entwurfs, gelesen, BEVOR ein Klick ihn verwirft — für das
       Foto, falls gleich ein neuer Andruck nötig wird (unten). */
    const entwurfBrief = istHaustier() ? briefZumEntwurf() : null;
    if (wahl._kombi) kombiWaehlen(wahl._kombi);
    Object.entries(wahl).forEach(([feld, wert]) => {
      if (feld === '_kombi' || !halter) return;
      const b = Array.from(halter.querySelectorAll(`[data-brieffeld="${feld}"]`))
        .find((x) => x.dataset.wert === wert);
      if (b && b.getAttribute('aria-pressed') !== 'true' && !b.disabled) b.click();
    });
    neurenderHinweisVerbergen();
    /* 🔴 NUR wenn der Entwurf dadurch verworfen ist — sonst ist `[data-aktion]` der
       Warenkorb-Knopf. Porträt ⇄ Lexikon und Farbe setzt der Satz-Weg ohne neuen Render. */
    if (s.phase === 'leer' && !s.kandidatId) {
      /* Das Foto DIESES Entwurfs geht mit — nach `?entwurf=` oder der Historie ist der Foto-Zustand der
         Seite leer, der Andruck stoppte sonst mit „Bitte lade ein Foto hoch" (Handy-Probe 26.10.2026).
         Muster `hinweisAnwenden`; der Dienst prüft beim Andruck, ob das Foto noch liegt.
         🔴 ERST HIER, nach den Klicks (code-pruefer Runde 1, 26.10.2026): vorher gesetzt, trug der Brief
         plötzlich `foto_id`, die Basis des gezeigten Entwurfs (`s.haustierBasis`, nach `?entwurf=`
         ohne Foto berechnet) nicht — der kostenlose Satz-Weg Porträt ⇄ Lexikon riss, und es wäre neu
         gerendert (bezahlt) worden. Ist der Entwurf verworfen, gibt es keine Basis mehr zu schützen. */
      if (istHaustier() && !foto.ohne && foto.status === 'leer' && entwurfBrief && entwurfBrief.foto_id) {
        foto = { ...foto, id: entwurfBrief.foto_id, status: entwurfBrief.hauptmotiv ? 'hauptmotiv' : 'ok',
                 meldung: '', hinweis: '', tiere: [], hauptmotiv: entwurfBrief.hauptmotiv || '' };
        fotoZeichnen();
      }
      const k = $('[data-aktion]');
      if (k && !k.disabled) k.click();
      /* Fehlt für die neue Machart noch etwas (z. B. Lexikon-Eigenheiten), startet kein Andruck:
         das Formular aufklappen, damit die Meldung neben einem sichtbaren Feld steht. */
      if (s.phase === 'leer' && !andersFehlendeZeigen()) {
        angabenOffen = true;
        kaufZeichnen(null);
        wachsenAlle();
        $('[data-fehler]:not([hidden])')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    } else {
      /* Satz-Weg (z. B. Porträt → Lexikon): fehlt eine Pflichtangabe, gleich dorthin. */
      andersFehlendeZeigen(true);
      andersZeichnen();
    }
  }

  /* --------------------------------------------- Daumen (13.10.2026) ----
     Sascha »A, bau es so ein«: „Gefällt dir dein Entwurf? 👍 👎" ersetzt die
     Meldezeile. 👎 öffnet das bestehende Melde-Panel, 👍 schließt es und zeigt
     einen Kaufgrund. Der Warenkorb-Knopf bleibt unberührt — er ist der einzige
     schwarze Knopf der Seite. Jeder Tipp geht als Ereignis »daumen« ans
     Backend; ein Fehler dort kostet den Kunden nichts und bleibt still.

     🔴 DIE WAHL GEHÖRT ZU EINEM ENTWURF, nicht zur Seite. Dieselbe Klasse wie
     das Melde-Panel (`meldenZeichnen`, Befund code-pruefer 15.08.2026): wer
     Entwurf A mit 👍 bewertet und dann B ansieht, darf B nicht als bewertet
     sehen. Deshalb trägt die Zeile die ID, zu der die Knöpfe gerade stehen. */
  const DAUMEN_GESENDET = new Set();   // `${kandidatId}|${wert}`, je Seitenaufruf

  function daumenZuruecksetzen(zeile) {
    if (!zeile) return;
    const fuer = String(s.kandidatId || '');
    if (zeile.dataset.daumenFuer === fuer) return;
    zeile.dataset.daumenFuer = fuer;
    zeile.querySelectorAll('[data-daumen]').forEach((b) =>
      b.setAttribute('aria-pressed', 'false'));
    /* Pills (27.10.2026): gleiche Regel — ein neu gesetztes Blatt bekommt frische, offene Pills. */
    const pills = zeile.querySelector('[data-pills]');
    if (pills) pills.dataset.pillsFuer = '';
    const dank = zeile.querySelector('[data-daumen-dank]');
    if (dank) dank.hidden = true;
  }

  function daumenGeben(wert) {
    if (!meldenMoeglich() || (wert !== 'hoch' && wert !== 'runter')) return;
    const zeile = document.querySelector('[data-melden-zeile]');
    if (!zeile) return;
    const kandidatId = s.kandidatId;
    zeile.dataset.daumenFuer = String(kandidatId);
    zeile.querySelectorAll('[data-daumen]').forEach((b) =>
      b.setAttribute('aria-pressed', String(b.dataset.daumen === wert)));
    const dank = zeile.querySelector('[data-daumen-dank]');
    if (dank) dank.hidden = wert !== 'hoch';
    if (wert === 'hoch') {
      meldenPanelVerbergen();
      zoegernPanelZeigen();
    } else {
      zoegernPanelVerbergen();
      if (!document.querySelector('[data-melden-panel]')) {
        if (rueckmeldungBereit && NACHGEZEICHNET.has(String(kandidatId))) neuRenderPanelZeigen();
        else meldenPanelZeigen();
      }
    }

    const schluessel = `${kandidatId}|${wert}`;
    if (DAUMEN_GESENDET.has(schluessel)) return;
    DAUMEN_GESENDET.add(schluessel);
    /* text/plain wie beim Kassenbild (Befund code-pruefer 13.10.2026): mit
       application/json bräuchte die Cross-Origin-Anfrage einen CORS-Vorabruf,
       und der ist zusammen mit `keepalive` nicht überall erlaubt — das Ereignis
       fehlte dann still. `_daumen()` liest den Körper als JSON, egal welcher Typ. */
    fetch(`${BACKEND}/api/daumen`, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify({ kandidat_id: kandidatId, wert }),
      keepalive: true,   // der Kunde darf direkt danach die Seite verlassen
    }).catch((e) => console.error(e));
  }

  /* ------------------------- Nachfrage nach 👍 (15.10.2026, Sascha »A«) ----
     „Fehlt dir noch etwas zur Bestellung?" — Anlass: 4 von 4 Kunden mit 👍
     (13.–15.10.) legten nichts in den Warenkorb. Mischform (Sascha »A« zur
     Mehrfachauswahl): der erste Tipp löst die Reaktion aus, die Knöpfe bleiben
     antippbar, jeder weitere Tipp zählt mit und zeigt seine eigene Reaktion.
     Kein Absende-Knopf, außer beim Freitext von „Etwas anderes".
     Die IDs sind Systemschlüssel und müssen zu `dienst.ZOEGERN_GRUENDE` passen
     (der Selbsttest des Dienstes liest diese Datei und prüft es); die Labels
     sind frei. Jeder Tipp geht als Ereignis »zoegern« ans Backend — ein Fehler
     dort kostet den Kunden nichts und bleibt still, wie beim Daumen.

     🔴 DIE REAKTIONEN NUTZEN, WAS DA IST — keine zweite Kopie. „Per Mail
     sichern" öffnet das bestehende Formular unter dem Warenkorb-Knopf
     (`[data-speichern]`, Einwilligungstext und Versand dort), die Raumansicht
     ist die bestehende Tafel, die Lieferzeit die bestehende Zeile. */
  /* 🆕 26.10.2026 (Saschas T1 »A«, Stufe 1): die Frage steht unter JEDEM Entwurf, nicht nur nach 👍,
     und kennt drei Gründe mehr — „Bild trifft es nicht" öffnet das Melde-Feld (dieselbe Wirkung wie
     👎), „Nur geschaut" und „Kenne Echoa noch nicht" zählen nur bzw. zeigen „So kommt es bei dir an".
     Neue IDs immer an DREI Stellen: hier, `dienst.ZOEGERN_GRUENDE`, `tagesdaten.ZOEGERN_GRUENDE`
     (Cockpit-Beschriftung: `skills/cockpit/cockpit.html` ZOEGERN_LABEL). */
  const ZOEGERN_GRUENDE = [
    { id: 'bild_trifft_nicht', label: 'Bild trifft es nicht' },
    { id: 'preis', label: 'Preis' },
    { id: 'groesse_rahmen', label: 'Größe oder Rahmen unsicher' },
    { id: 'andere_motive', label: 'Probiere noch andere Motive' },
    { id: 'geschenk', label: 'Geschenk, muss noch klären' },
    { id: 'spaeter', label: 'Später bestellen' },
    { id: 'kenne_echoa_nicht', label: 'Kenne Echoa noch nicht' },
    { id: 'nur_geschaut', label: 'Nur geschaut' },
    { id: 'anderes', label: 'Etwas anderes' },
  ];
  /* Muss zu `dienst.ZOEGERN_TEXT_MAX` passen (Selbsttest prüft beides). */
  const ZOEGERN_TEXT_MAX = 300;
  const ZOEGERN_GESENDET = new Set();   // `${kandidatId}|${grund}`, je Seitenaufruf

  /** Öffnet das Melde-Feld zum gezeigten Entwurf — nach einer Meldung mit Nachzeichnung den
      Neu-Wurf, sonst das Melde-Panel. Derselbe Zweig wie 👎 (`daumenGeben`). */
  function meldenOeffnen() {
    if (!meldenMoeglich()) return;
    if (!document.querySelector('[data-melden-panel]')) {
      if (rueckmeldungBereit && NACHGEZEICHNET.has(String(s.kandidatId))) neuRenderPanelZeigen();
      else meldenPanelZeigen();
    }
    document.querySelector('[data-melden-panel]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function zoegernPanelVerbergen() {
    const offen = document.querySelector('[data-zoegern-panel]');
    if (offen) offen.remove();
  }

  function zoegernSenden(kandidatId, grund, text = '') {
    const schluessel = `${kandidatId}|${grund}`;
    if (ZOEGERN_GESENDET.has(schluessel)) return;
    ZOEGERN_GESENDET.add(schluessel);
    /* text/plain + keepalive wie beim Daumen (kein CORS-Vorabruf). */
    fetch(`${BACKEND}/api/zoegern`, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify({ kandidat_id: kandidatId, grund, ...(text ? { text } : {}) }),
      keepalive: true,
    }).catch((e) => console.error(e));
  }

  /** Mail-Sicherung möglich? Dieselbe Bedingung, unter der `speichernZeigen()`
      den Block sichtbar macht — gelesen am Block selbst, nicht nachgerechnet. */
  function zoegernMailMoeglich() {
    const sp = $('[data-speichern]');
    return Boolean(sp && !sp.hidden && sp.dataset.fuer === s.kandidatId);
  }

  /** Öffnet das bestehende Mail-Formular und holt es ins Bild. */
  function zoegernMailOeffnen() {
    const sp = $('[data-speichern]');
    if (!sp || sp.hidden) return;
    const oeffnen = sp.querySelector('[data-mail-oeffnen]');
    if (oeffnen && !oeffnen.hidden) oeffnen.click();
    const form = sp.querySelector('[data-mail-form]');
    (form || sp).scrollIntoView({ behavior: 'smooth', block: 'center' });
    const feld = sp.querySelector('[data-mail-adresse]');
    if (feld) feld.focus({ preventScroll: true });
  }

  /** Bühne auf die erste Raumansicht. Gibt false zurück, wenn es keine gibt. */
  function zoegernRaumZeigen() {
    const raum = ANSICHTEN.find((a) => a.startsWith('raum-'));
    if (!raum) return false;
    ansichtWechseln(raum);
    const tafel = document.querySelector(`[data-tafel="${raum}"]`);
    if (tafel) tafel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
  }

  function zoegernPanelZeigen() {
    /* ⏪ 27.10.–29.10.2026 erst, wenn Format oder Rahmen angefasst wurden (`kaufBeruehrt`). Seit 29.10.2026
       (Sascha: „wurden bei mir die weiteren Feedback-Pillen zu Rahmen, Größe etc. gar nicht angezeigt“) steht
       sie unter jedem fertigen Entwurf — sie liegt unter dem Kaufknopf und schiebt ihn nicht weg. */
    if (!meldenMoeglich()) return;
    const zeile = document.querySelector('[data-melden-zeile]');
    if (!zeile) return;
    const vorhanden = document.querySelector('[data-zoegern-panel]');
    if (vorhanden && vorhanden.dataset.zoegernPanel === String(s.kandidatId)) return;
    zoegernPanelVerbergen();

    /* Eingefroren beim Öffnen, wie beim Melde-Panel: die Antwort gehört zu
       dem Entwurf, der beim 👍 auf der Bühne stand. `meldenZeichnen()` schließt
       das Panel, sobald ein anderer Entwurf gezeigt wird. */
    const kandidatId = s.kandidatId;
    const panel = document.createElement('div');
    panel.dataset.zoegernPanel = String(kandidatId);
    panel.className = 'melden zoegern';
    panel.innerHTML = `
      <p class="feld-label" id="zoegern-frage">Fehlt dir noch etwas zur Bestellung?</p>
      <div class="optionen melden__chips" role="group" aria-labelledby="zoegern-frage">
        ${ZOEGERN_GRUENDE.filter((g) => g.id !== 'bild_trifft_nicht').map((g) => `
          <button type="button" class="option" data-zoegern="${attr(g.id)}"
                  aria-pressed="false">${escape(g.label)}</button>`).join('')}
      </div>
      <div class="zoegern__antwort" data-zoegern-antwort aria-live="polite"></div>`;
    /* 🔴 UNTER DEM KAUFBEREICH, NICHT UNTER DER BÜHNE (26.10.2026). Seit die Frage allen gezeigt wird,
       hätte sie „In den Warenkorb" am Handy um ~430 px nach unten geschoben (Handy-Probe 390 px:
       2.536 → 3.127 px). Unter Knopf, Mail-Sicherung und Zusicherungen fragt sie den, der NICHT kauft —
       und die Kauffläche bleibt, wo sie war. ⏪ 15.–26.10.2026: direkt unter der Daumen-Zeile, nur nach 👍. */
    const anker = document.querySelector('[data-widerruf-block]') || document.querySelector('[data-anker]');
    if (anker) anker.insertAdjacentElement('afterend', panel);
    else zeile.insertAdjacentElement('afterend', panel);

    /* 🆕 29.10.2026 (Sascha, PDP-Vorlage E10): jeder Knopf lässt sich wieder abwählen, und jede Antwort
       steht in einem eigenen Kasten — abwählen nimmt genau diesen Kasten weg. ⏪ Bis heute ersetzte jede
       Antwort die vorige, und ein gedrückter Knopf blieb gedrückt („Ich kann mehrere anwählen, aber dann
       keinen Knopf mehr abwählen“). Wichtiges ist fett (Lieferdatum, Vorteil) — ⏪ der Geschenk-Text
       übernahm die Lieferzeile als reinen Text, die Fettung fiel weg. „Größe oder Rahmen“ springt nicht
       mehr ungefragt zur Galerie oben, sondern bietet beide Wege als Link an (Saschas Zusatz: auch die
       Raumansicht). */
    const antwort = panel.querySelector('[data-zoegern-antwort]');
    const DANKE = '<p class="melden__danke">Danke – das hilft uns weiter.</p>';
    const mailKnopf = `<div class="melden__aktionen">
        <button type="button" class="echoa-aktion echoa-aktion--leise"
                data-zoegern-mail>Entwurf per Mail sichern</button></div>`;
    const kastenSetzen = (grund, html) => {
      let k = antwort.querySelector(`[data-antwort-fuer="${grund}"]`);
      if (!html) { if (k) k.remove(); return; }
      if (!k) {
        k = document.createElement('div');
        k.className = 'zoegern__kasten';
        k.dataset.antwortFuer = grund;
        antwort.appendChild(k);
      }
      k.innerHTML = html;
    };
    const antwortFuer = (grund) => {
      const mail = zoegernMailMoeglich();
      if (grund === 'spaeter') {
        return mail
          ? `<p class="melden__danke">Kein Problem. <b>Schick dir den Entwurf per Mail</b> – dann ist er nicht weg.</p>${mailKnopf}`
          : DANKE;
      }
      if (grund === 'andere_motive') {
        return mail
          ? `<p class="melden__danke">Gern! <b>Schick dir diesen Entwurf per Mail</b>, dann geht er beim Stöbern nicht verloren.</p>${mailKnopf}`
          : DANKE;
      }
      if (grund === 'geschenk') {
        return `<p class="melden__danke">Bestellst du heute, ist dein Poster voraussichtlich <b>${escape(lieferSpanne())}</b> bei dir.</p>
          ${mail ? `<p class="melden__danke">Du kannst dir den Entwurf auch per Mail schicken und in Ruhe entscheiden.</p>${mailKnopf}` : ''}`;
      }
      if (grund === 'preis') {
        const vt = vorteilFuer(kandidatId);
        return vt
          ? `<p class="melden__danke">Für deinen Entwurf gilt gerade: <b>${escape(String(vt.prozent))}&nbsp;% + kostenloser Versand</b>, reserviert bis <b>${escape(vt.bis_text)}</b>. Wird im Warenkorb automatisch abgezogen.</p>`
          : DANKE;
      }
      if (grund === 'groesse_rahmen') {
        const raum = ANSICHTEN.some((a) => a.startsWith('raum-'));
        return `<p class="melden__danke">In der Raumansicht hängt <b>dein Entwurf in der gewählten Größe</b> an einer Wand. Wechselst du Format oder Rahmen, geht die Ansicht mit.</p>
          <p class="melden__danke zoegern__links">${raum ? '<button type="button" class="zoegern__link" data-zoegern-raum>Im Raum ansehen ↑</button>' : ''}<button type="button" class="zoegern__link" data-zoegern-format>Zu Format und Rahmen ↑</button></p>`;
      }
      if (grund === 'kenne_echoa_nicht') {
        return '<p class="melden__danke"><b>Gedruckt wird erst nach deinem OK.</b> Bist du nicht zufrieden, bekommst du dein Geld zurück.</p>';
      }
      if (grund === 'anderes') {
        if (ZOEGERN_GESENDET.has(`${kandidatId}|anderes`)) return DANKE;
        return `
          <label class="visually-hidden" for="zoegern-text">Was fehlt dir noch?</label>
          <textarea id="zoegern-text" class="melden__text" rows="2" data-zoegern-text
                    maxlength="${ZOEGERN_TEXT_MAX}" placeholder="Was fehlt dir noch?"></textarea>
          <p class="melden__fehler" data-zoegern-fehler hidden role="alert"></p>
          <div class="melden__aktionen">
            <button type="button" class="echoa-aktion echoa-aktion--leise"
                    data-zoegern-senden>Senden</button>
          </div>`;
      }
      return DANKE;
    };

    panel.addEventListener('click', (e) => {
      if (e.target.closest('[data-zoegern-mail]')) return zoegernMailOeffnen();
      if (e.target.closest('[data-zoegern-raum]')) return zoegernRaumZeigen();
      if (e.target.closest('[data-zoegern-format]')) {
        const ziel = wurzel.querySelector('.schritt--ausfuehrung') || wurzel.querySelector('[data-block="groesse"]');
        if (ziel) ziel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      const senden = e.target.closest('[data-zoegern-senden]');
      if (senden) {
        const feld = panel.querySelector('[data-zoegern-text]');
        const fehler = panel.querySelector('[data-zoegern-fehler]');
        const text = (feld ? feld.value : '').trim();
        if (!text) {
          if (fehler) { fehler.textContent = 'Schreib kurz, was dir noch fehlt.'; fehler.hidden = false; }
          if (feld) feld.focus();
          return;
        }
        zoegernSenden(kandidatId, 'anderes', text.slice(0, ZOEGERN_TEXT_MAX));
        kastenSetzen('anderes', DANKE);
        return;
      }

      const knopf = e.target.closest('[data-zoegern]');
      if (!knopf) return;
      const grund = knopf.dataset.zoegern;
      if (knopf.getAttribute('aria-pressed') === 'true') {
        /* Abwählen: Knopf lösen, nur seinen Kasten entfernen. Das Ereignis bleibt gezählt — es sagt,
           dass der Grund einmal genannt wurde. */
        knopf.setAttribute('aria-pressed', 'false');
        kastenSetzen(grund, '');
        return;
      }
      knopf.setAttribute('aria-pressed', 'true');
      /* „Etwas anderes" zählt erst mit Text — ein leeres »anderes« sagt nichts. */
      if (grund !== 'anderes') zoegernSenden(kandidatId, grund);
      if (grund === 'bild_trifft_nicht') {
        /* Dieselbe Wirkung wie 👎: das Melde-Feld (bzw. der neue Wurf nach einer Meldung) öffnet sich. */
        meldenOeffnen();
        kastenSetzen(grund, '<p class="melden__danke">Sag uns oben, was anders sein soll – wir zeichnen es neu.</p>');
        return;
      }
      kastenSetzen(grund, antwortFuer(grund));
      if (grund === 'anderes') {
        const feld = antwort.querySelector('[data-zoegern-text]');
        if (feld) feld.focus();
      }
    });
  }

  /** Der Brief-Stand, der zu dem GEZEIGTEN Entwurf gehört — nicht der von jetzt.
      🔴 Ohne ihn berichtet der Kunde über Bild A, während sein Text schon B ist.
      Primärquelle ist der in `historieMerken()` eingefrorene Stand; er ist der
      genauere, weil er den Moment des Absendens festhält. Erst wenn es ihn
      nicht gibt (Historie durch `sessionStorage`-Sperre leer), fällt es auf den
      aktuellen Stand zurück — und der ist immer noch besser als keiner. */
  function briefZumEntwurf() {
    const e = historieLesen().find((x) => x.id === s.kandidatId);
    if (e && e.brief) return e.brief;
    sammleBrief();
    return { ...s.brief };
  }

  function meldenPanelZeigen() {
    if (!meldenMoeglich()) return;
    meldenPanelVerbergen();
    const zeile = document.querySelector('[data-melden-zeile]');
    if (!zeile) return;

    /* Eingefroren beim ÖFFNEN, nicht beim Absenden: zwischen beidem liegt das
       Tippen des Kunden, und die Felder oben bleiben bedienbar. Was er
       beschreibt, ist der Entwurf, den er beim Öffnen vor sich hatte. */
    const kandidatId = s.kandidatId;
    const briefStand = briefZumEntwurf();
    /* Ein Knopf für Meldung UND neuen Wurf (Sascha, 21.10.2026 abends), wo der Dienst den
       Hinweis einlöst; sonst bleibt es beim Melden. Der Satz, was sich ändern lässt, steht
       VOR dem Absenden unter dem Feld — wer „mit Controller in der Hand" schreibt, soll es
       vorher wissen. */
    const direkt = direktNeuZeichnen();
    const knopfText = direkt ? 'Mit meinem Hinweis neu zeichnen' : 'Abschicken';

    const panel = document.createElement('div');
    /* Die ID des Entwurfs, zu dem dieses Panel gehört — `meldenZeichnen()`
       vergleicht sie gegen `s.kandidatId` und schließt bei Abweichung.
       Ohne diesen Wert gäbe es keinen Weg, einen Entwurfs-Wechsel unter einem
       offenen Formular zu bemerken. */
    panel.dataset.meldenPanel = String(kandidatId);
    panel.className = 'melden';
    /* Pills (27.10.2026): wer über eine Bild-Pill kommt, hat den Bereich schon gewählt — keine Kacheln,
       die Frage nennt die gewählten Bereiche (`meldenFrageSetzen`). */
    const pillModus = pillWahl.length > 0;
    panel.innerHTML = (pillModus ? `
      <label class="feld-label melden__label melden__label--pills" for="melden-text"
             data-melde-frage>Was genau?</label>` : `
      <p class="feld-label">Was stimmt nicht?</p>
      <div class="optionen melden__chips" role="group" aria-label="Art des Fehlers">
        ${MELDE_KATEGORIEN.map((k) => `
          <button type="button" class="option" data-melde-kat="${attr(k.id)}"
                  aria-pressed="false">${escape(k.label)}</button>`).join('')}
      </div>
      <label class="feld-label melden__label" for="melden-text">
        Beschreib es kurz – das ist der Teil, der uns wirklich hilft
      </label>`) + `
      <textarea id="melden-text" class="melden__text" rows="3" data-melde-text
                maxlength="${MELDE_TEXT_MAX}"
                placeholder="z. B. was fehlt, was anders aussehen soll oder welche Farbe nicht stimmt"></textarea>
      ${direkt ? `<p class="feld-hilfe melden__was-geht">${escape(direkt.satz)}</p>` : ''}
      <p class="melden__fehler" data-melde-fehler hidden role="alert"></p>
      <div class="melden__aktionen">
        <button type="button" class="echoa-aktion melden__senden" data-melde-senden>
          ${escape(knopfText)}
        </button>
        ${vormerkenMoeglich() ? `<button type="button" class="echoa-aktion echoa-aktion--leise melden__vormerken"
                data-melde-vormerken>Für nach der Bestellung vormerken</button>` : ''}
        <button type="button" class="echoa-link melden__abbrechen"
                data-melde-abbrechen>Abbrechen</button>
      </div>
      <div class="melden__vorgemerkt" data-vorgemerkt hidden role="status"></div>`;
    zeile.insertAdjacentElement('afterend', panel);

    let kategorie = null;
    if (pillModus) meldenFrageSetzen(panel);
    const feld = panel.querySelector('[data-melde-text]');
    const senden = panel.querySelector('[data-melde-senden]');
    const fehler = panel.querySelector('[data-melde-fehler]');

    /* Beides ist Pflicht: eine Kategorie ohne Text ist eine Zeile ohne Inhalt,
       ein Text ohne Kategorie ist nicht zählbar. Das Backend lehnt beides
       ebenfalls ab — die Prüfung hier ist die Bequemlichkeit, nicht der Riegel.

       ⏪ 19.08.2026: SIE SPERRT DEN KNOPF NICHT MEHR, SIE ANTWORTET.
       Bis hierher stand der Knopf auf `disabled`, bis beides ausgefüllt war —
       und `.echoa-aktion[disabled]` färbt ihn grau. Beim Öffnen des Panels
       war er damit IMMER grau; genau so hat Sascha ihn am 19.08. fotografiert
       und daraufhin „Abschicken schwarz (CTA)" bestellt. Ein schwarzer Knopf,
       der bei Klick nichts tut, wäre schlimmer als ein grauer: deshalb prüft
       der Klick jetzt selbst und benennt, was fehlt — in der Fehlerzeile, die
       für die Antworten des Backends ohnehin schon dasteht (`role="alert"`,
       also wird sie auch vorgelesen).
       ⚠️ Die Reihenfolge der Prüfung folgt der Reihenfolge im Panel: erst die
       Kachel, dann der Text. Wer beides vergisst, wird zur ersten Lücke
       geschickt, nicht zu zwei gleichzeitig. */
    const fehlt = () => {
      if (pillModus ? !pillWahl.length : !kategorie) return 'Bitte wähle zuerst, was nicht stimmt.';
      if (!feld.value.trim()) return 'Bitte beschreib es kurz – ohne den Text '
        + 'können wir nichts damit anfangen.';
      return null;
    };
    /* Eine sichtbare Rüge verschwindet, sobald der Kunde nachbessert. Sie
       stehen zu lassen hieße, ihm einen Fehler vorzuhalten, den er gerade
       behoben hat.
       Die Rüge vom Vormerk-Knopf verlangt nur den Text, keine Kachel (code-pruefer 29.10.2026) —
       sonst bliebe sie über einem ausgefüllten Feld stehen. */
    let ruegeNurText = false;
    const rugeLoeschen = () => {
      if (!fehler || fehler.hidden) return;
      if (ruegeNurText ? feld.value.trim() : !fehlt()) { fehler.hidden = true; ruegeNurText = false; }
    };

    panel.querySelectorAll('[data-melde-kat]').forEach((b) => {
      b.addEventListener('click', () => {
        kategorie = b.dataset.meldeKat;
        panel.querySelectorAll('[data-melde-kat]').forEach((x) =>
          x.setAttribute('aria-pressed', String(x === b)));
        rugeLoeschen();
      });
    });
    feld.addEventListener('input', rugeLoeschen);
    /* 🔴 Als Pfeilfunktion: direkt übergeben bekam `meldenPanelVerbergen` das Klick-Ereignis als
       `nur` und schloss deshalb nie (Sascha am iPhone, 22.10.2026 — betraf jeden Browser). */
    panel.querySelector('[data-melde-abbrechen]').addEventListener('click', () => {
      meldenPanelVerbergen();
      /* Pills: Abbrechen nimmt auch die Auswahl zurück — sonst stünden Bereiche gedrückt ohne Feld. */
      if (pillModus) pillsLoesen();
    });
    /* „Für nach der Bestellung vormerken“ (Saschas »B«, 29.10.2026): der Wunsch reist als Zeilen-Eigenschaft
       »Änderungswunsch« mit (`vormerkenSetzen`), kein neuer Entwurf. Sascha arbeitet ihn nach der Bestellung
       von Hand ein; die Druckstraße hält die Kunden-Freigabe solange an (`fulfillment.cmd_kunden_freigabe`). */
    const vorgemerkt = panel.querySelector('[data-vorgemerkt]');
    const vorgemerktZeigen = () => {
      const text = VORMERK.get(String(kandidatId)) || '';
      vorgemerkt.hidden = !text;
      vorgemerkt.innerHTML = text ? `<p class="melden__danke"><b>Vorgemerkt.</b> Wir schauen uns deinen Wunsch nach
          der Bestellung persönlich an und schicken dir den überarbeiteten Entwurf zur Freigabe. Gedruckt wird erst
          nach deinem OK.</p>
        <p class="melden__danke melden__vorgemerkt-text">„${escape(text)}“
          <button type="button" class="echoa-link" data-vormerk-weg>Entfernen</button></p>` : '';
    };
    vorgemerktZeigen();
    panel.querySelector('[data-melde-vormerken]')?.addEventListener('click', () => {
      const text = feld.value.trim();
      if (!text) {
        if (fehler) { fehler.textContent = 'Schreib kurz, was anders sein soll.'; fehler.hidden = false; ruegeNurText = true; }
        feld.focus();
        return;
      }
      if (fehler) fehler.hidden = true;
      vormerkenSetzen(kandidatId, text);
      vorgemerktZeigen();
    });
    vorgemerkt.addEventListener('click', (e) => {
      if (!e.target.closest('[data-vormerk-weg]')) return;
      vormerkenSetzen(kandidatId, '');
      vorgemerktZeigen();
    });
    senden.addEventListener('click', () => {
      const luecke = fehlt();
      if (luecke) {
        if (fehler) { fehler.textContent = luecke; fehler.hidden = false; ruegeNurText = false; }
        (kategorie || pillModus ? feld : panel.querySelector('[data-melde-kat]'))?.focus();
        return;
      }
      if (pillModus) {
        meldenAbsenden(panel, kandidatId, pillWahl[0], feld.value, briefStand, '', knopfText, [...pillWahl]);
        return;
      }
      meldenAbsenden(panel, kandidatId, kategorie, feld.value, briefStand, '', knopfText);
    });

    feld.focus();
  }

  /** Der Kasten der zweiten Stufe: das ZWEITE Bild gefällt auch nicht.
      🔴 Er schickt einen echten Bericht zu DIESEM Entwurf — ohne Bericht nimmt
      der Dienst keine Adresse an (`feedback_mail_ablegen`: eine Adresse ohne
      Meldung wäre eine Newsletter-Anmeldung durch die Hintertür), und
      `rueckmeldung.py neu` zeichnet aus genau diesem Bericht nach.
      Der Text ist mit dem der ersten Meldung VORBELEGT, sichtbar und änderbar:
      meist stimmt nach dem zweiten Wurf noch dasselbe nicht, und ein leeres
      Pflichtfeld vor dem Mailfeld kostet Adressen.
      ⚑ Die Kategorie reitet unsichtbar von der ersten Meldung mit (seiten-
      intern, reversibel): drei Chips ein zweites Mal kosten Adressen, und es
      ist dieselbe Beschwerde am Nachfolger.
      `opt.vorher` + `opt.vorspann` (21.10.2026, Hinweis → Felder): kein passendes
      Feld — der Kasten kommt direkt zum GLEICHEN Entwurf, mit dem Satz davor. */
  function neuRenderPanelZeigen(opt = {}) {
    if (!meldenMoeglich()) return;
    meldenPanelVerbergen();
    const zeile = document.querySelector('[data-melden-zeile]');
    const vorher = opt.vorher || NACHGEZEICHNET.get(String(s.kandidatId));
    if (!zeile || !vorher) return;

    const kandidatId = s.kandidatId;
    const briefStand = briefZumEntwurf();
    const panel = document.createElement('div');
    panel.dataset.meldenPanel = String(kandidatId);   // `meldenZeichnen()` schließt bei Wechsel
    panel.className = 'melden melden--neurender';
    panel.innerHTML = `
      ${opt.vorspann ? `<p class="melden__danke melden__vorspann">${escape(opt.vorspann)}</p>` : ''}
      <p class="melden__neurender-titel">${RUECK_KASTEN_TITEL}</p>
      <label class="feld-label melden__label" for="neurender-adresse">Deine Mail</label>
      <input type="email" id="neurender-adresse" class="echoa-feld melden__adresse"
             autocomplete="email" inputmode="email" maxlength="254"
             placeholder="deine@mail.de" data-melde-adresse>
      <!-- Wortlaut = dienst.RUECKMELDUNG_SATZ (Einwilligung v3); beide ändern, Version hochzählen -->
      <p class="entwurf-mail__hinweis" data-rueck-satz>Wir schicken dir nochmal einen
      verbesserten Entwurf per Mail, sobald dein Feedback eingearbeitet ist.
      Kein Newsletter. <a href="/policies/privacy-policy" class="echoa-link">Datenschutz</a></p>
      <label class="feld-label melden__label" for="neurender-text">Was sollen wir ändern?</label>
      <textarea id="neurender-text" class="melden__text" rows="2" data-melde-text
                maxlength="${MELDE_TEXT_MAX}">${escape(vorher.text)}</textarea>
      <p class="melden__fehler" data-melde-fehler hidden role="alert"></p>
      <div class="melden__aktionen">
        <button type="button" class="echoa-aktion melden__senden" data-melde-senden>
          Neu-Render anfordern
        </button>
        <button type="button" class="echoa-link melden__abbrechen"
                data-melde-abbrechen>Nein, danke</button>
      </div>`;
    zeile.insertAdjacentElement('afterend', panel);

    const adr = panel.querySelector('[data-melde-adresse]');
    const feld = panel.querySelector('[data-melde-text]');
    const fehler = panel.querySelector('[data-melde-fehler]');
    const fehlt = () => {
      const a = adr.value.trim();
      if (!a) return 'Bitte gib deine Mail an – dorthin schicken wir dein neues Bild.';
      if (!RUECK_ADRESSE_RE.test(a)) return 'Die Mailadresse stimmt so nicht.';
      if (!feld.value.trim()) return 'Schreib kurz, was wir ändern sollen.';
      return null;
    };
    const rugeLoeschen = () => {
      if (fehler && !fehler.hidden && !fehlt()) fehler.hidden = true;
    };
    adr.addEventListener('input', rugeLoeschen);
    feld.addEventListener('input', rugeLoeschen);
    panel.querySelector('[data-melde-abbrechen]').addEventListener('click',
      () => meldenPanelVerbergen(panel));
    panel.querySelector('[data-melde-senden]').addEventListener('click', () => {
      const luecke = fehlt();
      if (luecke) {
        fehler.textContent = luecke;
        fehler.hidden = false;
        (adr.value.trim() && RUECK_ADRESSE_RE.test(adr.value.trim()) ? feld : adr).focus();
        return;
      }
      meldenAbsenden(panel, kandidatId, vorher.kategorie, feld.value, briefStand,
        adr.value.trim(), 'Neu-Render anfordern');
    });
    /* Kein Fokus: auf dem Handy schöbe die Tastatur die Überschrift weg —
       und die ist der Grund, das Feld auszufüllen. */
    panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  /* ------------------------------------------- Rückmeldung per Mail
     🔴 13.10.2026 (Sascha, T1 »A«, am Mockup gewählt): ein FREIWILLIGES
     Mailfeld. Intern entsteht ein verbesserter Entwurf; die Mail geht erst
     raus, wenn Sascha ihn gesehen hat (`rueckmeldung.py`). Der Satz unter dem
     Feld ist Saschas Wortlaut vom 13.10.2026 — er hebt damit seine Bedingung
     vom 15.08. („kein ‚sobald‘") für diese Strecke selbst auf.
     ⏪ 21.10.2026: das Feld steht nicht mehr im ersten Meldeformular, sondern
     im Kasten nach dem zweiten Bild (`neuRenderPanelZeigen`, Einwilligung v3).
     Sichtbar nur, wenn das Backend die Adresse annimmt (`/puls` →
     rueckmeldung). „Entwurf per Mail sichern" (`[data-speichern]`) ist davon
     unberührt. */
  let rueckmeldungBereit = false;
  const RUECK_ADRESSE_RE = /^[^@\s<>"',;]+@[^@\s<>"',;]+\.[A-Za-z]{2,}$/;

  async function meldenAbsenden(panel, kandidatId, kategorie, text, briefStand,
                                adresse = '', knopfText = 'Abschicken', bereiche = null) {
    const senden = panel.querySelector('[data-melde-senden]');
    const fehler = panel.querySelector('[data-melde-fehler]');
    senden.disabled = true;
    senden.textContent = 'wird gesendet …';
    fehler.hidden = true;
    try {
      const r = await fetch(`${BACKEND}/api/feedback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          kandidat_id: kandidatId,
          kategorie,
          text: String(text).slice(0, MELDE_TEXT_MAX),
          brief_stand: briefStand,
          ...(adresse ? { adresse } : {}),
          ...(Array.isArray(bereiche) && bereiche.length ? { bereiche } : {}),
        }),
      });
      if (!r.ok) {
        /* 🔴 EINEN BENANNTEN GRUND WEITERGEBEN, statt ihn durch „bitte noch
           einmal versuchen" zu ersetzen. Es gibt einen Fall, in dem ein
           zweiter Versuch nichts ändert: der Deckel je Entwurf ist erreicht
           (`dienst.FEEDBACK_BERICHTE_JE_KANDIDAT`). Den Kunden dort in eine
           Schleife zu schicken, ist dieselbe Klasse wie die Rückfragen-Runde,
           die vor dem 11.08.2026 in einer Sackgasse endete. */
        const grund = await r.json().catch(() => null);
        throw Object.assign(new Error(`Backend ${r.status}`),
          { benannt: grund && typeof grund.fehler === 'string' ? grund.fehler : '' });
      }
      /* 🔴 KEIN VERSPRECHEN. Weder eine Rückmeldung noch eine Frist noch eine
         Behebung — es gibt heute keine Mail-Strecke, die eines davon einlösen
         könnte (das ist C). Der Text sagt genau das, was wahr ist: es ist
         angekommen, und es hilft. Wer hier später „wir melden uns" ergänzt,
         liest zuerst Saschas Bedingung am Kopf dieses Abschnitts. */
      /* „Gemerkt" nur, wenn das Backend die Adresse wirklich abgelegt hat —
         sonst wäre der Satz ein Versprechen ohne Adresse dahinter. */
      const antwort = await r.json().catch(() => ({}));
      /* Pills: der Bericht ist angekommen — die Auswahl gehört zu ihm, nicht zum nächsten. */
      if (Array.isArray(bereiche) && bereiche.length) pillsLoesen();
      /* Mit Adresse kam der Bericht aus dem Kasten der zweiten Stufe: danach
         wird nicht noch einmal gezeichnet — jetzt ist Sascha dran. */
      const zweiteStufe = Boolean(adresse);
      if (!(antwort && antwort.rueckmeldung)) adresse = '';
      const dankeText = adresse
        ? 'Angekommen – danke. Wir schicken dir einen verbesserten Entwurf, '
          + 'sobald dein Feedback eingearbeitet ist.'
        : zweiteStufe
          ? 'Angekommen – danke. Deine Mail konnten wir leider nicht speichern.'
          : 'Angekommen – danke.';
      panel.innerHTML = adresse || zweiteStufe
        ? `<p class="melden__danke">${escape(dankeText)}</p>`
        : `
        <p class="melden__danke">Angekommen – danke.<br>
        Das hilft uns mehr, als du denkst: wir sehen deinen Entwurf und deine
        Beschreibung nebeneinander.</p>`;
      /* „Noch einmal zeichnen" — nur, solange derselbe Entwurf auf der Bühne
         steht. Kein Versprechen: „jeder Wurf wird etwas anders" beschreibt,
         was passiert, nicht, dass es besser wird. */
      if (!zweiteStufe && NOCHMAL_HANDLES.has(D.produkt.handle) && s.kandidatId === kandidatId
          && s.phase === 'fertig') {
        /* 🔴 MIT HINWEIS NEU ZEICHNEN (Saschas 3A, 20.10.2026) — nur wenn das Backend den
           Wunsch mit Sperre einlöst (`/puls` → `WUNSCH_PULS`, Schalter `dienst.C1_WUNSCH`
           bzw. `dienst.A5_WUNSCH`) und der Kunde etwas geschrieben hat. Der Satz zur Sperre
           steht DAVOR, nicht danach: wer „mit einem Glas Wein" schreibt, soll vorher
           wissen, dass das Glas nicht kommt (Coogee-Wunsch, Masken-Test 20.10.2026).
           Beim Moment dürfen Dinge des Paares mit (`a5_neu._INSTRUKTION_WUNSCH`), die
           beiden bleiben klein — das sagt sein Satz. */
        const mitWunsch = wunschMoeglich() && String(text || '').trim() !== '';
        /* ⏪ 21.10.2026 abends: mit Wunsch wird SOFORT gezeichnet (Sascha: Schritt 2
           überspringen) — der Danke-Kasten bleibt nur für einen Dienst ohne Wunsch-Weg. */
        panel.innerHTML = mitWunsch ? '' : `
          <p class="melden__danke">${escape(dankeText)}</p>
          <p class="melden__nochmal">Sollen wir dein Bild nochmal zeichnen? Jeder
          Wurf wird etwas anders. Das dauert etwa
          ${escape(String(D.dauer_sekunden || 50))} Sekunden.</p>
          <div class="melden__aktionen">
            <button type="button" class="echoa-aktion melden__senden"
                    data-nochmal-los>Noch einmal zeichnen</button>
            <button type="button" class="echoa-link melden__abbrechen"
                    data-nochmal-nein>Nein, danke</button>
          </div>`;
        panel.querySelector('[data-nochmal-nein]')?.addEventListener('click',
          () => meldenPanelVerbergen(panel));
        const nochmal = (wunsch) => {
          meldenPanelVerbergen(panel);
          /* Der Entwurf kann inzwischen ein anderer sein (Historie) — dann
             wäre „noch einmal" ein Wurf zu einem Bild, das nicht gemeint war. */
          if (s.kandidatId !== kandidatId || s.phase !== 'fertig') return;
          /* Die Antworten DIESES Entwurfs, nicht die, die gerade am Formular
             hängen (s. `historieMerken`). Einträge ohne Feld (ältere Sitzung)
             behalten den aktuellen Stand. */
          const eintrag = historieLesen().find((x) => x.id === kandidatId);
          if (eintrag && Array.isArray(eintrag.antworten)) s.antworten = eintrag.antworten.slice();
          /* Der Wunsch gilt GENAU EINEM Wurf: ein früherer fliegt vorher raus, dieser
             danach wieder — sonst ritte er auf jedem weiteren Andruck mit. In der
             Historie bleibt er beim Entwurf, den er erzeugt hat. */
          s.antworten = s.antworten.filter((a) => a.frage !== WUNSCH_FRAGE);
          document.querySelector('[data-tafel="blatt"]')
            ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          backendLauf(wunsch ? [{ frage: WUNSCH_FRAGE, antwort: wunsch }] : null).then(() => {
            s.antworten = s.antworten.filter((a) => a.frage !== WUNSCH_FRAGE);
            /* Zweite Stufe vormerken: das 👎 auf DIESEM neuen Entwurf öffnet den
               Kasten „kostenloser Neu-Render" statt eines weiteren Wurfs. */
            if (s.kandidatId && s.kandidatId !== kandidatId && s.phase === 'fertig') {
              NACHGEZEICHNET.set(String(s.kandidatId),
                { vor: kandidatId, kategorie, text: String(text || '').slice(0, MELDE_TEXT_MAX) });
              if (wunsch) GEAENDERT.set(String(s.kandidatId), { wunsch });
              meldenZeichnen();
            }
            /* 🔴 SCHEITERT DER NEUE WURF, BLEIBT DER ALTE STEHEN (Befund
               code-pruefer 13.10.2026, T2, BELEGT). `backendLauf()` räumt den
               gezeigten Entwurf ab, bevor die Antwort da ist — bei Kontingent
               voll (429) oder Überlastung stand die Bühne danach leer, der
               Knopf auf „Andruck erstellen", obwohl der Kunde ein fertiges
               Bild hatte. Eine offene Rückfrage (`.andruck__frei`) ist kein
               Scheitern und bleibt stehen. */
            if (s.kandidatId || s.phase === 'laeuft'
                || document.querySelector('.andruck__frei')) return;
            /* 🔴 NUR, WENN DAS FORMULAR NOCH DIESEN ENTWURF TRÄGT (Befund
               code-pruefer R2, 13.10.2026, T2, BELEGT). Die Felder bleiben
               während des Laufs bedienbar; wer dabei tippt und dann scheitert,
               bekam sonst das ALTE Bild mit dem NEUEN Text in den Warenkorb
               („zwei Hüllen", nur für den Kunden sichtbar). Weicht der Text
               ab, bleibt die Bühne leer wie vor der Rückholung — der Kunde
               bestellt dann über einen neuen Andruck oder die Entwurfs-Kachel. */
            const zurueck = historieLesen().find((x) => x.id === kandidatId);
            sammleBrief();
            if (!zurueck || briefSchluessel(s.brief) !== zurueck.schluessel) return;
            const maske = document.querySelector('[data-andruck-fehler]');
            historieWaehlen(kandidatId, { formularSetzen: false });
            /* Die Fehlermaske sagt dem Kunden, WARUM nichts Neues kam —
               `historieWaehlen` räumt sie mit ab, also zurück auf die Bühne.
               Ohne ihren „Noch einmal versuchen"-Knopf: der klickt den
               Hauptknopf, und der heißt jetzt „In den Warenkorb". */
            if (maske) {
              maske.querySelector('[data-maske-nochmal]')?.remove();
              document.querySelector('[data-tafel="blatt"] .buehne__flaeche')
                ?.appendChild(maske);
            }
          });
        };
        if (mitWunsch) return nochmal(String(text).trim().slice(0, WUNSCH_MAX));
        panel.querySelector('[data-nochmal-los]').addEventListener('click', () => nochmal(null));
        return;
      }
      /* Hinweis → Felder (21.10.2026): sofort übersetzen und zeichnen, ohne Danke-Kasten
         (Sascha, 21.10.2026 abends). Kein „Ohne Hinweis noch einmal" — ein Zufallswurf
         ist dort ungemessen, beim Zitat und bei der Strecke wäre er dasselbe Blatt. */
      if (!zweiteStufe && hinweisMoeglich() && String(text || '').trim() !== ''
          && s.kandidatId === kandidatId && s.phase === 'fertig') {
        panel.innerHTML = '<p class="melden__danke">Angekommen – wir schauen, was sich '
          + 'ändern lässt …</p>';
        hinweisUebersetzen(panel, kandidatId, kategorie,
          String(text).trim().slice(0, HINWEIS_MAX));
        return;
      }
      // Nur DIESES Panel — nicht das, was in 6 s zufällig offen ist.
      window.setTimeout(() => meldenPanelVerbergen(panel), 6000);
    } catch (e) {
      senden.disabled = false;
      senden.textContent = knopfText;
      fehler.textContent = e && e.benannt
        ? e.benannt
        : 'Das kam nicht durch – bitte noch einmal versuchen.';
      fehler.hidden = false;
      console.error(e);
    }
  }

  /* ================================================================== Warenkorb */

  /* KONFLIKT 4 — /cart/add.js mit properties[], nicht Storefront cartCreate.
     On-domain erzeugt cartCreate einen zweiten Warenkorb-Token neben dem des
     Themes: der Kunde legt etwas in einen Korb, den der Header nicht zählt.
     /cart/add.js trägt Line-Item-Properties von Haus aus und es bleibt bei
     einem Warenkorb. Der Checkout bleibt der native Shopify-Checkout. */
  async function inDenWarenkorb() {
    /* Ein laufendes Umzeichnen (Chronik) zuerst abwarten — danach steht der
       Kandidat, dessen Bild der Kunde gerade sieht. */
    if (umzeichnenOffen) {
      /* 🔴 Ein zweiter Klick während des Wartens legte das Poster zweimal in
         den Korb (code-pruefer 16.10.2026, T2): der Knopf wird erst weiter
         unten gesperrt. Ab hier läuft der Rest ohne `await` bis zur Sperre. */
      if (warenkorbWartet) return;
      warenkorbWartet = true;
      try { await umzeichnenOffen; } finally { warenkorbWartet = false; }
    }
    const v = findeVariante();
    const fehler = $('[data-fehler]');
    const zeigeFehler = (txt) => {
      if (!fehler) return;
      fehler.textContent = txt;
      fehler.hidden = false;
    };
    if (fehler) fehler.hidden = true;

    if (!v) return zeigeFehler('Diese Kombination gibt es nicht. Bitte Format oder Ausführung ändern.');
    /* ⏪ 15.08.2026: hier stand die Pflichtprüfung des Häkchens. Es gibt kein
       Häkchen mehr (Saschas Entscheidung B) — geschuldet ist die INFORMATION,
       nicht eine Zustimmung, und die steht sichtbar über diesem Knopf.
       Der Beleg entsteht jetzt beim Absenden statt beim Anklicken. */

    /* Auf dem echten Pfad gibt es keinen Warenkorb ohne eingefrorenen
       Kandidaten — die _kandidat_id ist die Zuordnung Render↔Zeile, und
       das Fulfillment druckt exakt diese Datei. */
    if (livePfad() && !s.kandidatId) {
      return zeigeFehler('Bitte zuerst einen Andruck erstellen – gedruckt wird genau das Bild, das du gesehen hast.');
    }
    /* Haustier: ohne gesetzte Fassung weiß der Druck nicht, welche Machart,
       Farbe und Texte bestellt sind (`fulfillment._haustier_druck` hält an). */
    if (livePfad() && istSatzH1() && !s.haustierSatz) {
      return zeigeFehler('Bitte prüfe kurz deine Angaben – die Vorschau ist noch nicht aktuell.');
    }
    /* Strecke: ohne gesetzte Fassung weiß der Druck nicht, welche Zeit und
       welche Zeilen bestellt sind (`fulfillment._strecke_druck` hält an). */
    if (livePfad() && istStrecke() && !s.streckeSatz) {
      return zeigeFehler('Bitte prüfe kurz deine Angaben – die Vorschau ist noch nicht aktuell.');
    }
    /* Gesetzte Texte im Formular, die das Blatt nicht trägt (Neu-Setzen abgelehnt). */
    if (livePfad() && textSatzAktiv() && s.textSatzFehlt) {
      return zeigeFehler('Bitte prüfe kurz deine Texte – die Vorschau ist noch nicht aktuell.');
    }
    /* Rezept: derselbe Riegel (`fulfillment._rezept_druck` hält ohne Satz an). */
    if (livePfad() && istRezept() && !s.rezeptSatz) {
      return zeigeFehler('Bitte prüfe kurz deine Angaben – die Vorschau ist noch nicht aktuell.');
    }

    sammleBrief();

    /* BEWEISLAST (03.08.2026): Beim Ausschluss des Widerrufsrechts nach
       § 312g Abs. 2 Nr. 1 BGB trägt der VERKÄUFER die Beweislast. Belegt
       werden müssen zwei Dinge, und beide nur hier, nie später:
         1. dass der Kunde eigene Eingaben gemacht hat  → 'Namen', 'Sechs Dinge'
         2. dass er vorher belehrt wurde                → die drei Felder unten
       Festgehalten wird der WORTLAUT, den der Kunde gesehen hat — nicht ein
       Flag. Ein 'true' beweist nichts darüber, worauf es sich bezog, und der
       Text kann sich zwischen Bestellungen ändern. */
    const hinweisWortlaut = $('[data-widerruf-block]')
      ?.textContent.replace(/\s+/g, ' ').trim() || '';

    /* Properties mit führendem Unterstrich sind für den Kunden unsichtbar,
       stehen aber auf der Order — dort hängt die Zuordnung Render↔Zeile dran.
       Die sichtbaren Felder kommen aus dem Brief des Konzepts, nicht mehr
       fest aus A1 (09.08.2026). ⚠️ Titel/Unterzeile: bei C1 druckt das
       Fulfillment die EINGEFRORENE Meta-Typo, nicht diese Properties —
       die hier sind Beleg und Bestellbestätigung. */
    const properties = { 'Motiv': D.produkt.titel };
    briefDef().felder.forEach((f) => {
      /* `warenkorb: false` (Rezept, 17.10.2026): Zutaten, Zubereitung und
         Lexikon-Texte wären eine Bestellzeile von über 1.000 Zeichen.
         Gedruckt wird der Schnappschuss, nicht die Property. */
      if (f.warenkorb === false || f.typ === 'karte') return;
      /* Ausgeblendete Felder (andere Machart) stehen nicht auf dem Blatt. */
      if (f.nurWenn && briefHalter()?.querySelector(`[data-brieffeld-halter="${f.name}"]`)?.hidden
          && istRezept()) return;
      if (f.typ === 'namen') {
        if (s.brief.namen) properties['Namen'] = s.brief.namen;
      } else if (f.typ === 'liste') {
        const werte = s.brief[f.name] || [];
        if (werte.length) properties[f.label] = werte.join(' · ');
        const jahre = s.brief[f.name + '_jahre'] || [];
        if (f.jahr && jahre.some(Boolean)) properties['Jahre'] = jahre.join(' · ');
        const marken = s.brief[f.name + '_marken'] || [];
        const markenText = { ring: 'Punkt', haus: 'Zuhause', herz: 'Reise' };
        if (f.marke && marken.length) {
          properties['Markierung'] = marken.map((m) => markenText[m] || 'Punkt').join(' · ');
        }
        /* ⏪ Die Property »Farbträger« ist am 15.08.2026 entfallen — sie
           trug eine Bestellung, die es nicht mehr gibt. Welches Ding die
           Farbe trägt, steht in der Zeile des Kunden selbst. */
      } else if (f.typ === 'foto' || f.typ === 'gpx' || f.typ === 'ortsfoto' || f.typ === 'paarfoto') {
        /* Das Foto selbst reist nicht in die Bestellzeile — es liegt im
           Store, und die Kandidaten-Meta nennt es (`haustier.foto_id`).
           Dasselbe für die GPX-Datei: der Kandidat trägt ihre Linie selbst. */
      } else if ((f.typ === 'chips' || f.typ === 'stil' || f.typ === 'marker')
                 && s.brief[f.name]) {
        /* In der Bestellbestätigung steht das LABEL des Chips, nicht die
           interne ID — „Look: Farbig", nicht „Wie es aussehen soll: kontrolle". */
        const o = (f.optionen || []).find((x) => x.id === s.brief[f.name]);
        properties[f.property || f.label] = o ? o.label : s.brief[f.name];
      } else if (f.typ === 'farbmarker' && s.brief.look) {
        /* Der Marker ist EIN Bedienelement und wird als EINE Zeile bestellt.
           Zwei Zeilen („Look: aussparung" / „Grundton: petrol") wären für den
           Kunden zwei Angaben über eine Wahl, die er als eine getroffen hat —
           und „aussparung" ist ohnehin kein Wort der Bestellbestätigung.
           ⚠️ Der BRIEF ans Backend bleibt zweiteilig; das hier ist die
           Bestellzeile, nicht der Prompt. */
        const ton = s.brief[f.tonFeld] || '';
        const id = s.brief.look === 'kontrolle' ? 'kontrolle' : `${s.brief.look}:${ton}`;
        const o = (f.optionen || []).find((x) => x.id === id);
        properties[f.property || f.label] = o ? o.label : id;
      } else if (f.typ === 'marker-solo' && s.brief[f.name]) {
        const o = LISTE_B().find((x) => x.id === s.brief[f.name]);
        properties[f.property || f.label] = o ? o.label : s.brief[f.name];
      } else if (s.brief[f.name]) {
        properties[f.property || f.label] = s.brief[f.name];
      }
    });
    if (optikSichtbar()) {
      Object.assign(properties, {
        'Look': s.look, 'Grundton': s.grund, 'Akzent': s.akzent,
      });
    }
    /* Farbachse: der Ton, den der Kunde ZULETZT gesehen hat — `fulfillment`
       liest »Farbe« und wendet dieselbe Operation am Druck an. Nur, wenn er
       vom bestellten abweicht; sonst bleibt die Zeile schlank. */
    if (tonSichtbar() && s.ton && s.ton !== s.kandidatTon) {
      const t = LISTE_B().find((x) => x.id === s.ton);
      properties['Farbe'] = t ? t.label : s.ton;
      /* Die ID zusätzlich versteckt — der Warenkorb baut daraus den Rückweg
         `?entwurf=…&ton=…`, damit die PDP denselben Ton zeigt wie die Zeile. */
      properties['_ton'] = s.ton;
    }

    /* 🔴 DER RAND REIST GETRENNT, und das ist der Kern der Reparatur vom
       19.08.2026. Bis hierher hing er an `optikSichtbar()` — also an einer
       Hülle, die für alle vier Konzepte aus ist. Die Property ging damit NIE
       mit, und selbst wenn: das Fulfillment las sie nicht. Beides ist jetzt
       gebaut (`postergen.steg_anlegen`, `fulfillment.druckdatei_bauen`).
       ⚠️ Sie geht nur mit, wenn der Kunde die Wahl auch HATTE. Bei
       Orts-Print steht kein Regler, und eine Property „Rand: randlos" würde
       dort eine Wahl behaupten, die es nicht gab — im Fulfillment ist das
       ohnehin der Default. */
    if (randSichtbar()) properties['Rand'] = s.rand;
    /* Haustier: der Satz-Schnappschuss, den die Bühne zeigt — der Druck setzt
       GENAU ihn neu (`fulfillment._haustier_druck`). Ohne ihn hält der Druck an. */
    if (istSatzH1() && s.haustierSatz) properties['_haustier_satz'] = s.haustierSatz;
    /* Rezept: der Satz-Schnappschuss, den die Bühne zeigt (`_rezept_druck`). */
    if (istRezept() && s.rezeptSatz) properties['_rezept_satz'] = s.rezeptSatz;
    /* Strecke: dasselbe Muster — der Druck zeichnet GENAU diesen Satz neu
       (`fulfillment._strecke_druck`). Ohne ihn hält der Druck an. */
    if (istStrecke() && s.streckeSatz) properties['_strecke_satz'] = s.streckeSatz;
    if (s.kandidat && s.kandidat.unterzeile) properties['Unterzeile'] = s.kandidat.unterzeile;
    /* Vorgemerkter Wunsch zu GENAU diesem Entwurf (Saschas »B«, 29.10.2026) — die Druckstraße erkennt ihn am
       Namen »Änderungswunsch« und hält die Kunden-Freigabe an, bis Sascha ihn eingearbeitet hat. */
    const wunsch = VORMERK.get(String(s.kandidatId || ''));
    /* Nur, was der Kunde gerade sehen kann: ohne Box (Gelb) geht kein früher gemerkter Wunsch unsichtbar mit. */
    if (wunsch && vormerkenMoeglich()) properties['Änderungswunsch'] = wunsch;
    /* Symbol-Raster: geänderte Beschriftungen stehen in der Bestellzeile — gedruckt wird ohnehin die Meta des
       Entwurfs, aber „Deine Symbole“ allein trüge dann Texte, die nicht auf dem Blatt stehen. */
    const bs = s.brief.beschriftungen;
    if (D.produkt.handle === 'icon-grid' && Array.isArray(bs)
        && JSON.stringify(bs) !== JSON.stringify(s.brief.momente || [])) {
      properties['Beschriftungen'] = bs.join(' · ');
    }
    /* Eine simulierte ID ist KEIN Kandidat: als _kandidat_id gesendet sähe
       das Fulfillment eine personalisierte Zeile mit fehlendem Render und
       bräche nach der Zahlung ab. Die Zeile trägt stattdessen die
       Unterstrich-Property _andruck — für den Kunden unsichtbar (wie alle
       _-Properties), in der Admin-Order lesbar — bis alle Konzepte den
       Live-Pfad haben. Für LIVE_HANDLES ohne Backend greift zusätzlich der
       harte Halt in aktionZeichnen: dort entsteht gar kein Andruck. */
    const echterKandidat = s.kandidatId && !s.kandidatId.startsWith('sim_');
    /* 🔴 DAS BILD, DAS DER KUNDE ZULETZT GESEHEN HAT, reist als URL mit
       (22.09.2026, Sascha: der Warenkorb zeigte das Hero-Bild statt des
       eigenen Andrucks). `main-cart-items.liquid` liest `_vorschau_url` als
       Zeilenbild. Genommen wird die Bühne selbst, nicht `kandidat.vorschau_url`
       — nach einem Ton-Wechsel zeigt die Bühne `ton.png`, und genau das soll
       im Korb stehen. Nur bei einem echten Kandidaten; sonst gäbe es ein
       Beispielbild als Beleg. */
    const buehnenBild = document.querySelector('[data-tafel="blatt"] .buehne__bild');
    if (echterKandidat && buehnenBild && /^https?:/.test(buehnenBild.src)) {
      properties['_vorschau_url'] = mitRahmenParameter(buehnenBild.src);
    }
    Object.assign(properties, {
      '_kandidat_id': echterKandidat ? s.kandidatId : '',
      ...(echterKandidat ? {} : { '_andruck': 'simuliert – kein eingefrorener Render' }),
      '_konzept_handle': D.produkt.handle,
      /* 🔴 `_widerruf_hinweis_gezeigt`, NICHT mehr `_widerruf_bestaetigt`
         (15.08.2026). Es bestätigt niemand mehr etwas — ein Feld namens
         „bestätigt" auf einer Bestellung, bei der nichts bestätigt wurde,
         wäre ein falscher Eintrag im eigenen Beweismittel. Und ein
         Beweismittel, das an einer Stelle nicht stimmt, taugt an keiner.
         ⚠️ Umbenennung ist folgenlos: der Shop hat null Bestellungen
         (Checkliste 7g, `ordersCount 0`), es gibt keine Altdaten mit dem
         alten Namen. `fulfillment.py` ist mitgezogen. */
      '_widerruf_hinweis_gezeigt': new Date().toISOString(),
      '_widerruf_wortlaut': hinweisWortlaut,
    });

    if (BESTELLMODUS) return fassungNehmen(properties);

    const knopf = $('[data-aktion]');
    if (knopf) { knopf.disabled = true; knopf.textContent = 'Wird hinzugefügt …'; }

    try {
      const antwort = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties }] }),
      });

      if (!antwort.ok) {
        const f = await antwort.json().catch(() => ({}));
        throw new Error(f.description || f.message || 'Der Warenkorb hat die Zeile abgelehnt.');
      }

      auswahlMelden('warenkorb');
      /* Entwurfs-Vorteil (21.10.2026): beide Codes in den Warenkorb, über die
         offizielle Cart-API (`/cart/update.js`, `discount` mit Komma — mehrere
         Codes per URL sind laut Shopify-Forum unzuverlässig). Scheitert das,
         geht es trotzdem zum Warenkorb: der Kaufweg wartet nie auf den Rabatt. */
      const vt = echterKandidat ? vorteilFuer(s.kandidatId) : null;
      if (vt) {
        try {
          await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: vt.codes.join(',') }),
          });
        } catch { /* nie den Warenkorb aufhalten */ }
      }

      /* 🔴 KASSENBILD ANSTOSSEN, NICHT ABWARTEN (01.10.2026). Shopify braucht
         3–11 s, bis unser Bild auf cdn.shopify.com liegt (nur von dort zeigt
         die Kasse es). `keepalive` lässt die Anfrage den Seitenwechsel
         überleben; abgeholt und an der Zeile nachgetragen wird auf der
         Warenkorbseite (`echoa-kassenbild.js`). text/plain → kein CORS-
         Vorabruf, der bei keepalive nicht überall erlaubt ist. */
      if (properties['_vorschau_url'] && BACKEND) {
        try {
          fetch(`${BACKEND}/api/kassenbild`, {
            method: 'POST', keepalive: true,
            headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
            body: JSON.stringify({ url: properties['_vorschau_url'] }),
          }).catch(() => {});
        } catch { /* nie den Warenkorb aufhalten */ }
      }

      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    } catch (e) {
      zeigeFehler(e.message);
      if (knopf) { knopf.disabled = false; aktionZeichnen(v); }
    }
  }

  /* ============================================== Entwürfe der Sitzung (15.08.2026)

     🔴 WOZU, und es ist ein DEFEKT gewesen, kein fehlendes Feature:
     `eingabeGeaendert()` setzt `s.kandidatId = null`, sobald der Kunde ein
     Zeichen tippt. Der Kandidat selbst liegt weiter auf dem Backend (90 Tage,
     `cloud/aufraeumen.py`) und ist über `/api/kandidat/<id>/vorschau.png`
     erreichbar — verloren ging allein der Zeiger darauf. Wer umformulierte
     und dann merkte, dass die erste Fassung besser war, konnte nur neu
     rendern: 0,96 $, und die API hat keinen Seed, das Bild kam also NIE
     zurück.

     🔴 SESSIONSTORAGE, NICHT LOCALSTORAGE — und das ist die Bestellung:
     „akut temporär … in seiner aktuellen Session". Der Speicher stirbt mit
     dem Tab. Die dauerhafte Aufbewahrung („für später", 14 Tage) ist eine
     ANDERE Sache mit einem Abholweg und einer eigenen Entscheidung; sie hier
     mitzubauen hieße, eine Zusage zu machen, die dieser Speicher nicht hält.

     🔴 DER BRIEF WANDERT MIT. Ohne ihn zeigte die Bühne Entwurf A, während
     die Bestellzeile die Eingaben von B trüge — dieselbe Klasse wie „zwei
     Hüllen" (`rules/architektur.md`), nur diesmal für den Kunden sichtbar und
     auf gedruckter Ware. Beim Zurückspringen wird deshalb das FORMULAR
     mitgesetzt, nicht nur das Bild.

     ⚠️ PDP-ÜBERGREIFEND, aber nicht durch Magie: Einträge fremder Konzepte
     werden als LINK auf ihre eigene PDP gezeigt (`?entwurf=<id>`), nicht hier
     eingesetzt. Ein Konzept hat andere Felder — einen A5-Brief in ein
     A1-Formular zu schreiben ergäbe eine halb gefüllte Maske. */

  const HIST_KEY = 'echoa:entwuerfe';
  /* 🔴 GELTUNGSBEREICH DER ZAHL: wie viele Entwürfe die SITZUNG vorhält.
     JA für: zwei bis drei Fassungen vergleichen, über mehrere Konzepte.
     NEIN als Aussage über die Aufbewahrung auf dem Backend (90 Tage) und NEIN
     für die dauerhafte Speicherung. Kalibriert an der Bestellung („zwischen
     seinem letzten und diesem Entwurf") plus Luft; gespeichert werden IDs und
     Kurztexte, kein Bild, die 5-MB-Grenze ist damit weit weg.
     n=1 — würde die Zahl je erreicht, wäre der richtige Zug ein sichtbarer
     Verlauf, keine höhere Zahl. */
  const ENTWURF_HISTORIE_MAX = 6;
  /* ⏪ Bis 22.10.2026 sessionStorage (Saschas Entscheidung 15.08.2026; ein localStorage-Versuch am
     19.10. wurde als T1 zurückgenommen). Sascha am 22.10. abends: „Das System warnt, dass das
     Limit erreicht ist … ich konnte aber nirgendwo auf den PDPs meine Entwürfe auswählen … Sie
     sollten auf jeder PDP nahe des Andruck-Buttons klar ersichtlich sein." Das Tageslimit gilt je
     Browser (`sitzungsKennung`, localStorage), die Liste galt nur je Tab — in einem neuen Tab kam
     die Meldung ohne Entwürfe. Jetzt localStorage, aber nur 72 Stunden (so lange gilt auch der
     Vorteil; das Backend hält nicht bestellte Kandidaten 14 Tage, `aufraeumen.py` FRIST_TAGE —
     eine Kachel zeigt also nie ins Leere). Schalter zurück: `HISTORIE_72H = false`. */
  const HISTORIE_72H = true;
  /* 30.10.2026: 14 statt 3 Tage (Sascha über die Anzeigen-Session: „Dein Entwurf hängt noch nicht an der Wand“
     soll beim Wiederkommen den Entwurf zeigen). Nicht 30: das Backend löscht nicht bestellte Entwürfe nach
     14 Tagen (`cloud/aufraeumen.py` FRIST_TAGE), und die Datenschutzerklärung nennt 14 Tage — länger hieße eine
     Kachel ins Leere und ein anderer Rechtstext. Der Name `HISTORIE_72H` bleibt der Schalter. */
  const HISTORIE_FRIST_MS = 14 * 24 * 3600 * 1000;

  /* --- Meta-Ereignis „Entwurf“ (Sascha, 30.10.2026: „Event "Entwurf" zu Meta … Direkt mit angehen“) ----------
     Nach jedem fertigen Andruck EIN Ereignis je Entwurf an das Meta-Pixel, damit Meta eine Zielgruppe
     „Entwurf, nicht gekauft“ bilden kann. Nur mit Einwilligung in Marketing (Shopify-Banner,
     `customerPrivacy.marketingAllowed`), sonst nichts — auch kein Laden von Metas Skript.
     Warum im Theme statt über die Shopify-App: die Facebook-App reicht nur Standard-Ereignisse weiter,
     keine eigenen (recherchiert 30.10.2026). `autoConfig` aus und kein `PageView`: die App zählt Seiten
     schon selbst, hier geht nur „Entwurf“ raus. `eventID` je Entwurf, damit ein späteres Server-Ereignis
     (Conversions API) dedupliziert werden kann. */
  const META_PIXEL_ID = '1411449484223774';
  function metaMarketingErlaubt(fertig) {
    try {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function') return fertig(Boolean(cp.marketingAllowed()));
      if (window.Shopify && window.Shopify.loadFeatures) {
        return window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (fehler) => {
          const c = window.Shopify.customerPrivacy;
          fertig(!fehler && Boolean(c && c.marketingAllowed && c.marketingAllowed()));
        });
      }
    } catch { /* ohne Banner-Schnittstelle: keine Einwilligung */ }
    return fertig(false);
  }
  function metaEntwurf(kid) {
    if (!kid || String(kid).startsWith('sim_') || BESTELLMODUS) return;
    const merk = 'echoa:meta-entwurf';
    let schon = [];
    try { schon = JSON.parse(window.sessionStorage.getItem(merk) || '[]'); } catch { schon = []; }
    if (schon.includes(String(kid))) return;
    metaMarketingErlaubt((ja) => {
      if (!ja) return;
      try {
        if (!window.fbq) {
          /* Metas Grundcode (gekürzt, unverändert in der Wirkung) */
          const f = window.fbq = function () { f.callMethod ? f.callMethod.apply(f, arguments) : f.queue.push(arguments); };
          if (!window._fbq) window._fbq = f;
          f.push = f; f.loaded = true; f.version = '2.0'; f.queue = [];
          /* Sonst schickt Metas Skript nach dem ersten Ereignis bei jedem Adresswechsel (Ort ⇄ Moment,
             `history.replaceState`) ein eigenes PageView — die zählt die Shopify-App schon (code-pruefer
             30.10.2026, im Browser nachgestellt). */
          f.disablePushState = true;
          const t = document.createElement('script'); t.async = true; t.src = 'https://connect.facebook.net/en_US/fbevents.js';
          document.head.appendChild(t);
          window.fbq('set', 'autoConfig', false, META_PIXEL_ID);
          window.fbq('init', META_PIXEL_ID);
        }
        window.fbq('trackCustom', 'Entwurf', { konzept: D.produkt.handle }, { eventID: `entwurf-${kid}` });
        schon.push(String(kid));
        /* 30: frei gewählter Deckel gegen Wachstum, keine Messung dahinter. */
        try { window.sessionStorage.setItem(merk, JSON.stringify(schon.slice(-30))); } catch { /* egal */ }
      } catch { /* Messung darf den Konfigurator nie stören */ }
    });
  }
  const histSpeicher = () => (HISTORIE_72H ? window.localStorage : window.sessionStorage);

  function historieLesen() {
    try {
      const roh = histSpeicher().getItem(HIST_KEY);
      const liste = roh ? JSON.parse(roh) : [];
      if (!Array.isArray(liste)) return [];
      if (!HISTORIE_72H) return liste;
      const jetzt = Date.now();
      /* Rückweg aus der Mail (`rueckweg`): nur 24 h — sein Entwurf kann schon fast 14 Tage alt
         sein, und das Backend löscht ihn nach 14 Tagen (code-pruefer 22.10.2026, VERMUTET). */
      const gueltig = liste.filter((e) => e && typeof e.zeit === 'number'
        && e.zeit > jetzt - (e.rueckweg ? 24 * 3600 * 1000 : HISTORIE_FRIST_MS));
      /* Abgelaufenes wirklich löschen, nicht nur ausblenden — der Brief (Namen, Erinnerungen)
         soll nicht länger auf dem Gerät liegen, als der Hilfesatz sagt (code-pruefer, BELEGT). */
      if (gueltig.length !== liste.length) historieSchreiben(gueltig);
      return gueltig;
    } catch { return []; }        /* Privater Modus, voller Speicher, kaputtes
                                     JSON: die Leiste ist ein Komfort und darf
                                     den Konfigurator nie mitreißen. */
  }

  function historieSchreiben(liste) {
    try {
      histSpeicher().setItem(HIST_KEY, JSON.stringify(liste));
    } catch { /* s. o. — stillschweigend ohne Historie weiterlaufen */ }
  }

  function historieMerken(kandidat, briefStand, antworten = null) {
    /* Eine simulierte ID ist KEIN Entwurf: sie zeigt auf kein Bild im Store,
       und ein Eintrag, der beim Anklicken ins Leere läuft, ist schlechter als
       keiner. Dieselbe Grenze wie bei `_kandidat_id` im Warenkorb. */
    if (!kandidat || !kandidat.id || String(kandidat.id).startsWith('sim_')) return;
    const liste = historieLesen().filter((e) => e.id !== kandidat.id);
    liste.unshift({
      id: kandidat.id,
      handle: D.produkt.handle,
      produkt: D.produkt.titel,
      vorschau: `${BACKEND}${kandidat.vorschau_url}`,
      unterzeile: kandidat.unterzeile || '',
      /* Haarfarbe am Pixel-Paar (27.10.2026): die Wahl je Figur, damit ein wieder geöffneter Entwurf sie markiert. */
      ...(kandidat.haar ? { haar: kandidat.haar } : {}),
      /* Symbol-Raster (29.10.2026): die gesetzten Beschriftungen, mit denen die Felder in „Bild anpassen“
         vorbelegt werden — auch nach dem Wiederöffnen über die Entwurfsleiste. */
      ...(Array.isArray(kandidat.beschriftungen) ? { beschriftungen: kandidat.beschriftungen } : {}),
      zeit: Date.now(),
      ...(kandidat.rueckweg ? { rueckweg: true } : {}),
      /* Gelb: woraus der Entwurf entstand (`von`, Rückweg) und welche Umwandlungen davor liefen (Detail-Grenze). */
      ...(kandidat.umwandlung && typeof kandidat.umwandlung === 'object' ? { umwandlung: kandidat.umwandlung } : {}),
      /* Die Rückfrage-Antworten, mit denen DIESER Entwurf entstand
         (Befund code-pruefer 13.10.2026, T2, BELEGT). `s.antworten` hängt am
         Formular, nicht am gezeigten Entwurf: „Noch einmal zeichnen" schickte
         nach einem Kachelwechsel die Antworten eines ANDEREN Entwurfs mit. */
      antworten: Array.isArray(antworten) ? antworten : [],
      /* 🔴 DER BRIEF-STAND VOM ABSENDEN, nicht der von jetzt (Hinweis
         `code-pruefer` 15.08.2026). Die Eingabefelder bleiben während der
         ~50 s Renderzeit bedienbar — wer in dieser Zeit tippt, hätte sonst
         einen Eintrag bekommen, der das ALTE Bild mit dem NEUEN Text
         zusammenspannt. Gedruckt würde dann etwas anderes, als auf der
         Kachel zu sehen ist.
         ⚠️ Das behebt die Divergenz IN DER HISTORIE. Dass der laufende
         Andruck selbst gegen einen inzwischen geänderten Brief anläuft, ist
         eine ältere, eigene Frage (Felder während `laeuft` sperren) und
         gehört nicht in diese Runde. */
      brief: mitBeschriftungen(briefStand || s.brief, kandidat),
      /* Der Fingerabdruck des Briefs — damit `eingabeGeaendert()` erkennt,
         dass der Kunde gerade auf einen Stand zurückgekehrt ist, der schon
         gerendert wurde. Siehe `briefSchluessel()`. */
      schluessel: briefSchluessel(briefStand || s.brief),
    });
    historieSchreiben(liste.slice(0, ENTWURF_HISTORIE_MAX));
    historieZeichnen();
  }

  /* --- Der Fingerabdruck eines Briefs ---------------------------------------
     🔴 WOZU, und es ist Saschas Bestellung vom 17.08.2026: „Nach Vorschau des
     Bildes sollte die Möglichkeit zum Switchen weiterhin bestehen, Bild ändert
     sich dann dynamisch (ohne Zusatzkosten)."

     Kostenlos ist der Wechsel für den KUNDEN — für uns ist er es nicht: der
     Look bestimmt den Prompt (`dienst.look_und_ton`), ein anderer Look ist ein
     neuer Bildlauf zu 0,96 $. Beide Looks vorzurendern hieße, die Renderkosten
     je Sitzung zu verdoppeln, und die stehen bereits mit 22–55 % über dem
     Werbebudget ([[echoa_akquise]]).

     Was hier stattdessen passiert: der zweite Look wird EINMAL gerendert und
     liegt danach in der Historie. Kehrt der Kunde zu einem Stand zurück, den
     er schon gesehen hat — und der Look-Wechsel hin und zurück ist genau das —,
     wird der alte Entwurf sofort wieder gezeigt, ohne Lauf und ohne Kosten.
     Ab dem zweiten Wechsel ist das Umschalten damit tatsächlich sofort.

     ⚠️ ÜBER DEN GANZEN BRIEF, nicht nur über den Look. Ein Schlüssel, der nur
     den Look vergliche, träfe auch dann, wenn der Kunde inzwischen seine
     Geschichte umgeschrieben hat — und zeigte ein Bild zum alten Text. Das ist
     die Divergenz, gegen die `historieMerken()` und `brief_stand` gebaut sind.
     Die Sortierung der Schlüssel gehört dazu: `JSON.stringify` folgt sonst der
     Einfügereihenfolge, und die hängt an der Feldreihenfolge des Konzepts. */
  /* 🔴 DIE ZWEI KIDS-ACHSEN GEHÖREN NICHT IN DEN FINGERABDRUCK (07.09.2026).
     Der Fingerabdruck beantwortet genau eine Frage: „wurde DIESER Brief schon
     gerendert?" Muster und Passepartout ändern den Render nicht — sie werden
     NACH ihm gesetzt, aus demselben Motiv. Stünden sie hier drin, würfe ein
     Klick auf „Karo" den fertigen, bezahlten Entwurf weg und verlangte einen
     neuen: aus zwölf kostenlosen Kombinationen würden zwölf bezahlte Renders,
     also 1,61 $ statt 0,134 $ je Kunde — exakt die Rechnung, gegen die die
     Achse gebaut ist.
     ⚠️ Wer eine dritte kostenlose Achse ergänzt, trägt sie hier ein. Fehlt sie,
     scheppert nichts: der Kunde bekommt still einen zweiten Render berechnet. */
  /* 🆕 20.10.2026: `hintergrund` (Wortschatz-Pop) — beim Linolschnitt eine
     kostenlose Achse; beim Abstrakt nimmt `briefSchluessel` ihn wieder in den
     Fingerabdruck (die Palette des Gegenstands hängt am Hintergrund). */
  const ACHSEN_FELDER = new Set(['muster', 'passepartout', 'farbwelt', 'hintergrund']);
  const achseImFingerabdruck = (brief, k) => k === 'hintergrund' && brief.look === 'abstrakt';

  function briefSchluessel(brief) {
    if (!brief) return '';
    try {
      /* Leere Strings zählen nicht (23.09.2026, am Dev-Proxy gemessen): der
         Theme-Brief trägt beim Kontroll-Look `tinte: ""`, der Brief aus
         `brief.json` (Warenkorb-Rückweg) das Feld gar nicht — derselbe Stand,
         zwei Fingerabdrücke, und „Zurück zu »50×70 cm«" fand den eigenen
         Andruck nicht wieder. */
      /* Haustier: Satz-Felder ändern den Render nicht (16.10.2026). */
      /* Rezept: Satz-Felder und die Herkunft der Karte ebenso (17.10.2026). */
      /* Gesetzte Texte (Pixel-Paar, Moment, Orts-Print, …) ebenso (21.10.2026). */
      const ohne = istSatzH1() ? HAUSTIER_SATZ_FELDER
        : (istStrecke() ? STRECKE_SATZ_FELDER
          : (istRezept() ? new Set([...REZEPT_SATZ_FELDER, 'karte_id'])
            : (textSatzAktiv() ? textSatzOhne(brief) : null)));
      return JSON.stringify(Object.keys(brief).sort()
        .filter((k) => (!ACHSEN_FELDER.has(k) || achseImFingerabdruck(brief, k))
          && brief[k] !== '' && !(ohne && ohne.has(k)))
        .map((k) => [k, brief[k]]));
    } catch { return ''; }
  }

  /** Dasselbe Blatt, andere Achse — ohne neuen Render und ohne neue Wartezeit.
      Der Aufruf kostet 0,00 $ und zählt nicht gegen die freien Vorschauen. */
  function achsenVorschau() {
    if (!s.kandidat || !s.kandidatId || !BACKEND) return false;
    const felder = new URLSearchParams();
    if (s.brief.muster) felder.set('muster', s.brief.muster);
    if (s.brief.passepartout) felder.set('passepartout', s.brief.passepartout);
    if (s.brief.farbwelt) felder.set('farbwelt', s.brief.farbwelt);
    if (s.brief.hintergrund && !achseImFingerabdruck(s.brief, 'hintergrund')) {
      felder.set('hintergrund', s.brief.hintergrund);
    }
    if (!felder.toString()) return false;
    vorschauSetzen(
      `${BACKEND}/api/kandidat/${s.kandidatId}/achsen.png?${felder}`);
    return true;
  }

  /* --- Chronik umzeichnen (16.10.2026) -------------------------------------
     Markierung je Ort (Punkt/Zuhause/Reise) und Verbindungslinien sind zwei
     Felder im Szenario der Karte. Nach dem Andruck zeichnet das Backend sie
     neu (`POST /api/kandidat/<id>/umzeichnen`, `dienst.a8_umzeichnen`) — als
     NEUER Kandidat, damit Warenkorb und Druck das Gezeigte nehmen.
     ⚠️ Scheitert der Aufruf (alter Dienst ohne Route → 404, Entwurf von vor
     Chronik v2 → 400, Netz), fällt der Konfigurator auf das bisherige
     Verhalten zurück: Andruck verworfen, neu erstellen. */
  /* 🆕 21.10.2026: Namen und Jahre am Ort sind gesetzte Schrift im Szenario — sie zeichnen
     ebenfalls um statt neu zu erstellen (Saschas Linie: gesetzt = kostenlos änderbar). */
  const KARTEN_FELDER = ['stationen_marken', 'verbindungslinien', 'name1', 'name2', 'namen',
    'stationen_jahre'];
  /* Wartezeit nach dem letzten Klick, bevor gezeichnet wird. JA gegen eine
     Serie von Aufrufen beim schnellen Durchklicken; NEIN als Ladezeit. */
  const UMZEICHNEN_VERZUG_MS = 350;
  let umzeichnenNr = 0;
  let umzeichnenUhr = null;
  /* Steht, solange ein Umzeichnen aussteht — `inDenWarenkorb()` wartet
     darauf, sonst ginge der ALTE Kandidat mit den NEUEN Angaben in den Korb. */
  let umzeichnenOffen = null;
  let umzeichnenErledigt = null;
  let warenkorbWartet = false;
  /* Höchstwartezeit einer Umzeichnen-Antwort. JA gegen eine hängende
     Verbindung, die sonst auch den Warenkorb festhielte (gemessen 3–5 s je
     Umzeichnen, plus Kaltstart); NEIN als erwartete Dauer. */
  const UMZEICHNEN_ABBRUCH_MS = 20000;

  function kartenSchluessel(brief) {
    if (!brief) return '';
    const b = { ...brief };
    KARTEN_FELDER.forEach((k) => delete b[k]);
    return briefSchluessel(b);
  }

  function chronikUmzeichnenMoeglich() {
    if (BAUTYP_JE_HANDLE[D.produkt.handle] !== 'a8' || !BACKEND) return false;
    if (!s.kandidatId || String(s.kandidatId).startsWith('sim_')) return false;
    /* Nur Markierung, Linien, Namen und Jahre dürfen sich gegenüber dem gezeigten
       Andruck geändert haben — neue oder andere Orte brauchen Stufe 1 (Geokodierung).
       ⏪ Bis 21.10.2026 auch Namen und Jahre. */
    return Boolean(s.kartenBasis) && kartenSchluessel(s.brief) === s.kartenBasis;
  }

  function tafelLaedt(an) {
    const tafel = document.querySelector('[data-tafel="blatt"]');
    if (!tafel) return;
    if (an) tafel.dataset.laedt = '';
    else delete tafel.dataset.laedt;
  }

  function umzeichnenAbschliessen() {
    if (umzeichnenErledigt) umzeichnenErledigt();
    umzeichnenOffen = null;
    umzeichnenErledigt = null;
    /* Ein Hinweis, der nur neu gesetzt wurde, gilt erst ab hier (`HINWEIS_OFFEN.satz`). */
    if (HINWEIS_OFFEN && HINWEIS_OFFEN.satz) { hinweisOffenPruefen(); geaendertZeichnen(); }
  }

  /** Ein ausstehendes Umzeichnen gilt nicht mehr (anderer Brief, anderer
      Entwurf). Seine Antwort wird verworfen. */
  function umzeichnenAbbrechen() {
    if (!umzeichnenOffen) return;
    umzeichnenNr += 1;
    clearTimeout(umzeichnenUhr);
    tafelLaedt(false);
    umzeichnenAbschliessen();
  }

  function chronikUmzeichnen() {
    if (!umzeichnenOffen) {
      umzeichnenOffen = new Promise((fertig) => { umzeichnenErledigt = fertig; });
    }
    /* Die Nummer zählt beim KLICK, nicht beim Absenden: eine Antwort, die
       eintrifft, während schon ein neuerer Klick wartet, ist überholt. */
    const nr = ++umzeichnenNr;
    /* Der Entwurf, an dem geklickt wurde — beim KLICK festgehalten, nicht beim
       Absenden (code-pruefer 16.10.2026, T2): sonst zeichnete der Timer einen
       inzwischen gewählten anderen Entwurf um. */
    const vonId = s.kandidatId;
    tafelLaedt(true);
    clearTimeout(umzeichnenUhr);
    umzeichnenUhr = setTimeout(() => umzeichnenSenden(nr, vonId), UMZEICHNEN_VERZUG_MS);
  }

  async function umzeichnenSenden(nr, vonId) {
    if (nr !== umzeichnenNr) return;
    const vorher = historieLesen().find((x) => x.id === vonId);
    const marken = s.brief.stationen_marken || [];
    const linien = s.brief.verbindungslinien === 'ja' ? 'ja' : 'nein';
    let k = null;
    const abbruch = new AbortController();
    const uhr = setTimeout(() => abbruch.abort(), UMZEICHNEN_ABBRUCH_MS);
    try {
      /* text/plain wie beim Daumen: kein CORS-Vorabruf, ein Umlauf weniger.
         `_umzeichnen()` liest den Körper als JSON, egal welcher Typ. */
      const r = await fetch(
        `${BACKEND}/api/kandidat/${encodeURIComponent(vonId)}/umzeichnen`, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify({ stationen: s.brief.stationen || [], marken, linien,
            texte: { name1: s.brief.name1 || '', name2: s.brief.name2 || '',
              stationen_jahre: s.brief.stationen_jahre || [] } }),
          signal: abbruch.signal,
        });
      if (r.ok) k = ((await r.json()).kandidaten || [])[0] || null;
    } catch (e) { console.error(e); }
    clearTimeout(uhr);
    if (nr !== umzeichnenNr) return;          // ein neuerer Klick wartet
    umzeichnenAbschliessen();
    if (s.kandidatId !== vonId || s.phase !== 'fertig') {
      tafelLaedt(false);
      return;
    }
    if (!k || !k.id) {
      tafelLaedt(false);
      andruckVerwerfen();
      return;
    }
    vormerkErben(vonId, k.id);
    s.kandidatId = k.id;
    s.kandidat = k;
    s.kandidatBild = `${BACKEND}${k.vorschau_url}`;
    /* Die Farbe gehört weiter zum Entwurf: das Backend zeichnet im Material
       des Vorgängers, ein inzwischen gewählter anderer Ton bleibt die
       `ton.png`-Ansicht darüber — wie beim Größenwechsel. */
    if (s.ton && tonSichtbar() && s.ton !== s.kandidatTon) tonVorschau();
    else vorschauSetzen(kandidatBildUrl(s.kandidatBild));
    /* Für die Kachel der Stand, den das BILD trägt: der Brief des Vorgängers
       mit der neuen Markierung — nicht der Formularstand, der eine andere
       Farbe tragen kann (das Backend legt denselben Brief ab). */
    const bildBrief = { ...((vorher && vorher.brief) || s.brief),
      stationen_marken: marken, verbindungslinien: linien,
      name1: s.brief.name1 || '', name2: s.brief.name2 || '', namen: s.brief.namen || '',
      stationen_jahre: s.brief.stationen_jahre || [] };
    historieMerken(k, bildBrief, (vorher && vorher.antworten) || null);
    /* Der Mail-Block hängt am Entwurf — ohne diese Zeile stünde „ist
       unterwegs" unter dem neuen Blatt, verschickt war das alte
       (code-pruefer 16.10.2026, T2). */
    speichernZeigen();
    zeichne();
  }

  /* --- Gesetzte Texte neu setzen (21.10.2026) -------------------------------
     Dasselbe Muster wie das Chronik-Umzeichnen: Verzug gegen Tippen, Nummer beim
     Anstoß, Entwurf beim Anstoß festgehalten; das Backend legt einen NEUEN Kandidaten
     ab (`/api/kandidat/<kid>/gaming` bzw. `/texte`, Tabelle `TEXT_SATZ`). Passt eine
     Angabe nicht (Name leer, zu lang fürs Blatt, Zeichen ohne Glyphe), bleibt der
     Entwurf stehen, die Meldung sagt warum, und der Warenkorb ist gesperrt, bis die
     Angaben passen (`s.textSatzFehlt`) — sonst trüge die Bestellzeile Texte, die das
     Blatt nicht zeigt. Ein Entwurf, der sich nicht neu setzen lässt (vor dem 21.10.2026,
     älterer Look, 404), gilt nicht mehr: „Andruck erstellen" zeichnet neu.
     ⏪ Bis 21.10.2026 abends nur fürs Pixel-Paar (`gamingSatzAnstossen`). */
  /** Trägt das Formular andere gesetzte Texte als der gezeigte Entwurf? Ohne Eintrag in der
      Historie: ja (lieber einmal zu viel setzen — das Backend legt dann denselben Text ab). */
  function textSatzGeaendert() {
    const e = historieLesen().find((x) => x.id === s.kandidatId);
    if (!e || !e.brief) return true;
    return textSatzFelder(s.brief).some((k) => satzWert(e.brief[k]) !== satzWert(s.brief[k]));
  }
  /* Höchstwartezeit EINES Text-Neusetzens. JA gegen eine hängende Verbindung; NEIN als
     erwartete Dauer. Eigene Grenze, weil Wortschatz und Zitat beim Setzen das Bild neu
     umfärben wie beim Andruck: gemessen 21.10.2026 lokal 7–12 s am Dienst, beim ersten Aufruf
     mit kalt geladenen Modulen 19–20 s bis zur Antwort — die 20 s des Chronik-Umzeichnens
     rissen dort knapp. */
  const TEXT_SATZ_ABBRUCH_MS = 45000;
  function textSatzAnstossen() {
    if (!umzeichnenOffen) {
      umzeichnenOffen = new Promise((fertig) => { umzeichnenErledigt = fertig; });
    }
    const nr = ++umzeichnenNr;
    const vonId = s.kandidatId;
    tafelLaedt(true);
    clearTimeout(umzeichnenUhr);
    umzeichnenUhr = setTimeout(() => textSatzSenden(nr, vonId), UMZEICHNEN_VERZUG_MS);
  }

  async function textSatzSenden(nr, vonId) {
    if (nr !== umzeichnenNr) return;
    const vorher = historieLesen().find((x) => x.id === vonId);
    const satz = {};
    textSatzFelder(s.brief).forEach((k) => { satz[k] = s.brief[k] || ''; });
    /* Trägt der gezeigte Entwurf schon genau diese Angaben (Tippfehler und Korrektur,
       Rückweg auf einen Entwurf), gibt es nichts zu setzen — kein neuer Kandidat. */
    const vb = (vorher && vorher.brief) || null;
    if (vb && Object.keys(satz).every((x) => satzWert(vb[x]) === satzWert(satz[x]))) {
      umzeichnenAbschliessen();
      tafelLaedt(false);
      if (s.textSatzFehlt) { s.textSatzFehlt = false; $('[data-fehler]')?.setAttribute('hidden', ''); }
      zeichne();
      return;
    }
    /* Pixel-Paar mit Farben am Bild: liegt genau dieser Stand schon als Entwurf vor, ihn zurückholen (0 €, kein
       Umfärben, kein 409) — wie es der Fingerabdruck tat, solange die Kleidungsfarben darin zählten. */
    /* Derselbe Riegel wie nach dem Senden: inzwischen läuft ein neuer Andruck oder ein anderer Entwurf steht da
       (code-pruefer 27.10.2026, Runde 2: „Noch einmal zeichnen" binnen 350 ms). */
    if (s.kandidatId !== vonId || s.phase !== 'fertig') {
      umzeichnenAbschliessen();
      tafelLaedt(false);
      return;
    }
    if (istGaming() && HAAR_UMFAERBEN_AN) {
      const genau = historieLesen().find((e) => e.id !== vonId && genauGezeichnet(e));
      if (genau) {
        umzeichnenAbschliessen();
        tafelLaedt(false);
        if (s.textSatzFehlt) { s.textSatzFehlt = false; $('[data-fehler]')?.setAttribute('hidden', ''); }
        /* Derselbe Stand wie ein früherer Entwurf — der Wunsch des gezeigten zieht mit (code-pruefer R2). Nur hier,
           nicht in `historieWaehlen` allgemein: ein bewusst gewählter anderer Entwurf ist ein anderes Bild. */
        vormerkErben(vonId, genau.id);
        historieWaehlen(genau.id, { formularSetzen: false });
        return;
      }
    }
    let k = null;
    let meldung = '';
    let status = 0;
    let neuZeichnen = false;
    const abbruch = new AbortController();
    const uhr = setTimeout(() => abbruch.abort(), TEXT_SATZ_ABBRUCH_MS);
    try {
      const r = await fetch(
        `${BACKEND}/api/kandidat/${encodeURIComponent(vonId)}/${TEXT_SATZ[D.produkt.handle].route}`, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify(satz),
          signal: abbruch.signal,
        });
      status = r.status;
      const j = await r.json().catch(() => ({}));
      if (r.ok) k = (j.kandidaten || [])[0] || null; else meldung = j.fehler || '';
      neuZeichnen = r.status === 409 && Boolean(j.neu_zeichnen);
    } catch (e) { console.error(e); }
    clearTimeout(uhr);
    if (nr !== umzeichnenNr) return;          // ein neuerer Wechsel wartet
    umzeichnenAbschliessen();
    tafelLaedt(false);
    if (s.kandidatId !== vonId || s.phase !== 'fertig') return;
    if (status === 404) {
      andruckVerwerfen();
      return;
    }
    /* 🆕 27.10.2026 (Pixel-Paar): eine Wahl, die sich am Entwurf nicht umfärben lässt — sie braucht ein neues Bild.
       Der Entwurf bleibt unter „Deine Entwürfe", die Meldung sagt warum, und „Andruck erstellen" zeichnet neu. */
    if (neuZeichnen) {
      andruckVerwerfen();
      zeigeMeldung(meldung);
      return;
    }
    if (!k || !k.id) {
      s.textSatzFehlt = true;
      zeigeMeldung(meldung || 'Das hat gerade nicht geklappt – bitte noch einmal versuchen.');
      zeichne();
      return;
    }
    s.textSatzFehlt = false;
    const fehler = $('[data-fehler]');
    if (fehler) fehler.hidden = true;
    farbenErben(vonId, k.id);
    /* Die Felder sind die Quelle dieses Entwurfs: sie gehören jetzt ihm, statt mit seinen (älteren)
       Werten neu gebaut zu werden — sonst ginge verloren, was während des Setzens getippt wurde. */
    const bBlock = $('[data-beschriftungen]');
    if (bBlock && bBlock.dataset.fuer === vonId && Array.isArray(satz.beschriftungen)) bBlock.dataset.fuer = k.id;
    s.kandidatId = k.id;
    s.kandidat = k;
    s.kandidatBild = `${BACKEND}${k.vorschau_url}`;
    /* 🔴 TON UND ACHSEN NACHZIEHEN (code-pruefer 21.10.2026, T2, BELEGT am Code): das
       Backend setzt die Vorschau mit Ton und Hintergrund/Passepartout AUS DER META, also
       vom Andruck. Ein danach gewählter Ton oder Hintergrund steht nur in der Bestellzeile —
       ohne diese Zeilen zeigte die Bühne Kobalt, gedruckt würde Pink. Kostet 0 $. */
    if (s.ton && tonSichtbar() && s.ton !== s.kandidatTon) tonVorschau();
    else if (!achsenVorschau()) vorschauSetzen(kandidatBildUrl(s.kandidatBild));
    historieMerken(k, { ...((vorher && vorher.brief) || s.brief), ...satz,
      ...('name1' in satz ? { namen: [satz.name1, satz.name2].filter(Boolean).join(' & ') } : {}) },
    (vorher && vorher.antworten) || null);
    speichernZeigen();
    zeichne();
  }

  /* --- Haarfarbe am Entwurf umschalten (Pixel-Paar, 27.10.2026) -------------
     Je Figur eine Reihe Farbfelder unter dem Entwurf. Ein Tipp schickt die gesetzten Texte des Entwurfs plus
     `haar1`/`haar2` an denselben Satz-Weg wie ein Namenswechsel — das Ergebnis ist ein NEUER Entwurf (die Druckvorlage
     des alten bleibt unverändert). Die Wahl steht NICHT in `s.brief`: der Fingerabdruck des Briefs verwürfe sonst den
     Entwurf, und ein späterer Namenswechsel behält sie ohnehin, weil der Dienst sie im Brief des Entwurfs führt.
     Gezählt wird über `umzeichnenNr` wie beim Text-Satz — der jüngste Wechsel gewinnt, der Warenkorb wartet. */
  const haarGesperrt = {};            // `${kid}:${figur}` → true, wenn der Dienst die Figur nicht umfärben kann
  /* Die gewünschte Wahl BEIDER Figuren, festgehalten ab dem ersten Tipp auf einem Entwurf. Ein zweiter Tipp, während
     der erste noch läuft, schickt beide Wünsche mit — sonst startete er beim alten Entwurf ohne den ersten und Figur 1
     spränge zurück (code-pruefer 27.10.2026). */
  let haarWunsch = { fuer: null, 1: '', 2: '' };
  /** Die Wahl, die der GEZEIGTE Entwurf trägt: aus der Dienst-Antwort oder — nach dem Wiederöffnen über die
      Entwurfsleiste, wo `s.kandidat` sie nicht hat — aus der Historie (code-pruefer 27.10.2026). */
  function haarDesEntwurfs() {
    const e = historieLesen().find((x) => x.id === s.kandidatId);
    return (s.kandidat && s.kandidat.haar) || (e && e.haar) || {};
  }
  function haarMoeglich() {
    return HAAR_UMFAERBEN_AN && istGaming() && Boolean(BACKEND) && s.phase === 'fertig' && s.kandidatId
      && !String(s.kandidatId).startsWith('sim_');
  }
  /** Eine Figur unter Mütze/Cap oder mit Glatze hat kein sichtbares Haar zum Umfärben. */
  function haarFigurOffen(p) {
    const b = s.brief || {};
    return (b[`p${p}_muetze`] || 'nein') === 'nein' && b[`p${p}_frisur`] !== 'glatze'
      && !haarGesperrt[`${s.kandidatId}:${p}`];
  }
  /* Was der Dienst an DIESEM Entwurf sofort umfärben kann (`/api/kandidat/<kid>/farben.json`): kid → {1: [teil …],
     2: […]}, 'laedt' oder 'fehler'. Nur dafür gibt es Farbfelder; alles andere steht unter „Mehr ändern". */
  const farbenStand = {};
  async function farbenLaden(kid) {
    if (farbenStand[kid]) return;
    farbenStand[kid] = 'laedt';
    try {
      const r = await fetch(`${BACKEND}/api/kandidat/${encodeURIComponent(kid)}/farben.json`);
      farbenStand[kid] = r.ok ? await r.json() : 'fehler';
    } catch { farbenStand[kid] = 'fehler'; }
    if (s.kandidatId === kid) haarZeichnen();
  }
  /* Ein neuer Entwurf aus einem Wechsel trägt dieselbe Maske — er erbt den Stand seines Vorgängers. */
  function farbenErben(vonId, nachId) {
    if (farbenStand[vonId] && typeof farbenStand[vonId] === 'object') farbenStand[nachId] = farbenStand[vonId];
    vormerkErben(vonId, nachId);
  }
  /** Ein kostenloses Neu-Setzen (Text, Farbe, Chronik) erzeugt einen NEUEN Entwurf — der Wunsch für nach der
      Bestellung zieht mit, sonst stünde die Box leer und der Warenkorb trüge keinen »Änderungswunsch«
      (code-pruefer 30.10.2026, BELEGT; bestand schon im Pillen-Panel). Ein eigener Wunsch des Nachfolgers bleibt. */
  function vormerkErben(vonId, nachId) {
    const w = VORMERK.get(String(vonId || ''));
    if (w && !VORMERK.has(String(nachId || ''))) vormerkenSetzen(nachId, w);
  }
  const AM_BILD_TEILE = [['haar', 'Haare'], ['oberteil', 'Oberteil'], ['unterteil', 'Hose/Rock']];
  const AM_BILD_FELD = { oberteil: 'oberteil', unterteil: 'unterteilfarbe' };
  function amBildPunkte(teil) {
    const g = gamingAuswahl();
    return { oberteil: g.oberteile, unterteil: g.unterteilfarben }[teil] || [];
  }
  function umfaerbbar(p, teil) {
    const st = farbenStand[s.kandidatId];
    if (!st || typeof st !== 'object') return false;
    if (teil === 'haar' && !haarFigurOffen(p)) return false;
    return (st[p] || []).includes(teil);
  }
  /** Das Klappmenü „Farben am Bild ändern" unter dem Entwurf (Pixel-Paar): je Figur Haare, Oberteil, Hose — nur,
      was sich an diesem Entwurf sicher umfärben lässt (⏪ Haut bis 27.10.2026 abends, 30 von 34 fehlerhaft). Haare über
      `haarSenden`; Kleidung klickt den echten
      Knopf im Formular (derselbe Weg wie ein Kundenklick, keine zweite Wahrheit) — der Text-Satz färbt dann um.
      Was ein neues Bild braucht, steht im Block „Mehr ändern – mit neuem Bild" (`andersZeichnen`). */
  function haarZeichnen() {
    /* 30.10.2026 (`NACHHER_AN`): der Block steht in der grünen Sektion „Texte und Farben ändern“, nicht mehr
       allein unter dem Bild — Sascha: „nicht kongruent mit allen anderen Konzepten“. */
    const zeile = NACHHER_AN ? $('[data-nachher-gruen]') : document.querySelector('[data-melden-zeile]');
    let block = document.querySelector('[data-haar]');
    if (!haarMoeglich() || !zeile) {
      if (block) block.hidden = true;
      return;
    }
    farbenLaden(s.kandidatId);
    if (!block) {
      block = document.createElement('details');
      block.className = 'anders pdp__haar';
      block.dataset.haar = '';
      block.innerHTML = `<summary class="anders__kopf">
          <span class="anders__titel">Farben am Bild ändern</span>
          <span class="anders__zusatz">sofort, ohne neues Bild</span>
        </summary><div class="anders__inhalt" data-haar-inhalt></div>`;
      if (NACHHER_AN) { block.open = true; zeile.appendChild(block); } else zeile.before(block);
    }
    block.hidden = false;
    const st = farbenStand[s.kandidatId];
    const wahl = haarDesEntwurfs();
    const sig = JSON.stringify([s.kandidatId, st, wahl, GAMING_FARB_FELDER.map((f) => s.brief[f]),
      [1, 2].map(haarFigurOffen), s.brief.name1, s.brief.name2]);
    if (block.dataset.haarFuer === sig) return;
    block.dataset.haarFuer = sig;
    const inhalt = block.querySelector('[data-haar-inhalt]');
    if (st === 'laedt' || !st) {
      inhalt.innerHTML = '<p class="feld-hilfe">Wird vorbereitet …</p>';
      return;
    }
    const knopf = (attr, pressed, label, hintergrund) => `<button type="button" class="pdp__haar-ton" ${attr}
        aria-pressed="${pressed}" aria-label="${escape(label)}" title="${escape(label)}"
        style="background:${hintergrund}"></button>`;
    const figur = (p) => {
      const name = (s.brief || {})[`name${p}`] || (p === 1 ? 'Links' : 'Rechts');
      const reihen = AM_BILD_TEILE.filter(([teil]) => umfaerbbar(p, teil)).map(([teil, label]) => {
        let punkte;
        let zurueck = '';
        if (teil === 'haar') {
          punkte = HAAR_TOENE.map(([id, l, schatten, grund, licht]) => knopf(
            `data-haar-ton="${id}" data-haar-figur="${p}"`, wahl[p] === id, l,
            `linear-gradient(135deg, ${licht} 0 30%, ${grund} 30% 70%, ${schatten} 70%)`)).join('');
          if (wahl[p]) {
            zurueck = `<button type="button" class="pdp__haar-zurueck" data-haar-ton="" data-haar-figur="${p}">wie gezeichnet</button>`;
          }
        } else {
          const feld = `p${p}_${AM_BILD_FELD[teil]}`;
          punkte = amBildPunkte(teil).map((o) => knopf(`data-am-bild-feld="${feld}" data-wert="${o.id}"`,
            s.brief[feld] === o.id, o.label, o.hex)).join('');
        }
        return `<div class="pdp__haar-reihe"><span class="pdp__haar-name">${escape(label)}</span>
          <div class="pdp__haar-toene" role="group" aria-label="${escape(label)} ${escape(name)}">${punkte}</div>${zurueck}</div>`;
      });
      return reihen.length ? `<p class="feld-label">${escape(name)}</p>${reihen.join('')}` : '';
    };
    const teile = `${figur(1)}${figur(2)}`;
    inhalt.innerHTML = `${teile || '<p class="feld-hilfe">An diesem Bild lässt sich keine Farbe direkt ändern.</p>'}
      ${NACHHER_AN ? '' : `<p class="feld-hilfe">Hautton, Frisur, Brille, Bart, Mütze, Schnitt der Kleidung, Haustier und Spielwelt ändern sich
        nur mit einem neuen Bild – unter „Neu zeichnen“.</p>`}`;
  }

  async function haarSenden(p, ton) {
    if (!haarMoeglich()) return;
    if (!umzeichnenOffen) umzeichnenOffen = new Promise((fertig) => { umzeichnenErledigt = fertig; });
    const nr = ++umzeichnenNr;
    clearTimeout(umzeichnenUhr);
    const vonId = s.kandidatId;
    const vorher = historieLesen().find((x) => x.id === vonId);
    /* 🔴 Die Texte aus dem FORMULAR, wie `textSatzSenden` — nicht aus dem gezeigten Entwurf. Dieser Tipp verwirft
       einen laufenden Namenswechsel (`umzeichnenNr`); mit den alten Namen trüge das Blatt „Tom“, die Bestellzeile
       aber „Tim“ aus `s.brief` (code-pruefer 27.10.2026, BELEGT). */
    const satz = {};
    textSatzFelder(s.brief).forEach((k) => { satz[k] = s.brief[k] || ''; });
    if (haarWunsch.fuer !== vonId) haarWunsch = { fuer: vonId, ...haarDesEntwurfs() };
    haarWunsch[p] = ton;
    satz.haar1 = haarWunsch[1] || '';
    satz.haar2 = haarWunsch[2] || '';
    tafelLaedt(true);
    let k = null;
    let meldung = '';
    const abbruch = new AbortController();
    const uhr = setTimeout(() => abbruch.abort(), TEXT_SATZ_ABBRUCH_MS);
    try {
      const r = await fetch(`${BACKEND}/api/kandidat/${encodeURIComponent(vonId)}/gaming`, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(satz),
        signal: abbruch.signal,
      });
      const j = await r.json().catch(() => ({}));
      if (r.ok) k = (j.kandidaten || [])[0] || null; else meldung = j.fehler || '';
      if (r.status === 409 && j.neu_zeichnen) k = { neuZeichnen: true };
    } catch (e) { console.error(e); }
    clearTimeout(uhr);
    if (nr !== umzeichnenNr) return;          // ein neuerer Wechsel wartet
    umzeichnenAbschliessen();
    tafelLaedt(false);
    if (s.kandidatId !== vonId || s.phase !== 'fertig') return;
    /* Die Formular-Farben, die mitgingen, braucht ein neues Bild (409) — wie beim Text-Satz. */
    if (k && k.neuZeichnen) {
      andruckVerwerfen();
      zeigeMeldung(meldung);
      return;
    }
    if (!k || !k.id) {
      /* Kein Riegel am Warenkorb (anders als beim Text-Satz): der gezeigte Entwurf bleibt gültig, nur die neue
         Farbe kam nicht. Eine Figur, deren Haar der Dienst nicht findet, verliert ihre Farbfelder. */
      if (/Haarfarbe leider nicht ändern/.test(meldung)) haarGesperrt[`${vonId}:${p}`] = true;
      /* Der abgelehnte Wunsch darf nicht im Merker bleiben — sonst ginge er beim nächsten Tipp auf die ANDERE Figur
         mit und sperrte auch sie. Zurück auf das, was der gezeigte Entwurf trägt. */
      haarWunsch = { fuer: vonId, ...haarDesEntwurfs() };
      /* Dieser Tipp hat einen laufenden Namenswechsel verworfen. Tragen Formular und Blatt jetzt verschiedene Namen,
         gilt derselbe Riegel wie beim gescheiterten Text-Satz — sonst ginge das Blatt mit den alten Namen und die
         Bestellzeile mit den neuen in den Korb (code-pruefer 27.10.2026, Runde 2). */
      if (textSatzGeaendert()) s.textSatzFehlt = true;
      zeigeMeldung(meldung || 'Das hat gerade nicht geklappt – bitte noch einmal versuchen.');
      haarZeichnen();
      zeichne();
      return;
    }
    const fehler = $('[data-fehler]');
    if (fehler) fehler.hidden = true;
    if (s.textSatzFehlt) s.textSatzFehlt = false;   // die Texte des Formulars stehen jetzt auf dem Blatt
    farbenErben(vonId, k.id);
    s.kandidatId = k.id;
    s.kandidat = k;
    s.kandidatBild = `${BACKEND}${k.vorschau_url}`;
    haarWunsch = { fuer: k.id, ...(k.haar || {}) };
    vorschauSetzen(kandidatBildUrl(s.kandidatBild));
    /* `haar1`/`haar2` NICHT in den Brief der Historie: der Fingerabdruck zählte sie mit, und der umgefärbte Entwurf
       wäre über ihn nie mehr zu finden (code-pruefer 27.10.2026, Runde 2). Die Wahl steht als `haar` im Eintrag. */
    const { haar1: _h1, haar2: _h2, ...texte } = satz;
    historieMerken(k, { ...((vorher && vorher.brief) || s.brief), ...texte,
      ...('name1' in texte ? { namen: [texte.name1, texte.name2].filter(Boolean).join(' & ') } : {}) },
    (vorher && vorher.antworten) || null);
    speichernZeigen();
    zeichne();
  }

  /* --- Haustier: Foto hochladen und prüfen (16.10.2026) --------------------
     Ein Foto, im Browser auf 2000 px verkleinert (spart Datenvolumen am Handy,
     wandelt HEIC über den Browser in JPEG), dann `POST /api/haustier/foto`.
     Die Prüfung (Textmodell) sagt: Tier da? gut erkennbar? mehrere? — und
     füllt Fell, Ohren, Merkmal vor. Der Kunde bestätigt oder ändert. */
  /* Längste Kante vor dem Hochladen — Spiegel von `haustier.FOTO_MAX_KANTE`.
     Höchstwartezeit der Prüfung: JA gegen eine hängende Verbindung (gemessen
     5–15 s je Prüfung am 16.10.2026, plus Kaltstart); NEIN als erwartete Dauer. */
  const FOTO_MAX_KANTE = 2000;
  const FOTO_ABBRUCH_MS = 60000;

  function fotoFeldHtml(f, hilfe) {
    return `<p class="feld-label">${escape(f.label)}</p>${hilfe}
      <div class="fotofeld" data-fotofeld>
        <label class="echoa-aktion echoa-aktion--leise fotofeld__knopf" data-foto-waehlen>
          <input type="file" accept="image/*" data-foto-datei hidden>
          <span data-foto-knopftext>Foto wählen</span>
        </label>
        <!-- Zusicherung der Rechte am Foto (rechtstexte.md: „Vor jedem
             Foto-Upload-Motiv nachziehen"; Saschas Freigabe A, 16.10.2026).
             Klein, unter dem Knopf, nicht an der Kauffläche. -->
        <p class="feld-hilfe fotofeld__rechte">Mit dem Hochladen bestätigst du, dass du das Foto verwenden darfst.</p>
        <div class="fotofeld__bild" data-foto-bild hidden></div>
        <p class="feld-hilfe fotofeld__meldung" data-foto-meldung role="status" hidden></p>
        <div class="optionen" data-foto-tiere hidden></div>
        <!-- 🆕 30.10.2026 nachts (Sascha: „beim Haustier … noch das alte Klappmenü … vereinheitlichen“): der graue Kasten
             wie bei Moment und Linie. ⏪ Davor ein Listenknopf „→ Ohne Foto weiter – mit Rasse und Merkmalen“. -->
        <details class="anders ohne-klappe foto-ohne-klappe"><summary class="anders__kopf" data-foto-ohne>
          <span class="anders__titel">Kein Foto zur Hand?</span>
          <span class="anders__zusatz" data-foto-ohne-text>Wählt Rasse und Fellfarbe selbst</span></summary></details>
        <!-- Magazin ohne Foto (26.10.2026): im selben Schritt heilbar, ohne zurückzuspringen. -->
        <div class="fotofeld__alternativ" data-foto-alternativ hidden>
          <p class="feld-hilfe">Kein Foto zur Hand? Dann zeichnen wir ${
            D.produkt.handle === 'pferd' ? 'dein Pferd' : 'dein Tier'} nach deiner Beschreibung:</p>
          <div class="optionen">
            <button type="button" class="option" data-foto-machart="kohle">Kohle</button>
            <button type="button" class="option" data-foto-machart="portraet">Porträt</button>
            <button type="button" class="option" data-foto-machart="lexikon">Lexikon</button>
          </div>
        </div>
      </div>`;
  }

  /** Erste Meldung, die das Foto-Feld noch hat — null, wenn es passt. */
  /** `ohneStil` (Stufe 2, 22.10.2026): der „Weiter"-Knopf von Schritt 1 fragt nicht nach der Machart —
      die Magazin-Bedingung gehört zu Schritt 2 und meldet sich dort bzw. am Andruck-Knopf. */
  /** Magazin bearbeitet GENAU das Kundenfoto (sinngleich mit `dienst.MAGAZIN_OHNE_FOTO_TEXT`).
      Nur der Widerspruch Magazin + „Ohne Foto"; ein noch fehlendes Foto meldet `fotoFehler`. */
  function magazinOhneFoto() {
    return foto.ohne && magazinGewaehlt()
      ? 'Für den Magazin-Look brauchen wir ein Foto – oder wähle Kohle, Porträt oder Lexikon.' : null;
  }
  function magazinGewaehlt() {
    if (!istHaustier()) return false;
    /* Am gedrückten Knopf gelesen, nicht an `s.brief`: beim ersten Zeichnen ist der Brief noch nicht
       gesammelt (Handy-Probe 26.10.2026: „Ohne Foto weiter" stand trotz Magazin-Vorwahl da). */
    const b = briefHalter()?.querySelector('[data-brieffeld="stil"][aria-pressed="true"]');
    return (b ? b.dataset.wert : s.brief.stil) === 'magazin';
  }
  function fotoFehler(ohneStil = false) {
    if (!ohneStil && magazinOhneFoto()) return magazinOhneFoto();
    if (foto.ohne) {
      return (s.brief.rasse || '').trim()
        ? null : (D.produkt.handle === 'pferd' ? 'Ohne Foto brauchen wir die Rasse deines Pferdes.'
          : 'Ohne Foto brauchen wir die Rasse deines Tiers.');
    }
    if (foto.status === 'laedt') return 'Dein Foto wird gerade geprüft …';
    /* Sascha, 22.10.2026 abends: „Ohne Foto weiter" klang, als ginge es dann direkt weiter —
       gemeint ist: dann beschreibst du dein Tier in den Feldern. */
    if (foto.status === 'leer') {
      /* Magazin (26.10.2026): kein „Ohne Foto weiter" — geheilt wird im selben Schritt, mit Foto
         oder einer der Macharten in der Zeile unter dem Knopf (`data-foto-alternativ`). */
      if (!ohneStil && magazinGewaehlt()) {
        return eineSeite()
          ? 'Für den Magazin-Look brauchen wir ein Foto – lade es hier hoch oder wähle oben eine andere Machart.'
          : 'Für den Magazin-Look brauchen wir ein Foto – lade es hier hoch oder tippe darunter auf Kohle, Porträt oder Lexikon.';
      }
      return `Bitte lade ein Foto hoch – oder wähle unter „Kein Foto zur Hand?“ Rasse und Fellfarbe für ${
        D.produkt.handle === 'pferd' ? 'dein Pferd' : 'dein Tier'}.`;
    }
    if (foto.status === 'hauptmotiv' && !foto.hauptmotiv) return 'Bitte wähle, welches Tier wir zeichnen.';
    if (!['ok', 'hauptmotiv'].includes(foto.status)) return foto.meldung || 'Bitte wähle ein anderes Foto.';
    return null;
  }

  function fotoZeichnen() {
    const feld = $('[data-fotofeld]');
    if (!feld) return;
    const bild = feld.querySelector('[data-foto-bild]');
    const meldung = feld.querySelector('[data-foto-meldung]');
    const tiere = feld.querySelector('[data-foto-tiere]');
    const knopfText = feld.querySelector('[data-foto-knopftext]');
    const ohne = feld.querySelector('[data-foto-ohne]');
    feld.querySelector('[data-foto-waehlen]').hidden = foto.ohne;
    bild.hidden = foto.ohne || !foto.bild;
    if (!bild.hidden) bild.innerHTML = `<img src="${attr(foto.bild)}" alt="Dein Foto">`;
    knopfText.textContent = foto.bild ? 'Anderes Foto wählen' : 'Foto wählen';
    const ohneKasten = ohne.closest('details') || ohne;
    ohneKasten.open = Boolean(foto.ohne);
    /* Magazin: „Ohne Foto weiter" führte in einen Widerspruch — statt seiner stehen die
       Macharten ohne Foto da, solange noch kein brauchbares Foto vorliegt. */
    const magazin = magazinGewaehlt() && kombiDef() !== null;
    ohneKasten.hidden = magazin && !foto.ohne;
    const alternativ = feld.querySelector('[data-foto-alternativ]');
    /* Eine Seite: keine zweite Machart-Wahl am Foto — die Machart steht oben (Sascha 28.10.2026: „muss der Kunde erneut
       den Stil wählen … genau der logische Fehler"). Bei Magazin gibt es dann nur das Foto. */
    if (alternativ) alternativ.hidden = Boolean(eineSeite())
      || !(magazin && !foto.ohne && !['ok', 'hauptmotiv'].includes(foto.status));
    ohne.querySelector('[data-foto-ohne-text]').textContent = foto.ohne
      ? 'Doch mit Foto? Hier zuklappen' : 'Wählt Rasse und Fellfarbe selbst';
    const text = foto.ohne ? '' : (foto.status === 'laedt'
      ? 'Wir schauen uns dein Foto an …'
      : [foto.meldung, foto.hinweis,
         ['ok', 'hauptmotiv'].includes(foto.status)
           /* Seit 22.10.2026 sagt das die Zeile „Wir sehen: …" darunter — der Satz nur noch,
              wenn die Felder offen stehen. */
           && tierFelderOffen
           ? 'Fell und Merkmal haben wir aus dem Foto vorausgefüllt – bitte kurz prüfen.' : '']
        .filter(Boolean).join(' '));
    meldung.hidden = !text;
    meldung.textContent = text;
    meldung.classList.toggle('fotofeld__meldung--warnung',
      !foto.ohne && ['kein_tier', 'falsche_art', 'neues_foto', 'fehler'].includes(foto.status));
    const zeigen = !foto.ohne && foto.status === 'hauptmotiv' && foto.tiere.length > 1;
    tiere.hidden = !zeigen;
    tiere.innerHTML = zeigen ? foto.tiere.map((x) => `<button type="button" class="option"
        data-foto-tier="${attr(x.beschreibung)}" aria-pressed="${x.beschreibung === foto.hauptmotiv}">
        ${escape(x.beschreibung)}</button>`).join('') : '';
    tierBefundZeichnen();
  }

  /* 🆕 DER FOTO-BEFUND IST EINE BESTÄTIGUNG, KEIN FORMULAR (Saschas T1 »B«, 22.10.2026).
     Gemessen 08.–22.10.2026 (Speicher, ohne interne Andrucke): 53 von 53 Andrucken auf Haustier
     und Pferd hatten ein Foto, „Ohne Foto weiter" nutzte niemand; beim Haustier blieben Fell,
     Merkmal und Ohren in 59 von 60 Fällen so, wie das Foto sie vorschlug. Deshalb stehen Tierart,
     Rasse, Fell, Ohren und Merkmal nach einem geprüften Foto als EINE Zeile „Wir sehen: …" —
     die Felder öffnen sich auf „Ändern". Vor dem Foto stehen sie gar nicht, mit „Ohne Foto
     weiter" offen wie bisher.
     Ausnahme Pferd: die Rasse bleibt als Frage stehen — 17 von 24 Kunden haben sie korrigiert
     (das Modell schreibt „Warmblut", der Kunde „Hannoveraner").
     🔴 EIN LEERES PFLICHTFELD ÖFFNET DIE FELDER VON SELBST — sonst meldete `brieffehler()`
     „Bitte Fell ausfüllen" zu einem Feld, das der Kunde nicht sieht. Zu ist eine Klasse, nicht
     `hidden`: `hidden` heißt für `brieffehler()` „gilt nicht", und das wäre hier falsch. */
  const TIER_FELDER = ['art', 'rasse', 'fell', 'ohren', 'merkmal'];
  let tierFelderOffen = false;
  function tierBefundZeichnen() {
    if (!istHaustier()) return;
    const halter = briefHalter();
    if (!halter) return;
    const fotoGut = !foto.ohne && Boolean(foto.id) && ['ok', 'hauptmotiv'].includes(foto.status);
    const leer = (n) => {
      const el = halter.querySelector(`[data-feld="${n}"]`);
      if (el) return !el.value.trim();
      return !halter.querySelector(`[data-brieffeld="${n}"][aria-pressed="true"]`);
    };
    const pflichtLeer = briefDef().felder.some((f) => TIER_FELDER.includes(f.name) && f.pflicht
      && !halter.querySelector(`[data-brieffeld-halter="${f.name}"]`)?.hidden && leer(f.name));
    /* Einmal von selbst geöffnet, bleibt offen — sonst klappte das Feld beim ersten getippten
       Zeichen unter dem Finger zu (code-pruefer 22.10.2026, BELEGT). */
    if (fotoGut && pflichtLeer) tierFelderOffen = true;
    const offen = foto.ohne || tierFelderOffen;
    /* Eine sicher erkannte Rasse (Haflinger, Friese …) steht in der Zeile; sonst wird gefragt. */
    const pferdRasse = D.produkt.handle === 'pferd' && fotoGut && fotoVorschlag.rasse_sicher !== true;
    TIER_FELDER.forEach((n) => {
      const w = halter.querySelector(`[data-brieffeld-halter="${n}"]`);
      if (w) w.classList.toggle('brieffeld--zu', !(offen || (n === 'rasse' && pferdRasse)));
    });
    /* Die Zeile steht direkt unter dem Foto-Feld. */
    const fotoHalter = halter.querySelector('[data-brieffeld-halter="foto"]');
    if (!fotoHalter) return;
    let zeile = halter.querySelector('[data-tier-befund]');
    if (!zeile) {
      zeile = document.createElement('div');
      zeile.className = 'tier-befund';
      zeile.dataset.tierBefund = '';
      zeile.innerHTML = `<p class="tier-befund__text" data-tier-befund-text></p>
        <button type="button" class="tier-befund__aendern" data-tier-aendern>Stimmt nicht? Ändern</button>`;
      fotoHalter.insertAdjacentElement('afterend', zeile);
    }
    const teile = TIER_FELDER.filter((n) => !(n === 'rasse' && pferdRasse)).map((n) => {
      const el = halter.querySelector(`[data-feld="${n}"]`);
      if (el) return el.value.trim();
      const an = halter.querySelector(`[data-brieffeld="${n}"][aria-pressed="true"]`);
      return an ? an.textContent.trim() : '';
    }).filter(Boolean);
    zeile.hidden = !fotoGut || offen || !teile.length;
    zeile.querySelector('[data-tier-befund-text]').innerHTML =
      `<span class="tier-befund__titel">Wir sehen:</span> ${escape(teile.join(', '))}`;
    /* Pferd: die Rasse als Frage — mit dem, was das Foto vorschlug. */
    const rasseHalter = halter.querySelector('[data-brieffeld-halter="rasse"]');
    if (rasseHalter) {
      let frage = rasseHalter.querySelector('[data-rasse-frage]');
      if (pferdRasse && !offen) {
        if (!frage) {
          frage = document.createElement('p');
          frage.className = 'feld-hilfe';
          frage.dataset.rasseFrage = '';
          rasseHalter.querySelector('.feld-label')?.insertAdjacentElement('afterend', frage);
        }
        const vor = (fotoVorschlag.rasse || '').trim();
        frage.textContent = vor
          ? `Wir sehen ein ${vor} – stimmt das, oder kennst du die genaue Rasse?`
          : 'Welche Rasse ist dein Pferd? Dann treffen wir es genauer.';
        frage.hidden = false;
      } else if (frage) {
        frage.hidden = true;
      }
    }
  }

  /** Bild im Browser verkleinern → Data-URL (JPEG). */
  function fotoVerkleinern(datei) {
    return new Promise((fertig, fehler) => {
      const url = URL.createObjectURL(datei);
      const img = new Image();
      img.onload = () => {
        const f = Math.min(1, FOTO_MAX_KANTE / Math.max(img.naturalWidth, img.naturalHeight));
        const c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * f);
        c.height = Math.round(img.naturalHeight * f);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        fertig(c.toDataURL('image/jpeg', 0.9));
      };
      img.onerror = () => { URL.revokeObjectURL(url); fehler(new Error('Bild nicht lesbar')); };
      img.src = url;
    });
  }

  /* Vorschläge der Prüfung in die Felder — nur, wo der Kunde nichts Eigenes
     stehen hat oder der Wert vom letzten Vorschlag stammt. */
  let fotoVorschlag = {};
  function fotoVorschlagEinsetzen(v) {
    const halter = briefHalter();
    if (!halter || !v) return;
    /* „Bitte prüfen" (20.10.2026: zwei Kunden bekamen eine falsche Rasse bzw. „Grau"):
       was aus dem Foto kommt, trägt die Messing-Kante, bis der Kunde das Feld anfasst. */
    const textFeld = (name, wert) => {
      const el = halter.querySelector(`[data-feld="${name}"]`);
      if (!el || !wert) return;
      if (!el.value.trim() || el.value.trim() === (fotoVorschlag[name] || '')) {
        el.value = wert;
        el.classList.add('echoa-feld--unsicher');
      }
    };
    textFeld('fell', v.fell);
    textFeld('merkmal', v.merkmal);
    if (v.rasse && v.rasse.toLowerCase() !== 'mischling') textFeld('rasse', v.rasse);
    const chip = (name, wert) => {
      if (!wert) return;
      const knoepfe = halter.querySelectorAll(`[data-brieffeld="${name}"]`);
      if (!Array.from(knoepfe).some((b) => b.dataset.wert === wert)) return;
      knoepfe.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.wert === wert)));
    };
    chip('art', v.art);
    chip('ohren', v.ohren);
    /* `rasse_sicher` (Pferd, Dienst ab 58e95e77): false, wenn das Foto nur eine Klasse zeigt
       (Warmblut, Kaltblut, Pony) — dann fragt die Maske nach der Rasse. */
    fotoVorschlag = { fell: v.fell, merkmal: v.merkmal, rasse: v.rasse, rasse_sicher: v.rasse_sicher };
    $$('[data-waechst]').forEach(wachsen);
  }

  async function fotoGewaehlt(input) {
    const datei = input.files && input.files[0];
    input.value = '';
    if (!datei) return;
    foto = { ...foto, id: '', status: 'laedt', meldung: '', hinweis: '', tiere: [],
             hauptmotiv: '', ohne: false };
    let daten = '';
    try {
      daten = await fotoVerkleinern(datei);
    } catch (e) {
      foto = { ...foto, status: 'fehler', bild: '',
               meldung: 'Dieses Foto können wir nicht öffnen. Bitte ein JPG- oder PNG-Foto wählen.' };
      fotoZeichnen(); eingabeGeaendert(); return;
    }
    foto.bild = daten;
    fotoZeichnen();
    eingabeGeaendert();
    const nr = ++fotoNr;
    let a = null;
    const abbruch = new AbortController();
    const uhr = setTimeout(() => abbruch.abort(), FOTO_ABBRUCH_MS);
    try {
      const r = await fetch(`${BACKEND}/api/haustier/foto`, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({ produkt: D.produkt.handle, bild: daten }),
        signal: abbruch.signal,
      });
      a = await r.json().catch(() => ({}));
      if (!r.ok) a = { status: 'fehler', meldung: a.fehler || 'Das Foto konnte nicht geprüft werden.' };
    } catch (e) {
      a = { status: 'fehler', meldung: 'Das Foto ist nicht angekommen. Bitte noch einmal versuchen.' };
    }
    clearTimeout(uhr);
    if (nr !== fotoNr) return;                     // ein neueres Foto läuft
    foto = { ...foto, id: a.foto_id || '', status: a.status || 'fehler',
             meldung: a.meldung || '', hinweis: a.hinweis || '', tiere: a.tiere || [],
             hauptmotiv: '' };
    if (['ok', 'hauptmotiv'].includes(foto.status)) fotoVorschlagEinsetzen(a.vorschlag);
    fotoZeichnen();
    /* Die Tierart aus dem Foto (Katze) zeigt ihr Beispiel auf der Bühne (22.10.2026). */
    markerKlick = true;
    try { eingabeGeaendert(); } finally { markerKlick = false; }
    lookBeispielZeigen();
  }
  let fotoNr = 0;

  /* --- Orts-Print: optionales Foto des Ortes (19.10.2026) ---------------------
     Verkleinern wie das Tierfoto (`fotoVerkleinern`), dann `POST /api/ort/foto`. Die Prüfung sagt nur:
     Ort zu sehen? gut erkennbar? — Menschen sind kein Grund zur Ablehnung, sie werden nie gezeichnet. */
  function ortfotoFeldHtml(f, hilfe) {
    return `<p class="feld-label">${escape(f.label)}${f.ohneOptional ? '' : ' <span class="feld-label__optional">(optional)</span>'}</p>${hilfe}
      <div class="fotofeld" data-ortfotofeld>
        <label class="echoa-aktion echoa-aktion--leise fotofeld__knopf">
          <input type="file" accept="image/*" data-ortfoto-datei hidden>
          <span data-ortfoto-knopftext data-leer="${attr(f.knopf || 'Foto hinzufügen')}">${escape(f.knopf || 'Foto hinzufügen')}</span>
        </label>
        <p class="feld-hilfe fotofeld__rechte">Mit dem Hochladen bestätigst du, dass du das Foto verwenden darfst.</p>
        <div class="fotofeld__bild" data-ortfoto-bild hidden></div>
        <p class="feld-hilfe fotofeld__meldung" data-ortfoto-meldung role="status" hidden></p>
        <button type="button" class="listenknopf" data-ortfoto-weg hidden>
          <span class="listenknopf__zeichen" aria-hidden="true">×</span> <span>Foto entfernen</span>
        </button>
      </div>`;
  }

  function ortfotoZeichnen() {
    const feld = $('[data-ortfotofeld]');
    if (!feld) return;
    const bild = feld.querySelector('[data-ortfoto-bild]');
    const meldung = feld.querySelector('[data-ortfoto-meldung]');
    bild.hidden = !ortfoto.bild;
    if (!bild.hidden) bild.innerHTML = `<img src="${attr(ortfoto.bild)}" alt="Dein Foto vom Ort">`;
    const knopf = feld.querySelector('[data-ortfoto-knopftext]');
    knopf.textContent = ortfoto.bild ? 'Anderes Foto wählen' : (knopf.dataset.leer || 'Foto hinzufügen');
    /* `ORTS_KLAPPE_AN`: mit Foto (geprüft oder in Prüfung) ist die Klappe „Kein Foto zur Hand?" weg; ein
       abgelehntes Foto bringt sie zurück. Steht schon Text darin (zurückgeholter Entwurf), ist sie offen. */
    const klappe = ORTS_KLAPPE_AN ? $('[data-brieffeld-halter="muss_rein"]') : null;
    if (klappe) {
      klappe.hidden = Boolean(ortfoto.bild) && !['kein_ort', 'neues_foto', 'fehler'].includes(ortfoto.status);
      const d = klappe.querySelector('[data-feld-klappe]');
      const t = klappe.querySelector('[data-feld="muss_rein"]');
      if (d && t && t.value.trim() && !d.open) d.open = true;
    }
    feld.querySelector('[data-ortfoto-weg]').hidden = !ortfoto.bild;
    const text = ortfoto.status === 'laedt' ? 'Wir schauen uns dein Foto an …'
      : [ortfoto.meldung, ortfoto.hinweis].filter(Boolean).join(' ');
    meldung.hidden = !text;
    meldung.textContent = text;
    meldung.classList.toggle('fotofeld__meldung--warnung',
      ['kein_ort', 'neues_foto', 'fehler'].includes(ortfoto.status));
  }

  async function ortfotoGewaehlt(input) {
    const datei = input.files && input.files[0];
    input.value = '';
    if (!datei) return;
    ortfoto = { id: '', status: 'laedt', meldung: '', hinweis: '', bild: '' };
    let daten = '';
    try {
      daten = await fotoVerkleinern(datei);
    } catch (e) {
      ortfoto = { ...ortfoto, status: 'fehler',
                  meldung: 'Dieses Foto können wir nicht öffnen. Bitte ein JPG- oder PNG-Foto wählen.' };
      ortfotoZeichnen(); eingabeGeaendert(); return;
    }
    ortfoto.bild = daten;
    ortfotoZeichnen();
    eingabeGeaendert();
    const nr = ++ortfotoNr;
    let a = null;
    const abbruch = new AbortController();
    const uhr = setTimeout(() => abbruch.abort(), FOTO_ABBRUCH_MS);
    try {
      const r = await fetch(`${BACKEND}/api/ort/foto`, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({ bild: daten }),
        signal: abbruch.signal,
      });
      a = await r.json().catch(() => ({}));
      if (!r.ok) a = { status: 'fehler', meldung: a.fehler || 'Das Foto konnte nicht geprüft werden.' };
    } catch (e) {
      a = { status: 'fehler', meldung: 'Das Foto ist nicht angekommen. Bitte noch einmal versuchen.' };
    }
    clearTimeout(uhr);
    if (nr !== ortfotoNr) return;                  // entfernt oder ein neueres Foto läuft
    ortfoto = { ...ortfoto, id: a.foto_id || '', status: a.status || 'fehler',
                meldung: a.meldung || '', hinweis: a.hinweis || '' };
    ortfotoZeichnen();
    eingabeGeaendert();
  }
  let ortfotoNr = 0;

  /* --- Moment: das Foto von euch beiden (Feldtyp »paarfoto«, `PAARFOTO_AN`, 27.10.2026) ----------------
     Ablauf: Foto wählen → `POST /api/moment/foto` {bild, produkt} prüft und schlägt Merkmale vor → EINE Zeile
     „Wir sehen …" → „ändern" klappt die Auswahl auf. Ohne Foto (nur Dunkel/Farbig) fragt das Feld nur, wer die
     zwei sind — mehr braucht der kleine Moment nicht. Die IDs sind die aus `pipeline/a5_paar.py`
     (`merkmale_ordnen` verwirft Unbekanntes); die Wörter hier sind nur Anzeige. */
  const PAARFOTO_NUR_MIT_FOTO = ['kohle', 'strich'];
  const PAAR_PERSON = [['weiblich', 'Frau'], ['maennlich', 'Mann'], ['neutral', 'neutral']];
  const PAAR_HAAR = [['schwarz', 'schwarz', '#1d1a17'], ['dunkelbraun', 'dunkelbraun', '#3b2a20'],
    ['mittelbraun', 'mittelbraun', '#6a4a32'], ['hellbraun', 'hellbraun', '#8e6a48'],
    ['dunkelblond', 'dunkelblond', '#a8875c'], ['blond', 'blond', '#c9a86b'], ['hellblond', 'hellblond', '#e2cc93'],
    ['rot', 'rot', '#9a4a2a'], ['grau', 'grau', '#9b9893'], ['weiss', 'weiß', '#e6e2da']];
  /* 🆕 31.10.2026 (Saschas »Ja, ein Afro«): „Afro“ in beiden Frisur-Listen (Moment und Linie), ID aus `a5_paar.FRISUR`. */
  const PAAR_WAHL = {
    frisur: [['kurz', 'kurz'], ['kurz_scheitel', 'kurz mit Scheitel'], ['mittel', 'mittel'], ['lang', 'lang'],
             ['zopf', 'Zopf'], ['dutt', 'Dutt'], ['locken', 'Locken'], ['afro', 'Afro'], ['glatze', 'Glatze']],
    brille: [['keine', 'keine'], ['rund', 'rund'], ['eckig', 'eckig']],
    bart: [['keiner', 'keiner'], ['stoppel', 'Stoppeln'], ['kinn', 'Stoppeln an Kinn und Mund'], ['kurz', 'kurz'],
           ['voll', 'voll']],
    statur: [['schlank', 'schlank'], ['mittel', 'mittel'], ['kraeftig', 'kräftig']],
  };
  const PAAR_GROESSE = [['groesser', 'links'], ['gleich', 'gleich'], ['kleiner', 'rechts']];
  /* 🆕 Hautton, nur bei Farbig (Sascha 28.10.2026: „beim farbigen Entwurf würde ich die Hautfarbe mit einbauen, bei
     den anderen Stilen macht sie vermutlich keinen Unterschied"). IDs = `a5_paar.HAUTTON`; Vorwahl hell, mit Foto
     vorbelegt mit dem Befund. Geht als `hautton1/2` in den Brief (`dienst`, Farbig-Zweig). */
  const PAAR_HAUT = [['hell', 'hell', '#ebc09f'], ['mittel', 'mittel', '#c08a5f'], ['dunkel', 'dunkel', '#6b4128']];
  const PAAR_HAUT_VORWAHL = 'hell';
  const paarHaut = (q) => ((q || {}).hautton || PAAR_HAUT_VORWAHL);
  const paarMitHaut = () => s.brief.look === 'kontrolle' && !['linie', 'portraet'].includes(D.produkt.handle);
  const PAAR_STIL = [['casual', 'Casual'], ['elegant', 'Elegant'], ['sportlich', 'Sportlich'], ['festlich', 'Festlich']];
  const paarWort = (liste, id) => ((liste.find(([w]) => w === id) || [])[1] || '');
  const paarLeer = () => ({ p1: {}, p2: {}, groesse: '', stil: 'casual' });

  /* 🆕 OHNE FOTO: KLAPPMENÜ MIT TABELLE (Sascha 30.10.2026, Variante A: „Kein Foto zur Hand? Beschreibe euch manuell",
     ein Dropdown je Person, beide in einer Zeile, Haarfarben als Farbe, Zeile „Größe"). Ohne angenommenes Foto steht
     unter dem Foto-Knopf die Klappe (Muster `.anders`), mit Foto öffnet „ändern" dieselbe Tabelle. Gilt für den Moment
     und „Paar als Linie" — auch Kohle, Strich, Linie und Pinsel gehen damit ohne Foto (Spiegel: `dienst.A5_OHNE_FOTO`;
     das Foto geht dort ohnehin nicht ins Bild, es liefert nur die Merkmale). AUS = wie bis zum 30.10.: Chips je Person,
     Kohle/Strich/Linie nur mit Foto. Die IDs sind die aus `pipeline/a5_paar.py`, die Wörter nur Anzeige. */
  /* AUS bis zu Saschas Ja zum Ausrollen (Dienst `A5_OHNE_FOTO` muss vorher live sein, sonst meldet Kohle ohne Foto
     weiter „brauchen wir ein Foto“). */
  /* ▶️ EIN seit 30.10.2026 abends (Saschas T1 »A: ja, einschalten«, Dienst 98228f06 live mit Dunkel groß ohne Foto). */
  const OHNE_FOTO_AN = true;
  const PAAR_TAB = {
    geschlecht: [['', 'wählen'], ...PAAR_PERSON],
    /* „kurz mit Scheitel" passt am Handy nicht in die halbe Spalte — die ID bleibt `kurz_scheitel`. */
    frisur: [['', 'wählen'], ['kurz', 'kurz'], ['kurz_scheitel', 'Scheitel'], ['mittel', 'mittel'], ['lang', 'lang'],
             ['zopf', 'Zopf'], ['dutt', 'Dutt'], ['locken', 'Locken'], ['afro', 'Afro'], ['glatze', 'Glatze']],
    brille: PAAR_WAHL.brille,
    bart: [['keiner', 'keiner'], ['stoppel', 'Stoppeln'], ['kinn', 'Kinn & Mund'], ['kurz', 'kurz'], ['voll', 'voll']],
  };
  const PAAR_GROESSE_TAB = [['gleich', 'beide gleich groß'], ['groesser', 'links größer'], ['kleiner', 'rechts größer']];
  /* Was ohne Wahl gilt — so steht es im Feld, so geht es in den Brief (sonst zeigte das Feld „keine" und der Brief
     schickte nichts). Bart nur beim Mann; bei Frau und neutral fällt er weg. */
  const paarVorgabe = (q, w) => (q || {})[w] || ({ brille: 'keine', bart: (q || {}).geschlecht === 'maennlich'
    ? 'keiner' : '' })[w] || '';
  const paarMitHaar = () => D.produkt.handle !== 'linie';    // die Linie zeigt keine Farbe
  let ohneKlappe = false;      // Klappe „Kein Foto zur Hand?" offen
  let ohneWahl = '';           // offene Farbwahl, z. B. „p1.haarfarbe"

  function paarTabelle(p, mitFoto) {
    const sel = (feld, liste, wert) => `<select class="echoa-feld echoa-feld--wahl ohne__feld" data-paar-sel="${attr(feld)}"
        aria-label="${attr(feld)}">${liste.map(([id, wort]) =>
        `<option value="${attr(id)}"${id === wert ? ' selected' : ''}>${escape(wort)}</option>`).join('')}</select>`;
    const farbe = (k, w, liste, wert) => {
      const [, wort, hex] = liste.find(([id]) => id === wert) || ['', 'wählen', ''];
      return `<button type="button" class="echoa-feld ohne__feld ohne__farbknopf" data-paar-farbe="${k}.${w}"
          aria-expanded="${String(ohneWahl === `${k}.${w}`)}"><span class="ohne__punkt${hex ? '' : ' ohne__punkt--leer'}"
          ${hex ? `style="--farbe:${hex}"` : ''} aria-hidden="true"></span><span class="ohne__wort">${escape(wort)}</span></button>`;
    };
    const wahl = (k, w, liste, titel) => (ohneWahl !== `${k}.${w}` ? '' : `<div class="ohne__wahl">
        <p class="feld-hilfe">${titel} ${k === 'p1' ? 'links' : 'rechts'}</p><div class="marker-reihe" role="group">${
        liste.map(([id, wort, hex]) => `<button type="button" class="marker" data-paar="${k}.${w}" data-wert="${attr(id)}"
          aria-pressed="${String(id === (p[k] || {})[w])}"><span class="marker__kreis" style="--farbe:${hex}"
          aria-hidden="true"></span><span class="marker__name">${escape(wort).replace(/^(dunkel|mittel|hell)(?=.)/, '$1&shy;')}</span></button>`)
          .join('')}</div></div>`);
    const zeile = (titel, a, b) => `<span class="ohne__k">${titel}</span>${a}${b}`;
    const q = (k) => p[k] || {};
    const farbZeile = (w, titel, liste, wert) => zeile(titel, farbe('p1', w, liste, wert('p1')), farbe('p2', w, liste, wert('p2')))
      + wahl('p1', w, liste, titel) + wahl('p2', w, liste, titel);
    const bart = (k) => (q(k).geschlecht === 'maennlich'
      ? sel(`${k}.bart`, PAAR_TAB.bart, paarVorgabe(q(k), 'bart')) : '<span class="ohne__leer" aria-hidden="true">—</span>');
    return `<div class="ohne">
      <span></span><span class="ohne__kopf">Links</span><span class="ohne__kopf">Rechts</span>
      ${zeile('Person', sel('p1.geschlecht', PAAR_TAB.geschlecht, q('p1').geschlecht || ''),
        sel('p2.geschlecht', PAAR_TAB.geschlecht, q('p2').geschlecht || ''))}
      ${paarMitHaut() ? farbZeile('hautton', 'Haut', PAAR_HAUT, (k) => paarHaut(q(k))) : ''}
      ${paarMitHaar() ? farbZeile('haarfarbe', 'Haare', PAAR_HAAR, (k) => q(k).haarfarbe || '') : ''}
      ${zeile('Frisur', sel('p1.frisur', PAAR_TAB.frisur, q('p1').frisur || ''), sel('p2.frisur', PAAR_TAB.frisur, q('p2').frisur || ''))}
      ${zeile('Brille', sel('p1.brille', PAAR_TAB.brille, paarVorgabe(q('p1'), 'brille')),
        sel('p2.brille', PAAR_TAB.brille, paarVorgabe(q('p2'), 'brille')))}
      ${zeile('Bart', bart('p1'), bart('p2'))}
      ${mitFoto && D.produkt.handle !== 'linie'
        ? `<span class="ohne__k">Kleidung</span><span class="ohne__breit">${sel('stil', PAAR_STIL, p.stil || 'casual')}</span>` : ''}
      <span class="ohne__k">Größe</span><span class="ohne__breit">${sel('groesse', PAAR_GROESSE_TAB, p.groesse || 'gleich')}</span>
    </div>`;
  }

  /** Der Vorschlag des Dienstes, in die Werte des Formulars übersetzt (Geschlecht „männlich" → „maennlich"). */
  function paarAusVorschlag(v) {
    const p = paarLeer();
    if (!v || typeof v !== 'object') return p;
    ['p1', 'p2'].forEach((k) => {
      const q = v[k] && typeof v[k] === 'object' ? v[k] : {};
      const g = String(q.geschlecht || '').replace('ä', 'ae');
      p[k] = { geschlecht: PAAR_PERSON.some(([w]) => w === g) ? g : '',
               haarfarbe: q.haarfarbe || '', frisur: q.frisur || '', brille: q.brille || '',
               bart: q.bart || '', statur: q.statur || '',
               hautton: PAAR_HAUT.some(([w]) => w === q.hautton) ? q.hautton : '' };
    });
    p.groesse = v.groesse || '';
    p.stil = v.stil || 'casual';
    return p;
  }
  /** Was in den Brief geht: nur die Merkmal-Felder, die der Dienst liest (`a5_paar.merkmale_ordnen`). */
  function paarBrief(p) {
    const person = (q) => ({ haarfarbe: q.haarfarbe || '', frisur: q.frisur || '', brille: q.brille || '',
                             bart: q.bart || '', statur: q.statur || '' });
    return { p1: person(p.p1 || {}), p2: person(p.p2 || {}), groesse: p.groesse || '', stil: p.stil || 'casual' };
  }
  function paarSatz(p) {
    const wer = (q, seite) => {
      const g = { weiblich: 'eine Frau', maennlich: 'ein Mann', neutral: 'eine Person' }[q.geschlecht] || 'eine Person';
      const teile = [paarWort(PAAR_HAAR, q.haarfarbe), paarWort(PAAR_WAHL.frisur, q.frisur),
        q.brille && q.brille !== 'keine' ? `${paarWort(PAAR_WAHL.brille, q.brille)}e Brille` : '',
        q.bart && q.bart !== 'keiner' ? `Bart ${paarWort(PAAR_WAHL.bart, q.bart)}` : '',
        paarMitHaut() ? { hell: 'helle Haut', mittel: 'mittlere Haut', dunkel: 'dunkle Haut' }[paarHaut(q)] : '']
        .filter(Boolean);
      return `${seite} ${g}${teile.length ? ': ' + teile.join(', ') : ''}`;
    };
    const gr = { groesser: ' · links größer', kleiner: ' · rechts größer', gleich: ' · gleich groß' }[p.groesse] || '';
    return `${wer(p.p1 || {}, 'Links')} · ${wer(p.p2 || {}, 'rechts')}${gr}`;
  }

  function paarfotoFeldHtml(f, hilfe) {
    return `<p class="feld-label">${escape(f.label)}</p>${hilfe}<div class="fotofeld paarfeld" data-paarfotofeld></div>`;
  }

  function paarChips(feld, liste, wert) {
    return `<div class="optionen paarfeld__wahl" role="group">${liste.map(([id, wort]) =>
      `<button type="button" class="option" data-paar="${attr(feld)}" data-wert="${attr(id)}"
         aria-pressed="${String(id === wert)}">${escape(wort)}</button>`).join('')}</div>`;
  }
  function paarFarben(feld, wert, liste = PAAR_HAAR) {
    return `<div class="brieffeld--farben"><div class="optionen" role="group">${liste.map(([id, wort, hex]) =>
      `<button type="button" class="option option--farbe" data-paar="${attr(feld)}" data-wert="${attr(id)}"
         aria-pressed="${String(id === wert)}"><span class="option__kreis" style="--farbe:${hex}" aria-hidden="true"></span>
         <span class="option__name">${escape(wort)}</span></button>`).join('')}</div></div>`;
  }

  /* Porträt (29.10.2026): dasselbe Feld, aber ohne Merkmal-Auswahl — der Dienst zeichnet aus Foto und Befund, der
     Kunde sieht nur, wie viele Personen erkannt sind („Wir sehen 3 Personen, darunter ein Kind."). */
  function portraetfotoZeichnen(feld) {
    const text = paarfoto.status === 'laedt' ? 'Wir schauen uns dein Foto an …' : paarfoto.text;
    const ok = paarfoto.status === 'ok';
    feld.innerHTML = `
      ${paarfoto.bild ? `<div class="fotofeld__bild"><img src="${attr(paarfoto.bild)}" alt="Dein Foto"></div>` : ''}
      <label class="echoa-aktion echoa-aktion--leise fotofeld__knopf">
        <input type="file" accept="image/*" data-paarfoto-datei hidden>
        <span>${paarfoto.bild ? 'Anderes Foto wählen' : 'Foto wählen'}</span>
      </label>
      <p class="feld-hilfe">Bis zu 5 Personen, auch Kinder. Am schönsten mit einem hellen Foto, auf dem alle Gesichter gut zu sehen sind.</p>
      <p class="feld-hilfe fotofeld__rechte">Mit dem Hochladen bestätigst du, dass alle auf dem Foto einverstanden sind – bei Kindern ihre Eltern.</p>
      ${text ? `<p class="feld-hilfe fotofeld__meldung${['nein', 'fehler'].includes(paarfoto.status)
        ? ' fotofeld__meldung--warnung' : ''}" role="status">${escape(text)}</p>` : ''}
      ${ok ? `${paarfoto.satz ? `<p class="paarfeld__satz">${escape(paarfoto.satz)}</p>` : ''}
        <button type="button" class="listenknopf" data-paarfoto-weg>
          <span class="listenknopf__zeichen" aria-hidden="true">×</span> <span>Foto entfernen</span></button>` : ''}`;
  }

  /* Pixel-Paar (`GAMING_FOTO_AN`): Foto, „Wir sehen …" aus dem vorgefüllten Baukasten, Klappe „Figuren anpassen". */
  const gamingWort = (liste, id) => ((gamingAuswahl()[liste] || []).find((o) => o.id === id) || {}).label || '';
  function gamingSatz() {
    const b = s.brief || {};
    const wer = (n) => {
      const teile = [gamingWort('haare', b[`p${n}_haar`]), gamingWort('frisuren', b[`p${n}_frisur`]),
        b[`p${n}_brille`] && b[`p${n}_brille`] !== 'nein' ? `Brille ${gamingWort('brille', b[`p${n}_brille`])}` : '',
        b[`p${n}_bart`] && b[`p${n}_bart`] !== 'kein' ? `Bart ${gamingWort('bart', b[`p${n}_bart`])}` : '']
        .filter(Boolean).map((t) => t.toLowerCase());
      return `${n === 1 ? 'Links' : 'rechts'}: ${teile.join(', ')}`;
    };
    return `${wer(1)} · ${wer(2)}`;
  }
  function gamingfotoZeichnen(feld) {
    const text = paarfoto.status === 'laedt' ? 'Wir schauen uns euer Foto an …' : paarfoto.text;
    const ok = paarfoto.status === 'ok';
    feld.innerHTML = `
      ${paarfoto.bild ? `<div class="fotofeld__bild"><img src="${attr(paarfoto.bild)}" alt="Euer Foto"></div>` : ''}
      <!-- 🆕 30.10.2026 nachts (Saschas »A, wie Moment«): wie Moment und Linie — Foto-Knopf mit kurzem Hinweis, darunter
           der graue Kasten „Kein Foto zur Hand?“, der den Baukasten mit der Avatar-Vorschau öffnet. ⏪ Davor zwei
           gleich große Knöpfe mit „oder“ (Sascha: „nimmt zu viel Platz weg … wirkt wie ein eigener Abschnitt“). -->
      <label class="echoa-aktion echoa-aktion--leise fotofeld__knopf">
        <input type="file" accept="image/*" data-paarfoto-datei hidden>
        <span>${paarfoto.bild ? 'Anderes Foto wählen' : 'Foto von euch zwei wählen'}</span>
      </label>
      <p class="feld-hilfe">Wir übernehmen Haare, Frisur, Brille und Bart. Ändern könnt ihr alles.</p>
      <p class="feld-hilfe fotofeld__rechte">Mit dem Hochladen bestätigst du, dass ihr beide einverstanden seid.</p>
      ${text ? `<p class="feld-hilfe fotofeld__meldung${['nein', 'fehler'].includes(paarfoto.status)
        ? ' fotofeld__meldung--warnung' : ''}" role="status">${escape(text)}</p>` : ''}
      ${ok ? `<p class="paarfeld__satz"><b>Wir sehen:</b> ${escape(gamingSatz())}</p>
        <details class="anders ohne-klappe"${gamingFotoOffen ? ' open' : ''}><summary class="anders__kopf" data-gaming-anpassen>
          <span class="anders__titel">Figuren anpassen</span>
          <span class="anders__zusatz">Haare, Haut, Brille, Bart, Kleidung</span></summary></details>
        <button type="button" class="listenknopf" data-paarfoto-weg>
          <span class="listenknopf__zeichen" aria-hidden="true">×</span> <span>Foto entfernen</span></button>`
      : `<details class="anders ohne-klappe gaming-klappe"${gamingFotoOffen ? ' open' : ''}><summary class="anders__kopf"
          data-gaming-anpassen><span class="anders__titel">Kein Foto zur Hand?</span>
          <span class="anders__zusatz">Gestaltet eure Figuren selbst</span></summary></details>`}`;
    gamingMaskeZeichnen(briefHalter());
  }
  /** Den Baukasten aus dem Foto-Vorschlag vorfüllen (IDs aus `a5_paar` → `gaming_satz`). Nur, was der Vorschlag kennt. */
  function gamingVorbelegen(v) {
    const halter = briefHalter();
    if (!halter || !v) return;
    const HAAR = { schwarz: 'schwarz', dunkelbraun: 'dunkelbraun', mittelbraun: 'hellbraun', hellbraun: 'hellbraun',
      dunkelblond: 'blond', blond: 'blond', hellblond: 'blond', rot: 'rot', grau: 'grau', weiss: 'grau' };
    const FRISUR = { kurz: 'sehr_kurz', kurz_scheitel: 'seitenscheitel', mittel: 'mittel', lang: 'lang_glatt',
      locken: 'lang_lockig', zopf: 'lang_glatt', dutt: 'dutt', glatze: 'glatze' };
    const HAUT = { hell: 'hell', mittel: 'mittel', dunkel: 'dunkel' };
    const BRILLE = { keine: 'nein', rund: 'ja', eckig: 'ja' };
    /* „Stoppeln" im Foto reicht von kaum sichtbar bis Dreitagebart (Saschas Kommentare 30.10.2026) — eigene Stufe. */
    const BART = { keiner: 'kein', stoppel: 'stoppel', kinn: 'kurz', kurz: 'kurz', voll: 'voll' };
    const chip = (name, wert) => {
      if (!wert) return;
      const knoepfe = halter.querySelectorAll(`[data-brieffeld="${name}"]`);
      if (!Array.from(knoepfe).some((b) => b.dataset.wert === wert)) return;
      knoepfe.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.wert === wert)));
    };
    [1, 2].forEach((n) => {
      const q = v[`p${n}`] || {};
      /* `gaming`: Frisur, Bart und Brillenfarbe in Baukasten-Werten, am Kopf gelesen (`dienst._gaming_foto_lesen`) —
         sie schlagen die Übersetzung aus der Paar-Prüfung (Saschas Kommentare 30.10.2026). */
      const g = (q.gaming && typeof q.gaming === 'object') ? q.gaming : {};
      chip(`p${n}_haar`, HAAR[q.haarfarbe]);
      /* Locken beim Mann mit dunkler Haut: kurzer Afro (Sascha 30.10.2026: „lang, lockig" etwas zu lang, „sehr kurz"
         schor ihn). Sonst „lang, lockig" wie bisher. */
      chip(`p${n}_frisur`, g.frisur || (q.frisur === 'locken' && ['männlich', 'maennlich'].includes(q.geschlecht)
        && q.hautton === 'dunkel' ? 'afro_kurz' : FRISUR[q.frisur]));
      chip(`p${n}_haut`, HAUT[q.hautton]);
      /* Brillenfarbe aus dem Foto (`dienst._gaming_foto_lesen`, Saschas Kommentar 30.10.2026), sonst schwarz. */
      chip(`p${n}_brille`, BRILLE[q.brille] === 'nein' ? 'nein' : (g.brille || BRILLE[q.brille]));
      chip(`p${n}_bart`, g.bart || BART[q.bart]);
      chip(`p${n}_figur`, { weiblich: 'taille', 'männlich': 'gerade', maennlich: 'gerade' }[q.geschlecht]);
    });
  }

  function paarfotoZeichnen() {
    const feld = $('[data-paarfotofeld]');
    if (!feld) return;
    if (D.produkt.handle === 'portraet') { portraetfotoZeichnen(feld); return; }
    if (istGaming()) { gamingfotoZeichnen(feld); return; }
    const p = paarfoto.paar || paarLeer();
    /* Linien-Seite: gezeichnet wird nur aus einem Foto — ohne Foto gibt es dort nichts zu zeichnen. */
    const mussFoto = !OHNE_FOTO_AN && (PAARFOTO_NUR_MIT_FOTO.includes(s.brief.look) || D.produkt.handle === 'linie');
    const ok = paarfoto.status === 'ok';
    /* Fehlt ein Geschlecht (Dienst „unklar"), steht die Auswahl offen — sonst sperrte die Prüfung den Knopf mit
       einer Meldung zu Knöpfen, die nicht zu sehen sind (code-pruefer 27.10.2026). */
    if (ok && (!(p.p1 || {}).geschlecht || !(p.p2 || {}).geschlecht)) paarfoto.offen = true;
    const zeile = (titel, inhalt) => `<div class="paarfeld__zeile"><p class="feld-hilfe">${titel}</p>${inhalt}</div>`;
    const person = (k, titel) => `<div class="paarfeld__person"><p class="paarfeld__kopf">${titel}</p>
      ${zeile('Person', paarChips(`${k}.geschlecht`, PAAR_PERSON, (p[k] || {}).geschlecht))}
      ${paarMitHaut() ? zeile('Hautton', paarFarben(`${k}.hautton`, paarHaut(p[k]), PAAR_HAUT)) : ''}
      ${ok ? zeile('Haarfarbe', paarFarben(`${k}.haarfarbe`, (p[k] || {}).haarfarbe))
        + Object.entries({ frisur: 'Frisur', brille: 'Brille', bart: 'Bart', statur: 'Statur' }).map(([w, t]) =>
          zeile(t, paarChips(`${k}.${w}`, PAAR_WAHL[w], (p[k] || {})[w]))).join('') : ''}</div>`;
    const auswahl = OHNE_FOTO_AN ? paarTabelle(p, ok) : `<div class="paarfeld__auswahl">${person('p1', 'Person links')}${person('p2', 'Person rechts')}
      ${ok ? zeile('Wer ist größer?', paarChips('groesse', PAAR_GROESSE, p.groesse))
        /* Linien-Seite: Kleidung ist dort nur eine Kragenlinie — keine Wahl. */
        + (D.produkt.handle === 'linie' ? '' : zeile('Kleidung', paarChips('stil', PAAR_STIL, p.stil))) : ''}</div>`;
    const text = paarfoto.status === 'laedt' ? 'Wir schauen uns euer Foto an …' : paarfoto.text;
    feld.innerHTML = `
      ${paarfoto.bild ? `<div class="fotofeld__bild"><img src="${attr(paarfoto.bild)}" alt="Euer Foto"></div>` : ''}
      <label class="echoa-aktion echoa-aktion--leise fotofeld__knopf">
        <input type="file" accept="image/*" data-paarfoto-datei hidden>
        <span>${paarfoto.bild ? 'Anderes Foto wählen' : 'Foto von euch beiden wählen'}</span>
      </label>
      ${/* Sascha, 30.10.2026: das Foto muss nicht vom Ort stammen — Ort und Moment fragt die Maske getrennt ab. */''}
      <p class="feld-hilfe">${D.produkt.handle === 'momentaufnahme'
        ? 'Ein Selfie reicht, egal wo es entstand – Hauptsache, man erkennt euch beide gut. Den Ort zeichnen wir nach euren Angaben, euch von hinten, ohne Gesichter.'
        : 'Ein Selfie reicht. Wir zeichnen euch von hinten, ohne Gesichter.'}</p>
      <p class="feld-hilfe fotofeld__rechte">Mit dem Hochladen bestätigst du, dass ihr beide einverstanden seid.</p>
      ${text ? `<p class="feld-hilfe fotofeld__meldung${['nein', 'fehler'].includes(paarfoto.status)
        ? ' fotofeld__meldung--warnung' : ''}" role="status">${escape(text)}</p>` : ''}
      ${ok ? `<p class="paarfeld__satz"><b>Wir sehen:</b> ${escape(paarSatz(p))}
          <button type="button" class="paarfeld__aendern" data-paarfoto-aendern
            aria-expanded="${String(paarfoto.offen)}">${paarfoto.offen ? 'fertig' : 'ändern'}</button></p>
        ${paarfoto.offen ? auswahl : ''}
        <button type="button" class="listenknopf" data-paarfoto-weg>
          <span class="listenknopf__zeichen" aria-hidden="true">×</span> <span>Foto entfernen</span></button>`
      : OHNE_FOTO_AN ? `<details class="anders ohne-klappe"${ohneKlappe ? ' open' : ''}>
          <summary class="anders__kopf" data-ohne-klappe><span class="anders__titel">Kein Foto zur Hand?</span>
            <span class="anders__zusatz">Beschreibt euch selbst – dauert 20 Sekunden</span></summary>
          <div class="anders__inhalt ohne-klappe__inhalt">${ohneKlappe ? auswahl : ''}</div></details>`
      : (mussFoto ? '' : `<p class="feld-hilfe">Ohne Foto: Wer seid ihr zwei?</p>${auswahl}`)}`;
  }

  async function paarfotoGewaehlt(input) {
    const datei = input.files && input.files[0];
    input.value = '';
    if (!datei) return;
    paarfoto = { ...paarfoto, id: '', status: 'laedt', text: '', bild: '', ohne: false };
    let daten = '';
    try {
      daten = await fotoVerkleinern(datei);
    } catch (e) {
      paarfoto = { ...paarfoto, status: 'fehler',
                   text: 'Dieses Foto können wir nicht öffnen. Bitte ein JPG- oder PNG-Foto wählen.' };
      paarfotoZeichnen(); eingabeGeaendert(); return;
    }
    paarfoto.bild = daten;
    paarfotoZeichnen();
    eingabeGeaendert();
    const nr = ++paarfotoNr;
    let a = null;
    const abbruch = new AbortController();
    const uhr = setTimeout(() => abbruch.abort(), FOTO_ABBRUCH_MS);
    try {
      const r = await fetch(`${BACKEND}/api/moment/foto`, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({ bild: daten, produkt: D.produkt.handle }),
        signal: abbruch.signal,
      });
      a = await r.json().catch(() => ({}));
      if (!r.ok) a = { status: 'fehler', text: a.fehler || 'Das Foto konnte nicht geprüft werden.' };
    } catch (e) {
      a = { status: 'fehler', text: 'Das Foto ist nicht angekommen. Bitte noch einmal versuchen.' };
    }
    clearTimeout(uhr);
    if (nr !== paarfotoNr) return;                 // entfernt oder ein neueres Foto läuft
    const ok = a.status === 'ok';
    paarfoto = { ...paarfoto, id: ok ? (a.foto_id || '') : '', status: a.status || 'fehler', text: a.text || '',
                 paar: ok ? paarAusVorschlag(a.vorschlag) : paarfoto.paar, offen: false,
                 /* Porträt: „Wir sehen …" aus dem Dienst (`portraet.wir_sehen`), nur Anzeige. */
                 satz: ok && a.vorschlag && typeof a.vorschlag.satz === 'string' ? a.vorschlag.satz : '' };
    /* Pixel-Paar: der Vorschlag füllt den Baukasten vor; vor dem Zeichnen sammeln, damit „Wir sehen …" ihn zeigt. */
    if (ok && istGaming()) { gamingFotoOffen = false; gamingVorbelegen(a.vorschlag); sammleBrief(); }
    paarfotoZeichnen();
    eingabeGeaendert();
  }

  /** Klicks im Feld »paarfoto« — true, wenn hier behandelt. */
  function paarfotoKlick(e) {
    if (!e.target.closest('[data-paarfotofeld]')) return false;
    if (e.target.closest('[data-paarfoto-weg]')) {
      paarfoto = { id: '', status: 'leer', text: '', bild: '', paar: null, offen: false, ohne: false };
      paarfotoNr++;                                   // eine laufende Prüfung verwerfen
    } else if (e.target.closest('[data-paarfoto-aendern]')) {
      paarfoto.offen = !paarfoto.offen;
    } else if (e.target.closest('[data-gaming-anpassen]')) {
      e.preventDefault();
      gamingFotoOffen = !gamingFotoOffen;
      paarfotoZeichnen();
      return true;                                    // keine Briefänderung
    } else if (e.target.closest('[data-ohne-klappe]')) {
      /* Die Klappe zeichnet sich neu — der Zustand steht in `ohneKlappe`, nicht im `details`. */
      e.preventDefault();
      ohneKlappe = !ohneKlappe;
      ohneWahl = '';
      paarfotoZeichnen();
      return true;                                    // keine Briefänderung
    } else if (e.target.closest('[data-paar-farbe]')) {
      const f = e.target.closest('[data-paar-farbe]').dataset.paarFarbe;
      ohneWahl = ohneWahl === f ? '' : f;
      paarfotoZeichnen();
      return true;
    } else {
      const b = e.target.closest('[data-paar]');
      if (!b) return false;
      const p = paarfoto.paar || paarLeer();
      const [k, w] = b.dataset.paar.split('.');
      if (w) p[k] = { ...(p[k] || {}), [w]: b.dataset.wert };
      else p[k] = b.dataset.wert;
      paarfoto.paar = p;
      ohneWahl = '';
    }
    paarfotoZeichnen();
    eingabeGeaendert();
    return true;
  }

  /* --- Strecke: GENAU EINE GPX-Datei (17.10.2026) ---------------------------
     Gelesen wird im Browser als Text, geprüft und vereinfacht im Backend
     (`POST /api/strecke/datei`, `strecke.gpx_lesen`). Die Rohdatei mit
     Zeitstempeln und Puls bleibt nirgends liegen.
     🔴 KEIN `accept=".gpx"` am Feld: iOS kennt den Dateityp nicht und graut
     GPX-Dateien in der Auswahl sonst aus. Was keine GPX ist, sagt das Backend.
     Der Infotext ist der Recherche-Stand vom 16.10.2026 (Strava und Garmin
     Connect exportieren nur im Browser, Komoots Android-App kann es) —
     bewusst ohne Garantie, die Anbieter ändern ihre Menüs. */
  /* 🆕 SCREENSHOT STATT GPX (19.10.2026, Saschas Klarstellung: einbauen, am Kunden
     testen). Dasselbe Feld nimmt auch einen Screenshot der Karte aus der App;
     gelesen wird im Backend (`POST /api/strecke/bild`, `screenshot.lesen`), das
     Bild bleibt dort nirgends liegen. Ist das Backend nicht sicher, kommt eine
     Rückfrage statt einer Linie (`status: 'rueckfrage'`) — sie sperrt den Entwurf
     NICHT: der Kunde kann oben Orte nennen oder die GPX nachreichen.
     🔴 Angeboten wird der Screenshot nur, wenn `/puls` → `strecke_bild` meldet:
     das Theme darf vor dem Dienst live gehen, ohne einen toten Weg zu zeigen.
     🔴 Zeitangabe VOR dem Lesen (Sascha 18.10.2026: „höchstens 2 Minuten bis zur
     Vorschau, sonst muss der Kunde vorher eine Zeitangabe sehen"). */
  /* Größte Datei — Spiegel von `strecke.DATEI_MAX_BYTES`. Höchstwartezeit:
     JA gegen eine hängende Verbindung (eine 15-MB-Datei braucht am Handy
     ~10–30 s Upload); NEIN als erwartete Dauer. */
  const DATEI_MAX_BYTES = 15 * 1024 * 1024;
  const DATEI_ABBRUCH_MS = 90000;
  /* Screenshot — Spiegel von `dienst.STRECKE_BILD_MAX_BYTES`. Größer oder kein
     PNG/JPG (HEIC): einmal im Browser als JPEG neu kodieren, NICHT verkleinern
     (die Erkennung misst in Bildpunkten), nur über BILD_MAX_KANTE begrenzen.
     Höchstwartezeit: JA unter der Frist von Cloud Run (300 s) mit Luft für den
     Upload; NEIN als erwartete Dauer (gemessen siehe BILD_DAUER_TEXT). */
  const BILD_MAX_BYTES = 12 * 1024 * 1024;
  const BILD_MAX_KANTE = 4000;
  const BILD_ABBRUCH_MS = 270000;
  /* Was der Kunde VOR dem Lesen über die Dauer erfährt. Gemessen am Live-Server
     19.10.2026: 37–46 s je Bild (3 erkannte Apple-Screenshots,
     `pipeline/strecke/screenshot_live_messen.py`). ⏪ Bis dahin „etwa 1–2 Minuten" als
     Annahme aus der Mac-Messung. */
  const BILD_DAUER_TEXT = 'etwa eine Minute';
  let streckeBildBereit = false;

  function dateiLabel(f) {
    return streckeBildBereit ? 'Datei oder Screenshot aus deiner Uhr/App' : f.label;
  }

  function dateiFeldHtml(f, hilfe) {
    return `<p class="feld-label"><span data-gpx-label data-label-gpx="${attr(f.label)}">${escape(dateiLabel(f))}</span> <span class="feld-label__optional">(optional)</span></p>${hilfe}
      <div class="fotofeld" data-gpxfeld>
        <label class="echoa-aktion echoa-aktion--leise fotofeld__knopf">
          <input type="file" data-gpx-datei hidden>
          <span data-gpx-knopftext>${streckeBildBereit ? 'Datei oder Screenshot wählen' : 'GPX-Datei wählen'}</span>
        </label>
        <p class="feld-hilfe" data-gpx-bildhinweis ${streckeBildBereit ? '' : 'hidden'}>Screenshot der Karte aus Strava, Garmin,
          Komoot oder Apple Fitness: Das Lesen dauert ${BILD_DAUER_TEXT}. Die GPX-Datei geht sofort.</p>
        <p class="feld-hilfe fotofeld__meldung" data-gpx-meldung role="status" hidden></p>
        <button type="button" class="listenknopf" data-gpx-weg hidden>
          <span class="listenknopf__zeichen" aria-hidden="true">×</span> <span data-gpx-wegtext>Datei entfernen</span>
        </button>
        <details class="feld-hilfe datei-anleitung">
          <summary><span class="datei-anleitung__zeichen" aria-hidden="true">i</span>
            So bekommst du die Datei aus Strava, Garmin, Komoot oder Apple</summary>
          <p>Strava und Garmin Connect: im Browser (nicht in der App) die Aktivität öffnen und
             als GPX exportieren. Komoot: die Tour öffnen und als GPX herunterladen – im Browser,
             in der Android-App auch. Apple Fitness hat keinen eigenen Export; Apps wie HealthFit
             sichern eine Aktivität als GPX. Ohne Gewähr – die Anbieter ändern ihre Menüs.</p>
          <p data-gpx-bildanleitung ${streckeBildBereit ? '' : 'hidden'}>Einfacher: ein Screenshot der Karte in deiner App. Die ganze
             Strecke sollte darauf zu sehen sein, gern mit Straßennamen. Wir legen sie dann auf die
             echten Straßen.</p>
          <p>Ohne Datei geht es auch: schreib oben, wo du gelaufen oder gefahren bist.</p>
        </details>
      </div>`;
  }

  /** Sekunden als „0:42" — für die laufende Uhr beim Screenshot. */
  function uhrText(sek) {
    return `${Math.floor(sek / 60)}:${String(sek % 60).padStart(2, '0')}`;
  }

  function dateiZeichnen() {
    const feld = $('[data-gpxfeld]');
    if (!feld) return;
    const label = $('[data-gpx-label]');
    if (label) label.textContent = streckeBildBereit ? dateiLabel({}) : label.dataset.labelGpx;
    feld.querySelector('[data-gpx-bildhinweis]').hidden = !streckeBildBereit || datei.status === 'ok';
    feld.querySelector('[data-gpx-bildanleitung]').hidden = !streckeBildBereit;
    const meldung = feld.querySelector('[data-gpx-meldung]');
    let text = datei.meldung;
    if (datei.status === 'laedt') {
      text = datei.bild
        ? `Wir lesen die Karte auf deinem Screenshot … ${uhrText(datei.sekunden || 0)} – `
          + `das dauert ${BILD_DAUER_TEXT}. Lass die Seite bitte so lange offen.`
        : 'Wir lesen deine Datei …';
    }
    meldung.hidden = !text;
    meldung.textContent = text || '';
    meldung.classList.toggle('fotofeld__meldung--warnung',
      datei.status === 'fehler' || datei.status === 'rueckfrage');
    feld.querySelector('[data-gpx-knopftext]').textContent = datei.status === 'ok'
      ? (datei.bild ? 'Anderes Bild oder Datei wählen' : 'Andere Datei wählen')
      : (streckeBildBereit ? 'Datei oder Screenshot wählen' : 'GPX-Datei wählen');
    feld.querySelector('[data-gpx-wegtext]').textContent = datei.bild ? 'Bild entfernen' : 'Datei entfernen';
    /* Entfernen auch nach Fehler oder Rückfrage — sonst bleibt eine gescheiterte
       Datei stehen und sperrt den Entwurf (code-pruefer 19.10.2026). */
    feld.querySelector('[data-gpx-weg]').hidden = ['leer', 'laedt'].includes(datei.status);
  }

  /** Ein Bild (kein GPX)? Am Typ — iOS liefert Screenshots als image/png — oder an der Endung. */
  function istBildDatei(f) {
    return /^image\//.test(f.type || '') || /\.(png|jpe?g|heic|heif|webp)$/i.test(f.name || '');
  }

  /** Screenshot → Data-URL. PNG/JPG bis BILD_MAX_BYTES unverändert, sonst einmal
      als JPEG neu kodiert (HEIC über den Browser) — in voller Größe bis BILD_MAX_KANTE. */
  function bildVorbereiten(f) {
    if (/^image\/(png|jpeg)$/.test(f.type || '') && f.size <= BILD_MAX_BYTES) {
      return new Promise((fertig, fehler) => {
        const leser = new FileReader();
        leser.onload = () => fertig(String(leser.result || ''));
        leser.onerror = () => fehler(new Error('Bild nicht lesbar'));
        leser.readAsDataURL(f);
      });
    }
    return new Promise((fertig, fehler) => {
      const url = URL.createObjectURL(f);
      const img = new Image();
      img.onload = () => {
        const k = Math.min(1, BILD_MAX_KANTE / Math.max(img.naturalWidth, img.naturalHeight));
        const c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * k);
        c.height = Math.round(img.naturalHeight * k);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        fertig(c.toDataURL('image/jpeg', 0.92));
      };
      img.onerror = () => { URL.revokeObjectURL(url); fehler(new Error('Bild nicht lesbar')); };
      img.src = url;
    });
  }

  async function dateiGewaehlt(input) {
    const f = input.files && input.files[0];
    input.value = '';
    if (!f) return;
    const bild = istBildDatei(f);
    if (bild && !streckeBildBereit) {
      datei = { id: '', status: 'fehler', name: f.name,
                meldung: 'Bitte wähle die GPX-Datei aus deiner Uhr – ein Bild können wir hier noch nicht lesen.' };
      dateiZeichnen(); eingabeGeaendert(); return;
    }
    if (!bild && f.size > DATEI_MAX_BYTES) {
      datei = { id: '', status: 'fehler', name: f.name,
                meldung: 'Die Datei ist zu groß (höchstens 15 MB).' };
      dateiZeichnen(); eingabeGeaendert(); return;
    }
    datei = { id: '', status: 'laedt', meldung: '', name: f.name, bild, sekunden: 0 };
    dateiZeichnen();
    eingabeGeaendert();
    const nr = ++dateiNr;
    let a = null;
    const abbruch = new AbortController();
    const uhr = setTimeout(() => abbruch.abort(), bild ? BILD_ABBRUCH_MS : DATEI_ABBRUCH_MS);
    const start = Date.now();
    const ticker = bild ? setInterval(() => {
      if (nr !== dateiNr) return;
      datei.sekunden = Math.round((Date.now() - start) / 1000);
      dateiZeichnen();
    }, 1000) : null;
    try {
      let koerper;
      if (bild) {
        let daten = '';
        try {
          daten = await bildVorbereiten(f);
        } catch (e) {
          a = { fehler: 'Dieses Bild können wir nicht öffnen. Bitte einen Screenshot als PNG oder JPG wählen.' };
        }
        koerper = daten ? JSON.stringify({ produkt: D.produkt.handle, bild: daten }) : null;
      } else {
        koerper = JSON.stringify({ produkt: D.produkt.handle, gpx: await f.text() });
      }
      if (koerper) {
        const r = await fetch(`${BACKEND}/api/strecke/${bild ? 'bild' : 'datei'}`, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: koerper,
          signal: abbruch.signal,
        });
        const j = await r.json().catch(() => ({}));
        a = r.ok ? j : { fehler: j.fehler || (bild ? 'Das Bild konnte nicht gelesen werden.'
          : 'Die Datei konnte nicht gelesen werden.') };
      }
    } catch (e) {
      a = { fehler: bild
        ? 'Das Lesen hat zu lange gedauert oder ist abgebrochen. Bitte noch einmal versuchen – oder lade die Datei aus deiner Uhr hoch.'
        : 'Die Datei ist nicht angekommen. Bitte noch einmal versuchen.' };
    }
    clearTimeout(uhr);
    if (ticker) clearInterval(ticker);
    if (nr !== dateiNr) return;                    // eine neuere Datei läuft
    if (a && a.datei_id) {
      datei = { id: a.datei_id, status: 'ok', name: f.name, bild, meldung: a.meldung || '' };
    } else if (a && a.rueckfrage) {
      datei = { id: '', status: 'rueckfrage', name: f.name, bild, meldung: a.rueckfrage };
    } else {
      datei = { id: '', status: 'fehler', name: f.name, bild, meldung: (a && a.fehler) || '' };
    }
    dateiZeichnen();
    eingabeGeaendert();
  }
  let dateiNr = 0;

  /** Einmal beim Laden: kennt der Dienst den Screenshot-Weg? Scheitert die Frage,
      bleibt es beim GPX-Feld — der Kaufweg hängt nicht daran. */
  function streckeBildPruefen() {
    if (!BACKEND || !D.produkt || D.produkt.handle !== 'strecke') return;
    fetch(`${BACKEND}/puls`)
      .then((r) => (r.ok ? r.json() : null))
      .then((p) => {
        streckeBildBereit = Boolean(p && p.strecke_bild);
        dateiZeichnen();
      })
      .catch(() => {});
  }

  /* --- Strecke: Satz nach dem Andruck (17.10.2026) -------------------------
     Zeit, Namen, Ort, Distanz, Datum, Zeile bzw. Titel → `POST
     /api/kandidat/<id>/strecke` setzt den GEZEIGTEN Andruck neu (0 $, ohne
     Kartenabruf, 1–3 s). Nutzt den Zustand des Chronik-Umzeichnens
     (`umzeichnenOffen`), damit `inDenWarenkorb()` auf die Antwort wartet. */
  /* Höchstwartezeit eines Satz-Wechsels. JA gegen eine hängende Verbindung,
     die den Warenkorb festhielte (gemessen 1–3 s, ohne Netzabruf); NEIN als
     erwartete Dauer. */
  const STRECKE_SATZ_ABBRUCH_MS = 30000;
  /* Vorschläge der KI in die Felder — nur, wo der Kunde nichts Eigenes stehen
     hat oder der Wert vom letzten Vorschlag stammt (Muster Foto-Vorschlag). */
  let streckeVorschlag = {};
  /* `data-eigen` setzt nur ein echter Tastendruck (19.10.2026) — was der Kunde nicht
     selbst getippt hat, ist ein Vorschlag und darf ersetzt werden. Den Altwert vor dem
     Absenden leert `andruck` (dort die Begründung). */
  function streckeVorschlagEinsetzen(v) {
    const halter = briefHalter();
    if (!halter || !v) return;
    Object.keys(v).forEach((name) => {
      const el = halter.querySelector(`[data-feld="${name}"]`);
      if (!el) return;
      const jetzt = el.value.trim();
      if (!jetzt || jetzt === (streckeVorschlag[name] || '') || el.dataset.eigen !== '1') {
        el.value = v[name] || '';
      }
    });
    streckeVorschlag = { ...v };
    $$('[data-waechst]').forEach(wachsen);
    sammleBrief();
  }

  /* Die Satz-Felder GANZ auf eine Fassung setzen (Rückweg zu einem Entwurf). */
  function streckeFelderSetzen(felder) {
    const halter = briefHalter();
    if (!halter || !felder) return;
    Object.keys(felder).forEach((name) => {
      const el = halter.querySelector(`[data-feld="${name}"]`);
      if (el) el.value = felder[name] || '';
    });
    streckeVorschlag = { ...felder };
    $$('[data-waechst]').forEach(wachsen);
    sammleBrief();
  }

  function streckeSatzAnstossen(auffuellen = false) {
    if (!umzeichnenOffen) {
      umzeichnenOffen = new Promise((fertig) => { umzeichnenErledigt = fertig; });
    }
    const nr = ++umzeichnenNr;
    const vonId = s.kandidatId;
    tafelLaedt(true);
    clearTimeout(umzeichnenUhr);
    umzeichnenUhr = setTimeout(() => streckeSatzSenden(nr, vonId, auffuellen),
      UMZEICHNEN_VERZUG_MS);
  }

  async function streckeSatzSenden(nr, vonId, auffuellen = false) {
    if (nr !== umzeichnenNr) return;
    const satz = auffuellen ? { _zuletzt: true } : {};
    if (!auffuellen) {
      STRECKE_SATZ_FELDER.forEach((k) => { if (s.brief[k] !== undefined) satz[k] = s.brief[k]; });
    }
    let a = null;
    let meldung = '';
    const abbruch = new AbortController();
    const uhr = setTimeout(() => abbruch.abort(), STRECKE_SATZ_ABBRUCH_MS);
    try {
      const r = await fetch(
        `${BACKEND}/api/kandidat/${encodeURIComponent(vonId)}/strecke`, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify(satz),
          signal: abbruch.signal,
        });
      const j = await r.json().catch(() => ({}));
      if (r.ok) a = j; else meldung = j.fehler || '';
    } catch (e) { console.error(e); }
    clearTimeout(uhr);
    if (nr !== umzeichnenNr) return;          // ein neuerer Tastendruck wartet
    umzeichnenAbschliessen();
    tafelLaedt(false);
    if (s.kandidatId !== vonId || s.phase !== 'fertig') return;
    if (!a || !a.satz) {
      /* Der Andruck bleibt gültig, nur dieser Satz nicht: der Warenkorb ist
         gesperrt, bis die Angaben passen (`s.streckeSatz` leer). */
      s.streckeSatz = '';
      zeigeMeldung(meldung || 'Das hat gerade nicht geklappt – bitte noch einmal versuchen.');
      zeichne();
      return;
    }
    s.streckeSatz = a.satz;
    if (auffuellen && a.felder) streckeFelderSetzen(a.felder);
    s.kandidatBild = `${BACKEND}${a.vorschau_url}`;
    vorschauSetzen(kandidatBildUrl(s.kandidatBild));
    const fehler = $('[data-fehler]');
    if (fehler) fehler.hidden = true;
    speichernZeigen();
    zeichne();
  }

  /* --- Hinweis direkt an einem Feld (Rezept, 17.10.2026) -------------------
     Sascha, T1 »A«: leere Zutatenliste → „Bitte mindestens eine Zutat
     eintragen" AM FELD, nicht nur oben als Meldung. Leerer Text entfernt ihn. */
  /* EINE SEITE (Sascha, 28.10.2026): „Fehlermeldungen werden unten am Knopf ausgegeben, aber auch nochmal direkt
     am Feld, sodass der Kunde beim Hochscrollen direkt sieht, wo er hin muss." Das Feld ist das erste, dessen eigene
     Prüfung (`brieffehler([name])`) anschlägt; die Meldung am Knopf bekommt „Zum Feld", das dorthin scrollt.
     Weg ist der Hinweis beim nächsten Andruck-Versuch oder sobald im Feld etwas geändert wird. */
  /** Eine Seite: die optionalen Felder aus `EINE_SEITE[…].mehr` in einen Klappblock „Mehr aufs Poster" — im
      Formular wie in „Auf dem Poster", je an der Stelle des ersten dieser Felder. Ein Pflichtfeld bleibt draußen. */
  /** Eine Seite, Handy: ein Band oben am Bildschirm mit dem Bild der Bühne, solange die Maske im Blick ist und die Bühne
      selbst fast weggescrollt — Sascha 28.10.2026: „mobile mit einem feststehenden Galeriebild im oberen Bereich des
      Bildschirms (ggf. etwas verkleinert …)", damit Machart und Farbe des Namens ohne Hochscrollen zu sehen sind.
      ⏪ Nicht die kleine Vorschau oben rechts vom 22.10.2026 (Sascha: „mehr störend als nützlich") — ein Band über die
      ganze Breite. Am Desktop zeigt das die klebende linke Spalte (`echoa-pdp.css`, `.eine-seite-modus`). Das Band
      spiegelt das Blatt der Bühne (`[data-tafel="blatt"]`), also Beispiel oder eigenen Entwurf; ein Tipp scrollt hoch. */
  function buehneBandEinrichten() {
    const quelle = document.querySelector('[data-tafel="blatt"] .buehne__bild');
    const links = document.querySelector('.pdp__links');
    if (!quelle || !links || !wurzel || document.querySelector('[data-buehne-band]')
      || !('IntersectionObserver' in window)) return;
    const band = document.createElement('div');
    band.className = 'buehne-band';
    band.dataset.buehneBand = '';
    /* Etikett „Beispiel" bzw. „Dein Entwurf" (Sascha 28.10.2026 am Vorschau-Theme: „Vermerk / Kachel, dass es sich um ein
       Beispiel handelt — die Darstellung verschwimmt gerade noch mit der eigentlichen Maske"). */
    band.innerHTML = `<button type="button" class="buehne-band__knopf" aria-label="Zum großen Bild">
        <span class="buehne-band__bild"><img alt=""><span class="buehne__etikett buehne__etikett--pdp buehne-band__etikett"
          data-band-etikett>Beispiel</span></span></button>`;
    document.body.appendChild(band);
    const img = band.querySelector('img');
    const etikett = band.querySelector('[data-band-etikett]');
    const spiegeln = () => {
      const src = quelle.currentSrc || quelle.getAttribute('src') || '';
      if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      /* Derselbe Test wie `eigenerEntwurf` in `lookBeispielZeigen`. */
      const eigen = /\/api\/kandidat\//.test(src) || Boolean(BACKEND && src.startsWith(BACKEND));
      etikett.textContent = eigen ? 'Dein Entwurf' : 'Beispiel';
    };
    spiegeln();
    new MutationObserver(spiegeln).observe(quelle, { attributes: true, attributeFilter: ['src', 'srcset'] });
    quelle.addEventListener('load', spiegeln);
    let buehneWeg = false;
    let maskeDa = false;
    /* Nur solange die eine Seite gilt: beim Wechsel Orts-Print → Moment (eigene Seite) verschwindet das Band
       (code-pruefer 28.10.2026). */
    const zeigen = () => band.classList.toggle('ist-sichtbar',
      buehneWeg && maskeDa && document.body.classList.contains('eine-seite-modus'));
    /* „Fast weggescrollt" = weniger als 30 % der Bühne im Fenster; darüber sieht der Kunde das große Bild selbst. */
    new IntersectionObserver(([x]) => { buehneWeg = x.intersectionRatio < 0.3; zeigen(); },
      { threshold: [0, 0.3, 1] }).observe(links);
    new IntersectionObserver(([x]) => { maskeDa = x.isIntersecting; zeigen(); }).observe(wurzel);
    band.querySelector('button').addEventListener('click', () => links.scrollIntoView({ behavior: 'smooth', block: 'start' }));
  }
  function eineSeiteKlappen(...behaelter) {
    const e = eineSeite();
    /* Bleibt auch nach dem Andruck (anders als `maske-eine-seite`): die Titelfarbe soll dann nicht auf 4 + 1 springen. */
    wurzel?.classList.toggle('eine-seite-modus', Boolean(e));
    /* Auch am <body>: die Bühne (`.pdp__links`) liegt außerhalb von `wurzel` (Desktop-Regel in `echoa-pdp.css`). */
    document.body.classList.toggle('eine-seite-modus', Boolean(e));
    /* Pixel-Paar hat keine eine Seite (eigener Editor), seine linke Spalte war am Desktop aber genauso höher als das
       Fenster (838 > 800 px, Durchsicht 28.10.2026): dieselbe Begrenzung über eine eigene Klasse (`echoa-pdp.css`). */
    document.body.classList.toggle('buehne-fenster', Boolean(e) || istGaming());
    /* Ohne eine Seite (Wechsel Orts-Print → Moment) das Band sofort wegnehmen — seine Wächter melden sich erst an der
       nächsten Schwelle (code-pruefer Runde 2, 28.10.2026). */
    if (!e) { document.querySelector('[data-buehne-band]')?.classList.remove('ist-sichtbar'); return; }
    buehneBandEinrichten();
    /* `aufsPoster`: hinter den Satz unter „Auf dem Poster", vor das erste Feld dort. */
    const [formKasten, blattKasten] = behaelter;
    if (formKasten && blattKasten && (e.aufsPoster || []).length) {
      const anker = blattKasten.querySelector(':scope > [data-brieffeld-halter]');
      e.aufsPoster.forEach((n) => {
        const w = formKasten.querySelector(`:scope > [data-brieffeld-halter="${n}"]`);
        if (w) blattKasten.insertBefore(w, anker);
      });
    }
    if (!(e.mehr || []).length) return;
    const pflicht = new Set(briefDef().felder.filter((f) => f.pflicht).map((f) => f.name));
    behaelter.filter(Boolean).forEach((b) => {
      const wraps = e.mehr.filter((n) => !pflicht.has(n))
        .map((n) => b.querySelector(`:scope > [data-brieffeld-halter="${n}"]`)).filter(Boolean);
      if (!wraps.length) return;
      const box = document.createElement('details');
      box.className = 'am-blatt__mehr';
      box.dataset.eineSeiteMehr = '';
      box.innerHTML = '<summary>Mehr aufs Poster (optional)</summary>';
      wraps[0].before(box);
      wraps.forEach((w) => box.appendChild(w));
    });
  }
  let feldFehlerName = '';
  function feldFehlerZeigen(text) {
    if (feldFehlerName) { feldHinweis(feldFehlerName, ''); feldFehlerName = ''; }
    $('[data-fehler] [data-zum-feld]')?.remove();
    if (!text) return;
    const fx = briefDef().felder.find((x) => brieffehler([x.name]));
    /* „Ohne Foto brauchen wir die Rasse" kommt aus der Foto-Prüfung, gehört aber ans Rasse-Feld (code-pruefer
       28.10.2026: sonst blieb der Hinweis am Foto stehen, während der Kunde die Rasse tippte). */
    const name = fx && fx.typ === 'foto' && foto.ohne && briefHalter()?.querySelector('[data-brieffeld-halter="rasse"]')
      ? 'rasse' : fx?.name;
    const halterFeld = name && briefHalter()?.querySelector(`[data-brieffeld-halter="${name}"]`);
    if (!halterFeld) return;
    const f = { name };
    feldFehlerName = f.name;
    feldHinweis(f.name, text);
    const weg = () => { if (feldFehlerName === f.name) { feldHinweis(f.name, ''); feldFehlerName = ''; } };
    halterFeld.addEventListener('input', weg, { once: true });
    const tipp = (e) => { if (e.target.closest('button')) { weg(); halterFeld.removeEventListener('click', tipp); } };
    halterFeld.addEventListener('click', tipp);
    const zeile = $('[data-fehler]');
    if (zeile && !zeile.hidden) {
      /* Am Knopf nur der erste Satzteil: „lade es hier hoch oder tippe darunter …" stimmt nur am Feld. */
      const kurz = text.split(' – ')[0].trim().replace(/\s*[.…]?$/, '.');
      zeile.textContent = `${kurz} `;
      zeile.insertAdjacentHTML('beforeend', '<button type="button" data-zum-feld>Zum Feld</button>');
      zeile.querySelector('[data-zum-feld]').addEventListener('click', () => {
        /* Direkt, nicht weich: auf Moment und Orts-Print brach der weiche Bildlauf ab, „Zum Feld“ tat dort nichts
           (gemessen 30.10.2026 am Handy-Format; Sascha: „Fehler sollten mit einem Klick immer direkt zum Feld führen“).
           Danach der Cursor ins Feld, ohne zweiten Sprung. */
        halterFeld.scrollIntoView({ block: 'center' });
        halterFeld.querySelector('input:not([type=hidden]), textarea, select, button')?.focus({ preventScroll: true });
      });
    }
  }
  function feldHinweis(name, text) {
    const halterFeld = briefHalter()?.querySelector(`[data-brieffeld-halter="${name}"]`);
    if (!halterFeld) return;
    let el = halterFeld.querySelector('[data-feld-hinweis]');
    if (!text) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('p');
      el.className = 'feld-hilfe feld-hilfe--warnung';
      el.dataset.feldHinweis = '';
      el.setAttribute('role', 'alert');
      const label = halterFeld.querySelector('.feld-label');
      if (label) label.after(el); else halterFeld.prepend(el);
    }
    el.textContent = text;
  }

  /* --- Rezept: Karteikarte fotografieren (17.10.2026) ----------------------
     Ein Foto der Karte, im Browser verkleinert (`fotoVerkleinern`), dann
     `POST /api/rezept/karte`. Das Textmodell liest Handschrift und
     Schreibmaschine und füllt Titel, Name, Zutaten und Zubereitung VOR —
     unsicher Gelesenes wird am Feld markiert. Alles bleibt editierbar
     (Saschas Pflicht 16.10.2026). Gemessen 5–15 s je Karte. */
  function karteFeldHtml(f, hilfe) {
    return `<p class="feld-label">${escape(f.label)} <span class="feld-label__optional">(optional)</span></p>${hilfe}
      <div class="fotofeld" data-kartefeld>
        <label class="echoa-aktion echoa-aktion--leise fotofeld__knopf">
          <input type="file" accept="image/*" data-karte-datei hidden>
          <span data-karte-knopftext>Karte fotografieren oder Foto wählen</span>
        </label>
        <div class="fotofeld__bild" data-karte-bild hidden></div>
        <p class="feld-hilfe fotofeld__meldung" data-karte-meldung role="status" hidden></p>
      </div>`;
  }

  function karteZeichnen() {
    const feld = $('[data-kartefeld]');
    if (!feld) return;
    const bild = feld.querySelector('[data-karte-bild]');
    const meldung = feld.querySelector('[data-karte-meldung]');
    bild.hidden = !karte.bild;
    if (karte.bild) bild.innerHTML = `<img src="${attr(karte.bild)}" alt="Deine Rezeptkarte">`;
    feld.querySelector('[data-karte-knopftext]').textContent = karte.bild
      ? 'Andere Karte wählen' : 'Karte fotografieren oder Foto wählen';
    let text = '';
    if (karte.status === 'laedt') text = 'Wir lesen deine Karte …';
    else if (karte.status === 'ok') {
      text = karte.unsicher.length
        ? `Fertig – bitte prüfe die markierten Stellen: ${karte.unsicher.map((u) => `„${u}“`).join(', ')}.`
        : 'Fertig – wir haben die Felder unten ausgefüllt. Bitte kurz prüfen.';
      if (karte.meldung) text = `${karte.meldung} ${text}`;
    } else text = karte.meldung || '';
    meldung.hidden = !text;
    meldung.textContent = text;
    meldung.classList.toggle('fotofeld__meldung--warnung',
      ['kein_rezept', 'fehler'].includes(karte.status) || (karte.status === 'ok' && karte.unsicher.length > 0));
  }

  /* Markiert Felder, deren Wert eine unsicher gelesene Stelle enthält. Die
     Markierung geht, sobald der Kunde das Feld anfasst (`input`-Listener). */
  function karteUnsicherMarkieren() {
    const halter = briefHalter();
    if (!halter) return;
    halter.querySelectorAll('.echoa-feld--unsicher').forEach((el) => el.classList.remove('echoa-feld--unsicher'));
    if (karte.status !== 'ok' || !karte.unsicher.length) return;
    halter.querySelectorAll('[data-feld]').forEach((el) => {
      const v = (el.value || '').toLowerCase();
      if (v && karte.unsicher.some((u) => u && v.includes(u.toLowerCase()))) {
        el.classList.add('echoa-feld--unsicher');
      }
    });
  }

  function karteFelderEinsetzen(felder) {
    const halter = briefHalter();
    if (!halter || !felder) return;
    const setz = (name, wert) => {
      const el = halter.querySelector(`[data-feld="${name}"]`);
      if (el && wert) el.value = wert;
    };
    setz('titel', felder.titel);
    setz('von', felder.von);
    /* Das Gericht nur vorschlagen, wenn noch keins dasteht — der Titel der
       Karte („Omas Apfelkuchen") beschreibt es meist gut genug. */
    const gericht = halter.querySelector('[data-feld="gericht"]');
    if (gericht && !gericht.value.trim() && felder.titel) gericht.value = felder.titel;
    setz('zubereitung', felder.zubereitung);
    const def = briefDef().felder.find((f) => f.name === 'zutaten');
    const zutaten = felder.zutaten || [];
    if (def && zutaten.length) {
      const zeilen = Array.from(halter.querySelectorAll('[data-feld="zutaten"]'));
      zeilen.forEach((el, i) => { el.value = zutaten[i] || ''; });
      zeilenOeffnen(halter, def, Math.min(zutaten.length, zeilen.length));
      /* Mehr Zutaten als Zeilen: der Rest steht in der letzten Zeile, nichts
         geht still verloren — das Backend meldet dann „bitte zusammenfassen". */
      if (zutaten.length > zeilen.length && zeilen.length) {
        zeilen[zeilen.length - 1].value = zutaten.slice(zeilen.length - 1).join(', ');
      }
    }
    $$('[data-waechst]').forEach(wachsen);
  }

  async function karteGewaehlt(input) {
    const datei = input.files && input.files[0];
    input.value = '';
    if (!datei) return;
    karte = { id: '', status: 'laedt', meldung: '', unsicher: [], bild: '' };
    try {
      karte.bild = await fotoVerkleinern(datei);
    } catch (e) {
      karte = { ...karte, status: 'fehler',
                meldung: 'Dieses Foto können wir nicht öffnen. Bitte ein JPG- oder PNG-Foto wählen.' };
      karteZeichnen(); eingabeGeaendert(); return;
    }
    karteZeichnen();
    eingabeGeaendert();
    const nr = ++karteNr;
    let a = null;
    const abbruch = new AbortController();
    const uhr = setTimeout(() => abbruch.abort(), FOTO_ABBRUCH_MS);
    try {
      const r = await fetch(`${BACKEND}/api/rezept/karte`, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({ bild: karte.bild }),
        signal: abbruch.signal,
      });
      a = await r.json().catch(() => ({}));
      if (!r.ok) a = { status: 'fehler', meldung: a.fehler || 'Die Karte konnte nicht gelesen werden.' };
    } catch (e) {
      a = { status: 'fehler', meldung: 'Das Foto ist nicht angekommen. Bitte noch einmal versuchen.' };
    }
    clearTimeout(uhr);
    if (nr !== karteNr) return;                     // eine neuere Karte läuft
    karte = { ...karte, id: a.karte_id || '', status: a.status || 'fehler',
              meldung: [a.meldung, a.hinweis].filter(Boolean).join(' '),
              unsicher: a.unsicher || [] };
    if (karte.status === 'ok') karteFelderEinsetzen(a.felder);
    karteZeichnen();
    karteUnsicherMarkieren();
    eingabeGeaendert();
  }
  let karteNr = 0;

  /* --- Rezept: Satz nach dem Andruck (17.10.2026) --------------------------
     Look, Machart und alle Texte → `POST /api/kandidat/<id>/rezept` setzt den
     GEZEIGTEN Andruck neu (0 $; der erste Wechsel auf einen zweifarbigen Look
     bezahlt EINMAL die Bearbeitung, ~20–40 s). Dasselbe Muster wie
     `haustierSatzSenden` (Zustand `umzeichnenOffen`, damit der Warenkorb auf
     die Antwort wartet), bewusst als eigene Funktion: der Haustier-Weg ist
     live und wird hier nicht angefasst. */
  /* Höchstwartezeit eines Satz-Wechsels. Ohne SW ~3–9 s (gemessen 17.10.2026
     am lokalen Dienst), der erste Wechsel auf SW/Aussparung zusätzlich die
     Bearbeitung. JA gegen eine hängende Verbindung; NEIN als erwartete Dauer. */
  const REZEPT_SATZ_ABBRUCH_MS = 120000;
  /* Zuletzt erfolgreich gesetzte Farbe/Machart — Rückfall bei einem Fehlschlag. */
  let rezeptGut = { look: '', machart: '' };
  let rezeptHinweis = '';

  function rezeptChipSetzen(name, wert) {
    const knoepfe = Array.from(document.querySelectorAll(`[data-brieffeld="${name}"]`));
    if (!wert || !knoepfe.some((b) => b.dataset.wert === wert)) return false;
    if (s.brief[name] === wert) return false;
    knoepfe.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.wert === wert)));
    sammleBrief();
    return true;
  }

  function rezeptSatzAnstossen() {
    if (!umzeichnenOffen) {
      umzeichnenOffen = new Promise((fertig) => { umzeichnenErledigt = fertig; });
    }
    const nr = ++umzeichnenNr;
    const vonId = s.kandidatId;
    tafelLaedt(true);
    clearTimeout(umzeichnenUhr);
    umzeichnenUhr = setTimeout(() => rezeptSatzSenden(nr, vonId), UMZEICHNEN_VERZUG_MS);
  }

  async function rezeptSatzSenden(nr, vonId) {
    if (nr !== umzeichnenNr) return;
    sammleBrief();
    const satz = {};
    REZEPT_SATZ_FELDER.forEach((k) => { if (s.brief[k] !== undefined) satz[k] = s.brief[k]; });
    /* Was der Kunde gerade erst ausfüllt, geht nicht ans Backend: wer auf
       „Lexikon-Eintrag" klickt, hat noch keine Bedeutung getippt. Ohne diese
       Sperre käme ein 400 zurück — und der Rückfall unten warf ihn auf
       „Rezept" zurück, bevor er tippen konnte (am Prüfstand 17.10.2026). */
    const offen = satz.machart === 'lexikon'
      && ![1, 2, 3].some((i) => (satz[`bedeutung_${i}`] || '').trim())
      ? 'Für den Lexikon-Eintrag: bitte mindestens eine Bedeutung eintragen.'
      : (!(satz.zutaten || []).length ? REZEPT_LEER_ZUTATEN : '');
    if (offen) {
      umzeichnenAbschliessen();
      tafelLaedt(false);
      s.rezeptSatz = '';
      feldHinweis(satz.machart === 'lexikon' && !(offen === REZEPT_LEER_ZUTATEN)
        ? 'bedeutung_1' : 'zutaten', offen);
      zeichne();
      return;
    }
    feldHinweis('bedeutung_1', '');
    let a = null;
    let meldung = '';
    const abbruch = new AbortController();
    const uhr = setTimeout(() => abbruch.abort(), REZEPT_SATZ_ABBRUCH_MS);
    try {
      const r = await fetch(
        `${BACKEND}/api/kandidat/${encodeURIComponent(vonId)}/rezept`, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify(satz),
          signal: abbruch.signal,
        });
      const j = await r.json().catch(() => ({}));
      if (r.ok) a = j; else meldung = j.fehler || '';
    } catch (e) { console.error(e); }
    clearTimeout(uhr);
    if (nr !== umzeichnenNr) return;          // ein neuerer Klick wartet
    umzeichnenAbschliessen();
    tafelLaedt(false);
    if (s.kandidatId !== vonId || s.phase !== 'fertig') return;
    if (!a || !a.satz) {
      /* Der Andruck bleibt gültig, nur dieser Satz nicht: der Warenkorb ist
         gesperrt, bis die Angaben passen (`s.rezeptSatz` leer). */
      s.rezeptSatz = '';
      if (meldung === REZEPT_LEER_ZUTATEN) feldHinweis('zutaten', meldung);
      zeigeMeldung(meldung || 'Das hat gerade nicht geklappt – bitte noch einmal versuchen.');
      /* Lag es an Farbe oder Machart (SW taugt nicht, Lexikon nicht setzbar),
         zurück auf die letzte gute Wahl und mit den übrigen Angaben neu setzen
         (0 $ — das Backend merkt sich das Scheitern). 🔴 NUR bei genau diesen
         zwei Gründen — eine Textangabe, die nicht passt („bitte kürzen"), ist
         kein Grund, dem Kunden Farbe oder Machart unter der Hand zu ändern. */
      const swWeg = /Schwarz-Weiß und die Akzentfarben/.test(meldung);
      const lexWeg = /Lexikon-Eintrag können wir/.test(meldung);
      const zurueck = (swWeg && satz.look && rezeptGut.look && satz.look !== rezeptGut.look
                       && rezeptChipSetzen('look', rezeptGut.look))
        || (lexWeg && satz.machart && rezeptGut.machart && satz.machart !== rezeptGut.machart
            && rezeptChipSetzen('machart', rezeptGut.machart));
      if (zurueck) {
        rezeptHinweis = meldung || '';
        rezeptSatzAnstossen();
        return;
      }
      rezeptHinweis = '';
      zeichne();
      return;
    }
    s.rezeptSatz = a.satz;
    rezeptGut = { look: a.look || rezeptGut.look, machart: a.machart || rezeptGut.machart };
    s.kandidatBild = `${BACKEND}${a.vorschau_url}`;
    vorschauSetzen(kandidatBildUrl(s.kandidatBild));
    const fehler = $('[data-fehler]');
    if (rezeptHinweis) {
      zeigeMeldung(rezeptHinweis);
      rezeptHinweis = '';
    } else if (fehler) {
      fehler.hidden = true;
    }
    speichernZeigen();
    zeichne();
  }

  /* --- Haustier: Satz nach dem Andruck (16.10.2026) ------------------------
     Machart, Texte, Farbe → `POST /api/kandidat/<id>/haustier` setzt den
     GEZEIGTEN Andruck neu (0 $; der erste Wechsel auf Schwarz-Weiß oder einen
     Akzent bezahlt EINMAL die Bearbeitung, ~20–40 s). Nutzt den Zustand des
     Chronik-Umzeichnens (`umzeichnenOffen`), damit `inDenWarenkorb()` auf
     die Antwort wartet — sonst ginge der alte Satz mit der neuen Zeile. */
  /* Höchstwartezeit eines Satz-Wechsels. Ohne Schwarz-Weiß 1–4 s; der ERSTE
     Wechsel auf SW/Akzent bezahlt die Bearbeitung, gemessen ~40 s (16.10.2026).
     JA gegen eine hängende Verbindung, die den Warenkorb festhielte; NEIN als
     erwartete Dauer. */
  const HAUSTIER_SATZ_ABBRUCH_MS = 120000;
  /* Den Farb-Knopf auf den Look stellen, den das Backend TATSÄCHLICH gesetzt
     hat (code-pruefer 16.10.2026: scheitert die SW-Bearbeitung, zeigt die Bühne
     farbig, der Knopf stand aber auf Schwarz-Weiß — und die Bestellzeile sagte
     „Farbgebung: Schwarz-Weiß", gedruckt würde farbig). */
  function haustierLookSetzen(look) {
    const knoepfe = Array.from(document.querySelectorAll('[data-brieffeld="look"]'));
    if (!look || !knoepfe.some((b) => b.dataset.wert === look)) return false;
    if (s.brief.look === look) return false;
    knoepfe.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.wert === look)));
    sammleBrief();
    return true;
  }
  /* Der zuletzt erfolgreich gesetzte Look — Rückfall, wenn ein Wechsel scheitert. */
  let haustierLookGut = '';
  /* Erklärtext des Rückfalls: er muss den folgenden, erfolgreichen Satz
     ÜBERLEBEN (code-pruefer Runde 2, 16.10.2026: sonst sprang der Farb-Knopf
     „von selbst" zurück, und der Text war nach 1–4 s wieder weg). */
  let haustierHinweis = '';

  function haustierSatzAnstossen() {
    if (!umzeichnenOffen) {
      umzeichnenOffen = new Promise((fertig) => { umzeichnenErledigt = fertig; });
    }
    const nr = ++umzeichnenNr;
    const vonId = s.kandidatId;
    tafelLaedt(true);
    clearTimeout(umzeichnenUhr);
    umzeichnenUhr = setTimeout(() => haustierSatzSenden(nr, vonId), UMZEICHNEN_VERZUG_MS);
  }

  async function haustierSatzSenden(nr, vonId) {
    if (nr !== umzeichnenNr) return;
    const satz = {};
    HAUSTIER_SATZ_FELDER.forEach((k) => { if (s.brief[k] !== undefined) satz[k] = s.brief[k]; });
    let a = null;
    let meldung = '';
    const abbruch = new AbortController();
    const uhr = setTimeout(() => abbruch.abort(), HAUSTIER_SATZ_ABBRUCH_MS);
    try {
      const r = await fetch(
        `${BACKEND}/api/kandidat/${encodeURIComponent(vonId)}/haustier`, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify(satz),
          signal: abbruch.signal,
        });
      const j = await r.json().catch(() => ({}));
      if (r.ok) a = j; else meldung = j.fehler || '';
    } catch (e) { console.error(e); }
    clearTimeout(uhr);
    if (nr !== umzeichnenNr) return;          // ein neuerer Klick wartet
    umzeichnenAbschliessen();
    tafelLaedt(false);
    if (s.kandidatId !== vonId || s.phase !== 'fertig') return;
    if (!a || !a.satz) {
      /* Der Andruck bleibt gültig, nur dieser Satz nicht: der Warenkorb ist
         gesperrt, bis die Angaben passen (`s.haustierSatz` leer). */
      s.haustierSatz = '';
      zeigeMeldung(meldung || 'Das hat gerade nicht geklappt – bitte noch einmal versuchen.');
      /* Lag es an der Farbe (SW-Bearbeitung taugt nicht), zurück auf die
         letzte gute Farbe und mit den übrigen Angaben neu setzen (0 $ — das
         Backend merkt sich das Scheitern). */
      if (haustierLookGut && satz.look && satz.look !== haustierLookGut
          && haustierLookSetzen(haustierLookGut)) {
        haustierHinweis = meldung || '';
        haustierSatzAnstossen();
        return;
      }
      haustierHinweis = '';       // kein Rückfall: der Text steht schon
      zeichne();
      return;
    }
    s.haustierSatz = a.satz;
    haustierLookGut = a.look || haustierLookGut;
    s.kandidatBild = `${BACKEND}${a.vorschau_url}`;
    vorschauSetzen(kandidatBildUrl(s.kandidatBild));
    const fehler = $('[data-fehler]');
    if (haustierHinweis) {
      zeigeMeldung(haustierHinweis);
      haustierHinweis = '';
    } else if (fehler) {
      fehler.hidden = true;
    }
    speichernZeigen();
    zeichne();
  }

  function historieZeichnen() {
    const halter = $('[data-entwuerfe]');
    if (!halter) return;
    const liste = historieLesen();
    /* Ein einzelner Entwurf erscheint nur, wenn er NICHT gerade auf der Bühne steht — dann ist
       er der Rückweg zum eigenen Andruck (Sascha, 19.10.2026, Pixel-Paar: „kein Thumbnail, nur
       der Button für das erneute Erstellen"). ⏪ Bis 19.10.: erst ab zwei Entwürfen. */
    const nurDerGezeigte = liste.length === 1 && liste[0].id === s.kandidatId;
    if (!liste.length || nurDerGezeigte) { halter.hidden = true; halter.innerHTML = ''; return; }
    halter.hidden = false;
    const kacheln = liste.map((e, i) => {
      const eigen = e.handle === D.produkt.handle;
      const aktiv = eigen && e.id === s.kandidatId;
      const beschriftung = eigen
        ? (e.unterzeile || `Entwurf ${liste.length - i}`)
        : e.produkt;
      return `<button type="button" class="entwurf${aktiv ? ' entwurf--aktiv' : ''}"
                data-entwurf="${attr(e.id)}" aria-pressed="${aktiv}"
                title="${attr(eigen ? 'Diesen Entwurf wieder zeigen' : `Zu ${e.produkt} wechseln`)}">
                <img src="${attr(e.vorschau)}" alt="" loading="lazy">
                <span class="entwurf__text">${escape(beschriftung)}</span>
              </button>`;
    }).join('');
    halter.innerHTML =
      `<p class="feld-label entwuerfe__titel">Deine Entwürfe</p>
       <div class="entwuerfe__reihe">${kacheln}</div>
       <p class="feld-hilfe">${HISTORIE_72H ? 'Zwei Wochen lang auf diesem Gerät gemerkt.'
         : 'Nur für diesen Besuch gemerkt – beim Schließen des Tabs sind sie weg.'}</p>`;
  }

  /** Schreibt einen gespeicherten Brief zurück ins Formular.
      🔴 Ohne diesen Schritt zeigte die Bühne Entwurf A und die Bestellzeile
      trüge die Eingaben von B. */
  function briefEinsetzen(brief) {
    const halter = briefHalter();
    if (!halter || !brief) return;
    /* 🔴 NUR SCHREIBEN, WENN SICH ETWAS ÄNDERT (17.08.2026). `el.value = x`
       setzt den Cursor ans Feldende, auch wenn x der bereits stehende Wert
       ist. Seit `eingabeGeaendert()` bei jedem Tastendruck prüft, ob der
       Brief einem gerenderten Stand entspricht, kann diese Funktion MITTEN IM
       TIPPEN laufen — wer ein Zeichen löscht und wieder eintippt, landet
       genau dort. Ohne diesen Vergleich spränge ihm der Cursor weg.
       Dasselbe gilt für die Listen- und Jahresfelder weiter unten. */
    const setzWert = (el, wert) => {
      if (!el) return;
      const neu = wert == null ? '' : String(wert);
      if (el.value !== neu) el.value = neu;
    };
    const setz = (name, wert) =>
      setzWert(halter.querySelector(`[data-feld="${name}"]`), wert);
    briefDef().felder.forEach((f) => {
      if (f.typ === 'namen') {
        /* Rückfall für Briefe, die nur `namen` tragen (z. B. vom Backend
           zurückgeholt, 22.09.2026): „Peter & Gabi" → zwei Felder. */
        let n1 = brief.name1, n2 = brief.name2;
        if (!n1 && !n2 && typeof brief.namen === 'string') {
          [n1 = '', n2 = ''] = brief.namen.split(/\s*&\s*/);
        }
        setz('name1', n1); setz('name2', n2);
        if (f.geschlecht) {
          setz('geschlecht1', brief.geschlecht1);
          setz('geschlecht2', brief.geschlecht2);
        }
      } else if (f.typ === 'paarfoto') {
        /* Rückkehr zu einem Entwurf: Foto-ID und bestätigte Merkmale kommen aus dem Brief, das Bild selbst liegt
           nur im Dienst (kein Vorschaubild). Ohne Foto nur das Geschlecht. Nur schreiben, wenn sich etwas ändert —
           diese Funktion läuft auch mitten im Tippen (s. o.). */
        /* Ein Brief ohne Hautton (Dunkel/Kohle/Strich, ältere Entwürfe) lässt die Wahl stehen, statt sie auf hell
           zurückzusetzen — sonst passte beim Wechsel zurück auf Farbig dessen Entwurf nicht mehr. */
        const haut = (k, h) => h || ((paarfoto.paar || {})[k] || {}).hautton || '';
        const gesch = { p1: { geschlecht: brief.geschlecht1 || '', hautton: haut('p1', brief.hautton1) },
                        p2: { geschlecht: brief.geschlecht2 || '', hautton: haut('p2', brief.hautton2) } };
        const paar = brief.paar && typeof brief.paar === 'object'
          ? { ...paarAusVorschlag(brief.paar), p1: { ...paarAusVorschlag(brief.paar).p1, ...gesch.p1 },
              p2: { ...paarAusVorschlag(brief.paar).p2, ...gesch.p2 } }
          : { ...paarLeer(), ...gesch };
        /* Nie mischen (code-pruefer 27.10.2026): ein ANDERES Foto im Brief ersetzt den Zustand ganz (ohne
           Vorschaubild); ein Brief OHNE Foto nimmt ein angenommenes Foto zurück. Eine laufende Prüfung bleibt —
           diese Funktion läuft auch mitten im Tippen, und dann trägt der Brief das neue Foto noch nicht. */
        const neu = brief.paarfoto_id
          ? (brief.paarfoto_id === paarfoto.id ? { ...paarfoto, paar }
            : { id: brief.paarfoto_id, status: 'ok', text: '', bild: '', paar, offen: false, ohne: false })
          : (paarfoto.status === 'laedt' ? paarfoto
            : { id: '', status: paarfoto.status === 'ok' ? 'leer' : paarfoto.status, text: paarfoto.text,
                bild: paarfoto.status === 'ok' ? '' : paarfoto.bild, paar, offen: false, ohne: false });
        /* Ein zurückgeholter Entwurf ohne Foto mit gewählten Personen öffnet die Klappe — nur hier, nicht bei jedem
           Neuzeichnen (sonst ließe sie sich nicht mehr schließen, code-pruefer 30.10.2026). */
        if (OHNE_FOTO_AN && !neu.id && (brief.geschlecht1 || brief.geschlecht2)) ohneKlappe = true;
        if (JSON.stringify(neu) !== JSON.stringify(paarfoto)) { paarfoto = neu; paarfotoZeichnen(); }
      } else if (f.typ === 'chips' || f.typ === 'stil' || f.typ === 'marker-solo'
                 || f.typ === 'marker') {
        /* Ein älterer Brief kennt ein später hinzugekommenes Feld nicht
           (Verbindungslinien, 15.10.2026) — dann gilt die Vorwahl, sonst
           stünde der Kunde vor „Bitte … ausfüllen" (code-pruefer, BELEGT). */
        /* Klappe-Felder (Pixel-Paar): ein alter Entwurf trägt dort '' (bis 19.10. abends per nurWenn
           geleert) — dann die Vorwahl, sonst meldete `brieffehler` ein unsichtbares Feld als
           fehlend (code-pruefer 19.10.2026, BELEGT). */
        const leer = brief[f.name] === undefined || (f.klappe && brief[f.name] === '');
        const soll = leer && f.vorwahl ? f.vorwahl : brief[f.name];
        halter.querySelectorAll(`[data-brieffeld="${f.name}"]`).forEach((b) => {
          b.setAttribute('aria-pressed', String(b.dataset.wert === soll));
        });
      } else if (f.typ === 'farbmarker') {
        /* Der zusammengesetzte Marker-Wert wird aus den beiden getrennten
           Brief-Feldern REKONSTRUIERT — gespeichert ist der Brief, nicht die
           Oberfläche. Andersherum trüge die Historie eine Schreibweise, die
           das Backend nie sieht, und ein späterer Umbau der Marker machte
           alle gespeicherten Entwürfe unlesbar. */
        const look = brief.look || '';
        const ton = brief[f.tonFeld] || '';
        const soll = look && look !== 'kontrolle' && ton ? `${look}:${ton}` : look;
        halter.querySelectorAll(`[data-brieffeld="${f.name}"]`).forEach((b) => {
          b.setAttribute('aria-pressed', String(b.dataset.wert === soll));
        });
      } else if (f.typ === 'liste') {
        const werte = brief[f.name] || [];
        const jahre = brief[f.name + '_jahre'] || [];
        const felder = Array.from(halter.querySelectorAll(`[data-feld="${f.name}"]`));
        felder.forEach((el, i) => setzWert(el, werte[i] || ''));
        if (f.jahr) {
          Array.from(halter.querySelectorAll(`[data-feld="${f.name}_jahre"]`))
            .forEach((el, i) => setzWert(el, jahre[i] || ''));
        }
        if (f.marke) {
          const marken = brief[f.name + '_marken'] || [];
          Array.from(halter.querySelectorAll(`[data-feld="${f.name}_marken"]`))
            .forEach((el, i) => { el.value = marken[i] || 'ring'; });
        }
        /* 🔴 ZEILEN AUFKLAPPEN, SOWEIT DER GESPEICHERTE BRIEF SIE BRAUCHT.
           Ohne diesen Schritt zeigte ein zurückgeholter Entwurf mit sechs
           Dingen nur die vier Startzeilen — die Bühne trüge sechs Symbole,
           das Formular vier Zeilen, und der nächste Andruck bestellte etwas
           anderes als das gezeigte Bild. Das ist die „zwei Hüllen"-Klasse
           innerhalb eines Formulars. */
        zeilenOeffnen(halter, f, werte.length);
        if (f.jahr) jahrSchalterSetzen(halter, f.name, jahre.some(Boolean));
      } else {
        setz(f.name, brief[f.name]);
      }
    });
    $$('[data-waechst]').forEach(wachsen);
    /* Orts-Print (`ORTS_KLAPPE_AN`): steht im zurückgeholten Brief ein Blick-Satz, öffnet `ortfotoZeichnen` die Klappe —
       sonst reiste der Text unsichtbar in den nächsten Andruck (code-pruefer 30.10.2026). */
    if (ORTS_KLAPPE_AN) ortfotoZeichnen();
  }

  /** Einen gespeicherten Entwurf wieder zeigen.
      @param opt.formularSetzen  Ob der gespeicherte Brief ins Formular
        zurückgeschrieben wird. `true` beim Klick auf eine Entwurfs-Kachel —
        dort weicht der Brief ab, und ohne ihn zeigte die Bühne Entwurf A,
        während die Bestellzeile die Eingaben von B trüge.
        `false` beim Fingerabdruck-Rückweg aus `eingabeGeaendert()`: dort ist
        der Brief bereits inhaltlich derselbe, und ein Schreiben würde nur die
        LAGE der Zeilen verändern (s. dort). */
  function historieWaehlen(id, opt = {}) {
    const e = historieLesen().find((x) => x.id === id);
    if (!e) return;
    if (e.handle !== D.produkt.handle) {
      /* Fremdes Konzept: dort hat das Formular andere Felder. Der Entwurf
         wird auf SEINER PDP wiederhergestellt, nicht hier eingesetzt. */
      const wurzel = window.Shopify?.routes?.root || '/';
      window.location.href = `${wurzel}products/${e.handle}?entwurf=${encodeURIComponent(e.id)}`;
      return;
    }
    /* Ein wartendes Umzeichnen gehört zum bisher gezeigten Entwurf. */
    umzeichnenAbbrechen();
    if (opt.formularSetzen !== false) briefEinsetzen(e.brief);
    briefSichtbar();
    sammleBrief();
    s.kandidatId = e.id;
    s.kandidat = { id: e.id, vorschau_url: '', unterzeile: e.unterzeile };
    s.phase = 'fertig';
    /* Symbol-Raster: `sammleBrief` lief oben noch für den ALTEN Entwurf und las dessen Beschriftungen.
       Ohne zweites Sammeln setzte der Vergleich unten die alten Texte auf den gewählten Entwurf. */
    if (D.produkt.handle === 'icon-grid') sammleBrief();
    /* 🔴 Farbachse (Befund code-pruefer 09.09.2026, T1): der Ton gehört zum
       ENTWURF. Ohne diese Zeile blieb der zuletzt geklickte Ton stehen, die
       Bühne zeigte den bestellten, und die Bestellzeile trug den fremden —
       gedruckt worden wäre eine Farbe, die der Kunde auf diesem Blatt nie
       gesehen hat. */
    s.ton = (e.brief && (e.brief.grund || e.brief.tinte)) || '';
    s.kandidatTon = s.ton;
    /* 🔴 AUS DEM FORMULAR, nicht aus `e.brief` (16.10.2026, Live-Probe über
       `?entwurf=`): der Backend-Brief und `sammleBrief()` beschreiben
       denselben Stand in anderer Form (Jahresfelder, leere Werte) — gegen
       `e.brief` stimmte der Fingerabdruck nie, und jeder Markierungswechsel
       verwarf den Andruck. Das Formular trägt nach `briefEinsetzen` genau
       den Entwurf. */
    s.kartenBasis = kartenSchluessel(s.brief);
    s.kandidatBild = e.vorschau;
    vorschauSetzen(kandidatBildUrl(e.vorschau));
    /* Haustier: der Entwurf wird mit dem AKTUELLEN Satz des Formulars gesetzt
       (Name, Machart, Farbe) — sonst trüge die Bestellzeile einen Satz, den
       die Bühne nicht zeigt. Kostet nichts, das Bild bleibt. */
    if (istSatzH1()) {
      s.haustierBasis = briefSchluessel(s.brief);
      s.haustierSatz = '';
      haustierSatzAnstossen();
    }
    /* Gesetzte Texte: tragen Formular und Entwurf andere (Rückweg über den Fingerabdruck,
       der sie nicht zählt), wird der Entwurf mit den Texten des Formulars gesetzt —
       sonst trüge die Bestellzeile Texte, die das Blatt nicht zeigt. 0 $. */
    if (textSatzAktiv()) {
      s.textBasis = briefSchluessel(s.brief);
      s.textSatzFehlt = false;
      const alt = e.brief || {};
      if (textSatzFelder(s.brief).some((k) => satzWert(alt[k]) !== satzWert(s.brief[k]))) {
        textSatzAnstossen();
      }
    }
    /* Strecke: dasselbe — der Entwurf mit dem aktuellen Satz des Formulars. */
    if (istStrecke()) {
      s.streckeBasis = briefSchluessel(s.brief);
      s.streckeSatz = '';
      /* `zuletzt`: das Backend nennt die zuletzt gesetzte Fassung GENAU
         DIESES Entwurfs, und das Formular übernimmt sie ganz — es trägt auf
         diesem Weg sonst die Felder des zuvor gezeigten anderen Entwurfs
         (code-pruefer Runde 2, 17.10.2026). */
      streckeSatzAnstossen(true);
    }
    if (istRezept()) {
      s.rezeptBasis = briefSchluessel(s.brief);
      s.rezeptSatz = '';
      rezeptSatzAnstossen();
    }
    /* 🔴 Der gewählte Entwurf gehört auf die sichtbare Blatt-Tafel — stand
       die Galerie auf einer Beispiel-Tafel (Farbig/Wörterbuch), blieb sonst
       das Beispiel neben dem Warenkorb-Knopf seines Entwurfs stehen
       (code-pruefer 30.09.2026). Nur dann — ein Raumbild, das der Kunde
       gerade ansieht, bleibt stehen (auch beim Fingerabdruck-Rückweg). */
    const sichtbar = document.querySelector('[data-tafel]:not([hidden])');
    if (sichtbar && /^machart-/.test(sichtbar.dataset.tafel || '')) ansichtWechseln('blatt');
    andruckPanelVerbergen();
    speichernZeigen();
    const fehler = $('[data-fehler]');
    if (fehler) fehler.hidden = true;
    zeichne();
    historieZeichnen();
  }


  /* ============================================ Entwurf per Mail (10.10.2026)

     Sascha »B«: der Kunde schickt sich den Link auf seinen Entwurf, mit
     kleinem Vorschaubild — für den späteren Kauf, oder an den Partner.
     Versand im Backend (`/api/entwurf-mailen`, Resend). Die Adresse wird
     dort NICHT gespeichert.

     🔴 SICHTBAR NUR, WENN ALLES DA IST: ein echter Entwurf (`k_…`, kein
     `sim_`, kein Beispiel), die Phase „fertig" UND das Backend meldet den
     Versand (`/puls` → mail). Fehlt eines davon, bleibt der Block verborgen —
     ein Knopf ohne Funktion an der Kauffläche ist schlechter als keiner
     (genau das stand hier bis zum 10.10.2026). */
  let mailBereit = false;

  function speichernZeigen() {
    const sp = $('[data-speichern]');
    if (!sp) return;
    const echt = s.phase === 'fertig' && /^k_[0-9a-f]{12}$/.test(s.kandidatId || '');
    const zeigen = mailBereit && echt;
    /* Ein anderer Entwurf als beim letzten Öffnen: Formular zurück auf Anfang,
       sonst stünde „ist unterwegs" unter einem Entwurf, der nie verschickt wurde. */
    if (!zeigen || sp.dataset.fuer !== s.kandidatId) mailFormZurueck(sp);
    sp.dataset.fuer = zeigen ? s.kandidatId : '';
    sp.hidden = !zeigen;
  }

  function mailFormZurueck(sp) {
    const form = sp.querySelector('[data-mail-form]');
    const oeffnen = sp.querySelector('[data-mail-oeffnen]');
    if (!form || !oeffnen) return;
    form.hidden = true;
    oeffnen.hidden = false;
    oeffnen.setAttribute('aria-expanded', 'false');
    const meldung = form.querySelector('[data-mail-meldung]');
    if (meldung) { meldung.hidden = true; meldung.textContent = ''; }
    const zeile = form.querySelector('.entwurf-mail__zeile');
    if (zeile) zeile.hidden = false;
    const senden = form.querySelector('[data-mail-senden]');
    if (senden) { senden.disabled = false; senden.textContent = 'Schicken'; }
    /* Ein neuer Entwurf beginnt mit leerem Häkchen — die Einwilligung gehört zu
       dem Entwurf, bei dem sie gegeben wurde. */
    const box = form.querySelector('[data-mail-erinnern]');
    if (box) box.checked = false;
  }

  function mailVerdrahten() {
    const sp = $('[data-speichern]');
    if (!sp || !BACKEND) return;
    const form = sp.querySelector('[data-mail-form]');
    const oeffnen = sp.querySelector('[data-mail-oeffnen]');
    const feld = sp.querySelector('[data-mail-adresse]');
    const senden = sp.querySelector('[data-mail-senden]');
    const meldung = sp.querySelector('[data-mail-meldung]');
    const erinnernZeile = sp.querySelector('[data-mail-erinnern-zeile]');
    const erinnernBox = sp.querySelector('[data-mail-erinnern]');
    if (!form || !oeffnen || !feld || !senden || !meldung) return;

    oeffnen.addEventListener('click', () => {
      form.hidden = false;
      oeffnen.hidden = true;
      oeffnen.setAttribute('aria-expanded', 'true');
      feld.focus();
    });

    const melden = (text, fehler) => {
      meldung.textContent = text;
      meldung.classList.toggle('entwurf-mail__meldung--fehler', Boolean(fehler));
      meldung.hidden = false;
    };

    form.addEventListener('submit', async (ev) => {
      ev.preventDefault();
      const adresse = feld.value.trim();
      const kid = s.kandidatId;
      if (!/^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/.test(adresse)) {
        melden('Bitte eine gültige Mailadresse eintragen.', true);
        feld.focus();
        return;
      }
      if (!/^k_[0-9a-f]{12}$/.test(kid || '')) return;
      senden.disabled = true;
      senden.textContent = 'wird geschickt …';
      meldung.hidden = true;
      try {
        const r = await fetch(`${BACKEND}/api/entwurf-mailen`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ kandidat_id: kid, adresse,
            /* Häkchen nur, solange es sichtbar ist — ein verborgenes zählt nie. */
            erinnern: Boolean(erinnernZeile && !erinnernZeile.hidden && erinnernBox && erinnernBox.checked),
            /* Den Vorteil nennt die Mail nur, wenn DIESE Seite ihn zeigt — so
               schaltet der Konfigurator-Schalter auch den Mail-Weg ab. */
            mit_vorteil: Boolean(vorteilFuer(kid)) }),
        });
        const a = await r.json().catch(() => null);
        if (!r.ok) {
          throw Object.assign(new Error(`Backend ${r.status}`),
            { benannt: a && typeof a.fehler === 'string' ? a.fehler : '' });
        }
        /* Der Kunde kann inzwischen einen anderen Entwurf zeigen — dann
           gehört die Bestätigung nicht unter diesen. */
        if (s.kandidatId !== kid) return;
        form.querySelector('.entwurf-mail__zeile').hidden = true;
        if (erinnernZeile) erinnernZeile.hidden = true;
        melden(`Ist unterwegs an ${adresse} – schau gleich in dein Postfach.`
          + (a && typeof a.erinnerung_text === 'string'
            ? ` Wir erinnern dich einmal am ${a.erinnerung_text}.` : ''), false);
      } catch (e) {
        senden.disabled = false;
        senden.textContent = 'Schicken';
        melden(e && e.benannt ? e.benannt
          : 'Das kam nicht durch – bitte noch einmal versuchen.', true);
      }
    });

    /* Einmal beim Laden fragen, ob der Versand eingerichtet ist. Scheitert
       die Frage, bleibt die Funktion aus — der Kaufweg hängt nicht daran. */
    fetch(`${BACKEND}/puls`)
      .then((r) => (r.ok ? r.json() : null))
      .then((p) => {
        mailBereit = Boolean(p && p.mail);
        vorteilBereit = Boolean(p && p.vorteil === true);
        rueckmeldungBereit = Boolean(p && p.mail && p.rueckmeldung);
        pulsFelder = p || {};
        speichernZeigen();
        /* Gelb hängt am Puls (`umwandeln`) — kam er nach dem Entwurf, die Klappe einmal nachzeichnen. */
        if (NACHHER_AN && istKauf()) nachherZeichnen(true);
        vorteilZeichnen();
      })
      .catch(() => {});
  }

  /* ============================================ Entwurfs-Vorteil (21.10.2026)

     Saschas T1 »A, bau das so«: unter JEDEM eigenen Andruck, nicht erst nach 👍
     — 291 von 364 Andrucken blieben unbewertet (Cockpit 08.–21.10.). 15 % +
     kostenloser Versand, reserviert 72 h ab dem Andruck.

     🔴 KEIN KASTEN OHNE CODES. Gezeigt wird nur, was `/api/vorteil/<kid>` mit
     zwei Codes beantwortet; die Frist rechnet der Dienst aus dem Andruck, die
     Codes lehnt Shopify danach selbst ab. Läuft sie ab, während die Seite offen
     ist, verschwindet der Kasten beim nächsten Zeichnen.
     🔴 DIE ANTWORT GEHÖRT ZU EINEM ENTWURF (`VORTEIL` je Kandidat), wie Daumen
     und Melde-Panel: wer Entwurf B ansieht, bekommt Bs Frist, nicht As. */
  function vorteilFuer(kid) {
    if (!VORTEIL_AN || !vorteilBereit) return null;
    const v = VORTEIL.get(kid);
    return v && Date.now() / 1000 < v.bis ? v : null;
  }

  function vorteilZeichnen() {
    const box = $('[data-vorteil]');
    const kid = s.kandidatId;
    /* Im Bestellmodus ist schon gekauft — kein Vorteil, keine neuen Codes bei Shopify. */
    const echt = VORTEIL_AN && vorteilBereit && Boolean(BACKEND) && !BESTELLMODUS
      && s.phase === 'fertig' && /^k_[0-9a-f]{12}$/.test(kid || '');
    if (echt && !VORTEIL.has(kid)) {
      VORTEIL.set(kid, undefined);
      fetch(`${BACKEND}/api/vorteil/${kid}`)
        .then((r) => (r.ok ? r.json() : null))
        .then((a) => {
          VORTEIL.set(kid, a && a.gueltig === true && Array.isArray(a.codes)
            && a.codes.length === 2 && typeof a.bis === 'number' ? a : null);
          vorteilZeichnen();
        })
        .catch(() => { VORTEIL.set(kid, null); vorteilZeichnen(); });
    }
    const v = echt ? vorteilFuer(kid) : null;
    if (box) {
      if (v) {
        const bis = box.querySelector('[data-vorteil-bis]');
        if (bis) bis.textContent = v.bis_text;
        if (box.dataset.gezeigtFuer !== kid) {
          box.dataset.gezeigtFuer = kid;
          clarityEreignis('vorteil_gezeigt');
        }
      }
      box.hidden = !v;
    }
    document.querySelectorAll('[data-anker] [data-versand-anker]').forEach((li) => { li.hidden = Boolean(v); });
    /* Mail-Sicherung: Häkchen und Hinweis nur, solange der Vorteil gilt. Die
       Ausgangstexte stehen im Markup und werden beim Verschwinden zurückgesetzt. */
    const zeile = $('[data-mail-erinnern-zeile]');
    if (zeile) zeile.hidden = !v;
    /* ⏪ 21.10.2026 abends: die Zeile „Kostenlos – mit dem Link …" unter dem Knopf ist entfallen
       (Sascha »A« beim Ausdünnen); der Hinweis im Formular bleibt. */
    [['[data-mail-hinweis-text]', 'Du bekommst eine Mail mit dem Link zu deinem Entwurf und deinem Vorteil.']]
      .forEach(([sel, text]) => {
        const el = $(sel);
        if (!el) return;
        if (el.dataset.ursprung == null) el.dataset.ursprung = el.textContent;
        el.textContent = v ? text : el.dataset.ursprung;
      });
    kaufZeichnen(v);
  }

  /* ============== Kauffläche nach dem Andruck (Saschas T1 »A«, 21.10.2026) ==============
     EIN Muster für alle Produktseiten. Anlass, live gemessen am 21.10.2026 (Wortschatz,
     390 × 844 px): „In den Warenkorb" lag 3,6 Bildschirmhöhen unter dem Bild, das ganze
     ausgefüllte Formular dazwischen; 15 von 231 Besuchen mit Andruck (6,5 %) legten in den
     Warenkorb. Drei Teile, alle hier, alle an `s.phase === 'fertig'`:
       1 · Schritt I klappt zu „Deine Angaben … · Ändern ▾" (Entwurf der Session busy-bhabha)
       2 · die Kaufleiste läuft unten mit (`kaufleisteZeigen`)
       3 · bei gültigem Vorteil der Vorteilspreis in Preisfeld, Knopf und Leiste, mit Frist
     Gerufen aus `vorteilZeichnen()` — also bei jedem `aktionZeichnen()` und, wenn die
     Vorteil-Antwort später kommt, noch einmal. `vt` = Vorteil oder null. */
  function vorteilsPreis(cent, prozent) {
    return Math.round(cent * (100 - prozent) / 100);
  }
  /* 31.10.2026 Black Friday (Hinweis der Black-November-Session, Saschas »B«): im Zeitraum zieht die Kasse
     −20 % auch OHNE Entwurfs-Vorteil ab (abgelaufen nach 72 h, oder `VORTEIL_AN` aus). Der angezeigte Preis
     zieht dann denselben Rabatt ab, sonst stünde 49 € neben einer Kasse mit 39,20 €. Nur der PREIS — Frist,
     „Versand frei“, Band und Countdown hängen weiter allein am Vorteil (`vt`). Ein Code unter dem BF-Satz
     (alte 15 %) zeigt den BF-Preis, wie die Kasse ihn nimmt. */
  function anzeigePreis(v, vt) {
    if (!v) return null;
    const p = Math.max(vt ? vt.prozent : 0, bfAktiv(null) ? BF.p : 0);
    return p > 0 ? vorteilsPreis(v.preis, p) : null;
  }
  /** Der Hauptknopf im fertigen Zustand — EINE Stelle für beide Aufrufer (`aktionZeichnen`,
      `kaufZeichnen`); sonst überschreibt der eine die zweite Zeile des anderen (27.10.2026,
      an der Vorschau gefunden). */
  function kaufknopfSetzen(knopf, v) {
    knopf.classList.remove('mit-versprechen');
    if (BESTELLMODUS) {
      knopf.textContent = 'Diese Fassung nehmen';
    } else if (KAUFVERSPRECHEN_AN) {
      /* Zweite Zeile im Knopf (Sascha, 27.10.2026): mobil sieht der Kunde zuerst den Knopf,
         die Kacheln darunter oft gar nicht. */
      knopf.classList.add('mit-versprechen');
      knopf.innerHTML = `${escape(kaufknopfText(v))}`
        + '<small class="abschluss__aktion-zeile">Noch änderbar · Druck erst nach deinem OK</small>';
    } else {
      knopf.textContent = kaufknopfText(v);
    }
  }
  function kaufknopfText(v) {
    if (!v) return 'In den Warenkorb';
    const vt = s.phase === 'fertig' ? vorteilFuer(s.kandidatId) : null;
    const a = anzeigePreis(v, vt);
    return `In den Warenkorb – ${geld(a !== null ? a : v.preis)}`;
  }
  function angabenWerte() {
    /* Liest die SICHTBAREN Felder selbst — Text, Auswahl, gedrückte Knöpfe —, damit die
       Zeile für jedes Konzept stimmt, ohne eine zweite Feldliste zu pflegen. */
    const halter = $('[data-brief]');
    if (!halter) return '';
    const teile = [];
    halter.querySelectorAll('.brieffeld').forEach((f) => {
      const verborgen = f.closest('[hidden]');     // der zugeklappte Halter selbst zählt nicht
      if (verborgen && verborgen !== halter) return;
      const werte = [];
      f.querySelectorAll('textarea, input[type="text"], input:not([type])').forEach((e) => {
        if (e.value.trim()) werte.push(e.value.trim());
      });
      f.querySelectorAll('select').forEach((e) => {
        const o = e.options[e.selectedIndex];
        if (e.value && o) werte.push(o.textContent.trim());
      });
      f.querySelectorAll('[aria-pressed="true"]').forEach((b) => {
        /* Die verdeckten Original-Knöpfe unter der Machart-Reihe nicht doppelt zählen, und von
           einer Kachel nur den Namen, nicht den Zusatztext (Tiefen-Check 22.10.2026, Rezept:
           „RezeptGericht, Zutaten und Zubereitung & Rezept …"). */
        if (b.closest('.kombi--verdeckt') || b.matches('[data-foto-ohne]')) return;
        const n = b.querySelector('.stilkachel__name, .marker__name');
        /* `data-voll`: auf der einen Seite zeigt die Kachel „Tuch", hier steht „Seidentuch" (code-pruefer 28.10.2026). */
        const t = ((n ? n.dataset.voll || n.textContent : b.textContent) || '').trim() || b.getAttribute('aria-label') || b.title || '';
        if (t) werte.push(t);
      });
      if (werte.length) teile.push(werte.join(' & '));
    });
    const text = teile.join(' · ');
    return text.length > 140 ? `${text.slice(0, 139)}…` : text;
  }
  function kaufZeichnen(vt) {
    /* Ein Code von vor der Umstellung (15 %) tritt im Black-Friday-Zeitraum ganz zurück, wie in der Mail
       (abbrecher.py): sonst stünde „−15 %“ mit Countdown neben dem 20-%-Preis (code-pruefer 31.10.2026). */
    if (vt && BF && bfAktiv(null) && vt.prozent < BF.p) vt = null;
    const fertig = s.phase === 'fertig';
    const v = findeVariante();
    const neu = v && vt ? vorteilsPreis(v.preis, vt.prozent) : null;
    const anz = anzeigePreis(v, vt);   // was die Kasse abzieht — auch ohne Vorteil im Black-Friday-Zeitraum
    const anzStreich = Boolean(STREICHPREIS_AN && anz !== null && anz < v.preis);

    // 3 · Preisfeld, Vorteilszeile, Knopf
    const preis = $('[data-preis]');
    if (preis && fertig && v) {
      preis.innerHTML = anzStreich
        ? `<s class="pdp__preis-alt">${geld(v.preis)}</s> <span class="pdp__preis-neu">${geld(anz)}</span>`
        : geld(anz !== null ? anz : v.preis);
    }
    const zeile = $('[data-vorteilspreis]');
    if (zeile) {
      zeile.hidden = !(fertig && neu !== null);
      const pz = zeile.querySelector('[data-vorteilspreis-prozent]');
      if (pz && vt) pz.textContent = `−${vt.prozent} %`;
      bfText(zeile.querySelector('.vorteilspreis__text'), `Dein Preis mit ${BF_NAME}`, vt);
    }
    /* „zzgl. Versandkosten" weicht „Versand frei", solange der Vorteil gilt — sonst stünden
       zwei widersprüchliche Versandangaben am Preis. Ohne Vorteil zeichnet `zeichne()` ihn. */
    const vh = $('[data-versandhinweis]');
    if (vh && fertig && neu !== null) vh.hidden = true;
    const knopf = $('[data-aktion]');
    if (knopf && fertig) kaufknopfSetzen(knopf, v);

    // 1 · Deine Angaben
    const angaben = $('[data-angaben]');
    const brief = $('[data-brief]');
    if (fertig && kaufPhaseVorher !== 'fertig') angabenOffen = false;   // ein Andruck ist fertig geworden
    kaufPhaseVorher = s.phase;
    /* 30.10.2026 (`NACHHER_AN`): im Kaufzustand gibt es kein „Neu zeichnen“-Formular mehr unter dem Entwurf.
       Jeder Tipp darin verwarf den Entwurf sofort, die Seite klappte darüber zusammen und sprang (gemessen
       am Pixel-Paar: 497 px). Was das Bild behält, steht in „Doch schon etwas anpassen?“, alles andere ist
       „Neu beginnen“ (`neuBeginnen`). */
    if (angaben && brief && NACHHER_AN && fertig && meldenMoeglich()) {
      angaben.hidden = true;
      brief.hidden = true;
      const erk = $('[data-neu-erklaer]');
      if (erk) erk.hidden = true;
    } else if (angaben && brief) {
      const tipptDarin = brief.contains(document.activeElement);    // nie unter dem Finger zuklappen
      const zu = fertig && Boolean(s.kandidatId) && !angabenOffen && !tipptDarin;
      const werte = zu ? angabenWerte() : '';
      angaben.hidden = !fertig || !s.kandidatId || (zu && !werte);
      brief.hidden = zu && Boolean(werte);   // ohne lesbare Werte bleibt das Formular offen
      angaben.setAttribute('aria-expanded', String(!brief.hidden));
      const w = angaben.querySelector('[data-angaben-werte]');
      if (w) { w.textContent = werte; w.hidden = !brief.hidden; }
      const k = angaben.querySelector('[data-angaben-knopf]');
      /* Nach dem Andruck heißt die Zeile „Neu zeichnen“ (Saschas E7, 29.10.2026) — dort nur das Zeichen. */
      if (k) k.textContent = fertig ? (brief.hidden ? '▾' : '▴') : (brief.hidden ? 'Ändern ▾' : 'Zuklappen ▴');
      const erk = $('[data-neu-erklaer]');
      if (erk) erk.hidden = !fertig || brief.hidden;
      const nz = angaben.querySelector('[data-angaben-neu-zeile]');
      if (nz) nz.textContent = `neuer Entwurf in etwa ${Number(D.dauer_sekunden) || 50} Sekunden`;
    }

    // 2 · Kaufleiste
    const leiste = $('[data-kaufleiste]');
    if (leiste) {
      const alt = leiste.querySelector('[data-kaufleiste-alt]');
      const betrag = leiste.querySelector('[data-kaufleiste-betrag]');
      const marken = leiste.querySelector('[data-kaufleiste-marken]');
      const pz = leiste.querySelector('[data-kaufleiste-prozent]');
      if (alt) { alt.textContent = v ? geld(v.preis) : ''; alt.hidden = !anzStreich; }
      if (betrag) betrag.textContent = v ? geld(anz !== null ? anz : v.preis) : '';
      if (marken) marken.hidden = neu === null;
      if (pz && vt) pz.textContent = `−${vt.prozent} %`;
    }
    kaufKopfZeichnen(vt, v, neu, anz, anzStreich);
    vorteilHinweisZeigen(vt);
    kaufleisteZeigen();
  }
  function kaufleisteZeigen() {
    const leiste = $('[data-kaufleiste]');
    const knopf = $('[data-aktion]');
    if (!leiste || !knopf) return;
    let zeigen = !BESTELLMODUS && s.phase === 'fertig' && Boolean(findeVariante()) && !knopf.disabled;
    if (zeigen) {
      const hoehe = window.innerHeight || document.documentElement.clientHeight;
      const k = knopf.getBoundingClientRect();
      const knopfSichtbar = k.bottom > 0 && k.top < hoehe;
      /* Erst nach der Daumen-Zeile — sonst läge die Leiste über den Daumen. Die Zeile steht in der
         linken Spalte, AUSSERHALB von [data-konfigurator] — deshalb `document`, nicht `$`
         (code-pruefer 21.10.2026). Ist sie verborgen, gilt die gerade sichtbare Tafel (Blatt
         oder Raum); gibt es keinen Anker, erst nach einer Bildschirmhöhe. */
      const anker = [document.querySelector('[data-melden-zeile]'), ...document.querySelectorAll('[data-tafel]')]
        .find((e) => e && !e.hidden && e.offsetParent !== null);
      const ankerVorbei = anker ? anker.getBoundingClientRect().bottom < 0 : window.scrollY > hoehe;
      const a = document.activeElement;
      const tippt = Boolean(a && a.matches && a.matches('input, textarea, select'));
      zeigen = !knopfSichtbar && ankerVorbei && !tippt;
    }
    leiste.hidden = !zeigen;
    document.documentElement.classList.toggle('mit-kaufleiste', zeigen);
  }
  /* ================= Stufe 3 · die Kaufseite nach dem Andruck (22.10.2026 abends) =================
     Sascha am Pferd, live: „So kommt es bei dir an" kam vor der Finalisierung, „Deine Geschichte"
     und die Texte standen zu hoch, das Format zu tief, Rahmen und Rand ohne Vorschau in der Nähe,
     der Vorteil „völlig random" am Warenkorb, die Garantie kaum sichtbar; gemessen lag „In den
     Warenkorb" 2.557–3.147 px tief (3,0–3,7 Bildschirmhöhen). Ein Muster für alle Seiten, an
     `ist-kauf` (= eigener Entwurf fertig):
       · Galerie nur noch eigenes Blatt + erster Raum (`galerieKauf`)
       · oben echter Preis, Vorteil mit Countdown, Garantie (`kaufKopfZeichnen`)
       · einmal je Entwurf ein Hinweis auf dem Bild (`vorteilHinweisZeigen`)
       · Reihenfolge Format · Rahmen · Rand · Texte (zu) · Ankunft · Kauf · Angaben (CSS `order`)
       · Rahmen- und Rand-Kacheln zeigen den eigenen Entwurf (`kachelnEigenZeichnen`) */
  function istKauf() { return s.phase === 'fertig' && Boolean(s.kandidatId); }
  function entwurfUrl() {
    const b = document.querySelector('[data-tafel="blatt"] .buehne__bild');
    const url = b ? (b.currentSrc || b.src || '') : '';
    return /\/api\/kandidat\//.test(url) || (BACKEND && url.startsWith(BACKEND)) ? url : '';
  }
  let kaufVorher = false;
  function kaufAnsichtZeichnen() {
    const an = istKauf();
    wurzel.classList.toggle('ist-kauf', an);
    const blatt = $('[data-am-blatt]');
    /* Vorher offen (ohne Zusammenfassung), mit dem fertigen Andruck einmal zugeklappt — danach
       entscheidet der Kunde. */
    if (blatt && an !== kaufVorher) blatt.open = !an;
    kaufVorher = an;
    freieFelderUmziehen(an);
    beschriftungenZeichnen(an);
    farbeAmBlattZeichnen(an);
    bildAnpassenZusatz();
    nachherZeichnen(an);
    galerieKauf(an);
    kachelnEigenZeichnen(an);
  }

  /* ================= Nach dem Entwurf (Saschas T1, 30.10.2026) =================
     Eine Regel für alle Konzepte: nach dem Entwurf ändert der Kunde nur, was am BESTEHENDEN Bild geht. Grün
     („Texte und Farben ändern“) wirkt sofort und kostenlos; alles, was neue Angaben oder einen anderen Aufbau
     braucht, heißt „Neu beginnen“ und führt an den Anfang der Seite zurück. Gelb (gleiches Bild, andere Technik)
     folgt mit dem Dienst (Phase 2). Herleitung und Proben: Bilder-Seite JTdTB2S3Ufp6nHVgSAT1YQ.
     🔴 Die Satz-Wege bleiben dieselben — hier wird nur umgestellt, WO die Felder stehen, nie, was sie auslösen. */


  function nachherZeichnen(an) {
    const blatt = $('[data-am-blatt]');
    if (!NACHHER_AN || !blatt) return;
    /* Nur am ECHTEN Entwurf: ein simulierter (`sim_`) behält „Bild anpassen“ und das Formular wie bisher. */
    const kauf = an && meldenMoeglich();
    blatt.classList.toggle('am-blatt--nachher', kauf);
    /* Im Kaufzustand ist „Deine Geschichte“ leer (Formular und „Neu zeichnen“ sind weg) — die Hülle geht mit (CSS). */
    wurzel.classList.toggle('nachher-kauf', kauf);
    const titel = blatt.querySelector('.am-blatt__titel');
    if (titel) titel.textContent = kauf ? 'Doch schon etwas anpassen?' : 'Bild anpassen';
    if (kauf) neuBegonnen = false;
    const banner = $('[data-neu-banner]');
    if (banner) banner.hidden = !neuBegonnen || s.phase === 'fertig';
    const neu = $('[data-nachher-neu]');
    if (neu) {
      neu.hidden = !kauf || !meldenMoeglich();
      const f = neu.querySelector('[data-nachher-neu-frage]');
      /* Mit Gelb geht die Tageszeit am Bild selbst — dann fragt „Neu beginnen“ nur noch nach dem Ort. */
      const frage = gelbMoeglich() && GELB_NEU_FRAGE[D.produkt.handle];
      if (f) f.textContent = frage || NEU_FRAGE[D.produkt.handle] || 'Lieber etwas ganz anderes?';
    }
    const vorschau = $('[data-nachher-vorschau]');
    const url = kauf ? entwurfUrl() : '';
    if (vorschau && url && vorschau.getAttribute('src') !== url) vorschau.setAttribute('src', url);
    aufbauZeichnen(kauf);
    gelbZeichnen(kauf);
    wunschZeichnen(kauf);
    chronikOrteSperren(kauf);
    /* Ein Feldstand gehört zum Kaufzustand — beim Verlassen (Neu beginnen, verworfener Satz) geht er mit. */
    if (!kauf) document.querySelectorAll('.feldstand').forEach((st) => st.remove());
    /* Ohne ein einziges kostenloses Feld bleibt die grüne Sektion weg (CSS über `data-leer`). */
    const gruen = $('[data-nachher-gruen]');
    if (gruen) {
      const felder = gruen.querySelectorAll('[data-brieffeld-halter]:not([hidden]), [data-haar]:not([hidden]), '
        + '[data-farbe-am-blatt]:not([hidden]), [data-nachher-aufbau]:not([hidden])');
      gruen.dataset.leer = String(kauf && !felder.length);
    }
    feldstandPruefen();
  }

  /* --- Gelb: gleiches Bild, anders zeigen (Phase 2, 30.10.2026) ------------------------------------------------
     Jede Zeile wie in Saschas Vorlage: Beispielbild (beschriftet „Beispiel“ — es zeigt die Machart, nicht sein Bild),
     Titel, ein Satz, darunter Marke und Knopf. Erst der Knopf zeichnet; vorher kostet nichts. Was der Dienst nicht
     erlaubt (schon Abend, schon Linol, zwei Details), steht hier gar nicht erst — das Urteil fällt trotzdem dort. */
  const GELB_NEU_FRAGE = { 'orts-print': 'Lieber einen anderen Ort oder einen anderen Blick?' };
  const GELB_WARTE = {
    abend: 'Wir zeichnen dein Bild am Abend – etwa eine Minute.',
    linol: 'Wir zeichnen dein Bild als Linolschnitt – etwa eine Minute.',
    detail: 'Wir ändern das eine Detail – etwa eine Minute.',
  };
  const GELB_FERTIG = {
    abend: 'Gleiches Bild, jetzt am Abend. Das Bild davor liegt unter „Deine Entwürfe“.',
    linol: 'Gleiches Bild, jetzt als Linolschnitt. Die Farbe wählst du oben unter „Texte und Farben ändern“.',
    detail: 'Geändert. Das Bild davor liegt unter „Deine Entwürfe“.',
  };
  function gelbMoeglich() {
    return GELB_AN && meldenMoeglich() && Array.isArray(pulsFelder.umwandeln)
      && pulsFelder.umwandeln.includes(D.produkt.handle);
  }
  function gelbZeichnen(kauf) {
    const ziel = $('[data-nachher-gelb]');
    if (!ziel) return;
    if (!kauf || !gelbMoeglich()) { ziel.hidden = true; ziel.textContent = ''; delete ziel.dataset.sig; return; }
    const liste = historieLesen();
    const e = liste.find((x) => x.id === s.kandidatId) || {};
    const umw = e.umwandlung && typeof e.umwandlung === 'object' ? e.umwandlung : null;
    const kette = umw && Array.isArray(umw.kette) ? umw.kette : [];
    const zurueck = umw && umw.von && liste.some((x) => x.id === umw.von) ? String(umw.von) : '';
    const b = s.brief || {};
    const farbig = !b.look || b.look === 'kontrolle';
    const bilder = D.stilbilder || {};
    const zeilen = [];
    if (farbig && b.stimmung !== 'abend') {
      zeilen.push({ art: 'abend', titel: 'Am Abend', text: 'Blaue Stunde, Licht in den Fenstern.', bild: bilder.c1_abend });
    }
    if (farbig) {
      zeilen.push({ art: 'linol', titel: 'Als Linolschnitt', text: 'Eine Farbe, der Ort hell ausgespart.',
                    bild: bilder.c1_lino });
    }
    const detailRest = GELB_DETAIL_MAX - kette.filter((x) => x === 'detail').length;
    const sig = JSON.stringify([s.kandidatId, zeilen.map((z) => z.art), detailRest, zurueck]);
    if (ziel.dataset.sig === sig) { ziel.hidden = false; return; }
    /* Ein getippter Detail-Wunsch überlebt den Neuaufbau (Tonwechsel, neuer Satz) — samt Fokus. */
    const altFeld = ziel.querySelector('[data-gelb-wunsch]');
    const getippt = altFeld && ziel.dataset.kid === String(s.kandidatId) ? altFeld.value : '';
    const hatteFokus = altFeld && document.activeElement === altFeld;
    ziel.dataset.sig = sig;
    ziel.dataset.kid = String(s.kandidatId);
    const marke = '<span class="nachher-marke nachher-marke--gelb">neues Bild · etwa 1 Minute</span>';
    const zeile = (z) => `
      <div class="gelb-zeile">
        ${z.bild ? `<figure class="gelb-zeile__bsp"><img src="${attr(z.bild)}" alt="" loading="lazy" width="64" height="80">
          <figcaption>Beispiel</figcaption></figure>` : ''}
        <div class="gelb-zeile__text"><b>${escape(z.titel)}</b><span>${escape(z.text)}</span></div>
        <div class="gelb-zeile__unten">${marke}
          <button type="button" class="gelb-zeile__knopf" data-gelb-art="${attr(z.art)}">Zeigen</button></div>
      </div>`;
    const detail = detailRest > 0 ? `
      <div class="gelb-zeile gelb-zeile--detail">
        <div class="gelb-zeile__text"><b>Ein Detail ändern</b>
          <span>Alles bleibt, nur das eine ändert sich.</span></div>
        <textarea class="gelb-zeile__feld" data-gelb-wunsch rows="2" maxlength="${GELB_WUNSCH_MAX}"
                  placeholder="z. B. ohne das Boot vorne links" aria-label="Was soll anders sein?"></textarea>
        <p class="gelb-zeile__fehler" data-gelb-wunsch-fehler hidden>Schreib kurz, was anders sein soll.</p>
        <div class="gelb-zeile__unten">${marke}
          <button type="button" class="gelb-zeile__knopf" data-gelb-art="detail">Ändern</button></div>
      </div>` : `
      <p class="gelb-zeile__genug">Mehr Änderungen gehen an diesem Bild nicht – nach der Bestellung überarbeiten wir es
        gern mit dir.</p>`;
    const back = zurueck ? `
      <div class="gelb-zeile gelb-zeile--zurueck">
        <div class="gelb-zeile__text"><b>Zurück zum Bild davor</b><span>Liegt schon vor, ohne Wartezeit.</span></div>
        <div class="gelb-zeile__unten"><span class="nachher-marke nachher-marke--gruen">kostenlos</span>
          <button type="button" class="gelb-zeile__knopf" data-gelb-zurueck="${attr(zurueck)}">Zurück</button></div>
      </div>` : '';
    ziel.innerHTML = `
      <div class="nachher-gelb__kopf"><span class="nachher-gruen__titel">Gleiches Bild, anders zeigen</span></div>
      <p class="nachher-gelb__satz">Alles bleibt, wo es ist. Nur das, was du wählst, ändert sich.</p>
      ${back}${zeilen.map(zeile).join('')}${detail}`;
    const feld = ziel.querySelector('[data-gelb-wunsch]');
    if (feld && getippt) feld.value = getippt;
    if (feld && hatteFokus) feld.focus();
    ziel.hidden = false;
  }
  /** Gelb starten: derselbe Andruck-Weg wie „Neu zeichnen“ (`backendLauf`), mit dem Auftrag `_umwandeln`. */
  let gelbWartet = false;
  async function gelbStarten(art) {
    /* Ein laufender Text-Satz (Jahr in Grün geändert) zuerst abwarten — sonst wandelte der Dienst den Entwurf mit
       dem alten Jahr um, während Formular und Bestellzeile das neue tragen (code-pruefer 30.10.2026). */
    if (umzeichnenOffen) {
      if (gelbWartet) return;
      gelbWartet = true;
      try { await umzeichnenOffen; } catch { /* der Satz meldet selbst */ } finally { gelbWartet = false; }
    }
    if (!gelbMoeglich() || s.phase !== 'fertig') return;
    const von = String(s.kandidatId);
    const auftrag = { von, art };
    if (art === 'detail') {
      const feld = $('[data-gelb-wunsch]');
      const text = feld ? feld.value.replace(/\s+/g, ' ').trim().slice(0, GELB_WUNSCH_MAX) : '';
      const fehler = $('[data-gelb-wunsch-fehler]');
      if (!text) { if (fehler) fehler.hidden = false; feld?.focus(); return; }
      auftrag.wunsch = text;
    }
    /* Die Tinte des Formulars geht immer mit: bei Linol ist sie die Wahl, bei einem Linol-Entwurf die kostenlos
       gewechselte Farbe (der Dienst übernimmt sie nur dort). */
    if (s.brief && s.brief.tinte) auftrag.tinte = s.brief.tinte;
    else if (art === 'linol') auftrag.tinte = 'petrol';
    $('[data-tafel="blatt"]')?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    backendLauf(null, auftrag);
  }

  /** Aufbau ohne neuen Entwurf: Porträt ⇄ Lexikon (Haustier, Pferd) und Rezept ⇄ Lexikon. Jeder Knopf wählt die
      echte Kachel im (verborgenen) Formular (`kombiWaehlen`) — derselbe Satz-Weg wie bisher. Lexikon nur, wenn seine
      Pflichtangaben schon da sind: sonst bräuchte der Wechsel neue Felder, und das ist „Neu beginnen“. */
  function aufbauZeichnen(kauf) {
    const ziel = $('[data-nachher-aufbau]');
    if (!ziel) return;
    const def = kauf ? kombiDef() : null;
    const b = s.brief || {};
    /* Aus dem Feld selbst, nicht nur aus dem Brief: im Porträt sind die Eigenheiten ausgeblendet und gehen leer in den
       Brief — ihr Text steht aber noch im Feld, und genau der trägt den Rückweg zum Lexikon (Vorschau 30.10.2026). */
    const halter = briefHalter();
    const voll = (n) => String(b[n] || halter?.querySelector(`[data-feld="${n}"]`)?.value || '').trim().length > 0;
    let ids = [];
    if (def && istHaustier() && b.stil === 'illustration') {
      const lexikonGeht = voll('eigenheit_1') && voll('eigenheit_2')
        && (D.produkt.handle === 'pferd' || voll('familie'));
      ids = ['portraet', ...(lexikonGeht ? ['lexikon'] : [])];
    } else if (def && istRezept()) {
      ids = ['rezept', ...(voll('bedeutung_1') ? ['lexikon', 'lexikon_text'] : [])];
    }
    const kacheln = def ? def.kacheln.filter((k) => ids.includes(k.id)) : [];
    if (kacheln.length < 2) { ziel.hidden = true; ziel.textContent = ''; return; }
    const aktiv = (k) => k.setze.every(([f, w]) => kombiGedrueckt(f) === w);
    const sig = kacheln.map((k) => `${k.id}:${aktiv(k)}`).join('|');
    if (ziel.dataset.sig !== sig) {
      ziel.dataset.sig = sig;
      ziel.innerHTML = `<p class="feld-label">Aufbau</p>
        <div class="optionen" role="group" aria-label="Aufbau">${kacheln.map((k) => `
          <button type="button" class="option" data-nachher-aufbau-wahl="${attr(k.id)}"
                  aria-pressed="${aktiv(k)}">${escape(k.label)}</button>`).join('')}
        </div>`;
    }
    ziel.hidden = false;
  }

  /** Chronik im Kaufzustand: Jahre und Markierung je Ort bleiben änderbar (Umzeichnen, 0 €), die Ortsnamen und
      „Noch ein Ort“ / „×“ nicht — sie brauchen eine neue Karte. Ohne Kaufzustand alles wie vorher. */
  function chronikOrteSperren(kauf) {
    const h = $('[data-nachher-gruen] [data-brieffeld-halter="stationen"]');
    document.querySelectorAll('[data-nachher-gesperrt]').forEach((el) => {
      if (kauf && h && h.contains(el)) return;
      if (el.matches('textarea')) el.readOnly = false;
      delete el.dataset.nachherGesperrt;   // Knöpfe blendet nur CSS aus — ihr eigenes `hidden` bleibt unberührt
    });
    if (!kauf || !h) {
      document.querySelectorAll('[data-nachher-orte-hinweis]').forEach((el) => el.remove());
      return;
    }
    h.querySelectorAll('textarea[data-feld="stationen"]').forEach((el) => {
      if (el.readOnly) return;
      el.readOnly = true;
      el.dataset.nachherGesperrt = '';
    });
    h.querySelectorAll('[data-zeile-entfernen], [data-mehr]').forEach((el) => { el.dataset.nachherGesperrt = ''; });
    if (!h.querySelector('[data-nachher-orte-hinweis]')) {
      h.insertAdjacentHTML('beforeend', '<p class="feld-hilfe" data-nachher-orte-hinweis>Andere Orte? Unten über '
        + '„Neu beginnen“.</p>');
    }
  }

  /** „Etwas, das sich hier nicht ändern lässt?“ — der Wunsch für nach der Bestellung (`VORMERK`, Saschas »B«
      vom 29.10.2026), bisher nur über die Pillen erreichbar. Je Entwurf ein Text; er reist als »Änderungswunsch«
      mit in den Warenkorb. */
  function wunschZeichnen(kauf) {
    const box = $('[data-nachher-wunsch]');
    const inhalt = $('[data-nachher-wunsch-inhalt]');
    if (!box || !inhalt) return;
    box.hidden = !kauf || !vormerkenMoeglich();
    if (box.hidden) return;
    const kid = String(s.kandidatId);
    const text = VORMERK.get(kid) || '';
    const sig = `${kid}|${text}`;
    if (inhalt.dataset.sig === sig) return;
    /* Ein getippter, noch nicht gemerkter Wunsch überlebt den Neuaufbau (neue Entwurfs-ID nach einem Neu-Setzen,
       code-pruefer R2) — samt Fokus. */
    const altFeld = inhalt.querySelector('[data-nachher-wunsch-text]');
    const getippt = altFeld ? altFeld.value : '';
    const hatteFokus = altFeld && document.activeElement === altFeld;
    inhalt.dataset.sig = sig;
    inhalt.innerHTML = text
      ? `<p class="melden__danke"><b>Gemerkt.</b> Wir überarbeiten dein Bild nach der Bestellung mit dir.
           Gedruckt wird erst nach deinem OK.</p>
         <p class="melden__danke melden__vorgemerkt-text">„${escape(text)}“
           <button type="button" class="echoa-link" data-nachher-wunsch-weg>Entfernen</button></p>`
      : `<label class="feld-hilfe" for="nachher-wunsch-text">Schreib uns, was anders sein soll. Wir überarbeiten
           dein Bild nach der Bestellung mit dir – kostenlos.</label>
         <textarea id="nachher-wunsch-text" class="melden__text" rows="2" maxlength="${VORMERK_MAX}"
                   data-nachher-wunsch-text placeholder="z. B. die Gondel vorne etwas kleiner"></textarea>
         <p class="melden__fehler" data-nachher-wunsch-fehler hidden role="alert">Schreib kurz, was anders sein soll.</p>
         <button type="button" class="echoa-aktion echoa-aktion--leise" data-nachher-wunsch-merken>Für nach der Bestellung merken</button>`;
    const neuFeld = inhalt.querySelector('[data-nachher-wunsch-text]');
    if (neuFeld && getippt) neuFeld.value = getippt;
    if (neuFeld && hatteFokus) neuFeld.focus({ preventScroll: true });
  }

  /** „Neu beginnen“: der gezeigte Entwurf geht von der Bühne (er bleibt unter „Deine Entwürfe“), die ausgefüllte
      Eingabe steht wieder offen, ein Banner sagt, was passiert ist. Kein Render, keine Kosten — der nächste Entwurf
      entsteht erst mit „Andruck erstellen“. */
  function neuBeginnen() {
    if (!istKauf()) return;
    neuBegonnen = true;
    angabenOffen = true;
    andruckVerwerfen();
    const ziel = document.getElementById('schritt-1');
    ziel?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* „wird gesetzt …“ → „✓ Auf dem Poster“ am Feld (Sascha, 30.10.2026: „ob die Leute das gerade bei den Textfeldern
     checken, dass sich das wirklich live ändert“). Kein Bestätigen-Knopf: ohne ihn läge sonst ein vergessener Stand
     im Warenkorb. Fertig ist ein Feld, wenn kein Neu-Setzen mehr läuft (`umzeichnenOffen`) und keine Meldung steht. */
  function feldstandSetzen(halter) {
    if (!halter) return;
    let st = halter.querySelector(':scope > .feldstand');
    if (!st) {
      st = document.createElement('span');
      st.className = 'feldstand';
      st.setAttribute('aria-live', 'polite');
      halter.appendChild(st);
    }
    st.textContent = 'wird gesetzt …';
    st.dataset.stand = 'laeuft';
    st.dataset.seit = String(Date.now());
    window.setTimeout(feldstandPruefen, 900);
  }
  function feldstandPruefen() {
    /* Steht in Grün irgendwo ein Hinweis am Feld, ist der letzte Stand nicht gesetzt — dann kein Häkchen, auch kein
       altes (Rezept-Lexikon: der Hinweis steht immer an Bedeutung 1, code-pruefer R2). */
    if (document.querySelector('[data-nachher-gruen] [data-feld-hinweis]')) {
      document.querySelectorAll('[data-nachher-gruen] .feldstand').forEach((st) => st.remove());
      return;
    }
    const offen = document.querySelectorAll('.feldstand[data-stand="laeuft"]');
    if (!offen.length) return;
    if (!istKauf()) { offen.forEach((st) => st.remove()); return; }
    if (umzeichnenOffen) { window.setTimeout(feldstandPruefen, 700); return; }
    const meldung = document.querySelector('[data-fehler]:not([hidden])');
    offen.forEach((st) => {
      if (Date.now() - Number(st.dataset.seit || 0) < 800) { window.setTimeout(feldstandPruefen, 800); return; }
      /* Auch ein Hinweis AM FELD heißt: nicht gesetzt (Rezept ohne Zutaten — `feldHinweis`, keine `[data-fehler]`,
         code-pruefer 30.10.2026). */
      if (meldung || st.parentElement?.querySelector('[data-feld-hinweis]')) { st.remove(); return; }
      st.textContent = '✓ Auf dem Poster';
      st.dataset.stand = 'ok';
    });
  }

  /* 🆕 29.10.2026 (Sascha, PDP-Vorlage E7 »A«): nach dem Andruck stehen zwei Klappen — „Bild anpassen“
     (alles, was ohne neuen Entwurf geht) und „Neu zeichnen“ (der Rest der Angaben). Die gesetzten Texte
     (`TEXT_SATZ`, z. B. die Namen bei Symbole) standen bis heute im Formular „Deine Angaben“ — ändern war
     kostenlos, sah aber nach Neuzeichnen aus. Im Kaufzustand ziehen ihre Felder deshalb in „Bild anpassen“
     (`[data-brief-feinschliff]`) und davor wieder zurück. `briefHalter()` behandelt alle drei Container wie
     einen, Sammeln und Prüfen merken den Umzug nicht. `baueBrief()` leert alle drei und baut neu — dann ist
     die Marke weg und nichts zurückzutragen. */
  const UMZUG = new Map();   // Feldname → Kommentar-Marke an der alten Stelle
  function freieFelderUmziehen(an) {
    const brief = $('[data-brief]');
    const fein = $('[data-brief-feinschliff]');
    if (!brief || !fein) return;
    if (an) {
      /* Nur die festen Text-Felder je Produkt (`TEXT_SATZ[…].felder`) — nicht die Pixel-Paar-Farben, die
         `textSatzFelder` mitliefert (sie haben ihre eigene Klappe „Farben am Bild ändern“, code-pruefer 29.10.2026). */
      const fest = (TEXT_SATZ[D.produkt.handle] || {}).felder || [];
      const namen = new Set();
      textSatzFelder(s.brief).filter((f) => fest.includes(f))
        .forEach((f) => namen.add(f === 'name1' || f === 'name2' ? 'namen' : f));
      /* 30.10.2026 (`NACHHER_AN`): das Formular ist im Kaufzustand weg — kostenlose Felder, die bisher dort
         standen (Haustier-Eigenheiten, Rezept-Texte, Chronik-Namen), ziehen mit um. */
      if (NACHHER_AN) (FREI_IM_KAUF[D.produkt.handle] || []).forEach((n) => namen.add(n));
      /* Was nicht mehr gesetzt wird (Wortschatz auf »bildlich«, Zitat weg von Flieder), geht zurück —
         sonst stünde ein gemaltes Feld unter „kostenlos, sofort“ (code-pruefer 29.10.2026, BELEGT). */
      fein.querySelectorAll('[data-umgezogen]').forEach((h) => {
        if (namen.has(h.dataset.umgezogen)) return;
        const marke = UMZUG.get(h.dataset.umgezogen);
        UMZUG.delete(h.dataset.umgezogen);
        delete h.dataset.umgezogen;
        if (marke && marke.isConnected) marke.replaceWith(h); else h.remove();
      });
      namen.forEach((n) => {
        const h = brief.querySelector(`[data-brieffeld-halter="${n}"]`);
        if (!h || h.hidden) return;
        const marke = document.createComment(`umzug:${n}`);
        h.before(marke);
        UMZUG.set(n, marke);
        h.dataset.umgezogen = n;
        fein.appendChild(h);
      });
      return;
    }
    fein.querySelectorAll('[data-umgezogen]').forEach((h) => {
      const marke = UMZUG.get(h.dataset.umgezogen);
      delete h.dataset.umgezogen;
      if (marke && marke.isConnected) marke.replaceWith(h);
      else h.remove();
    });
    UMZUG.clear();
  }

  /* 🆕 29.10.2026 (Sascha, PDP-Vorlage E8 »A«): Symbol-Raster — die Beschriftung unter jedem Symbol ist
     gesetzt, nicht gemalt, und lässt sich nach dem Andruck ohne neuen Entwurf ändern. Je Symbol ein Feld in
     „Bild anpassen“, vorbelegt mit den Beschriftungen des GEZEIGTEN Entwurfs (Dienst-Antwort bzw. Historie).
     Kein Formularfeld: vor dem Andruck gibt es nichts vorzubelegen (Stufe 1 schreibt die Beschriftungen aus
     den Zeilen „Deine Symbole“). Geändert wird über den Text-Satz (`TEXT_SATZ`, Feld `beschriftungen`). */
  function beschriftungenDesEntwurfs() {
    const e = historieLesen().find((x) => x.id === s.kandidatId);
    const k = s.kandidat && s.kandidat.id === s.kandidatId ? s.kandidat : null;
    const b = (k && k.beschriftungen) || (e && e.beschriftungen);
    return Array.isArray(b) && b.length ? b : null;
  }
  /** Die Beschriftungen für `s.brief`: aus den Feldern, wenn sie zum gezeigten Entwurf gehören, sonst die des
      Entwurfs (die Felder werden beim nächsten Zeichnen für ihn neu gebaut). Null ohne Kaufzustand. */
  function beschriftungenLesen() {
    if (D.produkt.handle !== 'icon-grid' || !istKauf()) return null;
    const quelle = beschriftungenDesEntwurfs();
    if (!quelle) return null;
    const block = $('[data-beschriftungen]');
    const felder = block ? Array.from(block.querySelectorAll('[data-beschriftung]')) : [];
    if (block && block.dataset.fuer === s.kandidatId && felder.length === quelle.length) {
      /* Leerraum wie der Dienst (`" ".join(text.split())`) — sonst sähe der Vergleich nach dem Setzen eine Änderung. */
      return felder.map((i) => i.value.replace(/\s+/g, ' ').trim());
    }
    return quelle.slice();
  }
  let beschriftungenBaut = false;
  function beschriftungenZeichnen(an) {
    const fein = $('[data-brief-feinschliff]');
    let block = $('[data-beschriftungen]');
    const quelle = an && fein && D.produkt.handle === 'icon-grid' ? beschriftungenDesEntwurfs() : null;
    if (!quelle) { if (block) block.remove(); return; }
    if (block && block.dataset.fuer === s.kandidatId
        && block.querySelectorAll('[data-beschriftung]').length === quelle.length) return;
    if (beschriftungenBaut) return;
    if (!block) {
      block = document.createElement('div');
      block.className = 'brieffeld';
      block.dataset.brieffeldHalter = 'beschriftungen';
      block.dataset.beschriftungen = '';
    }
    /* 🔴 Ein fokussiertes, geändertes Feld feuert beim Ersetzen noch „change“ (gemessen 29.10.2026, Chrome):
       stand `fuer` da schon auf dem neuen Entwurf, las `sammleBrief` die ALTEN Texte als seine und setzte sie
       auf ihn. Deshalb zuerst loslassen (unter dem alten `fuer` — dann gilt der Wert als fremd) und `fuer`
       erst nach dem Neubau setzen; der Riegel hält den Aufruf aus dem change-Pfad heraus. */
    beschriftungenBaut = true;
    try {
      if (block.contains(document.activeElement)) document.activeElement.blur();
    } finally { beschriftungenBaut = false; }
    block.innerHTML = `<p class="feld-label">Beschriftungen</p>
      <p class="feld-hilfe">Das Symbol bleibt, nur der Text darunter ändert sich.</p>
      <div class="feldgruppe">${quelle.map((t, i) => `
        <input type="text" class="echoa-feld" data-eingabe data-beschriftung maxlength="${BESCHRIFTUNG_MAX}"
               aria-label="Beschriftung unter Symbol ${i + 1}" value="${attr(t)}">`).join('')}
      </div>`;
    block.dataset.fuer = s.kandidatId;
    fein.appendChild(block);
  }
  /** Der Brief eines Entwurfs in der Historie trägt dessen Beschriftungen — sonst sähe der Vergleich mit dem
      Formular nach dem Andruck eine Änderung, wo keine ist. */
  function mitBeschriftungen(brief, kandidat) {
    if (!kandidat || !Array.isArray(kandidat.beschriftungen)) return brief;
    return { ...brief, beschriftungen: kandidat.beschriftungen };
  }

  /** Farbe ohne neuen Entwurf in „Bild anpassen“ (Saschas E7, 29.10.2026). Gebaut aus den Markern des
      Formulars, die `tonNurWechsel` als reinen Tonwechsel erkennt (Look-Zweig gleich, Ton aus Liste B;
      beim Moment `grund`, beim Orts-Print `tinte`). Jeder Knopf drückt den echten Marker (`data-am-bild-feld`,
      vorhandener Hörer) — eine Achse, zwei Ansichten. Im Formular („Neu zeichnen“) blendet `data-nur-ton`
      dieselben Töne aus, sichtbar bleibt dort nur, was neu zeichnet. */
  function farbeAmBlattZeichnen(an) {
    const ziel = $('[data-farbe-am-blatt]');
    const brief = $('[data-brief]');
    if (!ziel || !brief) return;
    brief.querySelectorAll('[data-nur-ton]').forEach((b) => { delete b.dataset.nurTon; });
    const halter = briefHalter();
    const frei = an && tonSichtbar() && halter
      ? ['look', 'grund', 'tinte']
        .flatMap((f) => Array.from(halter.querySelectorAll(`[data-brieffeld="${f}"][data-wert]`)))
        .filter((b) => !b.disabled && tonNurWechsel(b.dataset.brieffeld, b.dataset.wert))
      : [];
    if (frei.length < 2) { ziel.hidden = true; ziel.textContent = ''; return; }
    frei.forEach((b) => { if (b.getAttribute('aria-pressed') !== 'true') b.dataset.nurTon = ''; });
    const sig = frei.map((b) => `${b.dataset.wert}:${b.getAttribute('aria-pressed')}`).join('|');
    if (ziel.dataset.sig !== sig) {
      ziel.dataset.sig = sig;
      ziel.innerHTML = `<p class="feld-label">Farbe</p>
        <div class="marker-reihe" role="group" aria-label="Farbe">${frei.map((b) => `
          <button type="button" class="marker" data-am-bild-feld="${attr(b.dataset.brieffeld)}"
                  data-wert="${attr(b.dataset.wert)}" aria-pressed="${b.getAttribute('aria-pressed') === 'true'}">${b.innerHTML}</button>`).join('')}
        </div>
        <p class="feld-hilfe">Kostet keinen neuen Entwurf.</p>`;
    }
    ziel.hidden = false;
  }

  /** Kopfzeile von „Bild anpassen“: was drin ist, ohne Liste je Konzept — Textfelder heißen „Texte“,
      Knopfreihen und der Ton „Farbe“. */
  function bildAnpassenZusatz() {
    const z = $('[data-am-blatt-zusatz]');
    const fein = $('[data-brief-feinschliff]');
    if (!z || !fein) return;
    const halter = Array.from(fein.querySelectorAll('[data-brieffeld-halter]')).filter((h) => !h.hidden);
    const texte = halter.some((h) => h.querySelector('input[type="text"], textarea'));
    const farbe = halter.some((h) => h.querySelector('[data-wert]'))
      || Boolean($('[data-farbe-am-blatt]') && !$('[data-farbe-am-blatt]').hidden);
    const teile = [texte && 'Texte', farbe && 'Farbe'].filter(Boolean);
    z.textContent = `${teile.length ? `${teile.join(' und ')} · ` : ''}kostenlos, sofort auf deinem Entwurf`;
    /* Ohne ein einziges Feld bleibt die Klappe weg (CSS); dann sagt „Neu zeichnen“ nicht „oben“. */
    const erk = $('[data-neu-erklaer]');
    if (erk) erk.dataset.mitAnpassen = String(halter.length > 0 || farbe);
    const was = $('[data-neu-erklaer-was]');
    if (was && teile.length) was.textContent = teile.join(' und ');
  }
  function galerieKauf(an) {
    const raum = document.querySelector('[data-tafel^="raum-"]')?.dataset.tafel || '';
    document.querySelectorAll('.pdp__kachel[data-ansicht]').forEach((k) => {
      k.classList.toggle('pdp__kachel--aus', an && k.dataset.ansicht !== 'blatt' && k.dataset.ansicht !== raum);
    });
    const sichtbar = document.querySelector('[data-tafel]:not([hidden])')?.dataset.tafel;
    if (an && sichtbar && sichtbar !== 'blatt' && sichtbar !== raum) ansichtWechseln('blatt');
    punkteZeichnen();
  }
  /* 🔴 29.10.2026 (Sascha, PDP-Vorlage E9 »B«: „Beim Wechsel zwischen den Rahmen springen die Bilder der
     Rand-Sektion leicht mit … umgekehrt genauso“). Ursache: die Bildchen nahmen das GERADE gezeigte Blatt —
     und dessen Adresse wechselt mit Rahmen, Rand und Format. Jeder Wechsel lud damit alle Bildchen beider
     Reihen neu. Jetzt bleibt das Bild je Entwurf und Farbe stehen; Rahmen und Rand zeigt die Kachel selbst
     (Rahmenfarbe, Steg), nicht ein neues Bild. */
  /* code-pruefer 29.10.2026 (BELEGT): `currentSrc` ist direkt nach `vorschauSetzen()` noch die ALTE Adresse,
     und ein Satz-Wechsel (Haustier, Rezept …) ändert das Bild bei gleicher kandidatId. Deshalb zählt die
     ZIEL-Adresse des Blatts (`src`-Attribut), ohne den Format-Parameter des Orts-Prints (`?format=`, nur ein
     Beschnitt) — sie wechselt mit Entwurf, Ton und Satz, nicht mit Rahmen, Rand oder Format. */
  let kachelBild = { fuer: '', url: '' };
  function entwurfZiel() {
    const b = document.querySelector('[data-tafel="blatt"] .buehne__bild');
    const url = b ? (b.getAttribute('src') || '') : '';
    return /\/api\/kandidat\//.test(url) || (BACKEND && url.startsWith(BACKEND)) ? url : '';
  }
  function ohneFormat(url) {
    try { const u = new URL(url, location.href); u.searchParams.delete('format'); return u.toString(); } catch { return url; }
  }
  function kachelnEigenZeichnen(an) {
    const ziel = an ? entwurfZiel() : '';
    if (ziel && kachelBild.fuer !== ohneFormat(ziel)) kachelBild = { fuer: ohneFormat(ziel), url: ziel };
    const url = an && ziel ? kachelBild.url : '';
    $$('[data-rahmenwahl] .rahmen').forEach((b) => {
      let eigen = b.querySelector('.rahmen__eigen');
      if (!url) { b.classList.remove('hat-eigen'); return; }
      if (!eigen) {
        eigen = document.createElement('span');
        eigen.className = 'rahmen__eigen';
        eigen.setAttribute('aria-hidden', 'true');
        eigen.innerHTML = '<img alt="" width="60" height="84">';
        b.querySelector('.rahmen__bild')?.appendChild(eigen);
      }
      const t = b.dataset.rahmen ? (rahmenTon(b.dataset.rahmen) || RAHMEN_RUECKFALL) : null;
      eigen.classList.toggle('rahmen__eigen--ohne', !t);
      if (t) eigen.style.setProperty('--r-farbe', t.flaeche);
      const img = eigen.querySelector('img');
      if (img.getAttribute('src') !== url) img.setAttribute('src', url);
      b.classList.add('hat-eigen');
    });
    $$('[data-wahl="rand"]').forEach((b) => {
      let mini = b.querySelector('.rand-mini');
      if (!url) { if (mini) mini.hidden = true; return; }
      if (!mini) {
        mini = document.createElement('span');
        mini.className = 'rand-mini';
        mini.setAttribute('aria-hidden', 'true');
        mini.innerHTML = '<img alt="" width="60" height="84">';
        mini.style.setProperty('--steg', `${STEG_STUFEN[b.dataset.wert] || 0}%`);
        b.prepend(mini);
      }
      mini.hidden = false;
      const img = mini.querySelector('img');
      if (img.getAttribute('src') !== url) img.setAttribute('src', url);
    });
  }
  /* Oben unter dem Titel: echter Preis, Vorteil mit Frist, Garantie. Der Countdown läuft gegen
     die Frist, die der Dienst für GENAU diesen Entwurf vergibt (`/api/vorteil`) — kein
     Seiten-Timer, der beim Neuladen von vorn beginnt. */
  let countdownTakt = 0;
  function kaufKopfZeichnen(vt, v, neu, anz, anzStreich) {
    const kopf = document.querySelector('[data-kauf-kopf]');
    const oben = document.querySelector('[data-preis-oben]');
    const an = istKauf();
    if (oben) {
      if (oben.dataset.ursprung == null) oben.dataset.ursprung = oben.innerHTML;
      oben.innerHTML = an && v
        ? (anzStreich ? `<s class="pdp__preis-alt">${geld(v.preis)}</s> <span class="pdp__preis-neu">${geld(anz)}</span>`
          : geld(anz !== null ? anz : v.preis))
        : oben.dataset.ursprung;
    }
    const vo = document.querySelector('[data-versand-oben]');
    if (vo && an && neu !== null) vo.hidden = true;
    if (!kopf) return;
    kopf.hidden = !an;
    const zeile = kopf.querySelector('[data-kopf-vorteil]');
    if (zeile) {
      zeile.hidden = !(an && vt && neu !== null);
      const pz = zeile.querySelector('[data-kopf-prozent]');
      if (pz && vt) pz.textContent = `−${vt.prozent} %`;
      /* Der Text steht im Theme VOR der Uhr (`<b data-countdown>`): nur dieser erste Textknoten wechselt. */
      const tx = zeile.querySelector('.kauf-kopf__text');
      const knoten = tx && tx.firstChild && tx.firstChild.nodeType === 3 ? tx.firstChild : null;
      if (knoten) {
        if (tx.dataset.ursprung == null) tx.dataset.ursprung = knoten.nodeValue;
        knoten.nodeValue = bfAktiv(vt) ? `Dein ${BF_NAME} · reserviert noch ` : tx.dataset.ursprung;
      }
    }
    clearInterval(countdownTakt);
    countdownTakt = 0;
    /* Das Band ganz oben (Wettbewerbs-Standard: Desenio, Crown & Paw, Purelei — Balken mit echtem
       Ende; Recherche 22.10.2026) trägt mit gültigem Vorteil dieselbe Frist statt der rollierenden
       Werbesätze. Ohne Vorteil bleibt es, wie es ist. */
    const band = document.querySelector('echoa-band, .band');
    const mitVorteil = an && Boolean(vt) && neu !== null;
    if (band) {
      let z = band.querySelector('[data-band-vorteil]');
      if (mitVorteil && !z) {
        z = document.createElement('p');
        z.className = 'band__vorteil';
        z.dataset.bandVorteil = '';
        /* EIN Kind: im Flex-Band fielen die Leerzeichen zwischen Text und Spans weg. */
        z.innerHTML = '<span><span data-band-wort>Dein Vorteil</span> <span data-band-prozent></span> · noch <b data-countdown></b></span>';
        band.appendChild(z);
      }
      if (z) {
        z.hidden = !mitVorteil;
        bfText(z.querySelector('[data-band-wort]'), BF_NAME, vt);
        const bp = z.querySelector('[data-band-prozent]');
        if (bp && vt) bp.textContent = `−${vt.prozent} %`;
      }
      band.classList.toggle('band--vorteil', mitVorteil);
    }
    const uhren = [...document.querySelectorAll('[data-countdown]')];
    if (!mitVorteil || !uhren.length) return;
    /* 🔴 Abgelaufen heißt hier dasselbe wie in `vorteilFuer` (jetzt ≥ bis) — und neu gezeichnet
       wird über einen Zeitgeber, nicht aus `ticken` heraus. Die erste Fassung meldete „0" bis zu
       1 s vor der Frist und rief `vorteilZeichnen` direkt: jede Ebene legte einen neuen
       Sekundentakt an, gemessen 106–229 verwaiste Zeitgeber (code-pruefer 22.10.2026). */
    const ticken = () => {
      const restMs = vt.bis * 1000 - Date.now();
      if (restMs <= 0) {
        clearInterval(countdownTakt);
        countdownTakt = 0;
        setTimeout(vorteilZeichnen, 0);
        return false;
      }
      const rest = Math.ceil(restMs / 1000);
      const zwei = (n) => String(n).padStart(2, '0');
      /* „Std." dahinter (Sascha: sonst ist unklar, was die Zahl bedeutet). */
      const text = `${zwei(Math.floor(rest / 3600))}:${zwei(Math.floor(rest / 60) % 60)}:${zwei(rest % 60)} Std.`;
      uhren.forEach((u) => { u.textContent = text; });
    };
    if (ticken() !== false) countdownTakt = setInterval(ticken, 1000);
  }
  /* Einmal je Entwurf, auf dem Bild, wegklickbar (Sascha: „Hover-Over auf dem Bild mit Option zum
     Wegklicken … damit der Nutzer merkt, dass es ein exklusiver Vorteil für ihn ist"). Kein Modal:
     es läge über dem Moment, in dem der Kunde sein Bild zum ersten Mal sieht. */
  const HINWEIS_GEZEIGT = new Set();
  function vorteilHinweisZeigen(vt) {
    const box = document.querySelector('[data-vorteil-hinweis]');
    if (!box) return;
    const kid = s.kandidatId || '';
    let schon = HINWEIS_GEZEIGT.has(kid);
    try { schon = schon || sessionStorage.getItem(`echoa_vh_${kid}`) === '1'; } catch { /* privat */ }
    if (!istKauf() || !vt || schon) { box.hidden = true; return; }
    const pz = box.querySelector('[data-vh-prozent]');
    if (pz) pz.textContent = `−${vt.prozent} %`;
    bfText(box.querySelector('.vorteil-hinweis__titel'), `Dein ${BF_NAME}`, vt);
    const bis = box.querySelector('[data-vh-bis]');
    if (bis) bis.textContent = vt.bis_text || '';
    if (box.hidden) clarityEreignis('vorteil_hinweis');
    box.hidden = false;
    box.dataset.fuer = kid;
  }
  function vorteilHinweisSchliessen() {
    const box = document.querySelector('[data-vorteil-hinweis]');
    if (!box) return;
    const kid = box.dataset.fuer || s.kandidatId || '';
    HINWEIS_GEZEIGT.add(kid);
    try { sessionStorage.setItem(`echoa_vh_${kid}`, '1'); } catch { /* privat */ }
    box.hidden = true;
  }

  /* ⏪ 22.10.2026: hier stand die mitlaufende Mini-Vorschau am Handy (Stufe 1). Sascha nach dem
     Live-Gang: „mehr störend als nützlich … der Nutzer [soll] … die Änderungen an seinem Bild
     erfassen (über kleinere Schritte oder Bilder direkt am Knopf)". Ersetzt durch die geführte
     Maske (Stufe 2, `schritteZeichnen`) und die Bilder an den Machart-Kacheln. */

  function kaufleisteBeobachten() {
    const takt = () => {
      if (leisteRahmen) return;
      leisteRahmen = requestAnimationFrame(() => { leisteRahmen = 0; kaufleisteZeigen(); });
    };
    window.addEventListener('scroll', takt, { passive: true });
    window.addEventListener('resize', takt);
    document.addEventListener('focusin', takt);
    document.addEventListener('focusout', () => setTimeout(takt, 0));
  }

  /* ======================================= Format- und Rahmenwahl (21.10.2026)

     Sascha: „Kann man in Clarity sehen, welche Optionen die Nutzer typischerweise
     wählen?" — nein: das Format ist ein Auswahlmenü, dessen Wert Clarity nicht
     mitschreibt. Deshalb ein eigenes Ereignis »auswahl« (alle Besucher, ohne
     Einwilligungs-Lücke) UND Clarity-Merkmale für die Aufzeichnungen (nur mit
     Einwilligung — Clarity lädt sonst gar nicht). Nur nach einem eigenen
     Andruck: vorher wählt niemand für ein Bild. Entdoppelt je Entwurf,
     Variante und Anlass; ein Fehler kostet den Kunden nichts. */
  function clarityWert(k, w) {
    try { if (typeof window.clarity === 'function') window.clarity('set', k, w); } catch { /* still */ }
  }
  function clarityEreignis(name) {
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch { /* still */ }
  }

  /* 🆕 EIN EREIGNIS JE SCHRITT (22.10.2026, Saschas T1 »B«). Bis heute war nicht messbar, wo im
     Formular Besucher aussteigen — es gab weder „Seite geöffnet" noch ein Ereignis je Schritt
     (Auswertung 08.–22.10.2026). `POST /api/schritt` (Dienst ab Commit 58e95e77):
       seite        die Produktseite ist geladen
       inhalt       erste eigene Eingabe in Schritt 1 (Tippen, Foto, Datei, Karte)
       machart      die Überschrift „2 · …" war im Bild (erreicht, nicht gewählt — die Machart
                    ist vorgewählt, ein Klick wäre kein Maß für „bis hierher gekommen")
       feinschliff  erste Änderung im Block „Deine Texte" nach dem Andruck
     Einmal je Produkt und Seitenaufruf; der Dienst entdoppelt zusätzlich je Kürzel. Ein alter Dienst
     ohne Route antwortet 404 — das wird geschluckt, wie jede Störung dieses Protokolls. */
  const SCHRITTE_GEMELDET = new Set();
  function schrittMelden(schritt) {
    const schluessel = `${D.produkt.handle}|${schritt}`;
    if (!BACKEND || SCHRITTE_GEMELDET.has(schluessel)) return;
    SCHRITTE_GEMELDET.add(schluessel);
    try {
      fetch(`${BACKEND}/api/schritt`, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({ produkt: D.produkt.handle, schritt, sitzung: sitzungsKennung() }),
        keepalive: true,
      }).catch(() => {});
    } catch { /* das Protokoll darf nie einen Klick kosten */ }
  }
  function schrittBeobachten() {
    schrittMelden('seite');
    if (!('IntersectionObserver' in window)) return;
    const beob = new IntersectionObserver((eintraege) => {
      eintraege.forEach((e) => {
        /* An der Überschrift der Machart, nicht an der Nummer (code-pruefer 22.10.2026: beim Moment ist
           „2 · Ihr zwei" der zweite Schritt). Ohne Schritt-Ansicht der einzige Weg zu diesem Ereignis. */
        if (e.isIntersecting && /Machart|Hintergrund|Poster|Motiv/.test(e.target.textContent || '')) schrittMelden('machart');
      });
    });
    document.querySelectorAll('[data-brief] .brief-gruppe').forEach((g) => beob.observe(g));
  }

  function auswahlMelden(anlass) {
    const kid = s.kandidatId;
    if (s.phase !== 'fertig' || !/^k_[0-9a-f]{12}$/.test(kid || '')) return;
    const v = findeVariante();
    if (!v) return;
    const rahmen = s.ausfuehrung === 'Gerahmt' ? String(s.rahmenfarbe || '') : 'Ohne Rahmen';
    clarityWert('format', String(s.groesse || ''));
    clarityWert('rahmen', rahmen);
    clarityEreignis(anlass === 'warenkorb' ? 'warenkorb'
      : (s.ausfuehrung === 'Gerahmt' ? 'rahmen_gewaehlt' : 'format_gewaehlt'));
    const schluessel = `${kid}|${v.id}|${anlass}`;
    if (!BACKEND || AUSWAHL_GESENDET.has(schluessel)) return;
    AUSWAHL_GESENDET.add(schluessel);
    /* text/plain + keepalive wie beim Daumen (kein CORS-Vorabruf; beim
       Warenkorb verlässt der Kunde direkt danach die Seite). */
    fetch(`${BACKEND}/api/auswahl`, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify({
        kandidat_id: kid, variante_id: String(v.id), groesse: String(s.groesse || ''),
        ausfuehrung: String(s.ausfuehrung || ''), rahmen,
        preis: typeof v.preis === 'number' ? v.preis / 100 : 0, anlass }),
      keepalive: true,
    }).catch(() => {});
  }

  /** `?entwurf=<id>[&ton=<id>]` beim Laden — der Rückweg von einer fremden
      PDP und seit dem 22.09.2026 auch aus dem Warenkorb („Ändern").
      Erst die Sitzungs-Historie; kennt sie den Entwurf nicht (neuer Tab,
      abgelaufene Sitzung), holt die PDP ihn über
      GET /api/kandidat/<id>/brief.json vom Backend und trägt ihn in die
      Historie ein — danach läuft derselbe `historieWaehlen`-Pfad. */
  /** Größe, Ausführung und Rahmen aus einer Varianten-ID zurücklesen — der
      Rückweg aus dem Warenkorb (`item.url` trägt `?variant=`). Bis zum
      23.09.2026 fiel die Wahl dort still auf die Vorwahl zurück (Befund
      code-pruefer): wer »Gerahmt 50×70« bestellt hatte, stand nach »Ändern«
      auf 30×40/Print. Liest dieselbe Optionsstruktur wie `trifft()`. */
  function zustandAusVariante(id) {
    const v = D.varianten.find((x) => String(x.id) === String(id));
    if (!v) return null;
    const o = v.optionen;
    const z = {};
    if (kombiniert) {
      const w = o[optIndex.ausfuehrung] || '';
      const t = w.indexOf(' ');
      if (t > 0) { z.ausfuehrung = w.slice(0, t); z.groesse = w.slice(t + 1); }
    } else {
      if (optIndex.ausfuehrung != null) z.ausfuehrung = o[optIndex.ausfuehrung];
      if (optIndex.groesse != null) z.groesse = o[optIndex.groesse];
    }
    if (optIndex.rahmenfarbe != null) {
      const r = o[optIndex.rahmenfarbe];
      if (r && r !== OHNE_RAHMEN) { z.rahmenfarbe = r; z.ausfuehrung = z.ausfuehrung || 'Gerahmt'; }
    }
    return z;
  }

  async function entwurfAusUrlEinloesen() {
    let wunsch = '';
    let ton = '';
    let varianteId = '';
    let ausMail = false;
    let antwortenAusRueckweg = null;
    try {
      const q = new URLSearchParams(window.location.search);
      wunsch = (q.get('entwurf') || '').trim();
      ausMail = q.get('von') === 'mail';
      ton = (q.get('ton') || '').trim();
      varianteId = (q.get('variant') || '').trim();
    } catch { return; }
    if (varianteId) {
      const z = zustandAusVariante(varianteId);
      if (z) {
        if (z.groesse && werteFuer('groesse').includes(z.groesse)) {
          s.groesse = z.groesse;
          const sel = $('[data-groesse]');
          if (sel) sel.value = z.groesse;
        }
        if (z.ausfuehrung === 'Gerahmt' || z.ausfuehrung === 'Print') s.ausfuehrung = z.ausfuehrung;
        if (z.rahmenfarbe) s.rahmenfarbe = z.rahmenfarbe;
        s.rahmenGewaehlt = true;          /* der Kunde hatte gewählt — der Raum zeigt es */
      }
    }
    if (!wunsch) return;
    /* Rückkehr über den Link einer Mail (14.10.2026, Sascha: „Sind solche
       Aktionen auch im Cockpit vermerkt?“). Nur ein Ereignis im Dienst — der
       Rückweg selbst hängt nicht daran: kennt der Dienst die Route noch nicht
       (404) oder ist er weg, öffnet der Entwurf trotzdem. text/plain wie beim
       Daumen, sonst bräuchte die Anfrage einen CORS-Vorabruf. */
    if (ausMail && BACKEND && /^k_[0-9a-f]{12}$/.test(wunsch)) {
      fetch(`${BACKEND}/api/rueckkehr`, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({ kandidat_id: wunsch }),
        keepalive: true,
      }).catch(() => {});
    }
    let e = historieLesen().find(
      (x) => x.id === wunsch && x.handle === D.produkt.handle);
    if (!e && BACKEND && /^k_[0-9a-f]{12}$/.test(wunsch)) {
      try {
        const r = await fetch(`${BACKEND}/api/kandidat/${wunsch}/brief.json`);
        if (r.ok) {
          const a = await r.json();
          if (a && a.produkt === D.produkt.handle && a.brief && a.vorschau_url) {
            /* Der Backend-Brief trägt `rueckfrageAntworten` — `sammleBrief()`
               erzeugt den Schlüssel nie. Im Fingerabdruck wäre er ein Zusatz,
               den kein lokaler Brief je trifft (Prüfer 22.09.2026): der
               Rückweg wäre für diesen Entwurf tot. Also trennen: der Brief
               ohne Antworten in die Historie, die Antworten nach `s.antworten`,
               damit ein zweiter Andruck nicht dieselben Fragen stellt. */
            /* Dasselbe für die Haarfarbe des Pixel-Paars (`haar1`/`haar2`, 27.10.2026): sie steht im Brief des
               Dienstes, nie im Formular — abgetrennt in den Eintrag (`haar`), damit Fingerabdruck und Markierung
               stimmen (code-pruefer 27.10.2026, Runde 2). */
            const { rueckfrageAntworten, haar1, haar2, ...briefOhne } = a.brief;
            historieMerken({ id: wunsch, vorschau_url: a.vorschau_url,
                             unterzeile: a.unterzeile || '', rueckweg: true,
                             ...(a.umwandlung && typeof a.umwandlung === 'object' ? { umwandlung: a.umwandlung } : {}),
                             ...(Array.isArray(a.beschriftungen) ? { beschriftungen: a.beschriftungen } : {}),
                             ...(haar1 || haar2 ? { haar: { 1: haar1 || '', 2: haar2 || '' } } : {}) }, briefOhne,
                           Array.isArray(rueckfrageAntworten) ? rueckfrageAntworten : null);
            e = historieLesen().find((x) => x.id === wunsch);
            if (e && Array.isArray(rueckfrageAntworten)) antwortenAusRueckweg = rueckfrageAntworten;
          }
        }
      } catch { /* ohne Rückweg weiter — die PDP bleibt bedienbar */ }
    }
    if (!e) return;
    historieWaehlen(e.id);
    if (antwortenAusRueckweg) s.antworten = antwortenAusRueckweg;
    /* Der zuletzt gesehene Ton (Warenkorb-Zeile »Farbe«) — nur, wenn der
       Look ihn trägt; sonst bleibt der bestellte. */
    if (ton && tonSichtbar() && LISTE_B().some((t) => t.id === ton) && ton !== s.ton) {
      s.ton = ton;
      const chip = wurzel && wurzel.querySelector(
        `[data-brieffeld="look"][data-wert="${s.brief.look}:${ton}"], [data-brieffeld="tinte"][data-wert="${ton}"], `
        + `[data-brieffeld="grund"][data-wert="${ton}"]`);
      if (chip) {
        wurzel.querySelectorAll(`[data-brieffeld="${chip.dataset.brieffeld}"]`)
          .forEach((x) => x.setAttribute('aria-pressed', String(x === chip)));
        sammleBrief();
        s.kartenBasis = kartenSchluessel(s.brief);
        if (s.textBasis) s.textBasis = briefSchluessel(s.brief);
      }
      tonVorschau();
      zeichne();
    }
  }

  /* ================================================================== Ansichten */

  /* Die Reihenfolge der Ansichten — sie steht NUR hier. Die Pfeile rechnen
     zyklisch darauf, die Kacheln stehen im Markup in derselben Folge.
     ⚠️ Wer eine vierte Ansicht einhängt, trägt sie hier UND als Kachel ein;
     eine Tafel ohne Eintrag ist über die Pfeile nicht erreichbar. */
  /* ⏪ 19.08.2026: die Liste kommt aus dem DOM, nicht mehr aus dem Code.
     Seit die Raum-Ansicht drei Interiors hat (`raum-A`, `raum-B`, `raum-D`,
     im Liquid aus der Raum-Tabelle erzeugt), wäre eine feste Liste hier die
     zweite Wahrheit: wer dort einen Raum ergänzt, müsste daran denken, ihn
     auch hier einzutragen — und ein vergessener Eintrag macht die Tafel über
     die Pfeile unerreichbar, ohne dass etwas scheppert.
     Die Reihenfolge im Markup ist die Reihenfolge der Pfeile. */
  const ANSICHTEN = Array.from(document.querySelectorAll('[data-tafel]'))
    .map((t) => t.dataset.tafel);

  function ansichtWechseln(welche) {
    document.querySelectorAll('[data-tafel]').forEach((t) => {
      t.hidden = t.dataset.tafel !== welche;
    });
    document.querySelectorAll('[data-ansicht]').forEach((b) => {
      b.setAttribute('aria-selected', String(b.dataset.ansicht === welche));
    });
    punkteZeichnen();
    /* Unter 750 px ersetzt dieser Name die Kachelspalte (`echoa-pdp.css`).
       Der Text kommt aus der Kachel selbst, damit die Benennung an genau
       einem Ort steht und nicht als zweite Liste danebenläuft. */
    const namensfeld = document.querySelector('[data-ansicht-name]');
    const kachel = document.querySelector(`.pdp__kachel[data-ansicht="${welche}"] .pdp__kachel-wort`);
    if (namensfeld && kachel) namensfeld.textContent = kachel.textContent;
  }

  /* 🆕 29.10.2026 (Sascha, PDP-Vorlage: „Galeriebilder lassen sich mobile nicht swipen“, E2 »A«): am Handy
     wechselt ein Wischen die Ansicht, und Punkte unter dem Bild zeigen, wo man steht. Die Punkte folgen
     derselben Liste wie die Pfeile (`sichtbareAnsichten`), also auch dem Kaufzustand (`galerieKauf`). */
  function sichtbareAnsichten() {
    return ANSICHTEN.filter((a) => {
      const k = document.querySelector(`.pdp__kachel[data-ansicht="${a}"]`);
      return !k?.hidden && !k?.classList.contains('pdp__kachel--aus');
    });
  }
  function punkteZeichnen() {
    const tafeln = document.querySelector('.pdp__tafeln');
    if (!tafeln) return;
    let punkte = document.querySelector('[data-galerie-punkte]');
    if (!punkte) {
      punkte = document.createElement('div');
      punkte.className = 'pdp__punkte';
      punkte.dataset.galeriePunkte = '';
      punkte.setAttribute('role', 'group');
      punkte.setAttribute('aria-label', 'Ansicht wählen');
      tafeln.insertAdjacentElement('afterend', punkte);
    }
    const liste = sichtbareAnsichten();
    const aktiv = document.querySelector('[data-tafel]:not([hidden])')?.dataset.tafel;
    punkte.hidden = liste.length < 2;
    punkte.innerHTML = liste.map((a, i) => `<button type="button" class="pdp__punkt" data-galerie-punkt="${attr(a)}"
      aria-label="Ansicht ${i + 1} von ${liste.length}" aria-current="${a === aktiv}"></button>`).join('');
  }
  (function wischenEinrichten() {
    const tafeln = document.querySelector('.pdp__tafeln');
    if (!tafeln) return;
    let x0 = null, y0 = 0;
    tafeln.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1 || e.target.closest('input, textarea, select, button, a, .andruck')) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    tafeln.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      const dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      /* 40 px und waagrechter als senkrecht: ein Scrollen der Seite wechselt nie das Bild. */
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) ansichtSchritt(dx < 0 ? 1 : -1);
    }, { passive: true });
  })();

  /** Einen Schritt weiter oder zurück, zyklisch. */
  function ansichtSchritt(richtung) {
    /* Ohne ausgeblendete Kacheln (`galerieTauschen` blendet Machart-Kacheln des anderen
       Produkts aus) — die Pfeile sollen nicht auf eine Tafel führen, die es links nicht gibt. */
    const liste = sichtbareAnsichten();
    const aktiv = document.querySelector('[data-tafel]:not([hidden])');
    const jetzt = aktiv ? liste.indexOf(aktiv.dataset.tafel) : 0;
    const i = jetzt < 0 ? 0 : jetzt;
    ansichtWechseln(liste[(i + richtung + liste.length) % liste.length]);
  }

  /* ================================================================== Ereignisse */

  /* Der Vorteil-Hinweis liegt auf dem Bild, AUSSERHALB von `wurzel` — eigener Hörer. Ein Tipp
     irgendwo auf den Hinweis schließt ihn (am Handy ist das × klein). */
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-vorteil-hinweis]')) vorteilHinweisSchliessen();
  });
  /* Die Kacheln mit dem eigenen Entwurf brauchen dessen Adresse — die steht erst, wenn das Blatt
     geladen ist (`zeichne()` läuft beim Fertigwerden davor). Auch nach jedem Tonwechsel. */
  /* Dasselbe gilt fürs Bildchen in „Texte und Farben ändern“: nach Gelb (Abend, Linol, Detail) lief `zeichne()`
     noch mit der alten Adresse, und das Bildchen zeigte das Bild davor (Klick-Durchgang 31.10.2026, Orts-Print). */
  document.querySelector('[data-tafel="blatt"] .buehne__bild')
    ?.addEventListener('load', () => {
      const kauf = istKauf();
      kachelnEigenZeichnen(kauf);
      const vorschau = $('[data-nachher-vorschau]');
      const url = kauf && NACHHER_AN ? entwurfUrl() : '';
      if (vorschau && url && vorschau.getAttribute('src') !== url) vorschau.setAttribute('src', url);
    });

  wurzel.addEventListener('click', (e) => {
    /* Nach dem Entwurf (30.10.2026, `nachherZeichnen`): Aufbau, Neu beginnen, Wunsch für nach der Bestellung. */
    const aufbauWahl = e.target.closest('[data-nachher-aufbau-wahl]');
    if (aufbauWahl) {
      if (aufbauWahl.getAttribute('aria-pressed') !== 'true') kombiWaehlen(aufbauWahl.dataset.nachherAufbauWahl);
      return;
    }
    if (e.target.closest('[data-neu-beginnen]')) { neuBeginnen(); return; }
    const gelbArt = e.target.closest('[data-gelb-art]');
    if (gelbArt) { gelbStarten(gelbArt.dataset.gelbArt); return; }
    const gelbZurueck = e.target.closest('[data-gelb-zurueck]');
    if (gelbZurueck) { historieWaehlen(gelbZurueck.dataset.gelbZurueck); return; }
    if (e.target.closest('[data-nachher-wunsch-merken]')) {
      const feld = $('[data-nachher-wunsch-text]');
      const text = feld ? feld.value.trim() : '';
      const fehler = $('[data-nachher-wunsch-fehler]');
      if (!text) { if (fehler) fehler.hidden = false; feld?.focus(); return; }
      if (!vormerkenMoeglich()) return;
      vormerkenSetzen(s.kandidatId, text);
      wunschZeichnen(istKauf());
      return;
    }
    if (e.target.closest('[data-nachher-wunsch-weg]')) {
      vormerkenSetzen(s.kandidatId, '');
      wunschZeichnen(istKauf());
      return;
    }
    /* Brief-Chips (Momenttyp, Raum, Look, Grundton/Tinte) — Gruppe über
       data-brieffeld. */
    /* Haustier-Foto: „Ohne Foto" und die Wahl des Hauptmotivs. */
    const dateiWeg = e.target.closest('[data-gpx-weg]');
    if (dateiWeg) {
      datei = { id: '', status: 'leer', meldung: '', name: '' };
      dateiZeichnen();
      eingabeGeaendert();
      return;
    }
    if (paarfotoKlick(e)) return;
    if (e.target.closest('[data-ortfoto-weg]')) {
      ortfoto = { id: '', status: 'leer', meldung: '', hinweis: '', bild: '' };
      ortfotoNr++;                                    // eine laufende Prüfung verwerfen
      ortfotoZeichnen();
      eingabeGeaendert();
      return;
    }
    /* Magazin ohne Foto, geheilt im Foto-Schritt (26.10.2026): Machart wechseln UND „Ohne Foto"
       setzen — dieselben Wege wie die Kachel oben und der Knopf „Ohne Foto weiter". */
    const fotoMachart = e.target.closest('[data-foto-machart]');
    if (fotoMachart) {
      kombiWaehlen(fotoMachart.dataset.fotoMachart);
      foto.ohne = true;
      sammleBrief();
      fotoZeichnen();
      eingabeGeaendert();
      schrittHinweisPruefen();
      return;
    }
    const ohneKnopf = e.target.closest('[data-foto-ohne]');
    if (ohneKnopf) {
      e.preventDefault();                               // `details` nicht selbst umklappen — `foto.ohne` zeichnet es
      foto.ohne = !foto.ohne;
      fotoZeichnen();
      eingabeGeaendert();
      return;
    }
    const tierKnopf = e.target.closest('[data-foto-tier]');
    if (tierKnopf) {
      foto.hauptmotiv = tierKnopf.dataset.fotoTier;
      fotoZeichnen();
      eingabeGeaendert();
      return;
    }
    /* Stufe 2: Weiter, Ändern an einer erledigten Zeile, Punkt der Schrittleiste. */
    const schrittVor = e.target.closest('[data-schritt-vor]');
    if (schrittVor) { schrittGehe(Number(schrittVor.dataset.schrittVor)); return; }
    const schrittZu = e.target.closest('[data-schritt-gehe]');
    if (schrittZu && !schrittZu.disabled) { schrittGehe(Number(schrittZu.dataset.schrittGehe)); return; }
    /* Machart als eine Reihe (Stufe 2): setzt die Felder darunter über ihre eigenen Knöpfe. */
    const kombi = e.target.closest('[data-kombi]');
    if (kombi) { kombiWaehlen(kombi.dataset.kombi); return; }
    /* Foto-Befund „Stimmt nicht? Ändern" (22.10.2026): die Tierfelder öffnen sich. */
    if (e.target.closest('[data-tier-aendern]')) {
      tierFelderOffen = true;
      tierBefundZeichnen();
      briefHalter()?.querySelector('[data-brieffeld-halter="fell"] [data-feld]')?.focus();
      return;
    }
    const chip = e.target.closest('[data-brieffeld]');
    /* Nur NACH dem Andruck: seit 22.10.2026 abends stehen dieselben Felder auch vorher sichtbar
       („Auf dem Blatt") — `feinschliff` heißt weiter „nach dem Andruck geändert" (code-pruefer). */
    if (chip && !chip.disabled && istKauf() && chip.closest('[data-brief-feinschliff]')) schrittMelden('feinschliff');
    if (chip && !chip.disabled) {
      /* Eigene Wahl überholt einen offenen Hinweis (s. Eingabe-Hörer). */
      if (HINWEIS_OFFEN) HINWEIS_OFFEN = null;
      const feld = chip.dataset.brieffeld;
      const vorher = wurzel.querySelector(`[data-brieffeld="${feld}"][aria-pressed="true"]`);
      /* 🔴 FARBWECHSEL NACH DEM ANDRUCK OHNE NEUEN RENDER (Sascha,
         22.09.2026: „Man drückt auf die Farbe und erwartet, dass sich das
         Bild direkt neu einfärbt, es passiert aber nichts."). Derselbe Look,
         anderer Liste-B-Ton → die Bühne holt `ton.png` (0 $), der Andruck
         bleibt gültig, die Bestellzeile trägt »Farbe«. Bewusst OHNE
         `eingabeGeaendert()` — die würde den Kandidaten verwerfen. Der Brief
         wird trotzdem neu gesammelt, damit Formular und Zustand nicht
         auseinanderlaufen; `Farbe` vergleicht gegen `s.kandidatTon`. */
      const nurTon = tonNurWechsel(feld, chip.dataset.wert);
      if (nurTon) {
        wurzel.querySelectorAll(`[data-brieffeld="${feld}"]`)
          .forEach((x) => x.setAttribute('aria-pressed', String(x === chip)));
        sammleBrief();
        s.ton = nurTon;
        /* Der Farbwechsel verwirft den Andruck nicht — also bleibt er die
           Basis, gegen die ein späterer Markierungswechsel prüft. */
        s.kartenBasis = kartenSchluessel(s.brief);
        /* Ebenso die Basis der gesetzten Texte — sonst kostete eine Namensänderung nach
           einem Farbwechsel einen neuen Andruck (code-pruefer 21.10.2026, T2). */
        if (s.textBasis) s.textBasis = briefSchluessel(s.brief);
        neurenderHinweisVerbergen();
        tonVorschau();
        zeichne();
        return;
      }
      /* 🔴 Eine eigene Look-Wahl VERBRAUCHT den URL-Wunsch. Ohne diese Zeile
         spränge die Wahl zurück, sobald der Kunde danach einen Momenttyp
         antippt — die URL überschriebe eine Entscheidung, die er sichtbar
         getroffen hat. Eine Landing-Adresse darf vorwählen, nie korrigieren. */
      if (chip.dataset.brieffeld === 'look') lookWunsch = '';
      wurzel.querySelectorAll(`[data-brieffeld="${chip.dataset.brieffeld}"]`)
        .forEach((x) => x.setAttribute('aria-pressed', String(x === chip)));
      /* 🔴 DUNKEL STARTET MIT PETROL (Sascha, 20.10.2026: „nach Klick auf Linolschnitt erstmal
         mit default blau … mobil ist das Galeriebild längst aus dem Sichtfeld und beim Klicken
         passiert nichts"). Hebt für die neue Maske die Regel „Ton nie vorwählen" (s. Vorwahl in
         `baueBrief`) auf — der Kreis ist sichtbar markiert, die Kachel zeigt den Ton. */
      if (ORTS_MASKE_AN && ORT_MOMENT[D.produkt.handle] && chip.dataset.brieffeld === 'look'
          && chip.dataset.wert !== 'kontrolle') {
        ['tinte', 'grund'].forEach((tf) => {
          const kreise = wurzel.querySelectorAll(`[data-brieffeld="${tf}"]`);
          if (kreise.length && ![...kreise].some((x) => x.getAttribute('aria-pressed') === 'true')) {
            kreise.forEach((x) => x.setAttribute('aria-pressed', String(x.dataset.wert === 'petrol')));
          }
        });
      }
      const warFertig = s.phase === 'fertig';
      const vorherStand = { kandidat: s.kandidatId, ton: s.ton };
      /* Magazin bearbeitet das Foto (26.10.2026, Machart zuerst): wer Magazin antippt, nachdem er
         „Ohne Foto weiter" gewählt hatte, bekommt das Foto-Feld zurück statt eines Widerspruchs. */
      if (chip.dataset.brieffeld === 'stil' && chip.dataset.wert === 'magazin' && foto.ohne) {
        foto.ohne = false;
      }
      /* Nur um DIESEN Aufruf herum: die Galerie darf springen (siehe
         `markerKlick`). `finally`, damit eine Ausnahme den Merker nicht
         stehen lässt und der nächste Tastendruck springt. */
      markerKlick = chip.dataset.brieffeld === 'look' || chip.dataset.brieffeld === 'tinte'
        || chip.dataset.brieffeld === 'poster' || ACHSEN_FELDER.has(chip.dataset.brieffeld)
        || (ORTS_MASKE_AN && chip.dataset.brieffeld === 'grund')
        /* Haustier Machart/Styling (20.10.2026): das Beispiel kommt aufs Blatt. */
        || chip.dataset.brieffeld === 'stil' || chip.dataset.brieffeld === 'styling'
        || (istHaustier() && chip.dataset.brieffeld === 'titelfarbe')
        /* 🆕 22.10.2026: Tierart (Beispiel je Tier) und Lexikon-Eintrag zeigen sich auf der Bühne. */
        || (istHaustier() && ['art', 'machart'].includes(chip.dataset.brieffeld))
        || (istRezept() && ['machart', 'bild'].includes(chip.dataset.brieffeld))
        /* 🆕 28.10.2026: die Stimmung (Abend) zeigt ihr Beispiel auf der Bühne (`stilBeispielUrl`). */
        || chip.dataset.brieffeld === 'stimmung';
      try { eingabeGeaendert(); } finally { markerKlick = false; }
      if (['stil', 'styling'].includes(chip.dataset.brieffeld)) schrittHinweisPruefen();
      /* Das Foto-Feld zeigt bei Magazin die Macharten ohne Foto statt „Ohne Foto weiter". */
      if (chip.dataset.brieffeld === 'stil' && istHaustier()) fotoZeichnen();
      stilKachelnTon();
      /* NACH `eingabeGeaendert()`: dort wird `s.brief` neu gesammelt, und die
         Achsen-URL liest genau daraus. Davor stünde die alte Wahl drin. */
      if (ACHSEN_FELDER.has(chip.dataset.brieffeld)) achsenVorschau();
      /* Ein Look-Wechsel (Hell ↔ dunkel, Farbig ↔ Linolschnitt) braucht einen
         neuen Andruck — und das muss man SEHEN, nicht am Knopftext erraten
         (Sascha, 22.09.2026). Nur, wenn der Klick den Andruck tatsächlich
         verworfen hat; der Fingerabdruck-Rückweg meldet nichts. */
      if (warFertig && s.phase === 'leer'
          && ['look', 'tinte', 'grund', 'poster', 'hintergrund'].includes(feld)) {
        neurenderHinweisZeigen(chip, vorher, vorherStand);
      }
      return;
    }

    /* Eine Listenzeile entfernen: Werte der folgenden Zeilen rücken nach oben,
       die letzte sichtbare wird geschlossen — die Zeilen bleiben so lückenlos
       (sammleBrief/briefEinsetzen arbeiten über den Index). */
    const weg = e.target.closest('[data-zeile-entfernen]');
    if (weg) {
      const feld = briefDef().felder.find((f) => f.name === weg.dataset.zeileEntfernen);
      const halter = briefHalter();
      const gruppe = halter && halter.querySelector(`[data-zeilen][data-feldname="${weg.dataset.zeileEntfernen}"]`);
      if (feld && gruppe) {
        const zeilen = Array.from(gruppe.querySelectorAll('.briefzeile'));
        const idx = Number(weg.dataset.index);
        const lesen = (z) => ({
          ding: z.querySelector(`[data-feld="${feld.name}"]`)?.value ?? '',
          jahr: z.querySelector(`[data-feld="${feld.name}_jahre"]`)?.value ?? '',
          marke: z.querySelector(`[data-feld="${feld.name}_marken"]`)?.value ?? 'ring',
        });
        const schreiben = (z, w) => {
          const d = z.querySelector(`[data-feld="${feld.name}"]`); if (d) d.value = w.ding;
          const y = z.querySelector(`[data-feld="${feld.name}_jahre"]`); if (y) y.value = w.jahr;
          const m = z.querySelector(`[data-feld="${feld.name}_marken"]`); if (m) m.value = w.marke || 'ring';
        };
        const sichtbar = zeilen.filter((z) => !z.hidden);
        const werte = sichtbar.map(lesen).filter((_, i) => i !== idx);
        sichtbar.forEach((z, i) => schreiben(z, werte[i] || { ding: '', jahr: '', marke: 'ring' }));
        /* Die Zeilenhöhe steht inline vom letzten Tippen — nach dem Verschieben
           neu messen, sonst steht mehrzeiliger Text in einem zu niedrigen Feld. */
        gruppe.querySelectorAll('[data-waechst]').forEach(wachsen);
        const letzte = sichtbar[sichtbar.length - 1];
        if (letzte && sichtbar.length > (feld.pflicht || 0)) letzte.hidden = true;
        const knopf = halter.querySelector(`[data-mehr="${feld.name}"]`);
        if (knopf) knopf.hidden = false;
        eingabeGeaendert();
      }
      return;
    }

    /* Eine eingeklappte Liste öffnen (Orts-Print, 30.09.2026). */
    const aufklapper = e.target.closest('[data-aufklapper]');
    if (aufklapper) {
      aufklappen(aufklapper.dataset.aufklapper, { fokus: true });
      return;
    }
    const zuklapper = e.target.closest('[data-zuklapper]');
    if (zuklapper) {
      zuklappen(zuklapper.dataset.zuklapper);
      eingabeGeaendert();
      return;
    }

    /* Noch eine Listenzeile holen. */
    const mehr = e.target.closest('[data-mehr]');
    if (mehr) {
      const feld = briefDef().felder.find((f) => f.name === mehr.dataset.mehr);
      const halter = briefHalter();
      if (feld && halter) {
        const gruppe = halter.querySelector(`[data-zeilen][data-feldname="${feld.name}"]`);
        const sichtbar = gruppe
          ? Array.from(gruppe.querySelectorAll('.briefzeile')).filter((z) => !z.hidden).length
          : 0;
        zeilenOeffnen(halter, feld, sichtbar + 1);
        /* Fokus in die neue Zeile: wer „+" drückt, will tippen, nicht suchen. */
        const neu = gruppe && Array.from(gruppe.querySelectorAll('.briefzeile'))
          .filter((z) => !z.hidden).pop();
        neu?.querySelector('textarea')?.focus();
      }
      return;
    }

    /* Jahres-Spalte ein- oder ausblenden. */
    const jahr = e.target.closest('[data-jahrschalter]');
    if (jahr) {
      const an = jahr.getAttribute('aria-pressed') !== 'true';
      jahrSchalterSetzen(briefHalter(), jahr.dataset.jahrschalter, an);
      /* Ausschalten LEERT die Felder (`jahrSchalterSetzen`) — das ist eine
         Briefänderung und muss den fertigen Andruck genauso ungültig machen
         wie das Löschen einer Zeile von Hand. */
      if (!an) eingabeGeaendert();
      return;
    }

    /* --- Rahmenkachel: setzt Ausführung UND Rahmenfarbe --------------------
       Die Oberfläche führt eine Achse, die Daten führen zwei (KONFLIKT 2).
       Hier ist die einzige Stelle, an der das übersetzt wird. */
    const rk = e.target.closest('[data-rahmen]');
    if (rk && !rk.disabled) {
      const farbe = rk.dataset.rahmen;
      s.ausfuehrung = farbe ? 'Gerahmt' : 'Print';
      s.rahmenGewaehlt = true;        /* ab jetzt zeigt der Raum, was gewählt ist */
      /* 🔴 Die Farbe wird beim Abwählen NICHT gelöscht. `trifft()` verlangt
         bei „Print" ohnehin `Ohne Rahmen` auf der Rahmen-Achse und ignoriert
         `s.rahmenfarbe` dort; sie stehenzulassen heißt, dass ein Kunde, der
         Eiche wählt, zu „Ohne Rahmen" springt und wieder zurück, seine Eiche
         wiederfindet statt der ersten Farbe der Liste. */
      if (farbe) s.rahmenfarbe = farbe;
      zeichne();
      auswahlMelden('wahl');
      kaufBeruehren();
      return;
    }

    const tonKnopf = e.target.closest('[data-tonwert]');
    if (tonKnopf && !tonKnopf.disabled) {
      s.ton = tonKnopf.dataset.tonwert;
      tonVorschau();
      zeichne();
      return;
    }

    const opt = e.target.closest('[data-wahl]');
    if (opt && !opt.disabled) {
      s[opt.dataset.wahl] = opt.dataset.wert;
      if (opt.dataset.wahl === 'look') grundtoeneSetzen();
      zeichne();
      return;
    }

    const sw = e.target.closest('[data-swatch]');
    if (sw && !sw.disabled) {
      s[sw.dataset.swatch] = sw.dataset.wert;
      zeichne();
      return;
    }

    const entw = e.target.closest('[data-entwurf]');
    if (entw) { historieWaehlen(entw.dataset.entwurf); return; }

    if (e.target.closest('[data-gaming-oeffnen]')) {
      gamingOffen = true;
      zeichne();
      $('[data-brief]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    const aktion = e.target.closest('[data-aktion]');
    if (aktion && !aktion.disabled) {
      if (s.phase === 'fertig') inDenWarenkorb();
      else if (s.phase === 'leer') (livePfad() ? backendLauf() : wartezeitStarten());
    }
  });

  document.addEventListener('click', (e) => {
    /* Kauffläche nach dem Andruck (21.10.2026): „Deine Angaben" auf- und zuklappen, und der
       Knopf der Kaufleiste löst den echten Knopf aus — ein Warenkorb-Weg, nicht zwei. */
    if (e.target.closest('[data-angaben]')) {
      const offen = angabenOffen;
      angabenOffen = !offen;
      kaufZeichnen(s.phase === 'fertig' ? vorteilFuer(s.kandidatId) : null);
      wachsenAlle();
      if (!offen) $('[data-brief]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    const groesseRaum = e.target.closest('[data-groesse-raum], [data-ankunft-raum]');
    if (groesseRaum) {
      const ziel = groesseRaum.dataset.ziel;
      if (ziel) {
        ansichtWechseln(ziel);
        document.querySelector(`[data-tafel="${ziel}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }
    if (e.target.closest('[data-kaufleiste-knopf]')) {
      const echt = $('[data-aktion]');
      if (echt && !echt.disabled) echt.click();
      return;
    }
    const tab = e.target.closest('[data-ansicht]');
    if (tab) {
      ansichtWechseln(tab.dataset.ansicht);
      if (tab.dataset.farbkachel || tab.dataset.machartkachel) farbkachelWaehlen(tab);
    }

    /* ⏪ 18.08.2026: Pfeile über dem Bild. Eigener `closest`, nicht in den
       Zweig oben gefaltet — ein Pfeil trägt kein `data-ansicht`, sondern eine
       Richtung, und beide Attribute an einem Knopf wären zwei Wahrheiten. */
    const punkt = e.target.closest('[data-galerie-punkt]');
    if (punkt) ansichtWechseln(punkt.dataset.galeriePunkt);
    const pfeil = e.target.closest('[data-ansicht-schritt]');
    if (pfeil) ansichtSchritt(Number(pfeil.dataset.ansichtSchritt) || 1);

    /* Die Melde-Zeile liegt in `pdp__links`, also AUSSERHALB von
       `[data-konfigurator]` — der Delegat oben greift dort nicht. Deshalb hier,
       am Dokument, wie schon der Ansichten-Wechsel. */
    const melden = e.target.closest('[data-melden]');
    if (melden) {
      if (document.querySelector('[data-melden-panel]')) meldenPanelVerbergen();
      else meldenPanelZeigen();
    }
    const daumen = e.target.closest('[data-daumen]');
    if (daumen) daumenGeben(daumen.dataset.daumen);
    const pill = e.target.closest('[data-pill]');
    if (pill) pillTippen(pill.dataset.pill);
    const amBild = e.target.closest('[data-am-bild-feld]');
    if (amBild) {
      /* Den echten Knopf im Formular drücken — der Formular-Hörer erkennt den Satz-Wechsel und färbt um. */
      const echt = briefHalter()?.querySelector(
        `[data-brieffeld="${amBild.dataset.amBildFeld}"][data-wert="${amBild.dataset.wert}"]`);
      if (echt && echt.getAttribute('aria-pressed') !== 'true') echt.click();
    }
    const haarTon = e.target.closest('[data-haar-ton]');
    if (haarTon) {
      haarTon.closest('[data-haar]')?.querySelectorAll(`[data-haar-figur="${haarTon.dataset.haarFigur}"]`)
        .forEach((b) => b.setAttribute('aria-pressed', String(b === haarTon && Boolean(haarTon.dataset.haarTon))));
      haarSenden(Number(haarTon.dataset.haarFigur), haarTon.dataset.haarTon);
    }
    if (e.target.closest('[data-pills-wieder]')) {
      const zeile = document.querySelector('[data-melden-zeile]');
      if (zeile) {
        zeile.querySelectorAll('[data-pill]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
        pillsOffen(zeile, true);
      }
    }
    /* Stufe 1 (26.10.2026): „Stimmt etwas noch nicht?" und der Block „Andere Machart ausprobieren"
       liegen wie die Daumen-Zeile außerhalb von `[data-konfigurator]`. */
    if (e.target.closest('[data-melden-oeffnen]')) meldenOeffnen();
    const umWahl = e.target.closest('[data-anders-wahl]');
    if (umWahl) andersWaehlen(umWahl.dataset.andersWahl, umWahl.dataset.wert);
    const umLos = e.target.closest('[data-anders-los]');
    if (umLos && !umLos.disabled) andersLos();
  });

  /* --- Felder wachsen mit der Eingabe mit ---------------------------------
     textarea rows="1" plus Höhenanpassung auf scrollHeight. Kein input:
     „Der Steg im Nebel bei Sonnenaufgang, Juli 2019" braucht 330 px, das Feld
     hat 197 (Desktop, zweispaltig) — einzeilig scrollten zwei Drittel weg. */
  function wachsen(el) {
    /* 🔴 NICHT MESSEN, WAS NICHT GEZEICHNET IST (26.10.2026, Saschas Bildschirmfoto: das Moment-Feld
       „Wo seid ihr, was macht ihr?" zeigte am Handy eine Zeile, der Text war abgeschnitten). Ein Feld
       in einem zugeklappten Schritt hat `scrollHeight` 0 — die Höhe blieb danach inline auf der
       Mindesthöhe stehen, auch wenn der Schritt aufging. Jetzt gilt dort die CSS-Höhe
       (`.echoa-feld--lang`: drei Zeilen), und `wachsenAlle()` misst nach, sobald es sichtbar ist. */
    if (!el.getClientRects().length) { el.style.height = ''; return; }
    el.style.height = 'auto';
    /* Ein LEERES Feld misst seinen Platzhalter mit (30.10.2026, Sascha am Handy: mit Jahreszahl daneben brach
       „Unsere Pfeffermühle aus Holz" in zwei Zeilen und war halb abgeschnitten). Den Wert kurz setzen löst
       kein Ereignis aus. */
    if (!el.value && el.placeholder) {
      el.value = el.placeholder;
      el.style.height = `${el.scrollHeight}px`;
      el.value = '';
      return;
    }
    el.style.height = `${el.scrollHeight}px`;
  }
  function wachsenAlle() {
    document.querySelectorAll('[data-waechst]').forEach(wachsen);
  }
  /* Drehen des Handys ändert die Breite und damit die Zeilen der Platzhalter (30.10.2026). */
  let wachsenTakt = 0;
  window.addEventListener('resize', () => {
    clearTimeout(wachsenTakt);
    wachsenTakt = setTimeout(wachsenAlle, 150);
  });

  /* Jede Brief-Änderung nach einem fertigen Andruck macht ihn ungültig —
     jede Änderung erzeugt einen neuen, es gibt keine Korrekturrunden. */
  function eingabeGeaendert() {
    /* Eine stehende Fehlermaske verdeckte sonst das Blatt, an dem der Kunde
       gerade weiterarbeitet. Eine LAUFENDE Maske bleibt unberührt. */
    document.querySelector('[data-andruck-fehler]')?.remove();
    /* Ein geänderter Brief kann andere Rückfragen bedeuten — alte Antworten
       zeigten dann auf Fragen, die so nicht mehr gestellt werden. */
    s.antworten = [];
    /* Erst die Sichtbarkeit nachziehen, dann sammeln: der Momenttyp kann die
       Aussparung gesperrt haben, und ein gesammelter Brief mit einer eben
       zurückgefallenen Wahl wäre einen Klick lang falsch. */
    briefSichtbar();
    sammleBrief();
    paarfotoZeichnen();   /* Kohle/Strich blenden die Auswahl ohne Foto aus und melden „Foto nötig" */

    /* 🔴 ZUERST FRAGEN, OB DIESER STAND SCHON GERENDERT WURDE (17.08.2026).
       Der Hin-und-zurück-Wechsel des Looks ist der häufigste Fall dafür, und
       er ist Saschas Bestellung: „Nach Vorschau des Bildes sollte die
       Möglichkeit zum Switchen weiterhin bestehen, Bild ändert sich dann
       dynamisch (ohne Zusatzkosten)." Herleitung: `briefSchluessel()`.

       ⚠️ Steht VOR dem Verwerfen unten. Andersherum wäre der Kandidat schon
       gelöscht, wenn die Historie ihn zurückgibt — und `historieWaehlen()`
       setzte ihn eine Zeile später wieder, mit einem sichtbaren Sprung
       dazwischen. */
    /* 🔴 HAUSTIER: Machart, Texte und Farbe setzen den GEZEIGTEN Andruck neu
       (0 $, kein Kontingent) — nur ein geändertes Foto oder Merkmal braucht
       einen neuen Render (16.10.2026). */
    if (istSatzH1() && s.phase === 'fertig' && s.kandidatId
        && briefSchluessel(s.brief) === s.haustierBasis) {
      haustierSatzAnstossen();
      return;
    }
    /* 🔴 GESETZTE TEXTE (Pixel-Paar, Moment, Orts-Print, Jahreszahl, Wortschatz, Zitat,
       Symbol): sie setzen den GEZEIGTEN Andruck neu (0 $, kein Render, 21.10.2026) — als
       neuer Entwurf, wie das Chronik-Umzeichnen. */
    /* Nur, wenn sich ein gesetzter Text gegenüber dem GEZEIGTEN Entwurf unterscheidet: ein
       Achsen-Klick (Hintergrund, Passepartout) zählt im Fingerabdruck ebenfalls nicht und fiele
       sonst hier hinein — der Leerlauf-Zweig nähme dann nach 350 ms den Lade-Schleier weg,
       während `achsen.png` noch lädt (code-pruefer 21.10.2026). */
    if (textSatzAktiv() && s.phase === 'fertig' && s.kandidatId
        && briefSchluessel(s.brief) === s.textBasis) {
      if (textSatzGeaendert()) {
        textSatzAnstossen();
        return;
      }
      /* 🔴 Gleiche Texte (Tippfehler und Korrektur, Achsen-Klick): der gezeigte Entwurf gilt.
         Hier selbst abschließen statt über den Rückweg weiter unten — der sucht über den
         Fingerabdruck, und der trägt nach einem kostenlosen Farbwechsel einen anderen Ton als
         der Historien-Eintrag. Dann fand er nichts und verwarf den bezahlten Andruck
         (code-pruefer 21.10.2026, Runde 1, T2). */
      umzeichnenAbbrechen();
      if (s.textSatzFehlt) { s.textSatzFehlt = false; $('[data-fehler]')?.setAttribute('hidden', ''); }
      zeichne();
      return;
    }
    /* 🔴 STRECKE: Zeit, Namen, Ort … setzen den GEZEIGTEN Andruck neu (0 $,
       ohne Kartenabruf) — nur ein geänderter Text oder eine neue Datei
       braucht einen neuen Andruck (17.10.2026). */
    if (istStrecke() && s.phase === 'fertig' && s.kandidatId
        && briefSchluessel(s.brief) === s.streckeBasis) {
      streckeSatzAnstossen();
      return;
    }
    /* 🔴 REZEPT ebenso: nur ein geändertes Gericht braucht einen neuen Render. */
    if (istRezept() && s.phase === 'fertig' && s.kandidatId
        && briefSchluessel(s.brief) === s.rezeptBasis) {
      rezeptSatzAnstossen();
      return;
    }
    const schluessel = briefSchluessel(s.brief);
    /* Mehrere Entwürfe können denselben Abdruck tragen — seit „Noch einmal
       zeichnen" (12.10.2026) ist das der Normalfall: gleicher Brief, neuer
       Wurf. Dann gewinnt der GEZEIGTE; sonst sprang die Bühne beim
       Hin-und-zurück-Tippen auf einen anderen Wurf, mit aktivem Warenkorb
       (Befund code-pruefer 12.10.2026, T2, BELEGT). Ist keiner davon gezeigt,
       der jüngste — die Liste steht neueste zuerst. */
    const passend = schluessel ? historieLesen().filter(
      (e) => e.handle === D.produkt.handle && e.schluessel === schluessel) : [];
    /* Pixel-Paar mit Farben am Bild: unter gleichem Abdruck zuerst den, der auch die Kleidung genau trägt — sonst
       färbte der Satz-Weg den jüngsten um oder verlangte einen neuen Andruck (code-pruefer 27.10.2026). */
    const treffer = passend.find((e) => e.id === s.kandidatId)
      || (istGaming() && HAAR_UMFAERBEN_AN ? passend.find(genauGezeichnet) : null) || passend[0];
    if (treffer && treffer.id !== s.kandidatId) {
      /* 🔴 OHNE DAS FORMULAR ANZUFASSEN (Befund `code-pruefer` 17.08.2026,
         BELEGT). Der Fingerabdruck sagt bereits, dass der Brief INHALTLICH
         dem gespeicherten entspricht — zurückzuholen ist allein das Bild.
         `briefEinsetzen()` hier laufen zu lassen war trotzdem falsch, und
         zwar nicht wegen des Cursors, sondern wegen der LAGE:

         `sammleBrief()` verdichtet Listenzeilen (leere fallen raus),
         `briefEinsetzen()` schreibt sie ab Index 0 zurück. Beide Lagen
         ergeben denselben Fingerabdruck. Wer bei A8 Zeile 1 leert, per „+"
         Zeile 3 holt und dort „Lissabon" tippt, trifft mit dem letzten
         Zeichen den alten Entwurf — und bekam sein Wort eine Zeile nach oben
         geschoben, während der Cursor in der nun leeren Zeile stand.
         Dasselbe traf den Jahres-Schalter: `jahre.some(Boolean)` klappte die
         Spalte ungefragt wieder ein.
         `setzWert()` fängt das nicht, weil sich der Wert je Feld tatsächlich
         ändert. Der Fehler war der Aufruf, nicht seine Vorsicht. */
      umzeichnenAbbrechen();
      historieWaehlen(treffer.id, { formularSetzen: false });
      /* 🔴 DIE ACHSEN NACHZIEHEN (code-pruefer 20.10.2026, T2, BELEGT am Code):
         der Rückweg zeigt das gespeicherte Vorschaubild — mit den Achsen vom
         Andruck-Zeitpunkt. Das Formular trägt aber die zuletzt gewählten
         (Wortschatz-Pop: Linol auf Kobalt angedruckt, dann „Pink", dann ein
         Tippfehler samt Korrektur). Ohne diese Zeile zeigte die Bühne Kobalt und
         die Cart-Property hieße „Pink" — gedruckt würde Pink. Kostet 0 $. */
      achsenVorschau();
      return;
    }
    if (treffer && treffer.id === s.kandidatId) {
      /* Auch ein noch ausstehendes Umzeichnen ist damit überholt. */
      umzeichnenAbbrechen();
      /* Zurück auf den Stand des gerade gezeigten Entwurfs — nichts zu tun,
         der Andruck gilt weiter. Ohne diesen Zweig würde ein Tippfehler und
         seine Korrektur den fertigen Entwurf kosten. */
      zeichne();
      return;
    }

    /* 🔴 CHRONIK: MARKIERUNG UND LINIEN ZEICHNEN UM, STATT DEN ANDRUCK ZU
       VERWERFEN (Sascha, 16.10.2026: „Ginge das nicht auch direkt in der
       Vorschau?"). Die Karte ist konstruiert, nicht gemalt — das Backend
       zeichnet sie aus dem eingefrorenen Szenario neu (0 $, ~3–5 s, kein
       Kontingent). Jede andere Änderung läuft weiter in das Verwerfen. */
    if (s.phase === 'fertig' && chronikUmzeichnenMoeglich()) {
      chronikUmzeichnen();
      return;
    }
    umzeichnenAbbrechen();
    andruckVerwerfen();
  }

  /** Der gezeigte Andruck gilt nicht mehr — zurück auf „Andruck erstellen". */
  function andruckVerwerfen() {
    if (s.phase === 'fertig') {
      s.phase = 'leer';
      s.kandidatId = null;
      s.kandidat = null;
      speichernZeigen();
      /* Die Leiste bleibt STEHEN — sie ist der Rückweg, den es bisher nicht
         gab. Nur die Aktiv-Markierung fällt weg, weil gerade kein Entwurf
         mehr gezeigt wird. */
      historieZeichnen();
    }
    lookBeispielZeigen();
    zeichne();
  }

  wurzel.addEventListener('input', (e) => {
    const feld = e.target.closest('[data-waechst]');
    if (feld) wachsen(feld);
    /* Rezept-Karte: die Markierung „bitte prüfen" geht, sobald der Kunde das
       Feld anfasst — er hat es dann gesehen. */
    e.target.classList?.remove('echoa-feld--unsicher');
    /* Selbst getippt — ein KI-Vorschlag überschreibt das nicht mehr. */
    if (e.target.dataset && e.target.dataset.feld) e.target.dataset.eigen = '1';
    /* Eine eigene Eingabe überholt einen noch offenen Hinweis — sonst hinge „Geändert"
       später an einem Entwurf, den der Kunde selbst verändert hat (code-pruefer
       21.10.2026). */
    if (HINWEIS_OFFEN && e.target.closest('[data-eingabe]')) HINWEIS_OFFEN = null;
    if (e.target.closest('[data-brief]')) {
      schrittMelden('inhalt');
      /* Stufe 2: eine Meldung unter „Weiter" gilt nur, bis der Kunde wieder tippt (code-pruefer R2). */
      const sf = $('[data-schritt-fehler]');
      if (sf) sf.hidden = true;
    }
    if (istKauf() && e.target.closest('[data-brief-feinschliff]')) schrittMelden('feinschliff');
    /* „wird gesetzt …“ am Feld, das der Kunde gerade ändert (`feldstandSetzen`). */
    if (NACHHER_AN && istKauf() && e.target.closest('[data-nachher-gruen] [data-eingabe]')) {
      feldstandSetzen(e.target.closest('[data-brieffeld-halter]'));
    }
    if (e.target.closest('[data-gelb-wunsch]')) { const f = $('[data-gelb-wunsch-fehler]'); if (f) f.hidden = true; }
    if (e.target.closest('[data-eingabe]')) eingabeGeaendert();
  });

  /* Selects (Geschlecht) und Radios feuern change, nicht input. */
  wurzel.addEventListener('change', (e) => {
    /* Haustier-Foto: eigener Weg — die Prüfung zieht den Brief selbst nach. */
    /* Ein Upload ist die erste Eingabe in Schritt 1 (22.10.2026). */
    if (e.target.closest('[data-foto-datei], [data-ortfoto-datei], [data-paarfoto-datei], [data-karte-datei], [data-gpx-datei]')) {
      schrittMelden('inhalt');
    }
    const fotoDatei = e.target.closest('[data-foto-datei]');
    if (fotoDatei) { fotoGewaehlt(fotoDatei); return; }
    /* Orts-Print: das optionale Foto des Ortes — eigener Weg wie das Tierfoto. */
    const ortfotoDatei = e.target.closest('[data-ortfoto-datei]');
    if (ortfotoDatei) { ortfotoGewaehlt(ortfotoDatei); return; }
    const paarfotoDatei = e.target.closest('[data-paarfoto-datei]');
    if (paarfotoDatei) { paarfotoGewaehlt(paarfotoDatei); return; }
    /* Moment/Linie: eine Auswahl der Tabelle (`paarTabelle`). Wechselt eine Person weg vom Mann, fällt ihr Bart weg. */
    const paarSel = e.target.closest('[data-paar-sel]');
    if (paarSel) {
      const p = paarfoto.paar || paarLeer();
      const [k, w] = paarSel.dataset.paarSel.split('.');
      if (w) {
        p[k] = { ...(p[k] || {}), [w]: paarSel.value };
        if (w === 'geschlecht' && paarSel.value !== 'maennlich') p[k].bart = '';
      } else p[k] = paarSel.value;
      paarfoto.paar = p;
      paarfotoZeichnen();
      eingabeGeaendert();
      return;
    }
    /* Rezept-Karte: eigener Weg — das Lesen füllt die Felder selbst vor. */
    const karteDatei = e.target.closest('[data-karte-datei]');
    if (karteDatei) { karteGewaehlt(karteDatei); return; }
    /* Strecke: die GPX-Datei — eigener Weg wie das Foto. */
    const gpxDatei = e.target.closest('[data-gpx-datei]');
    if (gpxDatei) { dateiGewaehlt(gpxDatei); return; }
    /* Das Format ist KEINE Briefänderung — es geht nie ins Backend und macht
       einen fertigen Andruck nicht ungültig. `eingabeGeaendert()` würde hier
       den Kandidaten löschen und den Kunden zurück auf „Andruck erstellen"
       werfen, nachdem er nur die Größe gewechselt hat. */
    if (e.target.closest('[data-groesse]')) {
      s.groesse = e.target.value;
      /* Orts-Print (23.09.2026): das Blatt wird EINMAL gerendert (Master
         4:5), jede Größe ist Seitenbeschnitt — die Bühne holt nur das Bild im
         neuen Format nach (0 $), der Andruck bleibt gültig. Kein Hinweis,
         kein neuer Wurf (Sascha: „das gezeigte Bild einfach nur in anderer
         Größe"). */
      if (istOrtsPrint() && s.phase === 'fertig' && s.kandidatId) {
        if (s.ton && tonSichtbar() && s.ton !== s.kandidatTon) tonVorschau();
        else if (s.kandidatBild) vorschauSetzen(kandidatBildUrl(s.kandidatBild));
      }
      zeichne();
      auswahlMelden('wahl');
      kaufBeruehren();
      return;
    }
    if (e.target.closest('[data-brief], [data-brief-feinschliff], [data-brief-ausfuehrung]')) {
      if (HINWEIS_OFFEN) HINWEIS_OFFEN = null;
      eingabeGeaendert();
    }
  });

  /* ================================================================== Start */

  baueBrief();

  /* Konzepte ohne globale Optik-Achsen (C1: Look kommt als Brief-Chip,
     Grund/Akzent/Rand aus dem Ortsstil) — der ganze Schritt II entfällt. */
  if (!optikSichtbar()) {
    document.getElementById('schritt-2')?.closest('.schritt')?.setAttribute('hidden', '');
  }

  /* Der Rand-Block steht im Ausführungs-Schritt und trägt `hidden` im Markup —
     dieselbe Regel wie überall hier: ohne Skript ist der Konfigurator
     funktionslos, und ein Element, das beim Laden kurz aufblitzt, ist genau
     das Aufblitzen, das weg soll. Er wird nur bei den Bautypen freigeschaltet,
     die einen Steg tragen. */
  if (randSichtbar()) {
    document.querySelector('[data-block="rand"]')?.removeAttribute('hidden');
  }

  /* 🔴 DIE VORWAHL IST NIE DAS ERSTE DER LISTE (17.08.2026, unverändert
     gültig). Die Liste beginnt mit dem kleinsten Format — dem Einstiegs-Anker,
     der im Listing den ab-Preis trägt (`katalog/varianten.json`, Rolle; seit
     18.08.2026 ist das 21×30). Als Vorwahl im Konfigurator wäre er die
     stillschweigende Empfehlung des billigsten Formats.
     ⏪ 19.08.2026: WELCHES Format es stattdessen ist, hat sich geändert —
     40×50 statt 30×40. Begründung im Block darunter; sie ist Saschas, nicht
     meine. Der Name `KERNFORMAT` bleibt, damit die Rückfall-Logik unten
     unverändert lesbar ist; „Kern / Bestseller" im Sinne der Preisleiter ist
     weiterhin 30×40, das ist jetzt also nicht mehr dasselbe wie die Vorwahl.
     ⚠️ Fällt das Vorwahl-Format aus dem Katalog, greift der bisherige Rückfall
     auf das erste vorhandene — die Vorwahl darf nie leer bleiben, sonst
     findet `findeVariante()` nichts und die Seite zeigt „—". */
  /* ⏪ 23.09.2026 (Sascha, nach dem Live-Test): Vorwahl wieder 30×40 OHNE
     Rahmen. Begründung: „ab 39 €" im Listing und danach 79 € + 25 € Rahmen als
     Erstanzeige nach dem Andruck ist ein Preisschock — dem Kunden fällt das
     Aufrüsten leichter als das Abrüsten. Die Raum-Ansichten zeigen den
     schwarzen Rahmen weiter (Saschas 19.08.-Bestellung „egal ob Stufe 1 oder
     2"), solange der Kunde die Rahmenwahl nicht selbst angefasst hat
     (`s.rahmenGewaehlt`). */
  const KERNFORMAT = '30×40 cm';
  const groessen = werteFuer('groesse');
  s.groesse = groessen.includes(KERNFORMAT) ? KERNFORMAT : (groessen[0] || null);

  /* --- Vorwahl: gerahmt, schwarz (19.08.2026) ------------------------------
     Sascha: „In den Interior-Bildern immer by default ein 40x50 Bild mit
     schwarzem Rahmen anzeigen, egal ob Stufe 1 oder Stufe 2. In Stufe 2 ist
     das dann quasi die Vorauswahl. Nur so wirken die Bilder auch optisch."

     🔴 DAS IST EINE ECHTE VORAUSWAHL, KEINE ANZEIGE-EINSTELLUNG. `s.groesse`
     und `s.ausfuehrung` bestimmen die Variante, die in den Warenkorb geht —
     wer hier etwas ändert, ändert den Standardkauf und den Preis, der nach
     dem Andruck erscheint. Bewusst so bestellt: das gerahmte Poster ist das,
     was im Raum überhaupt als Bild wirkt.
     ⏪ Damit ist die Format-Vorwahl vom 17.08.2026 abgelöst. Sie lautete
     30×40 („KERN / Bestseller — der Preis-Anker") und stand gegen das
     kleinste Format als Vorwahl. Der ab-Preis im Listing bleibt davon
     unberührt: den trägt weiter 21×30 (`katalog/varianten.json`, Rolle).

     🔴 DER SCHWARZE RAHMEN WIRD GESUCHT, NICHT NACHGESCHLAGEN. Die Werte
     kommen aus den LIVE-Produktvarianten und heißen im Store bis zum nächsten
     Reimport anders als im Katalog. Ein fester Name („Holz Schwarz") wäre
     genau die Handtabelle, die an dieser Stelle schon zweimal gerissen ist
     (s. `raumEinzeln`). Gesucht wird deshalb über dieselbe Erkennung, die
     auch die Kachel färbt (`rahmenTeile`), mit Vorrang Holz vor Alu — Holz
     Schwarz ist der wärmere Ton und der, den Sascha am 18.08. an der
     Kachelreihe abgenommen hat.
     ⚠️ Findet sich kein schwarzer Rahmen, bleibt es beim ersten Wert UND es
     meldet sich. Ein stiller Rückfall wäre hier besonders teuer: die Ansicht
     sähe „richtig" aus, nur eben mit einem anderen Rahmen als bestellt. */
  const rahmenfarben = werteFuer('rahmenfarbe');
  const schwarz = (werkstoff) => rahmenfarben.find((n) => {
    const t = rahmenTeile(n);
    return t && t.farbe === 'schwarz' && t.werkstoff === werkstoff;
  });
  const vorwahlRahmen = schwarz('holz') || schwarz('alu');
  if (!vorwahlRahmen && rahmenfarben.length) {
    console.warn('[echoa] Kein schwarzer Rahmen unter den Varianten '
      + `(${rahmenfarben.join(', ')}) – die Vorwahl fällt auf „${rahmenfarben[0]}". `
      + 'Der Raum zeigt den schwarzen Rahmen bis zur ersten Rahmenwahl (Sascha, 19.08./23.09.2026).');
  }
  s.rahmenfarbe = vorwahlRahmen || rahmenfarben[0] || null;
  /* Nur wenn es einen Rahmen GIBT, ist „Gerahmt" wählbar — sonst bliebe der
     Zustand auf einer Ausführung stehen, zu der `findeVariante()` nichts
     findet, und die Seite zeigte „—". */
  s.ausfuehrung = 'Print';           /* Vorwahl ohne Rahmen (23.09.2026) */
  s.rahmenGewaehlt = false;
  baueGroessen();
  baueRahmen();
  baueSwatches('akzent', D.akzente);
  s.akzent = D.akzente.length ? D.akzente[0].id : null;
  grundtoeneSetzen();
  $$('[data-waechst]').forEach(wachsen);
  zeichne();
  /* Reihenfolge: erst zeichnen (die Leiste braucht ein aufgebautes Formular),
     dann den URL-Wunsch einlösen — er SETZT den Zustand und muss zuletzt
     kommen, sonst überschreibt der Aufbau ihn wieder (dieselbe Lehre wie bei
     `lookWunschEinloesen`, code-pruefer 14.08.2026). */
  historieZeichnen();
  entwurfAusUrlEinloesen();
  mailVerdrahten();
  streckeBildPruefen();
  kaufleisteBeobachten();   // Kaufleiste nach dem Andruck (21.10.2026)
  schrittBeobachten();      // Ereignis je Schritt (22.10.2026)
})();
